function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
/*! @twilio/flex-ui.js 1.31.2
The following license applies to all parts of this software except as documented below.

Copyright (c) 2018 Twilio, Inc.
All rights reserved.

 Licensed under the Apache License, Version 2.0 (the “License”);
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an “AS IS” BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.


This software includes react under the following license.

Copyright (c) Facebook, Inc. and its affiliates.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This software includes redux under the following license.
Copyright (c) 2015-present Dan Abramov

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This software includes semver under the following license.
Copyright (c) Isaac Z. Schlueter and Contributors

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.


This software includes loglevel under the following license.
Copyright (c) 2013 Tim Perry

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.


This software includes hoist-non-react-statics under the following license.

Software License Agreement (BSD License)
========================================

Copyright (c) 2015, Yahoo! Inc. All rights reserved.
----------------------------------------------------

Redistribution and use of this software in source and binary forms, with or
without modification, are permitted provided that the following conditions are
met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.
  * Neither the name of Yahoo! Inc. nor the names of YUI's contributors may be
    used to endorse or promote products derived from this software without
    specific prior written permission of Yahoo! Inc.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.*/
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Flex = t() : (e.Twilio = e.Twilio || {}, e.Twilio.Flex = t());
}(window, function () {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/assets/", n(n.s = 295);
  }([function (e, t) {
    e.exports = require("@twilio/flex-ui-core");
  }, function (e, t) {
    e.exports = require("react");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.withTheme = void 0;
    var r = n(129),
      o = n(41);
    t.default = r.default;
    t.withTheme = function (e) {
      return o.withTheme(e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.connect = t.FlexModule = t.pastTokens = void 0;
    var r = n(82),
      o = n(107),
      i = n(300),
      a = n(12),
      s = n(7),
      l = n(28);
    t.pastTokens = [];
    var c = function c(e) {
        return e.flex;
      },
      u = function () {
        function e() {}
        return e.init = function (t, n) {
          void 0 === n && (n = c), e.stateCallback = n, e.store = t;
        }, Object.defineProperty(e, "state", {
          get: function get() {
            if (!e.stateCallback) throw s.ErrorManager.createAndProcessError("FlexModule not initialized", {
              type: s.FlexErrorType.app,
              context: "FlexModule"
            });
            return e.stateCallback(e.store.getState());
          },
          enumerable: !1,
          configurable: !0
        }), e.dispatch = function (t) {
          if (!e.store) throw s.ErrorManager.createAndProcessError("FlexModule not initialized", {
            type: s.FlexErrorType.app,
            context: "FlexModule"
          });
          return e.store.dispatch(t);
        }, Object.defineProperty(e, "initialized", {
          get: function get() {
            return Boolean(e.store);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "chatClient", {
          get: function get() {
            return this._chatClient;
          },
          set: function set(e) {
            this._chatClient = e, (null == e ? void 0 : e.addListener) && i.ChatListener.init(e);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "workerClient", {
          get: function get() {
            return this._workerClient;
          },
          set: function set(e) {
            this._workerClient = e;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "insightsClient", {
          get: function get() {
            return this._insightsClient;
          },
          set: function set(e) {
            this._insightsClient = e, this._insightsClient && (this._insightsClient.instantQuery = new Proxy(this._insightsClient.instantQuery, {
              apply: function apply(e, t, n) {
                return a.TelemetryManager.reportProgrammabilityEvent({
                  callType: a.ProgrammabilityEventCallType.SDKUsage,
                  name: "instant-query",
                  command: n[0]
                }), e.apply(t, n);
              }
            }), this._insightsClient.liveQuery = new Proxy(this._insightsClient.liveQuery, {
              apply: function apply(e, t, n) {
                return a.TelemetryManager.reportProgrammabilityEvent({
                  callType: a.ProgrammabilityEventCallType.SDKUsage,
                  name: "live-query",
                  options: {
                    query: n[1]
                  },
                  command: n[0]
                }), e.apply(t, n);
              }
            }));
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "voiceClient", {
          get: function get() {
            return this._voiceClient;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "cbmClient", {
          get: function get() {
            return this._cbmClient;
          },
          set: function set(e) {
            this._cbmClient = e;
          },
          enumerable: !1,
          configurable: !0
        }), e.events = new l.FlexEventEmitter(), e._voiceClient = new o.Device(), e;
      }();
    t.FlexModule = u, t.connect = function (e, t, n, o) {
      return r.connect(function (t, n) {
        var r = u.stateCallback(t);
        return e(r, n);
      }, t, n, o);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CompiledTemplate = t.Template = t.templates = void 0;
    var r = n(0);
    Object.defineProperty(t, "Template", {
      enumerable: !0,
      get: function get() {
        return r.Template;
      }
    }), Object.defineProperty(t, "CompiledTemplate", {
      enumerable: !0,
      get: function get() {
        return r.CompiledTemplate;
      }
    });
    var o = r.templates;
    t.templates = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.logManager = t.log = t.default = void 0;
    var r = n(108),
      o = n(160),
      i = n(161),
      a = r.getLogger("twilio-flex-ui");
    t.default = a, t.log = a;
    var s = new o.LogManager({
      identifier: "Default Flex Log Manager",
      spies: [{
        type: i.PredefinedSpies.DOMEvents,
        target: window,
        events: ["error"]
      }, {
        type: i.PredefinedSpies.ClassProxy,
        targetAlias: "Flex loglevel",
        target: window.console,
        methods: ["error", "log", "warn", "info", "debug"],
        onStart: function onStart(e) {
          window.console = e, window.console.info("Flex UI logger decorated");
        }
      }],
      storage: {
        type: o.PredefinedStorages.MemoryStorage
      },
      transport: {
        type: o.PredefinedTransports.ReturnToCode
      },
      formatter: {
        type: o.PredefinedFormatters.String,
        maxLineLength: 0
      }
    });
    t.logManager = s, s.prepare().then(s.start);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      i = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.fetchTaskRouterResource = t.templateStr = t.getFlexStatus = t.getUserRole = t.isSupervisor = t.isAdmin = t.tryInvokeAction = void 0;
    var a = n(0),
      s = n(27),
      l = n(85),
      c = n(9),
      u = n(7),
      p = n(3);
    function d(e) {
      return e.roles.indexOf("admin") >= 0;
    }
    function f(e) {
      return e.roles.indexOf("supervisor") >= 0;
    }
    t.tryInvokeAction = function (e, t) {
      return r(this, void 0, Promise, function () {
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2,, 3]), [4, a.Actions.invokeAction(e, t)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return n.sent(), [3, 3];
            case 3:
              return [2];
          }
        });
      });
    }, t.isAdmin = d, t.isSupervisor = f, t.getUserRole = function (e) {
      return d(e) ? "admin" : f(e) ? "supervisor" : "agent";
    }, t.getFlexStatus = function () {
      return r(this, void 0, Promise, function () {
        var e, t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2,, 3]), [4, s.default.get(c.statusSummaryUrl)];
            case 1:
              return e = n.sent(), [2, e.data.components.find(function (e) {
                return "FLEX" === e.name;
              }).status];
            case 2:
              return t = n.sent(), u.ErrorManager.createAndProcessError("Unable to fetch Flex status from Twilio status api", {
                type: u.FlexErrorType.app,
                description: "Unable to fetch resource " + c.statusSummaryUrl + ": " + t,
                context: "getFlexStatus",
                wrappedError: t
              }), [3, 3];
            case 3:
              return [2, void 0];
          }
        });
      });
    }, t.templateStr = function (e, t) {
      var n = Object.keys(t).reduce(function (e, n) {
          return e.replace("${" + n + "}", t[n]);
        }, e),
        r = n.match(/\$\{[a-zA-Z0-9]+\}/g);
      if (r) throw r = r.map(function (e) {
        return e.substr(2, e.length - 3);
      }), u.ErrorManager.createAndProcessError(l.ActionErrors.TEMPLATE_PARAM_MISSING, {
        type: u.FlexErrorType.app,
        description: "One or more parameters missing to replace in template: " + r.join(", "),
        context: "templateStr"
      });
      return n;
    }, t.fetchTaskRouterResource = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, l;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              t = p.FlexModule.state.session.ssoTokenPayload.token, n = e, r = [], o.label = 1;
            case 1:
              o.trys.push([1, 5,, 6]), o.label = 2;
            case 2:
              return n ? [4, s.default.get(n, {
                auth: {
                  username: "token",
                  password: t
                }
              })] : [3, 4];
            case 3:
              if (!((a = o.sent()).data && a.data.meta && a.data.meta.key)) throw u.ErrorManager.createAndProcessError("Missing metadata in the response body", {
                type: u.FlexErrorType.app,
                context: "fetchTaskRouterResource"
              });
              return n = a.data && a.data.meta && a.data.meta.next_page_url, r = i(r, a.data[a.data.meta.key]), [3, 2];
            case 4:
              return [3, 6];
            case 5:
              if (l = o.sent(), u.isFlexError(l)) throw l;
              throw u.ErrorManager.createAndProcessError("Unable to fetch TaskRouter resource", {
                type: u.FlexErrorType.app,
                description: "Unable to fetch TaskRouter resource " + e + ": " + l,
                context: "fetchTaskRouterResource",
                wrappedError: l
              });
            case 6:
              return [2, r];
          }
        });
      });
    };
  }, function (e, t, n) {
    "use strict";

    var _r,
      o = this && this.__extends || (_r = function r(e, t) {
        return (_r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorManager = t.isFlexError = t.FlexError = t.FlexErrorSeverity = t.FlexErrorType = void 0;
    var a,
      s,
      l = n(0),
      c = n(11),
      u = n(12),
      p = n(68),
      d = n(3),
      f = n(5),
      h = n(10),
      m = n(117),
      g = n(169);
    !function (e) {
      e.app = "app", e.chatSDK = "chatSDK", e.syncSDK = "syncSDK", e.taskrouterSDK = "taskrouterSDK", e.flexSDK = "flexSDK", e.voiceSDK = "voiceSDK";
    }(a = t.FlexErrorType || (t.FlexErrorType = {})), function (e) {
      e.user = "user", e.normal = "normal", e.severe = "severe";
    }(s = t.FlexErrorSeverity || (t.FlexErrorSeverity = {}));
    var y = function (e) {
      function n(r, o) {
        void 0 === o && (o = {});
        var i = e.call(this, r) || this;
        return i.getLogTime = function () {
          if (f.logManager) {
            var e = f.logManager.getLogsSnapshot(),
              t = e[e.length - 1];
            if (t) return new Date(t.timestamp).toLocaleTimeString([], {
              hour12: !1
            });
          }
        }, i.content = o, i.content.type || (i.content.type = a.app), i.content.severity || (i.content.severity = s.normal), i.content.twilioErrorCode || (i.content.twilioErrorCode = g.TwilioErrorCodes.FlexError), i.time = new Date(), i.sessionData = t.ErrorManager.sessionData, i.logManagerTimestamp = i.getLogTime(), Object.setPrototypeOf(i, n.prototype), i;
      }
      return o(n, e), Object.defineProperty(n.prototype, "type", {
        get: function get() {
          return this.content.type;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "logs", {
        get: function get() {
          return f.logManager && this.logManagerTimestamp && (f.logManager.flush().match(new RegExp("^(?:[\\s\\S]*)" + this.logManagerTimestamp + "(?:.+)")) || [])[0] || "";
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "logLine", {
        get: function get() {
          var e = this.content,
            t = e.description,
            n = e.context,
            r = e.wrappedError,
            o = t || this.message,
            i = "";
          r && (r.message ? i = '\n\nOriginal error:\n"' + r.message + '"' : "string" == typeof r && (i = '\n\nOriginal error:\n"' + r + '"'));
          var a = n ? "- " + n : "";
          return this.time.toLocaleString() + " " + a + ": " + o + i;
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }(Error);
    t.FlexError = y;
    t.isFlexError = function (e) {
      return e instanceof y;
    };
    var v = function () {
      function e() {
        var e = this;
        this.sessionData = {}, this.handleCoreError = function (n) {
          return t.isFlexError(n.content.wrappedError) ? n.content.wrappedError : e.createAndProcessError(n.message, {
            description: n.content.description,
            context: n.content.context,
            wrappedError: n.content.wrappedError,
            type: e.ErrorTypeFromCoreErrorType(n.type),
            severity: e.ErrorSeverityFromCoreErrorSeverity(n.content.severity)
          });
        }, l.ErrorManager.errorProcessingOverride = this.handleCoreError;
      }
      return e.prototype.initDebugger = function () {
        this.debuggerTransport || (this.debuggerTransport = new g.default());
      }, e.prototype.ErrorSeverityFromCoreErrorSeverity = function (e) {
        switch (e) {
          case l.CoreErrorSeverity.severe:
            return s.severe;
          case l.CoreErrorSeverity.user:
            return s.user;
        }
        return s.normal;
      }, e.prototype.ErrorTypeFromCoreErrorType = function (e) {
        switch (e) {
          case l.CoreErrorType.chatSDK:
            return a.chatSDK;
        }
        return a.app;
      }, e.prototype.updateSessionData = function (e) {
        this.sessionData = i(i({}, this.sessionData), e);
      }, e.prototype.processError = function (e) {
        try {
          if (d.FlexModule.events.emitError(e), f.log.error(e.logLine), e.content.twilioErrorCode === g.TwilioErrorCodes.FlexError && u.TelemetryManager.reportErrorEvent(e), e.content.severity !== s.user && d.FlexModule.initialized && m.Actions.newFlexError(e), e.content.severity !== s.user && this.debuggerTransport && c.FeatureFlags.isEnabled(h.FeatureFlag.DebuggerIntegration)) {
            var t = {
              correlationSid: d.FlexModule.state.worker.worker.sid,
              errorCode: e.content.twilioErrorCode,
              logLevel: "error",
              message: p.getErrorReportForDebugger(e),
              details: {
                type: e.content.type,
                context: e.content.context,
                wrappedError: e.content.wrappedError ? e.content.wrappedError.message : "",
                description: e.content.description,
                plugin: e.content.plugin
              }
            };
            this.debuggerTransport.sendDebugEvent(t);
          }
        } catch (e) {}
        return e;
      }, e.prototype.createAndProcessError = function (e, t) {
        void 0 === t && (t = {});
        var n = new y(e, t);
        return this.processError(n);
      }, e;
    }();
    t.ErrorManager = new v();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskHelper = void 0;
    var r = n(0),
      o = n(3),
      i = n(23),
      a = n(52),
      s = n(20),
      l = function () {
        function e(e) {
          this.task = e;
        }
        return Object.defineProperty(e.prototype, "lastChatMessage", {
          get: function get() {
            var e;
            return console.warn("Warning! Getter 'TaskHelper.lastChatMessage' has been deprecated, please use 'chat.lastMessage' instead!"), null === (e = this.chat) || void 0 === e ? void 0 : e.lastMessage;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "chat", {
          get: function get() {
            if (e.isChatBasedTask(this.task)) {
              if (this.chatChannelHelper) return this.chatChannelHelper;
              var t = i.StateHelper.getChatChannelStateForTask(this.task);
              if (t) return this.chatChannelHelper = new r.ChatChannelHelper(t), this.chatChannelHelper;
            }
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "durationSinceUpdate", {
          get: function get() {
            return r.Utils.formatTimeDuration(Math.max(Date.now() - this.task.dateUpdated.getTime(), 0));
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "durationSinceUpdateShort", {
          get: function get() {
            return r.Utils.formatTimeDuration(Math.max(Date.now() - (this.task.age + this.task.dateUpdated.getTime()), 0), "compact");
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "jsonString", {
          get: function get() {
            return JSON.stringify(this.task, void 0, 2);
          },
          enumerable: !1,
          configurable: !0
        }), e.isLiveCall = function (e) {
          return this.isCallTask(e) && "accepted" === e.status;
        }, Object.defineProperty(e.prototype, "isLiveCall", {
          get: function get() {
            return e.isLiveCall(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isCallOnHold = function (t) {
          return !!e.isLiveCall(t) && (!(e.isRegularConferenceCall(t) || !o.FlexModule.state.phone.connection || !o.FlexModule.state.phone.connection.oldHold) || !!t.conference && t.conference.participants.some(function (e) {
            return "customer" === e.participantType && e.onHold;
          }));
        }, Object.defineProperty(e.prototype, "isCallOnHold", {
          get: function get() {
            return e.isCallOnHold(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.canKickWorkerParticipant = function (t, n) {
          return e.isLiveCall(t) && e.isMyTask(t) && !e.amIOnHold(t) && !(t.outgoingTransferObject && "initiated" === t.outgoingTransferObject.status) && "joined" === n.status;
        }, e.canHold = function (t) {
          return e.isLiveCall(t) && e.isMyTask(t) && !e.amIOnHold(t) && !(t.outgoingTransferObject && "initiated" === t.outgoingTransferObject.status);
        }, e.amIOnHold = function (t) {
          if (!e.isRegularConferenceCall(t)) return !1;
          var n = t.conference.participants.find(function (e) {
            return e.isMyself && "joined" === e.status;
          });
          return !!n && n.onHold;
        }, e.canTransfer = function (t) {
          return !(!e.isLiveCall(t) || !e.isMyTask(t)) && !!e.isRegularConferenceCall(t) && (!t.outgoingTransferObject || "initiated" !== t.outgoingTransferObject.status) && !e.amIOnHold(t);
        }, e.isRegularConferenceCall = function (e) {
          return e.conference && e.conference.participants.length > 0;
        }, e.isGroupCall = function (e) {
          return !!e.conference && e.conference.liveParticipantCount > 2;
        }, e.isLiveChat = function (e) {
          return this.isChatBasedTask(e) && "accepted" === e.status;
        }, Object.defineProperty(e.prototype, "isLiveChat", {
          get: function get() {
            return e.isLiveChat(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isIncomingCall = function (e) {
          return this.isCallTask(e) && this.isPending(e);
        }, Object.defineProperty(e.prototype, "isIncomingCall", {
          get: function get() {
            return e.isIncomingCall(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isChatBasedTask = function (e) {
          if (o.FlexModule.state.config.useLegacyChatTaskConditional) {
            var t = s.TaskChannels.getForTask(e);
            return !!t && t.capabilities.has(a.TaskChannelCapability.Chat);
          }
          return !!e.attributes.channelSid;
        }, Object.defineProperty(e.prototype, "isChatBasedTask", {
          get: function get() {
            return e.isChatBasedTask(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isCallTask = function (e) {
          if (!e) return !1;
          var t = s.TaskChannels.getForTask(e);
          return !!t && t.capabilities.has(a.TaskChannelCapability.Call);
        }, Object.defineProperty(e.prototype, "isCallTask", {
          get: function get() {
            return e.isCallTask(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isVideoCallTask = function (e) {
          var t = s.TaskChannels.getForTask(e);
          return !!t && t.capabilities.has(a.TaskChannelCapability.Video);
        }, e.getTaskChatChannelSid = function (e) {
          return (e.attributes.channelSid || "").trim();
        }, Object.defineProperty(e.prototype, "getTaskChatChannelSid", {
          get: function get() {
            return e.getTaskChatChannelSid(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isPending = function (e) {
          return "pending" === e.status;
        }, Object.defineProperty(e.prototype, "isPending", {
          get: function get() {
            return e.isPending(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isInWrapupMode = function (e) {
          return "wrapping" === e.status;
        }, Object.defineProperty(e.prototype, "isInWrapupMode", {
          get: function get() {
            return e.isInWrapupMode(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isCompleted = function (e) {
          return "completed" === e.status;
        }, Object.defineProperty(e.prototype, "isCompleted", {
          get: function get() {
            return e.isCompleted(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isMyTask = function (e) {
          return e.workerSid && e.workerSid === o.FlexModule.workerClient.sid;
        }, Object.defineProperty(e.prototype, "isMyTask", {
          get: function get() {
            return e.isMyTask(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.getTaskFromChannelSid = function (t) {
          for (var n = Array.from(o.FlexModule.state.worker.tasks.values()).find(function (n) {
              return t === e.getTaskChatChannelSid(n);
            }), r = 0; !n && r < o.FlexModule.state.supervisor.workers.length;) {
            n = o.FlexModule.state.supervisor.workers[r].tasks.find(function (n) {
              return t === e.getTaskChatChannelSid(n);
            }), r++;
          }
          return n;
        }, e.getTaskByTaskSid = function (e) {
          return o.FlexModule.state.worker.tasks.get(e);
        }, e.isTaskAccepted = function (t) {
          return e.isCompleted(t) || e.isInWrapupMode(t) || "accepted" === t.status;
        }, Object.defineProperty(e.prototype, "isTaskAccepted", {
          get: function get() {
            return e.isTaskAccepted(this.task);
          },
          enumerable: !1,
          configurable: !0
        }), e.isOutboundCallTask = function (t) {
          return e.isCallTask(t) && !!t.routingTarget && "outbound" === t.attributes.direction;
        }, e.isInitialOutboundAttemptTask = function (t) {
          return e.isOutboundCallTask(t) && !t.incomingTransferObject && e.isPending(t);
        }, Object.defineProperty(e.prototype, "isCustomerOnline", {
          get: function get() {
            var e;
            return null === (e = this.chat) || void 0 === e ? void 0 : e.isCustomerOnline;
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
    t.TaskHelper = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getRedirectServiceApi = t.getQueuesStatsConfig = t.getAnalyticsUrl = t.getWorkspaceTaskQueuesUrl = t.getWorkspaceTaskChannelsUrl = t.getFlexInsightsInitTimeout = t.getFlexInsightsPlayerConfig = t.getFlexInsightsSSOUrl = t.getFlexInsightsAssessmentsUrl = t.getFlexInsightsQuestionnairesUrl = t.getFlexInsightsBaseUrl = t.getFlexInsightsIdentityUrl = t.getSessionUrl = t.getPublicConfigServiceUrl = t.getPluginServiceUrl = t.getSSOTokenRefreshUrl = t.getSSOLoginUrl = t.getCallRecordingCallbackUrl = t.getFlexConfigServiceUrl = t.getTwilioDebuggerUrl = t.isPreviewURL = t.getChatOrchestrationServiceUrl = t.getFlexServiceUrl = t.getTwilioTaskQueuesUrl = t.deprecatedFlexLookupServiceUrl = t.statusSummaryUrl = t.twilioServiceLoginUrl = t.flexPublicConfigServiceUrl = void 0;
    var r = n(113),
      o = "https://flex.twilio.com",
      i = "https://preview.twilio.com/iam/Accounts/{accountSid}",
      a = {
        flexServiceUrl: "https://preview.twilio.com/Flex",
        statusSummaryUrl: "https://status.twilio.com/api/v2/summary.json",
        chatOrchestrationServiceUrl: "https://flex-api.twilio.com/v1/Channels",
        twilioDebuggerUrl: o + "/logs/batch",
        flexConfigServiceUrl: "https://flex-api.twilio.com/v1/Configuration",
        flexInsightsIdentityUrl: "https://identity.ytica.com/identity",
        flexPublicConfigServiceUrl: "https://flex-api.twilio.com/v1/Configuration/Public",
        callRecordingCallbackUrl: "https://webhooks.twilio.com/v1/Accounts/{accountSid}/Workspaces/{workspaceSid}/Tasks/{taskSid}/FlexRecordingWebhook",
        ssoLoginUrl: i + "/authenticate",
        ssoTokenRefreshUrl: i + "/Tokens/refresh",
        twilioServiceLoginUrl: o + "/admin",
        twilioTaskQueuesUrl: "https://www.twilio.com/console/taskrouter/workspaces/{workspaceSid}/taskqueues",
        pluginServiceUrl: o + "/plugins",
        sessionUrl: o + "/api/v1/Session",
        workspaceTaskChannels: function workspaceTaskChannels(e, t) {
          return e + "/v1/Workspaces/" + t + "/TaskChannels";
        },
        workspaceTaskQueues: function workspaceTaskQueues(e, t) {
          return e + "/v1/Workspaces/" + t + "/TaskQueues";
        },
        redirectServiceApi: function redirectServiceApi(e, t) {
          return e + "/" + t;
        }
      };
    t.flexPublicConfigServiceUrl = a.flexPublicConfigServiceUrl, t.twilioServiceLoginUrl = a.twilioServiceLoginUrl, t.statusSummaryUrl = a.statusSummaryUrl, t.deprecatedFlexLookupServiceUrl = o + "/lookup", t.getTwilioTaskQueuesUrl = function (e) {
      return a.twilioTaskQueuesUrl.replace("{workspaceSid}", e);
    }, t.getFlexServiceUrl = function (e) {
      return e.flexServiceUrl || a.flexServiceUrl;
    }, t.getChatOrchestrationServiceUrl = function (e) {
      return e.chatOrchestrationServiceUrl || a.chatOrchestrationServiceUrl;
    }, t.isPreviewURL = function (e) {
      return /https:\/\/preview(\.(dev|stage))?\.twilio\.com/.test(e);
    }, t.getTwilioDebuggerUrl = function (e) {
      return e.twilioDebuggerUrl || a.twilioDebuggerUrl;
    }, t.getFlexConfigServiceUrl = function (e) {
      return e.flexConfigServiceUrl || a.flexConfigServiceUrl;
    }, t.getCallRecordingCallbackUrl = function (e) {
      return e.callRecordingCallbackUrl || e.call_recording_webhook_url || a.callRecordingCallbackUrl;
    }, t.getSSOLoginUrl = function (e, t) {
      return (e.loginUrl || a.ssoLoginUrl).replace("{accountSid}", t);
    }, t.getSSOTokenRefreshUrl = function (e, t) {
      return (e.tokenRefreshUrl || a.ssoTokenRefreshUrl).replace("{accountSid}", t);
    }, t.getPluginServiceUrl = function (e) {
      var t = e.pluginService;
      return t && t.url || a.pluginServiceUrl;
    }, t.getPublicConfigServiceUrl = function (e, t) {
      return void 0 === t && (t = {}), (t.publicConfigServiceUrl || a.flexPublicConfigServiceUrl) + "?AccountSid=" + e;
    }, t.getSessionUrl = function (e) {
      return e.sessionUrl || a.sessionUrl;
    }, t.getFlexInsightsIdentityUrl = function (e) {
      return e.insights && e.insights.identityUrl || a.flexInsightsIdentityUrl;
    }, t.getFlexInsightsBaseUrl = function (e) {
      return e.insights && e.insights.baseUrl || "https://app.ytica.com";
    }, t.getFlexInsightsQuestionnairesUrl = function (e) {
      return e.insights && e.insights.questionnairesUrl || "https://apps.ytica.com/assessments";
    }, t.getFlexInsightsAssessmentsUrl = function (e) {
      return e.insights && e.insights.assessmentsApiUrl || "https://apigw.ytica.com/assess";
    }, t.getFlexInsightsSSOUrl = function (e) {
      return e.insights && e.insights.ssoUrl || "https://apigw.ytica.com/provisioning/token-generator";
    }, t.getFlexInsightsPlayerConfig = function (e) {
      return e.insights && e.insights.player || r.defaultEnvConfig;
    }, t.getFlexInsightsInitTimeout = function (e) {
      return e.insights && e.insights.initTimeout || 1e4;
    }, t.getWorkspaceTaskChannelsUrl = function (e, t) {
      var n = e.taskRouterUrl || "https://taskrouter.twilio.com";
      return a.workspaceTaskChannels(n, t);
    }, t.getWorkspaceTaskQueuesUrl = function (e, t) {
      var n = e.taskRouterUrl || "https://taskrouter.twilio.com";
      return a.workspaceTaskQueues(n, t);
    }, t.getAnalyticsUrl = function (e) {
      var t = e.insights && e.insights.analyticsUrl;
      return t || "https://analytics.ytica.com";
    }, t.getQueuesStatsConfig = function (e) {
      return e.queuesStats || {};
    }, t.getRedirectServiceApi = function (e, t) {
      var n = e.redirectServiceUrl || "https://services.twilio.com/flex-insights-drilldown/accounts";
      return a.redirectServiceApi(n, t);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FEATURE_FLAG_OVERRIDE = t.FEATURE_FLAGS_OVERRIDES_UPDATE = t.FEATURE_FLAGS_UPDATE = t.FeatureStage = t.FeatureFlag = void 0, function (e) {
      e.TestFeature = "test-feature", e.TestPilotFeature = "test-pilot-feature", e.InsightsPlayer = "insights-player", e.ConversationScreen = "insights-conversation-screen", e.FlexInsights = "flex-insights", e.FlexInsightsForceDisable = "flex-insights-force-disable", e.AdvancedTeamsViewFilters = "advanced-teams-view-filters", e.AdvancedTeamsViewFiltersGA = "advanced-teams-view-filters-ga", e.FileAttachmentsInChat = "file-attachments-in-chat", e.QueueDetail = "flex-queue-detail", e.SingleSession = "flex-single-session", e.DebuggerUI = "flex-debugger-ui", e.DebuggerIntegration = "debugger-integration-v2", e.ChatAutoJoin = "flex-chat-auto-join", e.EmailPOC = "flex-email-POC", e.InsightsNativeDashboards = "insights-native-dashboards", e.InsightsNativeDashboardsBeta = "insights-native-dashboards-beta", e.DisableErrorTelemetry = "flex-disable-error-telemetry", e.ExternalWarmTransfers = "external-warm-transfers", e.PluginRenderInjectSrc = "plugin-render-inject-src", e.InsightsIdentityNext = "insights-identity-next", e.PluginsUsePluginProxy = "plugin-use-plugin-proxy", e.PluginActivityConsoleLogging = "plugin-activity-console-logging";
    }(t.FeatureFlag || (t.FeatureFlag = {})), function (e) {
      e.Private = "private", e.Pilot = "pilot", e.Beta = "beta", e.ForceEnable = "force-enable", e.ForceDisable = "force-disable";
    }(t.FeatureStage || (t.FeatureStage = {})), t.FEATURE_FLAGS_UPDATE = "FLEX_FEATURE_FLAGS_UPDATE", t.FEATURE_FLAGS_OVERRIDES_UPDATE = "FLEX_FEATURE_FLAGS_OVERRIDES_UPDATE", t.FEATURE_FLAG_OVERRIDE = "FLEX_FEATURE_FLAG_OVERRIDE";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FeatureFlags = void 0;
    var r = n(3),
      o = n(53),
      i = n(167),
      a = function () {
        function e() {}
        return e.isEnabled = function (e) {
          var t = i.featureFlagsSelector(r.FlexModule.state);
          return t[e] ? t[e].enabled : void 0;
        }, e.set = function (e, t) {
          o.Actions.overrideFeatureFlag({
            id: e,
            enabled: t
          });
        }, e;
      }();
    t.FeatureFlags = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TelemetryWrapper = t.TelemetryManager = t.ProgrammabilityEventCallType = t.ProgrammabilityEvent = void 0;
    var r = n(165);
    Object.defineProperty(t, "ProgrammabilityEvent", {
      enumerable: !0,
      get: function get() {
        return r.ProgrammabilityEvent;
      }
    }), Object.defineProperty(t, "ProgrammabilityEventCallType", {
      enumerable: !0,
      get: function get() {
        return r.ProgrammabilityEventCallType;
      }
    });
    var o = n(166);
    Object.defineProperty(t, "TelemetryManager", {
      enumerable: !0,
      get: function get() {
        return o.TelemetryManager;
      }
    });
    var i = n(318);
    Object.defineProperty(t, "TelemetryWrapper", {
      enumerable: !0,
      get: function get() {
        return i.TelemetryWrapper;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r2,
      o = this && this.__extends || (_r2 = function r(e, t) {
        return (_r2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      s = this && this.__metadata || function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      },
      l = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      c = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ManagerForOutside = t.Manager = t.defaultConfiguration = void 0;
    var u = n(0),
      p = n(86),
      d = n(178),
      f = n(7),
      h = n(28),
      m = n(179),
      g = n(3),
      y = n(44),
      v = n(69),
      b = n(5),
      C = n(10),
      _ = n(6),
      k = n(121),
      w = n(180),
      S = n(25),
      P = n(39),
      T = n(125),
      O = n(20),
      x = n(162),
      E = n(46),
      A = n(385),
      I = n(386);
    t.defaultConfiguration = I.default;
    var j = n(11),
      L = n(32),
      M = n(45),
      F = n(40),
      D = n(95),
      N = n(96),
      R = n(97),
      B = n(12),
      U = n(71),
      H = n(124),
      W = function W(e) {
        return e.flex.chat;
      },
      V = function () {
        function e(e, t) {
          this._initialized = !1, this._store = t, this.configureReduxStore(), this.updateConfig(I.default, e), B.TelemetryManager.resetContext();
        }
        var t, n;
        return e.getInstance = function () {
          return this._instance;
        }, e.validateConfig = function (e) {
          "string" == typeof e.colorTheme && (e.colorTheme = {
            baseName: e.colorTheme
          });
        }, e.updateLogLevels = function (e) {
          var t,
            n,
            r,
            o,
            i,
            a,
            s,
            l,
            c,
            p,
            d,
            f,
            h,
            m = !0;
          void 0 !== (null === (n = null === (t = e.sdkOptions) || void 0 === t ? void 0 : t.voice) || void 0 === n ? void 0 : n.debug) ? m = null === (o = null === (r = e.sdkOptions) || void 0 === r ? void 0 : r.voice) || void 0 === o ? void 0 : o.debug : !e.logLevel || "warn" !== e.logLevel && "error" !== e.logLevel && "silent" !== e.logLevel || (m = !1);
          var g = {
            chat: {
              logLevel: (null === (a = null === (i = e.sdkOptions) || void 0 === i ? void 0 : i.chat) || void 0 === a ? void 0 : a.logLevel) || e.logLevel || "debug"
            },
            worker: {
              logLevel: (null === (l = null === (s = e.sdkOptions) || void 0 === s ? void 0 : s.worker) || void 0 === l ? void 0 : l.logLevel) || e.logLevel || "debug"
            },
            flex: {
              logger: {
                level: (null === (d = null === (p = null === (c = e.sdkOptions) || void 0 === c ? void 0 : c.flex) || void 0 === p ? void 0 : p.logger) || void 0 === d ? void 0 : d.level) || e.logLevel || "debug"
              }
            },
            voice: {
              debug: m
            },
            insights: {
              logLevel: (null === (h = null === (f = e.sdkOptions) || void 0 === f ? void 0 : f.insights) || void 0 === h ? void 0 : h.logLevel) || e.logLevel || "debug"
            }
          };
          return u.Utils.merge(e, {
            sdkOptions: g
          });
        }, e.updateChatConfig = function () {
          var e = i(i({}, g.FlexModule.state.config.fileAttachment), {
            enabled: j.FeatureFlags.isEnabled(C.FeatureFlag.FileAttachmentsInChat)
          });
          u.ChatManager.config = {
            fileAttachment: e
          };
        }, e.createProxiedInstance = function () {
          this._proxiedInstance = new Proxy(this._instance, {
            get: function get(e, t, n) {
              return "workerClient" !== t && "voiceClient" !== t && "insightClient" !== t && "chatClient" !== t || B.TelemetryManager.reportSDKUsage(t), Reflect.get(e, t, n);
            }
          });
        }, e.create = function (t, n, r) {
          return l(this, void 0, Promise, function () {
            var o,
              i,
              a,
              s,
              p,
              d,
              h,
              v,
              k = this;
            return c(this, function (w) {
              switch (w.label) {
                case 0:
                  if ("object" != typeof t && (t = n, n = r, b.log.warn("Deprecated signature of Manager.create called and will not be supported by the future releases. Please change accordingly. Pass first parameter as configuration object and optionally your own Redux store as second parameter.")), b.log.setLevel(void 0 === t.logLevel ? "error" : t.logLevel), b.log.info("Manager: Creating manager. flex-ui version:", E.VERSION, "core-ui version:", u.VERSION), b.log.debug('Manager: Flex UI bundle type - "library"'), b.log.debug('Manager: React version - "' + window.React.version + '"'), n || (o = y.default(t.router), n = T.createDefaultStore({
                    history: o,
                    enableReduxLogging: t.enableReduxLogging
                  })), !n.getState().flex) throw f.ErrorManager.createAndProcessError("Invalid Redux store passed. 'flex' key not found in state.", {
                    type: f.FlexErrorType.app,
                    context: "Manager"
                  });
                  return a = function a() {
                    return l(k, void 0, void 0, function () {
                      return c(this, function (e) {
                        switch (e.label) {
                          case 0:
                            return !_.isAdmin(i.user) && !_.isSupervisor(i.user) || !j.FeatureFlags.isEnabled(C.FeatureFlag.FlexInsights) && void 0 !== j.FeatureFlags.isEnabled(C.FeatureFlag.FlexInsights) || j.FeatureFlags.isEnabled(C.FeatureFlag.FlexInsightsForceDisable) ? [3, 2] : [4, M.InsightsService.init(i)];
                          case 1:
                            return e.sent(), [3, 3];
                          case 2:
                            P.Actions.updateInsightsServiceStatus(F.InsightsServiceStatus.Inactive), e.label = 3;
                          case 3:
                            return [2];
                        }
                      });
                    });
                  }, [4, N.SSOLoginHandler.create(t.sso)];
                case 1:
                  s = w.sent(), b.log.info("Manager: loginHandler created"), i = new e(t, n), b.log.info("Manager: manager created"), w.label = 2;
                case 2:
                  return w.trys.push([2, 9,, 11]), [4, i.fetchConfiguration()];
                case 3:
                  if (p = w.sent(), b.log.info("Manager: remote config received"), !i.validateServiceVersion()) throw b.log.error("Manager: Service version is not compatible"), f.ErrorManager.createAndProcessError("Service version is not compatible", {
                    context: "Manager"
                  });
                  i.updateConfig(p || {}, t), f.ErrorManager.updateSessionData({
                    config: i.configuration,
                    reactVersion: window.React.version,
                    bundleType: "library",
                    userAgent: navigator.userAgent
                  }), e._instance = i, this.createProxiedInstance(), d = void 0, w.label = 4;
                case 4:
                  return w.trys.push([4, 6,, 7]), [4, L.FlexClientManager.fetchFlexFeatures(i)];
                case 5:
                  return w.sent(), b.log.info("Manager: features received"), [3, 7];
                case 6:
                  return h = w.sent(), d = h, [3, 7];
                case 7:
                  return [4, P.Actions.ssoLogin(s)];
                case 8:
                  return w.sent(), b.log.info("Manager: ssoLogin done"), d && f.ErrorManager.createAndProcessError("Failed to fetch feature flag configuration", {
                    type: f.FlexErrorType.app,
                    context: "Manager",
                    wrappedError: d
                  }), [3, 11];
                case 9:
                  return v = w.sent(), [4, R.parseCriticalPathError(v)];
                case 10:
                  throw w.sent(), v;
                case 11:
                  return !j.FeatureFlags.isEnabled(C.FeatureFlag.SingleSession) || L.FlexClientManager.isDegraded(g.FlexModule.workerClient) ? [3, 13] : [4, P.Actions.validateSession()];
                case 12:
                  w.sent(), w.label = 13;
                case 13:
                  return [4, a()];
                case 14:
                  return w.sent(), [4, L.FlexClientManager.initFlexPlugins(m.Flex, i)];
                case 15:
                  return w.sent(), B.TelemetryManager.reportSessionStartEvent({
                    enabledFeatureFlags: Object.values(C.FeatureFlag).filter(j.FeatureFlags.isEnabled),
                    config: e.getInstance().configuration,
                    plugins: D.Plugins.plugins,
                    flexVersion: E.VERSION
                  }), B.TelemetryManager.reportUIInteractionEvent({
                    name: "session_start_extension",
                    status: "start",
                    details: {
                      domain: window.location.origin
                    }
                  }), e.updateChatConfig(), j.FeatureFlags.isEnabled(C.FeatureFlag.EmailPOC) && O.TaskChannels.register(x.ChatEmail), b.log.info("Manager: ready to launch"), [2, i];
              }
            });
          });
        }, e.prototype.updateConfig = function () {
          for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
          var r = t.reduce(function (e, t) {
              return u.Utils.merge(e, t);
            }, this.configuration),
            o = e.updateLogLevels(r);
          if (e.validateConfig(o), this.setStringsFromConfig(o), o.componentProps && u.Utils.updateDefaultProps(p, o.componentProps), o.notifications) {
            var i = o.notifications.browser;
            i && !window.Notification && (b.log.warn("Manager: This browser does not support Notification capabilities"), i = !1), u.Notifications.toggleNotificationHandler(u.DefaultNotificationHandlerType.Browser, i);
          }
          w.Actions.initConfig(o);
        }, Object.defineProperty(e.prototype, "configuration", {
          get: function get() {
            return g.FlexModule.state.config;
          },
          set: function set(t) {
            e.validateConfig(t), e.validateConfig(I.default), t = u.Utils.merge(I.default, t), this.setStringsFromConfig(t), t.componentProps && u.Utils.updateDefaultProps(p, t.componentProps), w.Actions.initConfig(t);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "serviceConfiguration", {
          get: function get() {
            return this._serviceConfiguration;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "store", {
          get: function get() {
            return this._store;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "events", {
          get: function get() {
            return h.getProxiedFlexEventEmitter(g.FlexModule.events);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "strings", {
          get: function get() {
            if (!this._strings) throw f.ErrorManager.createAndProcessError("Strings not set", {
              context: "Manager"
            });
            return this._strings;
          },
          set: function set(e) {
            this._strings = e, this._initialized && u.initWithStrings(e);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "user", {
          get: function get() {
            var e = g.FlexModule.state.session.ssoTokenPayload;
            return {
              identity: e.identity,
              roles: e.roles,
              token: e.token,
              tokenExpirationDate: new Date(Date.parse(e.expiration))
            };
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "chatClient", {
          get: function get() {
            return g.FlexModule.chatClient;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "voiceClient", {
          get: function get() {
            return g.FlexModule.voiceClient;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "workerClient", {
          get: function get() {
            return g.FlexModule.workerClient;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "insightsClient", {
          get: function get() {
            return g.FlexModule.insightsClient;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.loadInitialData = function () {
          return this._initialized || (u.initWithStrings(this.strings), O.initAllRegisteredTaskChannels(p), this._initialized = !0), Promise.resolve();
        }, e.prototype.reportPluginInteraction = function (e) {
          B.TelemetryManager.reportPluginInteraction(e);
        }, e.prototype.fetchConfiguration = function () {
          return l(this, void 0, Promise, function () {
            var e,
              t = this;
            return c(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, U.TokenManager.getActiveTokenPayload()];
                case 1:
                  if (!(e = n.sent())) throw f.ErrorManager.createAndProcessError("Manager: Your session has expired", {
                    type: f.FlexErrorType.app,
                    context: "Manager"
                  });
                  return [2, u.FlexSDKManager.getAccountConfig(e.token).then(function (e) {
                    var n,
                      r = e,
                      o = Object.keys(r).reduce(function (e, t) {
                        var n;
                        return i(i({}, e), ((n = {})[H(t)] = r[t], n));
                      }, {});
                    return o.date_created = r.dateCreated.toISOString(), o.date_updated = r.dateUpdated.toISOString(), t._serviceConfiguration = o, r.queueStatsConfiguration && S.Actions.updateQueuesConfiguration(o.queue_stats_configuration), i(i({}, r.uiAttributes), {
                      sso: {
                        accountSid: r.accountSid
                      },
                      serviceBaseUrl: r.runtimeDomain,
                      notifications: i(i({}, r.notifications), {
                        browser: null === (n = r.notifications) || void 0 === n ? void 0 : n.enabled
                      }),
                      markdown: r.markdown
                    });
                  }).catch(function (e) {
                    throw f.ErrorManager.createAndProcessError("Manager: Failed to fetch configuration", {
                      type: f.FlexErrorType.app,
                      context: "Manager",
                      wrappedError: e
                    });
                  })];
              }
            });
          });
        }, e.prototype.validateServiceVersion = function () {
          if (!this._serviceConfiguration) throw f.ErrorManager.createAndProcessError("No service configuration", {
            context: "Manager"
          });
          var e = this._serviceConfiguration.ui_attributes;
          if (!e) throw f.ErrorManager.createAndProcessError("No ui_attributes in service configuration", {
            context: "Manager"
          });
          return A.isCompatible(e.version_compatibility, e.version_message);
        }, e.prototype.configureReduxStore = function () {
          g.FlexModule.init(this._store), u.ChatModule.init(this._store, W);
        }, e.prototype.setStringsFromConfig = function (e) {
          if (this.configuration.language !== e.language) {
            var t = e.language || "default",
              n = v.languages[t] || v.languages.default;
            this.strings = n;
          }
        }, a([d.deprecatedSetter("updateConfig"), s("design:type", "function" == typeof (t = void 0 !== k && k.Config) ? t : Object), s("design:paramtypes", ["function" == typeof (n = void 0 !== k && k.Config) ? n : Object])], e.prototype, "configuration", null), e;
      }();
    t.Manager = V;
    var z = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.getInstance = function () {
        return this._proxiedInstance;
      }, t;
    }(V);
    t.ManagerForOutside = z;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DegradedModeActive = t.FailedToFetchParticipants = t.ExternalWarmTransferFailed = t.NoTokenError = t.SecondVoiceConnectionIncoming = t.AddingAssessmentFailed = t.AddingCommentFailed = t.SLAPreferencesCustomLevelsError = t.SLAPreferencesCustomLevelsSuccess = t.GlobalSLSaveSuccess = t.NoNetworkConnection = t.NoInputDevice = t.CopyClipboardFailed = t.InsightsPlayerPlaybackFailed = t.InsightsPlayerLoadingSegmentFailed = t.FlexInsightsDataFetchFailed = t.FlexInsightsLoginFailed = t.OutboundCallCanceledFromNumberUnverified = t.OutboundCallCanceledDisabledCountry = t.OutboundCallCanceledInvalidNumber = t.OutboundCallCanceledNoAnswer = t.OutboundCallCanceledBusy = t.OutboundCallCanceledGeneric = t.IncomingCBMTaskNotSupported = t.IncomingTask = t.RequestBrowserNotificationPermissions = t.FlexSessionExpired = t.FlexUiVersionDeprecated = t.QueuesStatsStale = t.AudioPlayerGenericErrorNotificationId = t.AudioPlayerInvalidMediaErrorNotificationId = t.AudioPlayerDeniedErrorNotificationId = t.ChatOrchestrationLeaveChatChannelFailed = t.ChatOrchestrationDeactivateChatChannelFailed = t.ChatOrchestrationAddToChatChannelFailed = t.MonitoringFailed = t.CannotChangeOtherWorkerActivity = t.MessageSizeExceeded = t.MicTaken = t.BrowserVoiceDisabled = t.TaskCannotBeTransferred = t.TransferFailed = t.WorkerActivityUpdateFailed = t.PendingReservationsOnActivityStateChange = t.PendingReservationsOnLogout = void 0, t.PendingReservationsOnLogout = "PendingReservationsOnLogout", t.PendingReservationsOnActivityStateChange = "PendingReservationsOnActivityStateChange", t.WorkerActivityUpdateFailed = "WorkerActivityUpdateFailed", t.TransferFailed = "TransferFailed", t.TaskCannotBeTransferred = "TaskCannotBeTransferred", t.BrowserVoiceDisabled = "BrowserVoiceDisabled", t.MicTaken = "MicTaken", t.MessageSizeExceeded = "MessageSizeExceeded", t.CannotChangeOtherWorkerActivity = "CannotChangeOtherWorkerActivity", t.MonitoringFailed = "MonitoringFailed", t.ChatOrchestrationAddToChatChannelFailed = "ChatOrchestrationAddToChatChannelFailed", t.ChatOrchestrationDeactivateChatChannelFailed = "ChatOrchestrationDeactivateChatChannelFailed", t.ChatOrchestrationLeaveChatChannelFailed = "ChatOrchestrationLeaveChatChannelFailed", t.AudioPlayerDeniedErrorNotificationId = "AudioPlayerDeniedError", t.AudioPlayerInvalidMediaErrorNotificationId = "AudioPlayerInvalidMediaError", t.AudioPlayerGenericErrorNotificationId = "AudioPlayerGenericError", t.QueuesStatsStale = "QueuesStatsStale", t.FlexUiVersionDeprecated = "FlexUiVersionDeprecated", t.FlexSessionExpired = "FLEX_SESSION_EXPIRED", t.RequestBrowserNotificationPermissions = "RequestBrowserNotificationPermissions", t.IncomingTask = "IncomingTask", t.IncomingCBMTaskNotSupported = "IncomingCBMTaskNotSupported", t.OutboundCallCanceledGeneric = "OutboundCallCanceledGeneric", t.OutboundCallCanceledBusy = "OutboundCallCanceledBusy", t.OutboundCallCanceledNoAnswer = "OutboundCallCanceledNoAnswer", t.OutboundCallCanceledInvalidNumber = "OutboundCallCanceledInvalidNumber", t.OutboundCallCanceledDisabledCountry = "OutboundCallCanceledDisabledCountry", t.OutboundCallCanceledFromNumberUnverified = "OutboundCallCanceledFromNumberUnverified", t.FlexInsightsLoginFailed = "FlexInsightsLoginFailed", t.FlexInsightsDataFetchFailed = "FlexInsightsDataFetchFailed", t.InsightsPlayerLoadingSegmentFailed = "InsightsPlayerLoadingSegmentFailed", t.InsightsPlayerPlaybackFailed = "InsightsPlayerPlaybackFailed", t.CopyClipboardFailed = "CopyClipboardFailed", t.NoInputDevice = "NoInputDevice", t.NoNetworkConnection = "NoNetworkConnection", t.GlobalSLSaveSuccess = "GlobalSLSaveSuccess", t.SLAPreferencesCustomLevelsSuccess = "SLAPreferencesCustomLevelsSuccess", t.SLAPreferencesCustomLevelsError = "SLAPreferencesCustomLevelsError", t.AddingCommentFailed = "AddingCommentFailed", t.AddingAssessmentFailed = "AddingAssessmentFailed", t.SecondVoiceConnectionIncoming = "SecondVoiceConnectionIncoming", t.NoTokenError = "NoTokenError", t.ExternalWarmTransferFailed = "ExternalWarmTransferFailed", t.FailedToFetchParticipants = "FailedToFetchParticipants", t.DegradedModeActive = "DegradedModeActive";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(26), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ProxiedNotifications = t.registerToNotifications = t.NotificationEvent = t.NotificationType = t.Notifications = t.NotificationIds = void 0;
    var o = n(0);
    Object.defineProperty(t, "NotificationEvent", {
      enumerable: !0,
      get: function get() {
        return o.NotificationEvent;
      }
    }), Object.defineProperty(t, "Notifications", {
      enumerable: !0,
      get: function get() {
        return o.Notifications;
      }
    }), Object.defineProperty(t, "NotificationType", {
      enumerable: !0,
      get: function get() {
        return o.NotificationType;
      }
    });
    var i = n(1),
      a = n(12),
      s = n(68),
      l = n(3),
      c = n(5),
      u = n(14),
      p = n(6),
      d = n(8),
      f = n(114);
    t.NotificationIds = r(r({}, o.NotificationIds), u);
    t.registerToNotifications = function () {
      var e = {
        id: t.NotificationIds.PendingReservationsOnLogout,
        content: "PendingReservationsOnLogoutNotification",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(e);
      var n = {
        id: t.NotificationIds.PendingReservationsOnActivityStateChange,
        content: "PendingReservationsOnActivityStateChangeNotification",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(n);
      var r = {
        id: t.NotificationIds.WorkerActivityUpdateFailed,
        content: "WorkerActivityUpdateFailedNotification",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(r);
      var a = {
        id: t.NotificationIds.BrowserVoiceDisabled,
        content: "BrowserVoiceDisabledNotification",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(a);
      var u = {
        id: t.NotificationIds.TransferFailed,
        content: "TransferFailedNotification",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(u);
      var h = {
        id: t.NotificationIds.TaskCannotBeTransferred,
        content: "TaskCannotBeTransferredNotification",
        type: o.NotificationType.error,
        timeout: 5e3
      };
      o.Notifications.registerNotification(h);
      var m = {
        id: t.NotificationIds.MicTaken,
        content: "MicNotAvailableNotification",
        type: o.NotificationType.error,
        timeout: 5e3
      };
      o.Notifications.registerNotification(m);
      var g = {
        id: t.NotificationIds.CannotChangeOtherWorkerActivity,
        content: "CannotChangeOtherWorkerActivity",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(g);
      var y = {
        id: t.NotificationIds.MonitoringFailed,
        content: "MonitoringFailedNotification",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(y);
      var v = {
        id: t.NotificationIds.MessageSizeExceeded,
        content: "MessageSizeExceeded",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(v);
      var b = {
        id: t.NotificationIds.AddingCommentFailed,
        content: "AddingCommentFailed",
        type: o.NotificationType.error,
        timeout: 5e3
      };
      o.Notifications.registerNotification(b);
      var C = {
        id: t.NotificationIds.AddingAssessmentFailed,
        content: "AddingAssessmentFailed",
        type: o.NotificationType.error,
        timeout: 5e3
      };
      o.Notifications.registerNotification(C), o.Notifications.registerNotification({
        id: t.NotificationIds.ChatOrchestrationAddToChatChannelFailed,
        content: "ChatOrchestrationAddToChatChannelFailed",
        type: o.NotificationType.error
      }), o.Notifications.registerNotification({
        id: t.NotificationIds.ChatOrchestrationDeactivateChatChannelFailed,
        content: "ChatOrchestrationDeactivateChatChannelFailed",
        type: o.NotificationType.error
      }), o.Notifications.registerNotification({
        id: t.NotificationIds.ChatOrchestrationLeaveChatChannelFailed,
        content: "ChatOrchestrationLeaveChatChannelFailed",
        type: o.NotificationType.error
      });
      var _ = {
        id: t.NotificationIds.AudioPlayerDeniedErrorNotificationId,
        content: "AudioPlayerDeniedError",
        type: o.NotificationType.error,
        timeout: 0
      };
      o.Notifications.registerNotification(_);
      var k = {
        id: t.NotificationIds.AudioPlayerInvalidMediaErrorNotificationId,
        content: "AudioPlayerInvalidMediaError",
        type: o.NotificationType.error,
        timeout: 0
      };
      o.Notifications.registerNotification(k);
      var w = {
        id: t.NotificationIds.AudioPlayerGenericErrorNotificationId,
        content: "AudioPlayerGenericError",
        type: o.NotificationType.error,
        timeout: 0
      };
      o.Notifications.registerNotification(w);
      var S = {
        id: t.NotificationIds.FlexUiVersionDeprecated,
        content: "UiVersionDeprecated",
        type: o.NotificationType.warning,
        timeout: 0
      };
      o.Notifications.registerNotification(S);
      var P = {
        id: t.NotificationIds.FlexSessionExpired,
        closeButton: !0,
        content: "SessionExpired",
        timeout: 0,
        type: o.NotificationType.warning
      };
      o.Notifications.registerNotification(P);
      var T = {
        id: t.NotificationIds.DegradedModeActive,
        content: "DegradedWarning",
        type: o.NotificationType.warning,
        timeout: 0,
        recurrenceTimeout: 3e5,
        closeButton: !0,
        actions: [i.createElement(o.NotificationBar.Action, {
          label: "DegradedNotificationRefreshAction",
          onClick: function onClick(e) {
            window.location.reload(), e.preventDefault();
          }
        }), i.createElement(o.NotificationBar.Action, {
          label: "DegradedNotificationDownloadReportAction",
          onClick: function onClick(e) {
            s.downloadReport(l.FlexModule.state.flexErrors.errors), e.preventDefault();
          }
        })]
      };
      o.Notifications.registerNotification(T);
      var O = {
        id: t.NotificationIds.RequestBrowserNotificationPermissions,
        closeButton: !0,
        content: "RequestBrowserNotificationPermissions",
        timeout: 0,
        type: o.NotificationType.warning,
        icon: "Bell",
        onClick: function onClick(e) {
          window.Notification.requestPermission(), o.Notifications.dismissNotificationById(t.NotificationIds.RequestBrowserNotificationPermissions), e.preventDefault();
        }
      };
      o.Notifications.registerNotification(O);
      var x = {
        id: t.NotificationIds.IncomingTask,
        closeButton: !0,
        content: "IncomingUnregisteredTaskNotificationTitle",
        timeout: 0,
        actions: f.incomingTaskNotificationActions
      };
      o.Notifications.registerNotification(x);
      var E = {
        id: t.NotificationIds.IncomingCBMTaskNotSupported,
        content: "IncomingCBMTaskNotSupportedTitle",
        type: o.NotificationType.error,
        timeout: 0
      };
      o.Notifications.registerNotification(E);
      var A = {
        id: t.NotificationIds.FlexInsightsLoginFailed,
        closeButton: !0,
        content: "FlexInsightsLoginFailedNotificationTitle",
        timeout: 0,
        type: o.NotificationType.error,
        actions: [i.createElement(o.NotificationBar.Action, {
          label: "FlexInsightsLoginFailedNotificationAction",
          onClick: function onClick(e, t) {
            o.Notifications.dismissNotification(t), p.tryInvokeAction("ReloadWindow");
          }
        })]
      };
      o.Notifications.registerNotification(A);
      var I = {
        id: t.NotificationIds.FlexInsightsDataFetchFailed,
        closeButton: !0,
        content: "FlexInsightsDataFetchFailedNotificationTitle",
        timeout: 0,
        type: o.NotificationType.error,
        actions: [i.createElement(o.NotificationBar.Action, {
          label: "FlexInsightsLoginFailedNotificationAction",
          onClick: function onClick(e, t) {
            o.Notifications.dismissNotification(t), p.tryInvokeAction("ReloadWindow");
          }
        })]
      };
      o.Notifications.registerNotification(I);
      var j = {
        id: t.NotificationIds.InsightsPlayerLoadingSegmentFailed,
        content: "InsightsPlayerLoadingSegmentFailed",
        type: o.NotificationType.error,
        timeout: 0
      };
      o.Notifications.registerNotification(j);
      var L = {
        id: t.NotificationIds.InsightsPlayerPlaybackFailed,
        content: "InsightsPlayerPlaybackFailed",
        type: o.NotificationType.error,
        timeout: 5e3
      };
      o.Notifications.registerNotification(L);
      var M = {
        id: t.NotificationIds.CopyClipboardFailed,
        content: "CopyClipboardFailed",
        type: o.NotificationType.error,
        timeout: 0
      };
      o.Notifications.registerNotification(M);
      var F = {
        id: t.NotificationIds.NoInputDevice,
        content: "InputDeviceErrorNotification",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(F);
      var D = {
        id: t.NotificationIds.NoNetworkConnection,
        content: "ReconnectingConnection",
        type: o.NotificationType.warning,
        timeout: 0,
        closeButton: !1,
        icon: "ConnectionError"
      };
      o.Notifications.registerNotification(D);
      var N = {
        id: t.NotificationIds.GlobalSLSaveSuccess,
        content: "GlobalSLSuccessNotification",
        type: o.NotificationType.success,
        timeout: 5e3
      };
      o.Notifications.registerNotification(N);
      var R = {
        id: t.NotificationIds.SLAPreferencesCustomLevelsSuccess,
        content: "SLAPreferencesCustomLevelsSuccessNotification",
        type: o.NotificationType.success,
        timeout: 5e3
      };
      o.Notifications.registerNotification(R);
      var B = {
        id: t.NotificationIds.SLAPreferencesCustomLevelsError,
        content: "SLAPreferencesCustomLevelsErrorNotification",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(B);
      var U = {
        id: t.NotificationIds.SecondVoiceConnectionIncoming,
        content: "SecondIncomingVoiceConnectionNotificationContent",
        type: o.NotificationType.warning,
        timeout: 0,
        closeButton: !1,
        actions: [i.createElement(o.NotificationBar.Action, {
          label: "SecondIncomingVoiceConnectionNotificationAccept",
          onClick: function onClick(e, t) {
            t.context && t.context.accept();
          }
        }), i.createElement(o.NotificationBar.Action, {
          label: "SecondIncomingVoiceConnectionNotificationReject",
          onClick: function onClick(e, t) {
            t.context && t.context.reject();
          }
        })]
      };
      o.Notifications.registerNotification(U);
      var H = {
        id: t.NotificationIds.NoTokenError,
        content: "NoTokenErrorNotificationBody",
        type: o.NotificationType.warning,
        timeout: 0,
        actions: [i.createElement(o.NotificationBar.Action, {
          label: "NoTokenErrorNotificationAction",
          onClick: function onClick(e) {
            window.location.reload();
          }
        })]
      };
      o.Notifications.registerNotification(H);
      var W = {
        id: t.NotificationIds.ExternalWarmTransferFailed,
        content: "ExternalWarmTransferFailed",
        type: o.NotificationType.error,
        timeout: 0
      };
      o.Notifications.registerNotification(W);
      var V = {
        id: t.NotificationIds.FailedToFetchParticipants,
        content: "FailedToFetchParticipants",
        type: o.NotificationType.error,
        timeout: 0
      };
      o.Notifications.registerNotification(V), o.Notifications.addListener(o.NotificationEvent.beforeAddNotification, function (e, n) {
        if (e.id === t.NotificationIds.NewChatMessage) {
          if (!e.context) return;
          var r = e.context.lastMessage;
          if (!r) return;
          var o = d.TaskHelper.getTaskFromChannelSid(r.source.channel.sid);
          if (!o) return c.log.debug("Task for message chat channel does not exist - not showing notification"), void n();
          e.context.task = o, e.context.helper = new d.TaskHelper(o);
        }
      });
      var z = o.Notifications.registeredNotifications.get(t.NotificationIds.NewChatMessage);
      z && (z.options.browser.onClick = function (e) {
        p.tryInvokeAction("SelectTask", {
          task: e.context.task
        });
      });
    }, t.ProxiedNotifications = new Proxy(o.Notifications, {
      get: function get(e, t) {
        var n = e[t];
        return "function" == typeof n ? function () {
          for (var r = [], o = 0; o < arguments.length; o++) r[o] = arguments[o];
          switch (t) {
            case "registerHandler":
            case "registerNotification":
              var i = r[0];
              a.TelemetryManager.reportNotificationEvent(i.id, t);
              break;
            case "toggleNotificationHandler":
              var s = r[0],
                l = r[1];
              a.TelemetryManager.reportNotificationEvent(s, t, {
                enabled: l
              });
          }
          return n.apply(e, r);
        } : n;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskChannelHelper = void 0;
    var r = n(1),
      o = n(7),
      i = function () {
        function e() {}
        return e.getTemplateForStatus = function (e, t, n) {
          if (!t && "" !== t) throw o.ErrorManager.createAndProcessError("No template holder", {
            type: o.FlexErrorType.app,
            context: "TaskChannelHelper"
          });
          if ("string" == typeof t) return t;
          if ("function" == typeof t) return t(e, n);
          var r = "pending" === e.status && t.Pending || "accepted" === e.status && t.Accepted || "wrapping" === e.status && t.Wrapping || "completed" === e.status && t.Completed || "canceled" === e.status && t.Canceled || "pending" === e.status && t.Reserved || "accepted" === e.status && t.Assigned;
          return r || (r = ""), r;
        }, e.getIcon = function (e, t, n) {
          if (!t) throw o.ErrorManager.createAndProcessError("No icon holder", {
            type: o.FlexErrorType.app,
            context: "TaskChannelHelper"
          });
          if ("string" == typeof t || r.isValidElement(t)) return t;
          if ("function" == typeof t) return t(e, n);
          var i = t;
          return "wrapping" === e.status && i.Wrapping || "completed" === e.status && i.Completed || "canceled" === e.status && i.Canceled || "pending" === e.status && i.Pending || "accepted" === e.status && i.Accepted || "pending" === e.status && i.Reserved || "accepted" === e.status && i.Assigned;
        }, e.getColor = function (e, t, n) {
          if (!t) throw o.ErrorManager.createAndProcessError("No color holder", {
            type: o.FlexErrorType.app,
            context: "TaskChannelHelper"
          });
          return "string" == typeof t ? t : "function" == typeof t ? t(e, n) : "pending" === e.status && t.Pending || "accepted" === e.status && t.Accepted || "wrapping" === e.status && t.Wrapping || "completed" === e.status && t.Completed || "canceled" === e.status && t.Canceled || "pending" === e.status && t.Reserved || "accepted" === e.status && t.Assigned;
        }, e;
      }();
    t.TaskChannelHelper = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InsightsPlayerMediaLinkType = t.INSIGHTS_PLAYER_MEDIA_SELECT = t.INSIGHTS_PLAYER_SET_MEDIA_LINKS = void 0, t.INSIGHTS_PLAYER_SET_MEDIA_LINKS = "INSIGHTS_PLAYER_SET_MEDIA_LINKS", t.INSIGHTS_PLAYER_MEDIA_SELECT = "INSIGHTS_PLAYER_MEDIA_SELECT", function (e) {
      e.VoiceRecording = "VoiceRecording", e.Raw = "Raw", e.Embedded = "Embedded", e.Referenced = "Referenced", e.ChatTranscript = "ChatTranscript", e.EmailTranscript = "EmailTranscript";
    }(t.InsightsPlayerMediaLinkType || (t.InsightsPlayerMediaLinkType = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Log = t.Plugins = t.UserInfo = t.Manager = t.ContactCenterManager = t.defaultConfiguration = t.ClientManagerInstance = t.ClientManagerHelpers = t.ConfigErrorKeys = t.ConfigError = void 0;
    var i = n(160);
    t.Log = i, o(n(141), t);
    var a = n(48);
    Object.defineProperty(t, "ConfigError", {
      enumerable: !0,
      get: function get() {
        return a.ConfigError;
      }
    }), Object.defineProperty(t, "ConfigErrorKeys", {
      enumerable: !0,
      get: function get() {
        return a.ConfigErrorKeys;
      }
    });
    var s = n(188);
    Object.defineProperty(t, "ClientManagerHelpers", {
      enumerable: !0,
      get: function get() {
        return s.ClientManagerHelpers;
      }
    }), Object.defineProperty(t, "ClientManagerInstance", {
      enumerable: !0,
      get: function get() {
        return s.ClientManagerInstance;
      }
    });
    var l = n(13);
    Object.defineProperty(t, "defaultConfiguration", {
      enumerable: !0,
      get: function get() {
        return l.defaultConfiguration;
      }
    }), Object.defineProperty(t, "ContactCenterManager", {
      enumerable: !0,
      get: function get() {
        return l.ManagerForOutside;
      }
    }), Object.defineProperty(t, "Manager", {
      enumerable: !0,
      get: function get() {
        return l.ManagerForOutside;
      }
    }), Object.defineProperty(t, "UserInfo", {
      enumerable: !0,
      get: function get() {
        return l.UserInfo;
      }
    });
    var c = n(95);
    Object.defineProperty(t, "Plugins", {
      enumerable: !0,
      get: function get() {
        return c.Plugins;
      }
    }), o(n(62), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.initAllRegisteredTaskChannels = t.registerDefaultTaskChannels = t.TaskChannels = t.TaskChannelHelper = t.DefaultTaskChannels = void 0;
    var i = n(0),
      a = n(5),
      s = n(162);
    t.DefaultTaskChannels = s, o(n(52), t);
    var l = n(17);
    Object.defineProperty(t, "TaskChannelHelper", {
      enumerable: !0,
      get: function get() {
        return l.TaskChannelHelper;
      }
    });
    var c = [],
      u = function () {
        function e() {}
        return e.prototype.getRegistered = function () {
          return c;
        }, e.prototype.getForTask = function (e) {
          var t = c.find(function (t) {
            return t.isApplicable(e);
          });
          return t || (a.log.trace("Task channel definition not found for task, using default", e), s.Default);
        }, e.prototype.register = function (e, t) {
          void 0 === t && (t = !0), c.find(function (t) {
            return t === e || t.name === e.name;
          }) ? a.log.error("Task channel with the same name already registered") : (t && (e = i.Utils.merge(s.Default, e)), a.log.info("Registering custom task channel", e.name, e), c.unshift(e));
        }, e.prototype.unregister = function (e) {
          var t = c && c.find(function (t) {
            return t.name === e.name;
          });
          if (t) {
            a.log.info("Unregistering task channel", t);
            var n = t._registrationCallbacks;
            n && Array.isArray(n) && n.forEach(function (e) {
              return "function" == typeof e && e();
            }), c = c.filter(function (e) {
              return e === t;
            });
          } else a.log.warn("Task channel does not exist", e);
        }, e;
      }();
    t.TaskChannels = new u(), t.registerDefaultTaskChannels = function (e) {
      s.initDefaultChannels(e), c = [s.Call, s.ChatLine, s.ChatMessenger, s.ChatSms, s.ChatWhatsApp, s.Chat];
    }, t.initAllRegisteredTaskChannels = function (e) {
      a.log.debug("Initializing registered task channels"), c.forEach(function (t) {
        a.log.debug("Initializing task channel", t.name, t), p(t, e), d(t);
      });
    };
    var p = function p(e, t) {
        var n,
          r = [],
          o = function o(e) {
            if (e) {
              if (t[e]) {
                var n = t[e].Content;
                if (n) return n;
                a.log.error("Component doest not have dynamic Content", e);
              } else a.log.error("Component doest not exist", e);
            } else a.log.error("Invalid target", e);
          },
          i = function i(t, n) {
            Array.isArray(t) && t.forEach(function (t) {
              var i = t.component,
                s = t.target;
              if (i) {
                var l = o(s);
                if (l) {
                  var c = t.options || {};
                  c.replace = n;
                  var u = c.if;
                  c.if = function (t) {
                    return t.task && e.isApplicable(t.task) && (!u || u(t));
                  }, a.log.debug("Registering custom component. Target=" + s + " replace=" + n + ", channel: " + e.name, e, i), r.push(l.add(i, c));
                }
              } else a.log.error("Invalid component", i);
            });
          };
        i(e.addedComponents, !1), i(e.replacedComponents, !0), n = e.removedComponents, Array.isArray(n) && n.forEach(function (t) {
          var n = t.key,
            i = t.target;
          if (n) {
            var s = o(i);
            if (s) {
              var l = t.options || {},
                c = l.if;
              l.if = function (t) {
                return t.task && e.isApplicable(t.task) && (!c || c(t));
              }, a.log.debug("Registering component removal. Target=" + i + ", key: " + n + " channel: " + e.name, e), r.push(s.remove(n, l));
            }
          } else a.log.error("Invalid key", n);
        }), e._registrationCallbacks = r;
      },
      d = function d(e) {
        var t = e.notifications && e.notifications.override;
        t && i.Notifications.addListener("beforeAddNotification", function (n, r) {
          var o = t[n.id];
          if (void 0 !== o) {
            var a = n.context && n.context.task;
            a && e.isApplicable(a) && (null !== o ? "object" == typeof o ? i.Utils.mergeInto(n, o) : "function" == typeof o && o.call(null, n, r) : r());
          }
        });
      };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InsightsPermission = t.InsightsServiceStatus = t.InsightsService = void 0;
    var r = n(45);
    Object.defineProperty(t, "InsightsService", {
      enumerable: !0,
      get: function get() {
        return r.InsightsService;
      }
    });
    var o = n(40);
    Object.defineProperty(t, "InsightsServiceStatus", {
      enumerable: !0,
      get: function get() {
        return o.InsightsServiceStatus;
      }
    }), Object.defineProperty(t, "InsightsPermission", {
      enumerable: !0,
      get: function get() {
        return o.InsightsPermission;
      }
    });
  }, function (e, t) {
    e.exports = require("@material-ui/core");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StateHelper = void 0;
    var r = n(3),
      o = n(8),
      i = function () {
        function e() {}
        return e.getCurrentPhoneCallState = function () {
          return r.FlexModule.state.phone.connection;
        }, e.getChatChannelStateForTask = function (e) {
          var t = o.TaskHelper.getTaskChatChannelSid(e);
          if (t) return r.FlexModule.state.chat.channels[t];
        }, e.getReservation = function (e) {
          var t = r.FlexModule.state.worker.tasks.get(e);
          return t ? t.sourceObject : void 0;
        }, e.getTaskByTaskrouterTaskSid = function (e) {
          return Array.from(r.FlexModule.state.worker.tasks.values()).find(function (t) {
            return t.taskSid === e;
          });
        }, e.hasPendingCall = function () {
          return Array.from(r.FlexModule.state.worker.tasks.values()).some(function (e) {
            return o.TaskHelper.isPending(e) && o.TaskHelper.isCallTask(e);
          });
        }, e;
      }();
    t.StateHelper = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      },
      s = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.mediaLinksSelector = t.currentSegmentOffsetSelector = t.silencesAndCrosstalksSelector = t.displayedFindingsSelector = t.findingsSelector = t.currentSegmentListSelector = t.segmentListSelector = t.segmentSelector = t.currentSegmentSelector = void 0;
    var l = n(3),
      c = n(5),
      u = n(37),
      p = n(18),
      d = n(118),
      f = n(119),
      h = n(54),
      m = n(31),
      g = n(38),
      y = n(187),
      v = {
        segmentsById: {},
        client: void 0,
        playerMediaLinks: [],
        selectedMediaLink: void 0,
        questionnaires: [],
        assessments: {},
        comments: {},
        assessmentSettings: void 0,
        findingsBySegment: {},
        segmentId: void 0,
        insightsProjectDashboards: {},
        insightsAnalyticalDashboards: {},
        insightsDashboardCategory: void 0,
        drillableItemsByDashboard: {},
        profileInfo: void 0
      },
      b = function b(e) {
        return e.insights.segmentsById;
      };
    t.currentSegmentSelector = m.createSelector(b, function (e) {
      return e.insights.segmentId;
    }, function (e, t) {
      return e[t];
    });
    t.segmentSelector = function (e, t) {
      return e.insights.segmentsById[t];
    }, t.segmentListSelector = m.createSelector(t.segmentSelector, function (e) {
      return e && e.data && e.data.conversation && e.data.conversation.segments.map(function (e) {
        return {
          id: e.segment_id,
          duration: e.talk_time,
          offset: null === e.offset ? 0 : e.offset,
          hasFetched: !0,
          agentName: e.agent_name
        };
      });
    }), t.currentSegmentListSelector = m.createSelector(t.currentSegmentSelector, function (e) {
      return e && e.data && e.data.conversation && e.data.conversation.segments.map(function (e) {
        return {
          id: e.segment_id,
          duration: e.talk_time,
          offset: null === e.offset ? 0 : e.offset,
          hasFetched: !0,
          agentName: e.agent_name
        };
      });
    });
    t.findingsSelector = m.createSelector(t.segmentListSelector, function (e) {
      return e.insights.findingsBySegment;
    }, function (e, t) {
      if (!Array.isArray(e)) return [];
      var n = new Map();
      return e.forEach(function (e) {
        var r = t[e.id];
        r && r.forEach(function (e) {
          n.set(e.id, e);
        });
      }), Array.from(n.values());
    }), t.displayedFindingsSelector = m.createSelector(b, t.findingsSelector, function (e, t) {
      return t.filter(function (e) {
        return e.confidence >= 50 && "Silence" !== e.speech_search && "Crosstalk" !== e.speech_search;
      }).map(function (t) {
        return r(r({}, t), {
          offset: t.offset + e[t.segment_id].data.offset
        });
      });
    }), t.silencesAndCrosstalksSelector = m.createSelector(b, t.findingsSelector, function (e, t) {
      return t.filter(function (e) {
        return e.confidence >= 50 && ("Silence" === e.speech_search && e.duration >= 10 || "Crosstalk" === e.speech_search && e.duration >= 5);
      }).map(function (t) {
        return r(r({}, t), {
          offset: t.offset + e[t.segment_id].data.offset
        });
      });
    }), t.currentSegmentOffsetSelector = m.createSelector(t.currentSegmentSelector, function (e) {
      return e ? e.data && e.data.offset : 0;
    }), t.mediaLinksSelector = m.createSelector(t.currentSegmentSelector, function (e) {
      return e && e.data ? e.data.links.content : [];
    });
    var C = function C(e, t) {
      return e[t.identifier] = t, e;
    };
    t.reduce = function (e, t) {
      var n, o, i, l, c, u, m, g, y, b;
      switch (void 0 === e && (e = v), t.type) {
        case h.UPDATE_RECORDING_URL:
          var _ = t.payload,
            k = _.recordingUrl,
            w = _.recordingUrlExpiresAt,
            S = _.segmentId,
            P = null === (b = e.segmentsById[S].data) || void 0 === b ? void 0 : b.recordingUrl,
            T = r({}, e.segmentsById);
          return e.segmentsById[S].data.conversation.segments.forEach(function (t) {
            var n,
              o = t.segment_id;
            (null === (n = e.segmentsById[o].data) || void 0 === n ? void 0 : n.recordingUrl) === P && (T[o] = r(r({}, T[o]), {
              data: r(r({}, T[o].data), {
                recordingUrl: k,
                recordingUrlExpiresAt: w
              })
            }));
          }), r(r({}, e), {
            segmentsById: T
          });
        case h.SEGMENT_FETCH_START:
          var O = r(r({}, e.segmentsById), ((n = {})[t.payload] = {
            id: t.payload,
            hasFetched: !1
          }, n));
          return r(r({}, e), {
            segmentsById: O
          });
        case h.SEGMENT_FETCH_SUCCESS:
          var x = r({}, e.segmentsById);
          return Object.keys(t.payload).forEach(function (e) {
            x[e] = {
              data: t.payload[e].data,
              id: e,
              hasFetched: !0
            };
          }), r(r({}, e), {
            segmentsById: x
          });
        case h.SEGMENT_FETCH_FAILURE:
          O = r(r({}, e.segmentsById), ((o = {})[t.payload.id] = {
            id: t.payload.id,
            hasFetched: !0,
            error: t.payload.error
          }, o));
          return r(r({}, e), {
            segmentsById: O
          });
        case h.ACTION_INIT_INSIGHTS:
          return r(r({}, v), {
            client: t.payload
          });
        case p.INSIGHTS_PLAYER_SET_MEDIA_LINKS:
          return r(r({}, e), {
            playerMediaLinks: t.payload || [],
            selectedMediaLink: t.payload && t.payload.length ? 0 : void 0
          });
        case p.INSIGHTS_PLAYER_MEDIA_SELECT:
          return r(r({}, e), {
            selectedMediaLink: t.payload
          });
        case d.QUESTIONNAIRES_UPDATE:
          return r(r({}, e), {
            questionnaires: t.payload
          });
        case d.ASSESSMENTS_UPDATE:
          return t.payload[0] ? r(r({}, e), {
            assessments: r(r({}, e.assessments), (i = {}, i[t.payload[0].segment_id] = t.payload, i))
          }) : e;
        case d.ASSESSMENTS_ADD:
          if (t.payload) {
            var E = Date.now();
            return r(r({}, e), {
              assessments: r(r({}, e.assessments), (l = {}, l[t.payload.segment_id] = s(e.assessments[t.payload.segment_id] || [], [r(r({}, t.payload), {
                timestamp: E,
                timestamp_updated: E
              })]), l))
            });
          }
          return e;
        case d.ASSESSMENTS_REMOVE:
          return t.payload ? r(r({}, e), {
            assessments: r(r({}, e.assessments), (c = {}, c[t.payload.segment_id] = e.assessments[t.payload.segment_id] ? s(e.assessments[t.payload.segment_id]).filter(function (e) {
              return !(e.answer_id === t.payload.answer_id && e.metric_id === t.payload.metric_id && e.category_id === t.payload.category_id && e.questionnaire_id === t.payload.questionnaire_id);
            }) : void 0, c))
          }) : e;
        case d.ASSESSMENTS_SETTINGS_UPDATE:
          return r(r({}, e), {
            assessmentSettings: t.payload
          });
        case d.COMMENTS_UPDATE:
          return r(r({}, e), {
            comments: r(r({}, e.comments), (u = {}, u[t.payload.agentId] = t.payload.data, u))
          });
        case d.COMMENTS_ADD:
          if (t.payload) {
            E = Date.now();
            return r(r({}, e), {
              comments: r(r({}, e.comments), (m = {}, m[t.payload.agent_id] = s(e.comments[t.payload.agent_id] || [], [r(r({}, t.payload), {
                timestamp: E,
                timestamp_updated: E
              })]), m))
            });
          }
          return e;
        case f.FINDINGS_SET:
          if (t.payload) {
            var A = r(r({}, e.findingsBySegment), ((g = {})[t.payload.segmentId] = t.payload.findings, g));
            return r(r({}, e), {
              findingsBySegment: A
            });
          }
          return e;
        case h.UPDATE_CURRENT_SEGMENT_ID:
          return r(r({}, e), {
            segmentId: t.payload,
            selectedMediaLink: void 0
          });
        case h.UPDATE_INSIGHTS_PROJECT_DASHBOARDS:
          var I = t.payload.reduce(C, {});
          return r(r({}, e), {
            insightsProjectDashboards: I
          });
        case h.UPDATE_INSIGHTS_ANALYTICAL_DASHBOARDS:
          var j = t.payload.reduce(C, {});
          return r(r({}, e), {
            insightsAnalyticalDashboards: j
          });
        case h.UPDATE_DASHBOARD_CATEGORY:
          return r(r({}, e), {
            insightsDashboardCategory: t.payload
          });
        case h.DELETE_DASHBOARD:
          var L = e.insightsAnalyticalDashboards,
            M = t.payload,
            F = (L[M], a(L, ["symbol" == typeof M ? M : M + ""])),
            D = e.insightsProjectDashboards,
            N = t.payload,
            R = (D[N], a(D, ["symbol" == typeof N ? N : N + ""]));
          return r(r({}, e), {
            insightsAnalyticalDashboards: F,
            insightsProjectDashboards: R
          });
        case h.UPDATE_INSIGHTS_PROFILE_INFO:
          return r(r({}, e), {
            profileInfo: t.payload
          });
        case h.UPDATE_DASHBOARD_DRILLABLE_ITEMS:
          if (t.payload) {
            var B = r(r({}, e.drillableItemsByDashboard), ((y = {})[t.payload.dashboardId] = t.payload.items, y));
            return r(r({}, e), {
              drillableItemsByDashboard: B
            });
          }
          return e;
        default:
          return e;
      }
    };
    var _ = function () {
      function e() {}
      return e.dispatchAction = function (e, t) {
        l.FlexModule.dispatch({
          type: e,
          payload: t
        });
      }, e.init = function (e) {
        this.dispatchAction(h.ACTION_INIT_INSIGHTS, e);
      }, e.shutdown = function () {
        return o(this, void 0, void 0, function () {
          var e, t;
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                if (c.log.info("Insights shutdown"), u.InsightsEntityCache.destroy(), !(e = l.FlexModule.state.insights.client)) return [3, 4];
                n.label = 1;
              case 1:
                return n.trys.push([1, 3,, 4]), [4, e.shutdown()];
              case 2:
                return n.sent(), [3, 4];
              case 3:
                return t = n.sent(), c.log.error("Error on Insights shutdown", t), [3, 4];
              case 4:
                return this.dispatchAction(h.ACTION_INIT_INSIGHTS, null), [2];
            }
          });
        });
      }, e.updateGoodDataProfileInfo = function (e) {
        this.dispatchAction(h.UPDATE_INSIGHTS_PROFILE_INFO, e);
      }, e.updateInsightsProjectDashboards = function (e) {
        this.dispatchAction(h.UPDATE_INSIGHTS_PROJECT_DASHBOARDS, e);
      }, e.updateInsightsAnalyticalDashboards = function (e) {
        this.dispatchAction(h.UPDATE_INSIGHTS_ANALYTICAL_DASHBOARDS, e);
      }, e.deleteDashboard = function (e) {
        this.dispatchAction(h.DELETE_DASHBOARD, e);
      }, e.navigateToFirstDashboard = function () {
        var e = y.firstDashboardSelector(l.FlexModule.state);
        e && g.redirectToDashboard(e.identifier);
      }, e.updateDashboardDrillableItems = function (e) {
        this.dispatchAction(h.UPDATE_DASHBOARD_DRILLABLE_ITEMS, e);
      }, e;
    }();
    t.Actions = _;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkspaceStats = t.WorkerQueue = t.UPDATE_QUEUE = t.SET_WORKSPACE_STATS = t.SET_QUEUES = t.QueuesStateActionTypes = t.QueuesState = t.QueuesFilterFunction = t.Queue = t.ActivityStatistic = t.workspaceWaitingTasksSelector = t.workspaceStatsSelector = t.workspaceLongestQueueSelector = t.workspaceActiveTasksSelector = t.queuesListSelector = t.queuesListArrayWithoutEmptyChannelsSelector = t.queuesListArraySelector = t.getUnavailableAgentsCount = t.getOfflineAgentsCount = t.getAvailableAgentsCount = t.reduce = t.initialState = t.Actions = void 0;
    var r = n(181);
    Object.defineProperty(t, "Actions", {
      enumerable: !0,
      get: function get() {
        return r.Actions;
      }
    }), Object.defineProperty(t, "initialState", {
      enumerable: !0,
      get: function get() {
        return r.initialState;
      }
    }), Object.defineProperty(t, "reduce", {
      enumerable: !0,
      get: function get() {
        return r.reduce;
      }
    });
    var o = n(368);
    Object.defineProperty(t, "getAvailableAgentsCount", {
      enumerable: !0,
      get: function get() {
        return o.getAvailableAgentsCount;
      }
    }), Object.defineProperty(t, "getOfflineAgentsCount", {
      enumerable: !0,
      get: function get() {
        return o.getOfflineAgentsCount;
      }
    }), Object.defineProperty(t, "getUnavailableAgentsCount", {
      enumerable: !0,
      get: function get() {
        return o.getUnavailableAgentsCount;
      }
    });
    var i = n(55);
    Object.defineProperty(t, "queuesListArraySelector", {
      enumerable: !0,
      get: function get() {
        return i.queuesListArraySelector;
      }
    }), Object.defineProperty(t, "queuesListArrayWithoutEmptyChannelsSelector", {
      enumerable: !0,
      get: function get() {
        return i.queuesListArrayWithoutEmptyChannelsSelector;
      }
    }), Object.defineProperty(t, "queuesListSelector", {
      enumerable: !0,
      get: function get() {
        return i.queuesListSelector;
      }
    }), Object.defineProperty(t, "workspaceActiveTasksSelector", {
      enumerable: !0,
      get: function get() {
        return i.workspaceActiveTasksSelector;
      }
    }), Object.defineProperty(t, "workspaceLongestQueueSelector", {
      enumerable: !0,
      get: function get() {
        return i.workspaceLongestQueueSelector;
      }
    }), Object.defineProperty(t, "workspaceStatsSelector", {
      enumerable: !0,
      get: function get() {
        return i.workspaceStatsSelector;
      }
    }), Object.defineProperty(t, "workspaceWaitingTasksSelector", {
      enumerable: !0,
      get: function get() {
        return i.workspaceWaitingTasksSelector;
      }
    });
    var a = n(89);
    Object.defineProperty(t, "ActivityStatistic", {
      enumerable: !0,
      get: function get() {
        return a.ActivityStatistic;
      }
    }), Object.defineProperty(t, "Queue", {
      enumerable: !0,
      get: function get() {
        return a.Queue;
      }
    }), Object.defineProperty(t, "QueuesFilterFunction", {
      enumerable: !0,
      get: function get() {
        return a.QueuesFilterFunction;
      }
    }), Object.defineProperty(t, "QueuesState", {
      enumerable: !0,
      get: function get() {
        return a.QueuesState;
      }
    }), Object.defineProperty(t, "QueuesStateActionTypes", {
      enumerable: !0,
      get: function get() {
        return a.QueuesStateActionTypes;
      }
    }), Object.defineProperty(t, "SET_QUEUES", {
      enumerable: !0,
      get: function get() {
        return a.SET_QUEUES;
      }
    }), Object.defineProperty(t, "SET_WORKSPACE_STATS", {
      enumerable: !0,
      get: function get() {
        return a.SET_WORKSPACE_STATS;
      }
    }), Object.defineProperty(t, "UPDATE_QUEUE", {
      enumerable: !0,
      get: function get() {
        return a.UPDATE_QUEUE;
      }
    }), Object.defineProperty(t, "WorkerQueue", {
      enumerable: !0,
      get: function get() {
        return a.WorkerQueue;
      }
    }), Object.defineProperty(t, "WorkspaceStats", {
      enumerable: !0,
      get: function get() {
        return a.WorkspaceStats;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r3,
      o = this && this.__extends || (_r3 = function r(e, t) {
        return (_r3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      s = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.withTaskContext = t.TaskContextSource = t.TaskContext = void 0;
    var l = n(1),
      c = n(130),
      u = n(8),
      p = n(23),
      d = n(20),
      f = n(3);
    t.TaskContext = l.createContext({});
    var h = function h(e, t) {
        var n,
          r = e.worker.tasks.get(t.taskSid);
        return u.TaskHelper.isCallTask(r) && (n = e.conferences.states.get(r.taskSid)), {
          task: r,
          conference: n,
          call: r && (u.TaskHelper.isLiveCall(r) || u.TaskHelper.isInitialOutboundAttemptTask(r)) ? p.StateHelper.getCurrentPhoneCallState() : void 0,
          chatChannel: r && u.TaskHelper.isChatBasedTask(r) ? e.chat.channels[u.TaskHelper.getTaskChatChannelSid(r)] : void 0
        };
      },
      m = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          var e = this.props,
            n = (e.taskSid, e.children),
            r = s(e, ["taskSid", "children"]);
          return r.channelDefinition = r.task ? d.TaskChannels.getForTask(r.task) : void 0, l.createElement(t.TaskContext.Provider, {
            value: r
          }, n);
        }, n = a([f.connect(h)], n);
      }(l.PureComponent);
    t.TaskContextSource = m, t.withTaskContext = function (e) {
      var n;
      return c(((n = function (n) {
        function r() {
          return null !== n && n.apply(this, arguments) || this;
        }
        return o(r, n), r.prototype.render = function () {
          var n = this;
          return l.createElement(t.TaskContext.Consumer, null, function (t) {
            return l.createElement(e, i({}, n.props, t));
          });
        }, r;
      }(l.PureComponent)).displayName = "WithTaskContext(" + e.displayName + ")", n), e);
    };
  }, function (e, t) {
    e.exports = require("axios");
  }, function (e, t, n) {
    "use strict";

    var _r4,
      o = this && this.__extends || (_r4 = function r(e, t) {
        return (_r4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getProxiedFlexEventEmitter = t.FlexEventEmitter = t.FlexConnectionStatus = t.FlexEvent = void 0;
    var a,
      s = n(116),
      l = n(12),
      c = n(5);
    !function (e) {
      e.viewResized = "viewResized", e.flexSplitterResize = "flexSplitterResize", e.userLoggedIn = "userLoggedIn", e.selectedViewChanged = "selectedViewChanged", e.tokenUpdated = "tokenUpdated", e.tokenExpired = "tokenExpired", e.pluginsLoaded = "pluginsLoaded", e.chatChannelJoining = "chatChannelJoining", e.connectionStateChanged = "connectionStateChanged", e.error = "flexError", e.sessionValidated = "sessionValidated", e.sessionInvalidated = "sessionInvalidated", e.yticaTokenUpdated = "yticaTokenUpdated";
    }(a = t.FlexEvent || (t.FlexEvent = {})), function (e) {
      e.connected = "connected", e.notConnected = "notConnected";
    }(t.FlexConnectionStatus || (t.FlexConnectionStatus = {}));
    var u = function (e) {
      function t() {
        var t = e.call(this) || this;
        return t.emitSelectedViewChanged = function (e, n) {
          t.emit(a.selectedViewChanged, e, n);
        }, t.setMaxListeners(100), t;
      }
      return o(t, e), t.prototype.emit = function (t) {
        for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
        return c.log.debug("Flex event emitter:", t, n), e.prototype.emit.apply(this, i([t], n));
      }, t.prototype.emitSplitterResize = function () {
        this.emit(a.flexSplitterResize);
      }, t.prototype.emitViewResized = function (e) {
        this.emit(a.viewResized, e);
      }, t.prototype.emitUserLoggedIn = function () {
        this.emit(a.userLoggedIn);
      }, t.prototype.emitTokenUpdated = function (e) {
        this.emit(a.tokenUpdated, e);
      }, t.prototype.emitTokenExpired = function () {
        this.emit(a.tokenExpired);
      }, t.prototype.emitPluginsLoaded = function () {
        this.emit(a.pluginsLoaded);
      }, t.prototype.emitChatChannelJoining = function (e) {
        this.emit(a.chatChannelJoining, e);
      }, t.prototype.emitConnectionStateChanged = function (e) {
        this.emit(a.connectionStateChanged, e);
      }, t.prototype.emitError = function (e) {
        this.emit(a.error, e);
      }, t.prototype.emitSessionInvalidated = function () {
        this.emit(a.sessionInvalidated);
      }, t.prototype.emitSessionValidated = function () {
        this.emit(a.sessionValidated);
      }, t.prototype.emitYticaTokenUpdated = function (e) {
        this.emit(a.yticaTokenUpdated, e);
      }, t;
    }(s.EventEmitter);
    t.FlexEventEmitter = u;
    t.getProxiedFlexEventEmitter = function (e) {
      return new Proxy(e, {
        get: function get(e, t) {
          var n = e[t];
          return ["addListener", "on", "removeListener", "removeAllListeners", "once", "off", "prependListener", "prependOnceListener"].indexOf(t) > -1 ? function () {
            for (var r = [], o = 0; o < arguments.length; o++) r[o] = arguments[o];
            return l.TelemetryManager.reportFlexEventListeners(r[0], t), n.apply(e, r);
          } : n;
        }
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorMessages = void 0, function (e) {
      e.INSIGHTS_PLAYER_PLAYBACK_FAILED = "Insights Player has failed to play the recording", e.TEAMS_VIEW_SET_FILTER_FAILED = "Failed to set the TeamsView filter query", e.QS_VIEW_SUBSCRIPTION_INIT_FAILED = "Failed to subscribe to Queues statistics", e.CONVERSATION_SERVICE_PRESIGNED_URL_FETCH_FAILED = "Failed to fetch presigned recording URL", e.CONVERSATION_SERVICE_PEAKS_FETCH_FAILED = "Failed to fetch the waveform for the recording", e.INSIGHTS_SERVICE_USE_BEFORE_INIT = "Unable to use InsightsService before it is initialized", e.INSIGHTS_TOKEN_REFRESH_FAILED = "Failed to refresh insights token", e.INSIGHTS_DASHBOARDS_INVALID_HANDLER_TYPE = "Invalid handler type for Dashboard event provided";
    }(t.ErrorMessages || (t.ErrorMessages = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ValidationMessage = t.ChannelConfigurationListItemContent = t.Select = t.InputLabel = t.StyledInputLabel = t.StyledInputLabelText = t.InputSuffix = t.SuffixContent = t.Input = t.SectionContent = t.SectionSubtile = t.SectionTitle = t.DialogContent = t.DialogFooter = t.DialogHeader = t.SectionHeader = t.Section = t.PageFooter = t.PageHeader = t.PageContent = t.PageSubtitle = t.PageTitle = t.DialogError = t.FooterButtons = t.FooterWrapper = t.HeaderWrapper = t.Page = t.ButtonWithProgress = t.Button = void 0;
    var i = n(1),
      a = n(2),
      s = n(0),
      l = n(22),
      c = n(512),
      u = a.withTheme(function (e) {
        return i.createElement(s.Button, o({
          roundCorners: !1,
          themeOverride: {
            background: e.secondary ? e.theme.colors.base2 : e.theme.colors.defaultButtonColor,
            color: e.secondary ? e.theme.colors.base7 : e.theme.colors.lightTextColor
          }
        }, e));
      });
    t.Button = a.default(u)(d || (d = r(["\n    border-radius: 4px;\n    font-size: 14px;\n    line-height: 24px;\n    padding: 7px 23px;\n    letter-spacing: normal;\n    height: auto;\n    position: relative;\n    border: 1px solid ", ";\n\n    ", "\n"], ["\n    border-radius: 4px;\n    font-size: 14px;\n    line-height: 24px;\n    padding: 7px 23px;\n    letter-spacing: normal;\n    height: auto;\n    position: relative;\n    border: 1px solid ", ";\n\n    ", "\n"])), function (e) {
      return e.secondary ? e.theme.colors.base4 : e.theme.colors.defaultButtonColor;
    }, function (e) {
      return e.disabled && "pointer-events: none";
    });
    var p = a.default(l.CircularProgress)(f || (f = r(["\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin-left: -", "px;\n    margin-top: -", "px;\n    color: inherit;\n"], ["\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin-left: -", "px;\n    margin-top: -", "px;\n    color: inherit;\n"])), function (e) {
      return e.size / 2;
    }, function (e) {
      return e.size / 2;
    });
    t.ButtonWithProgress = function (e) {
      return i.createElement(t.Button, o({}, e, {
        disabled: e.disabled || e.isProgressing
      }), e.isProgressing && i.createElement(p, {
        size: 15
      }), i.createElement("span", {
        style: {
          opacity: e.isProgressing ? 0 : 1
        }
      }, e.children));
    }, t.Page = a.default("div")(h || (h = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow: auto;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow: auto;\n"]))), t.HeaderWrapper = a.default("div")(m || (m = r(["\n    padding: 18px 32px 28px;\n    border-bottom: 1px solid ", ";\n"], ["\n    padding: 18px 32px 28px;\n    border-bottom: 1px solid ", ";\n"])), function (e) {
      return e.theme.colors.base5;
    }), t.FooterWrapper = a.default("div")(g || (g = r(["\n    padding: 28px 32px;\n    border-top: 1px solid ", ";\n"], ["\n    padding: 28px 32px;\n    border-top: 1px solid ", ";\n"])), function (e) {
      return e.theme.colors.base5;
    }), t.FooterButtons = a.default("div")(y || (y = r(["\n    display: flex;\n    justify-content: flex-end;\n    margin: 0 -8px;\n    > * {\n        margin: 0 8px;\n    }\n"], ["\n    display: flex;\n    justify-content: flex-end;\n    margin: 0 -8px;\n    > * {\n        margin: 0 8px;\n    }\n"]))), t.DialogError = a.default("div")(v || (v = r(["\n    font-size: 14px;\n    color: black;\n    background-color: ", ";\n    padding: 18px 16px;\n    border-radius: 4px;\n    margin-bottom: 1em;\n"], ["\n    font-size: 14px;\n    color: black;\n    background-color: ", ";\n    padding: 18px 16px;\n    border-radius: 4px;\n    margin-bottom: 1em;\n"])), function (e) {
      return e.theme.colors.notificationBackgroundColorError;
    }), t.PageTitle = a.default("h1")(b || (b = r(["\n    font-weight: bold;\n    font-size: 32px;\n    line-height: 48px;\n\n    // Styles to align with the existing Admin Plugin style\n    font-size: 24px;\n    line-height: 1.25;\n    letter-spacing: 4px;\n    margin-bottom: 15px;\n    text-transform: uppercase;\n"], ["\n    font-weight: bold;\n    font-size: 32px;\n    line-height: 48px;\n\n    // Styles to align with the existing Admin Plugin style\n    font-size: 24px;\n    line-height: 1.25;\n    letter-spacing: 4px;\n    margin-bottom: 15px;\n    text-transform: uppercase;\n"]))), t.PageSubtitle = a.default("h2")(C || (C = r(["\n    font-size: 14px;\n"], ["\n    font-size: 14px;\n"]))), t.PageContent = a.default("div")(_ || (_ = r(["\n    padding: 0 16px;\n    flex: 1;\n"], ["\n    padding: 0 16px;\n    flex: 1;\n"])));
    t.PageHeader = function (e) {
      return i.createElement(t.HeaderWrapper, null, i.createElement(t.PageTitle, null, e.renderTitle()), i.createElement(t.PageSubtitle, null, e.renderSubtitle()));
    };
    t.PageFooter = function (e) {
      var n = e.onSave,
        r = e.saveDisabled,
        o = e.isProgressing,
        a = e.onCancel;
      return i.createElement(t.FooterWrapper, null, i.createElement(t.FooterButtons, null, i.createElement(t.Button, {
        onClick: a,
        secondary: !0,
        "data-test": "SLA_PageFooter_cancelBtn"
      }, i.createElement(s.Template, {
        source: s.templates.SLAPreferencesCancelButton
      })), i.createElement(t.ButtonWithProgress, {
        onClick: n,
        disabled: r,
        isProgressing: !!o,
        "data-test": "SLA_PageFooter_saveBtn"
      }, i.createElement(s.Template, {
        source: s.templates.SLAPreferencesSaveButton
      }))));
    }, t.Section = a.default("section")(k || (k = r(["\n    ", "\n    padding: 30px 16px;\n"], ["\n    ", "\n    padding: 30px 16px;\n"])), function (e) {
      var t = e.last,
        n = e.theme;
      return !t && "border-bottom: 1px solid " + n.colors.base5 + ";";
    }), t.SectionHeader = a.default("div")(w || (w = r(["\n    padding: 0 0 20px;\n    display: flex;\n    justify-content: space-between;\n"], ["\n    padding: 0 0 20px;\n    display: flex;\n    justify-content: space-between;\n"]))), t.DialogHeader = a.default("div")(S || (S = r(["\n    padding: 20px 24px;\n    justify-content: space-between;\n    border-bottom: 1px solid ", ";\n    display: flex;\n    align-items: center;\n"], ["\n    padding: 20px 24px;\n    justify-content: space-between;\n    border-bottom: 1px solid ", ";\n    display: flex;\n    align-items: center;\n"])), function (e) {
      return e.theme.colors.base5;
    }), t.DialogFooter = a.default("div")(P || (P = r(["\n    padding: 16px 24px;\n    border-top: 1px solid ", ";\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n"], ["\n    padding: 16px 24px;\n    border-top: 1px solid ", ";\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n"])), function (e) {
      return e.theme.colors.base5;
    }), t.DialogContent = a.default("div")(T || (T = r(["\n    padding: 24px;\n    font-size: 14px;\n"], ["\n    padding: 24px;\n    font-size: 14px;\n"]))), t.SectionTitle = a.default("h2")(O || (O = r(["\n    font-weight: bold;\n    font-size: 18px;\n    margin-bottom: 4px;\n"], ["\n    font-weight: bold;\n    font-size: 18px;\n    margin-bottom: 4px;\n"]))), t.SectionSubtile = a.default("h3")(x || (x = r(["\n    font-size: 14px;\n"], ["\n    font-size: 14px;\n"]))), t.SectionContent = a.default("div")(E || (E = r(["\n    display: flex;\n    flex-direction: column;\n\n    label {\n        > div:first-child {\n            font-size: 14px;\n            margin-bottom: 8px;\n        }\n    }\n\n    button {\n        margin-top: 26px;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n\n    label {\n        > div:first-child {\n            font-size: 14px;\n            margin-bottom: 8px;\n        }\n    }\n\n    button {\n        margin-top: 26px;\n    }\n"]))), t.Input = l.withStyles(function (e) {
      return {
        root: {
          margin: "2px 0",
          width: "105px"
        },
        input: {
          borderRadius: "4px",
          border: "1px solid " + e.colors.base3,
          fontSize: "14px",
          lineHeight: "22px",
          padding: "8px 16px"
        }
      };
    })(l.Input), t.SuffixContent = a.default("div")(A || (A = r(["\n    display: inline-flex;\n    margin-left: 4px;\n"], ["\n    display: inline-flex;\n    margin-left: 4px;\n"])));
    t.InputSuffix = function (e) {
      var n = e.children;
      return i.createElement(l.InputAdornment, {
        position: "start"
      }, i.createElement(t.SuffixContent, null, n));
    }, t.StyledInputLabelText = a.default("span")(I || (I = r(["\n    padding-bottom: 8px;\n"], ["\n    padding-bottom: 8px;\n"]))), t.StyledInputLabel = a.default("label")(j || (j = r(["\n    display: flex;\n    flex-direction: column;\n    margin-right: 6px;\n    padding-bottom: 18px;\n    position: relative;\n    font-size: 14px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    margin-right: 6px;\n    padding-bottom: 18px;\n    position: relative;\n    font-size: 14px;\n"])));
    var d, f, h, m, g, y, v, b, C, _, k, w, S, P, T, O, x, E, A, I, j, L, M;
    t.InputLabel = function (e) {
      var n = e.text,
        r = e.children,
        o = e.className;
      return i.createElement(t.StyledInputLabel, {
        className: o
      }, i.createElement(t.StyledInputLabelText, null, n), r);
    }, t.Select = a.withTheme(function (e) {
      var t = {
        container: function container(t) {
          return o(o({}, t), {
            margin: "2px 0",
            width: e.width || "auto"
          });
        },
        clearIndicator: function clearIndicator() {
          return {
            display: "none"
          };
        },
        menu: function menu(t) {
          return o(o({}, t), {
            boxShadow: "none",
            border: "1px solid " + e.theme.colors.base3,
            marginTop: "0"
          });
        },
        control: function control(t) {
          return o(o({}, t), {
            border: "1px solid " + (e.asButton ? e.theme.colors.defaultButtonColor : e.theme.colors.base3),
            background: "" + (e.asButton ? e.theme.colors.defaultButtonColor : t.background)
          });
        },
        option: function option(t, n) {
          return o(o({}, t), {
            fontWeight: n.isSelected ? "bold" : "initial",
            color: n.isDisabled ? e.theme.colors.base5 : e.theme.calculated.textColor,
            fontSize: "14px",
            lineHeight: "22px",
            padding: "8px 16px"
          });
        },
        valueContainer: function valueContainer(t) {
          return o(o({}, t), {
            fontSize: "14px",
            padding: "2px 16px",
            background: "" + (e.asButton ? e.theme.colors.defaultButtonColor : "inherit"),
            color: "" + (e.asButton ? e.theme.colors.lightTextColor : t.color)
          });
        },
        indicatorsContainer: function indicatorsContainer(t) {
          return o(o({}, t), {
            padding: "1px 8px",
            color: "" + (e.asButton ? e.theme.colors.lightTextColor + " !important" : t.color)
          });
        },
        dropdownIndicator: function dropdownIndicator(e) {
          return o(o({}, e), {
            color: "inherit"
          });
        },
        indicatorSeparator: function indicatorSeparator(e) {
          return o(o({}, e), {
            display: "none"
          });
        },
        singleValue: function singleValue(e, t) {
          return o(o({}, e), {
            fontSize: "14px",
            fontWeight: t
          });
        },
        placeholder: function placeholder(t) {
          return o(o({}, t), {
            color: "inherit",
            fontWeight: e.asButton ? "bold" : "inherit",
            fontSize: "14px"
          });
        },
        noOptionsMessage: function noOptionsMessage(e) {
          return o(o({}, e), {
            fontSize: "14px"
          });
        }
      };
      return i.createElement(c.default, o({}, e, {
        styles: t,
        theme: function theme(t) {
          return o(o({}, t), {
            colors: o(o({}, t.colors), {
              neutral0: e.theme.colors.base1,
              neutral5: e.theme.colors.base2,
              neutral10: e.theme.colors.base3,
              neutral20: e.theme.colors.base4,
              neutral30: e.theme.colors.base5,
              neutral40: e.theme.colors.base6,
              neutral50: e.theme.colors.base7,
              neutral60: e.theme.colors.base8,
              neutral70: e.theme.colors.base9,
              neutral80: e.theme.colors.base10,
              neutral90: e.theme.colors.base11,
              primary: e.theme.colors.base3,
              primary75: e.theme.colors.base3,
              primary50: e.theme.colors.base3,
              primary25: e.theme.colors.base3,
              danger: e.theme.colors.errorColor,
              dangerLight: e.theme.colors.errorColor
            })
          });
        }
      }));
    }), t.ChannelConfigurationListItemContent = a.default("div")(L || (L = r(["\n    ", "\n    padding: 0 0 25px 0;\n    margin-bottom: 25px;\n    align-self: flex-start;\n\n    h5 {\n        font-size: 14px;\n        font-weight: bold;\n        margin-bottom: 12px;\n    }\n\n    > div {\n        display: flex;\n    }\n"], ["\n    ", "\n    padding: 0 0 25px 0;\n    margin-bottom: 25px;\n    align-self: flex-start;\n\n    h5 {\n        font-size: 14px;\n        font-weight: bold;\n        margin-bottom: 12px;\n    }\n\n    > div {\n        display: flex;\n    }\n"])), function (e) {
      return "border-bottom: 1px solid " + e.theme.colors.base5 + ";";
    }), t.ValidationMessage = a.default("div")(M || (M = r(["\n    position: absolute;\n    bottom: -18px;\n    white-space: nowrap;\n    font-size: 12px;\n    color: ", ";\n"], ["\n    position: absolute;\n    bottom: -18px;\n    white-space: nowrap;\n    font-size: 12px;\n    color: ", ";\n"])), function (e) {
      return e.theme.colors.errorColor;
    });
  }, function (e, t) {
    e.exports = require("reselect");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexClientManager = void 0;
    var r = n(324);
    t.FlexClientManager = new r.FlexClientManagerImpl();
  }, function (e, t) {
    e.exports = require("emotion");
  }, function (e, t) {
    e.exports = require("query-string");
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.ACTION_DELETE_COMPONENT_STATE = t.ACTION_SET_COMPONENT_STATE = t.ACTION_DELETE_FILTER = t.ACTION_UPDATE_FILTER = t.ACTION_UPDATE_VIEW = t.ACTION_HIDE_OUTBOUND_DIALER = t.ACTION_TOGGLE_OUTBOUND_DIALER = t.ACTION_TOGGLE_SIDEBAR = t.ActiveFilters = t.FilterConditions = void 0;
    var s = n(184),
      l = n(93),
      c = n(3),
      u = n(94);
    !function (e) {
      e.IN = "IN", e.NOT_IN = "NOT_IN", e.CONTAINS = "CONTAINS";
    }(t.FilterConditions || (t.FilterConditions = {}));
    var p = function () {
      function e(e, t) {
        this.filters = [], this.filters = e, this.type = t;
      }
      return Object.defineProperty(e.prototype, "query", {
        get: function get() {
          return s.filtersToQuery(this.filters);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "count", {
        get: function get() {
          return this.filters.reduce(function (e, t) {
            var n = t.values;
            return Array.isArray(n) ? e + n.length : "string" == typeof n ? e + 1 : e;
          }, 0);
        },
        enumerable: !1,
        configurable: !0
      }), e;
    }();
    t.ActiveFilters = p;
    var d = {
      isSideNavOpen: !1,
      isOutboundDialerOpen: !1,
      isDirectoryOpen: !1,
      componentViewStates: {},
      filters: (r = {}, r[u.FiltersType.legacy] = "", r)
    };
    t.ACTION_TOGGLE_SIDEBAR = "VIEW_TOGGLE_SIDEBAR", t.ACTION_TOGGLE_OUTBOUND_DIALER = "VIEW_TOGGLE_OUTBOUND_DIALER", t.ACTION_HIDE_OUTBOUND_DIALER = "VIEW_HIDE_OUTBOUND_DIALER", t.ACTION_UPDATE_VIEW = "VIEW_UPDATE", t.ACTION_UPDATE_FILTER = "VIEW_UPDATE_FILTER", t.ACTION_DELETE_FILTER = "VIEW_DELETE_FILTER", t.ACTION_SET_COMPONENT_STATE = "VIEW_SET_COMPONENT_STATE", t.ACTION_DELETE_COMPONENT_STATE = "VIEW_DELETE_COMPONENT_STATE", t.reduce = function (e, n) {
      var r;
      switch (void 0 === e && (e = d), n.type) {
        case t.ACTION_TOGGLE_SIDEBAR:
          return o(o({}, e), {
            isSideNavOpen: !e.isSideNavOpen
          });
        case t.ACTION_TOGGLE_OUTBOUND_DIALER:
          return o(o({}, e), {
            isOutboundDialerOpen: !e.isOutboundDialerOpen
          });
        case t.ACTION_HIDE_OUTBOUND_DIALER:
          return o(o({}, e), {
            isOutboundDialerOpen: !1
          });
        case t.ACTION_UPDATE_VIEW:
          var i = n.payload;
          return o(o({}, e), i);
        case t.ACTION_SET_COMPONENT_STATE:
          var a = n.payload;
          return e.componentViewStates[a.name] = o(o({}, e.componentViewStates[a.name]), a.state), o({}, e);
        case t.ACTION_DELETE_COMPONENT_STATE:
          return delete e.componentViewStates[n.payload.name], o({}, e);
        case t.ACTION_UPDATE_FILTER:
          var s = o(o({}, e.filters), ((r = {})[n.payload.key] = new p(n.payload.filters, n.payload.key), r[u.FiltersType.legacy] = void 0 !== n.payload.legacyFilterQuery ? n.payload.legacyFilterQuery : e.filters && e.filters[u.FiltersType.legacy], r));
          return o(o({}, e), {
            filters: s
          });
        case t.ACTION_DELETE_FILTER:
          var l = o({}, e);
          return delete l.filters[n.payload.key], n.payload.key === u.FiltersType.filter && (l.filters[u.FiltersType.legacy] = ""), l;
        default:
          return e;
      }
    };
    var f = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || c.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.setComponentState = function (e, n) {
        this.dispatcher({
          type: t.ACTION_SET_COMPONENT_STATE,
          payload: {
            name: e,
            state: n
          }
        });
      }, e.deleteComponentState = function (e) {
        this.dispatcher({
          type: t.ACTION_DELETE_COMPONENT_STATE,
          payload: {
            name: e
          }
        });
      }, e.hideOutboundDialer = function () {
        this.dispatcher({
          type: t.ACTION_HIDE_OUTBOUND_DIALER
        });
      }, e.toggleOutboundDialer = function () {
        this.dispatcher({
          type: t.ACTION_TOGGLE_OUTBOUND_DIALER
        });
      }, e.toggleSidebar = function () {
        this.dispatcher({
          type: t.ACTION_TOGGLE_SIDEBAR
        });
      }, e.hideSidebar = function () {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            isSideNavOpen: !1
          }
        });
      }, e.showSidebar = function () {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            isSideNavOpen: !0
          }
        });
      }, e.setActiveView = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            activeView: e,
            isSideNavOpen: !1,
            isDirectoryOpen: !1
          }
        }), c.FlexModule.events.emitSelectedViewChanged(e, !1);
      }, e.showDirectory = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            isDirectoryOpen: !0
          }
        });
      }, e.hideDirectory = function () {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            isDirectoryOpen: !1
          }
        });
      }, e.selectTask = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            selectedTaskSid: e
          }
        });
      }, e.selectTaskInSupervisor = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            selectedTaskInSupervisorSid: e
          }
        });
      }, e.selectWorkerInSupervisor = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            selectedWorkerInSupervisorSid: e
          }
        });
      }, e.push = function (t) {
        return i(this, void 0, void 0, function () {
          var n;
          return a(this, function (r) {
            return n = c.FlexModule.state.router.location && c.FlexModule.state.router.location.pathname, t !== n && e.dispatcher(l.push.call(this, t)), [2];
          });
        });
      }, e.replace = function (t) {
        return i(this, void 0, void 0, function () {
          return a(this, function (n) {
            return e.dispatcher(l.replace.call(this, t)), [2];
          });
        });
      }, e.go = function (t) {
        return i(this, void 0, void 0, function () {
          return a(this, function (n) {
            return e.dispatcher(l.go.call(this, t)), [2];
          });
        });
      }, e.goForward = function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        return i(this, void 0, void 0, function () {
          return a(this, function (n) {
            return e.dispatcher(l.goForward.apply(this, t)), [2];
          });
        });
      }, e.goBack = function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        return i(this, void 0, void 0, function () {
          return a(this, function (n) {
            return e.dispatcher(l.goBack.apply(this, t)), [2];
          });
        });
      }, e.applyListFilters = function (e) {
        this.dispatcher({
          payload: e,
          type: t.ACTION_UPDATE_FILTER
        });
      }, e.removeListFilters = function (e) {
        this.dispatcher({
          payload: e,
          type: t.ACTION_DELETE_FILTER
        });
      }, e;
    }();
    t.Actions = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.LOAD_WORKERS_FAILED = t.LOAD_WORKERS_START = t.MONITORING_UPDATED = t.MONITORING_SUCCEEDED = t.UPDATE_STATE = t.LiveQueryError = t.CallMonitoringStatus = void 0;
    var s,
      l = n(3),
      c = n(172),
      u = n(5),
      p = n(8),
      d = n(16),
      f = n(192),
      h = n(98),
      m = n(7),
      g = n(29),
      y = n(98);
    Object.defineProperty(t, "CallMonitoringStatus", {
      enumerable: !0,
      get: function get() {
        return y.CallMonitoringStatus;
      }
    }), function (e) {
      e[e.None = 0] = "None", e[e.Other = 1] = "Other", e[e.LongQuery = 2] = "LongQuery";
    }(s = t.LiveQueryError || (t.LiveQueryError = {}));
    var v,
      b = {
        callMonitoring: {
          status: h.CallMonitoringStatus.none,
          workers: null,
          task: null
        },
        workers: [],
        stickyWorker: null,
        isLoadingWorkers: !1,
        errorLoadingWorkers: s.None
      };
    !function (e) {
      e[e.TooManyOperators = 54509] = "TooManyOperators", e[e.TooManyItems = 54510] = "TooManyItems";
    }(v || (v = {})), t.UPDATE_STATE = "SUPERVISOR_UPDATE", t.MONITORING_SUCCEEDED = "SUPERVISOR_INCOMING_CALL", t.MONITORING_UPDATED = "SUPERVISOR_INCOMING_CALL_UPDATE", t.LOAD_WORKERS_START = "SUPERVISOR_LOAD_WORKERS_START", t.LOAD_WORKERS_FAILED = "SUPERVISOR_LOAD_WORKERS_FAILED", t.reduce = function (e, n) {
      switch (void 0 === e && (e = b), n.type) {
        case t.UPDATE_STATE:
          var o = n.payload;
          return r(r({}, e), o);
        case t.MONITORING_SUCCEEDED:
        case t.MONITORING_UPDATED:
          var i = n.payload;
          o = {
            callMonitoring: r(r({}, e.callMonitoring), {
              status: h.CallMonitoringStatus.monitoring,
              workers: i.conference.liveWorkers.map(function (e) {
                return e.worker;
              })
            })
          };
          return r(r({}, e), o);
        case t.LOAD_WORKERS_START:
          return r(r({}, e), {
            isLoadingWorkers: !0,
            errorLoadingWorkers: s.None
          });
        case t.LOAD_WORKERS_FAILED:
          var a = "code" in n.payload && (n.payload.code === v.TooManyItems || n.payload.code === v.TooManyOperators) ? s.LongQuery : s.Other;
          return r(r({}, e), {
            isLoadingWorkers: !1,
            errorLoadingWorkers: a
          });
        default:
          return e;
      }
    };
    var C = function () {
      function e() {}
      return e.dispatchStateUpdate = function (e, n) {
        var o = this;
        void 0 === n && (n = !0);
        var i = function i(e) {
          o.dispatcher({
            type: t.UPDATE_STATE,
            payload: e
          });
        };
        n ? (this.stateUpdateThrottler && (clearTimeout(this.stateUpdateThrottler), this.stateUpdateThrottler = null, i(this.pendingStateUpdate), this.pendingStateUpdate = null), i(e)) : this.stateUpdateThrottler ? this.pendingStateUpdate = r(r({}, this.pendingStateUpdate), e) : (i(e), this.pendingStateUpdate = {}, this.stateUpdateThrottler = window.setTimeout(function () {
          clearTimeout(o.stateUpdateThrottler), i(o.pendingStateUpdate), o.stateUpdateThrottler = null, o.pendingStateUpdate = null;
        }, 500));
      }, Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || l.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.assignInsights = function (t) {
        this.dispatchStateUpdate({
          listener: f.SupervisorWorkersListener.create(t, e)
        });
      }, e.monitorCall = function (e) {
        var n = this;
        return new Promise(function (r, a) {
          if (n.callMonitoringStart) a(m.ErrorManager.createAndProcessError("Monitoring starting already", {
            type: m.FlexErrorType.app,
            context: "SupervisorState"
          }));else {
            var s = setTimeout(function () {
                var t = l.FlexModule.state.supervisor.callMonitoring;
                t.status === h.CallMonitoringStatus.waiting && t.task.taskSid === e.taskSid && (n.callMonitoringStart.conferenceListener && n.callMonitoringStart.conferenceListener.stop(), n.callMonitoringStart = void 0, n.dispatchStateUpdate({
                  callMonitoring: {
                    task: null,
                    workers: null,
                    status: h.CallMonitoringStatus.none
                  }
                }), d.Notifications.showNotification(d.NotificationIds.MonitoringFailed)), a(new Error("Failed to start monitoring"));
              }, 1e4),
              u = function u(e) {
                if ("conf_state" === e.key) return !1;
                var t = new c.ConferenceParticipant(e.value);
                return "supervisor" === t.participantType && t.isMyself;
              },
              p = new c.ConferenceListener(e.taskSid, function (s) {
                return o(n, void 0, void 0, function () {
                  var n, o;
                  return i(this, function (i) {
                    switch (i.label) {
                      case 0:
                        return !l.FlexModule.state.phone.connection || this.isMonitoredWorkerStillInTheCall(s, e) ? [3, 2] : [4, l.FlexModule.state.phone.connection.source.disconnect()];
                      case 1:
                        return i.sent(), [2];
                      case 2:
                        return n = s.children.filter(u), !(o = n.some(function (e) {
                          return "joined" === new c.ConferenceParticipant(e.value).status;
                        })) && n.length > this.callMonitoringStart.startingCountOfMyselvesAsSupervisor && (s.stop(), this.callMonitoringStart = void 0, this.dispatchStateUpdate({
                          callMonitoring: {
                            task: e,
                            workers: null,
                            status: h.CallMonitoringStatus.none
                          }
                        }), a(new Error("Monitoring stopped"))), o && (this.callMonitoringStart.timer ? (clearTimeout(this.callMonitoringStart.timer), this.callMonitoringStart.timer = null, this.dispatchStateUpdate({}, !0), this.dispatcher({
                          type: t.MONITORING_SUCCEEDED,
                          payload: {
                            conference: e.conference
                          }
                        }), r()) : this.dispatcher({
                          type: t.MONITORING_UPDATED,
                          payload: {
                            conference: e.conference
                          }
                        })), [2];
                    }
                  });
                });
              }),
              f = e.conference.source.children.filter(u);
            n.callMonitoringStart = {
              conferenceListener: p,
              timer: s,
              startingCountOfMyselvesAsSupervisor: f.length
            }, n.dispatchStateUpdate({
              callMonitoring: {
                task: e,
                status: h.CallMonitoringStatus.waiting
              }
            });
          }
        });
      }, e.isMonitoredWorkerStillInTheCall = function (e, t) {
        return e.children.find(function (e) {
          var n = new c.ConferenceParticipant(e.value);
          return n.workerSid === t.workerSid && "joined" === n.status;
        });
      }, e.manageConferenceListening = function (e, t) {
        var n = this;
        this.listenedConferences || (this.listenedConferences = new Set());
        var r = a(e);
        t && e && r.push(t);
        var o = [];
        r.forEach(function (e) {
          e.tasks.forEach(function (e) {
            p.TaskHelper.isLiveCall(e) && o.push(e);
          });
        }), this.listenedConferences.forEach(function (e) {
          o.find(function (t) {
            return t.taskSid === e;
          }) || (c.ConferenceListenerManager.stopListening(e, "supervisor"), n.listenedConferences.delete(e));
        }), o.forEach(function (e) {
          n.listenedConferences.has(e.taskSid) || (c.ConferenceListenerManager.startListening(e, "supervisor"), n.listenedConferences.add(e.taskSid));
        });
      }, e.updateStateWorkers = function (e) {
        this.manageConferenceListening(e, l.FlexModule.state.supervisor.stickyWorker), this.dispatchStateUpdate({
          workers: e,
          isLoadingWorkers: !1,
          errorLoadingWorkers: s.None
        }, !1);
      }, e.startLoadingWorkers = function () {
        this.dispatcher({
          type: t.LOAD_WORKERS_START
        });
      }, e.updateStateStickyWorker = function (e) {
        this.manageConferenceListening(l.FlexModule.state.supervisor.workers, e), this.dispatchStateUpdate({
          stickyWorker: e
        }, !1);
      }, e.setActiveFilterQuery = function (e, n) {
        var r = this;
        l.FlexModule.state.supervisor.listener.setActiveFilterQuery(e, n).catch(function (o) {
          m.ErrorManager.createAndProcessError(g.ErrorMessages.TEAMS_VIEW_SET_FILTER_FAILED, {
            type: m.FlexErrorType.app,
            context: "SupervisorState",
            wrappedError: o,
            description: JSON.stringify({
              query: e,
              taskFilter: n
            })
          }), r.dispatcher({
            type: t.LOAD_WORKERS_FAILED,
            payload: o
          });
        });
      }, e.setStickyWorkerSid = function (e, t) {
        var n;
        null === (n = l.FlexModule.state.supervisor.listener) || void 0 === n || n.setStickyWorkerSid(e, t);
      }, e.shutdown = function () {
        u.log.debug("Supervisor state logout"), this.callMonitoringStart && (clearTimeout(this.callMonitoringStart.timer), this.callMonitoringStart.conferenceListener.stop(), this.callMonitoringStart = void 0), this.listenedConferences && (this.listenedConferences.forEach(function (e) {
          c.ConferenceListenerManager.stopListening(e, "supervisor");
        }), this.listenedConferences = void 0);
        var e = l.FlexModule.state.supervisor.listener;
        e && e.unsubscribe();
      }, e;
    }();
    t.Actions = C;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InsightsEntityCache = void 0;
    var i = n(32),
      a = n(3),
      s = n(5),
      l = n(73),
      c = n(87),
      u = function () {
        function e() {}
        return e.destroy = function () {
          this.searches.forEach(function (e) {
            return e.query.removeAllListeners();
          });
        }, e.getWorker = function (e) {
          if ("WK" === (null == e ? void 0 : e.substr(0, 2))) return this.entities.get(e);
        }, e.getQueue = function (e) {
          if ("WQ" === e.substr(0, 2)) return this.entities.get(e);
        }, e.refreshInfoForEntities = function (e) {
          var t = this;
          return !a.FlexModule.insightsClient || i.FlexClientManager.isDegraded(a.FlexModule.insightsClient) ? Promise.resolve() : Promise.all(e.map(function (e) {
            return r(t, void 0, void 0, function () {
              var t,
                n,
                r,
                i = this;
              return o(this, function (o) {
                switch (o.label) {
                  case 0:
                    return e ? (t = this.searches.get(e)) && new Date().getTime() - t.time < 1e4 ? [2] : (s.log.debug("InsightsState refreshIdentity " + e), n = "WK" === e.substr(0, 2), [4, a.FlexModule.insightsClient.instantQuery(n ? "tr-worker" : "tr-queue")]) : [2];
                  case 1:
                    return r = o.sent(), this.searches.set(e, {
                      query: r,
                      time: new Date().getTime()
                    }), r.on("searchResult", function (t) {
                      Object.keys(t).forEach(function (e) {
                        s.log.debug("InsightsState found data for " + e);
                        var r = t[e],
                          o = n ? new l.InsightsWorker(r) : new l.InsightsQueue(r);
                        i.entities.set(e, o), c.Actions.updateConferencesWithParticipant(e);
                      }), r.removeAllListeners(), i.searches.delete(e);
                    }), n ? r.search('data.worker_sid == "' + e + '"') : r.search('data.queue_sid == "' + e + '"'), [2];
                }
              });
            });
          }));
        }, e.updateCache = function (e) {
          s.log.debug("InsightsState updateCache " + e.sid), this.entities.set(e.sid, e);
        }, e.entities = new Map(), e.searches = new Map(), e;
      }();
    t.InsightsEntityCache = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.navigateToCreateNewDashboard = t.redirectToDashboard = t.navigateToDashboard = void 0;
    var i = n(44),
      a = n(177);
    o(n(177), t), t.navigateToDashboard = function (e) {
      i.default().push("/dashboards/" + e), a.saveLastVisitedDashboard(e);
    }, t.redirectToDashboard = function (e) {
      e ? (i.default().replace("/dashboards/" + e), a.saveLastVisitedDashboard(e)) : (a.clearLastVisitedDashboard(), i.default().replace("/dashboards"));
    }, t.navigateToCreateNewDashboard = function () {
      i.default().push("/dashboards/new");
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.ACTION_LOGGED_OUT = t.INSIGHTS_INIT_TIMEOUT = t.LoginState = void 0;
    var a,
      s = n(0),
      l = n(11),
      c = n(32),
      u = n(21),
      p = n(40),
      d = n(13),
      f = n(71),
      h = n(7),
      m = n(3),
      g = n(5),
      y = n(10),
      v = n(14),
      b = n(6),
      C = n(90),
      _ = n(91);
    !function (e) {
      e.Unknown = "UNKNOWN", e.LoggingIn = "LOGGING_IN", e.LoggedIn = "LOGGED_IN", e.LoggedOut = "LOGGED_OUT", e.Error = "ERROR";
    }(a = t.LoginState || (t.LoginState = {})), t.INSIGHTS_INIT_TIMEOUT = 1e4;
    var k = {
      identity: void 0,
      insightsServiceStatus: p.InsightsServiceStatus.Initializing,
      goodDataServiceStatus: p.InsightsServiceStatus.Inactive,
      loginHandler: void 0,
      loginState: a.Unknown,
      loginError: void 0,
      ssoTokenPayload: void 0,
      singleSessionGuard: {
        otherSessionDetected: void 0,
        sessionInvalidated: void 0,
        otherSessionHasOngoingCall: !1
      },
      degraded: void 0
    };
    t.ACTION_LOGGED_OUT = "FLEX_ACTION_LOGGED_OUT";
    t.reduce = function (e, n) {
      switch (void 0 === e && (e = k), n.type) {
        case "FLEX_ACTION_LOGIN_PENDING":
          return r(r({}, e), {
            loginState: a.LoggingIn,
            loginError: void 0
          });
        case "FLEX_ACTION_LOGIN_REJECTED":
          return r(r({}, e), {
            loginState: a.Error,
            loginError: n.payload
          });
        case "FLEX_ACTION_LOGIN_FULFILLED":
          return r(r(r({}, e), n.payload), {
            loginState: a.LoggedIn,
            loginError: void 0,
            ssoTokenPayload: n.payload.tokenPayload,
            identity: n.payload.tokenPayload.identity
          });
        case "FLEX_ACTION_TOKEN_UPDATED":
          return r(r({}, e), {
            ssoTokenPayload: n.payload.tokenPayload,
            identity: n.payload.tokenPayload.identity
          });
        case t.ACTION_LOGGED_OUT:
          return r(r({}, k), {
            loginState: a.LoggedOut
          });
        case "FLEX_UPDATE_INSIGHTS_SERVICE_STATUS":
          return r(r({}, e), {
            insightsServiceStatus: n.payload
          });
        case "FLEX_UPDATE_GOOD_DATA_SERVICE_STATUS":
          return r(r({}, e), {
            goodDataServiceStatus: n.payload
          });
        case "FLEX_VALIDATE_SESSION":
          return r(r({}, e), {
            singleSessionGuard: r(r({}, e.singleSessionGuard), {
              sessionInvalidated: !1
            })
          });
        case "FLEX_INVALIDATE_SESSION":
          return r(r({}, e), {
            singleSessionGuard: {
              otherSessionDetected: void 0,
              otherSessionHasOngoingCall: !1,
              sessionInvalidated: !0
            }
          });
        case "FLEX_INVALIDATE_OTHER_SESSIONS":
          return r(r({}, e), {
            singleSessionGuard: {
              otherSessionDetected: void 0,
              otherSessionHasOngoingCall: !1,
              sessionInvalidated: !1
            }
          });
        case "FLEX_ALERT_MULTI_SESSION":
          return r(r({}, e), {
            singleSessionGuard: {
              otherSessionDetected: n.payload.otherSessionSid,
              otherSessionHasOngoingCall: n.payload.hasOngoingCall,
              sessionInvalidated: !1
            }
          });
        case "FLEX_ACTION_TOGGLE_DEGRADED_MODE":
          return r(r({}, e), {
            degraded: n.payload.degraded
          });
        default:
          return e;
      }
    };
    var w = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || m.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.init = function () {
        this.dispatcher({
          type: "FLEX_SESSION_INIT"
        });
      }, e.ssoLogin = function (e) {
        return o(this, void 0, Promise, function () {
          var t, n;
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return g.log.info("SessionState: ssoLogin"), f.TokenManager.initialize(), [4, f.TokenManager.getActiveTokenPayload()];
              case 1:
                return (t = r.sent()) ? (m.pastTokens.push(t.token), s.FlexSDKManager.addListener("tokenUpdated", this.handleTokenUpdated), s.FlexSDKManager.addListener("tokenExpired", this.handleTokenExpired), n = this.initClients(t).then(function () {
                  return {
                    tokenPayload: t,
                    loginHandler: e
                  };
                }), this.dispatcher({
                  type: "FLEX_ACTION_LOGIN",
                  payload: n
                }), [4, n]) : [3, 3];
              case 2:
                r.sent(), g.log.debug("SessionState: SDK clients initialized"), m.FlexModule.events.emitUserLoggedIn(), r.label = 3;
              case 3:
                return [2];
            }
          });
        });
      }, e.validateSession = function () {
        return o(this, void 0, void 0, function () {
          var e;
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return t.trys.push([0, 2,, 3]), [4, C.singleSessionGuard.initAndValidate({
                  syncClient: m.FlexModule.insightsClient,
                  workerSid: m.FlexModule.workerClient.sid,
                  handleOtherSessionDetected: this.alertForMultiSession,
                  handleCurrentSessionInvalidated: this.invalidateCurrentSession,
                  handleCurrentSessionValidated: this.validateCurrentSession,
                  handleOtherSessionsInvalidated: this.invalidateOtherSessions
                })];
              case 1:
                return t.sent(), g.log.debug("SessionState: session validated"), [3, 3];
              case 2:
                if (e = t.sent(), h.isFlexError(e)) throw e;
                throw h.ErrorManager.createAndProcessError("Could not validate session", {
                  type: h.FlexErrorType.app,
                  context: "SessionState",
                  description: "Could not validate session: " + e.message,
                  wrappedError: e
                });
              case 3:
                return [2];
            }
          });
        });
      }, e.updateInsightsServiceStatus = function (t) {
        e.dispatcher({
          type: "FLEX_UPDATE_INSIGHTS_SERVICE_STATUS",
          payload: t
        });
      }, e.updateGoodDataServiceStatus = function (t) {
        e.dispatcher({
          type: "FLEX_UPDATE_GOOD_DATA_SERVICE_STATUS",
          payload: t
        });
      }, e.handleTokenExpired = function () {
        var e = m.FlexModule.state.session.loginHandler;
        e && e.emit("tokenExpired", void 0), m.FlexModule.events.emitTokenExpired(), g.log.debug("SessionState: Token expired, showing notification"), s.Notifications.showNotification(v.FlexSessionExpired);
      }, e.initClients = function (e) {
        return o(this, void 0, void 0, function () {
          var t;
          return i(this, function (n) {
            return g.log.info("SessionState: initializing SDK clients"), t = e && e.token, h.ErrorManager.initDebugger(), [2, c.FlexClientManager.init(t)];
          });
        });
      }, e.logout = function (e) {
        return o(this, void 0, Promise, function () {
          var n, r, o, a, l;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                n = d.Manager.getInstance().serviceConfiguration.taskrouter_offline_activity_sid, r = c.FlexClientManager.isDegraded(m.FlexModule.workerClient), g.log.info("SessionState: logout");
                try {
                  null != e.activitySid ? o = _.Actions.setCurrentActivity(e.activitySid) : e.activityName ? (g.log.warn('Logout payload member "activityName" is deprecated. Please, consider using activitySid instead'), o = _.Actions.setCurrentActivityByName(e.activityName)) : o = null != n ? _.Actions.setCurrentActivity(n) : Promise.resolve();
                } catch (e) {
                  if (!r) throw e;
                }
                i.label = 1;
              case 1:
                return i.trys.push([1, 3,, 4]), [4, o];
              case 2:
                return i.sent(), [3, 4];
              case 3:
                if (a = i.sent(), l = "SessionState: Unable to set worker activity to offline", r) h.ErrorManager.createAndProcessError(l, {
                  context: "SessionState - Logout",
                  wrappedError: a
                });else {
                  if (!e.forceLogout) throw h.ErrorManager.createAndProcessError(l, {
                    context: "SessionState - Logout",
                    wrappedError: a
                  });
                  g.log.warn(l);
                }
                return [3, 4];
              case 4:
                return s.FlexSDKManager.removeListener("tokenUpdated", this.handleTokenUpdated), s.FlexSDKManager.removeListener("tokenExpired", this.handleTokenExpired), f.TokenManager.destroy(), f.TokenManager.clearTokenPayload(), [4, this.shutdown()];
              case 5:
                return i.sent(), this.dispatcher({
                  type: t.ACTION_LOGGED_OUT
                }), [2];
            }
          });
        });
      }, e.invalidateCurrentSession = function (t) {
        C.singleSessionGuard.isCurrentSession(t) ? (g.log.debug("SessionState: session invalidated by uninitialising SDKs"), e.shutdown(), e.dispatcher({
          type: "FLEX_INVALIDATE_SESSION",
          payload: {}
        })) : (g.log.debug("SessionState: session invalidated by logging out"), b.tryInvokeAction("Logout", {
          activitySid: m.FlexModule.workerClient.activity.sid,
          forceLogout: !0
        })), m.FlexModule.events.emitSessionInvalidated();
      }, e.invalidateOtherSessions = function () {
        g.log.debug("SessionState: other Flex instance invalidated"), e.dispatcher({
          type: "FLEX_INVALIDATE_OTHER_SESSIONS",
          payload: {}
        });
      }, e.validateCurrentSession = function () {
        e.dispatcher({
          type: "FLEX_VALIDATE_SESSION",
          payload: {}
        }), m.FlexModule.events.emitSessionValidated();
      }, e.updateDegradedMode = function () {
        var t = c.FlexClientManager.degradedMode;
        g.log.debug("SessionState: setting degraded to " + t), t ? s.Notifications.showNotificationSingle(v.DegradedModeActive) : s.Notifications.dismissNotificationById(v.DegradedModeActive), e.dispatcher({
          type: "FLEX_ACTION_TOGGLE_DEGRADED_MODE",
          payload: {
            degraded: t
          }
        });
      }, e.alertForMultiSession = function (t, n) {
        g.log.debug("SessionState: other Flex instance detected"), e.dispatcher({
          type: "FLEX_ALERT_MULTI_SESSION",
          payload: {
            hasOngoingCall: n,
            otherSessionSid: t
          }
        });
      }, e.handleTokenUpdated = function (t) {
        return o(void 0, void 0, void 0, function () {
          var n, r, o, a, s, l, c, u, p, d, f;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                if ((n = m.FlexModule.state.session.loginHandler) && n.emit("tokenUpdated", t), e.dispatcher({
                  type: "FLEX_ACTION_TOKEN_UPDATED",
                  payload: {
                    tokenPayload: t
                  }
                }), r = m.FlexModule.workerClient, o = m.FlexModule.chatClient, a = m.FlexModule.voiceClient, s = m.FlexModule.insightsClient, l = m.FlexModule.cbmClient, c = t.token, m.pastTokens.push(c), g.log.info("SessionState: token updated", t), u = "SessionState", !r) return [3, 4];
                g.log.debug("SessionState: Updating worker client token"), i.label = 1;
              case 1:
                return i.trys.push([1, 3,, 4]), [4, r.updateToken(c)];
              case 2:
                return i.sent(), [3, 4];
              case 3:
                return p = i.sent(), h.ErrorManager.createAndProcessError("Failed to update Task Router SDK token", {
                  type: h.FlexErrorType.taskrouterSDK,
                  description: "Failed to update Task Router SDK token",
                  context: u,
                  wrappedError: p
                }), [3, 4];
              case 4:
                if (!o) return [3, 8];
                g.log.debug("SessionState: Updating chat client token"), i.label = 5;
              case 5:
                return i.trys.push([5, 7,, 8]), [4, o.updateToken(c)];
              case 6:
                return i.sent(), [3, 8];
              case 7:
                return d = i.sent(), h.ErrorManager.createAndProcessError("Failed to update Chat SDK token", {
                  type: h.FlexErrorType.chatSDK,
                  description: "Failed to update Chat SDK token",
                  context: u,
                  wrappedError: d
                }), [3, 8];
              case 8:
                if (!m.FlexModule.state.config.disableBrowserVoice && a) {
                  g.log.debug("SessionState: Updating voice client token");
                  try {
                    a.setup(c, m.FlexModule.state.config.sdkOptions.voice);
                  } catch (e) {
                    h.ErrorManager.createAndProcessError("Failed to update Voice SDK token", {
                      type: h.FlexErrorType.voiceSDK,
                      description: "Failed to update Voice SDK token",
                      context: u,
                      wrappedError: e
                    });
                  }
                }
                if (!s) return [3, 12];
                g.log.debug("SessionState: Updating insights client token"), i.label = 9;
              case 9:
                return i.trys.push([9, 11,, 12]), [4, s.updateToken(c)];
              case 10:
                return i.sent(), [3, 12];
              case 11:
                return f = i.sent(), h.ErrorManager.createAndProcessError("Failed to update Sync SDK token", {
                  type: h.FlexErrorType.syncSDK,
                  description: "Failed to update Sync SDK token",
                  context: u,
                  wrappedError: f
                }), [3, 12];
              case 12:
                if (l) {
                  g.log.debug("SessionState: Updating cbm client token");
                  try {
                    l.updateToken(c);
                  } catch (e) {
                    h.ErrorManager.createAndProcessError("Failed to update CBM SDK token", {
                      type: h.FlexErrorType.taskrouterSDK,
                      description: "Failed to update CBM SDK token",
                      context: u,
                      wrappedError: e
                    });
                  }
                }
                return m.FlexModule.events.emitTokenUpdated(t), [2];
            }
          });
        });
      }, e.shutdown = function () {
        return o(void 0, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return c.FlexClientManager.shutdownClients(), l.FeatureFlags.isEnabled(y.FeatureFlag.SingleSession) && C.singleSessionGuard.shutdown(), [4, u.InsightsService.destroy()];
              case 1:
                return e.sent(), [4, s.FlexSDKManager.destroy()];
              case 2:
                return e.sent(), [2];
            }
          });
        });
      }, e;
    }();
    t.Actions = w;
  }, function (e, t, n) {
    "use strict";

    var r, o, i;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InsightsPermission = t.InsightsServiceStatus = void 0, function (e) {
      e.Inactive = "INACTIVE", e.Error = "ERROR", e.CORSError = "CORS_ERROR", e.Ready = "READY", e.Initializing = "INITIALIZING";
    }(t.InsightsServiceStatus || (t.InsightsServiceStatus = {})), function (e) {
      e.Add = "assessment.insert.comment", e.View = "assessment.view.comment";
    }(r || (r = {})), function (e) {
      e.Add = "assessment.insert.assessment";
    }(o || (o = {})), function (e) {
      e.ViewFindings = "player.view.findings", e.CopyDownloadLink = "player.export.recording", e.ViewPlayer = "player.view.player";
    }(i || (i = {})), t.InsightsPermission = {
      Assessment: o,
      Comment: r,
      Player: i
    };
  }, function (e, t) {
    e.exports = require("emotion-theming");
  }, function (e, t, n) {
    "use strict";

    var _r5,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r5 = function r(e, t) {
        return (_r5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r5(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__assign || function () {
        return (a = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationViewPanel = t.ConversationViewPanelWithContext = t.PanelContent = t.PanelTitleIcon = t.PanelTitle = t.PanelContainer = void 0;
    var s = n(1),
      l = n(0),
      c = n(2),
      u = n(225),
      p = n(480),
      d = n(82),
      f = n(24);
    t.PanelContainer = c.default("div")(h || (h = o(["\n    ", "\n    border: 1px solid ", ";\n    padding: 16px;\n    margin: 8px;\n    border-radius: 0.3em;\n    flex: 1;\n    position: relative;\n    overflow: hidden;\n"], ["\n    ", "\n    border: 1px solid ", ";\n    padding: 16px;\n    margin: 8px;\n    border-radius: 0.3em;\n    flex: 1;\n    position: relative;\n    overflow: hidden;\n"])), function (e) {
      return !e.hidden && "\n    display: flex;\n    flex-direction: column;\n    ";
    }, function (e) {
      return e.theme.colors.base2;
    }), t.PanelTitle = c.default("div")(m || (m = o(["\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 16px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n"], ["\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 16px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n"]))), t.PanelTitleIcon = c.default(l.Icon)(g || (g = o(["\n    margin-right: 6px;\n    margin-left: -4px;\n"], ["\n    margin-right: 6px;\n    margin-left: -4px;\n"]))), t.PanelContent = c.default("div")(y || (y = o(["\n    display: flex;\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    position: relative;\n    justify-content: center;\n    padding-right: 8px;\n"], ["\n    display: flex;\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    position: relative;\n    justify-content: center;\n    padding-right: 8px;\n"])));
    var h,
      m,
      g,
      y,
      v = function (e) {
        function n(t) {
          var n = e.call(this, t) || this;
          return t.registerPanel(t.id, t.name), n;
        }
        return i(n, e), n.prototype.render = function () {
          var e,
            n = this;
          return this.props.keepMounted || this.props.selectedPanel === this.props.id ? s.createElement(t.PanelContainer, {
            hidden: this.props.keepMounted && this.props.selectedPanel !== this.props.id
          }, this.props.selectedPanel === this.props.id && s.createElement(s.Fragment, null, s.createElement(t.PanelTitle, {
            "data-test": "ConversationViewPanel-Title"
          }, this.props.icon && s.createElement(t.PanelTitleIcon, {
            icon: this.props.icon,
            sizeMultiplier: 1.2
          }), this.props.title), s.createElement(p.ConversationViewPanelNavigation, {
            onPanelSelected: function onPanelSelected(e) {
              return n.props.onPanelSelected(e);
            },
            panels: this.props.siblings,
            selected: this.props.selectedPanel
          })), s.createElement(t.PanelContent, null, "function" == typeof this.props.children ? this.props.children({
            id: this.props.segment.id,
            mediaLinks: null === (e = this.props.segment.data) || void 0 === e ? void 0 : e.links.content
          }) : this.props.children)) : null;
        }, n;
      }(s.Component),
      b = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this;
          return s.createElement(u.ConversationViewPanelContext.Consumer, null, function (t) {
            return s.createElement(v, a({}, t, e.props));
          });
        }, t.defaultProps = {
          keepMounted: !1
        }, t;
      }(s.Component);
    t.ConversationViewPanelWithContext = b, t.ConversationViewPanel = d.connect(function (e) {
      return {
        segment: f.currentSegmentSelector(e.flex)
      };
    })(b);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SpeechSearchesView = t.QuestionnairesView = t.InspectionsView = t.DashboardsView = t.AnalyzeView = t.AgentsView = void 0;
    var r = n(691);
    Object.defineProperty(t, "AgentsView", {
      enumerable: !0,
      get: function get() {
        return r.AgentsView;
      }
    });
    var o = n(693);
    Object.defineProperty(t, "AnalyzeView", {
      enumerable: !0,
      get: function get() {
        return o.AnalyzeView;
      }
    });
    var i = n(694);
    Object.defineProperty(t, "DashboardsView", {
      enumerable: !0,
      get: function get() {
        return i.DashboardsView;
      }
    });
    var a = n(695);
    Object.defineProperty(t, "InspectionsView", {
      enumerable: !0,
      get: function get() {
        return a.InspectionsView;
      }
    });
    var s = n(696);
    Object.defineProperty(t, "QuestionnairesView", {
      enumerable: !0,
      get: function get() {
        return s.QuestionnairesView;
      }
    });
    var l = n(697);
    Object.defineProperty(t, "SpeechSearchesView", {
      enumerable: !0,
      get: function get() {
        return l.SpeechSearchesView;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.setHistory = t.isHistoryParams = t.isHistoryType = t.isHistory = void 0;
    var r,
      o = n(365),
      i = n(5);
    function a(e) {
      return "browser" === e || "memory" === e;
    }
    t.isHistory = function (e) {
      var t = e;
      return !!(t && t.length && t.location && t.listen && t.action && t.push && t.replace && t.go && t.goBack && t.goForward);
    }, t.isHistoryType = a, t.isHistoryParams = function (e) {
      var t = e;
      return t && ("string" == typeof t.type || "boolean" == typeof t.isolate || "object" == typeof t.history);
    }, t.default = function (e) {
      if (void 0 === e && (e = {
        type: "browser"
      }), !r) {
        var t = e.isolate ? "memory" : e.type;
        r = function (e) {
          return "memory" === e ? o.createMemoryHistory : (a(e) || i.log.error("History type '" + e + "' is not supported. Use 'browser' or 'memory' type for router configuration."), o.createBrowserHistory);
        }(t)(e.history);
      }
      return r;
    }, t.setHistory = function (e) {
      r = e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      i = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InsightsService = void 0;
    var a = n(369),
      s = n(0),
      l = n(27),
      c = n(70),
      u = n(56),
      p = n(7),
      d = n(28),
      f = n(3),
      h = n(5),
      m = n(10),
      g = n(14),
      y = n(24),
      v = n(39),
      b = n(11),
      C = n(9),
      _ = n(370),
      k = n(372),
      w = n(40),
      S = function () {
        function e(e) {
          var t = this;
          this.isLoggedIn = !1, this.sendTokensToYtica = function () {
            var e;
            t.yticaLoginIframe && (null === (e = t.yticaLoginIframe.contentWindow) || void 0 === e || e.postMessage({
              name: "com.twilio.flex.insights.login",
              yticaToken: t.identityClient.tokenPair,
              flexToken: {
                token: t.manager.user.token,
                expiration: t.manager.user.tokenExpirationDate
              }
            }, "*"));
          }, this.historicalReportingViewAction = function (e) {
            return r(t, void 0, void 0, function () {
              var t, n, r;
              return o(this, function (o) {
                switch (o.label) {
                  case 0:
                    return t = new URL(e), n = this.extractSegmentIdFromUrl(t), r = b.FeatureFlags.isEnabled(m.FeatureFlag.InsightsPlayer), n && r ? [3, 1] : (window.open(e, "_blank"), [3, 4]);
                  case 1:
                    return [4, s.Actions.invokeAction(c.INSIGHTS_PLAYER_HIDE)];
                  case 2:
                    return o.sent(), [4, s.Actions.invokeAction(c.INSIGHTS_PLAYER_PLAY, {
                      segmentId: n
                    })];
                  case 3:
                    o.sent(), o.label = 4;
                  case 4:
                    return [2];
                }
              });
            });
          }, this.manager = e, this.analyticsUrl = C.getAnalyticsUrl(this.manager.configuration), b.FeatureFlags.isEnabled(m.FeatureFlag.InsightsIdentityNext) ? this.identityClient = new _.default(this.manager) : this.identityClient = new k.YticaIdentityClient(this.manager);
        }
        return e.init = function (t) {
          return e.instance ? Promise.resolve() : (e.instance = new e(t), e.instance.login());
        }, e.destroy = function (t) {
          return void 0 === t && (t = !1), r(this, void 0, void 0, function () {
            return o(this, function (n) {
              switch (n.label) {
                case 0:
                  return e.instance && e.instance.isLoggedIn ? [4, e.instance.logout(t)] : [3, 2];
                case 1:
                  n.sent(), e.instance = void 0, n.label = 2;
                case 2:
                  return [2];
              }
            });
          });
        }, e.getInstance = function () {
          return e.instance;
        }, e.hasPermission = function (t) {
          return e.instance && e.instance.isLoggedIn && e.instance.identityClient.hasPermission(t);
        }, e.prototype.loginWithTimeout = function () {
          for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
          return r(this, void 0, void 0, function () {
            var t,
              n,
              r = this;
            return o(this, function (o) {
              return t = new Promise(function (e, t) {
                setTimeout(function () {
                  t(new Error("Unable to initialize Insights in time."));
                }, C.getFlexInsightsInitTimeout(r.manager.configuration));
              }), [2, Promise.race([t, (n = this.identityClient).ssoLogin.apply(n, e)])];
            });
          });
        }, e.prototype.login = function () {
          return r(this, void 0, void 0, function () {
            var e, t, n, r, i, a;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  if (o.trys.push([0, 2,, 3]), e = this.manager.store.getState().flex, t = e.session.ssoTokenPayload, n = t.identity, r = t.token, i = this.manager.serviceConfiguration.account_sid, !n || !r || !i) throw new Error("Missing one of SSO params: identity, token, accountSid");
                  return [4, this.loginWithTimeout({
                    identity: n,
                    token: r,
                    account_sid: i
                  })];
                case 1:
                  if (o.sent(), b.FeatureFlags.isEnabled(m.FeatureFlag.InsightsIdentityNext) && this.openYticaLoginIframe(), this.registerFlexActions(), !this.identityClient.isLoggedIn) throw new Error("Login failed");
                  return v.Actions.updateInsightsServiceStatus(w.InsightsServiceStatus.Ready), (b.FeatureFlags.isEnabled(m.FeatureFlag.InsightsNativeDashboards) || b.FeatureFlags.isEnabled(m.FeatureFlag.InsightsNativeDashboardsBeta)) && this.identityClient.hasPermission("dashboards") && this.loginGoodData(), this.isLoggedIn = !0, [3, 3];
                case 2:
                  return "Request failed with status code 400" === (a = o.sent()).message ? (h.log.debug("Flex Insights Service authentication failed: " + (a.message || a) + "."), v.Actions.updateInsightsServiceStatus(w.InsightsServiceStatus.Inactive)) : (p.ErrorManager.createAndProcessError("Flex Insights Service authentication failed", {
                    type: p.FlexErrorType.app,
                    context: "InsightsService",
                    wrappedError: a
                  }), s.Notifications.showNotification(g.FlexInsightsLoginFailed), v.Actions.updateInsightsServiceStatus(w.InsightsServiceStatus.Error)), [3, 3];
                case 3:
                  return [2];
              }
            });
          });
        }, e.prototype.logout = function (e) {
          return void 0 === e && (e = !1), Promise.all([this.identityClient.logout(), e ? void 0 : this.logoutYtica()]);
        }, e.prototype.logoutYtica = function () {
          return Promise.all([this.openYticaLogoutIframe(C.getFlexInsightsQuestionnairesUrl(this.manager.configuration) + "/logout-flex.html", "Twilio-AssessmentYticaLogout").catch(function (e) {
            return h.log.warn(e);
          }), this.openYticaLogoutIframe(C.getFlexInsightsBaseUrl(this.manager.configuration) + "/static/logout-flex.html", "Twilio-AppYticaLogout").catch(function (e) {
            return h.log.warn(e);
          })]);
        }, e.prototype.openYticaLogoutIframe = function (e, t) {
          var n = this;
          return new Promise(function (r, o) {
            var i = document.createElement("iframe"),
              a = function a(e) {
                e.source === i.contentWindow && "object" == typeof e.data && "com.twilio.flex.insights.logout" === e.data.name && (window.removeEventListener("message", a), n.manager.events.removeListener(d.FlexEvent.yticaTokenUpdated, n.sendTokensToYtica), n.manager.events.removeListener(d.FlexEvent.tokenUpdated, n.sendTokensToYtica), document.body.removeChild(i), r(void 0));
              };
            window.addEventListener("message", a), i.src = e, i.id = t, i.style.cssText = "position:absolute;top:0;left:0;display:none;opacity:0;", document.body.appendChild(i), setTimeout(function () {
              o(p.ErrorManager.createAndProcessError("Not logged out in time", {
                type: p.FlexErrorType.app,
                description: "Not logged out in time: " + t,
                context: "InsightsService"
              }));
            }, 1e4);
          });
        }, e.prototype.openYticaLoginIframe = function () {
          var e = this,
            t = document.createElement("iframe");
          t.src = C.getFlexInsightsBaseUrl(this.manager.configuration) + "/static/login-flex.html", t.id = "Twilio-AppYticaLogin", t.style.cssText = "position:absolute;top:0;left:0;display:none;opacity:0;", t.onload = function () {
            e.sendTokensToYtica();
          }, this.yticaLoginIframe = t, this.manager.events.addListener(d.FlexEvent.yticaTokenUpdated, this.sendTokensToYtica), this.manager.events.addListener(d.FlexEvent.tokenUpdated, this.sendTokensToYtica), document.body.appendChild(t);
        }, e.prototype.extractSegmentIdFromLegacyPlayerUrl = function (e) {
          var t = e.pathname.match(/player\/segment\/([0-9a-zA-Z-]+)/);
          return null === t || 2 !== t.length ? null : t[1];
        }, e.prototype.extractSegmentIdFromDrilldownServiceUrl = function (e) {
          if (!e.host.endsWith("twilio.com")) return null;
          var t = e.pathname.match(/\/flex-insights-drilldown\/accounts\/[0-9a-zA-Z]+\/segments\/([0-9a-zA-Z-]+)/);
          return null === t || 2 !== t.length ? null : t[1];
        }, e.prototype.extractSegmentIdFromUrl = function (e) {
          var t = this.extractSegmentIdFromDrilldownServiceUrl(e);
          return t || this.extractSegmentIdFromLegacyPlayerUrl(e);
        }, e.prototype.registerFlexActions = function () {
          s.Actions.registerAction("HistoricalReporting:view", this.historicalReportingViewAction);
        }, e.prototype.updateProfileInfo = function (e) {
          y.Actions.updateGoodDataProfileInfo(e.data.accountSetting);
        }, e.prototype.loginGoodData = function () {
          return r(this, void 0, Promise, function () {
            var e, t, n, r, i, c;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  if (o.trys.push([0, 8,, 9]), v.Actions.updateGoodDataServiceStatus(w.InsightsServiceStatus.Initializing), !this.identityClient.isLoggedIn) throw new Error("Unable to login to GoodData, because identity client is not logged in");
                  return [4, this.identityClient.getWorkspaceEncryptedClaims()];
                case 1:
                  return e = o.sent(), [4, this.identityClient.getSSOProvider()];
                case 2:
                  return t = o.sent(), (n = new URLSearchParams()).set("targetUrl", "/gdc/account/profile/current"), n.set("ssoProvider", t), n.set("encryptedClaims", e || ""), [4, l.default.post(this.analyticsUrl + "/gdc/account/customerlogin", n, {
                    withCredentials: !0,
                    headers: {
                      "Content-type": "application/x-www-form-urlencoded"
                    }
                  })];
                case 3:
                  r = o.sent(), this.updateProfileInfo(r), this.sdk = a.factory({
                    domain: this.analyticsUrl
                  }), o.label = 4;
                case 4:
                  return o.trys.push([4, 6,, 7]), [4, Promise.all([this.fetchProjectDashboards(), this.fetchAnalyticalDashboards()])];
                case 5:
                  return o.sent(), [3, 7];
                case 6:
                  return i = o.sent(), s.Notifications.showNotification(g.FlexInsightsDataFetchFailed), p.ErrorManager.createAndProcessError("Insights Dashboards fetch failed", {
                    type: p.FlexErrorType.app,
                    context: "InsightsService",
                    wrappedError: i,
                    description: "Unable to fetch project or analytical dashboards on " + window.location.hostname
                  }), h.log.error("Unable to fetch project or analytical dashboards", i), [3, 7];
                case 7:
                  return v.Actions.updateGoodDataServiceStatus(w.InsightsServiceStatus.Ready), [3, 9];
                case 8:
                  return "Network Error" === (c = o.sent()).message && "flex.twilio.com" !== window.location.hostname ? (v.Actions.updateGoodDataServiceStatus(w.InsightsServiceStatus.CORSError), p.ErrorManager.createAndProcessError("Login to GoodData failed", {
                    type: p.FlexErrorType.app,
                    context: "InsightsService",
                    wrappedError: c,
                    description: "Network Error likely due to CORS policy for " + window.location.hostname
                  })) : (v.Actions.updateGoodDataServiceStatus(w.InsightsServiceStatus.Error), p.ErrorManager.createAndProcessError("Login to GoodData failed", {
                    type: p.FlexErrorType.app,
                    context: "InsightsService",
                    wrappedError: c
                  })), [3, 9];
                case 9:
                  return [2];
              }
            });
          });
        }, e.prototype.getAnalyticalDashboardDrillableItems = function (e) {
          return r(this, void 0, void 0, function () {
            var t, n, r;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  if (t = u.drillableItemsByIdSelector(f.FlexModule.state, {
                    dashboardId: e
                  }), !(n = u.analyticalDashboardsByIdSelector(f.FlexModule.state, {
                    dashboardId: e
                  })) || t && t.length > 0) return [2];
                  o.label = 1;
                case 1:
                  return o.trys.push([1, 3,, 4]), [4, this.fetchWidgetsMetrics(n.widgets || [])];
                case 2:
                  return r = o.sent(), y.Actions.updateDashboardDrillableItems({
                    dashboardId: e,
                    items: r
                  }), [3, 4];
                case 3:
                  return o.sent(), p.ErrorManager.createAndProcessError("Could not fetch drillable items for KPI dashboard", {
                    type: p.FlexErrorType.app,
                    description: "Dashboard: " + e,
                    context: "Dashboard"
                  }), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e.prototype.fetchWidgetsMetrics = function (e) {
          var t;
          return r(this, void 0, void 0, function () {
            var n, r;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return e && e.length ? (n = null === (t = this.identityClient.user) || void 0 === t ? void 0 : t.workspace_id, [4, l.default.post(this.analyticsUrl + "/gdc/md/" + n + "/objects/get", {
                    get: {
                      items: e
                    }
                  }, {
                    withCredentials: !0
                  })]) : [2, []];
                case 1:
                  return r = o.sent(), [2, (i = r.data, i && i.objects && i.objects.items ? i.objects.items.filter(function (e) {
                    var t, n, r;
                    return !!(null === (r = null === (n = null === (t = e.kpi) || void 0 === t ? void 0 : t.content) || void 0 === n ? void 0 : n.drillTo) || void 0 === r ? void 0 : r.projectDashboardTab);
                  }).map(function (e) {
                    return e.kpi.content.metric;
                  }) : [])];
              }
              var i;
            });
          });
        }, e.prototype.fetchProjectDashboards = function () {
          return r(this, void 0, void 0, function () {
            function e(e) {
              var t = e.projectDashboard.meta,
                n = e.projectDashboard.content;
              return {
                category: t.category,
                identifier: t.identifier,
                link: t.uri,
                title: t.title,
                author: t.author,
                tabs: n.tabs.map(function (e) {
                  return {
                    title: e.title,
                    identifier: e.identifier
                  };
                })
              };
            }
            var t, n, r, a, s, c;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  t = this.identityClient.user ? this.identityClient.user.workspace_id : void 0, n = "/gdc/md/" + t + "/objects/query?category=projectDashboard&limit=50&offset=0&mode=raw", r = [], a = this.manager.store.getState().flex, o.label = 1;
                case 1:
                  return n ? [4, l.default.get("" + this.analyticsUrl + n, {
                    withCredentials: !0
                  })] : [3, 3];
                case 2:
                  return s = o.sent(), c = s.data.objects.items.filter(function (e) {
                    var t, n;
                    return 1 !== e.projectDashboard.meta.unlisted || e.projectDashboard.meta.author === (null === (n = null === (t = a.insights.profileInfo) || void 0 === t ? void 0 : t.links) || void 0 === n ? void 0 : n.self);
                  }), r = i(r, c.map(e)), n = s.data.objects.paging.next, [3, 1];
                case 3:
                  return y.Actions.updateInsightsProjectDashboards(r), [2];
              }
            });
          });
        }, e.prototype.fetchAnalyticalDashboards = function () {
          return r(this, void 0, void 0, function () {
            function e(e) {
              var t = e.analyticalDashboard.meta,
                n = e.analyticalDashboard.content;
              return {
                category: t.category,
                identifier: t.identifier,
                link: t.uri,
                title: t.title,
                author: t.author,
                widgets: n.widgets || []
              };
            }
            var t, n, r, a, s, c;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  t = this.identityClient.user ? this.identityClient.user.workspace_id : void 0, n = "/gdc/md/" + t + "/objects/query?category=analyticalDashboard&limit=50&offset=0&mode=raw", r = [], a = this.manager.store.getState().flex, o.label = 1;
                case 1:
                  return n ? [4, l.default.get("" + this.analyticsUrl + n, {
                    withCredentials: !0
                  })] : [3, 3];
                case 2:
                  return s = o.sent(), c = s.data.objects.items.filter(function (e) {
                    var t, n;
                    return 1 !== e.analyticalDashboard.meta.unlisted || e.analyticalDashboard.meta.author === (null === (n = null === (t = a.insights.profileInfo) || void 0 === t ? void 0 : t.links) || void 0 === n ? void 0 : n.self);
                  }), r = i(r, c.map(e)), n = s.data.objects.paging.next, [3, 1];
                case 3:
                  return y.Actions.updateInsightsAnalyticalDashboards(r), [2];
              }
            });
          });
        }, e;
      }();
    t.InsightsService = S;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VERSION = void 0, t.VERSION = "1.31.2";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isOutboundCallingEnabled = t.storeConfig = t.clearStoredConfig = t.getStoredConfig = t.fetchPublicConfiguration = t.fetchRuntimeDomainInfo = void 0;
    var a,
      s = n(0),
      l = n(48),
      c = n(13),
      u = n(12),
      p = n(5),
      d = n(124);
    function f(e, t) {
      return void 0 === t && (t = !0), o(this, void 0, Promise, function () {
        var n, o;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return t && a && e.accountSid && a.account_sid === e.accountSid ? [2, a] : [4, s.FlexSDKManager.getPublicConfig(e)];
            case 1:
              return n = i.sent(), o = Object.keys(n).reduce(function (e, t) {
                var o;
                return r(r({}, e), ((o = {})[d(t)] = n[t], o));
              }, {}), a = o, [2, o];
          }
        });
      });
    }
    t.fetchRuntimeDomainInfo = function (e, t) {
      return e = (e = e.trim()).endsWith("/") ? e.replace(/\/$/, "") : e, t ? (u.TelemetryManager.reportUIInteractionEvent({
        name: "custom_runtime_login",
        status: "complete"
      }), function (e, t) {
        void 0 === t && (t = !0);
        return o(this, void 0, Promise, function () {
          var n, r;
          return i(this, function (o) {
            switch (o.label) {
              case 0:
                return t && a ? [2, Promise.resolve(a)] : [4, fetch(e)];
              case 1:
                return 200 !== (n = o.sent()).status ? [3, 3] : [4, n.json()];
              case 2:
                if (r = o.sent().configurations, !Array.isArray(r) || r.length <= 0) throw p.log.error("Failed to fetch accountSid, no configurations"), s.ErrorManager.processError(new l.ValidationError(l.ValidationErrorKeys.accountSid));
                return [2, a = r[0]];
              case 3:
                throw p.log.error("Failed to fetch public configuration", n.status), s.ErrorManager.processError(new l.ValidationError(l.ValidationErrorKeys.accountSid));
            }
          });
        });
      }(t(e))) : f({
        runtimeDomain: e
      });
    }, t.fetchPublicConfiguration = f, t.getStoredConfig = function () {
      var e = localStorage.getItem("FLEX_CONFIG");
      return e && JSON.parse(e) || {};
    }, t.clearStoredConfig = function () {
      p.log.debug("clearing config from local storage", "FLEX_CONFIG"), localStorage.removeItem("FLEX_CONFIG");
    }, t.storeConfig = function (e) {
      var t = JSON.stringify(e);
      p.log.debug("saving config to local storage", "FLEX_CONFIG", t), localStorage.setItem("FLEX_CONFIG", t);
    }, t.isOutboundCallingEnabled = function () {
      var e = c.Manager.getInstance().serviceConfiguration.outbound_call_flows;
      return Boolean(e && e.default && e.default.enabled);
    };
  }, function (e, t, n) {
    "use strict";

    var _r6,
      o = this && this.__extends || (_r6 = function r(e, t) {
        return (_r6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r6(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ClientError = t.ClientErrorKeys = t.InternalError = t.BrowserError = t.BrowserErrorKeys = t.ValidationError = t.ValidationErrorKeys = t.ConfigError = t.ConfigErrorKeys = void 0;
    var a = n(7);
    !function (e) {
      e.accountSid = "accountSid", e.sso = "sso";
    }(t.ConfigErrorKeys || (t.ConfigErrorKeys = {}));
    var s = function (e) {
      function t(n) {
        var r = e.call(this, "Invalid or missing configuration: " + n + " is required", {
          context: "Login"
        }) || this;
        return r.key = n, Object.setPrototypeOf(r, t.prototype), r;
      }
      return o(t, e), t;
    }(a.FlexError);
    t.ConfigError = s, function (e) {
      e.accountSid = "accountSid", e.sso = "sso", e.untrustedDomain = "untrustedDomain", e.invalidCertificate = "invalidCertificate";
    }(t.ValidationErrorKeys || (t.ValidationErrorKeys = {}));
    var l = function (e) {
      function t(n, r) {
        void 0 === r && (r = {});
        var o = e.call(this, "Validation error: invalid " + n, i({
          context: "Login"
        }, r)) || this;
        return o.key = n, Object.setPrototypeOf(o, t.prototype), o;
      }
      return o(t, e), t;
    }(a.FlexError);
    t.ValidationError = l, function (e) {
      e.windowClosed = "windowClosed", e.popupBlocked = "popupBlocked", e.noWindowOpener = "noWindowOpener", e.redirecting = "redirecting";
    }(t.BrowserErrorKeys || (t.BrowserErrorKeys = {}));
    var c = function (e) {
      function t(n, r) {
        void 0 === r && (r = {});
        var o = e.call(this, "Browser error: " + n, i({
          context: "Login"
        }, r)) || this;
        return o.key = n, Object.setPrototypeOf(o, t.prototype), o;
      }
      return o(t, e), t;
    }(a.FlexError);
    t.BrowserError = c;
    var u = function (e) {
      function t(n, r) {
        void 0 === r && (r = {});
        var o = e.call(this, n || "Internal error", i({
          context: "Login"
        }, r)) || this;
        return Object.setPrototypeOf(o, t.prototype), o;
      }
      return o(t, e), t;
    }(a.FlexError);
    t.InternalError = u, function (e) {
      e.loginWindowOpenedFromLoginWindow = "loginWindowOpenedFromLoginWindow", e.metaNoReferrerMissing = "metaNoReferrerMissing";
    }(t.ClientErrorKeys || (t.ClientErrorKeys = {}));
    var p = function (e) {
      function t(n, r, o) {
        void 0 === o && (o = {});
        var a = e.call(this, r || "Client error: " + n, i({
          context: "Login"
        }, o)) || this;
        return a.key = n, Object.setPrototypeOf(a, t.prototype), a;
      }
      return o(t, e), t;
    }(a.FlexError);
    t.ClientError = p;
  }, function (e, t) {
    e.exports = require("react-router");
  }, function (e, t) {
    e.exports = require("@twilio/player");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.shortTimeCurrentLocaleFormatter = t.slaPreferencesPath = t.setSlaPreferencesPathPrefix = void 0;
    var r = "";
    t.setSlaPreferencesPathPrefix = function (e) {
      r = e;
    };
    t.slaPreferencesPath = function (e) {
      return void 0 === e && (e = ""), r + "/sla-preferences" + e;
    };
    t.shortTimeCurrentLocaleFormatter = function (e) {
      var t = new Date(),
        n = e.split(":"),
        r = n[0],
        o = n[1];
      return t.setHours(Number(r)), t.setMinutes(Number(o)), t.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ReservationStatuses = t.TaskChannelCapability = void 0, function (e) {
      e.Info = "Info", e.Call = "Call", e.Chat = "Chat", e.Video = "Video", e.Wrapup = "Wrapup";
    }(t.TaskChannelCapability || (t.TaskChannelCapability = {})), function (e) {
      e.Wrapping = "Wrapping", e.Completed = "Completed", e.Canceled = "Canceled", e.Pending = "Pending", e.Accepted = "Accepted", e.Rescinded = "Rescinded", e.Reserved = "Reserved", e.Assigned = "Assigned";
    }(t.ReservationStatuses || (t.ReservationStatuses = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(319), t), o(n(167), t);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UPDATE_INSIGHTS_PROFILE_INFO = t.UPDATE_DASHBOARD_DRILLABLE_ITEMS = t.DELETE_DASHBOARD = t.UPDATE_DASHBOARD_CATEGORY = t.UPDATE_INSIGHTS_ANALYTICAL_DASHBOARDS = t.UPDATE_INSIGHTS_PROJECT_DASHBOARDS = t.UPDATE_RECORDING_URL = t.UPDATE_CURRENT_SEGMENT_ID = t.SEGMENT_FETCH_FAILURE = t.SEGMENT_FETCH_SUCCESS = t.SEGMENT_FETCH_START = t.ACTION_INIT_INSIGHTS = void 0, t.ACTION_INIT_INSIGHTS = "FLEX_ACTION_INIT_INSIGHTS", t.SEGMENT_FETCH_START = "FLEX_ACTION_SEGMENT_FETCH_START", t.SEGMENT_FETCH_SUCCESS = "FLEX_ACTION_SEGMENT_FETCH_SUCCESS", t.SEGMENT_FETCH_FAILURE = "FLEX_ACTION_SEGMENT_FETCH_FAILURE", t.UPDATE_CURRENT_SEGMENT_ID = "FLEX_ACTION_UPDATE_CURRENT_SEGMENT_ID", t.UPDATE_RECORDING_URL = "FLEX_ACTION_UPDATE_RECORDING_URL", t.UPDATE_INSIGHTS_PROJECT_DASHBOARDS = "FLEX_UPDATE_INSIGHTS_PROJECT_DASHBOARDS", t.UPDATE_INSIGHTS_ANALYTICAL_DASHBOARDS = "FLEX_UPDATE_INSIGHTS_ANALYTICAL_DASHBOARDS", t.UPDATE_DASHBOARD_CATEGORY = "FLEX_UPDATE_DASHBOARD_CATEGORY", t.DELETE_DASHBOARD = "FLEX_DELETE_DASHBOARD", t.UPDATE_DASHBOARD_DRILLABLE_ITEMS = "FLEX_UPDATE_DASHBOARD_DRILLABLE_ITEMS", t.UPDATE_INSIGHTS_PROFILE_INFO = "UPDATE_INSIGHTS_PROFILE_INFO";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.globalSLConfigSelector = t.queuesGlobalConfig = t.queuesMetadataListSelector = t.queueChannelConfigurationsSelector = t.queueConfigurationSelector = t.validQueueChannelConfigurationsSelector = t.workspaceLongestQueueSelector = t.workspaceWaitingTasksSelector = t.workspaceActiveTasksSelector = t.queuesListArrayWithoutEmptyChannelsSelector = t.queuesListArraySelector = t.hasChannelData = t.queueSelector = t.workspaceStatsSelector = t.queuesListFilterSelector = t.queuesListSelector = void 0;
    var o = n(31);
    t.queuesListSelector = function (e) {
      return e.realtimeQueues.queuesList;
    };
    t.queuesListFilterSelector = function (e) {
      return e.realtimeQueues.filter;
    };
    t.workspaceStatsSelector = function (e) {
      return e.realtimeQueues.workspaceStats;
    };
    t.queueSelector = function (e, t) {
      return e.realtimeQueues.queuesList[t];
    };
    t.hasChannelData = function (e) {
      var t = ["timestamp_updated"],
        n = ["timestamp_updated", "longest_task_waiting_sid", "longest_task_waiting_from", "longest_task_waiting_age", "tasks_by_priority"],
        r = !1;
      return e.sla_30_min && Object.keys(e.sla_30_min).forEach(function (n) {
        if (!(t.indexOf(n) > -1)) {
          var o = e.sla_30_min[n];
          "number" == typeof o && o > 0 && (r = !0);
        }
      }), !!r || (e.sla_today && Object.keys(e.sla_today).forEach(function (n) {
        if (!(t.indexOf(n) > -1)) {
          var o = e.sla_today[n];
          "number" == typeof o && o > 0 && (r = !0);
        }
      }), !!r || (e.tasks_now && Object.keys(e.tasks_now).forEach(function (t) {
        if (!(n.indexOf(t) > -1)) {
          var o = e.tasks_now[t];
          "number" == typeof o && o > 0 && (r = !0);
        }
      }), r));
    }, t.queuesListArraySelector = o.createSelector(t.queuesListSelector, t.queuesListFilterSelector, function (e, t) {
      return void 0 === t && (t = function t() {
        return !0;
      }), Object.keys(e).map(function (t) {
        return e[t];
      }).filter(t).sort(function (e, t) {
        return e.friendly_name.localeCompare(t.friendly_name);
      });
    }), t.queuesListArrayWithoutEmptyChannelsSelector = o.createSelector(t.queuesListArraySelector, function (e) {
      return e.map(function (e) {
        return r(r({}, e), e.channels ? {
          channels: e.channels.filter(function (e) {
            return t.hasChannelData(e);
          })
        } : {});
      });
    }), t.workspaceActiveTasksSelector = o.createSelector(t.queuesListArraySelector, function (e) {
      return e.reduce(function (e, t) {
        return e + t.tasks_by_status.assigned + t.tasks_by_status.wrapping;
      }, 0);
    }), t.workspaceWaitingTasksSelector = o.createSelector(t.queuesListArraySelector, function (e) {
      return e.reduce(function (e, t) {
        return e + t.tasks_by_status.reserved + t.tasks_by_status.pending;
      }, 0);
    }), t.workspaceLongestQueueSelector = o.createSelector(t.queuesListArraySelector, function (e) {
      return e.reduce(function (e, t) {
        var n = t.longest_task_waiting_from ? new Date(t.longest_task_waiting_from) : new Date();
        return n < e.timestamp ? {
          queue: t,
          timestamp: n
        } : e;
      }, {
        timestamp: new Date(),
        queue: null
      }).queue;
    });
    var i = function i(e, t) {
      return t.queueSid;
    };
    t.validQueueChannelConfigurationsSelector = o.createSelector(function (e) {
      return e.realtimeQueues.queuesConfig.queue_channel_configurations;
    }, function (e) {
      return e.realtimeQueues.metadata.channelSids;
    }, function (e, t) {
      return e ? e.filter(function (e) {
        return t.indexOf(e.channel_sid) > -1;
      }) : [];
    }), t.queueConfigurationSelector = o.createSelector(function (e) {
      return e.realtimeQueues.queuesConfig.queue_configurations;
    }, i, function (e, t) {
      return null == e ? void 0 : e.find(function (e) {
        return e.queue_sid === t;
      });
    }), t.queueChannelConfigurationsSelector = o.createSelector(t.validQueueChannelConfigurationsSelector, i, function (e, t) {
      return e.filter(function (e) {
        return e.queue_sid === t;
      });
    });
    t.queuesMetadataListSelector = o.createSelector(function (e) {
      return e.realtimeQueues.metadata;
    }, function (e) {
      return e.queueSids.map(function (t) {
        return e.queuesBySid[t];
      });
    });
    t.queuesGlobalConfig = function (e) {
      return e.realtimeQueues.queuesConfig.default;
    }, t.globalSLConfigSelector = o.createSelector(t.queuesGlobalConfig, function (e) {
      return {
        timezone: e.reset_timezone,
        dailyReset: e.reset_time,
        serviceLevelThreshold: e.service_level_threshold,
        shortAbandonedThreshold: e.short_abandoned_threshold
      };
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.drillableItemsByIdSelector = t.drillableItemsSelector = t.createDrillableItemsByIdSelector = t.dashboardAuthorSelector = t.dashboardCategorySelector = t.analyticalDashboardsByIdSelector = t.filteredAnalyticalDashboards = t.analyticalDashboardsArraySelector = t.analyticalDashboardsSelector = t.filteredProjectDashboards = t.projectDashboardsArraySelector = t.projectDashboardsSelector = t.dashboardsFilterSelector = t.createDashboardByTabIdSelector = t.dashboardIdPropsSelector = t.tabIdToProjectDashboard = t.drillableItemsSelectorForFactory = t.projectDashboardsSelectorForFactory = void 0;
    var r = n(31);
    t.projectDashboardsSelectorForFactory = function (e) {
      return e.flex.insights.insightsProjectDashboards;
    };
    t.drillableItemsSelectorForFactory = function (e) {
      return e.flex.insights.drillableItemsByDashboard;
    }, t.tabIdToProjectDashboard = r.createSelector(t.projectDashboardsSelectorForFactory, function (e) {
      return Object.values(e).reduce(function (e, t) {
        return (t.tabs || []).forEach(function (n) {
          e[n.identifier] = t;
        }), e;
      }, {});
    });
    t.dashboardIdPropsSelector = function (e, t) {
      return t.dashboardId;
    };
    t.createDashboardByTabIdSelector = function () {
      return r.createSelector(t.tabIdToProjectDashboard, t.dashboardIdPropsSelector, function (e, t) {
        return e[t];
      });
    };
    t.dashboardsFilterSelector = function (e, t) {
      return t.dashboardsFilter;
    };
    t.projectDashboardsSelector = function (e) {
      return e.insights.insightsProjectDashboards;
    }, t.projectDashboardsArraySelector = r.createSelector(t.projectDashboardsSelector, function (e) {
      return Object.values(e);
    }), t.filteredProjectDashboards = r.createSelector(t.projectDashboardsArraySelector, t.dashboardsFilterSelector, function (e, t) {
      return e.filter(function (e) {
        return t(e);
      });
    });
    t.analyticalDashboardsSelector = function (e) {
      return e.insights.insightsAnalyticalDashboards;
    }, t.analyticalDashboardsArraySelector = r.createSelector(t.analyticalDashboardsSelector, function (e) {
      return Object.values(e);
    }), t.filteredAnalyticalDashboards = r.createSelector(t.analyticalDashboardsArraySelector, t.dashboardsFilterSelector, function (e, t) {
      return e.filter(function (e) {
        return t(e);
      });
    }), t.analyticalDashboardsByIdSelector = r.createSelector(t.analyticalDashboardsSelector, t.dashboardIdPropsSelector, function (e, t) {
      return e[t];
    });
    t.dashboardCategorySelector = function (e) {
      return e.insights.insightsDashboardCategory;
    };
    t.dashboardAuthorSelector = function (e) {
      var t, n;
      return null === (n = null === (t = e.insights.profileInfo) || void 0 === t ? void 0 : t.links) || void 0 === n ? void 0 : n.self;
    };
    t.createDrillableItemsByIdSelector = function () {
      return r.createSelector(t.drillableItemsSelectorForFactory, t.dashboardIdPropsSelector, function (e, t) {
        return e[t];
      });
    };
    t.drillableItemsSelector = function (e) {
      return e.insights.drillableItemsByDashboard;
    }, t.drillableItemsByIdSelector = r.createSelector(t.drillableItemsSelector, t.dashboardIdPropsSelector, function (e, t) {
      return e[t];
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Segment = t.ConversationViewPanel = t.Player = t.slaPreferencesPath = t.setSlaPreferencesPathPrefix = t.SLAPreferencesView = t.ServiceStatus = t.Controller = void 0, o(n(461), t), o(n(473), t);
    var i = n(60);
    Object.defineProperty(t, "Controller", {
      enumerable: !0,
      get: function get() {
        return i.InsightsController;
      }
    });
    var a = n(40);
    Object.defineProperty(t, "ServiceStatus", {
      enumerable: !0,
      get: function get() {
        return a.InsightsServiceStatus;
      }
    });
    var s = n(233);
    Object.defineProperty(t, "SLAPreferencesView", {
      enumerable: !0,
      get: function get() {
        return s.SLAPreferencesView;
      }
    });
    var l = n(51);
    Object.defineProperty(t, "setSlaPreferencesPathPrefix", {
      enumerable: !0,
      get: function get() {
        return l.setSlaPreferencesPathPrefix;
      }
    }), Object.defineProperty(t, "slaPreferencesPath", {
      enumerable: !0,
      get: function get() {
        return l.slaPreferencesPath;
      }
    });
    var c = n(523);
    t.Player = c, t.ConversationViewPanel = n(524);
    var u = n(54);
    Object.defineProperty(t, "Segment", {
      enumerable: !0,
      get: function get() {
        return u.PublicSegment;
      }
    });
  }, function (e, t) {
    e.exports = require("@material-ui/core/MenuItem");
  }, function (e, t) {
    e.exports = require("@material-ui/core/Select");
  }, function (e, t, n) {
    "use strict";

    var _r7,
      o = this && this.__extends || (_r7 = function r(e, t) {
        return (_r7 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r7(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InsightsController = t.InsightsControllerComponent = void 0;
    var i = n(1),
      a = n(21),
      s = n(3),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e;
          return this.props.children({
            status: this.props.status,
            historicalReportingStatus: this.props.historicalReportingStatus,
            client: null === (e = a.InsightsService.getInstance()) || void 0 === e ? void 0 : e.identityClient
          });
        }, t;
      }(i.PureComponent);
    t.InsightsControllerComponent = l, t.InsightsController = s.connect(function (e) {
      return {
        status: e.session.insightsServiceStatus,
        historicalReportingStatus: e.session.goodDataServiceStatus
      };
    })(l);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.LoadingContainer = void 0;
    var o,
      i,
      a = n(2),
      s = n(0);
    t.LoadingContainer = a.default("div")(o || (o = r(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 48px;\n    width: 100%;\n    ", "\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 48px;\n    width: 100%;\n    ", "\n"])), function (e) {
      return e.theme.QueuesStats.Container;
    }), t.Container = a.default(s.FlexBox)(i || (i = r(["\n    padding-top: 56px;\n    ", "\n"], ["\n    padding-top: 56px;\n    ", "\n"])), function (e) {
      return e.theme.QueuesStats.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var _r8,
      o = this && this.__extends || (_r8 = function r(e, t) {
        return (_r8 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r8(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ThemeProvider = t.StorelessThemeProvider = void 0;
    var a = n(1),
      s = n(41),
      l = n(0),
      c = n(3),
      u = n(142),
      p = n(471),
      d = n(472),
      f = n(78),
      h = p.createGenerateClassName({
        productionPrefix: "flex-md-"
      }),
      m = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            n = this.props.themeConf,
            r = u.ThemeColorsDefinitionCreator.getPredefined(this.props.themeConf.baseName);
          n.colors && (r.colors = i(i({}, r.colors), n.colors)), n.light && (r.lightTheme = n.light), e = f.createTheme(r.colors, r.lightTheme);
          var o = t.getMergedTheme(e, this.props.themeConf.overrides);
          o.name = this.props.themeConf.baseName;
          var l = p.createMuiTheme(o);
          return a.createElement(d.JssProvider, {
            generateClassName: h
          }, a.createElement(p.MuiThemeProvider, {
            theme: l
          }, a.createElement(s.ThemeProvider, {
            theme: o
          }, this.props.children)));
        }, t.getMergedTheme = function (e, t) {
          return t ? l.Utils.merge(e, t) : e;
        }, t;
      }(a.PureComponent);
    t.StorelessThemeProvider = m, t.ThemeProvider = c.connect(function (e) {
      return {
        themeConf: e.config.colorTheme
      };
    })(m);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PopoverDivider = t.PopoverWrapper = t.ThemedIcon = t.ThemedListItem = t.ThemedListSubheader = t.ThemedTooltip = t.WaveformContainer = t.RecordingInfoContainer = t.CallerInfoContainer = t.AgentsInfoContainer = t.ConversationInfoContainer = t.SegmentInfoContainer = t.PlayerContainer = t.Container = t.Sticky = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d,
      f,
      h,
      m,
      g,
      y,
      v = n(22),
      b = n(0),
      C = n(2);
    t.Sticky = C.default("div")(o || (o = r(["\n    position: sticky;\n    top: -1px;\n    z-index: 1;\n"], ["\n    position: sticky;\n    top: -1px;\n    z-index: 1;\n"]))), t.Container = C.default(b.FlexBox)(i || (i = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.ConversationView.Container;
    }), t.PlayerContainer = C.default(b.FlexBox)(a || (a = r(["\n    padding: ", ";\n    border-top: 1px solid;\n    border-bottom: 1px solid;\n    ", "\n"], ["\n    padding: ", ";\n    border-top: 1px solid;\n    border-bottom: 1px solid;\n    ", "\n"])), function (e) {
      return e.hasFindings ? "30px 16px 16px" : "16px";
    }, function (e) {
      return e.theme.ConversationView.Player.Container;
    }), t.SegmentInfoContainer = C.default(b.FlexBox)(s || (s = r(["\n    padding: 16px 12px;\n    align-items: baseline;\n    ", "\n    > * {\n        margin: 0 4px;\n    }\n"], ["\n    padding: 16px 12px;\n    align-items: baseline;\n    ", "\n    > * {\n        margin: 0 4px;\n    }\n"])), function (e) {
      return e.theme.ConversationView.SegmentInfo.Container;
    }), t.ConversationInfoContainer = C.default(b.FlexBox)(l || (l = r(["\n    padding: 16px;\n    strong {\n        font-weight: bold;\n    }\n    ", "\n"], ["\n    padding: 16px;\n    strong {\n        font-weight: bold;\n    }\n    ", "\n"])), function (e) {
      return e.theme.ConversationView.ConversationInfo.Container;
    }), t.AgentsInfoContainer = C.default("div")(c || (c = r(["\n    display: flex;\n    align-items: center;\n    flex-grow: 0;\n    margin-right: 16px;\n\n    .Twilio-Icon {\n        margin-right: 8px;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    flex-grow: 0;\n    margin-right: 16px;\n\n    .Twilio-Icon {\n        margin-right: 8px;\n    }\n"]))), t.CallerInfoContainer = C.default("div")(u || (u = r(["\n    display: flex;\n    align-items: center;\n    flex-grow: 0;\n\n    .Twilio-Icon {\n        margin-right: 8px;\n    }\n\n    > div {\n        display: flex;\n        align-items: center;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    flex-grow: 0;\n\n    .Twilio-Icon {\n        margin-right: 8px;\n    }\n\n    > div {\n        display: flex;\n        align-items: center;\n    }\n"]))), t.RecordingInfoContainer = C.default("div")(p || (p = r(["\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-grow: 1;\n\n    .Twilio-Icon {\n        margin: 0 8px;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-grow: 1;\n\n    .Twilio-Icon {\n        margin: 0 8px;\n    }\n"]))), t.WaveformContainer = C.default("div")(d || (d = r(["\n    margin: 0 8px;\n    flex: 1;\n"], ["\n    margin: 0 8px;\n    flex: 1;\n"]))), t.ThemedTooltip = v.withStyles(function (e) {
      return {
        tooltip: {
          backgroundColor: e.colors.base3,
          color: e.colors.base10,
          padding: "8px",
          fontSize: "12px"
        }
      };
    })(v.Tooltip), t.ThemedListSubheader = C.default(v.ListSubheader)(f || (f = r(["\n    font-size: 10px;\n    font-weight: bold;\n    line-height: 10px;\n    padding: 16px 16px 8px;\n    color: ", ";\n"], ["\n    font-size: 10px;\n    font-weight: bold;\n    line-height: 10px;\n    padding: 16px 16px 8px;\n    color: ", ";\n"])), function (e) {
      return e.theme.calculated.textColor;
    }), t.ThemedListItem = C.default(v.ListItem)(h || (h = r(["\n    font-size: 14px;\n    line-height: 14px;\n    height: 30px;\n    padding: 8px 16px;\n    color: ", ";\n    cursor: pointer;\n\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    font-size: 14px;\n    line-height: 14px;\n    height: 30px;\n    padding: 8px 16px;\n    color: ", ";\n    cursor: pointer;\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), function (e) {
      return e.theme.calculated.textColor;
    }, function (e) {
      return e.theme.colors.base3;
    }), t.ThemedIcon = C.default(b.Icon)(m || (m = r(["\n    margin-left: auto;\n    color: ", ";\n"], ["\n    margin-left: auto;\n    color: ", ";\n"])), function (e) {
      return e.theme.colors.acceptColor || "";
    }), t.PopoverWrapper = C.default("div")(g || (g = r(["\n    padding: 0 0 8px;\n    background-color: ", ";\n    border: 1px solid ", ";\n"], ["\n    padding: 0 0 8px;\n    background-color: ", ";\n    border: 1px solid ", ";\n"])), function (e) {
      return e.theme.colors.base1;
    }, function (e) {
      return e.theme.colors.base2;
    }), t.PopoverDivider = C.default("div")(y || (y = r(["\n    margin: 0 16px;\n    height: 1px;\n    background-color: ", ";\n"], ["\n    margin: 0 16px;\n    height: 1px;\n    background-color: ", ";\n"])), function (e) {
      return e.theme.colors.base2;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InsightsIconButton = t.InsightsButton = void 0;
    var o,
      i,
      a = n(0),
      s = n(2);
    t.InsightsButton = s.default(a.Button)(o || (o = r(["\n    width: 120px;\n    height: 32px;\n    font-size: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0;\n    border: 1px solid ", ";\n    display: block;\n    border-radius: 3px;\n\n    pointer-events: ", ";\n\n    &:hover {\n        cursor: pointer;\n        ", "\n    }\n    &:first-child {\n        margin-left: 0;\n    }\n    ", "\n    ", "\n"], ["\n    width: 120px;\n    height: 32px;\n    font-size: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0;\n    border: 1px solid ", ";\n    display: block;\n    border-radius: 3px;\n\n    pointer-events: ", ";\n\n    &:hover {\n        cursor: pointer;\n        ", "\n    }\n    &:first-child {\n        margin-left: 0;\n    }\n    ", "\n    ", "\n"])), function (e) {
      return e.theme.colors.base6;
    }, function (e) {
      return e.disabled ? "none" : "inherit";
    }, function (e) {
      var t = e.primary,
        n = e.theme;
      return t && n.ConversationView.PrimaryButtonHover;
    }, function (e) {
      return e.theme.ConversationView.Button;
    }, function (e) {
      var t = e.primary,
        n = e.theme;
      return t && n.ConversationView.PrimaryButton;
    }), t.InsightsIconButton = s.default(a.IconButton)(i || (i = r(["\n    border: 1px solid ", ";\n    border-radius: 3px;\n    svg {\n        width: auto;\n        height: auto;\n    }\n\n    &.active {\n        background-color: ", ";\n    }\n"], ["\n    border: 1px solid ", ";\n    border-radius: 3px;\n    svg {\n        width: auto;\n        height: auto;\n    }\n\n    &.active {\n        background-color: ", ";\n    }\n"])), function (e) {
      return e.theme.colors.base6;
    }, function (e) {
      return e.theme.colors.base3;
    });
  }, function (e, t, n) {
    "use strict";

    var _r9,
      o = this && this.__extends || (_r9 = function r(e, t) {
        return (_r9 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r9(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i,
      a = n(0),
      s = n(1),
      l = n(57),
      c = n(5),
      u = n(140),
      p = n(692);
    !function (e) {
      e[e.Fetching = 0] = "Fetching", e[e.Fetched = 1] = "Fetched", e[e.Error = 2] = "Error";
    }(i || (i = {}));
    var d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.hasFetched = !1, t.state = {
          url: "",
          urlStatus: i.Fetching
        }, t.yticaRef = s.createRef(), t.getUrl = function (e) {
          t.hasFetched = !0, t.props.getUrl(e).then(function (e) {
            t.setState({
              url: e,
              urlStatus: i.Fetched
            });
          }).catch(function (e) {
            c.log.error(e), t.setState({
              urlStatus: i.Error
            });
          });
        }, t;
      }
      return o(t, e), Object.defineProperty(t.prototype, "iframeRef", {
        get: function get() {
          return this.yticaRef.current && this.yticaRef.current.iframeRef.current ? this.yticaRef.current.iframeRef.current : null;
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.render = function () {
        var e = this;
        return s.createElement(l.Controller, null, function (t) {
          var n = t.status,
            r = t.client;
          if (n === l.ServiceStatus.Ready) {
            if (!e.hasFetched && r) return e.getUrl(r), s.createElement(a.CircularProgress, {
              borderWidth: 3
            });
            if (e.state.urlStatus === i.Fetched) return s.createElement(p.YticaApp, {
              name: e.props.name,
              src: e.state.url,
              isActive: e.props.isActive,
              onMessage: e.props.onMessage,
              ref: e.yticaRef
            });
          }
          return n === l.ServiceStatus.Initializing || e.state.urlStatus === i.Fetching ? s.createElement(a.CircularProgress, {
            borderWidth: 3
          }) : s.createElement(u.NotAvailable, {
            name: e.props.name
          });
        });
      }, t.defaultProps = {
        isActive: !0
      }, t;
    }(s.Component);
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var _r10,
      o = this && this.__extends || (_r10 = function r(e, t) {
        return (_r10 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r10(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkView = void 0;
    var i = n(1),
      a = n(0),
      s = n(80),
      l = n(6),
      c = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.gotoView = function () {
            l.tryInvokeAction("NavigateToView", {
              viewName: t.props.viewName
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.activeView,
            n = e.showLabel,
            r = e.Badge,
            o = e.viewName,
            l = e.icon,
            c = e.iconActive,
            u = e.template;
          return i.createElement(s.SideLink, {
            icon: l,
            iconActive: c,
            isActive: t === o,
            onClick: this.gotoView,
            showLabel: n,
            Badge: r
          }, i.createElement(a.Template, {
            source: u
          }));
        }, t;
      }(i.PureComponent);
    t.SideLinkView = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Spy = void 0;
    var r = function r(e) {
      this.target = e.target, this.targetAlias = e.targetAlias, this.trigger = e.trigger.bind(null), this.onStart = e.onStart, this.start = this.start.bind(this);
    };
    t.Spy = r;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.downloadReport = t.getErrorReportForDebugger = t.errorToJSON = void 0;
    var i = n(7),
      a = n(5),
      s = n(3),
      l = function l(e) {
        var t = [],
          n = JSON.stringify(e, function (e, n) {
            if (void 0 === n) return "undefined";
            if ("object" == typeof n) {
              if ("string" == typeof e && e.startsWith("__") && e.endsWith("__")) return;
              if (null !== n) {
                if (t.includes(n)) return;
                t.push(n);
              }
            }
            return n instanceof Object ? Object.getOwnPropertyNames(n).reduce(function (e, t) {
              return e[t] = n[t], e;
            }, {}) : n;
          }, 4);
        return t = [], n;
      },
      c = function c(e) {
        var t = "Error: ";
        return "string" == typeof e ? t += '"' + e + '"' : e.message && (t += '"' + e.message + '"'), ((t.match(/(.*)/) || [])[0] || "// No error message").replace(/[`*#\[\]\(\)]/g, function (e) {
          return "\\" + e;
        });
      },
      u = function u(e) {
        var t = {
          message: "string" == typeof e ? e : e.message
        };
        if (i.isFlexError(e)) {
          var n = e.content,
            a = n.wrappedError,
            s = o(n, ["wrappedError"]);
          t = r(a ? {
            message: e.message,
            wrappedError: "string" == typeof a ? a : a.message
          } : {
            message: e.message
          }, s);
        }
        return t;
      },
      p = function p(e) {
        return i.isFlexError(e) ? e.logs : a.logManager.flush();
      },
      d = function d(e) {
        return i.isFlexError(e) ? e.sessionData : i.ErrorManager.sessionData;
      };
    t.errorToJSON = function (e) {
      var n;
      if (i.isFlexError(e)) {
        var r = e.content.wrappedError;
        r && (n = "string" == typeof r ? r : t.errorToJSON(r));
      }
      return {
        title: c(e),
        name: e.name,
        message: e.message,
        logLine: i.isFlexError(e) && e.logLine,
        stack: e.stack,
        details: u(e),
        wrappedError: n,
        logs: p(e),
        sessionData: d(e)
      };
    };
    var f = function f(e, t) {
        void 0 === t && (t = !0);
        var n = e.stack;
        if (!(t || e instanceof i.FlexError)) return "\n```\nmessage: " + e.message + "\nstack: " + e.stack + "\n```\n";
        var r = "\n## " + c(e) + "\n";
        if (i.isFlexError(e) && (r += "\n### LOG LINE\n```\n" + e.logLine + "\n```\n"), n && (r += "\n### STACK TRACE\n```\n" + n + "\n```\n"), r += "\n### DETAILS\n```\n" + (l(u(e)) || "N/A") + "\n```\n    ", i.isFlexError(e)) {
          var o = e.content.wrappedError;
          if (o) r += "\n<details>\n<summary>WRAPPED ERROR</summary>\n" + ("string" == typeof o ? o : f(o, !1)) + "\n</details>\n---\n            ";
        }
        if (t) {
          var a;
          a = "\n<details>\n<summary>LOGS</summary>\n<pre>\n" + p(e) + "\n</pre>\n</details>            \n", r += "\n### SESSION DATA\n```\n" + l(d(e)) + "\n```\n" + a + "\n\n";
        }
        return r;
      },
      h = function h(e) {
        var t = d(),
          n = "## General Session Information\n\n### SESSION DATA\n```\n" + l(t) + "\n```\n\n" + (a.logManager ? "<details>\n<summary>LOGS</summary>\n\n<pre>\n" + a.logManager.flush() + "\n</pre>\n\n</details>" : "");
        if (!e || !e.length) return n;
        var r = "",
          o = "";
        e.forEach(function (e, t) {
          r += function (e, t) {
            return "\n" + (t + 1) + ". [" + c(e) + "](#" + c(e).replace(/\s/g, "-") + ")";
          }(e, t), o += f(e);
        }), r += "\n---";
        var i = "\n# Twilio Flex Error report\n---\n" + (e.length > 1 ? r : "") + "\n" + o + "\n\n" + n + "\n";
        return s.pastTokens.forEach(function (e) {
          i = i.replace(new RegExp("" + e, "g"), "***");
        }), i;
      };
    t.getErrorReportForDebugger = function (e) {
      return f(e, !1);
    };
    t.downloadReport = function (e) {
      var t = h(e),
        n = new Blob([t], {
          type: "text/plain"
        }),
        r = window.URL.createObjectURL(n),
        o = document.createElement("a"),
        i = new Date(),
        a = [i.getFullYear(), i.getMonth() + 1, i.getDate(), i.getHours(), i.getMinutes(), i.getSeconds()].map(function (e) {
          return e < 10 ? "0" + e : e;
        }).join("-");
      o.setAttribute("href", r), o.setAttribute("download", "flex_error_report_" + a + ".md"), o.style.display = "none", document.body.appendChild(o), o.click(), document.body.removeChild(o);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Strings = t.languages = void 0;
    var r = n(366),
      o = n(367);
    Object.defineProperty(t, "Strings", {
      enumerable: !0,
      get: function get() {
        return o.Strings;
      }
    });
    var i = {
      default: r.default
    };
    t.languages = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ENDPOINT_SEGMENT_ID = t.INSIGHTS_PLAYER_INITIALIZED = t.INSIGHTS_PLAYER_HIDE = t.INSIGHTS_PLAYER_SHOW = t.INSIGHTS_PLAYER_PLAY = void 0, t.INSIGHTS_PLAYER_PLAY = "InsightsPlayer:play", t.INSIGHTS_PLAYER_SHOW = "InsightsPlayer:show", t.INSIGHTS_PLAYER_HIDE = "InsightsPlayer:hide", t.INSIGHTS_PLAYER_INITIALIZED = "InsightsPlayer:initialized", t.ENDPOINT_SEGMENT_ID = "${mediaApiUrl}/segmentId/${accountSid}/${taskSid}";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TokenManager = void 0;
    var a = n(0),
      s = n(34),
      l = n(7),
      c = n(5),
      u = n(182);
    function p(e) {
      u.TokenStorage.set(e), c.log.debug("Token has been successfully updated");
    }
    function d() {
      c.log.debug("Token has expired"), u.TokenStorage.clear();
    }
    t.TokenManager = {
      initialize: function initialize() {
        a.FlexSDKManager.addListener("tokenUpdated", p), a.FlexSDKManager.addListener("tokenExpired", d);
      },
      destroy: function destroy() {
        a.FlexSDKManager.removeListener("tokenUpdated", p), a.FlexSDKManager.removeListener("tokenExpired", d);
      },
      hasActiveToken: function hasActiveToken() {
        return o(this, void 0, Promise, function () {
          var e;
          return i(this, function (t) {
            return (e = this.parseTokenPayloadFromQueryString() || u.TokenStorage.get()) ? [2, this.validate(e.token).then(function (e) {
              return !!(null == e ? void 0 : e.valid);
            })] : [2, !1];
          });
        });
      },
      validate: function validate(e) {
        return o(this, void 0, Promise, function () {
          return i(this, function (t) {
            return [2, a.FlexSDKManager.validateToken(e).catch(function (e) {
              if (!Boolean(e.message.match(/20104|20003/))) throw l.ErrorManager.createAndProcessError("Unable to authenticate into Flex", {
                type: l.FlexErrorType.flexSDK,
                context: "TokenManager",
                wrappedError: e
              });
              d();
            })];
          });
        });
      },
      getActiveTokenPayload: function getActiveTokenPayload() {
        return o(this, void 0, Promise, function () {
          var e, t;
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                return n.trys.push([0, 2,, 3]), (e = u.TokenStorage.get()) ? [4, this.validate(e.token)] : [2, void 0];
              case 1:
                return (null == (t = n.sent()) ? void 0 : t.valid) ? [2, r(r({}, e), {
                  roles: t.roles
                })] : [3, 3];
              case 2:
                return n.sent(), c.log.debug("TokenManager: an error occurred while trying to get the active token payload"), [2, void 0];
              case 3:
                return [2, void 0];
            }
          });
        });
      },
      parseTokenPayloadFromQueryString: function parseTokenPayloadFromQueryString() {
        var e = window.location.search;
        if (e) {
          var t = s.parse(e);
          if (t.Identity && t.Expiration && t.Token) {
            var n = [];
            return t.Roles && (n = Array.isArray(t.Roles) ? t.Roles : [t.Roles]), {
              roles: n,
              identity: t.Identity,
              expiration: t.Expiration,
              token: t.Token
            };
          }
        }
      },
      clearTokenPayload: function clearTokenPayload() {
        u.TokenStorage.clear();
      },
      storeTokenPayload: function storeTokenPayload(e) {
        u.TokenStorage.set(e);
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getParticipants = t.dispatch = t.clearPendingParticipants = t.addParticipant = t.removeParticipant = t.addPendingParticipant = t.getParticipantsRejected = t.getParticipantsFulfilled = t.getParticipantsPending = void 0;
    var i = n(3),
      a = n(16),
      s = n(376),
      l = n(377);
    t.getParticipantsPending = s.createAction("participants/get/pending"), t.getParticipantsFulfilled = s.createAction("participants/get/fulfilled"), t.getParticipantsRejected = s.createAction("participants/get/rejected"), t.addPendingParticipant = s.createAction("add/pending/participant"), t.removeParticipant = s.createAction("remove/participant"), t.addParticipant = s.createAction("add/participant"), t.clearPendingParticipants = s.createAction("clear/pending/participant"), t.dispatch = i.FlexModule.dispatch, t.getParticipants = function (e) {
      return r(this, void 0, void 0, function () {
        var n, r, i, s;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return o.trys.push([0, 3,, 4]), [4, e.getChannels()];
            case 1:
              return n = o.sent(), r = n.find(function (e) {
                return "voice" === e.type;
              }), [4, e.getParticipants(r.sid)];
            case 2:
              return i = o.sent(), s = i.map(l.decodeParticipantClass).filter(function (e) {
                return "external" === e.type;
              }), t.dispatch(t.getParticipantsFulfilled(s)), [3, 4];
            case 3:
              return o.sent(), a.Notifications.showNotification(a.NotificationIds.FailedToFetchParticipants), [3, 4];
            case 4:
              return [2];
          }
        });
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InsightsQueue = t.InsightsWorker = t.InsightsTask = void 0;
    var r = n(0),
      o = n(3),
      i = n(4),
      a = function () {
        function e(e) {
          this.complete = function () {
            throw new Error("Not implemented");
          }, this.setAttributes = function (e) {
            throw new Error("Not implemented");
          }, this.wrapUp = function () {
            throw new Error("Not implemented");
          }, this.transfer = function (e, t) {
            throw new Error("Not implemented");
          }, this.hold = function () {
            throw new Error("Not implemented");
          }, this.unhold = function () {
            throw new Error("Not implemented");
          }, this.addVoiceParticipant = function () {
            throw new Error("Not implemented");
          }, this.holdParticipant = function () {
            throw new Error("Not implemented");
          }, this.unholdParticipant = function () {
            throw new Error("Not implemented");
          }, this.kick = function () {
            throw new Error("Not implemented");
          }, this.cancelTransfer = function () {
            throw new Error("Not implemented");
          }, this.getChannels = function () {
            throw new Error("Not implemented");
          }, this.getParticipants = function () {
            throw new Error("Not implemented");
          }, this.setEndConferenceOnExit = function () {
            throw new Error("Not implemented");
          }, this.endConference = function () {
            throw new Error("Not implemented");
          }, this._source = e;
        }
        return Object.defineProperty(e.prototype, "source", {
          get: function get() {
            return this._source;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "sourceObject", {
          get: function get() {
            return this._source;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "addOns", {
          get: function get() {},
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "age", {
          get: function get() {
            return this._source.task_age;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "attributes", {
          get: function get() {
            return this._source.attributes;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "dateCreated", {
          get: function get() {
            return new Date(this._source.date_created);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "dateUpdated", {
          get: function get() {
            return new Date(this._source.date_updated);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "priority", {
          get: function get() {
            return this._source.task_priority;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "queueName", {
          get: function get() {
            return this._source.queue_name;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "queueSid", {
          get: function get() {},
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "reason", {
          get: function get() {},
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "taskSid", {
          get: function get() {
            return this._source.task_sid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "status", {
          get: function get() {
            var e = this._source.status;
            return "wrapup" === e && (e = "wrapping"), e;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "taskStatus", {
          get: function get() {
            return this._source.task_status;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "taskChannelSid", {
          get: function get() {},
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "taskChannelUniqueName", {
          get: function get() {
            return this._source.task_channel_unique_name;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "timeout", {
          get: function get() {},
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "workflowName", {
          get: function get() {},
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "workflowSid", {
          get: function get() {},
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "sid", {
          get: function get() {
            return this._source.reservation_sid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "workerSid", {
          get: function get() {
            return this._source.worker_sid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "routingTarget", {
          get: function get() {
            return this._source.task_routing_target;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "defaultFrom", {
          get: function get() {
            var e = this.attributes;
            return (e.name ? e.name : this.routingTarget && "outbound" === e.direction ? e.outbound_to : e.from) || i.templates.AnonymousParticipant();
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "channelType", {
          get: function get() {
            return this.attributes.channelType || this.taskChannelUniqueName;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "incomingTransferObject", {
          get: function get() {},
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "outgoingTransferObject", {
          get: function get() {},
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "conference", {
          get: function get() {
            var e = o.FlexModule.state.conferences.states.get(this.taskSid);
            return e ? e.source : void 0;
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
    t.InsightsTask = a;
    var s = function () {
      function e(e) {
        this._source = e;
      }
      return Object.defineProperty(e.prototype, "source", {
        get: function get() {
          return this._source;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sid", {
        get: function get() {
          return this.source.worker_sid;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "name", {
        get: function get() {
          return this.source.friendly_name;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "fullName", {
        get: function get() {
          var e;
          return (null === (e = this.source.attributes) || void 0 === e ? void 0 : e.full_name) || this.name;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "activityName", {
        get: function get() {
          return this.source.activity_name;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributes", {
        get: function get() {
          return this.source.attributes;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateUpdated", {
        get: function get() {
          return new Date(this.source.date_updated);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "activityDuration", {
        get: function get() {
          if (!this.source.date_activity_changed) return "30+d";
          var e = Math.max(Date.now() - new Date(this.source.date_activity_changed).getTime(), 0);
          return r.Utils.formatTimeDuration(e, "short");
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isAvailable", {
        get: function get() {
          return this.findAvailabilityByActivityName();
        },
        enumerable: !1,
        configurable: !0
      }), e.ensureAvailabilityCache = function () {
        var e = this;
        this.availabilityByNameCache.size || o.FlexModule.workerClient && o.FlexModule.workerClient.activities.size && o.FlexModule.workerClient.activities.forEach(function (t) {
          e.availabilityByNameCache.set(t.name, t.available);
        });
      }, e.prototype.findAvailabilityByActivityName = function () {
        return e.ensureAvailabilityCache(), Boolean(e.availabilityByNameCache.get(this.activityName));
      }, e.availabilityByNameCache = new Map(), e;
    }();
    t.InsightsWorker = s;
    var l = function () {
      function e(e) {
        this._source = e;
      }
      return Object.defineProperty(e.prototype, "source", {
        get: function get() {
          return this._source;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sid", {
        get: function get() {
          return this.source.queue_sid;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "name", {
        get: function get() {
          return this.source.queue_name;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateUpdated", {
        get: function get() {
          return new Date(this.source.date_updated);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workspaceSid", {
        get: function get() {
          return this.source.workspace_sid;
        },
        enumerable: !1,
        configurable: !0
      }), e;
    }();
    t.InsightsQueue = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconContainerWithStyle = t.TaskDetailsPanelProps = t.TaskDetailsPanel = void 0;
    var r = n(193);
    Object.defineProperty(t, "TaskDetailsPanel", {
      enumerable: !0,
      get: function get() {
        return r.TaskDetailsPanel;
      }
    });
    var o = n(394);
    Object.defineProperty(t, "TaskDetailsPanelProps", {
      enumerable: !0,
      get: function get() {
        return o.TaskDetailsPanelProps;
      }
    });
    var i = n(75);
    Object.defineProperty(t, "IconContainerWithStyle", {
      enumerable: !0,
      get: function get() {
        return i.IconContainerWithStyle;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.ButtonContainer = t.ContentContainer = t.InfoContainer = t.TitleLineContainer = t.FirstLineContainer = t.SecondLineContainer = t.IconContainerWithStyle = t.IconContainer = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d,
      f = n(0),
      h = n(2);
    t.IconContainer = h.default("div")(o || (o = r(["\n    margin-bottom: 15px;\n"], ["\n    margin-bottom: 15px;\n"]))), t.IconContainerWithStyle = h.default("div")(i || (i = r(["\n    border-radius: 50%;\n    width: 72px;\n    height: 72px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    ", ";\n    background: ", ";\n"], ["\n    border-radius: 50%;\n    width: 72px;\n    height: 72px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    ", ";\n    background: ", ";\n"])), function (e) {
      return e.theme.TaskDetailsPanel.IconContainer;
    }, function (e) {
      return e.background;
    }), t.SecondLineContainer = h.default("div")(a || (a = r(["\n    font-size: 12px;\n    margin-bottom: 0px;\n    margin-top: 0px;\n    ", "\n"], ["\n    font-size: 12px;\n    margin-bottom: 0px;\n    margin-top: 0px;\n    ", "\n"])), function (e) {
      return e.theme.TaskDetailsPanel.SecondLine;
    }), t.FirstLineContainer = h.default("div")(s || (s = r(["\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 2px;\n    margin-left: 4px;\n    margin-right: 4px;\n"], ["\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 2px;\n    margin-left: 4px;\n    margin-right: 4px;\n"]))), t.TitleLineContainer = h.default("div")(l || (l = r(["\n    font-size: 12px;\n    margin-bottom: 15px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n"], ["\n    font-size: 12px;\n    margin-bottom: 15px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n"]))), t.InfoContainer = h.default("div")(c || (c = r(["\n    margin: auto;\n    text-align: center;\n"], ["\n    margin: auto;\n    text-align: center;\n"]))), t.ContentContainer = h.default(f.FlexBoxColumn)(u || (u = r(["\n    flex-grow: 1;\n    overflow: auto;\n"], ["\n    flex-grow: 1;\n    overflow: auto;\n"]))), t.ButtonContainer = h.default("div")(p || (p = r(["\n    width: 100%;\n    display: flex;\n    margin: ", ";\n    justify-content: center;\n\n    button {\n        width: 44px;\n        height: 44px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    margin: ", ";\n    justify-content: center;\n\n    button {\n        width: 44px;\n        height: 44px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"])), function (e) {
      return e.compact ? "4px auto 12px" : "24px auto";
    }), t.Container = h.default(f.FlexBoxColumn)(d || (d = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.TaskDetailsPanel.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isValidWorkerParticipantActionPayload = t.isValidWorkerActionPayload = t.isValidTaskPayload = t.WorkerActions = void 0;
    var a,
      s = n(0),
      l = n(27),
      c = n(34),
      u = n(92),
      p = n(47),
      d = n(13),
      f = n(9),
      h = n(7),
      m = n(3),
      g = n(5),
      y = n(16),
      v = n(6),
      b = n(39),
      C = n(36),
      _ = n(35),
      k = n(23),
      w = n(8),
      S = n(85),
      P = function () {
        function e() {}
        return e.registerActions = function () {
          s.Actions.registerAction("AcceptTask", this.acceptTask, this.updateAcceptTaskPayload), s.Actions.registerAction("RejectTask", this.rejectTask, this.updateWorkerActionPayload), s.Actions.registerAction("CompleteTask", this.completeTask, this.updateWorkerActionPayload), s.Actions.registerAction("WrapupTask", this.wrapupTask, this.updateWorkerActionPayload), s.Actions.registerAction("SelectTask", this.selectTask, this.updateWorkerActionPayload), s.Actions.registerAction("SetActivity", this.setActivity, this.updateWorkerSetActivityPayload), s.Actions.registerAction("SetWorkerActivity", this.setWorkerActivity, this.updateWorkerSetWorkerActivityPayload), s.Actions.registerAction("TransferTask", this.transferTask, this.updateWorkerActionPayload), s.Actions.registerAction("KickParticipant", this.kickParticipant, this.updateWorkerParticipantActionPayload), s.Actions.registerAction("CancelTransfer", this.cancelTransfer, this.updateWorkerActionPayload), s.Actions.registerAction("Logout", this.logout), s.Actions.registerAction("HoldParticipant", this.holdParticipant, this.updateWorkerParticipantActionPayload), s.Actions.registerAction("UnholdParticipant", this.unholdParticipant, this.updateWorkerParticipantActionPayload), s.Actions.registerAction("ToggleDTMFDialpad", this.toggleDTMFDialpad, this.updateWorkerActionPayload), s.Actions.registerAction("SetDTMFDialpadDigits", this.setDTMFDialpadDigits, this.updateWorkerActionPayload), s.Actions.registerAction("SendDTMFDigits", this.sendDTMFDigitsToCall, this.updateWorkerActionPayload);
        }, e.blockActionUntilReservationEvent = function (e, t, n) {
          s.Actions.blockAction(e, t);
          var r = ["accepted", "rejected", "timeout", "canceled", "rescinded", "completed", "wrapup"],
            o = function o() {
              s.Actions.unblockAction(e, t), r.forEach(function (e) {
                n.removeListener(e, o);
              });
            };
          r.forEach(function (e) {
            n.addListener(e, o);
          });
        }, e.acceptTask = function (t) {
          return o(this, void 0, Promise, function () {
            var n, r, o, l, c, u, p, d;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (n = t.task, r = !1, o = "WorkerActions.AcceptTask", !(l = k.StateHelper.getReservation(n.sid))) throw h.ErrorManager.createAndProcessError(S.ActionErrors.RESERVATION_NOT_FOUND, {
                    type: h.FlexErrorType.app,
                    description: "Reservation " + n.sid + " for task not found",
                    context: o
                  });
                  if ("pending" !== n.status) throw h.ErrorManager.createAndProcessError(S.ActionErrors.RESEREVATION_NOT_PENDING, {
                    type: h.FlexErrorType.app,
                    description: "Reservation " + n.sid + " is not in pending state",
                    context: o
                  });
                  return w.TaskHelper.isCallTask(n) ? (a && clearTimeout(a), c = m.FlexModule.state.supervisor.callMonitoring.status !== C.CallMonitoringStatus.none, u = /^client:/, p = m.FlexModule.state.worker.attributes.contact_uri, (r = Boolean(k.StateHelper.getCurrentPhoneCallState())) ? c ? [4, v.tryInvokeAction("StopMonitoringCall", m.FlexModule.state.supervisor.callMonitoring.task)] : [3, 2] : [3, 3]) : [3, 8];
                case 1:
                  return i.sent(), [3, 3];
                case 2:
                  g.log.error("'Stuck task' scenario 1 flavour 2 intercepted: a ghost voice connection was active while agent tried to accept a call task."), i.label = 3;
                case 3:
                  if (m.FlexModule.state.config.disableBrowserVoice && (u.test(p) || !p && u.test(t.conferenceOptions.to))) throw y.Notifications.showNotification(y.NotificationIds.BrowserVoiceDisabled), h.ErrorManager.createAndProcessError(S.ActionErrors.BROWSER_VOICE_DISABLED, {
                    type: h.FlexErrorType.app,
                    context: o
                  });
                  e.blockActionUntilReservationEvent("AcceptTask", t, l), i.label = 4;
                case 4:
                  return i.trys.push([4, 6,, 7]), [4, l.conference(t.conferenceOptions)];
                case 5:
                  return i.sent(), a = setTimeout(function () {
                    !k.StateHelper.getCurrentPhoneCallState() || !n || "pending" !== n.status || r || n.attributes && "outbound" === n.attributes.direction || g.log.error("'Stuck task' scenario 1 flavour 1 intercepted: a call task is still pending after 5 seconds, but its voice connection is up.");
                  }, 5e3), [3, 7];
                case 6:
                  throw d = i.sent(), s.Actions.unblockAction("AcceptTask", t), h.ErrorManager.createAndProcessError(S.ActionErrors.CANT_ACCEPT_CALL, {
                    type: h.FlexErrorType.taskrouterSDK,
                    description: "Could not accept call: " + d.message,
                    context: o,
                    wrappedError: d
                  });
                case 7:
                  return [2, l];
                case 8:
                  return [4, l.accept()];
                case 9:
                  return i.sent(), [2, l];
              }
            });
          });
        }, e.rejectTask = function (e) {
          return o(this, void 0, Promise, function () {
            var t, n, r;
            return i(this, function (o) {
              switch (o.label) {
                case 0:
                  if (t = e.task, n = k.StateHelper.getReservation(t.sid), r = "WorkerActions.RejectTask", !n) throw h.ErrorManager.createAndProcessError(S.ActionErrors.RESERVATION_NOT_FOUND, {
                    type: h.FlexErrorType.app,
                    description: "Reservation " + t.sid + " not found for task",
                    context: r
                  });
                  if ("pending" !== t.status) throw h.ErrorManager.createAndProcessError(S.ActionErrors.RESEREVATION_NOT_PENDING, {
                    type: h.FlexErrorType.app,
                    description: "Reservation " + t.sid + " is not in pending state",
                    context: r
                  });
                  return [4, n.reject(void 0)];
                case 1:
                  return o.sent(), [2, n];
              }
            });
          });
        }, e.completeTask = function (e) {
          return o(this, void 0, Promise, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  if ("completed" === (t = e.task).status) throw h.ErrorManager.createAndProcessError(S.ActionErrors.RESERVATION_IS_COMPLETED, {
                    type: h.FlexErrorType.app,
                    description: "Reservation " + t.sid + " is in completed state",
                    context: "WorkerActions.CompleteTask"
                  });
                  return [4, u.ChatOrchestrator.orchestrateCompleteTask(t)];
                case 1:
                  return n.sent(), [4, t.complete()];
                case 2:
                  return n.sent(), [2, t];
              }
            });
          });
        }, e.wrapupTask = function (e) {
          return o(this, void 0, Promise, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  if ("accepted" !== (t = e.task).status) throw h.ErrorManager.createAndProcessError(S.ActionErrors.RESERVATION_IS_NOT_ACCEPTED, {
                    type: h.FlexErrorType.app,
                    description: "Reservation " + t.sid + " is not in accepted state",
                    context: "WorkerActions.WrapupTask"
                  });
                  return [4, u.ChatOrchestrator.orchestrateWrapupTask(t)];
                case 1:
                  return n.sent(), [4, t.wrapUp()];
                case 2:
                  return n.sent(), [2, t];
              }
            });
          });
        }, e.selectTask = function (e) {
          return o(this, void 0, void 0, function () {
            var t;
            return i(this, function (n) {
              return _.Actions.selectTask(e.sid), t = e.sid || "", s.Actions.invokeAction("HistoryPush", "/agent-desktop/" + t), [2];
            });
          });
        }, e.setActivity = function (e) {
          var t, n;
          return o(this, void 0, Promise, function () {
            var o, a, s, l, c, u, p, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (o = e.activitySid, a = m.FlexModule.state.worker.activities.get(o), s = m.FlexModule.state.worker.activity, o === s.sid) return [2];
                  l = e.options && e.options.rejectPendingReservations, c = !a.available && l, u = r(r({}, e.options), {
                    rejectPendingReservations: c
                  }), i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, a.setAsCurrent(u)];
                case 2:
                  return i.sent(), [3, 4];
                case 3:
                  if (p = i.sent(), d = null === (t = null == p ? void 0 : p.response) || void 0 === t ? void 0 : t.statusText, f = null === (n = null == p ? void 0 : p.response) || void 0 === n ? void 0 : n.status, d && d.match(/Worker WK.* cannot have its activity updated while it has .* pending reservations/)) y.Notifications.showNotification(y.NotificationIds.PendingReservationsOnActivityStateChange);else {
                    if (400 !== f && 429 !== f) throw h.ErrorManager.createAndProcessError(S.ActionErrors.CANT_SET_ACTIVITY, {
                      type: h.FlexErrorType.app,
                      description: "Could not set activity: " + p.message,
                      context: "WorkerActions.SetActivity",
                      wrappedError: p
                    });
                    y.Notifications.showNotification(y.NotificationIds.WorkerActivityUpdateFailed, {
                      statusCode: f
                    });
                  }
                  return [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e.setWorkerActivity = function (e) {
          var t;
          return o(this, void 0, Promise, function () {
            var n, r, o, a, s, u, p, h, v, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  n = e.workerSid, r = e.activitySid, o = m.FlexModule.state.worker.activities.get(r), a = e.options && e.options.rejectPendingReservations, s = !o.available && a, u = f.getFlexServiceUrl(m.FlexModule.state.config), p = {
                    Sid: n,
                    WorkspaceSid: d.Manager.getInstance().serviceConfiguration.taskrouter_workspace_sid,
                    ActivitySid: r,
                    RejectPendingReservations: s
                  }, h = {
                    auth: {
                      username: "token",
                      password: m.FlexModule.state.session.ssoTokenPayload.token
                    },
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded"
                    }
                  }, i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, l.default.post(u + "/Worker/Instance", c.stringify(p), h)];
                case 2:
                  return i.sent(), g.log.debug("worker activity updated", r), [3, 4];
                case 3:
                  return v = i.sent(), 400 === (b = null === (t = null == v ? void 0 : v.response) || void 0 === t ? void 0 : t.status) || 429 === b ? y.Notifications.showNotification(y.NotificationIds.WorkerActivityUpdateFailed, {
                    statusCode: b
                  }) : y.Notifications.showNotification(y.NotificationIds.CannotChangeOtherWorkerActivity), g.log.error("failed to update worker activity", v), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e.transferTask = function (e) {
          if (!w.TaskHelper.canTransfer(e.task)) {
            y.Notifications.showNotification(y.NotificationIds.TaskCannotBeTransferred);
            var t = h.ErrorManager.createAndProcessError(S.ActionErrors.CANT_TRANSFER_TASK, {
              type: h.FlexErrorType.app,
              context: "WorkerActions.TransferTask"
            });
            return Promise.reject(t);
          }
          return e.task.transfer(e.targetSid, e.options);
        }, e.cancelTransfer = function (e) {
          if (!e.task.outgoingTransferObject) {
            var t = h.ErrorManager.createAndProcessError(S.ActionErrors.NO_TRANSFER_TO_CANCEL, {
              type: h.FlexErrorType.app,
              context: "WorkerActions.CancelTransfer"
            });
            return Promise.reject(t);
          }
          return e.task.cancelTransfer();
        }, e.kickParticipant = function (e) {
          return e.task.kick(e.targetSid);
        }, e.holdParticipant = function (e) {
          var t = e.task;
          if (!w.TaskHelper.canHold(t)) {
            var n = h.ErrorManager.createAndProcessError(S.ActionErrors.CANT_HOLD_PARTICIPANT, {
              type: h.FlexErrorType.app,
              context: "WorkerActions.HoldParticipant"
            });
            return Promise.reject(n);
          }
          var r = e.holdMusicUrl || m.FlexModule.state.config.holdMusicUrl,
            o = e.holdMusicMethod || m.FlexModule.state.config.holdMusicMethod;
          return t.holdParticipant(e.targetSid, r, o);
        }, e.unholdParticipant = function (e) {
          var t = e.task;
          if (!w.TaskHelper.canHold(t) && e.targetSid !== m.FlexModule.state.worker.worker.sid) {
            var n = h.ErrorManager.createAndProcessError(S.ActionErrors.CANT_UNHOLD_PARTICIPANT, {
              type: h.FlexErrorType.app,
              context: "WorkerActions.UnholdParticipant"
            });
            return Promise.reject(n);
          }
          return t.unholdParticipant(e.targetSid);
        }, e.toggleDTMFDialpad = function (t) {
          return o(this, void 0, Promise, function () {
            var n;
            return i(this, function (o) {
              if (!w.TaskHelper.isCallTask(t.task)) throw h.ErrorManager.createAndProcessError(S.ActionErrors.CANT_TOGGLE_DTMF, {
                type: h.FlexErrorType.app,
                context: "WorkerActions.ToggleDTMFDialpad"
              });
              return n = "CallCanvasDialpad" + t.task.sid, Object.prototype.hasOwnProperty.call(t, "open") ? t.open ? [2, _.Actions.setComponentState(n, {
                digits: ""
              })] : [2, _.Actions.deleteComponentState(n)] : [2, e.toggleDTMFDialpad(r(r({}, t), {
                open: !m.FlexModule.state.view.componentViewStates[n]
              }))];
            });
          });
        }, e.sendDTMFDigitsToCall = function (e) {
          return o(this, void 0, Promise, function () {
            var t, n, r, o;
            return i(this, function (i) {
              if (t = "WorkerActions.SendDTMFDigits", !w.TaskHelper.isLiveCall(e.task)) throw h.ErrorManager.createAndProcessError(S.ActionErrors.CANT_SEND_DIGITS, {
                type: h.FlexErrorType.app,
                context: t
              });
              if (!(n = k.StateHelper.getCurrentPhoneCallState())) throw h.ErrorManager.createAndProcessError(S.ActionErrors.NO_ACTIVE_CALL, {
                type: h.FlexErrorType.app,
                context: t
              });
              return r = m.FlexModule.state.view.componentViewStates["CallCanvasDialpad" + e.task.sid], o = r ? r.digits : "", s.Actions.invokeAction("SetDTMFDialpadDigits", {
                task: e.task,
                digits: o + e.digits
              }), n.source.sendDigits(e.digits), [2];
            });
          });
        }, e.setDTMFDialpadDigits = function (e) {
          return o(this, void 0, Promise, function () {
            return i(this, function (t) {
              if (!w.TaskHelper.isLiveCall(e.task)) throw h.ErrorManager.createAndProcessError(S.ActionErrors.CANT_SET_DIGITS, {
                type: h.FlexErrorType.app,
                context: "WorkerActions.SetDTMFDialpadDigits"
              });
              return [2, _.Actions.setComponentState("CallCanvasDialpad" + e.task.sid, {
                digits: e.digits
              })];
            });
          });
        }, e.updateWorkerActionPayload = function (e) {
          var t = r({}, e);
          return t.task && (t.sid = t.task.sid), t.sid && !t.task && (t.task = w.TaskHelper.getTaskByTaskSid(t.sid)), t;
        }, e.updateWorkerParticipantActionPayload = function (t) {
          var n = e.updateWorkerActionPayload(t);
          if (n.participant && (n.targetSid = n.participant.sid), n.targetSid && !n.participant && n.task) {
            var r = m.FlexModule.state.conferences.states.get(n.task.taskSid);
            r && (n.participant = r.source.participants.find(function (e) {
              return e.workerSid === n.targetSid;
            }));
          }
          return n;
        }, e.updateAcceptTaskPayload = function (t) {
          var n = (t = e.updateWorkerActionPayload(t)).task.conference;
          t.conferenceOptions = t.conferenceOptions || {}, t.conferenceOptions.endConferenceOnExit = !n || 0 === n.liveWorkerCount, t.conferenceOptions.endConferenceOnCustomerExit = !0;
          var o = !!d.Manager.getInstance() && d.Manager.getInstance().serviceConfiguration,
            i = !!d.Manager.getInstance() && d.Manager.getInstance().configuration;
          if (t.conferenceOptions.conferenceRecord = !!o.call_recording_enabled, t.conferenceOptions.conferenceRecord) {
            var a = {
                accountSid: o.account_sid,
                workspaceSid: o.taskrouter_workspace_sid,
                taskSid: t.task.sourceObject.task.sid
              },
              s = f.getCallRecordingCallbackUrl(r(r({}, o), i));
            Object.keys(a).forEach(function (e) {
              s = s.replace("{" + e + "}", a[e]);
            }), t.conferenceOptions.conferenceRecordingStatusCallback = s, t.conferenceOptions.conferenceRecordingStatusCallbackMethod = "POST";
          }
          return t;
        }, e.updateWorkerSetActivityPayload = function (e) {
          if (e.activityName && !e.activitySid) {
            var t = Array.from(m.FlexModule.state.worker.activities).find(function (t) {
              t[0];
              return t[1].name === e.activityName;
            });
            e.activitySid = t && t[0];
          }
          return e.activitySid && (e.activityName = m.FlexModule.state.worker.activities.get(e.activitySid).name, e.activityAvailable = m.FlexModule.state.worker.activities.get(e.activitySid).available), e.options || (e.options = {}), void 0 === e.options.rejectPendingReservations && (e.options.rejectPendingReservations = m.FlexModule.state.config.rejectPendingReservations), e;
        }, e.updateWorkerSetWorkerActivityPayload = function (e) {
          if (e.activityName && !e.activitySid) {
            var t = Array.from(m.FlexModule.state.worker.activities).find(function (t) {
              t[0];
              return t[1].name === e.activityName;
            });
            e.activitySid = t && t[0];
          }
          return e.activitySid && (e.activityName = m.FlexModule.state.worker.activities.get(e.activitySid).name, e.activityAvailable = m.FlexModule.state.worker.activities.get(e.activitySid).available), e.options || (e.options = {}), void 0 === e.options.rejectPendingReservations && (e.options.rejectPendingReservations = m.FlexModule.state.config.rejectPendingReservations), e;
        }, e.logout = function (e) {
          return p.clearStoredConfig(), b.Actions.logout(e).catch(function (e) {
            if (h.isFlexError(e)) {
              var t = e.content.wrappedError,
                n = t && t.response && t.response.statusText;
              n && n.match(/Worker WK.* cannot have its activity updated while it has .* pending reservations/) && y.Notifications.showNotification(y.NotificationIds.PendingReservationsOnLogout);
            }
            throw e;
          });
        }, e;
      }();
    t.WorkerActions = P;
    t.isValidTaskPayload = function (e) {
      return function (t) {
        return e && t && t.task && t.task.sid === e.sid;
      };
    };
    t.isValidWorkerActionPayload = function (e) {
      return t.isValidTaskPayload(e);
    };
    t.isValidWorkerParticipantActionPayload = function (e, n) {
      return function (r) {
        return t.isValidWorkerActionPayload(e)(r) && n === r.targetSid;
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isValidVoiceActionPayload = t.VoiceActions = void 0;
    var a = n(0),
      s = n(11),
      l = n(12),
      c = n(7),
      u = n(3),
      p = n(10),
      d = n(72),
      f = n(399),
      h = n(126),
      m = n(23),
      g = n(8),
      y = n(85),
      v = n(76),
      b = function () {
        function e() {}
        return e.registerActions = function () {
          a.Actions.registerAction("ToggleMute", e.toggleMute), a.Actions.registerAction("HangupCall", e.hangupCall, this.updateVoiceActionPayload), a.Actions.registerAction("EndConferenceForAll", e.endConferenceForAll, this.updateVoiceActionPayload), a.Actions.registerAction("HoldCall", e.holdCall, this.updateVoiceActionPayload), a.Actions.registerAction("UnholdCall", e.unholdCall, this.updateVoiceActionPayload), a.Actions.registerAction("StartExternalWarmTransfer", e.startExternalWarmTransfer, this.updateVoiceActionPayload);
        }, e.toggleMute = function () {
          return o(this, void 0, Promise, function () {
            var e;
            return i(this, function (t) {
              if (!u.FlexModule.state.phone.connection) throw c.ErrorManager.createAndProcessError(y.ActionErrors.CANT_MUTE_WITH_NO_LIVE_CONNECTIONS, {
                type: c.FlexErrorType.app,
                context: "VoiceActions"
              });
              return (e = u.FlexModule.state.phone.connection.source).mute(!e.isMuted()), [2];
            });
          });
        }, e.holdCall = function (e) {
          return void 0 === e && (e = {}), o(this, void 0, Promise, function () {
            var t, n, r, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (t = e.task, !g.TaskHelper.canHold(t)) throw c.ErrorManager.createAndProcessError(y.ActionErrors.CANT_HOLD_CALL, {
                    type: c.FlexErrorType.app,
                    context: "VoiceActions"
                  });
                  g.TaskHelper.isRegularConferenceCall(t) || h.Actions.oldHoldConnection(), n = e.holdMusicUrl || u.FlexModule.state.config.holdMusicUrl, r = e.holdMusicMethod || u.FlexModule.state.config.holdMusicMethod, i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, t.hold(n, r)];
                case 2:
                  return [2, i.sent()];
                case 3:
                  throw o = i.sent(), c.ErrorManager.createAndProcessError(y.ActionErrors.ERROR_HOLDING_CALL, {
                    type: c.FlexErrorType.app,
                    context: "VoiceActions",
                    wrappedError: o,
                    description: "Error holding call: " + o.message
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, e.unholdCall = function (e) {
          return void 0 === e && (e = {}), o(this, void 0, Promise, function () {
            var t, n;
            return i(this, function (r) {
              switch (r.label) {
                case 0:
                  if (t = e.task, !g.TaskHelper.canHold(t)) throw c.ErrorManager.createAndProcessError(y.ActionErrors.CANT_UNHOLD_CALL, {
                    type: c.FlexErrorType.app,
                    context: "VoiceActions"
                  });
                  g.TaskHelper.isRegularConferenceCall(t) || h.Actions.oldUnHoldConnection(), r.label = 1;
                case 1:
                  return r.trys.push([1, 3,, 4]), [4, t.unhold()];
                case 2:
                  return [2, r.sent()];
                case 3:
                  throw n = r.sent(), c.ErrorManager.createAndProcessError(y.ActionErrors.ERROR_UNHOLDING_CALL, {
                    type: c.FlexErrorType.taskrouterSDK,
                    context: "VoiceActions",
                    wrappedError: n,
                    description: "Error unholding call: " + n.message
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, e.hangupCall = function (e) {
          var t, n;
          return void 0 === e && (e = {}), o(this, void 0, Promise, function () {
            var r, o, a, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (!e.task) throw c.ErrorManager.createAndProcessError(y.ActionErrors.NO_TASK_IN_PAYLOAD, {
                    type: c.FlexErrorType.app,
                    context: "VoiceActions"
                  });
                  if (!(r = m.StateHelper.getCurrentPhoneCallState())) throw c.ErrorManager.createAndProcessError(y.ActionErrors.NO_ACTIVE_CALL, {
                    type: c.FlexErrorType.app,
                    context: "VoiceActions"
                  });
                  return o = (null === (n = null === (t = null == e ? void 0 : e.task) || void 0 === t ? void 0 : t.conference) || void 0 === n ? void 0 : n.participants) || [], a = o.filter(function (e) {
                    return "worker" === e.participantType;
                  }).length, l = o.filter(function (e) {
                    return "customer" === e.participantType || "unknown" === e.participantType;
                  }).length, s.FeatureFlags.isEnabled(p.FeatureFlag.ExternalWarmTransfers) && a && l > 1 ? [4, Promise.all(o.filter(function (e) {
                    return e.participantSid;
                  }).map(function (t) {
                    return e.task.setEndConferenceOnExit(t.participantSid, !0);
                  }))] : [3, 2];
                case 1:
                  i.sent(), i.label = 2;
                case 2:
                  return s.FeatureFlags.isEnabled(p.FeatureFlag.ExternalWarmTransfers) && d.dispatch(d.clearPendingParticipants()), r.source.disconnect(), [2];
              }
            });
          });
        }, e.endConferenceForAll = function (e) {
          return void 0 === e && (e = {}), o(this, void 0, Promise, function () {
            return i(this, function (t) {
              if (!e.task) throw c.ErrorManager.createAndProcessError(y.ActionErrors.NO_TASK_IN_PAYLOAD, {
                type: c.FlexErrorType.app,
                context: "VoiceActions"
              });
              if (!m.StateHelper.getCurrentPhoneCallState()) throw c.ErrorManager.createAndProcessError(y.ActionErrors.NO_ACTIVE_CALL, {
                type: c.FlexErrorType.app,
                context: "VoiceActions"
              });
              return s.FeatureFlags.isEnabled(p.FeatureFlag.ExternalWarmTransfers) && d.dispatch(d.clearPendingParticipants()), [2, e.task.endConference()];
            });
          });
        }, e.startExternalWarmTransfer = function (e) {
          var t,
            n = e.phoneNumber,
            a = e.task,
            s = e.callerId;
          return o(this, void 0, Promise, function () {
            var e, o, c, u, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return i.trys.push([0, 3,, 4]), l.TelemetryManager.reportExternalWarmTransferStart(), [4, a.addVoiceParticipant(s, n, "external")];
                case 1:
                  return o = i.sent(), c = o.pendingParticipantResponse, u = o.waitForParticipantToSettle, e = c.sid, d.dispatch(d.addPendingParticipant(r(r({}, c), {
                    phoneNumber: n
                  }))), [4, u];
                case 2:
                  return i.sent(), [3, 4];
                case 3:
                  return p = i.sent(), d.dispatch(d.removeParticipant(e)), f.handleVOErrors(null === (t = null == p ? void 0 : p._errorData) || void 0 === t ? void 0 : t.error_data), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e.updateVoiceActionPayload = function (e) {
          return void 0 === e && (e = {}), e.task ? e.sid = e.task.sid : e.sid && (e.task = g.TaskHelper.getTaskByTaskSid(e.sid)), e;
        }, e;
      }();
    t.VoiceActions = b;
    t.isValidVoiceActionPayload = function (e) {
      return v.isValidTaskPayload(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createTheme = void 0;
    var o = n(0),
      i = n(84),
      a = r(r({}, o.BaseTheme.colors), i.commonColors);
    t.createTheme = function (e, t) {
      var n = o.createTheme(e, t),
        i = t ? e.darkTextColor : e.lightTextColor;
      return r(r({}, n), {
        colors: e,
        UserActivityControls: {
          Item: {
            color: i,
            lightHover: !1
          },
          Items: {
            background: e.base2
          },
          Divider: {
            background: e.base4
          }
        },
        LoginFormView: {
          Container: {
            backgroundColor: e.base2,
            borderColor: e.base4,
            color: i
          },
          LoginButton: {
            background: e.defaultButtonColor,
            lightHover: !0
          }
        },
        LoginView: {
          Container: {
            background: e.base2,
            color: i
          },
          LoginButton: {
            background: e.defaultButtonColor,
            color: e.lightTextColor
          },
          Logo: {
            color: e.base11
          }
        },
        RuntimeLoginView: {
          Container: {
            background: e.base2,
            color: i
          },
          LoginButton: {
            background: e.defaultButtonColor,
            lightHover: !0
          }
        },
        RootContainer: {},
        AgentDesktopView: {
          Panel1: {
            background: e.base2
          },
          Panel2: {
            background: e.base2
          },
          ContentSplitter: {
            background: e.base2,
            borderColor: e.base4,
            color: e.base10
          }
        },
        MainHeader: {
          Container: {
            background: t ? e.base9 : e.base3,
            color: e.lightTextColor,
            borderColor: e.base4
          },
          Button: {
            color: e.lightTextColor,
            lightHover: !0
          }
        },
        MainContainer: {},
        SideNav: {
          Container: {
            background: t ? e.base8 : e.base3,
            borderColor: e.base4
          },
          Button: {
            color: e.lightTextColor,
            background: t ? e.base8 : e.base3,
            lightHover: !0
          },
          Icon: {
            color: e.lightTextColor
          }
        },
        TaskDetailsPanel: {
          Container: {
            color: i
          },
          IconContainer: {
            color: e.lightTextColor,
            border: "1px solid " + e.base6
          },
          SecondLine: {
            color: e.base8
          }
        },
        IncomingTaskCanvas: {
          AcceptTaskButton: {
            color: e.acceptTextColor,
            background: e.acceptColor
          },
          RejectTaskButton: {
            color: e.declineTextColor,
            background: e.declineColor
          }
        },
        ConnectingOutboundCallCanvas: {
          CancelCallButton: {
            color: e.declineTextColor,
            background: e.declineColor
          }
        },
        TaskInfoPanel: {
          Container: {
            color: i
          }
        },
        CallCanvas: {
          Button: {
            background: e.base3,
            color: e.base11
          },
          HangUpButton: {
            background: e.declineColor,
            color: e.declineTextColor
          }
        },
        TaskCanvas: {
          Container: {
            background: e.base1
          }
        },
        TaskCanvasHeader: {
          Container: {
            background: e.base1,
            color: i
          },
          WrapupTaskButton: {
            background: e.declineColor,
            color: e.declineTextColor
          },
          EndTaskButton: {
            background: e.completeTaskColor,
            color: e.declineTextColor
          }
        },
        TaskList: {
          Filter: {
            Container: {
              background: e.base2,
              borderColor: e.base4
            },
            EntryButton: {
              color: i
            },
            Menu: {
              Item: {
                color: i,
                lightHover: !t
              },
              Items: {}
            }
          },
          Item: {
            Container: {
              color: i,
              borderColor: e.base4,
              background: e.base2,
              lightHover: !t
            },
            Icon: {
              color: e.lightTextColor
            },
            SelectedContainer: {
              background: e.base1,
              color: i,
              lightHover: !t
            },
            Buttons: {
              DefaultButton: {
                color: e.base11,
                background: e.base3,
                lightHover: !t
              },
              AcceptButton: {
                color: e.acceptTextColor,
                background: e.acceptColor
              },
              RejectButton: {
                color: e.declineTextColor,
                background: e.declineColor
              }
            }
          }
        },
        TaskCard: {
          Container: {
            Default: {
              borderColor: e.base4,
              lightHover: !t
            },
            Selected: {
              borderColor: e.base11
            },
            Hover: {
              borderColor: e.base11
            }
          },
          IconArea: {
            Default: {
              color: e.lightTextColor
            }
          },
          ContentArea: {
            Default: {
              color: i,
              backgroundColor: e.base1
            },
            Inactive: {
              color: i,
              backgroundColor: e.base2
            }
          }
        },
        TaskCardPlaceholder: {
          borderColor: e.base4
        },
        NoTasksCanvas: {
          Container: {
            color: i,
            background: e.base2
          },
          Hint: {
            color: e.base8
          }
        },
        CRMContainer: {
          Container: {
            borderColor: e.base4
          },
          Placeholder: {
            Container: {
              color: i,
              background: e.base1
            },
            Icon: {
              color: e.base11
            },
            Button: {
              background: e.defaultButtonColor,
              color: e.lightTextColor
            },
            Hint: {
              color: e.base8
            }
          }
        },
        Supervisor: {
          Container: {
            background: e.base1
          },
          TaskCanvas: {
            HeaderButton: {
              color: e.base11,
              lightHover: !t
            },
            Container: {
              borderColor: e.base4,
              background: e.base1
            },
            MonitorActiveButton: {
              background: e.flexBlueColor,
              color: e.lightTextColor
            },
            Button: {
              background: e.base3,
              color: e.base11
            },
            Header: {
              borderColor: e.base4,
              color: i
            }
          },
          WorkerCanvas: {
            Container: {
              borderColor: e.base4,
              color: i
            },
            Header: {
              color: i
            },
            SectionCaption: {
              borderColor: e.base4,
              color: i
            }
          },
          FilterButton: {
            borderColor: e.base4,
            color: i,
            lightHover: !0
          },
          Search: {
            Container: {
              color: i
            },
            Button: {
              background: e.defaultButtonColor,
              color: e.lightTextColor,
              lightHover: !1
            }
          }
        },
        WorkerDirectory: {
          Container: {
            boxShadow: "-2px 0 10px 0 rgba(0, 0, 0, 0.2)",
            background: e.base2,
            color: i
          },
          Header: {
            Button: {
              color: e.base11,
              background: e.base3,
              lightHover: !t
            },
            Container: {}
          },
          ItemsContainer: {
            borderColor: e.base4
          },
          Item: {
            borderColor: e.base4,
            background: e.base2,
            lightHover: !t
          },
          ItemActionButton: {
            color: e.base11,
            background: e.base3,
            lightHover: !t
          },
          QueueItem: {
            Avatar: {
              background: e.base3
            }
          }
        },
        WorkerSkills: {
          SaveButton: {
            background: e.flexBlueColor,
            color: e.lightTextColor
          },
          CancelButton: {
            background: e.disabledColor,
            color: e.darkTextColor
          },
          DeleteButton: {
            borderColor: e.base4,
            lightHover: !t
          }
        },
        LoadingView: {
          Container: {
            backgroundColor: e.base2,
            color: i
          }
        },
        ErrorPage: {
          Container: {
            backgroundColor: e.base2,
            color: i
          },
          Actions: {
            RetryButton: {
              background: e.defaultButtonColor,
              color: e.lightTextColor
            },
            DownloadReportButton: {
              background: e.base4
            }
          }
        },
        ParticipantsCanvas: {
          ParticipantCanvas: {
            Container: {
              color: i
            },
            Avatar: {
              background: e.flexBlueColor,
              color: e.lightTextColor,
              borderColor: e.base5
            },
            StateHover: {
              background: e.buttonHoverColor,
              color: e.lightTextColor
            },
            ConnectingAnimation: {
              color: e.lightTextColor
            },
            Button: {
              background: e.base3,
              color: e.base11
            },
            HangUpButton: {
              background: e.declineColor,
              color: e.declineTextColor
            }
          },
          Notification: {
            Container: {
              background: e.holdColor,
              color: t ? e.base1 : e.base11
            }
          }
        },
        QueueStats: {
          Container: {
            backgroundColor: e.base1,
            color: i
          },
          TableContainer: {},
          TilesGrid: {}
        },
        QueuesStats: {
          Container: {
            backgroundColor: e.base1,
            color: i
          },
          TableContainer: {},
          TilesGrid: {},
          QueuesDataTableCell: {}
        },
        ConversationView: {
          Container: {
            backgroundColor: e.base1,
            color: i
          },
          Button: {
            backgroundColor: e.base1,
            color: i
          },
          PrimaryButton: {
            borderColor: "#197BDD",
            backgroundColor: "#197BDD",
            color: "white"
          },
          PrimaryButtonHover: {
            borderColor: "#0567c9",
            backgroundColor: "#0567c9",
            color: "white"
          },
          Player: {
            Container: {
              backgroundColor: e.base1,
              color: i,
              borderColor: e.base2
            }
          },
          SegmentInfo: {
            Container: {
              backgroundColor: e.base1,
              color: i
            }
          },
          ConversationInfo: {
            Container: {
              backgroundColor: e.base1,
              color: i
            }
          },
          Questionnaire: {
            Answer: {
              borderColor: e.base3
            },
            AnswerHover: {
              backgroundColor: e.base3
            },
            AnswerSelected: {
              backgroundColor: e.base3
            }
          }
        },
        ToggleLoggingPanel: {
          IconButton: {},
          Panel: {
            backgroundColor: e.base2
          },
          Button: {
            backgroundImage: "linear-gradient(\n                    to top,\n                    " + e.defaultButtonColor + ",\n                    " + e.defaultButtonColor + "\n                )"
          }
        },
        ErrorUI: {
          Panel: {
            backgroundColor: e.base1,
            border: "1px solid " + e.base4
          },
          IconButton: {
            color: "currentColor"
          },
          NoErrorsIcon: {
            color: t ? e.base1 : e.base11,
            background: e.acceptColor
          },
          CloseButton: {
            lightHover: !t,
            backgroundColor: e.defaultButtonColor
          },
          DownloadButton: {
            lightHover: !1,
            color: t ? e.base1 : e.base11,
            backgroundColor: e.defaultButtonColor
          },
          ClearButton: {
            lightHover: !1,
            color: t ? e.base11 : e.base1,
            backgroundColor: "#dddddd"
          },
          ActionText: {
            color: t ? e.focusColor : e.lightTextColor
          },
          WarningIcon: {
            color: "#ee0c00"
          },
          ErrorContainer: {
            color: "#ee0c00"
          }
        },
        OutboundDialerPanel: {
          Container: {
            background: e.base1,
            borderColor: e.base4,
            color: i,
            disabled: {
              color: e.disabledColor
            }
          },
          Header: {
            background: e.base1,
            color: i
          },
          HeaderButton: {
            lightHover: !t
          }
        },
        TranscriptPlayer: {
          Sidepanel: {
            backgroundColor: e.base1
          }
        },
        Dashboards: {
          Sidebar: {
            Container: {
              background: e.base1,
              borderColor: e.base3
            },
            Divider: {
              borderColor: e.base3
            },
            ActionButton: {
              borderColor: e.base3
            },
            Item: {
              color: i
            },
            SelectedItem: {
              backgroundColor: e.base2,
              borderColor: e.focusColor
            }
          }
        }
      });
    };
    var s = {
      colors: a,
      lightTheme: !0
    };
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var _r11,
      o = this && this.__extends || (_r11 = function r(e, t) {
        return (_r11 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r11(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.TaskCanvasHeader = void 0;
    var s = n(1),
      l = n(0),
      c = n(26),
      u = n(530),
      p = n(535),
      d = n(2),
      f = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        var r;
        return o(n, e), r = n, n.prototype.render = function () {
          return s.createElement(t.Connected, i({}, this.props));
        }, n.displayName = "TaskCanvasHeader", n.Content = new l.DynamicContentStore(r.displayName), n.defaultProps = {
          content: r.Content,
          ActionsComponent: u.EndTaskButton,
          titleTemplateContext: {}
        }, n = r = a([l.withDefaultPropsUpdate], n);
      }(s.PureComponent);
    t.TaskCanvasHeader = f, t.Connected = d.withTheme(c.withTaskContext(p.TaskCanvasHeaderImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkProps = t.SideLink = void 0;
    var r = n(716);
    Object.defineProperty(t, "SideLink", {
      enumerable: !0,
      get: function get() {
        return r.SideLink;
      }
    });
    var o = n(719);
    Object.defineProperty(t, "SideLinkProps", {
      enumerable: !0,
      get: function get() {
        return o.SideLinkProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BUNDLE_TYPE = t.ThemeProps = t.Theme = t.ThemeDef = t.ThemeColorsDefinition = t.VERSION = t.Notifications = t.NotificationEvent = t.NotificationType = t.NotificationIds = t.ActionsImpl = t.Actions = t.TaskChannels = t.DefaultTaskChannels = t.flexStoreEnhancer = t.FlexState = t.FlexErrorType = t.FlexErrorContents = t.ErrorManager = t.FlexError = t.ChatOrchestratorEvent = t.ChatOrchestrator = t.Strings = t.languages = void 0, n(299).default(), o(n(86), t), o(n(19), t);
    var i = n(69);
    Object.defineProperty(t, "languages", {
      enumerable: !0,
      get: function get() {
        return i.languages;
      }
    }), Object.defineProperty(t, "Strings", {
      enumerable: !0,
      get: function get() {
        return i.Strings;
      }
    }), o(n(755), t), o(n(756), t);
    var a = n(92);
    Object.defineProperty(t, "ChatOrchestrator", {
      enumerable: !0,
      get: function get() {
        return a.ChatOrchestrator;
      }
    }), Object.defineProperty(t, "ChatOrchestratorEvent", {
      enumerable: !0,
      get: function get() {
        return a.ChatOrchestration;
      }
    }), o(n(185), t), o(n(186), t), o(n(23), t);
    var s = n(7);
    Object.defineProperty(t, "FlexError", {
      enumerable: !0,
      get: function get() {
        return s.FlexError;
      }
    }), Object.defineProperty(t, "ErrorManager", {
      enumerable: !0,
      get: function get() {
        return s.ErrorManager;
      }
    }), Object.defineProperty(t, "FlexErrorContents", {
      enumerable: !0,
      get: function get() {
        return s.FlexErrorContents;
      }
    }), Object.defineProperty(t, "FlexErrorType", {
      enumerable: !0,
      get: function get() {
        return s.FlexErrorType;
      }
    });
    var l = n(125);
    Object.defineProperty(t, "FlexState", {
      enumerable: !0,
      get: function get() {
        return l.FlexState;
      }
    }), Object.defineProperty(t, "flexStoreEnhancer", {
      enumerable: !0,
      get: function get() {
        return l.flexStoreEnhancer;
      }
    }), o(n(8), t), o(n(52), t), o(n(17), t);
    var c = n(20);
    Object.defineProperty(t, "DefaultTaskChannels", {
      enumerable: !0,
      get: function get() {
        return c.DefaultTaskChannels;
      }
    }), Object.defineProperty(t, "TaskChannels", {
      enumerable: !0,
      get: function get() {
        return c.TaskChannels;
      }
    });
    var u = n(758);
    Object.defineProperty(t, "Actions", {
      enumerable: !0,
      get: function get() {
        return u.ProxiedActions;
      }
    }), Object.defineProperty(t, "ActionsImpl", {
      enumerable: !0,
      get: function get() {
        return u.ProxiedActions;
      }
    });
    var p = n(759),
      d = n(16);
    p.registerActions(), d.registerToNotifications();
    var f = n(16);
    Object.defineProperty(t, "NotificationIds", {
      enumerable: !0,
      get: function get() {
        return f.NotificationIds;
      }
    }), Object.defineProperty(t, "NotificationType", {
      enumerable: !0,
      get: function get() {
        return f.NotificationType;
      }
    }), Object.defineProperty(t, "NotificationEvent", {
      enumerable: !0,
      get: function get() {
        return f.NotificationEvent;
      }
    }), Object.defineProperty(t, "Notifications", {
      enumerable: !0,
      get: function get() {
        return f.ProxiedNotifications;
      }
    });
    var h = n(46);
    Object.defineProperty(t, "VERSION", {
      enumerable: !0,
      get: function get() {
        return h.VERSION;
      }
    }), n(179), o(n(142), t);
    var m = n(142);
    Object.defineProperty(t, "ThemeColorsDefinition", {
      enumerable: !0,
      get: function get() {
        return m.ThemeColorsDefinition;
      }
    }), Object.defineProperty(t, "ThemeDef", {
      enumerable: !0,
      get: function get() {
        return m.ThemeDef;
      }
    });
    var g = n(86);
    Object.defineProperty(t, "Theme", {
      enumerable: !0,
      get: function get() {
        return g.Theme;
      }
    }), Object.defineProperty(t, "ThemeProps", {
      enumerable: !0,
      get: function get() {
        return g.ThemeProps;
      }
    }), o(n(763), t), o(n(770), t), t.BUNDLE_TYPE = "library", n(771).initialize();
  }, function (e, t) {
    e.exports = require("react-redux");
  }, function (e, t) {
    e.exports = require("lodash.debounce");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.defaultChannelColors = t.commonColors = void 0, t.commonColors = {
      holdColor: "#ea6c00",
      declineColor: "#d32f2f",
      acceptColor: "#07874a",
      declineTextColor: "#ffffff",
      acceptTextColor: "#ffffff",
      completeTaskColor: "#1976d2",
      flexBlueColor: "#1976D2",
      agentAvailableColor: "#62c158",
      agentBusyColor: "#f1a33e",
      agentUnavailableColor: "#dd392b",
      agentOfflineColor: "#606471"
    }, t.defaultChannelColors = {
      inactive: "#a0a8bd",
      call: "#1976D2",
      video: "#1976D2",
      chat: "#057D9E",
      sms: "#D81B60",
      facebook: "#4266B2",
      line: "#3ACE01",
      whatsapp: "#2BB826",
      custom: "#a0a8bd"
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionErrors = void 0, function (e) {
      e.RESERVATION_NOT_FOUND = "reservation for task not found", e.RESEREVATION_NOT_PENDING = "reservation is not in pending state", e.RESERVATION_IS_COMPLETED = "reservation is in completed state", e.RESERVATION_IS_NOT_ACCEPTED = "reservation is not in accepted state", e.CANT_TRANSFER_TASK = "cannot transfer task", e.NO_TASK_IN_PAYLOAD = "no task in payload", e.OUTBOUND_CALLING_DISABLED = "outbound calling disabled", e.VOICE_CONNECTION_ALREADY_LIVE = "voice connection already live", e.PENDING_INBOUND_CALL = "cannot do outbound calls with a pending inbound call", e.OUTBOUND_CALL_ALREADY_PENDING = "outbound call action already pending", e.CALL_TASK_ALREADY_EXISTS = "live call task already exists", e.NO_TRANSFER_TO_CANCEL = "there are no outgoing transfer to cancel", e.BROWSER_VOICE_DISABLED = "browser voice disabled", e.ERROR_HOLDING_CALL = "error holding call action", e.ERROR_UNHOLDING_CALL = "error unholding call action", e.CANT_ACCEPT_CALL = "could not accept call", e.NO_ACTIVE_CALL = "no active call", e.CANT_HOLD_CALL = "cannot hold call", e.CANT_UNHOLD_CALL = "cannot unhold call", e.CANT_CREATE_TASK = "task could not be created", e.CANT_MUTE_WITH_NO_LIVE_CONNECTIONS = "cannot call mute with no live connection", e.CANT_SET_ACTIVITY = "could not set activity", e.CANT_HOLD_PARTICIPANT = "cannot hold participant", e.CANT_UNHOLD_PARTICIPANT = "cannot unhold participant", e.CANT_TOGGLE_DTMF = "cannot toggle DTMF dialpad for non call task", e.CANT_SEND_DIGITS = "cannot send digits to a non live call", e.CANT_SET_DIGITS = "cannot set digits for non live call", e.CANT_OUTBOUND_WHEN_OFFLINE = "cannot do outbound calls when offline", e.CANT_FETCH_TOKEN = "could not fetch token", e.CANT_FETCH_NEW_TOKEN = "failed to fetch new token", e.TOKEN_UPDATE_FAILED = "failed to update token", e.HOSTED_FLEX_ERROR = "hosted flex error", e.QUEUE_MANAGEMENT_ERROR = "queue Management error", e.GENERIC_ERROR = "error", e.TEMPLATE_PARAM_MISSING = "one or more parameters missing to replace in template";
    }(t.ActionErrors || (t.ActionErrors = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Notification = t.NotificationIsApplicableFunction = t.NotificationClickFunction = t.NotificationOptions = t.NotificationContentProps = t.NotificationIds = t.DeepPartial = t.initialize = t.ActionStateListener = t.ActionState = t.ActionStateListenerState = t.ActionStateListenerProps = t.ChildrenCallback = t.MatchActionPayload = t.MatchActionPayloadPredicate = t.ActionName = t.ActionPayload = t.ActionsWithPayload = t.ActionWithPayload = t.PayloadUpdateFunction = t.ReplacedActionFunction = t.ActionCancelFunction = t.ActionFunction = t.Template = t.TemplateProps = t.templates = t.initWithStrings = t.CompiledTemplate = t.Utils = t.Version = t.StateMachine = t.StateMachineCb = t.resetCSS = t.registerGlobalStyles = t.registerStyles = t.CleanupFunction = t.ContentFragmentProps = t.ContentFragmentAlignment = t.RemoveComponentCall = t.RemoveComponentCallOptions = t.ContentFragmentConditionFunction = t.DynamicComponent = t.DynamicComponentProps = t.DefaultContentFragment = t.ContentFragment = t.DynamicContentStore = t.chatReducer = t.ChatStateCallback = t.ChatModule = t.ChatEventEmitter = void 0, t.SplitContentContainerProps = t.SplitContentContainer = t.ModalPopupWithEntryControlProps = t.ModalPopupWithEntryControl = t.ModalPopupProps = t.ModalPopup = t.LegendProps = t.Legend = t.MenuItemProps = t.MenuItem = t.StyledUl = t.MenuThemeProps = t.MenuProps = t.Menu = t.AvatarProps = t.Avatar = t.SvgContainerProps = t.IconProps = t.Icon = t.IconButtonProps = t.IconButton = t.FlexBoxColumn = t.FlexBoxProperties = t.FlexBox = t.ErrorMessage = t.DataTableColumnDefinition = t.ColumnDefinition = t.DataTableProps = t.DataTable = t.ButtonThemeProps = t.LinkProps = t.Link = t.StyledButtonProps = t.StyledButton = t.ButtonProps = t.Button = t.AggregatedDataTile = t.FrameConstants = t.ChatChannelHelper = t.withDefaultPropsUpdate = t.Notifications = t.NotificationManager = t.NotificationType = t.NotificationEvent = t.NotificationHandler = t.NotificationHandlerType = t.DefaultNotificationHandlerType = t.NotificationEventListener = t.NotificationFilterFunction = t.NotificationCancelFunction = void 0, t.CircularProgressThemeProps = t.UserCardProps = t.UserCardState = t.UserCard = t.NotificationBarItem = t.NotificationBar = t.CheckboxGroup = t.ThumbsUpOrDownItem = t.TextareaItem = t.SelectItem = t.RadioItem = t.InputItem = t.FormAttributes = t.DynamicForm = t.ConnectingAnimationProps = t.ConnectingAnimation = t.MessageCanvasTray = t.MessageList = t.InlineMessage = t.InlineDateSeparator = t.MessageBubble = t.MessageListItem = t.MessageInput = t.MessagingCanvasContext = t.MessagingCanvas = t.getBackgroundWithHoverCSS = t.ThemeSupport = t.CoreThemeColors = t.CoreThemeBaseplates = t.styled = t.StyledStatelessComponent = t.StyledOtherComponent = t.StyledComponentMethods = t.StyledComponent = t.CreateStyledStatelessComponent = t.CreateStyledOtherComponent = t.CreateStyled = t.Themed = t.StyledOptions = t.Interpolation = t.FunctionInterpolation = t.ArrayInterpolation = t.TabsProps = t.Tabs = t.TabProps = t.Tab = t.StackedBarChartProps = t.StackedBarChart = t.LastSplitterState = t.SplitContentContainerState = void 0, t.ColumnDataCreationContext = t.AgentsDataTable = t.WorkersDataTable = t.QueuesStats = t.Insights = t.Supervisor = t.ErrorCode = t.AudioPlayerError = t.MediaData = t.AudioPlayerManager = t.CountryManager = t.createTheme = t.FlexLight = t.FlexDark = t.GreyLight = t.GreyDark = t.BaseTheme = t.BlueDarkTheme = t.BlueMediumTheme = t.DarkTheme = t.MediumTheme = t.ChatConfig = t.ChatState = t.ChatSessionState = t.ChatChannelsState = t.ChatChannelState = t.Strings = t.languages = t.Animations = t.BadgeProps = t.BadgeChildrenProps = t.BadgeThemeProps = t.Badge = t.AriaProps = t.AriaLive = t.DialpadButtonThemeProps = t.DialpadProps = t.Dialpad = t.DialerThemeProps = t.DialerProps = t.Dialer = t.CSSProps = t.FiltersListItemType = t.FilterDefinition = t.FiltersListProps = t.FiltersList = t.SidePanelProps = t.SidePanel = t.CircularProgress = t.CircularProgressProps = void 0, t.ThemeProps = t.Theme = t.withTheme = t.PropsWithTheme = t.OutboundDialerPanel = t.LiveCommsBarItemActionsProps = t.LiveCommsBarItemActions = t.LiveCommsBarItemAction = t.LiveCommsBarItem = t.LiveCommsBarChildrenProps = t.LiveCommsBar = t.WorkerCanvas = t.WorkerSkills = t.WorkerProfile = t.WorkerDirectoryTabs = t.WorkerDirectory = t.ViewCollectionChildrenProps = t.ViewProps = t.View = t.ViewCollectionProps = t.ViewCollection = t.TaskListContainer = t.TaskListButtons = t.SideLinkProps = t.SideLink = t.SideNavChildrenProps = t.SideNavProps = t.SideNav = t.MuteButtonProps = t.MuteButton = t.MainContainerChildrenProps = t.MainContainerProps = t.MainContainer = t.CRMContainerProps = t.CRMContainer = t.RootContainerChildrenProps = t.RootContainer = t.TaskCardList = t.TaskCard = void 0;
    var i = n(320);
    t.Supervisor = i;
    var a = n(136);
    t.QueuesStats = a;
    var s = n(57);
    t.Insights = s;
    var l = n(0);
    Object.defineProperty(t, "ChatEventEmitter", {
      enumerable: !0,
      get: function get() {
        return l.ChatEventEmitter;
      }
    }), Object.defineProperty(t, "ChatModule", {
      enumerable: !0,
      get: function get() {
        return l.ChatModule;
      }
    }), Object.defineProperty(t, "ChatStateCallback", {
      enumerable: !0,
      get: function get() {
        return l.ChatStateCallback;
      }
    }), Object.defineProperty(t, "chatReducer", {
      enumerable: !0,
      get: function get() {
        return l.chatReducer;
      }
    }), Object.defineProperty(t, "DynamicContentStore", {
      enumerable: !0,
      get: function get() {
        return l.DynamicContentStore;
      }
    }), Object.defineProperty(t, "ContentFragment", {
      enumerable: !0,
      get: function get() {
        return l.ContentFragment;
      }
    }), Object.defineProperty(t, "DefaultContentFragment", {
      enumerable: !0,
      get: function get() {
        return l.DefaultContentFragment;
      }
    }), Object.defineProperty(t, "DynamicComponentProps", {
      enumerable: !0,
      get: function get() {
        return l.DynamicComponentProps;
      }
    }), Object.defineProperty(t, "DynamicComponent", {
      enumerable: !0,
      get: function get() {
        return l.DynamicComponent;
      }
    }), Object.defineProperty(t, "ContentFragmentConditionFunction", {
      enumerable: !0,
      get: function get() {
        return l.ContentFragmentConditionFunction;
      }
    }), Object.defineProperty(t, "RemoveComponentCallOptions", {
      enumerable: !0,
      get: function get() {
        return l.RemoveComponentCallOptions;
      }
    }), Object.defineProperty(t, "RemoveComponentCall", {
      enumerable: !0,
      get: function get() {
        return l.RemoveComponentCall;
      }
    }), Object.defineProperty(t, "ContentFragmentAlignment", {
      enumerable: !0,
      get: function get() {
        return l.ContentFragmentAlignment;
      }
    }), Object.defineProperty(t, "ContentFragmentProps", {
      enumerable: !0,
      get: function get() {
        return l.ContentFragmentProps;
      }
    }), Object.defineProperty(t, "CleanupFunction", {
      enumerable: !0,
      get: function get() {
        return l.CleanupFunction;
      }
    }), Object.defineProperty(t, "registerStyles", {
      enumerable: !0,
      get: function get() {
        return l.registerStyles;
      }
    }), Object.defineProperty(t, "registerGlobalStyles", {
      enumerable: !0,
      get: function get() {
        return l.registerGlobalStyles;
      }
    }), Object.defineProperty(t, "resetCSS", {
      enumerable: !0,
      get: function get() {
        return l.resetCSS;
      }
    }), Object.defineProperty(t, "StateMachineCb", {
      enumerable: !0,
      get: function get() {
        return l.StateMachineCb;
      }
    }), Object.defineProperty(t, "StateMachine", {
      enumerable: !0,
      get: function get() {
        return l.StateMachine;
      }
    }), Object.defineProperty(t, "Version", {
      enumerable: !0,
      get: function get() {
        return l.Version;
      }
    }), Object.defineProperty(t, "Utils", {
      enumerable: !0,
      get: function get() {
        return l.Utils;
      }
    }), Object.defineProperty(t, "CompiledTemplate", {
      enumerable: !0,
      get: function get() {
        return l.CompiledTemplate;
      }
    }), Object.defineProperty(t, "initWithStrings", {
      enumerable: !0,
      get: function get() {
        return l.initWithStrings;
      }
    }), Object.defineProperty(t, "templates", {
      enumerable: !0,
      get: function get() {
        return l.templates;
      }
    }), Object.defineProperty(t, "TemplateProps", {
      enumerable: !0,
      get: function get() {
        return l.TemplateProps;
      }
    }), Object.defineProperty(t, "Template", {
      enumerable: !0,
      get: function get() {
        return l.Template;
      }
    }), Object.defineProperty(t, "ActionFunction", {
      enumerable: !0,
      get: function get() {
        return l.ActionFunction;
      }
    }), Object.defineProperty(t, "ActionCancelFunction", {
      enumerable: !0,
      get: function get() {
        return l.ActionCancelFunction;
      }
    }), Object.defineProperty(t, "ReplacedActionFunction", {
      enumerable: !0,
      get: function get() {
        return l.ReplacedActionFunction;
      }
    }), Object.defineProperty(t, "PayloadUpdateFunction", {
      enumerable: !0,
      get: function get() {
        return l.PayloadUpdateFunction;
      }
    }), Object.defineProperty(t, "ActionWithPayload", {
      enumerable: !0,
      get: function get() {
        return l.ActionWithPayload;
      }
    }), Object.defineProperty(t, "ActionsWithPayload", {
      enumerable: !0,
      get: function get() {
        return l.ActionsWithPayload;
      }
    }), Object.defineProperty(t, "ActionPayload", {
      enumerable: !0,
      get: function get() {
        return l.ActionPayload;
      }
    }), Object.defineProperty(t, "ActionName", {
      enumerable: !0,
      get: function get() {
        return l.ActionName;
      }
    }), Object.defineProperty(t, "MatchActionPayloadPredicate", {
      enumerable: !0,
      get: function get() {
        return l.MatchActionPayloadPredicate;
      }
    }), Object.defineProperty(t, "MatchActionPayload", {
      enumerable: !0,
      get: function get() {
        return l.MatchActionPayload;
      }
    }), Object.defineProperty(t, "ChildrenCallback", {
      enumerable: !0,
      get: function get() {
        return l.ChildrenCallback;
      }
    }), Object.defineProperty(t, "ActionStateListenerProps", {
      enumerable: !0,
      get: function get() {
        return l.ActionStateListenerProps;
      }
    }), Object.defineProperty(t, "ActionStateListenerState", {
      enumerable: !0,
      get: function get() {
        return l.ActionStateListenerState;
      }
    }), Object.defineProperty(t, "ActionState", {
      enumerable: !0,
      get: function get() {
        return l.ActionState;
      }
    }), Object.defineProperty(t, "ActionStateListener", {
      enumerable: !0,
      get: function get() {
        return l.ActionStateListener;
      }
    }), Object.defineProperty(t, "initialize", {
      enumerable: !0,
      get: function get() {
        return l.initialize;
      }
    }), Object.defineProperty(t, "DeepPartial", {
      enumerable: !0,
      get: function get() {
        return l.DeepPartial;
      }
    }), Object.defineProperty(t, "NotificationIds", {
      enumerable: !0,
      get: function get() {
        return l.NotificationIds;
      }
    }), Object.defineProperty(t, "NotificationContentProps", {
      enumerable: !0,
      get: function get() {
        return l.NotificationContentProps;
      }
    }), Object.defineProperty(t, "NotificationOptions", {
      enumerable: !0,
      get: function get() {
        return l.NotificationOptions;
      }
    }), Object.defineProperty(t, "NotificationClickFunction", {
      enumerable: !0,
      get: function get() {
        return l.NotificationClickFunction;
      }
    }), Object.defineProperty(t, "NotificationIsApplicableFunction", {
      enumerable: !0,
      get: function get() {
        return l.NotificationIsApplicableFunction;
      }
    }), Object.defineProperty(t, "Notification", {
      enumerable: !0,
      get: function get() {
        return l.Notification;
      }
    }), Object.defineProperty(t, "NotificationCancelFunction", {
      enumerable: !0,
      get: function get() {
        return l.NotificationCancelFunction;
      }
    }), Object.defineProperty(t, "NotificationFilterFunction", {
      enumerable: !0,
      get: function get() {
        return l.NotificationFilterFunction;
      }
    }), Object.defineProperty(t, "NotificationEventListener", {
      enumerable: !0,
      get: function get() {
        return l.NotificationEventListener;
      }
    }), Object.defineProperty(t, "DefaultNotificationHandlerType", {
      enumerable: !0,
      get: function get() {
        return l.DefaultNotificationHandlerType;
      }
    }), Object.defineProperty(t, "NotificationHandlerType", {
      enumerable: !0,
      get: function get() {
        return l.NotificationHandlerType;
      }
    }), Object.defineProperty(t, "NotificationHandler", {
      enumerable: !0,
      get: function get() {
        return l.NotificationHandler;
      }
    }), Object.defineProperty(t, "NotificationEvent", {
      enumerable: !0,
      get: function get() {
        return l.NotificationEvent;
      }
    }), Object.defineProperty(t, "NotificationType", {
      enumerable: !0,
      get: function get() {
        return l.NotificationType;
      }
    }), Object.defineProperty(t, "NotificationManager", {
      enumerable: !0,
      get: function get() {
        return l.NotificationManager;
      }
    }), Object.defineProperty(t, "Notifications", {
      enumerable: !0,
      get: function get() {
        return l.Notifications;
      }
    }), Object.defineProperty(t, "withDefaultPropsUpdate", {
      enumerable: !0,
      get: function get() {
        return l.withDefaultPropsUpdate;
      }
    }), Object.defineProperty(t, "ChatChannelHelper", {
      enumerable: !0,
      get: function get() {
        return l.ChatChannelHelper;
      }
    }), Object.defineProperty(t, "FrameConstants", {
      enumerable: !0,
      get: function get() {
        return l.FrameConstants;
      }
    }), Object.defineProperty(t, "AggregatedDataTile", {
      enumerable: !0,
      get: function get() {
        return l.AggregatedDataTile;
      }
    }), Object.defineProperty(t, "Button", {
      enumerable: !0,
      get: function get() {
        return l.Button;
      }
    }), Object.defineProperty(t, "ButtonProps", {
      enumerable: !0,
      get: function get() {
        return l.ButtonProps;
      }
    }), Object.defineProperty(t, "StyledButton", {
      enumerable: !0,
      get: function get() {
        return l.StyledButton;
      }
    }), Object.defineProperty(t, "StyledButtonProps", {
      enumerable: !0,
      get: function get() {
        return l.StyledButtonProps;
      }
    }), Object.defineProperty(t, "Link", {
      enumerable: !0,
      get: function get() {
        return l.Link;
      }
    }), Object.defineProperty(t, "LinkProps", {
      enumerable: !0,
      get: function get() {
        return l.LinkProps;
      }
    }), Object.defineProperty(t, "ButtonThemeProps", {
      enumerable: !0,
      get: function get() {
        return l.ButtonThemeProps;
      }
    }), Object.defineProperty(t, "DataTable", {
      enumerable: !0,
      get: function get() {
        return l.DataTable;
      }
    }), Object.defineProperty(t, "DataTableProps", {
      enumerable: !0,
      get: function get() {
        return l.DataTableProps;
      }
    }), Object.defineProperty(t, "ColumnDefinition", {
      enumerable: !0,
      get: function get() {
        return l.ColumnDefinition;
      }
    }), Object.defineProperty(t, "DataTableColumnDefinition", {
      enumerable: !0,
      get: function get() {
        return l.DataTableColumnDefinition;
      }
    }), Object.defineProperty(t, "ErrorMessage", {
      enumerable: !0,
      get: function get() {
        return l.ErrorMessage;
      }
    }), Object.defineProperty(t, "FlexBox", {
      enumerable: !0,
      get: function get() {
        return l.FlexBox;
      }
    }), Object.defineProperty(t, "FlexBoxProperties", {
      enumerable: !0,
      get: function get() {
        return l.FlexBoxProperties;
      }
    }), Object.defineProperty(t, "FlexBoxColumn", {
      enumerable: !0,
      get: function get() {
        return l.FlexBoxColumn;
      }
    }), Object.defineProperty(t, "IconButton", {
      enumerable: !0,
      get: function get() {
        return l.IconButton;
      }
    }), Object.defineProperty(t, "IconButtonProps", {
      enumerable: !0,
      get: function get() {
        return l.IconButtonProps;
      }
    }), Object.defineProperty(t, "Icon", {
      enumerable: !0,
      get: function get() {
        return l.Icon;
      }
    }), Object.defineProperty(t, "IconProps", {
      enumerable: !0,
      get: function get() {
        return l.IconProps;
      }
    }), Object.defineProperty(t, "SvgContainerProps", {
      enumerable: !0,
      get: function get() {
        return l.SvgContainerProps;
      }
    }), Object.defineProperty(t, "Avatar", {
      enumerable: !0,
      get: function get() {
        return l.Avatar;
      }
    }), Object.defineProperty(t, "AvatarProps", {
      enumerable: !0,
      get: function get() {
        return l.AvatarProps;
      }
    }), Object.defineProperty(t, "Menu", {
      enumerable: !0,
      get: function get() {
        return l.Menu;
      }
    }), Object.defineProperty(t, "MenuProps", {
      enumerable: !0,
      get: function get() {
        return l.MenuProps;
      }
    }), Object.defineProperty(t, "MenuThemeProps", {
      enumerable: !0,
      get: function get() {
        return l.MenuThemeProps;
      }
    }), Object.defineProperty(t, "StyledUl", {
      enumerable: !0,
      get: function get() {
        return l.StyledUl;
      }
    }), Object.defineProperty(t, "MenuItem", {
      enumerable: !0,
      get: function get() {
        return l.MenuItem;
      }
    }), Object.defineProperty(t, "MenuItemProps", {
      enumerable: !0,
      get: function get() {
        return l.MenuItemProps;
      }
    }), Object.defineProperty(t, "Legend", {
      enumerable: !0,
      get: function get() {
        return l.Legend;
      }
    }), Object.defineProperty(t, "LegendProps", {
      enumerable: !0,
      get: function get() {
        return l.LegendProps;
      }
    }), Object.defineProperty(t, "ModalPopup", {
      enumerable: !0,
      get: function get() {
        return l.ModalPopup;
      }
    }), Object.defineProperty(t, "ModalPopupProps", {
      enumerable: !0,
      get: function get() {
        return l.ModalPopupProps;
      }
    }), Object.defineProperty(t, "ModalPopupWithEntryControl", {
      enumerable: !0,
      get: function get() {
        return l.ModalPopupWithEntryControl;
      }
    }), Object.defineProperty(t, "ModalPopupWithEntryControlProps", {
      enumerable: !0,
      get: function get() {
        return l.ModalPopupWithEntryControlProps;
      }
    }), Object.defineProperty(t, "SplitContentContainer", {
      enumerable: !0,
      get: function get() {
        return l.SplitContentContainer;
      }
    }), Object.defineProperty(t, "SplitContentContainerProps", {
      enumerable: !0,
      get: function get() {
        return l.SplitContentContainerProps;
      }
    }), Object.defineProperty(t, "SplitContentContainerState", {
      enumerable: !0,
      get: function get() {
        return l.SplitContentContainerState;
      }
    }), Object.defineProperty(t, "LastSplitterState", {
      enumerable: !0,
      get: function get() {
        return l.LastSplitterState;
      }
    }), Object.defineProperty(t, "StackedBarChart", {
      enumerable: !0,
      get: function get() {
        return l.StackedBarChart;
      }
    }), Object.defineProperty(t, "StackedBarChartProps", {
      enumerable: !0,
      get: function get() {
        return l.StackedBarChartProps;
      }
    }), Object.defineProperty(t, "Tab", {
      enumerable: !0,
      get: function get() {
        return l.Tab;
      }
    }), Object.defineProperty(t, "TabProps", {
      enumerable: !0,
      get: function get() {
        return l.TabProps;
      }
    }), Object.defineProperty(t, "Tabs", {
      enumerable: !0,
      get: function get() {
        return l.Tabs;
      }
    }), Object.defineProperty(t, "TabsProps", {
      enumerable: !0,
      get: function get() {
        return l.TabsProps;
      }
    }), Object.defineProperty(t, "ArrayInterpolation", {
      enumerable: !0,
      get: function get() {
        return l.ArrayInterpolation;
      }
    }), Object.defineProperty(t, "FunctionInterpolation", {
      enumerable: !0,
      get: function get() {
        return l.FunctionInterpolation;
      }
    }), Object.defineProperty(t, "Interpolation", {
      enumerable: !0,
      get: function get() {
        return l.Interpolation;
      }
    }), Object.defineProperty(t, "StyledOptions", {
      enumerable: !0,
      get: function get() {
        return l.StyledOptions;
      }
    }), Object.defineProperty(t, "Themed", {
      enumerable: !0,
      get: function get() {
        return l.Themed;
      }
    }), Object.defineProperty(t, "CreateStyled", {
      enumerable: !0,
      get: function get() {
        return l.CreateStyled;
      }
    }), Object.defineProperty(t, "CreateStyledOtherComponent", {
      enumerable: !0,
      get: function get() {
        return l.CreateStyledOtherComponent;
      }
    }), Object.defineProperty(t, "CreateStyledStatelessComponent", {
      enumerable: !0,
      get: function get() {
        return l.CreateStyledStatelessComponent;
      }
    }), Object.defineProperty(t, "StyledComponent", {
      enumerable: !0,
      get: function get() {
        return l.StyledComponent;
      }
    }), Object.defineProperty(t, "StyledComponentMethods", {
      enumerable: !0,
      get: function get() {
        return l.StyledComponentMethods;
      }
    }), Object.defineProperty(t, "StyledOtherComponent", {
      enumerable: !0,
      get: function get() {
        return l.StyledOtherComponent;
      }
    }), Object.defineProperty(t, "StyledStatelessComponent", {
      enumerable: !0,
      get: function get() {
        return l.StyledStatelessComponent;
      }
    }), Object.defineProperty(t, "styled", {
      enumerable: !0,
      get: function get() {
        return l.styled;
      }
    }), Object.defineProperty(t, "CoreThemeBaseplates", {
      enumerable: !0,
      get: function get() {
        return l.CoreThemeBaseplates;
      }
    }), Object.defineProperty(t, "CoreThemeColors", {
      enumerable: !0,
      get: function get() {
        return l.CoreThemeColors;
      }
    }), Object.defineProperty(t, "ThemeSupport", {
      enumerable: !0,
      get: function get() {
        return l.ThemeSupport;
      }
    }), Object.defineProperty(t, "getBackgroundWithHoverCSS", {
      enumerable: !0,
      get: function get() {
        return l.getBackgroundWithHoverCSS;
      }
    }), Object.defineProperty(t, "MessagingCanvas", {
      enumerable: !0,
      get: function get() {
        return l.MessagingCanvas;
      }
    }), Object.defineProperty(t, "MessagingCanvasContext", {
      enumerable: !0,
      get: function get() {
        return l.MessagingCanvasContext;
      }
    }), Object.defineProperty(t, "MessageInput", {
      enumerable: !0,
      get: function get() {
        return l.MessageInput;
      }
    }), Object.defineProperty(t, "MessageListItem", {
      enumerable: !0,
      get: function get() {
        return l.MessageListItem;
      }
    }), Object.defineProperty(t, "MessageBubble", {
      enumerable: !0,
      get: function get() {
        return l.MessageBubble;
      }
    }), Object.defineProperty(t, "InlineDateSeparator", {
      enumerable: !0,
      get: function get() {
        return l.InlineDateSeparator;
      }
    }), Object.defineProperty(t, "InlineMessage", {
      enumerable: !0,
      get: function get() {
        return l.InlineMessage;
      }
    }), Object.defineProperty(t, "MessageList", {
      enumerable: !0,
      get: function get() {
        return l.MessageList;
      }
    }), Object.defineProperty(t, "MessageCanvasTray", {
      enumerable: !0,
      get: function get() {
        return l.MessageCanvasTray;
      }
    }), Object.defineProperty(t, "ConnectingAnimation", {
      enumerable: !0,
      get: function get() {
        return l.ConnectingAnimation;
      }
    }), Object.defineProperty(t, "ConnectingAnimationProps", {
      enumerable: !0,
      get: function get() {
        return l.ConnectingAnimationProps;
      }
    }), Object.defineProperty(t, "DynamicForm", {
      enumerable: !0,
      get: function get() {
        return l.DynamicForm;
      }
    }), Object.defineProperty(t, "FormAttributes", {
      enumerable: !0,
      get: function get() {
        return l.FormAttributes;
      }
    }), Object.defineProperty(t, "InputItem", {
      enumerable: !0,
      get: function get() {
        return l.InputItem;
      }
    }), Object.defineProperty(t, "RadioItem", {
      enumerable: !0,
      get: function get() {
        return l.RadioItem;
      }
    }), Object.defineProperty(t, "SelectItem", {
      enumerable: !0,
      get: function get() {
        return l.SelectItem;
      }
    }), Object.defineProperty(t, "TextareaItem", {
      enumerable: !0,
      get: function get() {
        return l.TextareaItem;
      }
    }), Object.defineProperty(t, "ThumbsUpOrDownItem", {
      enumerable: !0,
      get: function get() {
        return l.ThumbsUpOrDownItem;
      }
    }), Object.defineProperty(t, "CheckboxGroup", {
      enumerable: !0,
      get: function get() {
        return l.CheckboxGroup;
      }
    }), Object.defineProperty(t, "NotificationBar", {
      enumerable: !0,
      get: function get() {
        return l.NotificationBar;
      }
    }), Object.defineProperty(t, "NotificationBarItem", {
      enumerable: !0,
      get: function get() {
        return l.NotificationBarItem;
      }
    }), Object.defineProperty(t, "UserCard", {
      enumerable: !0,
      get: function get() {
        return l.UserCard;
      }
    }), Object.defineProperty(t, "UserCardState", {
      enumerable: !0,
      get: function get() {
        return l.UserCardState;
      }
    }), Object.defineProperty(t, "UserCardProps", {
      enumerable: !0,
      get: function get() {
        return l.UserCardProps;
      }
    }), Object.defineProperty(t, "CircularProgressThemeProps", {
      enumerable: !0,
      get: function get() {
        return l.CircularProgressThemeProps;
      }
    }), Object.defineProperty(t, "CircularProgressProps", {
      enumerable: !0,
      get: function get() {
        return l.CircularProgressProps;
      }
    }), Object.defineProperty(t, "CircularProgress", {
      enumerable: !0,
      get: function get() {
        return l.CircularProgress;
      }
    }), Object.defineProperty(t, "SidePanel", {
      enumerable: !0,
      get: function get() {
        return l.SidePanel;
      }
    }), Object.defineProperty(t, "SidePanelProps", {
      enumerable: !0,
      get: function get() {
        return l.SidePanelProps;
      }
    }), Object.defineProperty(t, "FiltersList", {
      enumerable: !0,
      get: function get() {
        return l.FiltersList;
      }
    }), Object.defineProperty(t, "FiltersListProps", {
      enumerable: !0,
      get: function get() {
        return l.FiltersListProps;
      }
    }), Object.defineProperty(t, "FilterDefinition", {
      enumerable: !0,
      get: function get() {
        return l.FilterDefinition;
      }
    }), Object.defineProperty(t, "FiltersListItemType", {
      enumerable: !0,
      get: function get() {
        return l.FiltersListItemType;
      }
    }), Object.defineProperty(t, "CSSProps", {
      enumerable: !0,
      get: function get() {
        return l.CSSProps;
      }
    }), Object.defineProperty(t, "Dialer", {
      enumerable: !0,
      get: function get() {
        return l.Dialer;
      }
    }), Object.defineProperty(t, "DialerProps", {
      enumerable: !0,
      get: function get() {
        return l.DialerProps;
      }
    }), Object.defineProperty(t, "DialerThemeProps", {
      enumerable: !0,
      get: function get() {
        return l.DialerThemeProps;
      }
    }), Object.defineProperty(t, "Dialpad", {
      enumerable: !0,
      get: function get() {
        return l.Dialpad;
      }
    }), Object.defineProperty(t, "DialpadProps", {
      enumerable: !0,
      get: function get() {
        return l.DialpadProps;
      }
    }), Object.defineProperty(t, "DialpadButtonThemeProps", {
      enumerable: !0,
      get: function get() {
        return l.DialpadButtonThemeProps;
      }
    }), Object.defineProperty(t, "AriaLive", {
      enumerable: !0,
      get: function get() {
        return l.AriaLive;
      }
    }), Object.defineProperty(t, "AriaProps", {
      enumerable: !0,
      get: function get() {
        return l.AriaProps;
      }
    }), Object.defineProperty(t, "Badge", {
      enumerable: !0,
      get: function get() {
        return l.Badge;
      }
    }), Object.defineProperty(t, "BadgeThemeProps", {
      enumerable: !0,
      get: function get() {
        return l.BadgeThemeProps;
      }
    }), Object.defineProperty(t, "BadgeChildrenProps", {
      enumerable: !0,
      get: function get() {
        return l.BadgeChildrenProps;
      }
    }), Object.defineProperty(t, "BadgeProps", {
      enumerable: !0,
      get: function get() {
        return l.BadgeProps;
      }
    }), Object.defineProperty(t, "Animations", {
      enumerable: !0,
      get: function get() {
        return l.Animations;
      }
    }), Object.defineProperty(t, "languages", {
      enumerable: !0,
      get: function get() {
        return l.languages;
      }
    }), Object.defineProperty(t, "Strings", {
      enumerable: !0,
      get: function get() {
        return l.Strings;
      }
    }), Object.defineProperty(t, "ChatChannelState", {
      enumerable: !0,
      get: function get() {
        return l.ChatChannelState;
      }
    }), Object.defineProperty(t, "ChatChannelsState", {
      enumerable: !0,
      get: function get() {
        return l.ChatChannelsState;
      }
    }), Object.defineProperty(t, "ChatSessionState", {
      enumerable: !0,
      get: function get() {
        return l.ChatSessionState;
      }
    }), Object.defineProperty(t, "ChatState", {
      enumerable: !0,
      get: function get() {
        return l.ChatState;
      }
    }), Object.defineProperty(t, "ChatConfig", {
      enumerable: !0,
      get: function get() {
        return l.ChatConfig;
      }
    }), Object.defineProperty(t, "MediumTheme", {
      enumerable: !0,
      get: function get() {
        return l.MediumTheme;
      }
    }), Object.defineProperty(t, "DarkTheme", {
      enumerable: !0,
      get: function get() {
        return l.DarkTheme;
      }
    }), Object.defineProperty(t, "BlueMediumTheme", {
      enumerable: !0,
      get: function get() {
        return l.BlueMediumTheme;
      }
    }), Object.defineProperty(t, "BlueDarkTheme", {
      enumerable: !0,
      get: function get() {
        return l.BlueDarkTheme;
      }
    }), Object.defineProperty(t, "BaseTheme", {
      enumerable: !0,
      get: function get() {
        return l.BaseTheme;
      }
    }), Object.defineProperty(t, "GreyDark", {
      enumerable: !0,
      get: function get() {
        return l.GreyDark;
      }
    }), Object.defineProperty(t, "GreyLight", {
      enumerable: !0,
      get: function get() {
        return l.GreyLight;
      }
    }), Object.defineProperty(t, "FlexDark", {
      enumerable: !0,
      get: function get() {
        return l.FlexDark;
      }
    }), Object.defineProperty(t, "FlexLight", {
      enumerable: !0,
      get: function get() {
        return l.FlexLight;
      }
    }), Object.defineProperty(t, "createTheme", {
      enumerable: !0,
      get: function get() {
        return l.createTheme;
      }
    }), Object.defineProperty(t, "CountryManager", {
      enumerable: !0,
      get: function get() {
        return l.CountryManager;
      }
    }), Object.defineProperty(t, "AudioPlayerManager", {
      enumerable: !0,
      get: function get() {
        return l.AudioPlayerManager;
      }
    }), Object.defineProperty(t, "MediaData", {
      enumerable: !0,
      get: function get() {
        return l.MediaData;
      }
    }), Object.defineProperty(t, "AudioPlayerError", {
      enumerable: !0,
      get: function get() {
        return l.AudioPlayerError;
      }
    }), Object.defineProperty(t, "ErrorCode", {
      enumerable: !0,
      get: function get() {
        return l.ErrorCode;
      }
    }), o(n(15), t), o(n(525), t), o(n(242), t), o(n(245), t), o(n(575), t);
    var c = n(154);
    Object.defineProperty(t, "WorkersDataTable", {
      enumerable: !0,
      get: function get() {
        return c.WorkersDataTable;
      }
    }), Object.defineProperty(t, "AgentsDataTable", {
      enumerable: !0,
      get: function get() {
        return c.WorkersDataTable;
      }
    }), Object.defineProperty(t, "ColumnDataCreationContext", {
      enumerable: !0,
      get: function get() {
        return c.ColumnDataCreationContext;
      }
    });
    var u = n(277);
    Object.defineProperty(t, "TaskCard", {
      enumerable: !0,
      get: function get() {
        return u.TaskCard;
      }
    });
    var p = n(277);
    Object.defineProperty(t, "TaskCardList", {
      enumerable: !0,
      get: function get() {
        return p.TaskCardList;
      }
    });
    var d = n(278);
    Object.defineProperty(t, "RootContainer", {
      enumerable: !0,
      get: function get() {
        return d.RootContainer;
      }
    }), Object.defineProperty(t, "RootContainerChildrenProps", {
      enumerable: !0,
      get: function get() {
        return d.RootContainerChildrenProps;
      }
    });
    var f = n(259);
    Object.defineProperty(t, "CRMContainer", {
      enumerable: !0,
      get: function get() {
        return f.CRMContainer;
      }
    }), Object.defineProperty(t, "CRMContainerProps", {
      enumerable: !0,
      get: function get() {
        return f.CRMContainerProps;
      }
    });
    var h = n(279);
    Object.defineProperty(t, "MainContainer", {
      enumerable: !0,
      get: function get() {
        return h.MainContainer;
      }
    });
    var m = n(294);
    Object.defineProperty(t, "MainContainerProps", {
      enumerable: !0,
      get: function get() {
        return m.MainContainerProps;
      }
    }), Object.defineProperty(t, "MainContainerChildrenProps", {
      enumerable: !0,
      get: function get() {
        return m.MainContainerChildrenProps;
      }
    });
    var g = n(132);
    Object.defineProperty(t, "MuteButton", {
      enumerable: !0,
      get: function get() {
        return g.MuteButton;
      }
    }), Object.defineProperty(t, "MuteButtonProps", {
      enumerable: !0,
      get: function get() {
        return g.MuteButtonProps;
      }
    });
    var y = n(287);
    Object.defineProperty(t, "SideNav", {
      enumerable: !0,
      get: function get() {
        return y.SideNav;
      }
    }), Object.defineProperty(t, "SideNavProps", {
      enumerable: !0,
      get: function get() {
        return y.SideNavProps;
      }
    }), Object.defineProperty(t, "SideNavChildrenProps", {
      enumerable: !0,
      get: function get() {
        return y.SideNavChildrenProps;
      }
    }), Object.defineProperty(t, "SideLink", {
      enumerable: !0,
      get: function get() {
        return y.SideLink;
      }
    }), Object.defineProperty(t, "SideLinkProps", {
      enumerable: !0,
      get: function get() {
        return y.SideLinkProps;
      }
    });
    var v = n(252);
    Object.defineProperty(t, "TaskListButtons", {
      enumerable: !0,
      get: function get() {
        return v.TaskListButtons;
      }
    });
    var b = n(256);
    Object.defineProperty(t, "TaskListContainer", {
      enumerable: !0,
      get: function get() {
        return b.TaskListContainer;
      }
    });
    var C = n(291);
    Object.defineProperty(t, "ViewCollection", {
      enumerable: !0,
      get: function get() {
        return C.ViewCollection;
      }
    }), Object.defineProperty(t, "ViewCollectionProps", {
      enumerable: !0,
      get: function get() {
        return C.ViewCollectionProps;
      }
    }), Object.defineProperty(t, "View", {
      enumerable: !0,
      get: function get() {
        return C.View;
      }
    }), Object.defineProperty(t, "ViewProps", {
      enumerable: !0,
      get: function get() {
        return C.ViewProps;
      }
    }), Object.defineProperty(t, "ViewCollectionChildrenProps", {
      enumerable: !0,
      get: function get() {
        return C.ViewCollectionChildrenProps;
      }
    });
    var _ = n(257);
    Object.defineProperty(t, "WorkerDirectory", {
      enumerable: !0,
      get: function get() {
        return _.WorkerDirectory;
      }
    }), Object.defineProperty(t, "WorkerDirectoryTabs", {
      enumerable: !0,
      get: function get() {
        return _.WorkerDirectoryTabs;
      }
    });
    var k = n(272);
    Object.defineProperty(t, "WorkerProfile", {
      enumerable: !0,
      get: function get() {
        return k.WorkerProfile;
      }
    });
    var w = n(273);
    Object.defineProperty(t, "WorkerSkills", {
      enumerable: !0,
      get: function get() {
        return w.WorkerSkills;
      }
    });
    var S = n(271);
    Object.defineProperty(t, "WorkerCanvas", {
      enumerable: !0,
      get: function get() {
        return S.WorkerCanvas;
      }
    });
    var P = n(282);
    Object.defineProperty(t, "LiveCommsBar", {
      enumerable: !0,
      get: function get() {
        return P.LiveCommsBar;
      }
    }), Object.defineProperty(t, "LiveCommsBarChildrenProps", {
      enumerable: !0,
      get: function get() {
        return P.LiveCommsBarChildrenProps;
      }
    }), Object.defineProperty(t, "LiveCommsBarItem", {
      enumerable: !0,
      get: function get() {
        return P.LiveCommsBarItem;
      }
    }), Object.defineProperty(t, "LiveCommsBarItemAction", {
      enumerable: !0,
      get: function get() {
        return P.LiveCommsBarItemAction;
      }
    }), Object.defineProperty(t, "LiveCommsBarItemActions", {
      enumerable: !0,
      get: function get() {
        return P.LiveCommsBarItemActions;
      }
    }), Object.defineProperty(t, "LiveCommsBarItemActionsProps", {
      enumerable: !0,
      get: function get() {
        return P.LiveCommsBarItemActionsProps;
      }
    });
    var T = n(754);
    Object.defineProperty(t, "OutboundDialerPanel", {
      enumerable: !0,
      get: function get() {
        return T.OutboundDialerPanel;
      }
    });
    var O = n(2);
    Object.defineProperty(t, "PropsWithTheme", {
      enumerable: !0,
      get: function get() {
        return O.PropsWithTheme;
      }
    }), Object.defineProperty(t, "withTheme", {
      enumerable: !0,
      get: function get() {
        return O.withTheme;
      }
    }), Object.defineProperty(t, "Theme", {
      enumerable: !0,
      get: function get() {
        return O.Theme;
      }
    }), Object.defineProperty(t, "ThemeProps", {
      enumerable: !0,
      get: function get() {
        return O.ThemeProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = void 0;
    var o = n(11),
      i = n(3),
      a = n(5),
      s = n(10),
      l = n(8),
      c = n(37),
      u = n(72),
      p = n(91),
      d = n(189),
      f = n(190),
      h = n(128),
      m = {
        states: new Map()
      };
    t.reduce = function (e, t) {
      switch (void 0 === e && (e = m), t.type) {
        case "CONFERENCE_INIT":
          return r(r({}, m), t.payload);
        case "CONFERENCE_MULTIPLE_UPDATE":
          var n = t.payload,
            o = new Map(e.states);
          return n.conferences.forEach(function (e) {
            o.set(e.sid, {
              source: e
            });
          }), r(r({}, e), {
            states: o
          });
        default:
          return e;
      }
    };
    var g = function () {
      function e() {}
      return e.dispatchAction = function (e, t) {
        i.FlexModule.dispatch({
          type: e,
          payload: t
        });
      }, e.assignInsights = function (e) {
        this.dispatchAction("CONFERENCE_INIT", {
          client: e
        }), f.ConferenceListenerManager.initialize(this.handleConferenceUpdate.bind(this));
      }, e.handleConferenceUpdateImpl = function () {
        if (a.log.debug("ConferencesState handleConferenceUpdateImpl " + this.handleConferenceUpdateCalls.size), 0 !== this.handleConferenceUpdateCalls.size) {
          var e = new Set();
          this.handleConferenceUpdateCalls.forEach(function (t) {
            if (a.log.debug("ConferencesState handleConferenceUpdateImpl " + t.sid), 0 !== t.children.length) {
              var n = t.sid,
                r = new d.Conference(n);
              if (t.children.forEach(function (e) {
                if ("conf_status" === e.key) {
                  var t = e.value;
                  r.status = t.status, r.conferenceSid = t.conference_sid;
                } else {
                  var n = new h.ConferenceParticipant(e.value, e.key);
                  "supervisor" !== n.participantType && r.participants.push(n);
                }
              }), a.log.debug("ConferencesState handleConferenceUpdateImpl raw participants: " + r.participants.length), t.outboundTransfer && "initialized" !== t.outboundTransfer.status) {
                a.log.debug("ConferencesState handleConferenceUpdateImpl adding fake outbound participant");
                var o = {
                    worker_sid: t.outboundTransfer.sid,
                    status: t.outboundTransfer.status,
                    participant_type: "transfer",
                    connecting: "recently_left" !== t.outboundTransfer.status
                  },
                  s = new h.ConferenceParticipant(o);
                r.participants.push(s);
              }
              var l = [];
              r.participants.forEach(function (e) {
                "left" !== e.status ? l.push(e) : l.find(function (t) {
                  return t.uniqueId === e.uniqueId;
                }) || r.participants.find(function (t) {
                  return t.uniqueId === e.uniqueId && "left" !== t.status;
                }) || l.push(e);
              }), r.participants = l, a.log.debug("ConferencesState handleConferenceUpdateImpl filtered participants: " + r.participants.length);
              var u = i.FlexModule.state.conferences.states.get(n);
              u && (r.participants = r.participants.map(function (e) {
                if ("left" === e.status) {
                  var n = u.source.participants.find(function (t) {
                    return t.uniqueId === e.uniqueId;
                  });
                  if (n) {
                    if ("joined" === n.status) return t.triggerDelayedStateUpdate(5e3), new h.ConferenceParticipant(e.source, e.callSid, new Date().getTime());
                    if (n.participantLeftTimestamp && new Date().getTime() - n.participantLeftTimestamp < 5e3) return n;
                  }
                }
                return e;
              })), a.log.debug("ConferencesState handleConferenceUpdateImpl final participants: " + r.participants.length);
              var p = r.participants.map(function (e) {
                return e.workerSid;
              });
              c.InsightsEntityCache.refreshInfoForEntities(p), r.source = t, e.add(r);
            }
          }), this.dispatchAction("CONFERENCE_MULTIPLE_UPDATE", {
            conferences: e
          }), e.forEach(function (e) {
            var t = Array.from(i.FlexModule.state.worker.tasks.values()).find(function (t) {
              return t.taskSid === e.sid && l.TaskHelper.isLiveCall(t);
            });
            t && p.Actions.updateEndConferenceOnExitForTask(t), t && o.FeatureFlags.isEnabled(s.FeatureFlag.ExternalWarmTransfers) && u.getParticipants(t);
          });
        }
      }, e.handleConferenceUpdate = function (e) {
        var t = this;
        if (e) {
          if (a.log.debug("ConferencesState handleConferenceUpdate " + e.sid), this.handleConferenceUpdateThrottler) return void this.handleConferenceUpdateCalls.add(e);
          this.handleConferenceUpdateCalls = new Set(), this.handleConferenceUpdateCalls.add(e), this.handleConferenceUpdateImpl(), this.handleConferenceUpdateCalls = new Set(), this.handleConferenceUpdateThrottler = setTimeout(function () {
            t.handleConferenceUpdateImpl(), clearTimeout(t.handleConferenceUpdateThrottler), t.handleConferenceUpdateThrottler = null;
          }, 500);
        }
      }, e.updateConferencesWithParticipant = function (e) {
        var t = [];
        i.FlexModule.state.conferences.states.forEach(function (n, r) {
          n.source.participants.find(function (t) {
            return t.workerSid === e;
          }) && t.push(n.source);
        }), t.length > 0 && this.dispatchAction("CONFERENCE_MULTIPLE_UPDATE", {
          conferences: t
        });
      }, e.shutdown = function () {
        this.dispatchAction("CONFERENCE_INIT", {});
      }, e;
    }();
    t.Actions = g;
  }, function (e, t) {
    e.exports = require("redux");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UPDATE_METADATA = t.UPDATE_QUEUES_CONFIG = t.QUEUES_ERROR = t.UPDATE_FILTER = t.SET_WORKSPACE_STATS = t.UPDATE_QUEUE = t.SET_QUEUES = void 0, t.SET_QUEUES = "FLEX_SET_QUEUES", t.UPDATE_QUEUE = "FLEX_UPDATE_QUEUE", t.SET_WORKSPACE_STATS = "FLEX_SET_WORKSPACE_STATS", t.UPDATE_FILTER = "FLEX_UPDATE_QUEUES_FILTER", t.QUEUES_ERROR = "FLEX_QUEUES_ERROR", t.UPDATE_QUEUES_CONFIG = "FLEX_UPDATE_QUEUES_CONFIG", t.UPDATE_METADATA = "FLEX_UPDATE_QUEUES_METADATA";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t._SingleSessionGuardConstructor = t.singleSessionGuard = void 0;
    var a,
      s = n(3),
      l = n(122),
      c = n(5);
    !function (e) {
      e[e.checkForInstance = 0] = "checkForInstance", e[e.instanceResponse = 1] = "instanceResponse", e[e.loadingInstanceResponse = 2] = "loadingInstanceResponse";
    }(a || (a = {}));
    var u = function () {
      function e() {
        var e = this;
        this._broadcastChannel = void 0, this.initialized = !1, this.isCurrentSession = function (t) {
          return t === e.getDeviceSid();
        }, this.invalidateOtherSessions = function () {
          return o(e, void 0, void 0, function () {
            return i(this, function (e) {
              switch (e.label) {
                case 0:
                  return c.log.debug("SingleSessionGuard: invalidating other sessions"), [4, this.record.update({
                    keepalive: void 0,
                    deviceSid: this.getDeviceSid()
                  })];
                case 1:
                  return e.sent(), this.callbacks.handleOtherSessionsInvalidated(), [4, this.approveSession()];
                case 2:
                  return e.sent(), [2];
              }
            });
          });
        }, this.handleCurrentSessionValidated = function () {
          e.callbacks.handleCurrentSessionValidated();
        }, this.handleOtherSessionDetected = function (t) {
          e.record.on("updated", function (t) {
            t.isLocal || e.callbacks.handleOtherSessionDetected(t.value.deviceSid, t.value.onACall);
          }), e.callbacks.handleOtherSessionDetected(t.deviceSid, t.onACall);
        }, this.refreshPageWithInitialParams = function () {
          var t = window.location,
            n = t.origin,
            r = t.pathname;
          window.location.assign("" + n + r + e.initialLocationParams);
        }, this.listenForOtherSessionsTakingOver = function (t) {
          var n = t.value,
            r = n.keepalive,
            o = n.deviceSid;
          t.isLocal ? c.log.trace("SingleSessionGuard: record was updated with", t) : r || (c.log.debug("SingleSessionGuard: record was cleared by another session. Invalidating current session"), e.callbacks.handleCurrentSessionInvalidated(o));
        }, this.getDeviceSid = function () {
          var e = window.localStorage.getItem("FLEX_SINGLE_SESSION_GUARD_LOCAL");
          return e || (e = l.v4(), window.localStorage.setItem("FLEX_SINGLE_SESSION_GUARD_LOCAL", e)), e;
        }, this.approveSession = function () {
          return o(e, void 0, void 0, function () {
            var e = this;
            return i(this, function (t) {
              switch (t.label) {
                case 0:
                  return this.initialized = !0, c.log.debug("SingleSessionGuard: session validation successful"), this.broadcastChannel && this.broadcastChannel.addEventListener("message", this.onOtherTabsMessages), this.record.removeAllListeners(), this.record.on("updated", this.listenForOtherSessionsTakingOver), [4, this.updateRecord({
                    deviceSid: this.getDeviceSid()
                  })];
                case 1:
                  return t.sent(), this.handleCurrentSessionValidated(), this.interval = setInterval(function () {
                    e.updateRecord();
                  }, 15e3), [2];
              }
            });
          });
        }, this.onOtherTabsMessagesWhenLoading = function (t) {
          switch (t.data.cmd) {
            case a.instanceResponse:
            case a.loadingInstanceResponse:
              clearTimeout(e.localTabValidationTimeout), e.broadcastChannel.removeEventListener("message", e.onOtherTabsMessagesWhenLoading), c.log.debug("SingleSessionGuard: got a reply from another local session, showing prompt."), e.handleOtherSessionDetected({
                deviceSid: e.record.value.deviceSid,
                onACall: t.data.onACall,
                keepalive: void 0
              });
              break;
            case a.checkForInstance:
              c.log.debug("SingleSessionGuard: another local session is attempting validation. Sending a message to prevent that."), e.broadcastChannel.postMessage({
                cmd: a.loadingInstanceResponse
              });
          }
        }, this.onOtherTabsMessages = function (t) {
          t.data.cmd === a.checkForInstance && e.postLocalInstanceResponse();
        }, this.getServerTime = function () {
          return o(e, void 0, void 0, function () {
            var e;
            return i(this, function (t) {
              switch (t.label) {
                case 0:
                  return e = Math.floor(1e6 * Math.random()).toString(), [4, this.client.document({
                    id: e,
                    ttl: 30
                  })];
                case 1:
                  return [2, t.sent().dateUpdated];
              }
            });
          });
        }, this.isRecordOutdated = function () {
          return o(e, void 0, void 0, function () {
            var e, t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.getServerTime()];
                case 1:
                  return e = n.sent(), t = new Date(e).getTime() - new Date(this.record.dateUpdated).getTime(), c.log.debug("SingleSessionGuard: record is", t, "ms old"), [2, t > 4e4];
              }
            });
          });
        };
      }
      return Object.defineProperty(e.prototype, "broadcastChannel", {
        get: function get() {
          if (window.BroadcastChannel) return this._broadcastChannel || (this._broadcastChannel = new window.BroadcastChannel("FLEX_SINGLE_SESSION_GUARD_LOCAL")), this._broadcastChannel;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.initAndValidate = function (e) {
        var t = e.syncClient,
          n = e.workerSid,
          r = e.handleOtherSessionDetected,
          a = e.handleCurrentSessionInvalidated,
          s = e.handleCurrentSessionValidated,
          l = e.handleOtherSessionsInvalidated;
        return o(this, void 0, void 0, function () {
          var e = this;
          return i(this, function (o) {
            switch (o.label) {
              case 0:
                return this.client = t, this.callbacks = {
                  handleOtherSessionDetected: r,
                  handleCurrentSessionValidated: s,
                  handleCurrentSessionInvalidated: a,
                  handleOtherSessionsInvalidated: l
                }, this.DOCUMENT_NAME = "flexSingleTabGuard_" + n, this.initialLocationParams = window.location.search, [4, this.validate()];
              case 1:
                return o.sent(), this.client.on("connectionStateChanged", function (t) {
                  "connecting" === t ? (c.log.debug("SingleSessionGuard: connection dropped, removing listeners"), e.shutdown(!0)) : "connected" === t && (c.log.debug("SingleSessionGuard: connection is back up, re-validating session"), e.validate());
                }), [2];
            }
          });
        });
      }, e.prototype.fetchDocument = function () {
        return o(this, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.client.document({
                  id: this.DOCUMENT_NAME,
                  mode: "open_or_create",
                  ttl: 172800
                })];
              case 1:
                return [2, e.sent()];
            }
          });
        });
      }, e.prototype.getRemoteDocumentValue = function () {
        var e = this,
          t = !1,
          n = new Promise(function (n) {
            return o(e, void 0, void 0, function () {
              return i(this, function (e) {
                switch (e.label) {
                  case 0:
                    if (t) return [2, n(void 0)];
                    e.label = 1;
                  case 1:
                    return "established" === this.record.syncDocumentImpl.subscriptionState ? [3, 3] : (c.log.debug("SingleSessionGuard: establishing connection with remote WorkerRecord document"), [4, new Promise(function (e) {
                      return setTimeout(e, 500);
                    })]);
                  case 2:
                    return e.sent(), [3, 1];
                  case 3:
                    return t = !0, c.log.debug("SingleSessionGuard: connected with remote WorkerRecord document"), [2, n(void 0)];
                }
              });
            });
          });
        return Promise.race([n, new Promise(function (e) {
          return setTimeout(function () {
            return t ? e(void 0) : (c.log.debug("SingleSessionGuard: connection to document is taking too long"), t = !0, e(void 0));
          }, 5e3);
        })]);
      }, e.prototype.validate = function () {
        return o(this, void 0, void 0, function () {
          var e, t;
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                return this.record ? [3, 2] : (e = this, [4, this.fetchDocument()]);
              case 1:
                e.record = n.sent(), n.label = 2;
              case 2:
                return [4, this.getRemoteDocumentValue()];
              case 3:
                return n.sent(), this.record.value && Object.keys(this.record.value).length ? (c.log.debug("SingleSessionGuard: record found"), (t = this.record.value).deviceSid !== this.getDeviceSid() ? [3, 7] : (c.log.debug("SingleSessionGuard: record matches current deviceSid"), this.broadcastChannel ? (this.checkForLocalInstances(), [3, 6]) : [3, 4])) : [3, 12];
              case 4:
                return c.log.debug("SingleSessionGuard: browser doesn't support BroadcastMessage. Approving session."), [4, this.approveSession()];
              case 5:
                n.sent(), n.label = 6;
              case 6:
                return [3, 11];
              case 7:
                return [4, this.isRecordOutdated()];
              case 8:
                return n.sent() ? (c.log.debug("SingleSessionGuard: record is expired"), [4, this.invalidateOtherSessions()]) : [3, 10];
              case 9:
                return n.sent(), [3, 11];
              case 10:
                c.log.debug("SingleSessionGuard: valid record with different cookiesDid found, showing prompt"), this.handleOtherSessionDetected(t), n.label = 11;
              case 11:
                return [3, 14];
              case 12:
                return c.log.debug("SingleSessionGuard: record not found"), [4, this.approveSession()];
              case 13:
                n.sent(), n.label = 14;
              case 14:
                return [2];
            }
          });
        });
      }, e.prototype.updateRecordIsOnCall = function (e) {
        c.log.debug("SingleSessionGuard: setting sync document `onACall` to", e), this.updateRecord({
          onACall: e
        });
      }, e.prototype.shutdown = function (e) {
        this.initialized && (c.log.debug("SingleSessionGuard: shutting down, removing listeners and intervals"), this.initialized = !1, clearInterval(this.interval), this.broadcastChannel && this.broadcastChannel.removeEventListener("message", this.onOtherTabsMessages), e ? this.record.removeAllListeners() : (this.record.close(), this.record = void 0));
      }, e.prototype.updateRecord = function (e) {
        return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.record.update(r({
                  keepalive: new Date().toUTCString(),
                  onACall: Boolean(s.FlexModule.state.phone.connection)
                }, e), {
                  ttl: 172800
                })];
              case 1:
                return t.sent(), [2];
            }
          });
        });
      }, e.prototype.checkForLocalInstances = function () {
        var e = this;
        c.log.debug("SingleSessionGuard: checking for other local instances"), this.localTabValidationTimeout = setTimeout(function () {
          c.log.debug("SingleSessionGuard: no reply from other local instances, no prompt needed."), e.postLocalInstanceResponse(), e.broadcastChannel.removeEventListener("message", e.onOtherTabsMessagesWhenLoading), e.approveSession();
        }, 3e3), this.broadcastChannel.addEventListener("message", this.onOtherTabsMessagesWhenLoading), this.broadcastChannel.postMessage({
          cmd: a.checkForInstance
        });
      }, e.prototype.postLocalInstanceResponse = function () {
        this.broadcastChannel.postMessage({
          cmd: a.instanceResponse,
          onACall: Boolean(s.FlexModule.state.phone.connection)
        });
      }, e;
    }();
    t.singleSessionGuard = new u(), t._SingleSessionGuardConstructor = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerListener = t.Actions = t.reduce = t.ACTION_LOGGED_OUT = void 0;
    var o = n(0),
      i = n(92),
      a = n(32),
      s = n(12),
      l = n(7),
      c = n(3),
      u = n(5),
      p = n(374),
      d = n(16),
      f = n(123),
      h = n(6),
      m = n(20),
      g = n(164),
      y = n(8),
      v = n(375),
      b = n(172),
      C = n(72),
      _ = n(378);
    t.ACTION_LOGGED_OUT = "FLEX_ACTION_LOGGED_OUT";
    var k = {
      tasks: new Map(),
      listener: void 0,
      activities: new Map(),
      activity: void 0,
      attributes: {},
      source: void 0,
      worker: void 0
    };
    t.reduce = function (e, n) {
      switch (void 0 === e && (e = k), n.type) {
        case "WORKER_INIT":
          var o = n.payload;
          return r(r(r({}, k), n.payload), {
            worker: new p.TaskRouterWorker(o.source)
          });
        case t.ACTION_LOGGED_OUT:
          return k;
        case "WORKER_UPDATE":
          return r(r({}, e), n.payload);
        case "WORKER_ADD_RESERVATION":
        case "WORKER_UPDATE_RESERVATION":
          var i = n.payload,
            a = new Map(e.tasks),
            s = new p.TaskRouterTask(i);
          return a.set(s.sid, s), r(r({}, e), {
            tasks: a
          });
        case "WORKER_DELETE_RESERVATION":
          i = n.payload;
          var l = new Map(e.tasks);
          return l.delete(i.sid), r(r({}, e), {
            tasks: l
          });
      }
      return e;
    };
    var w = function () {
      function e() {}
      return e.dispatchWorkerAction = function (e, t) {
        c.FlexModule.dispatch({
          type: e,
          payload: t
        });
      }, e.init = function (e) {
        var t = c.FlexModule.state.worker.listener;
        t || (t = new S(e)), t.start();
      }, e.addReservation = function (e) {
        this.dispatchWorkerAction("WORKER_ADD_RESERVATION", e);
      }, e.setCurrentActivity = function (e) {
        var t = c.FlexModule.state.worker.activities.get(e);
        return t ? t.isCurrent ? Promise.resolve() : t.setAsCurrent() : Promise.reject("Activity not found: " + e);
      }, e.setCurrentActivityByName = function (e) {
        var t;
        return c.FlexModule.state.worker.activities.forEach(function (n) {
          n.name === e && (t = n);
        }), t ? t.isCurrent ? Promise.resolve() : t.setAsCurrent() : Promise.reject("Activity not found: " + e);
      }, e.updateEndConferenceOnExitForTask = function (e, t) {
        var n = t || e.conference;
        if (n && y.TaskHelper.isLiveCall(e) && "started" === n.status) {
          var r = n.participants.find(function (e) {
              return e.isMyself && "joined" === e.status;
            }),
            o = n.liveParticipantCount <= 2,
            i = this.previousEndConferenceOnExits.get(e.sid);
          u.log.info("Updating endConferenceOnExit for task " + e.sid + ". imLivePerConference: " + r + ", oldValue: " + i + ", newValue: " + o), r && i !== o && (u.log.info("Updating endConferenceOnExit done"), this.previousEndConferenceOnExits.set(e.sid, o), e.sourceObject.updateParticipant({
            endConferenceOnExit: o
          }));
        }
      }, e.shutdown = function () {
        u.log.debug("Worker state logout");
        var e = c.FlexModule.workerClient;
        if (e) try {
          e.disconnect();
        } catch (e) {
          u.log.error("Error on worker disconnect", e);
        }
        var t = c.FlexModule.state.worker.listener;
        t && t.stop();
      }, e.previousEndConferenceOnExits = new Map(), e;
    }();
    t.Actions = w;
    var S = function () {
      function e(e) {
        var t = this;
        this.handleActivityUpdated = function () {
          t.dispatchAction("WORKER_UPDATE", {
            activity: t._worker.activity,
            activities: t._worker.activities
          });
        }, this.handleAttributesUpdated = function () {
          t.dispatchAction("WORKER_UPDATE", {
            attributes: t._worker.attributes
          });
        }, this.handleWorkerReady = function () {
          u.log.debug("WorkerState: Worker " + t._worker.sid + " ready"), t.initAndLoadReservations();
        }, this.handleWorkerDisconnected = function () {
          u.log.debug("WorkerState: Worker " + t._worker.sid + " disconnected");
        }, this.handleWorkerError = function (e) {
          a.FlexClientManager.setDegradedMode(t._worker, !0), l.ErrorManager.createAndProcessError("Worker error intercepted", {
            type: l.FlexErrorType.taskrouterSDK,
            context: "WorkerState",
            description: "TaskRouter Worker client has thrown an error",
            wrappedError: e
          });
        }, this.handleReservationCreated = function (e) {
          var n, r;
          u.log.debug("reservationCreated event, sid: " + e.sid, e), t.initReservationListeners(e), w.addReservation(e);
          var o = new p.TaskRouterTask(e);
          if (t.playSound(o), (null === (n = o.attributes) || void 0 === n ? void 0 : n.flexInteractionChannelSid) && "email" !== o.attributes.channelType && (d.Notifications.showNotification(d.NotificationIds.IncomingCBMTaskNotSupported), s.TelemetryManager.reportIncomingCBMTaskNotSupported(e.sid, o.taskSid, o.attributes.channelType)), y.TaskHelper.isCallTask(o) && b.ConferenceListenerManager.startListening(o, "worker" + o.sid), y.TaskHelper.isInitialOutboundAttemptTask(o)) h.tryInvokeAction("AcceptTask", {
            task: o
          }), h.tryInvokeAction("SelectTask", {
            task: o
          });else if (o.incomingTransferObject && y.TaskHelper.isPending(o)) var i = 0,
            a = setInterval("WORKER" === (null === (r = o.incomingTransferObject) || void 0 === r ? void 0 : r.type) ? function () {
              (o.incomingTransferObject.worker || i > 50) && (d.Notifications.showNotification(d.NotificationIds.IncomingTask, {
                task: o
              }), clearInterval(a)), i += 1;
            } : function () {
              (o.incomingTransferObject.queue || i > 50) && (d.Notifications.showNotification(d.NotificationIds.IncomingTask, {
                task: o
              }), clearInterval(a)), i += 1;
            }, 100);else d.Notifications.showNotification(d.NotificationIds.IncomingTask, {
            task: o
          });
        }, this.handleOutboundReservationCanceled = function (e) {
          f.OutboundCalling.handleOutboundTaskCancelledEvent(e);
        }, this.handleReservationUpdated = function (e, n) {
          u.log.info("Event, reservation updated", e, n);
          var r = d.Notifications.activeNotifications.find(function (e) {
            return e.id === d.NotificationIds.IncomingTask && e.context.task.sid === n.sid;
          });
          r && d.Notifications.dismissNotification(r);
          var o = new p.TaskRouterTask(n);
          switch (i.ChatOrchestrator.handleReservationEvent(e, o).catch(function (e) {
            return u.log.error(e);
          }), v.ChatJoiner.verifyChatParticipation(o), e) {
            case "wrapup":
              t.dispatchAction("WORKER_UPDATE_RESERVATION", n);
              break;
            case "accepted":
              t.dispatchAction("WORKER_UPDATE_RESERVATION", n), t.stopSound(o), y.TaskHelper.isLiveCall(o) && w.updateEndConferenceOnExitForTask(o), y.TaskHelper.isCallTask(o) && o.incomingTransferObject && "COLD" === o.incomingTransferObject.mode && h.tryInvokeAction("UnholdCall", {
                task: o
              }), y.TaskHelper.isChatBasedTask(o) && g.loadTaskChatChannel(o);
              break;
            case "completed":
            case "rejected":
            case "timeout":
            case "canceled":
            case "rescinded":
              "canceled" === e && y.TaskHelper.isOutboundCallTask(o) && t.handleOutboundReservationCanceled(n), t.stopReservationListeners(n), b.ConferenceListenerManager.stopListening(n.task.sid, "worker" + n.sid), t.stopSound(o), t.dispatchAction("WORKER_DELETE_RESERVATION", n), b.ConferenceListenerManager.unInitOutboundTransferForTask(n.task.sid);
          }
        }, this.handleTaskUpdated = function (e, n) {
          u.log.info("Task updated", e, n.task), ["completed", "rejected", "timeout", "canceled", "rescinded"].indexOf(n.status) > -1 || t.dispatchAction("WORKER_UPDATE_RESERVATION", n);
        }, this._reservationListeners = new Map(), this._worker = e, this.currentMediaIds = {}, this.initAndLoadReservations(), this.start();
      }
      return e.prototype.start = function () {
        this._listening || (u.log.debug("Adding worker listeners"), this._worker.addListener("disconnected", this.handleWorkerDisconnected), this._worker.addListener("reservationCreated", this.handleReservationCreated), this._worker.addListener("activityUpdated", this.handleActivityUpdated), this._worker.addListener("attributesUpdated", this.handleAttributesUpdated), this._worker.addListener("ready", this.handleWorkerReady), this._worker.addListener("error", this.handleWorkerError), this._listening = !0);
      }, e.prototype.stop = function () {
        this._listening && (u.log.debug("Removing worker listeners"), this._worker.removeListener("disconnected", this.handleWorkerDisconnected), this._worker.removeListener("reservationCreated", this.handleReservationCreated), this._worker.removeListener("activityUpdated", this.handleActivityUpdated), this._worker.removeListener("attributesUpdated", this.handleAttributesUpdated), this._worker.removeListener("ready", this.handleWorkerReady), this._worker.removeListener("error", this.handleWorkerError), this._listening = !1);
      }, e.prototype.initAndLoadReservations = function () {
        var e = this;
        this.stopAllReservationListeners();
        var t = new Map();
        this._worker.reservations.forEach(function (n) {
          var r = new p.TaskRouterTask(n);
          t.set(n.sid, r), e.initReservationListeners(n), y.TaskHelper.isCallTask(r) && b.ConferenceListenerManager.startListening(r, "worker" + n.sid), y.TaskHelper.isChatBasedTask(r) && y.TaskHelper.isTaskAccepted(r) && (g.loadTaskChatChannel(r), v.ChatJoiner.verifyChatParticipation(r));
        }), this.dispatchAction("WORKER_INIT", {
          listener: this,
          source: this._worker,
          activity: this._worker.activity,
          activities: this._worker.activities,
          attributes: this._worker.attributes,
          tasks: t
        });
      }, e.prototype.stopAllReservationListeners = function () {
        var e = this;
        Array.from(this._reservationListeners.keys()).forEach(function (t) {
          return e.stopReservationListeners(t);
        });
      }, e.prototype.dispatchAction = function (e, t) {
        w.dispatchWorkerAction(e, t);
      }, e.prototype.stopReservationListeners = function (e) {
        var t = this._reservationListeners.get(e);
        t && (t.resListeners.forEach(function (t) {
          e.removeListener(t.event, t.callback);
        }), t.taskListeners.forEach(function (t) {
          e.task.removeListener(t.event, t.callback);
        }), this._reservationListeners.delete(e));
      }, e.prototype.initReservationListeners = function (e) {
        var t = this;
        this.stopReservationListeners(e);
        var n = [],
          r = [];
        ["accepted", "rejected", "timeout", "canceled", "rescinded", "completed", "wrapup"].forEach(function (r) {
          var o = function o() {
            return t.handleReservationUpdated(r, e);
          };
          e.addListener(r, o), n.push({
            callback: o,
            event: r
          });
        });
        ["updated", "wrapup", "completed", "canceled"].forEach(function (n) {
          var o = function o() {
            return t.handleTaskUpdated(n, e);
          };
          e.task.addListener(n, o), e.task.addListener("participantAdded", function (e, t) {
            "voice" === t.channel_type && "external" === t.type && C.dispatch(C.addParticipant(_.decodeParticipantEvent(t)));
          }), r.push({
            callback: o,
            event: n
          });
        });
        var o = function o(e) {
          b.ConferenceListenerManager.initOutboundTransfer(e);
        };
        e.task.addListener("transferInitiated", o), r.push({
          event: "transferInitiated",
          callback: o
        }), this._reservationListeners.set(e, {
          resListeners: n,
          taskListeners: r
        });
      }, e.prototype.playSound = function (e) {
        var t,
          n = this,
          r = m.TaskChannels.getForTask(e);
        (null === (t = r.sounds) || void 0 === t ? void 0 : t.Pending) && !y.TaskHelper.isOutboundCallTask(e) && (this.currentMediaIds[e.taskSid] = o.AudioPlayerManager.play({
          url: r.sounds.Pending.url,
          repeatable: r.sounds.Pending.repeatable
        }, function (e) {
          n.handlePlayError(e);
        }));
      }, e.prototype.handlePlayError = function (e) {
        var t;
        t = e.code === o.ErrorCode.NotAllowed ? d.NotificationIds.AudioPlayerDeniedErrorNotificationId : e.code === o.ErrorCode.InvalidMedia ? d.NotificationIds.AudioPlayerInvalidMediaErrorNotificationId : d.NotificationIds.AudioPlayerGenericErrorNotificationId, d.Notifications.showNotification(t);
      }, e.prototype.stopSound = function (e) {
        this.currentMediaIds[e.taskSid] && o.AudioPlayerManager.stop(this.currentMediaIds[e.taskSid]);
      }, e.prototype.isListening = function () {
        return this._listening;
      }, e;
    }();
    t.WorkerListener = S;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatOrchestrator = t.ChatOrchestrationManager = t.ChatOrchestration = void 0;
    var a,
      s = n(0),
      l = n(27),
      c = n(34),
      u = n(11),
      p = n(32),
      d = n(13),
      f = n(9),
      h = n(7),
      m = n(3),
      g = n(5),
      y = n(10),
      v = n(14),
      b = n(16),
      C = n(6),
      _ = n(23),
      k = n(8);
    !function (e) {
      e.AddToChatChannel = "AddToChatChannel", e.DeactivateChatChannel = "DeactivateChatChannel", e.LeaveChatChannel = "LeaveChatChannel";
    }(a = t.ChatOrchestration || (t.ChatOrchestration = {}));
    var w = {
        accepted: new Set([a.AddToChatChannel]),
        wrapup: new Set([a.DeactivateChatChannel]),
        completed: new Set([a.DeactivateChatChannel, a.LeaveChatChannel])
      },
      S = function () {
        function e() {
          var e;
          this.events = r({}, w), this.mapEventToFunc = ((e = {})[a.AddToChatChannel] = this.addWorkerToChatChannelInternal, e[a.DeactivateChatChannel] = this.deactivateChatChannelInternal, e[a.LeaveChatChannel] = this.leaveAgentFromChatInternal, e);
        }
        return e.prototype.getOrchestrations = function (e) {
          var t = this.events[e];
          return this.isChatOrchestrationsCallbackType(t) ? t : Array.from(t);
        }, e.prototype.setOrchestrations = function (e, t) {
          if (this.isChatOrchestrationsCallbackType(t)) return g.log.debug("ChatOrchestrator setOrchestrations, event: " + e + ", orchestrations: callback"), void (this.events[e] = t);
          var n = this.getOrchestrationsSet(e, t);
          this.events[e] = n;
          var r = Array.from(n).join(", ");
          g.log.debug("ChatOrchestrator setOrchestrations, event: " + e + ", orchestrations: [" + r + "]");
        }, e.prototype.clearAllOrchestrations = function () {
          var e = this;
          g.log.debug("ChatOrchestrator clearAllOrchestrations"), Object.keys(this.events).forEach(function (t) {
            e.events[t] = new Set();
          });
        }, e.prototype.orchestrateWrapupTask = function (e) {
          return g.log.debug("ChatOrchestrator orchestrateWrapupTask"), this.handleReservationEvent("wrapup", e);
        }, e.prototype.orchestrateCompleteTask = function (e) {
          return g.log.debug("ChatOrchestrator orchestrateCompleteTask"), this.handleReservationEvent("completed", e);
        }, e.prototype.handleReservationEvent = function (e, t) {
          return o(this, void 0, Promise, function () {
            var n, r, o, a, s, l, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (!k.TaskHelper.isChatBasedTask(t)) return [2, !1];
                  if (n = this.events[e], u.FeatureFlags.isEnabled(y.FeatureFlag.EmailPOC) && "email" === t.attributes.channelType) return [2, !1];
                  if (this.isChatOrchestrationsCallbackType(n) && (r = n(t), n = this.getOrchestrationsSet(e, r)), !n) return [2, !1];
                  if (!(o = Array.from(n.values())).length) return g.log.debug("ChatOrchestrator no events to handle for " + e + " in " + t.sid), [2, !1];
                  a = Array.from(o).join(", "), g.log.debug("ChatOrchestrator handleReservationEvent event: " + e + " for " + t.sid + ", orchestrations: [" + a + "]"), s = !1, l = 0, i.label = 1;
                case 1:
                  return l < o.length ? (c = o[l], [4, (0, this.mapEventToFunc[c])(t)]) : [3, 4];
                case 2:
                  s = i.sent() || s, i.label = 3;
                case 3:
                  return l++, [3, 1];
                case 4:
                  return [2, s];
              }
            });
          });
        }, e.prototype.addWorkerToChatChannelInternal = function (e) {
          return o(this, void 0, void 0, function () {
            var t, n, o, a, s, u, h, y, w;
            return i(this, function (i) {
              return m.FlexModule.chatClient ? p.FlexClientManager.isDegraded(m.FlexModule.chatClient) ? (g.log.debug("Chat SDK is in degraded mode, worker not added to conversation"), [2, !1]) : (t = _.StateHelper.getChatChannelStateForTask(e)) && t.source && "joined" === t.source.status ? (g.log.debug("ChatOrchestrator addAgentToChatChannel - chat channel state exists already"), [2, !1]) : (n = k.TaskHelper.getTaskChatChannelSid(e)) ? (g.log.debug("ChatOrchestrator addAgentToChatChannel for " + e.sid), o = d.Manager.getInstance().user, a = C.getUserRole(o), s = f.getChatOrchestrationServiceUrl(m.FlexModule.state.config), u = f.isPreviewURL(s), h = c.stringify(r({
                Identity: m.FlexModule.chatClient.user.identity
              }, u ? {
                ChatChannelSid: n
              } : {})), y = u ? s + "/Users" : s + "/" + n + "/Roles/" + a + "/Users", w = {
                auth: {
                  username: "token",
                  password: m.FlexModule.chatClient.token
                },
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                }
              }, g.log.debug("requesting to join channel for task", n, e.sid), [2, l.default.post(y, h, w).then(function () {
                return g.log.debug("Request to join channel successfully sent", n, e.sid), !0;
              }).catch(function (t) {
                if (t && t.response && 409 === t.response.status) return g.log.warn("Agent is already in the chat channel", n, e.sid), !0;
                throw b.Notifications.dismissNotificationById(v.ChatOrchestrationAddToChatChannelFailed), b.Notifications.showNotification(v.ChatOrchestrationAddToChatChannelFailed), g.log.error("Failed to join channel", n, e.sid, t), t;
              })]) : (g.log.warn("ChatOrchestrator addAgentToChatChannel - No chat channel sid in task", e), [2, !1]) : (g.log.debug("chat client not ready yet, loading channel later"), [2, !1]);
            });
          });
        }, e.prototype.deactivateChatChannelInternal = function (e) {
          return o(this, void 0, void 0, function () {
            var t, n, o, a, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (!(t = _.StateHelper.getChatChannelStateForTask(e)) || p.FlexClientManager.isDegraded(m.FlexModule.chatClient)) return [3, 5];
                  if (!(n = t.source)) throw b.Notifications.showNotification(v.ChatOrchestrationDeactivateChatChannelFailed), a = k.TaskHelper.getTaskChatChannelSid(e), h.ErrorManager.createAndProcessError("Failed to deactivate chat channel", {
                    type: h.FlexErrorType.app,
                    context: "ChatOrchestrator",
                    description: "Failed to deactivate chat channel for task " + e.sid + " channelSid: " + a + ". Chat channel is not loaded."
                  });
                  if (n.attributes[s.FrameConstants.CHANNEL_STATUS_ATTRIBUTE] === s.FrameConstants.CHANNEL_STATUS_INACTIVE) return g.log.trace("ChatOrchestrator DeactivateChatChannel channel already inactive " + e.sid), [2, !1];
                  g.log.debug("ChatOrchestrator DeactivateChatChannel for " + e.sid), i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, t.source.updateAttributes(r(r({}, t.source.attributes), (l = {}, l[s.FrameConstants.CHANNEL_STATUS_ATTRIBUTE] = s.FrameConstants.CHANNEL_STATUS_INACTIVE, l)))];
                case 2:
                  return i.sent(), g.log.debug("ChatOrchestrator DeactivateChatChannel for " + e.sid + " done"), [3, 4];
                case 3:
                  throw o = i.sent(), b.Notifications.showNotification(v.ChatOrchestrationDeactivateChatChannelFailed), a = k.TaskHelper.getTaskChatChannelSid(e), h.ErrorManager.createAndProcessError("Failed to deactivate chat channel", {
                    type: h.FlexErrorType.chatSDK,
                    wrappedError: o,
                    context: "ChatOrchestrator",
                    description: "Failed to deactivate chat channel for task " + e.sid + ", channelSid: " + a
                  });
                case 4:
                  return [2, !0];
                case 5:
                  return g.log.debug("ChatOrchestrator DeactivateChatChannel chat channel not found for " + e.sid), [2, !1];
              }
            });
          });
        }, e.prototype.leaveAgentFromChatInternal = function (e) {
          return o(this, void 0, void 0, function () {
            var t, n;
            return i(this, function (r) {
              return g.log.debug("ChatOrchestrator leaveAgentFromChat for " + e.sid), !(t = k.TaskHelper.getTaskChatChannelSid(e)) || p.FlexClientManager.isDegraded(m.FlexModule.chatClient) ? (g.log.trace("chat channel sid for task does not exist", e), [2, !1]) : (n = _.StateHelper.getChatChannelStateForTask(e)) ? [2, n.source.leave().then(function () {
                return g.log.debug("ChatOrchestrator leaveAgentFromChat for " + e.sid + " done"), !0;
              }).catch(function (e) {
                throw b.Notifications.showNotification(v.ChatOrchestrationLeaveChatChannelFailed), h.ErrorManager.createAndProcessError("Failed to leave chat channel", {
                  type: h.FlexErrorType.chatSDK,
                  wrappedError: e,
                  context: "ChatOrchestrator",
                  description: "Failed to leave chat channel for chatChannelSid: " + t
                });
              })] : (g.log.trace("No chat channel state for task", e), [2, !1]);
            });
          });
        }, e.prototype.isChatOrchestrationsCallbackType = function (e) {
          return "function" == typeof e;
        }, e.prototype.getOrchestrationsSet = function (e, t) {
          if (!Array.isArray(t)) return new Set();
          var n = new Set(t);
          return this.validateOrchestrations(e, n), n;
        }, e.prototype.validateOrchestrations = function (e, t) {
          var n = this;
          if (t.forEach(function (e) {
            if (!n.mapEventToFunc[e]) throw h.ErrorManager.createAndProcessError("Unknown orchestration", {
              type: h.FlexErrorType.app,
              context: "ChatOrchestrator",
              description: "Unknown orchestration: " + e
            });
          }), "accepted" === e && (t.has(a.DeactivateChatChannel) || t.has(a.LeaveChatChannel))) throw h.ErrorManager.createAndProcessError("DeactivateChatChannel and LeaveChatChannel are not valid orchestrations for 'accept'", {
            type: h.FlexErrorType.app,
            context: "ChatOrchestrator"
          });
        }, e;
      }();
    t.ChatOrchestrationManager = S, t.ChatOrchestrator = new S();
  }, function (e, t) {
    e.exports = require("react-router-redux");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersType = void 0, function (e) {
      e.search = "teams-view-search", e.filter = "teams-view-filter", e.legacy = "teams-view-legacy-query";
    }(t.FiltersType || (t.FiltersType = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.loadPlugins = t.Plugins = t.PluginManager = t.PluginState = t.PluginProvider = void 0;
    var a = n(27),
      s = n(122),
      l = n(7),
      c = n(3),
      u = n(5),
      p = n(10),
      d = n(46),
      f = n(11),
      h = n(387),
      m = n(9),
      g = n(12),
      y = n(124);
    !function (e) {
      e.LegacyConsoleAsset = "LegacyConsoleAsset", e.LegacyServerlessAsset = "LegacyServerlessAsset", e.FlexSystem = "FlexSystem", e.StaticCustom = "StaticCustom", e.DynamicCustom = "DynamicCustom", e.PluginsApiV1 = "PluginsApiV1";
    }(t.PluginProvider || (t.PluginProvider = {}));
    var v,
      b = ["pluginSid", "provider", "pluginVersionSid", "configurationSid", "releaseSid"];
    !function (e) {
      e.NotStarted = "NotStarted", e.Loaded = "Loaded", e.Initialising = "Initialising", e.Initialized = "Initialized", e.Failed = "Failed";
    }(v = t.PluginState || (t.PluginState = {}));
    var C = function () {
      function e() {
        var t = this;
        this._plugins = [], this._phase = 0, this._listeners = [], this.getProxiedManager = function (n) {
          return new Proxy(t._manager, {
            get: function get(t, r, o) {
              return "workerClient" !== r && "voiceClient" !== r && "insightClient" !== r && "chatClient" !== r || g.TelemetryManager.reportSDKUsage(r, {
                pluginName: n.name,
                pluginVersion: n.version,
                options: e.getTelemetryOptions(n)
              }), Reflect.get(t, r, o);
            }
          });
        }, this.doInit = function (n, r) {
          return o(t, void 0, void 0, function () {
            var t, o, a, s, c, p, d;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  t = this._plugins.find(function (e) {
                    return e.uuid === r;
                  }), o = t.name, a = t.version, u.log.debug("loading plugin", o, n), s = null !== (d = h.getPluginProxy(o)) && void 0 !== d ? d : this._flexComponents, this.updatePluginState(r, v.Initialising), c = new n(), g.TelemetryManager.setContext({
                    currentPluginName: o,
                    currentPluginVersion: a,
                    currentOptions: e.getTelemetryOptions(t)
                  }), i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, c.init(s, this._manager ? this.getProxiedManager(t) : void 0, this._plugins)];
                case 2:
                  return i.sent(), u.log.debug("successfully loaded plugin", c.name), this.updatePluginState(r, v.Initialized), [3, 4];
                case 3:
                  return p = i.sent(), l.ErrorManager.createAndProcessError("Failed to load plugin", {
                    context: "PluginManager",
                    plugin: {
                      name: o,
                      version: a
                    },
                    wrappedError: p,
                    description: "There was an error during '" + o + "' plugin initialization"
                  }), this.updatePluginState(r, v.Failed), [3, 4];
                case 4:
                  return g.TelemetryManager.resetContext(), [2];
              }
            });
          });
        }, this.incrementPhase = function () {
          t._phase += 1, t.notifyListeners();
        }, this.notifyListeners = function () {
          t._listeners.forEach(function (e) {
            return e.callback();
          });
        }, this.createListener = function (e) {
          var n = s.v4(),
            r = {
              uuid: n,
              callback: e
            };
          return t._listeners.push(r), function () {
            var e = t._listeners.findIndex(function (e) {
              return e.uuid === n;
            });
            -1 !== e && t._listeners.splice(e, 1);
          };
        };
      }
      return e.getTelemetryOptions = function (e, t) {
        var n = {};
        return e.provider && (n.plugin_provider = e.provider), b.forEach(function (t) {
          t in e && "provider" !== t && (n[y(t)] = e[t]);
        }), t && Object.entries(t).forEach(function (e) {
          var t = e[0],
            r = e[1];
          n[t] = r;
        }), n;
      }, Object.defineProperty(e.prototype, "currentlyInitializingPlugin", {
        get: function get() {
          return this._currentlyInitializingPlugin;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "plugins", {
        get: function get() {
          return this._plugins;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "phase", {
        get: function get() {
          return this._phase;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "listeners", {
        get: function get() {
          return this._listeners;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.setup = function (e, t) {
        this._flexComponents = e, this._manager = t;
      }, e.prototype.init = function (e) {
        var n = this,
          r = document.currentScript.getAttribute("uuid");
        t.Plugins.updatePluginState(r, v.Loaded);
        var o = this.createListener(function () {
          n.canInitPlugin(r) && (o(), n.doInit(e, r));
        });
        this.canInitPlugin(r) && (o(), this.doInit(e, r));
      }, e.prototype.storePluginDefinition = function (e) {
        if (0 !== this._plugins.length) throw l.ErrorManager.createAndProcessError("Plugins can only be set once", {
          type: l.FlexErrorType.app,
          context: "PluginManager"
        });
        this._plugins = e;
      }, e.prototype.updatePluginState = function (e, t) {
        var n = this._plugins.find(function (t) {
          return t.uuid === e;
        });
        n && (t === v.Initialising ? this._currentlyInitializingPlugin = n : this._currentlyInitializingPlugin === n && (this._currentlyInitializingPlugin = void 0), n.state = t, t !== v.Failed && t !== v.Initialized || this.notifyListeners());
      }, e.prototype.canInitPlugin = function (e) {
        var t = this,
          n = this._plugins.slice(),
          r = n.filter(function (e) {
            return e.phase === t._phase;
          }),
          o = r.filter(function (e) {
            return e.state === v.NotStarted || e.state === v.Loaded;
          }),
          i = n.filter(function (t) {
            return t.uuid === e;
          })[0];
        if (!i) return u.log.warn("Could not find a loaded plugin"), !1;
        if (i.state === v.Initialized || i.state === v.Failed) return u.log.warn("Attempting to re-initialize an already initialized plugin"), !1;
        if (0 === r.length || 0 === o.length) return this.incrementPhase(), !1;
        if (!i || i.phase !== this._phase) return !1;
        if (1 === r.length) return !0;
        var a = r.findIndex(function (t) {
          return t.uuid === e;
        });
        return -1 !== a && r.slice().splice(0, a).every(function (e) {
          return e.state === v.Initialized || e.state === v.Failed;
        });
      }, e;
    }();
    t.PluginManager = C, t.Plugins = new C(), t.loadPlugins = function (e, n) {
      var g = this,
        y = n.configuration.pluginService;
      return y && y.enabled ? (u.log.debug("loading plugins ..."), t.Plugins.setup(e, n), new Promise(function (e, y) {
        return o(g, void 0, Promise, function () {
          var g,
            b,
            C,
            _,
            k,
            w = this;
          return i(this, function (S) {
            switch (S.label) {
              case 0:
                return S.trys.push([0, 3,, 4]), g = {
                  "X-Flex-JWE": c.FlexModule.state.session.ssoTokenPayload.token,
                  "X-Flex-Version": d.VERSION
                }, b = m.getPluginServiceUrl(n.configuration), [4, a.default.get(b, {
                  withCredentials: !0,
                  headers: g
                }).then(function (e) {
                  return e.data;
                }).catch(function (e) {
                  throw l.ErrorManager.createAndProcessError("Failed to reach plugin service", {
                    type: l.FlexErrorType.app,
                    context: "PluginManager",
                    description: "Failed to reach plugin service at " + b + " " + e,
                    wrappedError: e
                  });
                })];
              case 1:
                return C = S.sent(), Array.isArray(C) && 0 !== C.length ? (l.ErrorManager.updateSessionData({
                  plugins: C.map(function (e) {
                    return {
                      name: e.name
                    };
                  })
                }), _ = C.map(function (e) {
                  return r(r({
                    phase: 3
                  }, e), {
                    uuid: s.v4(),
                    state: v.NotStarted
                  });
                }), t.Plugins.storePluginDefinition(_), [4, Promise.all(_.map(function (e) {
                  return new Promise(function (n) {
                    return o(w, void 0, void 0, function () {
                      var r, o, s;
                      return i(this, function (i) {
                        switch (i.label) {
                          case 0:
                            if (u.log.debug("downloading plugin: " + e.name + " version: " + e.version), (r = document.createElement("script")).setAttribute("uuid", e.uuid), h.setupPluginProxy(e), !f.FeatureFlags.isEnabled(p.FeatureFlag.PluginRenderInjectSrc)) return e.integrity && (r.setAttribute("integrity", e.integrity), r.setAttribute("crossorigin", "anonymous")), r.src = e.src, r.async = !0, r.onload = function () {
                              u.log.debug("plugin " + e.name + " correctly downloaded from " + e.src), n(void 0);
                            }, r.onerror = function (r) {
                              l.ErrorManager.createAndProcessError("Failed to download plugin", {
                                type: l.FlexErrorType.app,
                                context: "PluginManager",
                                wrappedError: r
                              }), t.Plugins.updatePluginState(e.uuid, v.Failed), n(void 0);
                            }, document.body.appendChild(r), [2];
                            i.label = 1;
                          case 1:
                            return i.trys.push([1, 3, 4, 5]), r.setAttribute("type", "text/javascript"), [4, a.default.get(e.src, {
                              headers: g
                            }).then(function (e) {
                              return e.data;
                            })];
                          case 2:
                            if (!(o = i.sent())) throw new Error("Plugin " + e.name + " url " + e.src + " provided no sourcecode");
                            return r.textContent = o, document.body.appendChild(r), [3, 5];
                          case 3:
                            return s = i.sent(), l.ErrorManager.createAndProcessError("Failed to download plugin", {
                              type: l.FlexErrorType.app,
                              context: "PluginManager",
                              wrappedError: s
                            }), t.Plugins.updatePluginState(e.uuid, v.Failed), [3, 5];
                          case 4:
                            return n(void 0), [7];
                          case 5:
                            return [2];
                        }
                      });
                    });
                  });
                }))]) : (u.log.debug("no plugins loaded"), e(void 0), [2]);
              case 2:
                return S.sent(), c.FlexModule.events.emitPluginsLoaded(), e(void 0), [3, 4];
              case 3:
                return k = S.sent(), y(l.ErrorManager.createAndProcessError("Failed to fetch plugin configuration", {
                  type: l.FlexErrorType.app,
                  context: "PluginManager",
                  wrappedError: k
                })), [3, 4];
              case 4:
                return [2];
            }
          });
        });
      })) : (u.log.debug("plugin service not configured"), Promise.resolve());
    };
  }, function (e, t, n) {
    "use strict";

    var _r12,
      o = this && this.__extends || (_r12 = function r(e, t) {
        return (_r12 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r12(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SSOLoginHandler = t.LOGIN_SUCCESSFUL_MESSAGE = t.LOGIN_WINDOW_NAME = t.SSOConfig = void 0;
    var l = n(0),
      c = n(116),
      u = n(47),
      p = n(7),
      d = n(5),
      f = n(121);
    Object.defineProperty(t, "SSOConfig", {
      enumerable: !0,
      get: function get() {
        return f.SSOConfig;
      }
    });
    var h = n(48),
      m = n(13),
      g = n(97),
      y = n(71),
      v = n(182);
    t.LOGIN_WINDOW_NAME = "twilioFlexLoginWindow", t.LOGIN_SUCCESSFUL_MESSAGE = "TWILIO_FLEX_LOGIN_SUCCESSFUL";
    var b = {
        products: ["flex"],
        redirectUrl: window.location.href
      },
      C = function (e) {
        function n(t) {
          var n = e.call(this) || this;
          return n.externalTokenChangeCallback = function (e) {
            if (e.key === v.LOCAL_STORAGE_KEY) {
              var t,
                n = m.Manager.getInstance();
              try {
                t = JSON.parse(e.newValue);
              } catch (e) {
                p.ErrorManager.createAndProcessError("Couldn't parse externally stored token", {
                  context: "SSOLoginHandler",
                  wrappedError: e
                });
              }
              (null == t ? void 0 : t.token) && (null == n ? void 0 : n.user) && (null == t ? void 0 : t.token) !== n.user.token && l.FlexSDKManager.emit("tokenUpdated", t);
            }
          }, n._config = l.Utils.merge(b, t), n;
        }
        return o(n, e), n.create = function (e) {
          return void 0 === e && (e = {}), new n(e).initialize(!0);
        }, n.tryLogin = function (e) {
          return void 0 === e && (e = {}), a(this, void 0, Promise, function () {
            return s(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, new n(e).initialize(!1)];
                case 1:
                  return t.sent(), [2, !0];
              }
            });
          });
        }, n.tryValidateConfig = function (e) {
          return a(this, void 0, void 0, function () {
            return s(this, function (t) {
              if (!e) throw p.ErrorManager.processError(new h.ConfigError(h.ConfigErrorKeys.sso));
              if (!e.accountSid) throw p.ErrorManager.processError(new h.ConfigError(h.ConfigErrorKeys.accountSid));
              return [2];
            });
          });
        }, n.tryLoginInNewWindow = function (e) {
          return a(this, void 0, void 0, function () {
            var r,
              o = this;
            return s(this, function (i) {
              if (n.isInLoginWindow()) throw p.ErrorManager.processError(new h.ClientError(h.ClientErrorKeys.loginWindowOpenedFromLoginWindow));
              if (!e.idpUrl) throw p.ErrorManager.processError(new h.InternalError("No idpUrl"));
              if (!(r = n.openLoginWindow(e))) throw p.ErrorManager.processError(new h.BrowserError(h.BrowserErrorKeys.popupBlocked, {
                description: "Unable to open a new window to log in. Pop-up might have been blocked by browser."
              }));
              return [2, new Promise(function (e, n) {
                var i = setInterval(function () {
                  r.closed && (n(p.ErrorManager.processError(new h.BrowserError(h.BrowserErrorKeys.windowClosed))), clearInterval(i));
                }, 100);
                window.addEventListener("message", function (n) {
                  return a(o, void 0, void 0, function () {
                    return s(this, function (o) {
                      switch (o.label) {
                        case 0:
                          return n.origin !== window.location.origin ? [2] : n.data !== t.LOGIN_SUCCESSFUL_MESSAGE ? [3, 2] : (d.log.debug("Got LOGIN_SUCCESSFUL_MESSAGE"), [4, y.TokenManager.hasActiveToken()]);
                        case 1:
                          if (!o.sent()) throw p.ErrorManager.createAndProcessError("Token is invalid");
                          d.log.debug("Got token from login window"), e(void 0), clearInterval(i), r.close(), o.label = 2;
                        case 2:
                          return [2];
                      }
                    });
                  });
                });
              })];
            });
          });
        }, n.openLoginWindow = function (e) {
          var n = e.loginPopupFeatures || g.stringifyLoginWindowFeatures(g.getDefaultLoginWindowFeatures());
          return d.log.debug("opening login view in a new window", e.idpUrl, n), window.open(e.idpUrl, t.LOGIN_WINDOW_NAME, n);
        }, n.prototype.getTokenInfo = function () {
          return d.log.debug("Instance method getTokenInfo of SSOLoginHandler is deprecated. Consider using a similar static method SSOLoginHandler.getTokenInfo() instead"), n.getTokenInfo();
        }, n.getTokenInfo = function () {
          return v.TokenStorage.get();
        }, n.prototype.logout = function () {
          y.TokenManager.destroy(), v.TokenStorage.clear();
        }, n.prototype.initialize = function (e) {
          return a(this, void 0, Promise, function () {
            var r, o, i, a;
            return s(this, function (s) {
              if (r = y.TokenManager.parseTokenPayloadFromQueryString()) {
                if (n.isInLoginWindow()) {
                  if (!window.opener) throw d.log.error("window.opener is not set"), window.close(), p.ErrorManager.processError(new h.BrowserError(h.BrowserErrorKeys.noWindowOpener));
                  return y.TokenManager.storeTokenPayload(r), window.opener.postMessage(t.LOGIN_SUCCESSFUL_MESSAGE, window.location.origin), [2, Promise.reject("Logging in in another window")];
                }
                if (y.TokenManager.storeTokenPayload(r), o = g.sanitizeSSOParams(window.location.href), window.history.replaceState({}, document.title, o), !(i = document.head.querySelector("meta[name='referrer']")) || "no-referrer" !== i.getAttribute("content")) throw a = 'element <meta name="referrer" content="no-referrer"> not found in page <head> section', d.log.warn("Redirecting to clear referrer, " + a + "."), window.location.href = o, p.ErrorManager.processError(new h.ClientError(h.ClientErrorKeys.metaNoReferrerMissing, "Redirecting because " + a + "."));
              }
              return [2, this.initialiseActiveToken(e)];
            });
          });
        }, n.prototype.initialiseActiveToken = function (e) {
          return a(this, void 0, void 0, function () {
            var t,
              r,
              o,
              a,
              c,
              f,
              m = this;
            return s(this, function (s) {
              switch (s.label) {
                case 0:
                  return [4, y.TokenManager.getActiveTokenPayload()];
                case 1:
                  return !(t = s.sent()) && this._config.loginPopup && n.openLoginWindow(i(i({}, this._config), {
                    idpUrl: "about:blank"
                  })), t ? (r = Promise.resolve(this), [3, 6]) : [3, 2];
                case 2:
                  return this._config.idpUrl ? [3, 5] : (o = this.getAccountSid(), [4, g.IdpUrl.get(o, this._config)]);
                case 3:
                  return a = s.sent(), this._config.accountSid = o, this._config.idpUrl = a, d.log.debug("got the redirect url", a), [4, u.fetchPublicConfiguration({
                    accountSid: this._config.accountSid
                  })];
                case 4:
                  c = s.sent(), f = c.public_attributes || {}, this._config = l.Utils.merge(f || {}, this._config), s.label = 5;
                case 5:
                  this._config.loginPopup ? r = n.tryLoginInNewWindow(this._config) : (d.log.debug("redirecting to ", this._config.idpUrl), window.location.assign(this._config.idpUrl), r = Promise.reject(p.ErrorManager.processError(new h.BrowserError(h.BrowserErrorKeys.redirecting)))), s.label = 6;
                case 6:
                  return [2, r.then(function () {
                    return e && m.listenForExternalTokenChange(), m;
                  })];
              }
            });
          });
        }, n.prototype.getAccountSid = function () {
          var e = m.Manager.getInstance();
          if (e) return e.serviceConfiguration.account_sid;
          if (this._config.accountSid) return this._config.accountSid;
          throw p.ErrorManager.processError(new h.ConfigError(h.ConfigErrorKeys.accountSid));
        }, n.isInLoginWindow = function () {
          return window.name === t.LOGIN_WINDOW_NAME;
        }, n.prototype.listenForExternalTokenChange = function () {
          window.addEventListener("storage", this.externalTokenChangeCallback);
        }, n;
      }(c.EventEmitter);
    t.SSOLoginHandler = C;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IdpUrl = t.parseCriticalPathError = t.stringifyLoginWindowFeatures = t.getDefaultLoginWindowFeatures = t.sanitizeSSOParams = void 0;
    var i = n(27),
      a = n(7),
      s = n(6),
      l = n(48),
      c = n(9),
      u = {
        untrustedDomain: {
          code: 70002,
          status: 400
        },
        invalidCertificate: {
          code: 70251,
          status: 403
        }
      };
    function p(e) {
      return e.replace(/((Token|Expiration|Identity|Roles)=[^&]+[&]?)/g, "").replace(/[&?]$/, "");
    }
    t.sanitizeSSOParams = p, t.getDefaultLoginWindowFeatures = function () {
      return {
        toolbar: "no",
        location: "no",
        menubar: "no",
        scrollbars: "no",
        resizable: "no",
        copyhistory: "no",
        width: 600,
        height: 800
      };
    }, t.stringifyLoginWindowFeatures = function (e) {
      return e ? Object.keys(e).map(function (t) {
        return t + "=" + e[t];
      }).join(", ") : "";
    };
    var d = function d(e, t) {
      var n = e.code,
        r = e.status;
      return n === t.code && r === t.status;
    };
    t.parseCriticalPathError = function (e) {
      return r(void 0, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, s.getFlexStatus()];
            case 1:
              return t = n.sent(), e.message = "Log in failed. Please contact your administrator and try again later.", t && "operational" !== t && (e.message = "We're not able to log you in right now - this might be due to an ongoing incident we're experiencing. Contact your administrator and try again later."), [2];
          }
        });
      });
    };
    var f = function () {
      function e() {
        throw a.ErrorManager.createAndProcessError("Instance of this class can't be created", {
          type: a.FlexErrorType.app,
          description: "Instance of this class SSOLoginHandlerHelper can't be created",
          context: "SSOLoginHandlerHelper"
        });
      }
      return e.fetchRedirectURL = function (e, t) {
        return r(this, void 0, Promise, function () {
          var n, r, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return n = c.getSSOLoginUrl(t, e), r = {
                  products: (u = t).products,
                  resource: p(u.redirectUrl || "")
                }, [4, i.default.post(n, r)];
              case 1:
                if (!(s = o.sent().data).location) throw a.ErrorManager.processError(new l.InternalError("Invalid response from /authenticate endpoint", {
                  description: "No redirect location from /authenticate request, data: " + s
                }));
                return [2, s.location];
            }
            var u;
          });
        });
      }, e.get = function (n, i) {
        return r(this, void 0, Promise, function () {
          var r, s, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                if (e.accountSid === n) return [3, 8];
                e.resetCache(), e.accountSid = n, o.label = 1;
              case 1:
                return o.trys.push([1, 3,, 8]), r = e, [4, e.fetchRedirectURL(n, i)];
              case 2:
                return r.idpUrl = o.sent(), [3, 8];
              case 3:
                if (!(s = o.sent()).isAxiosError) throw e.resetCache(), a.ErrorManager.createAndProcessError("Could not fetch redirect url", {
                  type: a.FlexErrorType.app,
                  description: "Could not fetch redirect url: " + s.message,
                  context: "SSOLoginHandlerHelper",
                  wrappedError: s
                });
                return (c = s.response) && d(c.data, u[l.ValidationErrorKeys.untrustedDomain]) ? (e.error = new l.ValidationError(l.ValidationErrorKeys.untrustedDomain, {
                  wrappedError: s
                }), [3, 7]) : [3, 4];
              case 4:
                return c && d(c.data, u[l.ValidationErrorKeys.invalidCertificate]) ? (e.error = new l.ValidationError(l.ValidationErrorKeys.invalidCertificate, {
                  wrappedError: s
                }), [3, 7]) : [3, 5];
              case 5:
                return e.error = new a.FlexError(s.message, {
                  context: "IdpUrl.get",
                  wrappedError: s
                }), [4, t.parseCriticalPathError(e.error)];
              case 6:
                o.sent(), o.label = 7;
              case 7:
                return [3, 8];
              case 8:
                if (e.error) throw a.ErrorManager.processError(e.error);
                return [2, e.idpUrl];
            }
          });
        });
      }, e.resetCache = function () {
        e.accountSid = void 0, e.idpUrl = void 0, e.error = void 0;
      }, e;
    }();
    t.IdpUrl = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallMonitoringStatus = void 0, function (e) {
      e[e.none = 0] = "none", e[e.waiting = 1] = "waiting", e[e.monitoring = 2] = "monitoring";
    }(t.CallMonitoringStatus || (t.CallMonitoringStatus = {}));
  }, function (e, t, n) {
    "use strict";

    var _r13,
      o = this && this.__extends || (_r13 = function r(e, t) {
        return (_r13 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r13(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasTabs = void 0;
    var s = n(1),
      l = n(0),
      c = n(3),
      u = n(26),
      p = n(200),
      d = n(2),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(h, i({}, this.props));
        }, t.displayName = p.displayName, t.Content = p.contentStore, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.TaskCanvasTabs = f;
    var h = c.connect(function (e) {
      var t,
        n,
        r = e.view.componentViewStates.AgentTaskCanvasTabs;
      return {
        selectedTabName: !!r && r.selectedTabName,
        uniqueName: "AgentTaskCanvasTabs",
        hasMarkdownSupport: null === (n = null === (t = e.config) || void 0 === t ? void 0 : t.markdown) || void 0 === n ? void 0 : n.enabled
      };
    })(u.withTaskContext(d.withTheme(p.TaskCanvasTabsImpl)));
  }, function (e, t, n) {
    "use strict";

    var _r14,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r14 = function r(e, t) {
        return (_r14 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r14(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TranscriptContent = void 0;
    var a,
      s = n(0),
      l = n(1),
      c = n(12),
      u = n(3),
      p = s.styled("div")(a || (a = o(["\n    display: flex;\n    flex: 1;\n    justify-content: center;\n\n    .Twilio-MessageList {\n        padding: 0;\n        padding-bottom: 1em;\n    }\n"], ["\n    display: flex;\n    flex: 1;\n    justify-content: center;\n\n    .Twilio-MessageList {\n        padding: 0;\n        padding-bottom: 1em;\n    }\n"]))),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.sid,
            n = e.isLoading,
            r = e.hasError;
          return t ? l.createElement(p, null, n && l.createElement(s.CircularProgress, {
            animating: !0,
            size: 64
          }), r && l.createElement("div", null, "Could not load the transcript."), l.createElement(c.TelemetryWrapper, {
            name: "chat_monitoring",
            data: !1 === r && !1 === n ? t : void 0,
            details: {
              medium: "insights-transcript-player",
              sid: t
            }
          }, l.createElement(s.MessagingCanvas, {
            sid: this.props.sid,
            autoInitChannel: this.props.autoInitChannel,
            hideFooterOnInactive: !0,
            showWelcomeMessage: !1
          }))) : null;
        }, t;
      }(l.PureComponent);
    t.TranscriptContent = u.connect(function (e, t) {
      var n = t.mediaLink.sid || t.mediaLink.conversation_sid;
      if (n) {
        var r = e.chat.channels[n];
        return {
          sid: n,
          hasError: null == r ? void 0 : r.errorWhileLoadingChannel,
          isLoading: null == r ? void 0 : r.isLoadingChannel
        };
      }
      return {
        sid: n,
        hasError: !1,
        isLoading: !1
      };
    })(d), t.TranscriptContent.defaultProps = {
      autoInitChannel: !0
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
      i,
      a = n(0),
      s = n(1),
      l = n(21),
      c = n(4),
      u = n(2),
      p = u.default("h2")(o || (o = r(["\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 6px;\n"], ["\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 6px;\n"]))),
      d = u.default("div")(i || (i = r(["\n    padding: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    > * {\n        margin: 0 8px;\n    }\n"], ["\n    padding: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    > * {\n        margin: 0 8px;\n    }\n"])));
    t.default = function (e) {
      return l.InsightsService.hasPermission(l.InsightsPermission.Player.ViewPlayer) ? s.createElement(s.Fragment, null, e.children) : s.createElement(d, null, s.createElement(a.Icon, {
        icon: "AlertTriangle",
        sizeMultiplier: 2.3
      }), s.createElement("div", null, s.createElement(p, null, s.createElement(a.Template, {
        source: c.templates.InsightsPlayerNoPermissionToPlayContent_Title
      })), s.createElement("p", null, s.createElement(a.Template, {
        source: c.templates.InsightsPlayerNoPermissionToPlayContent_Body
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    var _r15,
      o = this && this.__extends || (_r15 = function r(e, t) {
        return (_r15 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r15(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SLAPreferencesHomePage = void 0;
    var i = n(1),
      a = n(30),
      s = n(0),
      l = n(515),
      c = n(2),
      u = n(51),
      p = n(516),
      d = n(234),
      f = n(236),
      h = c.withTheme(function (e) {
        return i.createElement(a.Section, null, i.createElement(a.SectionHeader, null, i.createElement("div", null, i.createElement(a.SectionTitle, null, i.createElement(s.Template, {
          source: s.templates.SLAPreferencesGlobalLevelsTitle
        })), i.createElement(a.SectionSubtile, null, i.createElement(s.Template, {
          source: s.templates.SLAPreferencesGlobalLevelsSubtitle
        }))), i.createElement(a.Button, {
          onClick: e.onEditBtnClick,
          "data-test": "SLA_EditGlobalServiceLevelsBtn"
        }, i.createElement(s.Template, {
          source: s.templates.SLAEditGlobalButton
        }))), i.createElement(a.SectionContent, null, i.createElement(l.GlobalSLMetricsTiles, null)));
      }),
      m = c.withTheme(function (e) {
        return i.createElement(a.Section, {
          last: !0
        }, i.createElement(a.SectionHeader, null, i.createElement("div", null, i.createElement(a.SectionTitle, null, i.createElement(s.Template, {
          source: s.templates.SLAPreferencesCustomLevelsTitle
        })), i.createElement(a.SectionSubtile, null, i.createElement(s.Template, {
          source: s.templates.SLAPreferencesCustomLevelsSubtitle
        })))), i.createElement(a.SectionContent, null, i.createElement(p.SLAQueuesList, {
          onEditQueue: e.onEditQueue
        })));
      }),
      g = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onGlobalServiceLevelEdit = function () {
            s.Actions.invokeAction("HistoryPush", d.SLAPreferencesGlobalPage.path);
          }, t.onEditQueue = function (e) {
            s.Actions.invokeAction("HistoryPush", f.SLAPreferencesQueuePage.path + "/" + e);
          }, t;
        }
        return o(t, e), Object.defineProperty(t, "path", {
          get: function get() {
            return u.slaPreferencesPath();
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.render = function () {
          return i.createElement(a.Page, null, i.createElement(a.PageHeader, {
            renderTitle: function renderTitle() {
              return i.createElement(s.Template, {
                source: s.templates.SLAPreferencesHomePageTitle
              });
            },
            renderSubtitle: function renderSubtitle() {
              return i.createElement(s.Template, {
                source: s.templates.SLAPreferencesHomePageSubtitle
              });
            }
          }), i.createElement(a.PageContent, null, i.createElement(h, {
            onEditBtnClick: this.onGlobalServiceLevelEdit
          }), i.createElement(m, {
            onEditQueue: this.onEditQueue
          })));
        }, t;
      }(i.PureComponent);
    t.SLAPreferencesHomePage = g;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.timezones = void 0, t.timezones = [{
      value: "Africa/Abidjan",
      label: "Africa/Abidjan"
    }, {
      value: "Africa/Accra",
      label: "Africa/Accra"
    }, {
      value: "Africa/Addis_Ababa",
      label: "Africa/Addis Ababa"
    }, {
      value: "Africa/Algiers",
      label: "Africa/Algiers"
    }, {
      value: "Africa/Asmara",
      label: "Africa/Asmara"
    }, {
      value: "Africa/Asmera",
      label: "Africa/Asmera"
    }, {
      value: "Africa/Bamako",
      label: "Africa/Bamako"
    }, {
      value: "Africa/Bangui",
      label: "Africa/Bangui"
    }, {
      value: "Africa/Banjul",
      label: "Africa/Banjul"
    }, {
      value: "Africa/Bissau",
      label: "Africa/Bissau"
    }, {
      value: "Africa/Blantyre",
      label: "Africa/Blantyre"
    }, {
      value: "Africa/Brazzaville",
      label: "Africa/Brazzaville"
    }, {
      value: "Africa/Bujumbura",
      label: "Africa/Bujumbura"
    }, {
      value: "Africa/Cairo",
      label: "Africa/Cairo"
    }, {
      value: "Africa/Casablanca",
      label: "Africa/Casablanca"
    }, {
      value: "Africa/Ceuta",
      label: "Africa/Ceuta"
    }, {
      value: "Africa/Conakry",
      label: "Africa/Conakry"
    }, {
      value: "Africa/Dakar",
      label: "Africa/Dakar"
    }, {
      value: "Africa/Dar_es_Salaam",
      label: "Africa/Dar es Salaam"
    }, {
      value: "Africa/Djibouti",
      label: "Africa/Djibouti"
    }, {
      value: "Africa/Douala",
      label: "Africa/Douala"
    }, {
      value: "Africa/El_Aaiun",
      label: "Africa/El Aaiun"
    }, {
      value: "Africa/Freetown",
      label: "Africa/Freetown"
    }, {
      value: "Africa/Gaborone",
      label: "Africa/Gaborone"
    }, {
      value: "Africa/Harare",
      label: "Africa/Harare"
    }, {
      value: "Africa/Johannesburg",
      label: "Africa/Johannesburg"
    }, {
      value: "Africa/Juba",
      label: "Africa/Juba"
    }, {
      value: "Africa/Kampala",
      label: "Africa/Kampala"
    }, {
      value: "Africa/Khartoum",
      label: "Africa/Khartoum"
    }, {
      value: "Africa/Kigali",
      label: "Africa/Kigali"
    }, {
      value: "Africa/Kinshasa",
      label: "Africa/Kinshasa"
    }, {
      value: "Africa/Lagos",
      label: "Africa/Lagos"
    }, {
      value: "Africa/Libreville",
      label: "Africa/Libreville"
    }, {
      value: "Africa/Lome",
      label: "Africa/Lome"
    }, {
      value: "Africa/Luanda",
      label: "Africa/Luanda"
    }, {
      value: "Africa/Lubumbashi",
      label: "Africa/Lubumbashi"
    }, {
      value: "Africa/Lusaka",
      label: "Africa/Lusaka"
    }, {
      value: "Africa/Malabo",
      label: "Africa/Malabo"
    }, {
      value: "Africa/Maputo",
      label: "Africa/Maputo"
    }, {
      value: "Africa/Maseru",
      label: "Africa/Maseru"
    }, {
      value: "Africa/Mbabane",
      label: "Africa/Mbabane"
    }, {
      value: "Africa/Mogadishu",
      label: "Africa/Mogadishu"
    }, {
      value: "Africa/Monrovia",
      label: "Africa/Monrovia"
    }, {
      value: "Africa/Nairobi",
      label: "Africa/Nairobi"
    }, {
      value: "Africa/Ndjamena",
      label: "Africa/Ndjamena"
    }, {
      value: "Africa/Niamey",
      label: "Africa/Niamey"
    }, {
      value: "Africa/Nouakchott",
      label: "Africa/Nouakchott"
    }, {
      value: "Africa/Ouagadougou",
      label: "Africa/Ouagadougou"
    }, {
      value: "Africa/Porto-Novo",
      label: "Africa/Porto-Novo"
    }, {
      value: "Africa/Sao_Tome",
      label: "Africa/Sao Tome"
    }, {
      value: "Africa/Timbuktu",
      label: "Africa/Timbuktu"
    }, {
      value: "Africa/Tripoli",
      label: "Africa/Tripoli"
    }, {
      value: "Africa/Tunis",
      label: "Africa/Tunis"
    }, {
      value: "Africa/Windhoek",
      label: "Africa/Windhoek"
    }, {
      value: "America/Adak",
      label: "America/Adak"
    }, {
      value: "America/Anchorage",
      label: "America/Anchorage"
    }, {
      value: "America/Anguilla",
      label: "America/Anguilla"
    }, {
      value: "America/Antigua",
      label: "America/Antigua"
    }, {
      value: "America/Araguaina",
      label: "America/Araguaina"
    }, {
      value: "America/Argentina/Buenos_Aires",
      label: "America/Argentina/Buenos Aires"
    }, {
      value: "America/Argentina/Catamarca",
      label: "America/Argentina/Catamarca"
    }, {
      value: "America/Argentina/ComodRivadavia",
      label: "America/Argentina/ComodRivadavia"
    }, {
      value: "America/Argentina/Cordoba",
      label: "America/Argentina/Cordoba"
    }, {
      value: "America/Argentina/Jujuy",
      label: "America/Argentina/Jujuy"
    }, {
      value: "America/Argentina/La_Rioja",
      label: "America/Argentina/La Rioja"
    }, {
      value: "America/Argentina/Mendoza",
      label: "America/Argentina/Mendoza"
    }, {
      value: "America/Argentina/Rio_Gallegos",
      label: "America/Argentina/Rio Gallegos"
    }, {
      value: "America/Argentina/Salta",
      label: "America/Argentina/Salta"
    }, {
      value: "America/Argentina/San_Juan",
      label: "America/Argentina/San Juan"
    }, {
      value: "America/Argentina/San_Luis",
      label: "America/Argentina/San Luis"
    }, {
      value: "America/Argentina/Tucuman",
      label: "America/Argentina/Tucuman"
    }, {
      value: "America/Argentina/Ushuaia",
      label: "America/Argentina/Ushuaia"
    }, {
      value: "America/Aruba",
      label: "America/Aruba"
    }, {
      value: "America/Asuncion",
      label: "America/Asuncion"
    }, {
      value: "America/Atikokan",
      label: "America/Atikokan"
    }, {
      value: "America/Atka",
      label: "America/Atka"
    }, {
      value: "America/Bahia",
      label: "America/Bahia"
    }, {
      value: "America/Bahia_Banderas",
      label: "America/Bahia Banderas"
    }, {
      value: "America/Barbados",
      label: "America/Barbados"
    }, {
      value: "America/Belem",
      label: "America/Belem"
    }, {
      value: "America/Belize",
      label: "America/Belize"
    }, {
      value: "America/Blanc-Sablon",
      label: "America/Blanc-Sablon"
    }, {
      value: "America/Boa_Vista",
      label: "America/Boa Vista"
    }, {
      value: "America/Bogota",
      label: "America/Bogota"
    }, {
      value: "America/Boise",
      label: "America/Boise"
    }, {
      value: "America/Buenos_Aires",
      label: "America/Buenos Aires"
    }, {
      value: "America/Cambridge_Bay",
      label: "America/Cambridge Bay"
    }, {
      value: "America/Campo_Grande",
      label: "America/Campo Grande"
    }, {
      value: "America/Cancun",
      label: "America/Cancun"
    }, {
      value: "America/Caracas",
      label: "America/Caracas"
    }, {
      value: "America/Catamarca",
      label: "America/Catamarca"
    }, {
      value: "America/Cayenne",
      label: "America/Cayenne"
    }, {
      value: "America/Cayman",
      label: "America/Cayman"
    }, {
      value: "America/Chicago",
      label: "America/Chicago"
    }, {
      value: "America/Chihuahua",
      label: "America/Chihuahua"
    }, {
      value: "America/Coral_Harbour",
      label: "America/Coral Harbour"
    }, {
      value: "America/Cordoba",
      label: "America/Cordoba"
    }, {
      value: "America/Costa_Rica",
      label: "America/Costa Rica"
    }, {
      value: "America/Creston",
      label: "America/Creston"
    }, {
      value: "America/Cuiaba",
      label: "America/Cuiaba"
    }, {
      value: "America/Curacao",
      label: "America/Curacao"
    }, {
      value: "America/Danmarkshavn",
      label: "America/Danmarkshavn"
    }, {
      value: "America/Dawson",
      label: "America/Dawson"
    }, {
      value: "America/Dawson_Creek",
      label: "America/Dawson Creek"
    }, {
      value: "America/Denver",
      label: "America/Denver"
    }, {
      value: "America/Detroit",
      label: "America/Detroit"
    }, {
      value: "America/Dominica",
      label: "America/Dominica"
    }, {
      value: "America/Edmonton",
      label: "America/Edmonton"
    }, {
      value: "America/Eirunepe",
      label: "America/Eirunepe"
    }, {
      value: "America/El_Salvador",
      label: "America/El Salvador"
    }, {
      value: "America/Ensenada",
      label: "America/Ensenada"
    }, {
      value: "America/Fort_Nelson",
      label: "America/Fort Nelson"
    }, {
      value: "America/Fort_Wayne",
      label: "America/Fort Wayne"
    }, {
      value: "America/Fortaleza",
      label: "America/Fortaleza"
    }, {
      value: "America/Glace_Bay",
      label: "America/Glace Bay"
    }, {
      value: "America/Godthab",
      label: "America/Godthab"
    }, {
      value: "America/Goose_Bay",
      label: "America/Goose Bay"
    }, {
      value: "America/Grand_Turk",
      label: "America/Grand Turk"
    }, {
      value: "America/Grenada",
      label: "America/Grenada"
    }, {
      value: "America/Guadeloupe",
      label: "America/Guadeloupe"
    }, {
      value: "America/Guatemala",
      label: "America/Guatemala"
    }, {
      value: "America/Guayaquil",
      label: "America/Guayaquil"
    }, {
      value: "America/Guyana",
      label: "America/Guyana"
    }, {
      value: "America/Halifax",
      label: "America/Halifax"
    }, {
      value: "America/Havana",
      label: "America/Havana"
    }, {
      value: "America/Hermosillo",
      label: "America/Hermosillo"
    }, {
      value: "America/Indiana/Indianapolis",
      label: "America/Indiana/Indianapolis"
    }, {
      value: "America/Indiana/Knox",
      label: "America/Indiana/Knox"
    }, {
      value: "America/Indiana/Marengo",
      label: "America/Indiana/Marengo"
    }, {
      value: "America/Indiana/Petersburg",
      label: "America/Indiana/Petersburg"
    }, {
      value: "America/Indiana/Tell_City",
      label: "America/Indiana/Tell City"
    }, {
      value: "America/Indiana/Vevay",
      label: "America/Indiana/Vevay"
    }, {
      value: "America/Indiana/Vincennes",
      label: "America/Indiana/Vincennes"
    }, {
      value: "America/Indiana/Winamac",
      label: "America/Indiana/Winamac"
    }, {
      value: "America/Indianapolis",
      label: "America/Indianapolis"
    }, {
      value: "America/Inuvik",
      label: "America/Inuvik"
    }, {
      value: "America/Iqaluit",
      label: "America/Iqaluit"
    }, {
      value: "America/Jamaica",
      label: "America/Jamaica"
    }, {
      value: "America/Jujuy",
      label: "America/Jujuy"
    }, {
      value: "America/Juneau",
      label: "America/Juneau"
    }, {
      value: "America/Kentucky/Louisville",
      label: "America/Kentucky/Louisville"
    }, {
      value: "America/Kentucky/Monticello",
      label: "America/Kentucky/Monticello"
    }, {
      value: "America/Knox_IN",
      label: "America/Knox IN"
    }, {
      value: "America/Kralendijk",
      label: "America/Kralendijk"
    }, {
      value: "America/La_Paz",
      label: "America/La Paz"
    }, {
      value: "America/Lima",
      label: "America/Lima"
    }, {
      value: "America/Los_Angeles",
      label: "America/Los Angeles"
    }, {
      value: "America/Louisville",
      label: "America/Louisville"
    }, {
      value: "America/Lower_Princes",
      label: "America/Lower Princes"
    }, {
      value: "America/Maceio",
      label: "America/Maceio"
    }, {
      value: "America/Managua",
      label: "America/Managua"
    }, {
      value: "America/Manaus",
      label: "America/Manaus"
    }, {
      value: "America/Marigot",
      label: "America/Marigot"
    }, {
      value: "America/Martinique",
      label: "America/Martinique"
    }, {
      value: "America/Matamoros",
      label: "America/Matamoros"
    }, {
      value: "America/Mazatlan",
      label: "America/Mazatlan"
    }, {
      value: "America/Mendoza",
      label: "America/Mendoza"
    }, {
      value: "America/Menominee",
      label: "America/Menominee"
    }, {
      value: "America/Merida",
      label: "America/Merida"
    }, {
      value: "America/Metlakatla",
      label: "America/Metlakatla"
    }, {
      value: "America/Mexico_City",
      label: "America/Mexico City"
    }, {
      value: "America/Miquelon",
      label: "America/Miquelon"
    }, {
      value: "America/Moncton",
      label: "America/Moncton"
    }, {
      value: "America/Monterrey",
      label: "America/Monterrey"
    }, {
      value: "America/Montevideo",
      label: "America/Montevideo"
    }, {
      value: "America/Montreal",
      label: "America/Montreal"
    }, {
      value: "America/Montserrat",
      label: "America/Montserrat"
    }, {
      value: "America/Nassau",
      label: "America/Nassau"
    }, {
      value: "America/New_York",
      label: "America/New York"
    }, {
      value: "America/Nipigon",
      label: "America/Nipigon"
    }, {
      value: "America/Nome",
      label: "America/Nome"
    }, {
      value: "America/Noronha",
      label: "America/Noronha"
    }, {
      value: "America/North_Dakota/Beulah",
      label: "America/North Dakota/Beulah"
    }, {
      value: "America/North_Dakota/Center",
      label: "America/North Dakota/Center"
    }, {
      value: "America/North_Dakota/New_Salem",
      label: "America/North Dakota/New Salem"
    }, {
      value: "America/Ojinaga",
      label: "America/Ojinaga"
    }, {
      value: "America/Panama",
      label: "America/Panama"
    }, {
      value: "America/Pangnirtung",
      label: "America/Pangnirtung"
    }, {
      value: "America/Paramaribo",
      label: "America/Paramaribo"
    }, {
      value: "America/Phoenix",
      label: "America/Phoenix"
    }, {
      value: "America/Port-au-Prince",
      label: "America/Port-au-Prince"
    }, {
      value: "America/Port_of_Spain",
      label: "America/Port of Spain"
    }, {
      value: "America/Porto_Acre",
      label: "America/Porto Acre"
    }, {
      value: "America/Porto_Velho",
      label: "America/Porto Velho"
    }, {
      value: "America/Puerto_Rico",
      label: "America/Puerto Rico"
    }, {
      value: "America/Punta_Arenas",
      label: "America/Punta Arenas"
    }, {
      value: "America/Rainy_River",
      label: "America/Rainy River"
    }, {
      value: "America/Rankin_Inlet",
      label: "America/Rankin Inlet"
    }, {
      value: "America/Recife",
      label: "America/Recife"
    }, {
      value: "America/Regina",
      label: "America/Regina"
    }, {
      value: "America/Resolute",
      label: "America/Resolute"
    }, {
      value: "America/Rio_Branco",
      label: "America/Rio Branco"
    }, {
      value: "America/Rosario",
      label: "America/Rosario"
    }, {
      value: "America/Santa_Isabel",
      label: "America/Santa Isabel"
    }, {
      value: "America/Santarem",
      label: "America/Santarem"
    }, {
      value: "America/Santiago",
      label: "America/Santiago"
    }, {
      value: "America/Santo_Domingo",
      label: "America/Santo Domingo"
    }, {
      value: "America/Sao_Paulo",
      label: "America/Sao Paulo"
    }, {
      value: "America/Scoresbysund",
      label: "America/Scoresbysund"
    }, {
      value: "America/Shiprock",
      label: "America/Shiprock"
    }, {
      value: "America/Sitka",
      label: "America/Sitka"
    }, {
      value: "America/St_Barthelemy",
      label: "America/St Barthelemy"
    }, {
      value: "America/St_Johns",
      label: "America/St Johns"
    }, {
      value: "America/St_Kitts",
      label: "America/St Kitts"
    }, {
      value: "America/St_Lucia",
      label: "America/St Lucia"
    }, {
      value: "America/St_Thomas",
      label: "America/St Thomas"
    }, {
      value: "America/St_Vincent",
      label: "America/St Vincent"
    }, {
      value: "America/Swift_Current",
      label: "America/Swift Current"
    }, {
      value: "America/Tegucigalpa",
      label: "America/Tegucigalpa"
    }, {
      value: "America/Thule",
      label: "America/Thule"
    }, {
      value: "America/Thunder_Bay",
      label: "America/Thunder Bay"
    }, {
      value: "America/Tijuana",
      label: "America/Tijuana"
    }, {
      value: "America/Toronto",
      label: "America/Toronto"
    }, {
      value: "America/Tortola",
      label: "America/Tortola"
    }, {
      value: "America/Vancouver",
      label: "America/Vancouver"
    }, {
      value: "America/Virgin",
      label: "America/Virgin"
    }, {
      value: "America/Whitehorse",
      label: "America/Whitehorse"
    }, {
      value: "America/Winnipeg",
      label: "America/Winnipeg"
    }, {
      value: "America/Yakutat",
      label: "America/Yakutat"
    }, {
      value: "America/Yellowknife",
      label: "America/Yellowknife"
    }, {
      value: "Antarctica/Casey",
      label: "Antarctica/Casey"
    }, {
      value: "Antarctica/Davis",
      label: "Antarctica/Davis"
    }, {
      value: "Antarctica/DumontDUrville",
      label: "Antarctica/DumontDUrville"
    }, {
      value: "Antarctica/Macquarie",
      label: "Antarctica/Macquarie"
    }, {
      value: "Antarctica/Mawson",
      label: "Antarctica/Mawson"
    }, {
      value: "Antarctica/McMurdo",
      label: "Antarctica/McMurdo"
    }, {
      value: "Antarctica/Palmer",
      label: "Antarctica/Palmer"
    }, {
      value: "Antarctica/Rothera",
      label: "Antarctica/Rothera"
    }, {
      value: "Antarctica/South_Pole",
      label: "Antarctica/South Pole"
    }, {
      value: "Antarctica/Syowa",
      label: "Antarctica/Syowa"
    }, {
      value: "Antarctica/Troll",
      label: "Antarctica/Troll"
    }, {
      value: "Antarctica/Vostok",
      label: "Antarctica/Vostok"
    }, {
      value: "Arctic/Longyearbyen",
      label: "Arctic/Longyearbyen"
    }, {
      value: "Asia/Aden",
      label: "Asia/Aden"
    }, {
      value: "Asia/Almaty",
      label: "Asia/Almaty"
    }, {
      value: "Asia/Amman",
      label: "Asia/Amman"
    }, {
      value: "Asia/Anadyr",
      label: "Asia/Anadyr"
    }, {
      value: "Asia/Aqtau",
      label: "Asia/Aqtau"
    }, {
      value: "Asia/Aqtobe",
      label: "Asia/Aqtobe"
    }, {
      value: "Asia/Ashgabat",
      label: "Asia/Ashgabat"
    }, {
      value: "Asia/Ashkhabad",
      label: "Asia/Ashkhabad"
    }, {
      value: "Asia/Atyrau",
      label: "Asia/Atyrau"
    }, {
      value: "Asia/Baghdad",
      label: "Asia/Baghdad"
    }, {
      value: "Asia/Bahrain",
      label: "Asia/Bahrain"
    }, {
      value: "Asia/Baku",
      label: "Asia/Baku"
    }, {
      value: "Asia/Bangkok",
      label: "Asia/Bangkok"
    }, {
      value: "Asia/Barnaul",
      label: "Asia/Barnaul"
    }, {
      value: "Asia/Beirut",
      label: "Asia/Beirut"
    }, {
      value: "Asia/Bishkek",
      label: "Asia/Bishkek"
    }, {
      value: "Asia/Brunei",
      label: "Asia/Brunei"
    }, {
      value: "Asia/Calcutta",
      label: "Asia/Calcutta"
    }, {
      value: "Asia/Chita",
      label: "Asia/Chita"
    }, {
      value: "Asia/Choibalsan",
      label: "Asia/Choibalsan"
    }, {
      value: "Asia/Chongqing",
      label: "Asia/Chongqing"
    }, {
      value: "Asia/Chungking",
      label: "Asia/Chungking"
    }, {
      value: "Asia/Colombo",
      label: "Asia/Colombo"
    }, {
      value: "Asia/Dacca",
      label: "Asia/Dacca"
    }, {
      value: "Asia/Damascus",
      label: "Asia/Damascus"
    }, {
      value: "Asia/Dhaka",
      label: "Asia/Dhaka"
    }, {
      value: "Asia/Dili",
      label: "Asia/Dili"
    }, {
      value: "Asia/Dubai",
      label: "Asia/Dubai"
    }, {
      value: "Asia/Dushanbe",
      label: "Asia/Dushanbe"
    }, {
      value: "Asia/Famagusta",
      label: "Asia/Famagusta"
    }, {
      value: "Asia/Gaza",
      label: "Asia/Gaza"
    }, {
      value: "Asia/Harbin",
      label: "Asia/Harbin"
    }, {
      value: "Asia/Hebron",
      label: "Asia/Hebron"
    }, {
      value: "Asia/Ho_Chi_Minh",
      label: "Asia/Ho Chi Minh"
    }, {
      value: "Asia/Hong_Kong",
      label: "Asia/Hong Kong"
    }, {
      value: "Asia/Hovd",
      label: "Asia/Hovd"
    }, {
      value: "Asia/Irkutsk",
      label: "Asia/Irkutsk"
    }, {
      value: "Asia/Istanbul",
      label: "Asia/Istanbul"
    }, {
      value: "Asia/Jakarta",
      label: "Asia/Jakarta"
    }, {
      value: "Asia/Jayapura",
      label: "Asia/Jayapura"
    }, {
      value: "Asia/Jerusalem",
      label: "Asia/Jerusalem"
    }, {
      value: "Asia/Kabul",
      label: "Asia/Kabul"
    }, {
      value: "Asia/Kamchatka",
      label: "Asia/Kamchatka"
    }, {
      value: "Asia/Karachi",
      label: "Asia/Karachi"
    }, {
      value: "Asia/Kashgar",
      label: "Asia/Kashgar"
    }, {
      value: "Asia/Kathmandu",
      label: "Asia/Kathmandu"
    }, {
      value: "Asia/Katmandu",
      label: "Asia/Katmandu"
    }, {
      value: "Asia/Khandyga",
      label: "Asia/Khandyga"
    }, {
      value: "Asia/Kolkata",
      label: "Asia/Kolkata"
    }, {
      value: "Asia/Krasnoyarsk",
      label: "Asia/Krasnoyarsk"
    }, {
      value: "Asia/Kuala_Lumpur",
      label: "Asia/Kuala Lumpur"
    }, {
      value: "Asia/Kuching",
      label: "Asia/Kuching"
    }, {
      value: "Asia/Kuwait",
      label: "Asia/Kuwait"
    }, {
      value: "Asia/Macao",
      label: "Asia/Macao"
    }, {
      value: "Asia/Macau",
      label: "Asia/Macau"
    }, {
      value: "Asia/Magadan",
      label: "Asia/Magadan"
    }, {
      value: "Asia/Makassar",
      label: "Asia/Makassar"
    }, {
      value: "Asia/Manila",
      label: "Asia/Manila"
    }, {
      value: "Asia/Muscat",
      label: "Asia/Muscat"
    }, {
      value: "Asia/Nicosia",
      label: "Asia/Nicosia"
    }, {
      value: "Asia/Novokuznetsk",
      label: "Asia/Novokuznetsk"
    }, {
      value: "Asia/Novosibirsk",
      label: "Asia/Novosibirsk"
    }, {
      value: "Asia/Omsk",
      label: "Asia/Omsk"
    }, {
      value: "Asia/Oral",
      label: "Asia/Oral"
    }, {
      value: "Asia/Phnom_Penh",
      label: "Asia/Phnom Penh"
    }, {
      value: "Asia/Pontianak",
      label: "Asia/Pontianak"
    }, {
      value: "Asia/Pyongyang",
      label: "Asia/Pyongyang"
    }, {
      value: "Asia/Qatar",
      label: "Asia/Qatar"
    }, {
      value: "Asia/Qostanay",
      label: "Asia/Qostanay"
    }, {
      value: "Asia/Qyzylorda",
      label: "Asia/Qyzylorda"
    }, {
      value: "Asia/Rangoon",
      label: "Asia/Rangoon"
    }, {
      value: "Asia/Riyadh",
      label: "Asia/Riyadh"
    }, {
      value: "Asia/Saigon",
      label: "Asia/Saigon"
    }, {
      value: "Asia/Sakhalin",
      label: "Asia/Sakhalin"
    }, {
      value: "Asia/Samarkand",
      label: "Asia/Samarkand"
    }, {
      value: "Asia/Seoul",
      label: "Asia/Seoul"
    }, {
      value: "Asia/Shanghai",
      label: "Asia/Shanghai"
    }, {
      value: "Asia/Singapore",
      label: "Asia/Singapore"
    }, {
      value: "Asia/Srednekolymsk",
      label: "Asia/Srednekolymsk"
    }, {
      value: "Asia/Taipei",
      label: "Asia/Taipei"
    }, {
      value: "Asia/Tashkent",
      label: "Asia/Tashkent"
    }, {
      value: "Asia/Tbilisi",
      label: "Asia/Tbilisi"
    }, {
      value: "Asia/Tehran",
      label: "Asia/Tehran"
    }, {
      value: "Asia/Tel_Aviv",
      label: "Asia/Tel Aviv"
    }, {
      value: "Asia/Thimbu",
      label: "Asia/Thimbu"
    }, {
      value: "Asia/Thimphu",
      label: "Asia/Thimphu"
    }, {
      value: "Asia/Tokyo",
      label: "Asia/Tokyo"
    }, {
      value: "Asia/Tomsk",
      label: "Asia/Tomsk"
    }, {
      value: "Asia/Ujung_Pandang",
      label: "Asia/Ujung Pandang"
    }, {
      value: "Asia/Ulaanbaatar",
      label: "Asia/Ulaanbaatar"
    }, {
      value: "Asia/Ulan_Bator",
      label: "Asia/Ulan Bator"
    }, {
      value: "Asia/Urumqi",
      label: "Asia/Urumqi"
    }, {
      value: "Asia/Ust-Nera",
      label: "Asia/Ust-Nera"
    }, {
      value: "Asia/Vientiane",
      label: "Asia/Vientiane"
    }, {
      value: "Asia/Vladivostok",
      label: "Asia/Vladivostok"
    }, {
      value: "Asia/Yakutsk",
      label: "Asia/Yakutsk"
    }, {
      value: "Asia/Yangon",
      label: "Asia/Yangon"
    }, {
      value: "Asia/Yekaterinburg",
      label: "Asia/Yekaterinburg"
    }, {
      value: "Asia/Yerevan",
      label: "Asia/Yerevan"
    }, {
      value: "Atlantic/Azores",
      label: "Atlantic/Azores"
    }, {
      value: "Atlantic/Bermuda",
      label: "Atlantic/Bermuda"
    }, {
      value: "Atlantic/Canary",
      label: "Atlantic/Canary"
    }, {
      value: "Atlantic/Cape_Verde",
      label: "Atlantic/Cape Verde"
    }, {
      value: "Atlantic/Faeroe",
      label: "Atlantic/Faeroe"
    }, {
      value: "Atlantic/Faroe",
      label: "Atlantic/Faroe"
    }, {
      value: "Atlantic/Jan_Mayen",
      label: "Atlantic/Jan Mayen"
    }, {
      value: "Atlantic/Madeira",
      label: "Atlantic/Madeira"
    }, {
      value: "Atlantic/Reykjavik",
      label: "Atlantic/Reykjavik"
    }, {
      value: "Atlantic/South_Georgia",
      label: "Atlantic/South Georgia"
    }, {
      value: "Atlantic/St_Helena",
      label: "Atlantic/St Helena"
    }, {
      value: "Atlantic/Stanley",
      label: "Atlantic/Stanley"
    }, {
      value: "Australia/ACT",
      label: "Australia/ACT"
    }, {
      value: "Australia/Adelaide",
      label: "Australia/Adelaide"
    }, {
      value: "Australia/Brisbane",
      label: "Australia/Brisbane"
    }, {
      value: "Australia/Broken_Hill",
      label: "Australia/Broken Hill"
    }, {
      value: "Australia/Canberra",
      label: "Australia/Canberra"
    }, {
      value: "Australia/Currie",
      label: "Australia/Currie"
    }, {
      value: "Australia/Darwin",
      label: "Australia/Darwin"
    }, {
      value: "Australia/Eucla",
      label: "Australia/Eucla"
    }, {
      value: "Australia/Hobart",
      label: "Australia/Hobart"
    }, {
      value: "Australia/LHI",
      label: "Australia/LHI"
    }, {
      value: "Australia/Lindeman",
      label: "Australia/Lindeman"
    }, {
      value: "Australia/Lord_Howe",
      label: "Australia/Lord Howe"
    }, {
      value: "Australia/Melbourne",
      label: "Australia/Melbourne"
    }, {
      value: "Australia/NSW",
      label: "Australia/NSW"
    }, {
      value: "Australia/North",
      label: "Australia/North"
    }, {
      value: "Australia/Perth",
      label: "Australia/Perth"
    }, {
      value: "Australia/Queensland",
      label: "Australia/Queensland"
    }, {
      value: "Australia/South",
      label: "Australia/South"
    }, {
      value: "Australia/Sydney",
      label: "Australia/Sydney"
    }, {
      value: "Australia/Tasmania",
      label: "Australia/Tasmania"
    }, {
      value: "Australia/Victoria",
      label: "Australia/Victoria"
    }, {
      value: "Australia/West",
      label: "Australia/West"
    }, {
      value: "Australia/Yancowinna",
      label: "Australia/Yancowinna"
    }, {
      value: "Brazil/Acre",
      label: "Brazil/Acre"
    }, {
      value: "Brazil/DeNoronha",
      label: "Brazil/DeNoronha"
    }, {
      value: "Brazil/East",
      label: "Brazil/East"
    }, {
      value: "Brazil/West",
      label: "Brazil/West"
    }, {
      value: "CET",
      label: "CET"
    }, {
      value: "Canada/Atlantic",
      label: "Canada/Atlantic"
    }, {
      value: "Canada/Central",
      label: "Canada/Central"
    }, {
      value: "Canada/Eastern",
      label: "Canada/Eastern"
    }, {
      value: "Canada/Mountain",
      label: "Canada/Mountain"
    }, {
      value: "Canada/Newfoundland",
      label: "Canada/Newfoundland"
    }, {
      value: "Canada/Pacific",
      label: "Canada/Pacific"
    }, {
      value: "Canada/Saskatchewan",
      label: "Canada/Saskatchewan"
    }, {
      value: "Canada/Yukon",
      label: "Canada/Yukon"
    }, {
      value: "Chile/Continental",
      label: "Chile/Continental"
    }, {
      value: "Chile/EasterIsland",
      label: "Chile/EasterIsland"
    }, {
      value: "Cuba",
      label: "Cuba"
    }, {
      value: "EET",
      label: "EET"
    }, {
      value: "Egypt",
      label: "Egypt"
    }, {
      value: "Eire",
      label: "Eire"
    }, {
      value: "Europe/Amsterdam",
      label: "Europe/Amsterdam"
    }, {
      value: "Europe/Andorra",
      label: "Europe/Andorra"
    }, {
      value: "Europe/Astrakhan",
      label: "Europe/Astrakhan"
    }, {
      value: "Europe/Athens",
      label: "Europe/Athens"
    }, {
      value: "Europe/Belfast",
      label: "Europe/Belfast"
    }, {
      value: "Europe/Belgrade",
      label: "Europe/Belgrade"
    }, {
      value: "Europe/Berlin",
      label: "Europe/Berlin"
    }, {
      value: "Europe/Bratislava",
      label: "Europe/Bratislava"
    }, {
      value: "Europe/Brussels",
      label: "Europe/Brussels"
    }, {
      value: "Europe/Bucharest",
      label: "Europe/Bucharest"
    }, {
      value: "Europe/Budapest",
      label: "Europe/Budapest"
    }, {
      value: "Europe/Busingen",
      label: "Europe/Busingen"
    }, {
      value: "Europe/Chisinau",
      label: "Europe/Chisinau"
    }, {
      value: "Europe/Copenhagen",
      label: "Europe/Copenhagen"
    }, {
      value: "Europe/Dublin",
      label: "Europe/Dublin"
    }, {
      value: "Europe/Gibraltar",
      label: "Europe/Gibraltar"
    }, {
      value: "Europe/Guernsey",
      label: "Europe/Guernsey"
    }, {
      value: "Europe/Helsinki",
      label: "Europe/Helsinki"
    }, {
      value: "Europe/Isle_of_Man",
      label: "Europe/Isle of Man"
    }, {
      value: "Europe/Istanbul",
      label: "Europe/Istanbul"
    }, {
      value: "Europe/Jersey",
      label: "Europe/Jersey"
    }, {
      value: "Europe/Kaliningrad",
      label: "Europe/Kaliningrad"
    }, {
      value: "Europe/Kiev",
      label: "Europe/Kiev"
    }, {
      value: "Europe/Kirov",
      label: "Europe/Kirov"
    }, {
      value: "Europe/Lisbon",
      label: "Europe/Lisbon"
    }, {
      value: "Europe/Ljubljana",
      label: "Europe/Ljubljana"
    }, {
      value: "Europe/London",
      label: "Europe/London"
    }, {
      value: "Europe/Luxembourg",
      label: "Europe/Luxembourg"
    }, {
      value: "Europe/Madrid",
      label: "Europe/Madrid"
    }, {
      value: "Europe/Malta",
      label: "Europe/Malta"
    }, {
      value: "Europe/Mariehamn",
      label: "Europe/Mariehamn"
    }, {
      value: "Europe/Minsk",
      label: "Europe/Minsk"
    }, {
      value: "Europe/Monaco",
      label: "Europe/Monaco"
    }, {
      value: "Europe/Moscow",
      label: "Europe/Moscow"
    }, {
      value: "Europe/Nicosia",
      label: "Europe/Nicosia"
    }, {
      value: "Europe/Oslo",
      label: "Europe/Oslo"
    }, {
      value: "Europe/Paris",
      label: "Europe/Paris"
    }, {
      value: "Europe/Podgorica",
      label: "Europe/Podgorica"
    }, {
      value: "Europe/Prague",
      label: "Europe/Prague"
    }, {
      value: "Europe/Riga",
      label: "Europe/Riga"
    }, {
      value: "Europe/Rome",
      label: "Europe/Rome"
    }, {
      value: "Europe/Samara",
      label: "Europe/Samara"
    }, {
      value: "Europe/San_Marino",
      label: "Europe/San Marino"
    }, {
      value: "Europe/Sarajevo",
      label: "Europe/Sarajevo"
    }, {
      value: "Europe/Saratov",
      label: "Europe/Saratov"
    }, {
      value: "Europe/Simferopol",
      label: "Europe/Simferopol"
    }, {
      value: "Europe/Skopje",
      label: "Europe/Skopje"
    }, {
      value: "Europe/Sofia",
      label: "Europe/Sofia"
    }, {
      value: "Europe/Stockholm",
      label: "Europe/Stockholm"
    }, {
      value: "Europe/Tallinn",
      label: "Europe/Tallinn"
    }, {
      value: "Europe/Tirane",
      label: "Europe/Tirane"
    }, {
      value: "Europe/Tiraspol",
      label: "Europe/Tiraspol"
    }, {
      value: "Europe/Ulyanovsk",
      label: "Europe/Ulyanovsk"
    }, {
      value: "Europe/Uzhgorod",
      label: "Europe/Uzhgorod"
    }, {
      value: "Europe/Vaduz",
      label: "Europe/Vaduz"
    }, {
      value: "Europe/Vatican",
      label: "Europe/Vatican"
    }, {
      value: "Europe/Vienna",
      label: "Europe/Vienna"
    }, {
      value: "Europe/Vilnius",
      label: "Europe/Vilnius"
    }, {
      value: "Europe/Volgograd",
      label: "Europe/Volgograd"
    }, {
      value: "Europe/Warsaw",
      label: "Europe/Warsaw"
    }, {
      value: "Europe/Zagreb",
      label: "Europe/Zagreb"
    }, {
      value: "Europe/Zaporozhye",
      label: "Europe/Zaporozhye"
    }, {
      value: "Europe/Zurich",
      label: "Europe/Zurich"
    }, {
      value: "GB",
      label: "GB"
    }, {
      value: "GB-Eire",
      label: "GB-Eire"
    }, {
      value: "GMT",
      label: "GMT"
    }, {
      value: "Greenwich",
      label: "Greenwich"
    }, {
      value: "Hongkong",
      label: "Hongkong"
    }, {
      value: "Iceland",
      label: "Iceland"
    }, {
      value: "Indian/Antananarivo",
      label: "Indian/Antananarivo"
    }, {
      value: "Indian/Chagos",
      label: "Indian/Chagos"
    }, {
      value: "Indian/Christmas",
      label: "Indian/Christmas"
    }, {
      value: "Indian/Cocos",
      label: "Indian/Cocos"
    }, {
      value: "Indian/Comoro",
      label: "Indian/Comoro"
    }, {
      value: "Indian/Kerguelen",
      label: "Indian/Kerguelen"
    }, {
      value: "Indian/Mahe",
      label: "Indian/Mahe"
    }, {
      value: "Indian/Maldives",
      label: "Indian/Maldives"
    }, {
      value: "Indian/Mauritius",
      label: "Indian/Mauritius"
    }, {
      value: "Indian/Mayotte",
      label: "Indian/Mayotte"
    }, {
      value: "Indian/Reunion",
      label: "Indian/Reunion"
    }, {
      value: "Iran",
      label: "Iran"
    }, {
      value: "Israel",
      label: "Israel"
    }, {
      value: "Jamaica",
      label: "Jamaica"
    }, {
      value: "Japan",
      label: "Japan"
    }, {
      value: "Kwajalein",
      label: "Kwajalein"
    }, {
      value: "Libya",
      label: "Libya"
    }, {
      value: "Mexico/BajaNorte",
      label: "Mexico/BajaNorte"
    }, {
      value: "Mexico/BajaSur",
      label: "Mexico/BajaSur"
    }, {
      value: "Mexico/General",
      label: "Mexico/General"
    }, {
      value: "Navajo",
      label: "Navajo"
    }, {
      value: "Pacific/Apia",
      label: "Pacific/Apia"
    }, {
      value: "Pacific/Auckland",
      label: "Pacific/Auckland"
    }, {
      value: "Pacific/Bougainville",
      label: "Pacific/Bougainville"
    }, {
      value: "Pacific/Chatham",
      label: "Pacific/Chatham"
    }, {
      value: "Pacific/Chuuk",
      label: "Pacific/Chuuk"
    }, {
      value: "Pacific/Easter",
      label: "Pacific/Easter"
    }, {
      value: "Pacific/Efate",
      label: "Pacific/Efate"
    }, {
      value: "Pacific/Enderbury",
      label: "Pacific/Enderbury"
    }, {
      value: "Pacific/Fakaofo",
      label: "Pacific/Fakaofo"
    }, {
      value: "Pacific/Fiji",
      label: "Pacific/Fiji"
    }, {
      value: "Pacific/Funafuti",
      label: "Pacific/Funafuti"
    }, {
      value: "Pacific/Galapagos",
      label: "Pacific/Galapagos"
    }, {
      value: "Pacific/Gambier",
      label: "Pacific/Gambier"
    }, {
      value: "Pacific/Guadalcanal",
      label: "Pacific/Guadalcanal"
    }, {
      value: "Pacific/Guam",
      label: "Pacific/Guam"
    }, {
      value: "Pacific/Honolulu",
      label: "Pacific/Honolulu"
    }, {
      value: "Pacific/Johnston",
      label: "Pacific/Johnston"
    }, {
      value: "Pacific/Kiritimati",
      label: "Pacific/Kiritimati"
    }, {
      value: "Pacific/Kosrae",
      label: "Pacific/Kosrae"
    }, {
      value: "Pacific/Kwajalein",
      label: "Pacific/Kwajalein"
    }, {
      value: "Pacific/Majuro",
      label: "Pacific/Majuro"
    }, {
      value: "Pacific/Marquesas",
      label: "Pacific/Marquesas"
    }, {
      value: "Pacific/Midway",
      label: "Pacific/Midway"
    }, {
      value: "Pacific/Nauru",
      label: "Pacific/Nauru"
    }, {
      value: "Pacific/Niue",
      label: "Pacific/Niue"
    }, {
      value: "Pacific/Norfolk",
      label: "Pacific/Norfolk"
    }, {
      value: "Pacific/Noumea",
      label: "Pacific/Noumea"
    }, {
      value: "Pacific/Pago_Pago",
      label: "Pacific/Pago Pago"
    }, {
      value: "Pacific/Palau",
      label: "Pacific/Palau"
    }, {
      value: "Pacific/Pitcairn",
      label: "Pacific/Pitcairn"
    }, {
      value: "Pacific/Pohnpei",
      label: "Pacific/Pohnpei"
    }, {
      value: "Pacific/Ponape",
      label: "Pacific/Ponape"
    }, {
      value: "Pacific/Port_Moresby",
      label: "Pacific/Port Moresby"
    }, {
      value: "Pacific/Rarotonga",
      label: "Pacific/Rarotonga"
    }, {
      value: "Pacific/Saipan",
      label: "Pacific/Saipan"
    }, {
      value: "Pacific/Samoa",
      label: "Pacific/Samoa"
    }, {
      value: "Pacific/Tahiti",
      label: "Pacific/Tahiti"
    }, {
      value: "Pacific/Tarawa",
      label: "Pacific/Tarawa"
    }, {
      value: "Pacific/Tongatapu",
      label: "Pacific/Tongatapu"
    }, {
      value: "Pacific/Truk",
      label: "Pacific/Truk"
    }, {
      value: "Pacific/Wake",
      label: "Pacific/Wake"
    }, {
      value: "Pacific/Wallis",
      label: "Pacific/Wallis"
    }, {
      value: "Pacific/Yap",
      label: "Pacific/Yap"
    }, {
      value: "Poland",
      label: "Poland"
    }, {
      value: "Portugal",
      label: "Portugal"
    }, {
      value: "Singapore",
      label: "Singapore"
    }, {
      value: "Turkey",
      label: "Turkey"
    }, {
      value: "US/Alaska",
      label: "US/Alaska"
    }, {
      value: "US/Aleutian",
      label: "US/Aleutian"
    }, {
      value: "US/Arizona",
      label: "US/Arizona"
    }, {
      value: "US/Central",
      label: "US/Central"
    }, {
      value: "US/East-Indiana",
      label: "US/East-Indiana"
    }, {
      value: "US/Eastern",
      label: "US/Eastern"
    }, {
      value: "US/Hawaii",
      label: "US/Hawaii"
    }, {
      value: "US/Indiana-Starke",
      label: "US/Indiana-Starke"
    }, {
      value: "US/Michigan",
      label: "US/Michigan"
    }, {
      value: "US/Mountain",
      label: "US/Mountain"
    }, {
      value: "US/Pacific",
      label: "US/Pacific"
    }, {
      value: "US/Pacific-New",
      label: "US/Pacific-New"
    }, {
      value: "US/Samoa",
      label: "US/Samoa"
    }, {
      value: "UTC",
      label: "UTC"
    }];
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialContainer = t.DialButton = t.TabContainer = t.InputContainer = t.StyledInput = t.Container = t.ItemContainer = t.Label = t.LabelContainer = t.HeaderPanel = t.PopupContainer = t.ButtonContainer = t.ItemInnerContainer = t.CallButton = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d,
      f,
      h,
      m,
      g,
      y,
      v = n(105),
      b = n(0),
      C = n(2);
    t.CallButton = C.default(b.IconButton)(o || (o = r(["\n    margin-right: 8px;\n"], ["\n    margin-right: 8px;\n"]))), t.ItemInnerContainer = C.default(b.FlexBox)(i || (i = r(["\n    display: flex;\n    padding-left: 0px;\n    padding-right: 12px;\n    color: inherit;\n    outline: none;\n    height: 44px;\n    background: none;\n    border: none;\n    border-style: solid;\n    border-width: 0px 0px 1px 0px;\n    ", "\n    &:hover {\n        & .Twilio-WorkerDirectory-ButtonContainer {\n            display: flex;\n        }\n        ", "\n        & .Twilio-WorkerDirectory-QueueAvatar {\n            ", "\n        }\n    }\n"], ["\n    display: flex;\n    padding-left: 0px;\n    padding-right: 12px;\n    color: inherit;\n    outline: none;\n    height: 44px;\n    background: none;\n    border: none;\n    border-style: solid;\n    border-width: 0px 0px 1px 0px;\n    ", "\n    &:hover {\n        & .Twilio-WorkerDirectory-ButtonContainer {\n            display: flex;\n        }\n        ", "\n        & .Twilio-WorkerDirectory-QueueAvatar {\n            ", "\n        }\n    }\n"])), function (e) {
      return e.theme.WorkerDirectory.Item;
    }, function (e) {
      return b.getBackgroundWithHoverCSS(e.theme.WorkerDirectory.Item.background, e.theme.WorkerDirectory.Item.lightHover, !0);
    }, function (e) {
      return b.getBackgroundWithHoverCSS(e.theme.WorkerDirectory.QueueItem.Avatar.background, e.theme.WorkerDirectory.Item.lightHover, !0);
    }), t.ButtonContainer = C.default("div")(a || (a = r(["\n    display: none;\n"], ["\n    display: none;\n"]))), t.PopupContainer = C.default("div")(s || (s = r(["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    width: 325px;\n    height: 100%;\n    right: 0px;\n    z-index: 100;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    width: 325px;\n    height: 100%;\n    right: 0px;\n    z-index: 100;\n    ", "\n"])), function (e) {
      return b.Animations.FadeInOutTransition(e.isOpen);
    }), t.HeaderPanel = C.default(b.FlexBox)(l || (l = r(["\n    height: 44px;\n    padding-left: 12px;\n    padding-right: 40px;\n    ", "\n"], ["\n    height: 44px;\n    padding-left: 12px;\n    padding-right: 40px;\n    ", "\n"])), function (e) {
      return e.theme.WorkerDirectory.Header.Container;
    }), t.LabelContainer = C.default(b.FlexBox)(c || (c = r(["\n    margin: auto;\n"], ["\n    margin: auto;\n"]))), t.Label = C.default("div")(u || (u = r(["\n    width: 100%;\n    text-align: center;\n    font-size: 12px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 1px;\n    text-align: center;\n"], ["\n    width: 100%;\n    text-align: center;\n    font-size: 12px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 1px;\n    text-align: center;\n"]))), t.ItemContainer = C.default(b.FlexBox)(p || (p = r(["\n    flex-grow: 1;\n    overflow-y: auto;\n    border-style: solid;\n    border-width: 1px 0 0 0;\n    ", "\n"], ["\n    flex-grow: 1;\n    overflow-y: auto;\n    border-style: solid;\n    border-width: 1px 0 0 0;\n    ", "\n"])), function (e) {
      return e.theme.WorkerDirectory.ItemsContainer;
    }), t.Container = C.default(b.FlexBox)(d || (d = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.WorkerDirectory.Container;
    }), t.StyledInput = C.default(v.default)(f || (f = r(["\n    margin-left: 12px;\n    margin-top: 10px;\n    width: calc(100% - 24px);\n"], ["\n    margin-left: 12px;\n    margin-top: 10px;\n    width: calc(100% - 24px);\n"]))), t.InputContainer = C.default("div")(h || (h = r(["\n    flex: 0 0 56px;\n"], ["\n    flex: 0 0 56px;\n"]))), t.TabContainer = C.default(b.FlexBoxColumn)(m || (m = r(["\n    overflow-x: hidden;\n"], ["\n    overflow-x: hidden;\n"]))), t.DialButton = C.default(b.Button)(g || (g = r(["\n    display: block;\n    font-size: 12px;\n    line-height: 12px;\n    min-height: 32px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-transform: uppercase;\n    width: 100%;\n"], ["\n    display: block;\n    font-size: 12px;\n    line-height: 12px;\n    min-height: 32px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-transform: uppercase;\n    width: 100%;\n"]))), t.DialContainer = C.default("div")(y || (y = r(['\n    padding: 12px;\n    position: relative;\n\n    &::before {\n        content: "";\n        display: flex;\n        left: 0;\n        height: 30px;\n        pointer-events: none;\n        position: absolute;\n        right: 0;\n        top: -30px;\n        background: linear-gradient(0deg, #ecedf1 0%, rgba(255, 255, 255, 0) 100%);\n    }\n'], ['\n    padding: 12px;\n    position: relative;\n\n    &::before {\n        content: "";\n        display: flex;\n        left: 0;\n        height: 30px;\n        pointer-events: none;\n        position: absolute;\n        right: 0;\n        top: -30px;\n        background: linear-gradient(0deg, #ecedf1 0%, rgba(255, 255, 255, 0) 100%);\n    }\n'])));
  }, function (e, t) {
    e.exports = require("@material-ui/core/Input");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getTitleForLink = t.getSegmentByTaskSid = void 0;
    var i = n(13),
      a = n(9),
      s = n(7),
      l = n(6),
      c = n(70),
      u = n(18);
    t.getSegmentByTaskSid = function (e, t) {
      return r(this, void 0, void 0, function () {
        var n, r, u, p, d;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              if (n = t.axios, r = i.Manager.getInstance().serviceConfiguration.account_sid, u = a.getFlexInsightsPlayerConfig(i.Manager.getInstance().configuration).mediaApiUrl, !n) throw s.ErrorManager.createAndProcessError("Axios not found in identity object", {
                type: s.FlexErrorType.app,
                context: "getSegmentByTaskSid"
              });
              if (!r) throw s.ErrorManager.createAndProcessError("account_sid not found in serviceConfiguration object", {
                type: s.FlexErrorType.app,
                context: "getSegmentByTaskSid"
              });
              o.label = 1;
            case 1:
              return o.trys.push([1, 3,, 4]), [4, n.get(l.templateStr(c.ENDPOINT_SEGMENT_ID, {
                mediaApiUrl: u,
                accountSid: r,
                taskSid: e
              }))];
            case 2:
              if (200 !== (p = o.sent()).status) throw s.ErrorManager.createAndProcessError("failed to get segmentId", {
                type: s.FlexErrorType.app,
                context: "getSegmentByTaskSid"
              });
              return [2, p.data.segmentId];
            case 3:
              if (d = o.sent(), s.isFlexError(d)) throw d;
              throw s.ErrorManager.createAndProcessError("Failed to get segmentId", {
                type: s.FlexErrorType.app,
                description: "Failed to get segmentId: " + d.message,
                context: "getSegmentByTaskSid",
                wrappedError: d
              });
            case 4:
              return [2];
          }
        });
      });
    }, t.getTitleForLink = function (e) {
      if (e.title) return e.title;
      if (e.type === u.InsightsPlayerMediaLinkType.VoiceRecording) return "Voice Recording";
      if (e.type === u.InsightsPlayerMediaLinkType.ChatTranscript) return "Chat Transcript";
      if (e.type === u.InsightsPlayerMediaLinkType.EmailTranscript) return "Email Transcript";
      try {
        return new URL(e.url).host;
      } catch (t) {
        return e.url;
      }
    };
  }, function (e, t) {
    e.exports = require("twilio-client");
  }, function (e, t) {
    e.exports = require("loglevel");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.stringifyArguments = t.cutLong = t.stringify = void 0;
    var o = function o(e) {
      return void 0 === e && (e = 0), function (t) {
        var n = r({}, t);
        return Object.getOwnPropertyNames(n).forEach(function (t) {
          var r = n[t];
          "object" != typeof r || Array.isArray(r) || null === r || (n[t] = e >= 1 ? "[Object]" : o(e + 1)(r));
        }), n;
      };
    };
    function i(e) {
      return JSON.stringify(e, function (e, t) {
        return "function" == typeof t ? "[Function]" : "object" != typeof t || null === t || Array.isArray(t) ? t : o()(t);
      });
    }
    t.stringify = i;
    t.cutLong = function (e) {
      return function (t) {
        return e && t.length > e ? t.substring(0, e) + " [CUT " + (t.length - e) + " characters]}" : t;
      };
    };
    t.stringifyArguments = function (e) {
      return e.map(function (e) {
        return void 0 === e && (e = "undefined"), "object" == typeof e ? i(e) : e.toString();
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Storage = void 0;
    var r = function r() {
      this.add = this.add.bind(this), this.get = this.get.bind(this), this.clear = this.clear.bind(this);
    };
    t.Storage = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Transport = void 0;
    var r = function r() {};
    t.Transport = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Default = t.createDefaultTaskChannel = void 0;
    var r = n(52),
      o = n(84),
      i = {
        Pending: "TaskReserved",
        Accepted: "TaskAssigned",
        Wrapping: "TaskWrapup",
        Completed: "TaskCompleted",
        Canceled: "TaskCanceled",
        Reserved: "TaskReserved",
        Assigned: "TaskAssigned"
      },
      a = {
        Accepted: "SupervisorTaskLive",
        Pending: "SupervisorTaskLive",
        Wrapping: "SupervisorTaskWrapUp",
        Completed: "SupervisorTaskCompleted",
        Canceled: "SupervisorTaskCompleted",
        Reserved: "SupervisorTaskLive",
        Assigned: "SupervisorTaskLive"
      },
      s = o.defaultChannelColors.inactive;
    function l(e, t, n, l, c) {
      return void 0 === n && (n = "GenericTask"), void 0 === l && (l = "GenericTaskBold"), void 0 === c && (c = o.defaultChannelColors.custom), {
        name: e,
        isApplicable: t,
        capabilities: new Set([r.TaskChannelCapability.Info]),
        charLimit: 32768,
        colors: {
          main: {
            Reserved: c,
            Assigned: c,
            Accepted: c,
            Pending: c,
            Canceled: s,
            Wrapping: s,
            Completed: s
          }
        },
        icons: {
          list: {
            Reserved: l,
            Assigned: l,
            Accepted: l,
            Pending: l,
            Canceled: n,
            Wrapping: n,
            Completed: n
          },
          active: l,
          main: n
        },
        templates: {
          CallCanvas: {
            titleLine: "TaskLineTitle",
            firstLine: "TaskHeaderLine",
            secondLine: i
          },
          IncomingTaskCanvas: {
            titleLine: "TaskLineTitle",
            firstLine: "TaskHeaderLine",
            secondLine: i
          },
          ConnectingOutboundCallCanvas: {
            titleLine: "TaskLineOutboundCallTitle",
            firstLine: "TaskLineOutboundCallHeader",
            secondLine: "TaskLineOutboundCallDetail"
          },
          TaskListItem: {
            firstLine: "TaskHeaderLine",
            secondLine: i,
            extraInfo: "TaskExtraInfo"
          },
          TaskCanvasHeader: {
            title: "TaskHeaderLine",
            secondLine: i,
            endButton: {
              Assigned: "TaskHeaderComplete",
              Accepted: "TaskHeaderComplete",
              Reserved: void 0,
              Wrapping: "TaskHeaderWrapup",
              Completed: void 0,
              Canceled: void 0,
              Pending: void 0
            }
          },
          TaskCard: {
            firstLine: "SupervisorTaskCardHeader",
            secondLine: a
          },
          TaskInfoPanel: {
            content: "TaskInfoPanelContent"
          },
          Supervisor: {
            TaskCanvasHeader: {
              title: "SupervisorTaskHeaderLine",
              secondLine: i
            },
            TaskInfoPanel: {
              content: "SupervisorTaskInfoPanelContent"
            },
            TaskOverviewCanvas: {
              firstLine: "SupervisorTaskViewContentHeader",
              secondLine: a
            }
          }
        },
        componentProps: {},
        notifications: {
          override: {}
        }
      };
    }
    t.createDefaultTaskChannel = l, t.Default = l("default", function () {
      return !0;
    });
  }, function (e, t) {
    e.exports = require("@twilio/flex-insights-player");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.incomingTaskNotificationActions = void 0;
    var r = n(1),
      o = n(0);
    t.incomingTaskNotificationActions = [r.createElement(o.NotificationBar.Action, {
      label: "IncomingNotificationAccept",
      onClick: function onClick(e, t) {
        t.context && (o.Actions.invokeAction("AcceptTask", {
          task: t.context.task
        }), o.Actions.invokeAction("SelectTask", {
          task: t.context.task
        }));
      }
    }), r.createElement(o.NotificationBar.Action, {
      label: "IncomingNotificationReject",
      onClick: function onClick(e, t) {
        t.context && o.Actions.invokeAction("RejectTask", {
          task: t.context.task
        });
      }
    })];
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AppStateHelper = void 0;
    var r = n(8),
      o = function () {
        function e(e) {
          this.appState = e;
        }
        return e.prototype.getUnconsumedMessagesCount = function () {
          var e = this;
          return Array.from(this.appState.worker.tasks.values()).reduce(function (t, n) {
            return t + e.getUnconsumedMessagesCountForTask(n);
          }, 0);
        }, e.prototype.getPendingTasks = function () {
          return Array.from(this.appState.worker.tasks.values()).filter(function (e) {
            return r.TaskHelper.isPending(e);
          }).length;
        }, e.prototype.getUnconsumedMessagesCountForTask = function (e) {
          if (!r.TaskHelper.isTaskAccepted(e) || !r.TaskHelper.isChatBasedTask(e)) return 0;
          var t = r.TaskHelper.getTaskChatChannelSid(e);
          return t && this.appState.chat.channels[t] ? this.appState.chat.channels[t].unconsumedMessages.length : 0;
        }, e.prototype.isAgentView = function () {
          return Boolean(this.appState.router && this.appState.router.location && this.appState.router.location.pathname && this.appState.router.location.pathname.match(/agent-desktop/));
        }, e;
      }();
    t.AppStateHelper = o;
  }, function (e, t) {
    e.exports = require("events");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
      var r = Array(e),
        o = 0;
      for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
      return r;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.ACTION_CLEAR_ALL_ERRORS = t.ACTION_NEW_FLEX_ERROR = void 0;
    var o = n(3);
    t.ACTION_NEW_FLEX_ERROR = "ACTION_NEW_FLEX_ERROR", t.ACTION_CLEAR_ALL_ERRORS = "ACTION_CLEAR_ALL_ERRORS";
    var i = {
      errors: []
    };
    t.reduce = function (e, n) {
      switch (void 0 === e && (e = i), n.type) {
        case t.ACTION_NEW_FLEX_ERROR:
          var o = e.errors;
          return o.length >= 50 && o.shift(), {
            errors: r(o, [n.payload.error])
          };
        case t.ACTION_CLEAR_ALL_ERRORS:
          return {
            errors: []
          };
        default:
          return e;
      }
    };
    var a = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return o.FlexModule.dispatch;
        },
        enumerable: !1,
        configurable: !0
      }), e.newFlexError = function (e) {
        this.dispatcher({
          type: t.ACTION_NEW_FLEX_ERROR,
          payload: {
            error: e
          }
        });
      }, e.clearAllErrors = function () {
        this.dispatcher({
          type: t.ACTION_CLEAR_ALL_ERRORS
        });
      }, e;
    }();
    t.Actions = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ASSESSMENTS_SETTINGS_UPDATE = t.COMMENTS_ADD = t.COMMENTS_UPDATE = t.ASSESSMENTS_REMOVE = t.ASSESSMENTS_ADD = t.ASSESSMENTS_UPDATE = t.QUESTIONNAIRES_UPDATE = void 0, t.QUESTIONNAIRES_UPDATE = "FLEX_INSIGHTS_QUESTIONNAIRES_UPDATE", t.ASSESSMENTS_UPDATE = "FLEX_INSIGHTS_ASSESSMENTS_UPDATE", t.ASSESSMENTS_ADD = "FLEX_INSIGHTS_ASSESSMENTS_ADD", t.ASSESSMENTS_REMOVE = "FLEX_INSIGHTS_ASSESSMENTS_REMOVE", t.COMMENTS_UPDATE = "FLEX_INSIGHTS_COMMENTS_UPDATE", t.COMMENTS_ADD = "FLEX_INSIGHTS_COMMENTS_ADD", t.ASSESSMENTS_SETTINGS_UPDATE = "FLEX_INSIGHTS_ASSESSMENTS_SETTINGS_UPDATE";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FINDINGS_SET = void 0, t.FINDINGS_SET = "FLEX_INSIGHTS_FINDINGS_SET";
  }, function (e, t) {
    e.exports = require("react-dom");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t) {
    e.exports = require("uuid");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.OutboundCalling = t.OutboundCallingErrors = void 0;
    var a,
      s = n(0),
      l = n(1),
      c = n(85),
      u = n(47),
      p = n(32),
      d = n(13),
      f = n(12),
      h = n(7),
      m = n(3),
      g = n(5),
      y = n(14),
      v = n(6),
      b = n(35),
      C = n(23),
      _ = n(8);
    !function (e) {
      e.missingDestination = "missing destination", e.missingQueue = "missing queue", e.missingCallerId = "missing caller id", e.generic = "generic error", e.invalidDestination = "invalid destination", e.notInTaskQueue = "The RoutingTarget Worker is not valid for the given TaskQueueSid";
    }(a = t.OutboundCallingErrors || (t.OutboundCallingErrors = {}));
    var k = function () {
      function e() {}
      return e.initialize = function () {
        this.registerActions(), this.registerNotifications(), this.fetchCountriesAndFlags();
      }, e.handleOutboundTaskCancelledEvent = function (e) {
        if (g.log.debug("Outbound call " + e.sid + " canceled with reason: " + e.canceledReasonCode + " (https://www.twilio.com/docs/api/errors/" + e.canceledReasonCode + ")"), e.canceledReasonCode) {
          switch (e.canceledReasonCode) {
            case 13223:
            case 21211:
              s.Notifications.showNotification(y.OutboundCallCanceledInvalidNumber);
              break;
            case 21210:
              s.Notifications.showNotification(y.OutboundCallCanceledFromNumberUnverified);
              break;
            case 21215:
              s.Notifications.showNotification(y.OutboundCallCanceledDisabledCountry);
              break;
            case 45305:
              s.Notifications.showNotification(y.OutboundCallCanceledNoAnswer);
              break;
            case 45303:
              s.Notifications.showNotification(y.OutboundCallCanceledBusy);
              break;
            case 45302:
            case 45306:
            case 45307:
              break;
            default:
              s.Notifications.showNotification(y.OutboundCallCanceledGeneric, {
                reasonCode: e.canceledReasonCode
              });
          }
          f.TelemetryManager.reportOutboundCallCanceledEvent(e.canceledReasonCode, e.sid);
        }
      }, e.registerActions = function () {
        s.Actions.registerAction("StartOutboundCall", this.startOutboundCall), s.Actions.registerAction("ToggleOutboundDialer", this.toggleOutboundDialer);
      }, e.registerNotifications = function () {
        var e = this,
          t = {
            id: y.OutboundCallCanceledGeneric,
            content: "OutboundCallFailedNotificationTitle",
            type: s.NotificationType.warning,
            timeout: 0
          };
        s.Notifications.registerNotification(t);
        var n = {
          id: y.OutboundCallCanceledBusy,
          content: "OutboundCallFailedNotificationTitleBusy",
          type: s.NotificationType.warning,
          timeout: 0,
          actions: [l.createElement(s.NotificationBar.Action, {
            label: "OutboundCallFailedNotificationAction",
            onClick: function onClick(t, n) {
              s.Notifications.dismissNotification(n), v.tryInvokeAction("StartOutboundCall", e.lastOutboundCallActionPayload);
            }
          })]
        };
        s.Notifications.registerNotification(n);
        var r = {
          id: y.OutboundCallCanceledNoAnswer,
          content: "OutboundCallFailedNotificationTitleNoAnswer",
          type: s.NotificationType.warning,
          timeout: 0,
          actions: [l.createElement(s.NotificationBar.Action, {
            label: "OutboundCallFailedNotificationAction",
            onClick: function onClick(t, n) {
              s.Notifications.dismissNotification(n), v.tryInvokeAction("StartOutboundCall", e.lastOutboundCallActionPayload);
            }
          })]
        };
        s.Notifications.registerNotification(r);
        var o = {
          id: y.OutboundCallCanceledInvalidNumber,
          content: "OutboundCallFailedNotificationTitleInvalidNumber",
          type: s.NotificationType.warning,
          timeout: 0
        };
        s.Notifications.registerNotification(o);
        var i = {
          id: y.OutboundCallCanceledDisabledCountry,
          content: "OutboundCallFailedNotificationTitleDisabledCountry",
          type: s.NotificationType.warning,
          timeout: 0
        };
        s.Notifications.registerNotification(i);
        var a = {
          id: y.OutboundCallCanceledFromNumberUnverified,
          content: "OutboundCallFailedNotificationTitleFromNumberUnverified",
          type: s.NotificationType.warning,
          timeout: 0
        };
        s.Notifications.registerNotification(a);
      }, e.fetchCountriesAndFlags = function () {
        s.CountryManager.getAllCountries(), s.CountryManager.getAllCountriesFlagPositions();
      }, e.startOutboundCall = function (t) {
        var n;
        return o(this, void 0, Promise, function () {
          var o, l, f, v, b, k, w, S, P, T, O, x, E, A, I;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                if (p.FlexClientManager.isDegraded(m.FlexModule.voiceClient)) return g.log.error("OutboundCalling: Voice SDK is in degraded mode, outbound call cancelled"), [2];
                if (s.Actions.findBlockedActions("StartOutboundCall", {}).first) throw h.ErrorManager.createAndProcessError(c.ActionErrors.OUTBOUND_CALL_ALREADY_PENDING, {
                  type: h.FlexErrorType.app,
                  context: "OutboundCalling"
                });
                s.Actions.blockAction("StartOutboundCall", t), i.label = 1;
              case 1:
                if (i.trys.push([1,, 10, 11]), s.Notifications.dismissNotificationById(y.OutboundCallCanceledBusy), s.Notifications.dismissNotificationById(y.OutboundCallCanceledGeneric), s.Notifications.dismissNotificationById(y.OutboundCallCanceledNoAnswer), s.Notifications.dismissNotificationById(y.OutboundCallCanceledInvalidNumber), !u.isOutboundCallingEnabled()) throw h.ErrorManager.createAndProcessError(c.ActionErrors.OUTBOUND_CALLING_DISABLED, {
                  type: h.FlexErrorType.app,
                  context: "OutboundCalling"
                });
                if (m.FlexModule.state.phone.connection) throw h.ErrorManager.createAndProcessError(c.ActionErrors.VOICE_CONNECTION_ALREADY_LIVE, {
                  type: h.FlexErrorType.app,
                  context: "OutboundCalling"
                });
                if (C.StateHelper.hasPendingCall()) throw h.ErrorManager.createAndProcessError(c.ActionErrors.PENDING_INBOUND_CALL, {
                  type: h.FlexErrorType.app,
                  context: "OutboundCalling"
                });
                if (m.FlexModule.state.worker.tasks.forEach(function (e) {
                  if (_.TaskHelper.isLiveCall(e)) throw h.ErrorManager.createAndProcessError(c.ActionErrors.CALL_TASK_ALREADY_EXISTS, {
                    type: h.FlexErrorType.app,
                    context: "OutboundCalling"
                  });
                }), m.FlexModule.state.worker.tasks.forEach(function (e) {
                  if (_.TaskHelper.isInitialOutboundAttemptTask(e)) throw h.ErrorManager.createAndProcessError(c.ActionErrors.CALL_TASK_ALREADY_EXISTS, {
                    type: h.FlexErrorType.app,
                    context: "OutboundCalling"
                  });
                }), o = d.Manager.getInstance().serviceConfiguration, l = o.outbound_call_flows, f = o.taskrouter_offline_activity_sid, m.FlexModule.state.worker.activity.sid === f) throw h.ErrorManager.createAndProcessError(c.ActionErrors.CANT_OUTBOUND_WHEN_OFFLINE, {
                  type: h.FlexErrorType.app,
                  context: "OutboundCalling"
                });
                if (v = t.queueSid, b = t.callerId, k = t.destination, l && l.default && (v = v || l.default.queue_sid, b = b || l.default.caller_id), !k) throw h.ErrorManager.createAndProcessError(a.missingDestination, {
                  type: h.FlexErrorType.app,
                  context: "OutboundCalling"
                });
                if (!v) throw h.ErrorManager.createAndProcessError(a.missingQueue, {
                  type: h.FlexErrorType.app,
                  context: "OutboundCalling"
                });
                if (!b) throw h.ErrorManager.createAndProcessError(a.missingCallerId, {
                  type: h.FlexErrorType.app,
                  context: "OutboundCalling"
                });
                if (k.match(/client:/) && !m.FlexModule.state.config.enableClientCalling) throw h.ErrorManager.createAndProcessError(a.invalidDestination, {
                  type: h.FlexErrorType.app,
                  context: "OutboundCalling"
                });
                if (e.lastOutboundCallActionPayload = t, k.match(/client:/) || (S = !!l.default && l.default.location, P = s.CountryManager.formatPhoneNumberWithCountryCode(k, S), k = P || k), !m.FlexModule.state.phone.listener.isMicrophoneSet) return g.log.error("OutboundCalling: no audio input device, outbound call cancelled"), s.Notifications.showNotification(y.NoInputDevice), [2];
                T = [], O = [], x = function x(e) {
                  T.push(e.task.sid);
                }, E = function E(e) {
                  O.push(e.task.sid);
                }, m.FlexModule.workerClient.addListener("reservationCreated", x), m.FlexModule.workerClient.addListener("reservationFailed", E), i.label = 2;
              case 2:
                return i.trys.push([2, 4, 5, 6]), [4, m.FlexModule.workerClient.createTask(k, b, l.default.workflow_sid, v, {
                  attributes: r(r({}, t.taskAttributes), {
                    direction: "outbound"
                  }),
                  taskChannelUniqueName: "voice"
                })];
              case 3:
                return w = i.sent(), [3, 6];
              case 4:
                throw A = i.sent(), I = "Unknown error", (null === (n = A.response) || void 0 === n ? void 0 : n.statusText) ? I = A.response.statusText : A.message && (I = A.message), h.ErrorManager.createAndProcessError(c.ActionErrors.CANT_CREATE_TASK, {
                  type: h.FlexErrorType.taskrouterSDK,
                  description: I,
                  context: "OutboundCalling",
                  wrappedError: A
                });
              case 5:
                return m.FlexModule.workerClient.removeListener("reservationCreated", x), m.FlexModule.workerClient.removeListener("reservationFailed", E), [7];
              case 6:
                return i.trys.push([6, 8,, 9]), [4, new Promise(function (e, t) {
                  var n = function n(t) {
                      t.task.sid === w && (m.FlexModule.workerClient.removeListener("reservationCreated", n), m.FlexModule.workerClient.removeListener("reservationFailed", r), e(void 0));
                    },
                    r = function r(e) {
                      e.task.sid === w && (m.FlexModule.workerClient.removeListener("reservationCreated", n), m.FlexModule.workerClient.removeListener("reservationFailed", r), t());
                    };
                  T.indexOf(w) > -1 ? e(void 0) : O.indexOf(w) > -1 ? t() : (m.FlexModule.workerClient.addListener("reservationCreated", n), m.FlexModule.workerClient.addListener("reservationFailed", r));
                })];
              case 7:
                return i.sent(), [3, 9];
              case 8:
                throw i.sent(), h.ErrorManager.createAndProcessError(a.generic, {
                  type: h.FlexErrorType.taskrouterSDK,
                  context: "OutboundCalling"
                });
              case 9:
                return [3, 11];
              case 10:
                return s.Actions.unblockAction("StartOutboundCall", t), [7];
              case 11:
                return [2];
            }
          });
        });
      }, e.toggleOutboundDialer = function () {
        return o(this, void 0, Promise, function () {
          return i(this, function (e) {
            if (!u.isOutboundCallingEnabled()) throw h.ErrorManager.createAndProcessError(c.ActionErrors.OUTBOUND_CALLING_DISABLED, {
              type: h.FlexErrorType.app,
              context: "OutboundCalling"
            });
            if (m.FlexModule.state.phone.connection && !m.FlexModule.state.view.isOutboundDialerOpen) throw h.ErrorManager.createAndProcessError(c.ActionErrors.VOICE_CONNECTION_ALREADY_LIVE, {
              type: h.FlexErrorType.app,
              context: "OutboundCalling"
            });
            return [2, b.Actions.toggleOutboundDialer()];
          });
        });
      }, e;
    }();
    t.OutboundCalling = k;
  }, function (e, t) {
    e.exports = require("lodash.snakecase");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createDefaultStore = t.flexStoreEnhancer = t.getDefaultStore = void 0;
    var o,
      i = n(88),
      a = n(185),
      s = n(186),
      l = n(5);
    t.getDefaultStore = function () {
      return o;
    };
    var c,
      u = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        actionSanitizer: function actionSanitizer(e) {
          return e;
        },
        stateSanitizer: function stateSanitizer(e) {
          return e.flex.config ? r(r({}, e), {
            flex: r(r({}, e.flex), {
              chat: "<<CUT FOR DEV>>",
              supervisor: "<<CUT FOR DEV>>"
            })
          }) : e;
        }
      }) || i.compose;
    t.flexStoreEnhancer = function (e) {
      return function (t, n, o) {
        c = t;
        var i = r(r({}, e(t, n, o)), {
          addReducer: function addReducer(e, t) {
            if ("flex" !== e) {
              var n = c,
                o = function o(_o, i) {
                  var a;
                  void 0 === _o && (_o = {});
                  var s,
                    l = r({}, _o);
                  l && l[e] && (s = l[e], delete l[e]);
                  var c = n(l, i),
                    u = t(s, i);
                  return l === c && s === u ? _o : r(r({}, c), ((a = {})[e] = u, a));
                };
              c = o, i.replaceReducer(o);
            } else l.log.debug("Cannot add reducer with name `flex`");
          }
        });
        return i;
      };
    }, t.createDefaultStore = function (e) {
      if (o) return l.log.error("default store already exists"), null;
      var n = i.combineReducers({
        flex: a.FlexReducer
      });
      return o = i.createStore(n, u(s.applyFlexMiddleware(e.history, e.enableReduxLogging), t.flexStoreEnhancer));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DeviceListener = t.Actions = t.reduce = void 0;
    var o = n(0),
      i = n(107),
      a = n(11),
      s = n(12),
      l = n(7),
      c = n(3),
      u = n(5),
      p = n(10),
      d = n(16),
      f = n(90),
      h = n(35),
      m = {
        listener: void 0,
        connection: void 0,
        connections: []
      };
    t.reduce = function (e, t) {
      switch (void 0 === e && (e = m), t.type) {
        case "PHONE_INIT":
          var n = t.payload;
          return r(r({}, m), {
            listener: n.listener
          });
        case "PHONE_UNINIT":
          return m;
        case "PHONE_TOGGLE_MUTE":
          var o = e.connection && e.connection.oldHold || !1,
            i = v(t.payload, o);
          return r(r({}, e), {
            connection: i,
            connections: [i]
          });
        case "PHONE_UNHOLD_CONNECTION":
        case "PHONE_ADD_CONNECTION":
          i = v(t.payload, !1);
          return r(r({}, e), {
            connection: i,
            connections: [i]
          });
        case "PHONE_HOLD_CONNECTION":
          i = v(t.payload, !0);
          return r(r({}, e), {
            connection: i,
            connections: [i]
          });
        case "PHONE_REMOVE_CONNECTION":
          return r(r({}, e), {
            connection: void 0,
            connections: []
          });
        default:
          return e;
      }
    };
    var g = function () {
      function e() {}
      return e.dispatchPhoneAction = function (e, t) {
        c.FlexModule.dispatch({
          type: e,
          payload: t
        });
      }, e.init = function (e, t) {
        this.listener = new y(e, t), this.dispatchPhoneAction("PHONE_INIT", {
          listener: this.listener
        });
      }, e.getDeviceListener = function () {
        return this.listener;
      }, e.oldHoldConnection = function () {
        c.FlexModule.state.phone.connection && e.dispatchPhoneAction("PHONE_HOLD_CONNECTION", c.FlexModule.state.phone.connection.source);
      }, e.oldUnHoldConnection = function () {
        c.FlexModule.state.phone.connection && e.dispatchPhoneAction("PHONE_UNHOLD_CONNECTION", c.FlexModule.state.phone.connection.source);
      }, e.shutdown = function () {
        u.log.info("PhoneState: shutdown");
        var e = c.FlexModule.state.phone.listener;
        e && (e.stop(), this.dispatchPhoneAction("PHONE_UNINIT", null));
      }, e;
    }();
    t.Actions = g;
    var y = function () {
      function e(e, t) {
        var n = this;
        this.handleDeviceChange = function () {
          navigator.mediaDevices.getUserMedia({
            audio: !0
          }).then(function (e) {
            try {
              u.log.info("PhoneState: handleDeviceChange");
              var t = Array.from(c.FlexModule.voiceClient.audio.availableInputDevices.keys());
              t.length > 0 ? (n.microphoneID = t.find(function (e) {
                return "default" === e;
              }) || t[0], u.log.info("PhoneState: input device: " + n.microphoneID)) : (n.microphoneID = void 0, u.log.warn("PhoneState: no input devices"), o.Notifications.showNotification(d.NotificationIds.NoInputDevice));
            } finally {
              e.getTracks().forEach(function (e) {
                return e.stop();
              });
            }
          }).catch(function (e) {
            u.log.error("PhoneState: error in getUserMedia", e);
          });
        }, this.handleDeviceReady = function (e) {
          u.log.info("PhoneState: handleDeviceReady", n, e), n.tryInitialDeviceCheck();
        }, this.handleDeviceError = function (e) {
          31201 === e.code && o.Notifications.showNotification(d.NotificationIds.MicTaken), l.ErrorManager.createAndProcessError("Voice SDK device error intercepted", {
            type: l.FlexErrorType.voiceSDK,
            context: "PhoneState",
            description: "Voice SDK device error intercepted. A device error has been thrown from Voice SDK",
            wrappedError: e
          });
        }, this.handleDeviceConnect = function (e) {
          u.log.info("PhoneState: connection connected", e), h.Actions.hideOutboundDialer(), e.on("mute", n.handleConnectionMute), g.dispatchPhoneAction("PHONE_ADD_CONNECTION", e), a.FeatureFlags.isEnabled(p.FeatureFlag.SingleSession) && f.singleSessionGuard.updateRecordIsOnCall(!0);
        }, this.handleDeviceDisconnect = function (e) {
          u.log.info("PhoneState: connection disconnected", e), h.Actions.hideDirectory(), e.removeListener("mute", n.handleConnectionMute), g.dispatchPhoneAction("PHONE_REMOVE_CONNECTION", void 0), c.FlexModule.state.config.initialDeviceCheck && c.FlexModule.voiceClient.audio.unsetInputDevice(), a.FeatureFlags.isEnabled(p.FeatureFlag.SingleSession) && f.singleSessionGuard.updateRecordIsOnCall(!1);
        }, this.handleDeviceIncoming = function (e) {
          var t;
          u.log.info("PhoneState: connection incoming", e);
          var r = function r() {
            if (a.FeatureFlags.isEnabled(p.FeatureFlag.SingleSession) && c.FlexModule.state.session.singleSessionGuard.otherSessionDetected) u.log.debug("PhoneState: incoming call not accepted as session is not yet validated");else if (c.FlexModule.state.config.initialDeviceCheck) {
              if (!n.microphoneID) return u.log.error("PhoneState: no input device, rejecting connection"), o.Notifications.showNotification(d.NotificationIds.NoInputDevice), void e.reject();
              c.FlexModule.voiceClient.audio.setInputDevice(n.microphoneID).then(function () {
                return e.accept();
              }).catch(function (t) {
                u.log.error("PhoneState: Error setting the input device", t), o.Notifications.showNotification(d.NotificationIds.NoInputDevice), e.reject();
              });
            } else e.accept();
          };
          c.FlexModule.voiceClient.status() === i.Device.Status.Busy ? (o.Notifications.showNotification(d.NotificationIds.SecondVoiceConnectionIncoming, {
            accept: function accept() {
              r(), o.Notifications.dismissNotificationById(d.NotificationIds.SecondVoiceConnectionIncoming);
            },
            reject: function reject() {
              e.reject(), o.Notifications.dismissNotificationById(d.NotificationIds.SecondVoiceConnectionIncoming);
            }
          }), s.TelemetryManager.reportSecondIncomingVoiceConnection(null === (t = e.customParameters) || void 0 === t ? void 0 : t.get("taskSid"))) : r();
        }, this.handleDeviceCancel = function (e) {
          u.log.info("PhoneState: connection was cancelled", e);
        }, this.handleConnectionMute = function (e) {
          u.log.info("PhoneState: connection was " + (e ? "muted" : "unmuted")), g.dispatchPhoneAction("PHONE_TOGGLE_MUTE", c.FlexModule.state.phone.connection.source);
        }, c.FlexModule.voiceClient.setup(e, t), c.FlexModule.voiceClient.on(i.Device.EventName.Ready, this.handleDeviceReady), c.FlexModule.voiceClient.on(i.Device.EventName.Connect, this.handleDeviceConnect), c.FlexModule.voiceClient.on(i.Device.EventName.Disconnect, this.handleDeviceDisconnect), c.FlexModule.voiceClient.on(i.Device.EventName.Error, this.handleDeviceError), c.FlexModule.voiceClient.on(i.Device.EventName.Incoming, this.handleDeviceIncoming), c.FlexModule.voiceClient.on(i.Device.EventName.Cancel, this.handleDeviceCancel), this._listening = !0;
      }
      return Object.defineProperty(e.prototype, "isMicrophoneSet", {
        get: function get() {
          return !!this.microphoneID;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.stop = function () {
        this._listening && (c.FlexModule.voiceClient.removeListener(i.Device.EventName.Ready, this.handleDeviceReady), c.FlexModule.voiceClient.removeListener(i.Device.EventName.Connect, this.handleDeviceConnect), c.FlexModule.voiceClient.removeListener(i.Device.EventName.Disconnect, this.handleDeviceDisconnect), c.FlexModule.voiceClient.removeListener(i.Device.EventName.Error, this.handleDeviceError), c.FlexModule.voiceClient.removeListener(i.Device.EventName.Incoming, this.handleDeviceIncoming), c.FlexModule.voiceClient.removeListener(i.Device.EventName.Cancel, this.handleDeviceCancel), this.hasPerformedInitialDeviceCheck && c.FlexModule.voiceClient.audio.removeListener("deviceChange", this.handleDeviceChange), this._listening = !1, c.FlexModule.voiceClient.destroy());
      }, e.prototype.isListening = function () {
        return this._listening;
      }, e.prototype.tryInitialDeviceCheck = function () {
        !this.hasPerformedInitialDeviceCheck && c.FlexModule.state.config.initialDeviceCheck && (this.hasPerformedInitialDeviceCheck = !0, c.FlexModule.voiceClient.audio.on("deviceChange", this.handleDeviceChange), this.handleDeviceChange());
      }, e;
    }();
    function v(e, t) {
      return {
        oldHold: t,
        source: e
      };
    }
    t.DeviceListener = y;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createReducer = t.FLEX_LOCATION_CHANGE = void 0;
    var o = n(93);
    t.FLEX_LOCATION_CHANGE = "@@flex/LOCATION_CHANGE";
    t.createReducer = function (e) {
      return function (n, i) {
        var a = i.type === t.FLEX_LOCATION_CHANGE,
          s = i.type === o.LOCATION_CHANGE,
          l = e && e.router && e.router.isolate,
          c = i;
        return s && l ? n : (a && (c = r(r({}, i), {
          type: o.LOCATION_CHANGE
        })), o.routerReducer.call(null, n, c));
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConferenceParticipant = void 0;
    var r = n(3),
      o = n(5),
      i = n(37),
      a = function () {
        function e(e, t, n) {
          e && (this._source = e, this._callSid = t, this.participantLeftTimestamp = n, this._participantType = this._source && this._source.participant_type);
        }
        return Object.defineProperty(e.prototype, "source", {
          get: function get() {
            return this._source;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "worker", {
          get: function get() {
            return i.InsightsEntityCache.getWorker(this.workerSid);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "queue", {
          get: function get() {
            return i.InsightsEntityCache.getQueue(this.workerSid);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "onHold", {
          get: function get() {
            return this._source && this._source.hold;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "muted", {
          get: function get() {
            return this._source && this._source.muted;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "connecting", {
          get: function get() {
            return this._source && this._source.connecting;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "participantType", {
          get: function get() {
            return this._participantType;
          },
          set: function set(e) {
            this._participantType = e;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "reservationSid", {
          get: function get() {
            return this._source && this._source.reservation_sid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "workerSid", {
          get: function get() {
            return this._source && this._source.worker_sid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "status", {
          get: function get() {
            return this.participantLeftTimestamp ? "recently_left" : this._source && this._source.status;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "uniqueId", {
          get: function get() {
            var e = this.callSid || "";
            return "" + this.workerSid + this.participantType + e;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "sid", {
          get: function get() {
            return o.log.warn("Participant.sid is deprecated, use uniqueId instead!"), this.uniqueId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isMyself", {
          get: function get() {
            return this._source.worker_sid === r.FlexModule.state.worker.worker.sid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "callSid", {
          get: function get() {
            return this._callSid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "participantSid", {
          get: function get() {
            return this._participantSid;
          },
          set: function set(e) {
            this._participantSid = e;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "phoneNumber", {
          get: function get() {
            return this._phoneNumber;
          },
          set: function set(e) {
            this._phoneNumber = e;
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
    t.ConferenceParticipant = a;
  }, function (e, t) {
    e.exports = require("react-emotion");
  }, function (e, t) {
    e.exports = require("hoist-non-react-statics");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasTabs = void 0;
    var r = n(404);
    Object.defineProperty(t, "TaskCanvasTabs", {
      enumerable: !0,
      get: function get() {
        return r.TaskCanvasTabs;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MuteButtonProps = t.MuteButton = void 0;
    var r = n(413);
    Object.defineProperty(t, "MuteButton", {
      enumerable: !0,
      get: function get() {
        return r.MuteButton;
      }
    }), Object.defineProperty(t, "MuteButtonProps", {
      enumerable: !0,
      get: function get() {
        return r.MuteButtonProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r16,
      o = this && this.__extends || (_r16 = function r(e, t) {
        return (_r16 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r16(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskInfoPanel = void 0;
    var s = n(1),
      l = n(0),
      c = n(26),
      u = n(425),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        var n;
        return o(t, e), n = t, t.prototype.render = function () {
          return s.createElement(d, i({}, this.props));
        }, t.displayName = "TaskInfoPanel", t.Content = new l.DynamicContentStore(n.displayName), t.defaultProps = {
          content: n.Content
        }, t = n = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.TaskInfoPanel = p;
    var d = c.withTaskContext(u.TaskInfoPanelImpl);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingOutboundCallCanvasActions = t.ConnectingOutboundCallCanvasProps = t.ConnectingOutboundCallCanvas = void 0;
    var r = n(427);
    Object.defineProperty(t, "ConnectingOutboundCallCanvas", {
      enumerable: !0,
      get: function get() {
        return r.ConnectingOutboundCallCanvas;
      }
    });
    var o = n(431);
    Object.defineProperty(t, "ConnectingOutboundCallCanvasProps", {
      enumerable: !0,
      get: function get() {
        return o.ConnectingOutboundCallCanvasProps;
      }
    });
    var i = n(208);
    Object.defineProperty(t, "ConnectingOutboundCallCanvasActions", {
      enumerable: !0,
      get: function get() {
        return i.ConnectingOutboundCallCanvasActions;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasHeader = void 0;
    var r = n(436);
    Object.defineProperty(t, "TaskCanvasHeader", {
      enumerable: !0,
      get: function get() {
        return r.TaskCanvasHeader;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.setSubscriptionFilter = t.setFilter = t.WorkspaceStats = t.WorkerQueue = t.ActivityStatistic = t.QueuesDataTableCellProps = t.QueuesDataTableCell = t.QueuesDataTableProps = t.QueuesDataTable = t.AggregatedQueuesDataTiles = t.AggregatedQueuesDataTilesProps = void 0;
    var r = n(441);
    Object.defineProperty(t, "AggregatedQueuesDataTilesProps", {
      enumerable: !0,
      get: function get() {
        return r.AggregatedQueuesDataTilesProps;
      }
    }), Object.defineProperty(t, "AggregatedQueuesDataTiles", {
      enumerable: !0,
      get: function get() {
        return r.AggregatedQueuesDataTiles;
      }
    });
    var o = n(457);
    Object.defineProperty(t, "QueuesDataTable", {
      enumerable: !0,
      get: function get() {
        return o.QueuesDataTable;
      }
    }), Object.defineProperty(t, "QueuesDataTableProps", {
      enumerable: !0,
      get: function get() {
        return o.QueuesDataTableProps;
      }
    }), Object.defineProperty(t, "QueuesDataTableCell", {
      enumerable: !0,
      get: function get() {
        return o.QueuesDataTableCell;
      }
    }), Object.defineProperty(t, "QueuesDataTableCellProps", {
      enumerable: !0,
      get: function get() {
        return o.QueuesDataTableCellProps;
      }
    });
    var i = n(25);
    Object.defineProperty(t, "ActivityStatistic", {
      enumerable: !0,
      get: function get() {
        return i.ActivityStatistic;
      }
    }), Object.defineProperty(t, "WorkerQueue", {
      enumerable: !0,
      get: function get() {
        return i.WorkerQueue;
      }
    }), Object.defineProperty(t, "WorkspaceStats", {
      enumerable: !0,
      get: function get() {
        return i.WorkspaceStats;
      }
    });
    var a = n(216),
      s = n(25);
    t.setFilter = function (e) {
      return s.Actions.setFilter(e);
    };
    t.setSubscriptionFilter = function (e) {
      a.QueuesStatsSubscriptionService.filter = e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      i = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Link = t.Marker = t.ChannelName = t.QueuesDataTableCellComponent = t.TableContainer = void 0;
    var a = n(2),
      s = n(212),
      l = n(1),
      c = n(0);
    t.TableContainer = a.default("div")(u || (u = r(["\n    overflow-y: auto;\n    width: 100%;\n    margin: 48px auto 0;\n    box-sizing: border-box;\n\n    table {\n        table-layout: auto;\n    }\n\n    td {\n        font-size: 12px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    td.Twilio-DataTable-Cell-Agents {\n        width: 149px;\n    }\n\n    td:first-child,\n    th:first-child {\n        padding-left: 16px;\n    }\n\n    th:first-child,\n    td:first-child {\n        width: 330px;\n    }\n\n    ", "\n"], ["\n    overflow-y: auto;\n    width: 100%;\n    margin: 48px auto 0;\n    box-sizing: border-box;\n\n    table {\n        table-layout: auto;\n    }\n\n    td {\n        font-size: 12px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    td.Twilio-DataTable-Cell-Agents {\n        width: 149px;\n    }\n\n    td:first-child,\n    th:first-child {\n        padding-left: 16px;\n    }\n\n    th:first-child,\n    td:first-child {\n        width: 330px;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.QueuesStats.TableContainer;
    }), t.QueuesDataTableCellComponent = a.default("ul")(p || (p = r(["\n    padding: 2px 0;\n    margin: 0;\n\n    li:first-child {\n        font-weight: bold;\n    }\n\n    li {\n        height: 16px;\n        padding: 16px 16px 16px 0;\n        display: flex;\n        align-items: center;\n\n        .Twilio-IconButton:hover {\n            background: transparent;\n        }\n    }\n\n    ", "\n"], ["\n    padding: 2px 0;\n    margin: 0;\n\n    li:first-child {\n        font-weight: bold;\n    }\n\n    li {\n        height: 16px;\n        padding: 16px 16px 16px 0;\n        display: flex;\n        align-items: center;\n\n        .Twilio-IconButton:hover {\n            background: transparent;\n        }\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.QueuesStats.QueuesDataTableCell;
    }), t.ChannelName = a.default("div")(d || (d = r(["\n    ", "\n    display: flex;\n    align-items: center;\n    flex: 1;\n\n    li:not(:first-child) & {\n        padding-left: 48px;\n    }\n\n    .Twilio-Icon {\n        margin-right: 4px;\n    }\n"], ["\n    ", "\n    display: flex;\n    align-items: center;\n    flex: 1;\n\n    li:not(:first-child) & {\n        padding-left: 48px;\n    }\n\n    .Twilio-Icon {\n        margin-right: 4px;\n    }\n"])), function (e) {
      return e.clickable && "cursor: pointer;";
    });
    var u,
      p,
      d,
      f,
      h,
      m = a.default("dt")(f || (f = r(["\n    height: 18px;\n    width: 18px;\n    line-height: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n    margin-right: 8px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    color: white;\n"], ["\n    height: 18px;\n    width: 18px;\n    line-height: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n    margin-right: 8px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    color: white;\n"])), function (e) {
        return e.color || e.theme.calculated.textColor;
      });
    t.Marker = function (e) {
      var t = e.icon,
        n = (e.ref, i(e, ["icon", "ref"]));
      return l.createElement(m, o({}, n), l.createElement(c.Icon, {
        icon: t,
        sizeMultiplier: 1
      }));
    }, t.Link = a.default(s.Link)(h || (h = r(["\n    color: ", ";\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 24px;\n    text-decoration: none;\n\n    &:hover {\n        border-bottom: 1px solid ", ";\n    }\n"], ["\n    color: ", ";\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 24px;\n    text-decoration: none;\n\n    &:hover {\n        border-bottom: 1px solid ", ";\n    }\n"])), function (e) {
      return e.theme.calculated.textColor;
    }, function (e) {
      return e.theme.calculated.textColor;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.removeTickListener = t.addTickListener = void 0;
    var r = new (n(456))();
    window.setInterval(function () {
      return r.emit("tick");
    }, 1e3);
    t.addTickListener = function (e) {
      return r.on.call(r, "tick", e);
    };
    t.removeTickListener = function (e) {
      return r.off.call(r, "tick", e);
    };
  }, function (e, t, n) {
    "use strict";

    var _r17,
      o = this && this.__extends || (_r17 = function r(e, t) {
        return (_r17 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r17(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GoodDataGate = void 0;
    var i = n(1),
      a = n(0),
      s = n(21),
      l = n(60),
      c = n(220),
      u = n(61),
      p = n(140),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return i.createElement(c.InsightsGate, null, i.createElement(l.InsightsController, null, function (t) {
            var n = t.historicalReportingStatus;
            return n === s.InsightsServiceStatus.Ready ? e.props.children : n === s.InsightsServiceStatus.Inactive ? i.createElement(a.ErrorMessage, {
              title: "Unable to access Flex Insights Historical Reporting",
              description: "Embedding Historical Reporting is not active for your account. Please contact support to enable the feature.",
              hideBranding: !0
            }) : n === s.InsightsServiceStatus.Initializing ? i.createElement(u.LoadingContainer, null, i.createElement(a.CircularProgress, {
              animating: !0,
              size: 80,
              borderWidth: 3
            })) : n === s.InsightsServiceStatus.CORSError ? "localhost" === window.location.hostname ? i.createElement(a.ErrorMessage, {
              hideBranding: !0,
              title: "Unable to access Flex Insights Historical Reporting",
              description: i.createElement(i.Fragment, null, "Make sure your dev proxy is running. See", " ", i.createElement("a", {
                href: "https://www.twilio.com/docs/flex/developer/insights/custom-domain#local-development",
                target: "_blank",
                rel: "noreferrer"
              }, "Historical Reporting - local development"), " ", "documentation. If the problem persists, please contact support.")
            }) : i.createElement(a.ErrorMessage, {
              hideBranding: !0,
              title: "Unable to access Flex Insights Historical Reporting",
              description: i.createElement(i.Fragment, null, "Make sure access is allowed from your domain. See", " ", i.createElement("a", {
                href: "https://www.twilio.com/docs/flex/developer/insights/custom-domain",
                target: "_blank",
                rel: "noreferrer"
              }, "Historical Reporting for Custom Domains"), " ", "documentation . If the problem persists, please contact support.")
            }) : i.createElement(p.NotAvailable, {
              name: "Flex Insights Historical Reporting"
            });
          }));
        }, t;
      }(i.PureComponent);
    t.GoodDataGate = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotAvailable = void 0;
    var r = n(1),
      o = n(0),
      i = n(6),
      a = function a(e) {
        return "" + e[0].toUpperCase() + e.slice(1) + " view";
      },
      s = function s(e) {
        return "There's an issue with accessing " + (e ? a(e) : "Insights") + " in Flex, sorry about this. Please refresh your screen and try again.\n    If you continue to see this message, contact your support team.\n    ";
      };
    t.NotAvailable = function (e) {
      var t = e.name;
      return r.createElement(o.ErrorMessage, {
        title: t ? a(t) + " is unavailable" : "Insights unavailable",
        description: s(t),
        primaryAction: function primaryAction() {
          return i.tryInvokeAction("ReloadWindow");
        },
        primaryActionTitle: "Refresh",
        hideBranding: !0
      });
    }, t.NotAvailable.defaultProps = {
      name: void 0
    };
  }, function (e, t, n) {
    "use strict";

    var _r18,
      o = this && this.__extends || (_r18 = function r(e, t) {
        return (_r18 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r18(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ContextProvider = t.FlexContext = void 0;
    var i = n(1),
      a = n(82),
      s = n(62),
      l = n(125),
      c = n(5),
      u = n(7);
    t.FlexContext = i.createContext(void 0);
    var p = function p(e) {
        return e.store === l.getDefaultStore() || e.legacy ? i.createElement(a.Provider, {
          store: e.store
        }, e.children) : e.children;
      },
      d = function (e) {
        function n(t) {
          var n = e.call(this, t) || this;
          return t.manager ? (t.manager.loadInitialData().then(function () {
            return c.log.info("All data has been loaded...");
          }).catch(function (e) {
            throw u.ErrorManager.createAndProcessError("Couldn't load initial data", {
              type: u.FlexErrorType.app,
              context: "Context Provider",
              wrappedError: e
            });
          }), n) : (c.log.error("manager missing in the props of ContextProvider"), n);
        }
        return o(n, e), n.prototype.render = function () {
          var e = this.props.manager;
          return i.createElement(t.FlexContext.Provider, {
            value: this.props
          }, i.createElement(p, {
            store: e.store,
            legacy: this.props.legacy
          }, i.createElement(s.ThemeProvider, null, this.props.children)));
        }, n;
      }(i.PureComponent);
    t.ContextProvider = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      i = this && this.__metadata || function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ThemeDefCreator = t.ThemeColorsDefinitionCreator = void 0;
    var a = n(467),
      s = n(468),
      l = n(469),
      c = n(470),
      u = n(178),
      p = function () {
        function e() {}
        return e.getPredefined = function (e) {
          var t = {
              MediumTheme: a.default,
              DarkTheme: s.default,
              BlueMediumTheme: c.default,
              BlueDarkTheme: l.default
            },
            n = r(r({}, t), {
              GreyDark: s.GreyDark,
              GreyLight: a.GreyLight,
              FlexDark: l.FlexDark,
              FlexLight: c.FlexLight
            })[e];
          return n || (n = c.FlexLight), n;
        }, e;
      }();
    t.ThemeColorsDefinitionCreator = p;
    var d = function () {
      function e() {}
      return e.getPredefinedTheme = function (e) {
        return p.getPredefined(e);
      }, o([u.deprecatedMethod("ThemeColorsDefinitionCreator.getPredefined"), i("design:type", Function), i("design:paramtypes", [String]), i("design:returntype", Object)], e, "getPredefinedTheme", null), e;
    }();
    t.ThemeDefCreator = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationsService = void 0;
    var s = n(45),
      l = n(3),
      c = n(54),
      u = n(13),
      p = n(9),
      d = n(18),
      f = n(222),
      h = n(29),
      m = n(7);
    function g(e) {
      if (!e) return {
        unsecureRecordingUrl: void 0,
        secureRecordingUrl: void 0
      };
      var t = e.content.find(function (e) {
        return e.type === d.InsightsPlayerMediaLinkType.VoiceRecording;
      });
      return t ? {
        unsecureRecordingUrl: t.url,
        secureRecordingUrl: t.url_secure
      } : e.media && e.media.href ? {
        unsecureRecordingUrl: e.media.href,
        secureRecordingUrl: e.media.href_secure
      } : {
        unsecureRecordingUrl: void 0,
        secureRecordingUrl: void 0
      };
    }
    function y(e) {
      return o(this, void 0, Promise, function () {
        var t, n, r, o, a;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 3,, 4]), [4, fetch(e, {
                headers: {
                  Authorization: "Basic " + btoa("token:" + u.Manager.getInstance().user.token)
                }
              })];
            case 1:
              if (!(t = i.sent()).ok) throw new Error("Fetching secured recording url from " + e + " failed with " + t.status + ": " + t.statusText);
              return [4, t.json()];
            case 2:
              return n = i.sent(), r = function (e) {
                if (!e) return 0;
                var t = new URL(e),
                  n = new URLSearchParams(t.search);
                return Number(n.get("X-Amz-Expires"));
              }(n.media_url), o = r > 0 && n.media_url ? Date.now() + 1e3 * r : -1, [2, {
                presignedRecordingUrl: n.media_url,
                presignedRecordingUrlExpiresAt: o,
                secureUrl: e
              }];
            case 3:
              return a = i.sent(), m.ErrorManager.createAndProcessError(h.ErrorMessages.CONVERSATION_SERVICE_PRESIGNED_URL_FETCH_FAILED, {
                type: m.FlexErrorType.app,
                context: "ConversationService",
                wrappedError: a
              }), [2, {
                presignedRecordingUrl: void 0,
                presignedRecordingUrlExpiresAt: -1,
                secureUrl: e
              }];
            case 4:
              return [2];
          }
        });
      });
    }
    function v(e, t) {
      return o(this, void 0, Promise, function () {
        var n;
        return i(this, function (r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 3,, 4]), [4, fetch(e)];
            case 1:
              return [4, r.sent().json()];
            case 2:
              return [2, {
                peaks: r.sent().peaks,
                recordingUrl: t
              }];
            case 3:
              return n = r.sent(), m.ErrorManager.createAndProcessError(h.ErrorMessages.CONVERSATION_SERVICE_PEAKS_FETCH_FAILED, {
                type: m.FlexErrorType.app,
                context: "ConversationService",
                wrappedError: n
              }), [2, {
                peaks: void 0,
                recordingUrl: t
              }];
            case 4:
              return [2];
          }
        });
      });
    }
    var b = function () {
      function e() {
        this.playerConfig = p.getFlexInsightsPlayerConfig(u.Manager.getInstance().configuration), this.insightsService = s.InsightsService.getInstance(), this.dispatch = l.FlexModule.dispatch;
      }
      return e.getInstance = function () {
        return e.instance || (e.instance = new e()), e.instance;
      }, e.prototype.refreshPresignedRecordingUrl = function (e) {
        return o(this, void 0, void 0, function () {
          var t, n, r, o, a, s, l;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                if (t = u.Manager.getInstance().store, !(n = t ? t.getState().flex : void 0)) return [2];
                if (!(r = n.insights.segmentsById[e]) || !r.data) return [2];
                if (!(o = g(r.data.links).secureRecordingUrl)) throw new Error("Attempting to refresh presigned URL for a segment that does not provide secure URL");
                return [4, y(o)];
              case 1:
                return a = i.sent(), s = a.presignedRecordingUrl, l = a.presignedRecordingUrlExpiresAt, this.dispatch({
                  type: c.UPDATE_RECORDING_URL,
                  payload: {
                    recordingUrl: s,
                    recordingUrlExpiresAt: l,
                    segmentId: e
                  }
                }), [2];
            }
          });
        });
      }, e.prototype.fetchSegment = function (e) {
        return o(this, void 0, Promise, function () {
          var t,
            n,
            o,
            s,
            l,
            u,
            p,
            d,
            h,
            m,
            b,
            C,
            _ = this;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                this.dispatch({
                  type: c.SEGMENT_FETCH_START,
                  payload: e
                }), i.label = 1;
              case 1:
                return i.trys.push([1, 6,, 7]), [4, Promise.all([this.insightsService.identityClient.axios.get(this.playerConfig.mediaApiUrl + "/data/" + e), this.insightsService.identityClient.axios.get(this.playerConfig.mediaApiUrl + "/conversation?segment_id=" + e)])];
              case 2:
                return t = i.sent(), n = t[0], o = t[1], s = o.data._embedded.segment.filter(function (t) {
                  return t.segment_id !== e;
                }).map(function (e) {
                  return _.insightsService.identityClient.axios.get(_.playerConfig.mediaApiUrl + "/data/" + e.segment_id);
                }), u = [[n]], [4, Promise.all(s)];
              case 3:
                return l = a.apply(void 0, u.concat([i.sent()])), p = {}, l.forEach(function (e) {
                  p[e.data.metadata.segment_id] = {
                    id: e.data.metadata.segment_id,
                    data: r(r({}, e.data.metadata), {
                      links: e.data._links,
                      conversation: {
                        conversation_id: o.data.conversation_id,
                        segmentCount: o.data.segment_count,
                        segments: o.data._embedded.segment
                      }
                    })
                  };
                }), d = new Map(), h = new Map(), l.forEach(function (e) {
                  var t = g(e.data._links),
                    n = t.secureRecordingUrl,
                    r = t.unsecureRecordingUrl;
                  if (n) (o = d.get(n)) ? o.push(e.data.metadata.segment_id) : d.set(n, [e.data.metadata.segment_id]);else if (r) {
                    var o;
                    (o = h.get(r)) ? o.push(e.data.metadata.segment_id) : h.set(r, [e.data.metadata.segment_id]);
                  }
                }), m = [], b = [], d.forEach(function (e, t) {
                  m.push(y(t));
                  var n = p[e[0]].data.links.peaks.href;
                  n && b.push(v(n, t));
                }), h.forEach(function (e, t) {
                  var n = p[e[0]].data.links.peaks.href;
                  n && b.push(v(n, t)), e.forEach(function (e) {
                    p[e].data.recordingUrl = t, p[e].data.recordingUrlExpiresAt = -1;
                  });
                }), [4, Promise.all(m)];
              case 4:
                return i.sent().forEach(function (e) {
                  var t = d.get(e.secureUrl);
                  null == t || t.forEach(function (t) {
                    p[t].data.recordingUrl = e.presignedRecordingUrl, p[t].data.recordingUrlExpiresAt = e.presignedRecordingUrlExpiresAt;
                  });
                }), [4, Promise.all(b)];
              case 5:
                return i.sent().forEach(function (e) {
                  var t = d.get(e.recordingUrl) || h.get(e.recordingUrl);
                  null == t || t.forEach(function (t) {
                    p[t].data.peaks = e.peaks;
                  });
                }), d.size + h.size > 0 && f.FindingService.getInstance().fetchConversationFindings(o.data._embedded.segment.map(function (e) {
                  return e.segment_id;
                })), this.dispatch({
                  type: c.SEGMENT_FETCH_SUCCESS,
                  payload: p
                }), [3, 7];
              case 6:
                return C = i.sent(), this.dispatch({
                  type: c.SEGMENT_FETCH_FAILURE,
                  payload: {
                    id: e,
                    error: C
                  }
                }), [3, 7];
              case 7:
                return [2];
            }
          });
        });
      }, e;
    }();
    t.ConversationsService = b;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QuestionnaireService = void 0;
    var i = n(40),
      a = n(45),
      s = n(118),
      l = n(3),
      c = n(57),
      u = n(13),
      p = n(9),
      d = n(0),
      f = n(14),
      h = function () {
        function e() {
          this.assessmentsApiUrl = p.getFlexInsightsAssessmentsUrl(u.Manager.getInstance().configuration), this.insightsService = a.InsightsService.getInstance(), this.dispatch = l.FlexModule.dispatch;
        }
        return e.getInstance = function () {
          return e.instance || (e.instance = new e()), e.instance;
        }, e.prototype.fetchQuestionnaires = function () {
          return r(this, void 0, Promise, function () {
            var e;
            return o(this, function (t) {
              switch (t.label) {
                case 0:
                  return a.InsightsService.hasPermission(i.InsightsPermission.Assessment.Add) ? [4, this.insightsService.identityClient.axios.get(this.assessmentsApiUrl + "/questionnaires")] : [2];
                case 1:
                  return e = t.sent(), this.dispatch({
                    type: s.QUESTIONNAIRES_UPDATE,
                    payload: e.data.questionnaires
                  }), [2];
              }
            });
          });
        }, e.prototype.fetchComments = function (e) {
          return r(this, void 0, Promise, function () {
            var t;
            return o(this, function (n) {
              switch (n.label) {
                case 0:
                  return a.InsightsService.hasPermission(i.InsightsPermission.Comment.View) ? [4, this.insightsService.identityClient.axios.get(this.assessmentsApiUrl + "/comments/agent/" + e)] : [2];
                case 1:
                  return t = n.sent(), this.dispatch({
                    type: s.COMMENTS_UPDATE,
                    payload: {
                      agentId: e,
                      data: t.data.comments
                    }
                  }), [2];
              }
            });
          });
        }, e.prototype.fetchAssessment = function (e) {
          return r(this, void 0, Promise, function () {
            var t;
            return o(this, function (n) {
              switch (n.label) {
                case 0:
                  return a.InsightsService.hasPermission(i.InsightsPermission.Assessment.Add) ? [4, this.insightsService.identityClient.axios.get(this.assessmentsApiUrl + "/assessments/segment/" + e)] : [2];
                case 1:
                  return t = n.sent(), this.dispatch({
                    type: s.ASSESSMENTS_UPDATE,
                    payload: t.data.assessments
                  }), [2];
              }
            });
          });
        }, e.prototype.fetchSettings = function () {
          return r(this, void 0, Promise, function () {
            var e;
            return o(this, function (t) {
              switch (t.label) {
                case 0:
                  return a.InsightsService.hasPermission(i.InsightsPermission.Assessment.Add) ? [4, this.insightsService.identityClient.axios.get(this.assessmentsApiUrl + "/settings")] : [2];
                case 1:
                  return e = t.sent(), this.dispatch({
                    type: s.ASSESSMENTS_SETTINGS_UPDATE,
                    payload: e.data
                  }), [2];
              }
            });
          });
        }, e.prototype.submitAssessment = function (e, t) {
          return r(this, void 0, Promise, function () {
            var n,
              r = this;
            return o(this, function (o) {
              return a.InsightsService.hasPermission(i.InsightsPermission.Assessment.Add) ? (t.segment_id = e, t.user_name = this.insightsService.identityClient && this.insightsService.identityClient.user && this.insightsService.identityClient.user.name || "", t.user_email = this.insightsService.identityClient && this.insightsService.identityClient.user && this.insightsService.identityClient.user.email || "", n = l.FlexModule.state.insights.segmentsById[e], t.agent_id = n && n.data && n.data.agent_id || "", t.offset = c.ConversationView.Player ? c.ConversationView.Player.getCurrentTime() : 0, this.dispatch({
                type: s.ASSESSMENTS_ADD,
                payload: t
              }), this.insightsService.identityClient.axios.post(this.assessmentsApiUrl + "/assessments", t).catch(function () {
                d.Notifications.showNotification(f.AddingAssessmentFailed), r.dispatch({
                  type: s.ASSESSMENTS_REMOVE,
                  payload: t
                });
              }), [2]) : [2];
            });
          });
        }, e.prototype.submitComment = function (e, t) {
          return r(this, void 0, Promise, function () {
            var n;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  if (!a.InsightsService.hasPermission(i.InsightsPermission.Comment.Add)) throw new Error("The user does not have permission to submit comments");
                  return t.segment_id = e, t.user_name = this.insightsService.identityClient && this.insightsService.identityClient.user && this.insightsService.identityClient.user.name || "", t.user_email = this.insightsService.identityClient && this.insightsService.identityClient.user && this.insightsService.identityClient.user.email || "", n = l.FlexModule.state.insights.segmentsById[e], t.agent_id = n && n.data && n.data.agent_id || "", t.offset = c.ConversationView.Player ? c.ConversationView.Player.getCurrentTime() : 0, [4, this.insightsService.identityClient.axios.post(this.assessmentsApiUrl + "/comments", t)];
                case 1:
                  return r.sent(), [2, t];
              }
            });
          });
        }, e;
      }();
    t.QuestionnaireService = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getChannelColor = void 0;
    t.getChannelColor = function (e, t) {
      return t && e && {
        customer: t.colors.acceptColor,
        agent: t.colors.defaultButtonColor
      }[e] || "rgb(90, 90, 90)";
    };
  }, function (e, t, n) {
    "use strict";

    var _r19,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r19 = function r(e, t) {
        return (_r19 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r19(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmbeddedContent = void 0;
    var a,
      s = n(1),
      l = n(2).default("iframe")(a || (a = o(["\n    width: 100%;\n    height: 100%;\n    flex: 1;\n"], ["\n    width: 100%;\n    height: 100%;\n    flex: 1;\n"]))),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.render = function () {
          return "url" in this.props.mediaLink ? s.createElement(l, {
            src: this.props.mediaLink.url,
            title: this.props.mediaLink.title,
            "data-test": "embedded-content"
          }) : null;
        }, t;
      }(s.PureComponent);
    t.EmbeddedContent = c;
  }, function (e, t, n) {
    "use strict";

    var _r20,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r20 = function r(e, t) {
        return (_r20 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r20(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ReferencedContent = void 0;
    var s,
      l = n(1),
      c = n(0),
      u = n(2),
      p = u.default("div")(s || (s = o(["\n    padding: 16px 0;\n    text-align: center;\n\n    strong {\n        font-weight: bold;\n    }\n\n    button {\n        margin-top: 16px;\n    }\n"], ["\n    padding: 16px 0;\n    text-align: center;\n\n    strong {\n        font-weight: bold;\n    }\n\n    button {\n        margin-top: 16px;\n    }\n"]))),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.openLink = function () {
            "url" in t.props.mediaLink && window.open(t.props.mediaLink.url, "_blank");
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this.props.theme ? this.props.theme.colors.lightTextColor : c.BaseTheme.colors.lightTextColor,
            t = this.props.theme ? this.props.theme.colors.defaultButtonColor : c.BaseTheme.colors.defaultButtonColor;
          return "url" in this.props.mediaLink ? l.createElement(p, null, l.createElement("p", null, l.createElement("strong", null, "Referenced URL:"), l.createElement("br", null), this.props.mediaLink.url), l.createElement(c.Button, {
            onClick: this.openLink,
            roundCorners: !1,
            themeOverride: {
              color: e,
              background: t
            }
          }, "Open in a new tab")) : null;
        }, t = a([u.withTheme], t);
      }(l.PureComponent);
    t.ReferencedContent = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AccountMenuTitle = t.AccountMenuDivider = t.AccountMenuItemLogout = t.AccountMenuItem = t.UserActivityControls = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u = n(2),
      p = n(0);
    t.Container = u.default("div")(o || (o = r(["\n    max-width: 200px;\n    ", "\n"], ["\n    max-width: 200px;\n    ", "\n"])), function (e) {
      return e.large && {
        minWidth: "120px;",
        maxWidth: "180px;"
      };
    }), t.UserActivityControls = u.default(p.Menu)(i || (i = r(["\n    white-space: nowrap;\n    min-width: 200px;\n    box-shadow: -1px 1px 3px 0 rgba(0, 0, 0, 0.4);\n"], ["\n    white-space: nowrap;\n    min-width: 200px;\n    box-shadow: -1px 1px 3px 0 rgba(0, 0, 0, 0.4);\n"]))), t.AccountMenuItem = u.default(p.MenuItem)(a || (a = r(["\n    font-weight: normal;\n    letter-spacing: initial;\n    font-weight: ", ";\n"], ["\n    font-weight: normal;\n    letter-spacing: initial;\n    font-weight: ", ";\n"])), function (e) {
      return e.selected && "bold";
    }), t.AccountMenuItemLogout = u.default(p.MenuItem)(s || (s = r(["\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 12px;\n    font-size: 12px;\n    letter-spacing: initial;\n\n    & > span {\n        margin-top: auto;\n        margin-bottom: auto;\n    }\n"], ["\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 12px;\n    font-size: 12px;\n    letter-spacing: initial;\n\n    & > span {\n        margin-top: auto;\n        margin-bottom: auto;\n    }\n"]))), t.AccountMenuDivider = u.default("li")(l || (l = r(["\n    height: 1px;\n    ", "\n"], ["\n    height: 1px;\n    ", "\n"])), function (e) {
      return e.theme.UserActivityControls.Divider;
    }), t.AccountMenuTitle = u.default("li")(c || (c = r(["\n    font-size: 12px;\n    font-weight: bold;\n    padding-top: 4px;\n    padding-bottom: 3px;\n    padding-left: 12px;\n    padding-right: 12px;\n    ", "\n"], ["\n    font-size: 12px;\n    font-weight: bold;\n    padding-top: 4px;\n    padding-bottom: 3px;\n    padding-left: 12px;\n    padding-right: 12px;\n    ", "\n"])), function (e) {
      return e.theme.UserActivityControls.Item;
    });
  }, function (e, t) {
    e.exports = require("lodash.isequal");
  }, function (e, t, n) {
    "use strict";

    var _r21,
      o = this && this.__extends || (_r21 = function r(e, t) {
        return (_r21 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r21(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskList = t.TaskListContext = void 0;
    var s = n(1),
      l = n(0),
      c = n(8),
      u = n(246),
      p = n(246);
    Object.defineProperty(t, "TaskListContext", {
      enumerable: !0,
      get: function get() {
        return p.TaskListContext;
      }
    });
    var d = function d(e, t) {
        var n = c.TaskHelper.isPending(e),
          r = c.TaskHelper.isPending(t);
        return n !== r ? r ? 1 : -1 : n && r ? t.dateUpdated.getTime() - e.dateUpdated.getTime() : t.dateCreated.getTime() - e.dateCreated.getTime();
      },
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
          return s.createElement(u.TaskListImpl, i({}, this.props));
        }, t.displayName = u.displayName, t.Content = u.contentStore, t.IncludeAllFilter = {
          callback: function callback() {
            return !0;
          }
        }, t.defaultProps = {
          compareFunction: d
        }, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.TaskList = f;
  }, function (e, t, n) {
    "use strict";

    var _r22,
      o = this && this.__extends || (_r22 = function r(e, t) {
        return (_r22 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r22(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerDirectoryTabs = void 0;
    var s = n(0),
      l = n(1),
      c = n(26),
      u = n(2),
      p = n(582),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return l.createElement(f, i({}, this.props));
        }, t.friendlyName = p.displayName, t.displayName = p.displayName, t.Content = p.contentStore, t.defaultProps = {}, t = a([s.withDefaultPropsUpdate], t);
      }(l.PureComponent);
    t.WorkerDirectoryTabs = d;
    var f = u.withTheme(c.withTaskContext(p.WorkerDirectoryTabsImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginFormViewProps = t.LoginFormView = void 0;
    var r = n(262);
    Object.defineProperty(t, "LoginFormView", {
      enumerable: !0,
      get: function get() {
        return r.LoginFormView;
      }
    }), Object.defineProperty(t, "LoginFormViewProps", {
      enumerable: !0,
      get: function get() {
        return r.LoginFormViewProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LogoWithCircle = void 0;
    var r = n(615);
    Object.defineProperty(t, "LogoWithCircle", {
      enumerable: !0,
      get: function get() {
        return r.LogoWithCircle;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.defaultCompareFunction = t.WorkerListFilter = t.ColumnDataCreationContext = t.WorkersDataTableProps = t.WorkersDataTable = void 0;
    var r = n(620);
    Object.defineProperty(t, "WorkersDataTable", {
      enumerable: !0,
      get: function get() {
        return r.WorkersDataTable;
      }
    }), Object.defineProperty(t, "WorkersDataTableProps", {
      enumerable: !0,
      get: function get() {
        return r.WorkersDataTableProps;
      }
    }), Object.defineProperty(t, "ColumnDataCreationContext", {
      enumerable: !0,
      get: function get() {
        return r.ColumnDataCreationContext;
      }
    }), Object.defineProperty(t, "WorkerListFilter", {
      enumerable: !0,
      get: function get() {
        return r.WorkerListFilter;
      }
    }), Object.defineProperty(t, "defaultCompareFunction", {
      enumerable: !0,
      get: function get() {
        return r.defaultCompareFunction;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SupervisorStateHelper = void 0;
    var r = n(3);
    t.SupervisorStateHelper = {
      getTaskBySid: function getTaskBySid(e) {
        if (e) {
          var t = function (e) {
            var t = r.FlexModule.state.supervisor.stickyWorker;
            if (t) {
              var n = t.tasks.find(function (t) {
                return t.sid === e;
              });
              if (n) return n;
            }
          }(e);
          if (t) return t;
          for (var n = r.FlexModule.state.supervisor.workers, o = 0; o < n.length; o += 1) {
            if (t = n[o].tasks.find(function (t) {
              return t.sid === e;
            })) return t;
          }
        }
      },
      getTaskByTaskSid: function getTaskByTaskSid(e) {
        if (e) {
          var t = function (e) {
            var t = r.FlexModule.state.supervisor.stickyWorker;
            if (t) {
              var n = t.tasks.find(function (t) {
                return t.taskSid === e;
              });
              if (n) return n;
            }
          }(e);
          if (t) return t;
          for (var n = r.FlexModule.state.supervisor.workers, o = 0; o < n.length; o += 1) {
            if (t = n[o].tasks.find(function (t) {
              return t.taskSid === e;
            })) return t;
          }
        }
      },
      getWorkerBySid: function getWorkerBySid(e) {
        if (e) {
          var t = r.FlexModule.state.supervisor,
            n = t.workers,
            o = t.stickyWorker;
          if (o && o.worker.sid === e) return o.worker;
          var i = n.find(function (t) {
            return t.worker.sid === e;
          });
          return Boolean(i) ? i.worker : void 0;
        }
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LevelInputAndButtonContainer = t.RightButtonContainer = t.StyledSkillLevelInput = t.StyledFormControlLabel = t.AddPanelContainer = t.ButtonsContainer = t.NotificationTextContainer = t.NoSkillsContainer = t.SkillsContainer = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d,
      f,
      h = n(105),
      m = n(639),
      g = n(0),
      y = n(2);
    t.Container = y.default(g.FlexBox)(o || (o = r(["\n    padding-top: 12px;\n    padding-bottom: 12px;\n"], ["\n    padding-top: 12px;\n    padding-bottom: 12px;\n"]))), t.SkillsContainer = y.default(g.FlexBox)(i || (i = r(["\n    padding-left: 12px;\n    padding-right: 12px;\n    overflow-x: hidden;\n    overflow-y: auto;\n"], ["\n    padding-left: 12px;\n    padding-right: 12px;\n    overflow-x: hidden;\n    overflow-y: auto;\n"]))), t.NoSkillsContainer = y.default(g.FlexBox)(a || (a = r(["\n    margin-top: 16px;\n    & > * {\n        margin: auto;\n    }\n"], ["\n    margin-top: 16px;\n    & > * {\n        margin: auto;\n    }\n"]))), t.NotificationTextContainer = y.default(g.FlexBox)(s || (s = r(["\n    margin-top: 12px;\n    font-size: 10px;\n    & > * {\n        margin: auto;\n    }\n"], ["\n    margin-top: 12px;\n    font-size: 10px;\n    & > * {\n        margin: auto;\n    }\n"]))), t.ButtonsContainer = y.default(g.FlexBox)(l || (l = r(["\n    margin-top: 32px;\n    padding-left: 12px;\n    padding-right: 12px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    justify-content: center;\n    & > * {\n        margin-left: 6px;\n        margin-right: 6px;\n        min-width: 100px;\n    }\n"], ["\n    margin-top: 32px;\n    padding-left: 12px;\n    padding-right: 12px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    justify-content: center;\n    & > * {\n        margin-left: 6px;\n        margin-right: 6px;\n        min-width: 100px;\n    }\n"]))), t.AddPanelContainer = y.default(g.FlexBox)(c || (c = r(["\n    padding-left: 12px;\n    padding-right: 12px;\n    min-height: 48px;\n"], ["\n    padding-left: 12px;\n    padding-right: 12px;\n    min-height: 48px;\n"]))), t.StyledFormControlLabel = y.default(m.default)(u || (u = r(["\n    flex: 1 1 auto;\n    overflow: hidden;\n    margin-bottom: auto;\n"], ["\n    flex: 1 1 auto;\n    overflow: hidden;\n    margin-bottom: auto;\n"]))), t.StyledSkillLevelInput = y.default(h.default)(p || (p = r(["\n    flex: 0 0 56px;\n    height: 32px;\n    width: 56px;\n"], ["\n    flex: 0 0 56px;\n    height: 32px;\n    width: 56px;\n"]))), t.RightButtonContainer = y.default("div")(d || (d = r(["\n    display: flex;\n    flex: 0 0 28px;\n    margin-left: 12px;\n    & > * {\n        margin: auto;\n    }\n"], ["\n    display: flex;\n    flex: 0 0 28px;\n    margin-left: 12px;\n    & > * {\n        margin: auto;\n    }\n"]))), t.LevelInputAndButtonContainer = y.default(g.FlexBox)(f || (f = r(["\n    flex-basis: 0;\n"], ["\n    flex-basis: 0;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isSkillLevelOk = void 0, t.isSkillLevelOk = function (e) {
      return !e.multivalue || e.level >= e.minimum && e.level <= e.maximum;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MediaSelectDropdown = void 0, o(n(685), t);
    var i = n(686);
    Object.defineProperty(t, "MediaSelectDropdown", {
      enumerable: !0,
      get: function get() {
        return i.MediaSelectDropdown;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FullScreenAlertViewProps = t.FullScreenAlertView = void 0;
    var r = n(749);
    Object.defineProperty(t, "FullScreenAlertView", {
      enumerable: !0,
      get: function get() {
        return r.FullScreenAlertView;
      }
    }), Object.defineProperty(t, "FullScreenAlertViewProps", {
      enumerable: !0,
      get: function get() {
        return r.FullScreenAlertViewProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PredefinedTransports = t.PredefinedFormatters = t.PredefinedStorages = t.PredefinedSpies = t.Transport = t.Formatter = t.Storage = t.Spy = t.NotifyCallback = t.LogManager = void 0;
    var a = n(161);
    Object.defineProperty(t, "Spy", {
      enumerable: !0,
      get: function get() {
        return a.Spy;
      }
    }), Object.defineProperty(t, "PredefinedSpies", {
      enumerable: !0,
      get: function get() {
        return a.PredefinedSpies;
      }
    }), Object.defineProperty(t, "NotifyCallback", {
      enumerable: !0,
      get: function get() {
        return a.NotifyCallback;
      }
    });
    var s = n(305);
    Object.defineProperty(t, "Formatter", {
      enumerable: !0,
      get: function get() {
        return s.Formatter;
      }
    }), Object.defineProperty(t, "PredefinedFormatters", {
      enumerable: !0,
      get: function get() {
        return s.PredefinedFormatters;
      }
    });
    var l = n(307);
    Object.defineProperty(t, "Storage", {
      enumerable: !0,
      get: function get() {
        return l.Storage;
      }
    }), Object.defineProperty(t, "PredefinedStorages", {
      enumerable: !0,
      get: function get() {
        return l.PredefinedStorages;
      }
    });
    var c,
      u = n(310);
    Object.defineProperty(t, "Transport", {
      enumerable: !0,
      get: function get() {
        return u.Transport;
      }
    }), Object.defineProperty(t, "PredefinedTransports", {
      enumerable: !0,
      get: function get() {
        return u.PredefinedTransports;
      }
    }), function (e) {
      e.isLogging = "isLogging", e.ready = "ready";
    }(c || (c = {}));
    var p = function () {
      function e(t) {
        var n = this,
          o = t.identifier;
        this.config = r(r(r({}, e.defaults), {
          identifier: o
        }), t), this.storage = "function" == typeof this.config.storage ? this.config.storage() : l.getStorage(r({
          identifier: this.config.identifier
        }, this.config.storage));
        var i = this.storage ? function (e) {
          return n.storage.add(e);
        } : function (e) {
          return n.flush([e]);
        };
        this.spies = this.config.spies.map(function (e) {
          return "function" == typeof e ? e({
            trigger: i
          }) : a.getSpy(r({
            trigger: i
          }, e));
        }).filter(function (e) {
          return void 0 !== e;
        }), this.formatter = "function" == typeof this.config.formatter ? this.config.formatter() : s.getFormatter(this.config.formatter), this.transport = "function" == typeof this.config.transport ? this.config.transport() : u.getTransport(this.config.transport), this.start = this.start.bind(this);
      }
      return e.prototype.start = function () {
        this.isReady() && (this.setState(c.isLogging, !0), this.spies.forEach(function (e) {
          return e.start();
        }));
      }, e.prototype.stop = function () {
        this.spies.forEach(function (e) {
          return e.stop();
        }), this.storage.clear(), this.setState(c.ready, !1), this.setState(c.isLogging, !1);
      }, e.prototype.flush = function (e) {
        e = void 0 === e && this.storage ? this.storage.get() : e;
        var t = this.formatter(e);
        return this.transport.flush(t);
      }, e.prototype.isReady = function () {
        return !!this.getState(c.ready);
      }, e.prototype.isLogging = function () {
        return !!this.getState(c.isLogging);
      }, e.prototype.getLogsSnapshot = function () {
        return this.storage.get();
      }, e.prototype.prepare = function () {
        return o(this, void 0, Promise, function () {
          return i(this, function (e) {
            return this.setState(c.ready, !0), [2, Promise.resolve()];
          });
        });
      }, e.prototype.setState = function (t, n) {
        var o,
          i = JSON.parse(window.localStorage.getItem(e.persistKey)) || {};
        i[this.config.identifier] = r(r({}, i[this.config.identifier]), ((o = {})[t] = n, o)), window.localStorage.setItem(e.persistKey, JSON.stringify(i));
      }, e.prototype.getState = function (t) {
        var n = (JSON.parse(window.localStorage.getItem(e.persistKey)) || {})[this.config.identifier] || {};
        return t ? n[t] : n;
      }, e.persistKey = "FLEX_LOG_STATE", e.defaults = {
        spies: [],
        storage: {
          type: l.PredefinedStorages.LocalStorage
        },
        transport: {
          type: u.PredefinedTransports.File
        },
        formatter: {
          type: s.PredefinedFormatters.String
        }
      }, e;
    }();
    t.LogManager = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__rest || function (e, t) {
      var n = {};
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
      }
      return n;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getSpy = t.PredefinedSpies = t.OnStartCallback = t.NotifyCallback = t.Spy = void 0;
    var o = n(67);
    Object.defineProperty(t, "Spy", {
      enumerable: !0,
      get: function get() {
        return o.Spy;
      }
    }), Object.defineProperty(t, "NotifyCallback", {
      enumerable: !0,
      get: function get() {
        return o.NotifyCallback;
      }
    }), Object.defineProperty(t, "OnStartCallback", {
      enumerable: !0,
      get: function get() {
        return o.OnStartCallback;
      }
    });
    var i,
      a = n(301),
      s = n(302),
      l = n(303),
      c = n(304);
    !function (e) {
      e.ClassProxy = "ClassProxy", e.EventEmitter = "EventEmitter", e.DOMEvents = "DOMEvents", e.Loglevel = "Loglevel";
    }(i = t.PredefinedSpies || (t.PredefinedSpies = {}));
    t.getSpy = function (e) {
      var t = e.type,
        n = r(e, ["type"]);
      switch (e.type) {
        case i.ClassProxy:
          return new a.ClassProxySpy(n);
        case i.EventEmitter:
          return new s.EventEmitterSpy(n);
        case i.DOMEvents:
          return new l.DOMEventsSpy(n);
        case i.Loglevel:
          return new c.LoglevelSpy(n);
        default:
          console.error("invalid spy type: " + t);
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.initDefaultChannels = void 0;
    var i = n(163);
    o(n(163), t), o(n(313), t), o(n(112), t), t.initDefaultChannels = function (e) {
      i.init(e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.init = t.Call = t.createCallTaskChannel = void 0;
    var r,
      o,
      i,
      a = n(0),
      s = n(112),
      l = n(52),
      c = n(8),
      u = n(84),
      p = n(6),
      d = n(114),
      f = function f(e, t) {
        if (e.incomingTransferObject && "pending" === e.status) return "WORKER" === e.incomingTransferObject.type ? t === o ? "TaskLineCallTransferWorkerDetail" : "TaskLineCallTransferWorker" : t === o ? "TaskLineCallTransferQueueDetail" : "TaskLineCallTransferQueue";
        if (c.TaskHelper.isInitialOutboundAttemptTask(e)) return "TaskLineOutboundCallConnecting";
        switch (e.status) {
          case "pending":
            return t === o ? "TaskLineQueue" : "TaskLineCallReserved";
          case "accepted":
            return e.conference && e.conference.liveParticipantCount > 2 ? "TaskLineGroupCallAssigned" : "TaskLineCallAssigned";
          case "wrapping":
            if (t === r) return;
            return "TaskLineCallWrapup";
          default:
            return "";
        }
      },
      h = function h(e, t) {
        switch (e.status) {
          case "accepted":
            return e.conference && e.conference.liveParticipantCount > 2 ? "TaskHeaderLeaveCall" : "TaskHeaderEndCall";
          case "wrapping":
            return "TaskHeaderComplete";
          default:
            return "";
        }
      },
      m = function m(e, t) {
        switch (e.status) {
          case "accepted":
            return e.conference && e.conference.liveParticipantCount > 2 ? "SupervisorTaskGroupCall" : "SupervisorTaskLive";
          case "pending":
            return "SupervisorTaskLive";
          case "wrapping":
            return "SupervisorTaskWrapUp";
          default:
            return "SupervisorTaskCompleted";
        }
      },
      g = function g(e, t) {
        if (e.incomingTransferObject && "pending" === e.status) return "TaskLineCallTransferTitle";
        switch (e.status) {
          case "pending":
            return "TaskLineCallIncomingTitle";
          case "wrapping":
            return "TaskLineCallEndedTitle";
          default:
            return "";
        }
      },
      y = function y(e, t) {
        switch (e.status) {
          case "pending":
            return "TaskHeaderStatusPending";
          case "accepted":
            return e.conference && e.conference.liveParticipantCount > 2 ? "TaskHeaderGroupCallAccepted" : "TaskHeaderStatusAccepted";
          case "wrapping":
            return "TaskHeaderStatusWrapup";
          case "completed":
            return "TaskHeaderStatusCompleted";
          default:
            return "";
        }
      },
      v = function v(e, t) {
        return c.TaskHelper.isOutboundCallTask(e) ? "TaskLineOutboundCallHeader" : "TaskHeaderLine";
      },
      b = {
        IncomingTask: function IncomingTask(e, t) {
          var n = e.context.task,
            r = "IncomingCallNotificationTitle",
            o = "IncomingCallBrowserNotificationTitle",
            i = "IncomingCallBrowserNotificationBody";
          n && n.incomingTransferObject && (r = "IncomingCallTransferNotificationTitle", o = "IncomingCallTransferBrowserNotificationTitle", i = "WORKER" === n.incomingTransferObject.type ? "IncomingCallTransferWorkerBrowserNotificationBody" : "IncomingCallTransferQueueBrowserNotificationBody"), e.content = r, e.timeout = 0, e.icon = "IncomingCallBold", e.actions = d.incomingTaskNotificationActions, e.options || (e.options = {}), e.options.browser = {
            title: o,
            body: i,
            onClick: function onClick(e, t) {
              p.tryInvokeAction("SelectTask", {
                task: e.context.task
              });
            },
            options: {
              requireInteraction: !0
            }
          };
        }
      };
    function C(e, t) {
      return a.Utils.merge(s.Default, {
        name: e,
        isApplicable: t,
        capabilities: new Set([l.TaskChannelCapability.Call, l.TaskChannelCapability.Info, l.TaskChannelCapability.Wrapup]),
        colors: {
          main: w
        },
        icons: {
          list: _,
          active: k,
          main: "Call"
        },
        notifications: {
          override: b
        },
        templates: {
          CallCanvas: {
            secondLine: f,
            titleLine: g
          },
          IncomingTaskCanvas: {
            secondLine: f,
            titleLine: g
          },
          TaskListItem: {
            firstLine: v,
            secondLine: f
          },
          TaskCanvasHeader: {
            title: v,
            secondLine: y,
            endButton: h
          },
          TaskCard: {
            secondLine: m
          },
          Supervisor: {
            TaskCanvasHeader: {
              secondLine: y
            }
          },
          TaskCanvasTabs: {
            contentTabHeader: "TaskTabHeaderCall"
          }
        },
        componentProps: {}
      });
    }
    function _(e, t, n) {
      void 0 === n && (n = !1);
      var r = "Call";
      return i.has(t) && (r = "IncomingCall", c.TaskHelper.isInitialOutboundAttemptTask(e) ? r = "OutboundCall" : e.incomingTransferObject && "pending" === e.status ? r = "IncomingTransfer" : c.TaskHelper.isRegularConferenceCall(e) && c.TaskHelper.isGroupCall(e) && !c.TaskHelper.isInWrapupMode(e) && !c.TaskHelper.isCompleted(e) ? r = "GroupCall" : c.TaskHelper.isCallOnHold(e) ? r = "Hold" : c.TaskHelper.isLiveCall(e) ? r = c.TaskHelper.isOutboundCallTask(e) ? "OutboundCall" : "Call" : (c.TaskHelper.isInWrapupMode(e) || c.TaskHelper.isCompleted(e)) && (r = "Hangup")), n && (r += "Bold"), r;
    }
    function k(e, t, n) {
      return _(e, t, !0);
    }
    function w(e, t) {
      return c.TaskHelper.isCallOnHold(e) && !c.TaskHelper.isGroupCall(e) ? u.commonColors.holdColor : c.TaskHelper.isLiveCall(e) || c.TaskHelper.isIncomingCall(e) || c.TaskHelper.isInitialOutboundAttemptTask(e) ? u.defaultChannelColors.call : u.defaultChannelColors.inactive;
    }
    t.createCallTaskChannel = C, t.Call = C("call", function (e) {
      return "voice" === e.taskChannelUniqueName;
    }), t.init = function (e) {
      i || (i = new Set([e.CallCanvas, e.IncomingTaskCanvas, e.TaskCard, e.TaskOverviewCanvas, e.TaskListBaseItem, e.ConnectingOutboundCallCanvas]), r = e.CallCanvas, o = e.IncomingTaskCanvas);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.loadTaskChatChannel = void 0;
    var r = n(0),
      o = n(8),
      i = n(5);
    t.loadTaskChatChannel = function (e) {
      var t = o.TaskHelper.getTaskChatChannelSid(e);
      i.log.debug("initializing chat for channel", t), r.ChatChannelState.Actions.initWithChannelSid(t);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ProgrammabilityEventCallType = void 0, function (e) {
      e.Action = "action", e.DynamicComponent = "dynamic_component", e.DynamicComponentInTaskChannel = "dynamic_component_taskchannel", e.EventUsage = "event_usage", e.Notification = "notification", e.SDKUsage = "sdk_usage";
    }(t.ProgrammabilityEventCallType || (t.ProgrammabilityEventCallType = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TelemetryManager = void 0;
    var s = n(0),
      l = n(5),
      c = n(20),
      u = n(314),
      p = n(165),
      d = n(315),
      f = n(316),
      h = n(317),
      m = function () {
        function e() {
          var e = this;
          this.sentSDKTelemetryClients = new Set(), this.initialTaskChannels = [], this.uiInteractionEventsDelegate = new h.UIInteractionEventsDelegate(), this.programmabilityEventsDelegate = new d.ProgrammabilityEventsDelegate(), this.sessionStartEventDelegate = new f.SessionStartEventDelegate(), this.errorEventDelegate = new u.ErrorEventDelegate(), this.onReportMediaMessageSent = function (t) {
            var n = e.uiInteractionEventsDelegate.format({
              name: "send_media_message",
              status: "complete",
              details: {
                fileSize: String(t.size),
                fileType: t.type
              }
            });
            e.uiInteractionEventsDelegate.report(n);
          }, this.onReportMediaMessageReceived = function (t) {
            return o(e, void 0, Promise, function () {
              var e, n, r, o;
              return i(this, function (i) {
                return e = t.state.media.state, n = e.contentType, r = e.size, o = this.uiInteractionEventsDelegate.format({
                  name: "receive_media_message",
                  status: "complete",
                  details: {
                    fileSize: String(r),
                    fileType: String(n)
                  }
                }), this.uiInteractionEventsDelegate.report(o), [2];
              });
            });
          }, this.reportPluginInteraction = function (t) {
            var n = e.uiInteractionEventsDelegate.format({
              name: t.name,
              status: t.status,
              details: t.details
            });
            e.uiInteractionEventsDelegate.report(n);
          }, this.onAddProgrammabilityEvent = function (t) {
            e.reportProgrammabilityEvent.call(e, t);
          }, this.reportProgrammabilityEvent = function (t) {
            e.programmabilityEventsDelegate.report(e.programmabilityEventsDelegate.format(t));
          }, this.reportUIInteractionEvent = function (t) {
            e.uiInteractionEventsDelegate.report(e.uiInteractionEventsDelegate.format(t));
          }, this.reportErrorEvent = function (t) {
            e.errorEventDelegate.report(e.errorEventDelegate.format(t));
          }, this.stopProgrammabilityGrouping = function () {
            e.resetContext(), e.programmabilityEventsDelegate.stopProgrammabilityGrouping();
          }, this.reportSessionStartEvent = function (t) {
            e.sessionStartEventDelegate.report(e.sessionStartEventDelegate.format(t));
          }, this.reportChatAutoJoinRetryStart = function (t) {
            var n = e.uiInteractionEventsDelegate.format({
              name: "chat_auto_join",
              status: "start",
              details: {
                taskSid: t
              }
            });
            e.uiInteractionEventsDelegate.report(n);
          }, this.reportChatAutoJoinRetryComplete = function (t, n) {
            var r = e.uiInteractionEventsDelegate.format({
              name: "chat_auto_join",
              status: "complete",
              details: {
                retryCount: String(n),
                taskSid: t
              }
            });
            e.uiInteractionEventsDelegate.report(r);
          }, this.reportSecondIncomingVoiceConnection = function (t) {
            var n = e.uiInteractionEventsDelegate.format({
              name: "second_incoming_voice_connection",
              status: "start",
              details: {
                taskSid: t
              }
            });
            e.uiInteractionEventsDelegate.report(n);
          }, this.reportFlexEventListeners = function (t, n) {
            e.reportProgrammabilityEvent({
              callType: p.ProgrammabilityEventCallType.EventUsage,
              listenee: "FlexEvent",
              name: t,
              command: n
            });
          }, this.reportSDKUsage = function (t, n) {
            e.sentSDKTelemetryClients.has(t) || (e.sentSDKTelemetryClients.add(t), e.reportProgrammabilityEvent(r({
              callType: p.ProgrammabilityEventCallType.SDKUsage,
              name: t,
              command: ""
            }, n)));
          }, this.reportNotificationEvent = function (t, n, r) {
            void 0 === r && (r = {}), e.reportProgrammabilityEvent({
              callType: p.ProgrammabilityEventCallType.Notification,
              listenee: "Notifications",
              name: t,
              command: n,
              options: r
            });
          }, this.reportVoiceConnectionWithWrongSecret = function (t, n) {
            n.issue = t;
            var r = e.uiInteractionEventsDelegate.format({
              name: "voice_connection_with_wrong_secret",
              status: "start",
              details: n
            });
            e.uiInteractionEventsDelegate.report(r);
          }, this.reportTransferPanelOpen = function () {
            var t = e.uiInteractionEventsDelegate.format({
              name: "call_canvas_transfer_panel_open",
              status: "start"
            });
            e.uiInteractionEventsDelegate.report(t);
          }, this.reportTransferPanelClose = function () {
            var t = e.uiInteractionEventsDelegate.format({
              name: "call_canvas_transfer_panel_close",
              status: "start"
            });
            e.uiInteractionEventsDelegate.report(t);
          }, this.reportDirectoryTabClick = function (t) {
            var n = e.uiInteractionEventsDelegate.format({
              name: "call_canvas_transfer_panel_close",
              status: "start",
              details: {
                tab: t
              }
            });
            e.uiInteractionEventsDelegate.report(n);
          }, this.reportExternalWarmTransferStart = function () {
            var t = e.uiInteractionEventsDelegate.format({
              name: "external_warm_transfer_start",
              status: "start"
            });
            e.uiInteractionEventsDelegate.report(t);
          }, this.reportCallParticipantHold = function (t) {
            var n = t.type,
              r = e.uiInteractionEventsDelegate.format({
                name: "call_participant_hold",
                status: "start",
                details: {
                  type: n
                }
              });
            e.uiInteractionEventsDelegate.report(r);
          }, this.reportCallParticipantUnhold = function (t) {
            var n = t.type,
              r = e.uiInteractionEventsDelegate.format({
                name: "call_participant_unhold",
                status: "start",
                details: {
                  type: n
                }
              });
            e.uiInteractionEventsDelegate.report(r);
          }, this.reportCallParticipantKicked = function (t) {
            var n = t.type,
              r = e.uiInteractionEventsDelegate.format({
                name: "call_participant_kicked",
                status: "start",
                details: {
                  type: n
                }
              });
            e.uiInteractionEventsDelegate.report(r);
          }, this.reportOutboundCallCanceledEvent = function (t, n) {
            var r = e.uiInteractionEventsDelegate.format({
              name: "outbound_call_canceled",
              status: "complete",
              details: {
                reasonCode: String(t),
                sid: n
              }
            });
            e.uiInteractionEventsDelegate.report(r);
          }, this.reportIncomingCBMTaskNotSupported = function (t, n, r) {
            var o = e.uiInteractionEventsDelegate.format({
              name: "cbm_task_not_supported",
              status: "complete",
              details: {
                reservationSid: t,
                taskSid: n,
                channelType: r
              }
            });
            e.uiInteractionEventsDelegate.report(o);
          };
        }
        return e.prototype.compareTaskChannelDefinitions = function () {
          var e = this,
            t = c.TaskChannels.getRegistered();
          t && t.forEach(function (t, n) {
            (t.addedComponents || []).forEach(function (t, r) {
              (n >= e.initialTaskChannels.length || e.initialTaskChannels[n].addedComponents.length <= r) && e.reportProgrammabilityEvent({
                name: t.target,
                command: "add",
                callType: p.ProgrammabilityEventCallType.DynamicComponentInTaskChannel
              });
            }), (t.removedComponents || []).forEach(function (t, r) {
              (n >= e.initialTaskChannels.length || e.initialTaskChannels[n].removedComponents.length <= r) && e.reportProgrammabilityEvent({
                name: t.target,
                command: "remove",
                options: {
                  key: t.key
                },
                callType: p.ProgrammabilityEventCallType.DynamicComponentInTaskChannel
              });
            }), (t.replacedComponents || []).forEach(function (t, r) {
              (n >= e.initialTaskChannels.length || e.initialTaskChannels[n].replacedComponents.length <= r) && e.reportProgrammabilityEvent({
                name: t.target,
                command: "replace",
                callType: p.ProgrammabilityEventCallType.DynamicComponentInTaskChannel
              });
            });
          });
        }, e.prototype.setContext = function (e) {
          this.programmabilityEventsDelegate.currentPlugin = e.currentPluginName, this.programmabilityEventsDelegate.currentPluginVersion = e.currentPluginVersion, this.programmabilityEventsDelegate.currentOptions || (this.programmabilityEventsDelegate.currentOptions = {}), e.currentOptions && (this.programmabilityEventsDelegate.currentOptions = r(r({}, this.programmabilityEventsDelegate.currentOptions), e.currentOptions));
        }, e.prototype.resetContext = function () {
          var e = this;
          this.initialTaskChannels && this.compareTaskChannelDefinitions(), this.programmabilityEventsDelegate.currentPlugin = void 0, this.programmabilityEventsDelegate.currentPluginVersion = void 0, this.programmabilityEventsDelegate.currentOptions = {};
          var t = c.TaskChannels.getRegistered();
          this.initialTaskChannels = [], t && t.forEach(function (t) {
            e.initialTaskChannels.push({
              name: t.name,
              addedComponents: a(t.addedComponents || []),
              removedComponents: a(t.removedComponents || []),
              replacedComponents: a(t.replacedComponents || [])
            });
          });
        }, e.prototype.initialize = function (e) {
          e ? (this.uiInteractionEventsDelegate.initialize(e), this.programmabilityEventsDelegate.initialize(e), this.sessionStartEventDelegate.initialize(e), this.errorEventDelegate.initialize(e), s.TelemetryBridge.addListener(s.TelemetryBridgeMessageType.MEDIA_MESSAGE_SENT, this.onReportMediaMessageSent), s.TelemetryBridge.addListener(s.TelemetryBridgeMessageType.MEDIA_MESSAGE_RECEIVED, this.onReportMediaMessageReceived), s.TelemetryBridge.addListener(s.TelemetryBridgeMessageType.DYNAMIC_COMPONENT_PROGRAMMABILITY, this.onAddProgrammabilityEvent)) : l.log.debug("Can not initialize TelemetryManager as the FlexSDK client instance is " + typeof e);
        }, e;
      }();
    t.TelemetryManager = new m();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.featureEnabledSelector = t.featureFlagsSelector = void 0;
    var r = n(168),
      o = n(31);
    t.featureFlagsSelector = o.createSelector(function (e) {
      return e.featureFlags.features;
    }, function (e) {
      return e.featureFlags.localOverrides;
    }, function (e, t) {
      return r({}, e, t);
    });
    t.featureEnabledSelector = function (e) {
      return o.createSelector(t.featureFlagsSelector, function (t) {
        return t[e] && t[e].enabled;
      });
    };
  }, function (e, t) {
    e.exports = require("lodash.merge");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TwilioErrorCodes = void 0;
    var r = n(27),
      o = n(9),
      i = n(3),
      a = n(5);
    !function (e) {
      e[e.FlexError = 45600] = "FlexError", e[e.CustomFlexError = 45601] = "CustomFlexError";
    }(t.TwilioErrorCodes || (t.TwilioErrorCodes = {}));
    var s = function () {
      function e() {
        this.events = [], this.sendTimer = null;
      }
      return e.prototype.sendDebugEvent = function (e) {
        var t = this;
        this.events.length < 10 ? this.events.push(e) : a.log.warn("attempting to send too many events to Twilio Debugger"), this.sendTimer || (this.sendTimer = setTimeout(function () {
          t.sendTimer = null, t.publishBatch();
        }, 3e3));
      }, e.prototype.publishBatch = function () {
        var e = o.getTwilioDebuggerUrl(i.FlexModule.state.config);
        r.default.post(e, this.events, {
          headers: {
            "X-Flex-JWE": i.FlexModule.state.session.ssoTokenPayload.token
          }
        }).catch(function (e) {
          a.log.warn("not able to send errors to Twilio Debugger: " + e);
        }), this.events = [];
      }, e;
    }();
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskOverviewCanvasProps = t.TaskOverviewCanvas = void 0;
    var r = n(171);
    Object.defineProperty(t, "TaskOverviewCanvas", {
      enumerable: !0,
      get: function get() {
        return r.TaskOverviewCanvas;
      }
    }), Object.defineProperty(t, "TaskOverviewCanvasProps", {
      enumerable: !0,
      get: function get() {
        return r.TaskOverviewCanvasProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r23,
      o = this && this.__extends || (_r23 = function r(e, t) {
        return (_r23 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r23(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskOverviewCanvas = void 0;
    var s = n(1),
      l = n(0),
      c = n(321),
      u = n(392),
      p = n(74),
      d = n(17),
      f = n(15),
      h = n(2),
      m = n(194),
      g = n(8),
      y = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        var n;
        return o(t, e), n = t, t.prototype.render = function () {
          var e,
            t = this.props,
            r = t.firstLine,
            o = t.secondLine,
            a = t.task,
            l = t.channelDefinition;
          return t.conference && g.TaskHelper.isLiveCall(a) && (e = s.createElement(m.ParticipantsCanvas, {
            includeMyself: !0,
            hideActions: !0
          })), s.createElement(p.TaskDetailsPanel, i({
            content: n.Content,
            IconComponent: u.TaskOverviewIcon,
            ActionsComponent: c.SupervisorTaskOverviewActions,
            contentComponent: e,
            firstLine: r || d.TaskChannelHelper.getTemplateForStatus(a, l.templates.Supervisor.TaskOverviewCanvas.firstLine, n),
            secondLine: o
          }, this.props));
        }, t.friendlyName = "TaskOverviewCanvas", t.displayName = n.friendlyName, t.Content = new l.DynamicContentStore(n.friendlyName), t = n = a([h.withTheme, f.withTaskContext], t);
      }(s.PureComponent);
    t.TaskOverviewCanvas = y;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConferenceParticipant = t.Conference = t.ConferenceListener = t.ConferenceListenerManager = t.ConferenceState = t.ConferencesState = t.UpdateMultipleConferencePayload = t.UpdateConferencePayload = t.Actions = t.reduce = t.OutboundTransfer = t.ConferenceStatus = t.ParticipantStatus = t.ParticipantType = void 0;
    var r = n(173);
    Object.defineProperty(t, "ParticipantType", {
      enumerable: !0,
      get: function get() {
        return r.ParticipantType;
      }
    }), Object.defineProperty(t, "ParticipantStatus", {
      enumerable: !0,
      get: function get() {
        return r.ParticipantStatus;
      }
    }), Object.defineProperty(t, "ConferenceStatus", {
      enumerable: !0,
      get: function get() {
        return r.ConferenceStatus;
      }
    }), Object.defineProperty(t, "OutboundTransfer", {
      enumerable: !0,
      get: function get() {
        return r.OutboundTransfer;
      }
    });
    var o = n(87);
    Object.defineProperty(t, "reduce", {
      enumerable: !0,
      get: function get() {
        return o.reduce;
      }
    }), Object.defineProperty(t, "Actions", {
      enumerable: !0,
      get: function get() {
        return o.Actions;
      }
    }), Object.defineProperty(t, "UpdateConferencePayload", {
      enumerable: !0,
      get: function get() {
        return o.UpdateConferencePayload;
      }
    }), Object.defineProperty(t, "UpdateMultipleConferencePayload", {
      enumerable: !0,
      get: function get() {
        return o.UpdateMultipleConferencePayload;
      }
    }), Object.defineProperty(t, "ConferencesState", {
      enumerable: !0,
      get: function get() {
        return o.ConferencesState;
      }
    }), Object.defineProperty(t, "ConferenceState", {
      enumerable: !0,
      get: function get() {
        return o.ConferenceState;
      }
    });
    var i = n(190);
    Object.defineProperty(t, "ConferenceListenerManager", {
      enumerable: !0,
      get: function get() {
        return i.ConferenceListenerManager;
      }
    });
    var a = n(191);
    Object.defineProperty(t, "ConferenceListener", {
      enumerable: !0,
      get: function get() {
        return a.ConferenceListener;
      }
    });
    var s = n(189);
    Object.defineProperty(t, "Conference", {
      enumerable: !0,
      get: function get() {
        return s.Conference;
      }
    });
    var l = n(128);
    Object.defineProperty(t, "ConferenceParticipant", {
      enumerable: !0,
      get: function get() {
        return l.ConferenceParticipant;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConferenceListenerState = void 0, function (e) {
      e.initializing = "initializing", e.initialized = "initialized", e.destroying = "destroying";
    }(t.ConferenceListenerState || (t.ConferenceListenerState = {}));
  }, function (e, t) {
    e.exports = require("twilio-taskrouter");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectionStatusState = t.reduce = void 0;
    var r = n(83),
      o = n(3),
      i = n(176),
      a = n(16),
      s = n(28),
      l = {
        timestampLastConnected: Date.now(),
        connectionState: "connected"
      };
    t.reduce = function (e, t) {
      switch (void 0 === e && (e = l), t.type) {
        case i.CONNECTION_STATUS_CHANGE:
          if (t.payload !== e.connectionState) {
            var n = e.timestampLastConnected;
            return "connected" !== e.connectionState && "connected" !== t.payload || (n = Date.now()), {
              timestampLastConnected: n,
              connectionState: t.payload
            };
          }
          return e;
        default:
          return e;
      }
    };
    var c = function () {
      function e() {}
      return e.init = function (e, t) {
        void 0 === e && (e = o.FlexModule.insightsClient), void 0 === t && (t = o.FlexModule.dispatch), this.syncClient = e, this.dispatch = t, this.updateConnectionState(this.syncClient.connectionState), this.syncClient.on("connectionStateChanged", this.updateConnectionState);
      }, e.updateConnectionState = function (t) {
        e.dispatchUpdate(t), "connected" === t ? (a.Notifications.dismissNotificationById(a.NotificationIds.NoNetworkConnection), e.dispatchUpdate.flush(), o.FlexModule.events.emitConnectionStateChanged(s.FlexConnectionStatus.connected)) : "connecting" === t && (a.Notifications.dismissNotificationById(a.NotificationIds.NoNetworkConnection), a.Notifications.showNotification(a.NotificationIds.NoNetworkConnection), o.FlexModule.events.emitConnectionStateChanged(s.FlexConnectionStatus.notConnected));
      }, e.dispatchUpdate = r(function (t) {
        e.dispatch({
          type: i.CONNECTION_STATUS_CHANGE,
          payload: t
        });
      }, 5e3), e;
    }();
    t.ConnectionStatusState = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CONNECTION_STATUS_CHANGE = void 0, t.CONNECTION_STATUS_CHANGE = "FLEX_CONNECTION_STATUS_CHANGE";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.clearLastVisitedDashboard = t.getLastVisitedDashboard = t.saveLastVisitedDashboard = void 0;
    var r = n(13);
    t.saveLastVisitedDashboard = function (e) {
      var t = r.Manager.getInstance().serviceConfiguration.account_sid;
      window.localStorage.setItem("insights:last-visited-dashboard:" + t, e);
    }, t.getLastVisitedDashboard = function () {
      var e = r.Manager.getInstance().serviceConfiguration.account_sid;
      return window.localStorage.getItem("insights:last-visited-dashboard:" + e);
    }, t.clearLastVisitedDashboard = function () {
      var e = r.Manager.getInstance().serviceConfiguration.account_sid;
      window.localStorage.removeItem("insights:last-visited-dashboard:" + e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.deprecatedMethod = t.deprecatedSetter = t.deprecatedGetter = void 0, t.deprecatedGetter = function (e) {
      var t = this;
      return function (n, r, o) {
        var i = o.get;
        return o.get = function () {
          return console.warn("Warning! Getter '" + r + "' has been deprecated, please use '" + e + "' instead!"), i.call(t);
        }, o;
      };
    }, t.deprecatedSetter = function (e) {
      var t = this;
      return function (n, r, o) {
        var i = o.set;
        return o.set = function (n) {
          return console.warn("Warning! Setter '" + r + "' has been deprecated, please use '" + e + "' instead!"), i.call(t, n);
        }, o;
      };
    }, t.deprecatedMethod = function (e) {
      var t = this;
      return function (n, r, o) {
        var i = o.value;
        return o.value = function () {
          for (var n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
          return console.warn("Warning! Method '" + r + "' has been deprecated, please use '" + e + "' instead!"), i.apply(t, n);
        }, o;
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Flex = t.isConflictingDependency = void 0;
    var r = n(1),
      o = n(120),
      i = n(82),
      a = n(88),
      s = n(81);
    t.Flex = s;
    var l = n(5);
    window.Twilio = window.Twilio || {
      Flex: s
    }, window.Twilio.Flex || (window.Twilio.Flex = s);
    var c = {
      React: r,
      ReactDOM: o,
      Redux: a,
      ReactRedux: i
    };
    t.isConflictingDependency = function (e, t) {
      var n = window[e],
        r = t[e],
        o = r && r.version,
        i = n && n.version;
      return !!n && n !== r && (!i || i !== o);
    }, Object.keys(c).forEach(function (e) {
      t.isConflictingDependency(e, c) && l.log.warn("Cannot define global `" + e + "` variable for the module because the variable has been set by some other script. This may cause inconsistency."), window[e] = c[e];
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = void 0;
    var o = n(0),
      i = n(3),
      a = n(5);
    t.reduce = function (e, t) {
      switch (void 0 === e && (e = {}), t.type) {
        case "LOAD_CC_CONFIG":
          return r({
            sso: {}
          }, t.payload);
        default:
          return e;
      }
    };
    var s = function () {
      function e() {}
      return e.initConfig = function (e) {
        i.FlexModule.dispatch({
          type: "LOAD_CC_CONFIG",
          payload: e
        }), e.logLevel && a.log.setLevel(e.logLevel), o.ChatConfig.setConfig({
          language: e.language,
          logLevel: e.logLevel
        });
      }, e;
    }();
    t.Actions = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.initialState = void 0;
    var o = n(9),
      i = n(3),
      a = n(6),
      s = n(89);
    t.initialState = {
      queuesList: {},
      hasFetchedList: !1,
      workspaceStats: void 0,
      filter: void 0,
      error: void 0,
      queuesConfig: {
        default: {
          service_level_threshold: 20,
          short_abandoned_threshold: 5,
          reset_timezone: "GMT",
          reset_time: "08:00"
        },
        queue_configurations: [],
        queue_channel_configurations: []
      },
      metadata: {
        queuesBySid: {},
        queueSids: [],
        channelsBySid: {},
        channelSids: [],
        hasFetched: !1,
        error: null
      }
    }, t.reduce = function (e, n) {
      var o;
      switch (void 0 === e && (e = t.initialState), n.type) {
        case s.SET_QUEUES:
          var i = n.payload.reduce(function (e, t) {
            return e[t.key] = t, e;
          }, {});
          return r(r({}, e), {
            queuesList: i,
            hasFetchedList: !0,
            error: void 0
          });
        case s.UPDATE_QUEUE:
          return r(r({}, e), {
            queuesList: r(r({}, e.queuesList), (o = {}, o[n.payload.key] = n.payload, o))
          });
        case s.SET_WORKSPACE_STATS:
          return r(r({}, e), {
            workspaceStats: n.payload
          });
        case s.UPDATE_FILTER:
          return r(r({}, e), {
            filter: n.payload
          });
        case s.QUEUES_ERROR:
          return r(r({}, e), {
            error: n.payload
          });
        case s.UPDATE_QUEUES_CONFIG:
          return r(r({}, e), {
            queuesConfig: n.payload
          });
        case s.UPDATE_METADATA:
          return r(r({}, e), {
            metadata: n.payload
          });
        default:
          return e;
      }
    };
    var l = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || i.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.updateQueuesConfiguration = function (e) {
        this.dispatcher({
          type: s.UPDATE_QUEUES_CONFIG,
          payload: e
        });
      }, e.setFilter = function (e) {
        this.dispatcher({
          type: s.UPDATE_FILTER,
          payload: e
        });
      }, e.fetchMetadata = function () {
        var e = this;
        return this.dispatcher({
          type: s.UPDATE_METADATA,
          payload: {
            queuesBySid: {},
            queueSids: [],
            channelsBySid: {},
            channelSids: [],
            hasFetched: !1,
            error: null
          }
        }), Promise.all([this.fetchQueues(), this.fetchChannels()]).then(function (t) {
          var n = t[0],
            r = t[1],
            o = n.reduce(function (e, t) {
              return e[t.sid] = t, e;
            }, {}),
            i = n.map(function (e) {
              return e.sid;
            }),
            a = r.reduce(function (e, t) {
              return e[t.sid] = t, e;
            }, {}),
            l = r.map(function (e) {
              return e.sid;
            });
          e.dispatcher({
            type: s.UPDATE_METADATA,
            payload: {
              queuesBySid: o,
              queueSids: i,
              channelsBySid: a,
              channelSids: l,
              hasFetched: !0,
              error: null
            }
          });
        }).catch(function (t) {
          e.dispatcher({
            type: s.UPDATE_METADATA,
            payload: {
              queuesBySid: {},
              queueSids: [],
              channelsBySid: {},
              channelSids: [],
              hasFetched: !0,
              error: t
            }
          });
        });
      }, e.fetchQueues = function () {
        var e = o.getWorkspaceTaskQueuesUrl(i.FlexModule.state.config, i.FlexModule.workerClient.workspaceSid);
        return a.fetchTaskRouterResource(e);
      }, e.fetchChannels = function () {
        return a.fetchTaskRouterResource(o.getWorkspaceTaskChannelsUrl(i.FlexModule.state.config, i.FlexModule.workerClient.workspaceSid));
      }, e;
    }();
    t.Actions = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TokenStorage = t.LOCAL_STORAGE_KEY = void 0;
    var r = n(5);
    t.LOCAL_STORAGE_KEY = "TWILIO_FLEX_SSO", t.TokenStorage = {
      set: function set(e) {
        localStorage.setItem(t.LOCAL_STORAGE_KEY, JSON.stringify(e));
      },
      get: function get() {
        var e = localStorage.getItem(t.LOCAL_STORAGE_KEY);
        if (e) try {
          return JSON.parse(e);
        } catch (e) {
          return void r.log.debug("Can't parse the stringified version of the token. Check the \"" + t.LOCAL_STORAGE_KEY + '" key in the local storage and try again');
        }
        r.log.debug("TokenManager: there is no token in the storage");
      },
      clear: function clear() {
        localStorage.removeItem(t.LOCAL_STORAGE_KEY);
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskTransfer = void 0;
    var r = n(7),
      o = n(37),
      i = function () {
        function e(e) {
          e && (this.mode = e.mode, this.type = e.type, this.workerSid = e.workerSid, this.to = e.to, this.sid = e.sid, this.source = e);
        }
        return Object.defineProperty(e.prototype, "worker", {
          get: function get() {
            return o.InsightsEntityCache.getWorker(this.workerSid);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "status", {
          get: function get() {
            return this.source ? this.source.status : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "queue", {
          get: function get() {
            return o.InsightsEntityCache.getQueue(this.to);
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.cancel = function () {
          var e = this;
          return this.source.cancel ? this.source.cancel().catch(function (t) {
            return r.ErrorManager.createAndProcessError("Could not cancel transfer", {
              type: r.FlexErrorType.taskrouterSDK,
              description: "Could not cancel transfer " + e.sid + ": " + t.message,
              context: "CommonModel",
              wrappedError: t
            }), Promise.reject(t);
          }) : Promise.reject();
        }, e;
      }();
    t.TaskTransfer = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.filtersToQuery = void 0;
    t.filtersToQuery = function (e) {
      return e.reduce(function (e, t) {
        if ("string" == typeof t) return (e ? e + " AND " : "") + "(" + t + ")";
        var n = t.values;
        if (Array.isArray(n)) {
          if (0 === n.length) return e;
          n = '["' + n.join('", "') + '"]';
        } else "string" == typeof n && (n = '"' + n + '"');
        return (e ? e + " AND " : "") + "(" + t.name + " " + t.condition + " " + n + ")";
      }, "").trim();
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexReducer = void 0;
    var r = n(0),
      o = n(180),
      i = n(87),
      a = n(379),
      s = n(53),
      l = n(117),
      c = n(24),
      u = n(380),
      p = n(126),
      d = n(25),
      f = n(127),
      h = n(39),
      m = n(36),
      g = n(35),
      y = n(91),
      v = {};
    t.FlexReducer = function (e, t) {
      return void 0 === e && (e = v), {
        config: o.reduce(e.config, t),
        session: h.reduce(e.session, t),
        chat: r.chatReducer(e.chat, t),
        worker: y.reduce(e.worker, t),
        phone: p.reduce(e.phone, t),
        view: g.reduce(e.view, t),
        insights: c.reduce(e.insights, t),
        supervisor: m.reduce(e.supervisor, t),
        router: f.createReducer(e.config)(e.router, t),
        connectionStatus: a.reduce(e.connectionStatus, t),
        conferences: i.reduce(e.conferences, t),
        realtimeQueues: d.reduce(e.realtimeQueues, t),
        featureFlags: s.reduce(e.featureFlags, t),
        flexErrors: l.reduce(e.flexErrors, t),
        participants: u.reduce(e.participants, t)
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.applyFlexMiddleware = void 0;
    var r = n(88),
      o = n(383),
      i = n(384),
      a = n(93),
      s = n(44);
    t.applyFlexMiddleware = function (e, t) {
      var n;
      void 0 === t && (t = !1), s.isHistory(e) ? (n = e, s.setHistory(n)) : n = s.isHistoryParams(e) ? s.default(e) : s.isHistoryType(e) ? s.default({
        type: e
      }) : s.default();
      var l = [a.routerMiddleware(n), i.default()];
      return t && l.push(o.createLogger()), r.applyMiddleware.apply(void 0, l);
    };
  }, function (e, t, n) {
    "use strict";

    var _r24,
      o = this && this.__extends || (_r24 = function r(e, t) {
        return (_r24 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r24(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RedirectToFirstDashboard = t.firstDashboardSelector = void 0;
    var i = n(1),
      a = n(31),
      s = n(3),
      l = n(56),
      c = n(38),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this.props.dashboard && c.redirectToDashboard(this.props.dashboard.identifier);
        }, t.prototype.componentDidUpdate = function (e) {
          this.props.dashboard && !e.dashboard && c.redirectToDashboard(this.props.dashboard.identifier);
        }, t.prototype.render = function () {
          return null;
        }, t;
      }(i.Component);
    t.firstDashboardSelector = a.createSelector(l.projectDashboardsArraySelector, l.analyticalDashboardsArraySelector, function (e, t) {
      var n;
      return t[0] || (null === (n = e[0]) || void 0 === n ? void 0 : n.tabs[0]);
    }), t.RedirectToFirstDashboard = s.connect(function (e) {
      return {
        dashboard: t.firstDashboardSelector(e)
      };
    })(u);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ClientManagerHelpers = t.ClientManagerInstance = void 0;
    var i = n(7),
      a = n(3);
    !function (e) {
      e.FlexSDKClient = "FlexSDKClient", e.TaskRouterClient = "TaskRouterClient", e.ChatClient = "ChatClient", e.VoiceClient = "VoiceClient", e.InsightsClient = "InsightsClient", e.PluginManager = "PluginManager", e.FlexFeatures = "FlexFeatures";
    }(t.ClientManagerInstance || (t.ClientManagerInstance = {}));
    var s = function () {
      function e() {}
      return e.forceDegraded = function (e, t) {
        return void 0 === t && (t = !0), r(this, void 0, Promise, function () {
          var n;
          return o(this, function (r) {
            if (n = this.forcedClientsMap.has(e), !t && n) return window.location.reload(), [2];
            if (n || !t) return i.ErrorManager.createAndProcessError("Error. Cannot degrade Flex client twice. " + e + " already degraded.", {
              context: "ClientManagerHelpers",
              type: i.FlexErrorType.app
            }), [2];
            try {
              if (Boolean(a.FlexModule.stateCallback)) throw i.ErrorManager.createAndProcessError("Error. Cannot degrade Flex clients after Flex is already initialised.", {
                context: "ClientManagerHelpers",
                type: i.FlexErrorType.app
              });
              this.forcedClientsMap.add(e);
            } catch (e) {}
            return [2];
          });
        });
      }, e.isForcedDegraded = function (e) {
        return e ? this.forcedClientsMap.has(e) : this.forcedClientsMap.size > 0;
      }, e.forcedClientsMap = new Set(), e;
    }();
    t.ClientManagerHelpers = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Conference = void 0;
    var r = function () {
      function e(e) {
        this.participants = [], this.sid = e;
      }
      return Object.defineProperty(e.prototype, "liveParticipantCount", {
        get: function get() {
          return this.participants.filter(function (e) {
            return "joined" === e.status && "transfer" !== e.participantType;
          }).length;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "liveWorkerCount", {
        get: function get() {
          return this.liveWorkers.length;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "liveWorkers", {
        get: function get() {
          return this.participants.filter(function (e) {
            return "joined" === e.status && "worker" === e.participantType;
          });
        },
        enumerable: !1,
        configurable: !0
      }), e;
    }();
    t.Conference = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConferenceListenerManager = void 0;
    var r = n(5),
      o = n(23),
      i = n(8),
      a = n(37),
      s = n(191),
      l = function () {
        function e() {}
        return e.initialize = function (e) {
          var t = this;
          r.log.debug("ConferenceListenerManager initialize"), this.initialized = !0, this.conferenceWrappers = new Map(), this.conferenceListenerCallback = e, this.requestedSids.forEach(function (e, n) {
            t.startListening(o.StateHelper.getTaskByTaskrouterTaskSid(n), e);
          });
        }, e.startListening = function (e, t) {
          if (e && (r.log.debug("ConferenceListenerManager startListening " + e.taskSid + " " + t), i.TaskHelper.isCallTask(e))) if (this.initialized) {
            e.incomingTransferObject && a.InsightsEntityCache.refreshInfoForEntities([e.incomingTransferObject.workerSid, e.incomingTransferObject.to]), e.outgoingTransferObject && a.InsightsEntityCache.refreshInfoForEntities([e.outgoingTransferObject.workerSid, e.outgoingTransferObject.to]);
            var n = this.conferenceWrappers.get(e.taskSid);
            if (n) -1 === n.consumers.indexOf(t) && (r.log.debug("ConferenceListenerManager new Consumer to listener"), n.consumers.push(t));else {
              r.log.debug("ConferenceListenerManager new Listener");
              var o = new s.ConferenceListener(e.taskSid, this.conferenceListenerCallback);
              this.conferenceWrappers.set(e.taskSid, {
                listener: o,
                consumers: [t]
              });
            }
          } else this.requestedSids.set(e.taskSid, t);
        }, e.stopListening = function (e, t) {
          r.log.debug("ConferenceListenerManager stopListening " + e + " " + t);
          var n = this.conferenceWrappers.get(e);
          if (n) {
            var o = n.consumers.indexOf(t);
            o > -1 && n.consumers.splice(o, 1), 0 === n.consumers.length && (n.listener.stop(), this.conferenceWrappers.delete(e));
          }
        }, e.initOutboundTransfer = function (e) {
          var t = e.taskSid,
            n = e.to;
          r.log.debug("ConferenceListenerManager initOutboundTransfer " + t + " " + n);
          var o = this.conferenceWrappers.get(t);
          o && o.listener.initOutboundTransfer(e);
        }, e.unInitOutboundTransferForTask = function (e) {
          r.log.debug("ConferenceListenerManager unInitOutboundTransfer " + e);
          var t = this.conferenceWrappers.get(e);
          t && t.listener.unInitOutboundTransfer();
        }, e.requestedSids = new Map(), e.initialized = !1, e;
      }();
    t.ConferenceListenerManager = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConferenceListener = void 0;
    var i = n(390),
      a = n(7),
      s = n(3),
      l = n(5),
      c = n(173),
      u = function () {
        function e(e, t) {
          var n = this;
          this.stateUpdateTimers = [], this.updateOutboundTransfer = function (e) {
            if (n.outboundTransfer) {
              switch (e.status) {
                case "complete":
                case "canceled":
                  n.stopOutgoingTransferListeners(), n.outboundTransfer = void 0;
                  break;
                case "failed":
                  n.failedTransferRemoveTimer = window.setTimeout(function () {
                    n.updateOutboundTransfer({
                      status: "complete"
                    }), n.failedTransferRemoveTimer = 0;
                  }, 5e3), n.outboundTransfer.status = "recently_left";
              }
              n.emitCallback();
            }
          }, this.itemAdded = function (e) {
            l.log.debug("ConferenceListener itemAdded " + n.children.length), n.children.push(e.item), n.emitCallback();
          }, this.itemUpdated = function (e) {
            l.log.debug("ConferenceListener itemUpdated " + n.children.length), n.emitCallback();
          }, this.itemRemoved = function (e) {
            l.log.debug("ConferenceListener itemRemoved " + n.children.length), n.children.splice(n.children.indexOf(e.item), 1), n.emitCallback();
          }, this.lifeCycle = c.ConferenceListenerState.initializing, this.sid = e, this.updateCallback = t, this.initialize(e);
        }
        return e.prototype.triggerDelayedStateUpdate = function (e) {
          var t = this;
          this.stateUpdateTimers.push(window.setTimeout(function () {
            t.emitCallback();
          }, e));
        }, e.prototype.stop = function () {
          l.log.debug("ConferenceListener stop " + this.sid), this.lifeCycle === c.ConferenceListenerState.initialized ? (this.map.removeListener("itemAdded", this.itemAdded), this.map.removeListener("itemUpdated", this.itemUpdated), this.map.removeListener("itemRemoved", this.itemRemoved), this.map.close(), this.failedTransferRemoveTimer && window.clearTimeout(this.failedTransferRemoveTimer), this.stateUpdateTimers.forEach(function (e) {
            return window.clearTimeout(e);
          })) : (this.lifeCycle = c.ConferenceListenerState.destroying, l.log.debug("ConferenceListener canceling initialization"));
        }, e.prototype.initOutgoingTransferListeners = function () {
          this.outboundTransfer.source.addListener("attemptFailed", this.updateOutboundTransfer), this.outboundTransfer.source.addListener("completed", this.updateOutboundTransfer), this.outboundTransfer.source.addListener("failed", this.updateOutboundTransfer), this.outboundTransfer.source.addListener("canceled", this.updateOutboundTransfer);
        }, e.prototype.stopOutgoingTransferListeners = function () {
          this.outboundTransfer.source.removeListener("attemptFailed", this.updateOutboundTransfer), this.outboundTransfer.source.removeListener("completed", this.updateOutboundTransfer), this.outboundTransfer.source.removeListener("failed", this.updateOutboundTransfer), this.outboundTransfer.source.removeListener("canceled", this.updateOutboundTransfer);
        }, e.prototype.initOutboundTransfer = function (e) {
          this.outboundTransfer = {
            sid: e.to,
            status: "joined",
            source: e
          }, this.initOutgoingTransferListeners(), this.emitCallback();
        }, e.prototype.unInitOutboundTransfer = function () {
          this.updateOutboundTransfer({
            status: "complete"
          }), this.failedTransferRemoveTimer = 0;
        }, e.prototype.initialize = function (t) {
          return r(this, void 0, void 0, function () {
            var n, r;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return l.log.debug("ConferenceListener initialize " + t + " started. " + e.mapQuerySemaphore.nrWaiting() + " waiting on lock"), [4, e.mapQuerySemaphore.acquire()];
                case 1:
                  o.sent(), l.log.debug("Lock aquired for " + t + "."), o.label = 2;
                case 2:
                  return o.trys.push([2,, 5, 6]), n = this, [4, s.FlexModule.insightsClient.map({
                    id: t + ".CS",
                    mode: "open_existing"
                  }).catch(function (e) {
                    throw a.ErrorManager.createAndProcessError("Failed to create Sync Map", {
                      type: a.FlexErrorType.syncSDK,
                      description: "Failed to create Sync Map for sid: " + t,
                      context: "ConferenceListener",
                      wrappedError: e
                    });
                  })];
                case 3:
                  return n.map = o.sent(), [4, this.map.getItems()];
                case 4:
                  return r = o.sent(), this.children = r.items, this.map.on("itemAdded", this.itemAdded), this.map.on("itemUpdated", this.itemUpdated), this.map.on("itemRemoved", this.itemRemoved), [3, 6];
                case 5:
                  return e.mapQuerySemaphore.release(), l.log.debug("Lock released for " + t + "."), [7];
                case 6:
                  return this.lifeCycle === c.ConferenceListenerState.destroying ? (l.log.debug("ConferenceListener initialize " + t + " canceled"), this.lifeCycle = c.ConferenceListenerState.initialized, this.stop(), [2]) : (this.lifeCycle = c.ConferenceListenerState.initialized, l.log.debug("ConferenceListener initialize " + t + " finished"), this.emitCallback(), [2]);
              }
            });
          });
        }, e.prototype.emitCallback = function () {
          this.updateCallback && this.updateCallback(this);
        }, e.mapQuerySemaphore = new i.Sema(20), e;
      }();
    t.ConferenceListener = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SupervisorWorkersListener = t.maxWorkersNumberFromInitialLoad = void 0;
    var o = n(122),
      i = n(5),
      a = n(73),
      s = n(391);
    t.maxWorkersNumberFromInitialLoad = 200;
    var l = function () {
      function e(e) {
        var t = this;
        this.workerListeners = [], this.onWorkerTasksChanged = function () {
          t.updateCurrentWorkers();
        }, this.insightsClient = e;
      }
      return e.create = function (t, n) {
        return e.Actions = n, new e(t);
      }, e.prototype.getActiveFilterQuery = function () {
        return this.activeFilterQuery;
      }, e.prototype.setActiveFilterQuery = function (e, t) {
        return void 0 === e && (e = ""), void 0 === t && (t = ""), this.activeFilterQuery !== e || this.taskFilter !== t ? (this.taskFilter = t, this.activeFilterQuery = e, this.subscribeWorkersLiveQuery(e, t)) : Promise.resolve();
      }, e.prototype.setStickyWorkerSid = function (t, n) {
        t === this.stickyWorkerSid && n === this.stickyTaskSid || (this.stickyWorkerSid = t, this.stickyTaskSid = n, t ? this.initStickyWorker() : (e.Actions.updateStateStickyWorker(null), this.unInitStickyWorker()));
      }, e.prototype.unsubscribe = function () {
        this.unsubscribeWorkersLiveQuery(), this.unInitStickyWorker();
      }, e.prototype.subscribeWorkersLiveQuery = function (t, n) {
        var r = this;
        return this.unsubscribeWorkersLiveQuery(), e.Actions.startLoadingWorkers(), this.insightsClient.liveQuery("tr-worker", t).then(function (e) {
          r.activeFilterQuery === t && r.taskFilter === n ? (r.workersLiveQuery = e, r.loadInitialWorkers(e.getItems(), n), e.on("itemUpdated", function (e) {
            r.onWorkerItemUpdated(e, n);
          }), e.on("itemRemoved", function (e) {
            r.onWorkerItemRemoved(e);
          })) : e.close();
        }).catch(function (e) {
          if (r.activeFilterQuery === t && r.taskFilter === n) throw e;
          i.log.warn(e);
        });
      }, e.prototype.unsubscribeWorkersLiveQuery = function () {
        this.workersLiveQuery && (this.workersLiveQuery.removeAllListeners(), this.workersLiveQuery.close(), this.workersLiveQuery = void 0);
      }, e.prototype.updateCurrentWorkers = function () {
        var t = this.workerListeners.map(function (e) {
          return e.state;
        });
        e.Actions.updateStateWorkers(t);
      }, e.prototype.loadInitialWorkers = function (e, t) {
        var n = this,
          r = Object.keys(e).map(function (t) {
            return new a.InsightsWorker(e[t]);
          });
        this.workerListeners = this.workerListeners.reduce(function (e, t) {
          var n = r.findIndex(function (e) {
            return e.sid === t.state.worker.sid;
          });
          return n >= 0 ? (t.updateWorker(r[n]), r.splice(n, 1), e.push(t)) : t.unInit(), e;
        }, []), r.forEach(function (e) {
          var r = new s.WorkerListener(e, n.insightsClient, n.onWorkerTasksChanged, t);
          n.workerListeners.push(r);
        }), this.updateCurrentWorkers();
      }, e.prototype.onWorkerItemUpdated = function (e, n) {
        var r = new a.InsightsWorker(e.value),
          o = this.workerListeners.findIndex(function (e) {
            return e.state.worker.sid === r.sid;
          });
        if (o >= 0) this.workerListeners[o].updateWorker(r);else {
          if (!(this.workerListeners.length < t.maxWorkersNumberFromInitialLoad)) return;
          var i = new s.WorkerListener(r, this.insightsClient, this.onWorkerTasksChanged, n);
          this.workerListeners.push(i);
        }
        this.stickyWorker && r.sid === this.stickyWorker.state.worker.sid && (this.stickyWorker.state.worker = r), this.updateCurrentWorkers();
      }, e.prototype.onWorkerItemRemoved = function (e) {
        var t = this.workerListeners.findIndex(function (t) {
          return t.state.worker.sid === e.key;
        });
        t < 0 || (this.workerListeners[t].unInit(), this.workerListeners.splice(t, 1), this.updateCurrentWorkers());
      }, e.prototype.initStickyWorker = function () {
        var e = this;
        this.unInitStickyWorker();
        var t = o.v4();
        this.lastStickyWorkerQueryUUID = t, this.insightsClient.liveQuery("tr-worker", 'data.worker_sid == "' + this.stickyWorkerSid + '"').then(function (n) {
          e.lastStickyWorkerQueryUUID === t ? (e.stickyWorkerLiveQuery = n, e.loadInitialStickyWorker(n.getItems()), n.on("itemUpdated", function (t) {
            e.onStickyWorkerUpdate(t);
          }), n.on("itemRemoved", function () {
            e.onStickyWorkerRemoved();
          })) : n.close();
        });
      }, e.prototype.unInitStickyWorker = function () {
        this.lastStickyWorkerQueryUUID = "", this.stickyWorkerLiveQuery && (this.stickyWorkerLiveQuery.removeAllListeners(), this.stickyWorkerLiveQuery.close()), this.stickyWorker && (this.stickyWorker.unInit(), this.stickyWorker = null);
      }, e.prototype.loadInitialStickyWorker = function (t) {
        var n = this,
          r = Object.keys(t)[0];
        if (!r && this.stickyWorker && (this.stickyWorker.unInit(), this.stickyWorker = null), r) {
          var o = new a.InsightsWorker(t[r]),
            i = this.taskFilter;
          this.stickyTaskSid && (i = i ? this.taskFilter + ' OR data.reservation_sid=="' + this.stickyTaskSid + '"' : 'data.reservation_sid=="' + this.stickyTaskSid + '"'), this.stickyWorker = o && new s.WorkerListener(o, this.insightsClient, function () {
            return n.stickyWorker && e.Actions.updateStateStickyWorker(n.stickyWorker.state);
          }, i);
        }
        e.Actions.updateStateStickyWorker(this.stickyWorker ? this.stickyWorker.state : null);
      }, e.prototype.onStickyWorkerUpdate = function (t) {
        var n = new a.InsightsWorker(t.value);
        e.Actions.updateStateStickyWorker(r(r({}, this.stickyWorker.state), {
          worker: n
        }));
      }, e.prototype.onStickyWorkerRemoved = function () {
        this.stickyWorker && this.stickyWorker.unInit(), this.stickyWorker = null, e.Actions.updateStateStickyWorker(null);
      }, e;
    }();
    t.SupervisorWorkersListener = l;
  }, function (e, t, n) {
    "use strict";

    var _r25,
      o = this && this.__extends || (_r25 = function r(e, t) {
        return (_r25 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r25(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      s = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskDetailsPanel = void 0;
    var l = n(1),
      c = n(0),
      u = n(75),
      p = n(8),
      d = n(3),
      f = n(2),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.refreshTimer = void 0, t.renderContainer = function () {
            var e = t.props,
              n = e.IconComponent,
              r = (e.ActionsComponent, e.titleLine),
              o = e.firstLine,
              a = e.subjectLine,
              f = e.secondLine,
              h = e.task,
              m = (e.conference, e.contentComponent),
              g = s(e, ["IconComponent", "ActionsComponent", "titleLine", "firstLine", "subjectLine", "secondLine", "task", "conference", "contentComponent"]);
            if (m) return m;
            var y = new p.TaskHelper(h),
              v = d.FlexModule.state.supervisor.workers.find(function (e) {
                return e.worker.sid === t.props.task.workerSid;
              });
            !v && d.FlexModule.state.supervisor.stickyWorker && t.props.task.workerSid === d.FlexModule.state.supervisor.stickyWorker.worker.sid && (v = d.FlexModule.state.supervisor.stickyWorker);
            var b = !!v && v.worker;
            return l.createElement(u.InfoContainer, {
              key: "info-container",
              className: "Twilio-TaskDetailsPanel-Info"
            }, !!r && l.createElement(u.TitleLineContainer, {
              className: "Twilio-TaskDetailsPanel-TitleLine"
            }, l.createElement(c.Template, {
              code: r,
              task: h,
              helper: y,
              worker: b
            })), !!n && l.createElement(u.IconContainer, {
              className: "Twilio-TaskDetailsPanel-Icon"
            }, l.createElement(n, i({
              task: h
            }, g))), !!o && l.createElement(u.FirstLineContainer, {
              className: "Twilio-TaskDetailsPanel-FirstLine"
            }, l.createElement(c.Template, {
              code: o,
              task: h,
              helper: y,
              worker: b
            })), !!a && l.createElement(u.FirstLineContainer, {
              className: "Twilio-TaskDetailsPanel-FirstLine"
            }, l.createElement(c.Template, {
              code: a,
              task: h,
              helper: y,
              worker: b
            })), !!f && l.createElement(u.SecondLineContainer, {
              className: "Twilio-TaskDetailsPanel-SecondLine"
            }, l.createElement(c.Template, {
              code: f,
              task: h,
              helper: y,
              worker: b
            })));
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          var e = this;
          this.refreshTimer = window.setInterval(function () {
            return e.forceUpdate();
          }, 1e3);
        }, t.prototype.componentWillUnmount = function () {
          void 0 !== this.refreshTimer && window.clearInterval(this.refreshTimer);
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.content,
            n = e.ActionsComponent,
            r = e.compact,
            o = s(e, ["content", "ActionsComponent", "compact"]);
          return l.createElement(c.DynamicComponent, {
            contentStore: t,
            childProps: this.props,
            name: t.name,
            customChildren: this.props.children,
            vertical: !0
          }, l.createElement(u.Container, {
            className: "Twilio-TaskDetailsPanel-Container"
          }, l.createElement(u.ContentContainer, {
            className: "Twilio-TaskDetailsPanel-Content",
            key: "container"
          }, this.renderContainer()), l.createElement(u.ButtonContainer, {
            compact: r,
            className: "Twilio-TaskDetailsPanel-Buttons",
            key: "button-container"
          }, !!n && l.createElement(n, i({}, o)))));
        }, t = a([f.withTheme], t);
      }(l.PureComponent);
    t.TaskDetailsPanel = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ParticipantsCanvasProps = t.ParticipantsCanvas = void 0;
    var r = n(195);
    Object.defineProperty(t, "ParticipantsCanvas", {
      enumerable: !0,
      get: function get() {
        return r.ParticipantsCanvas;
      }
    });
    var o = n(403);
    Object.defineProperty(t, "ParticipantsCanvasProps", {
      enumerable: !0,
      get: function get() {
        return o.ParticipantsCanvasProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r26,
      o = this && this.__extends || (_r26 = function r(e, t) {
        return (_r26 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r26(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.ParticipantsCanvas = void 0;
    var a = n(1),
      s = n(88),
      l = n(3),
      c = n(396),
      u = n(26),
      p = n(2),
      d = n(397),
      f = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.displayName = d.displayName, n.Content = d.contentStore, n;
      }(a.PureComponent);
    t.ParticipantsCanvas = f, t.Connected = s.compose(p.withTheme, u.withTaskContext, l.connect(function (e) {
      return {
        external: c.canvasParticipants(e.participants),
        participantsByCallSid: e.participants.byCallSid
      };
    }))(d.ParticipantsCanvasImpl);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ParticipantCanvas = void 0;
    var r = n(398);
    Object.defineProperty(t, "ParticipantCanvas", {
      enumerable: !0,
      get: function get() {
        return r.ParticipantCanvas;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasHeader = t.TaskInfoPanel = t.TaskCanvasTabs = t.TaskCanvasThemeProps = t.TaskCanvasChildrenProps = t.TaskCanvas = void 0;
    var r = n(198);
    Object.defineProperty(t, "TaskCanvas", {
      enumerable: !0,
      get: function get() {
        return r.TaskCanvas;
      }
    }), Object.defineProperty(t, "TaskCanvasChildrenProps", {
      enumerable: !0,
      get: function get() {
        return r.TaskCanvasChildrenProps;
      }
    }), Object.defineProperty(t, "TaskCanvasThemeProps", {
      enumerable: !0,
      get: function get() {
        return r.TaskCanvasThemeProps;
      }
    });
    var o = n(131);
    Object.defineProperty(t, "TaskCanvasTabs", {
      enumerable: !0,
      get: function get() {
        return o.TaskCanvasTabs;
      }
    });
    var i = n(209);
    Object.defineProperty(t, "TaskInfoPanel", {
      enumerable: !0,
      get: function get() {
        return i.TaskInfoPanel;
      }
    });
    var a = n(135);
    Object.defineProperty(t, "TaskCanvasHeader", {
      enumerable: !0,
      get: function get() {
        return a.TaskCanvasHeader;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r27,
      o = this && this.__extends || (_r27 = function r(e, t) {
        return (_r27 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r27(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.TaskCanvas = void 0;
    var a = n(1),
      s = n(15),
      l = n(131),
      c = n(135),
      u = n(439),
      p = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.displayName = u.displayName, n.Content = u.contentStore, n.Header = c.TaskCanvasHeader, n.Tabs = l.TaskCanvasTabs, n;
      }(a.PureComponent);
    t.TaskCanvas = p, t.Connected = s.withTaskContext(u.TaskCanvasImpl);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getThemeForChat = t.TaskCanvasTabsChildrenProps = t.TaskCanvasTabs = void 0;
    var r = n(99);
    Object.defineProperty(t, "TaskCanvasTabs", {
      enumerable: !0,
      get: function get() {
        return r.TaskCanvasTabs;
      }
    });
    var o = n(433);
    Object.defineProperty(t, "TaskCanvasTabsChildrenProps", {
      enumerable: !0,
      get: function get() {
        return o.TaskCanvasTabsChildrenProps;
      }
    });
    var i = n(200);
    Object.defineProperty(t, "getThemeForChat", {
      enumerable: !0,
      get: function get() {
        return i.getThemeForChat;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r28,
      o = this && this.__extends || (_r28 = function r(e, t) {
        return (_r28 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r28(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getThemeForChat = t.TaskCanvasTabsImpl = t.contentStore = t.displayName = void 0;
    var i = n(1),
      a = n(20),
      s = n(8),
      l = n(0),
      c = n(4),
      u = n(201),
      p = n(205),
      d = n(133),
      f = n(41),
      h = n(99),
      m = n(6),
      g = n(134),
      y = n(23),
      v = n(432),
      b = n(11),
      C = n(10);
    t.displayName = "TaskCanvasTabs", t.contentStore = new l.DynamicContentStore(t.displayName);
    var _ = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleTabSelection = function (e) {
          m.tryInvokeAction("SetComponentState", {
            name: "AgentTaskCanvasTabs",
            state: {
              selectedTabName: e
            }
          });
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = e.task,
          r = e.selectedTabName,
          o = a.TaskChannels.getForTask(n),
          f = s.TaskHelper.isPending(n),
          m = s.TaskHelper.isInitialOutboundAttemptTask(n),
          y = o.templates.TaskCanvasTabs && o.templates.TaskCanvasTabs.contentTabHeader || "";
        return i.createElement(l.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          vertical: !0
        }, i.createElement(l.Tabs, {
          className: "Twilio-TaskCanvasTabs",
          selectedTabName: r,
          onTabSelected: this.handleTabSelection
        }, i.createElement(l.Tab, {
          key: "outbound",
          uniqueName: "outbound",
          label: i.createElement(l.Template, {
            code: a.TaskChannelHelper.getTemplateForStatus(n, y, h.TaskCanvasTabs)
          }),
          hidden: !f || !m
        }, i.createElement(g.ConnectingOutboundCallCanvas, null)), i.createElement(l.Tab, {
          key: "incoming",
          uniqueName: "incoming",
          label: i.createElement(l.Template, {
            source: c.templates.TaskTabAgentIncomingLabel
          }),
          hidden: !f || m
        }, i.createElement(u.IncomingTaskCanvas, null)), i.createElement(l.Tab, {
          key: "call",
          uniqueName: "call",
          label: i.createElement(l.Template, {
            code: a.TaskChannelHelper.getTemplateForStatus(n, y, h.TaskCanvasTabs)
          }),
          hidden: !s.TaskHelper.isCallTask(n) || f
        }, i.createElement(p.CallCanvas, null)), i.createElement(l.Tab, {
          key: "chat",
          uniqueName: "chat",
          label: i.createElement(l.Template, {
            code: a.TaskChannelHelper.getTemplateForStatus(n, y, h.TaskCanvasTabs)
          }),
          hidden: !s.TaskHelper.isChatBasedTask(n) || f
        }, !!this.props.task && this.renderChat(a.TaskChannelHelper.getColor(n, o.colors.main, h.TaskCanvasTabs))), i.createElement(l.Tab, {
          key: "info",
          uniqueName: "info",
          label: i.createElement(l.Template, {
            source: c.templates.TaskTabAgentInfoLabel
          })
        }, i.createElement(d.TaskInfoPanel, null))));
      }, n.prototype.renderChat = function (e) {
        var t = this.props.task,
          n = this.props,
          r = n.channelDefinition,
          o = r.charLimit,
          a = r.componentProps,
          u = n.hasMarkdownSupport,
          p = k(e),
          d = y.StateHelper.getChatChannelStateForTask(t);
        return "accepted" !== t.status || d && d.source ? i.createElement(f.ThemeProvider, {
          theme: p
        }, i.createElement(l.MessagingCanvas, {
          sid: s.TaskHelper.getTaskChatChannelSid(t),
          charLimit: o,
          inputDisabledReason: s.TaskHelper.isCompleted(t) || s.TaskHelper.isInWrapupMode(t) ? c.templates.ChatInputDisabledText() : void 0,
          welcomeMessageText: c.templates.ChatWelcomeText,
          predefinedMessage: a.MessagingCanvas && a.MessagingCanvas.predefinedMessage,
          messageStyle: b.FeatureFlags.isEnabled(C.FeatureFlag.EmailPOC) && "email" === t.attributes.channelType ? "Wide" : void 0,
          hasMarkdownSupport: u,
          welcomeMessageIcon: b.FeatureFlags.isEnabled(C.FeatureFlag.EmailPOC) && "email" === t.attributes.channelType && "EmailBold"
        })) : i.createElement(v.CenterContentContainer, null, i.createElement(l.CircularProgress, {
          size: 80,
          borderWidth: 2,
          animating: !0
        }), i.createElement(v.JoiningLabel, {
          source: c.templates.LoadingChatCanvas
        }));
      }, n;
    }(i.PureComponent);
    function k(e) {
      return function (t) {
        return e ? l.Utils.merge(t, {
          Chat: {
            MessageInput: {
              Button: {
                background: e
              }
            },
            MessageListItem: {
              FromMe: {
                Bubble: {
                  background: e
                }
              }
            },
            WelcomeMessage: {
              Icon: {
                color: e
              }
            }
          }
        }) : t;
      };
    }
    t.TaskCanvasTabsImpl = _, t.getThemeForChat = k;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IncomingTaskCanvasActions = t.IncomingTaskIcon = t.IncomingTaskCanvasProps = t.IncomingTaskCanvas = void 0;
    var r = n(202);
    Object.defineProperty(t, "IncomingTaskCanvas", {
      enumerable: !0,
      get: function get() {
        return r.IncomingTaskCanvas;
      }
    });
    var o = n(409);
    Object.defineProperty(t, "IncomingTaskCanvasProps", {
      enumerable: !0,
      get: function get() {
        return o.IncomingTaskCanvasProps;
      }
    });
    var i = n(204);
    Object.defineProperty(t, "IncomingTaskIcon", {
      enumerable: !0,
      get: function get() {
        return i.IncomingTaskIcon;
      }
    });
    var a = n(203);
    Object.defineProperty(t, "IncomingTaskCanvasActions", {
      enumerable: !0,
      get: function get() {
        return a.IncomingTaskCanvasActions;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r29,
      o = this && this.__extends || (_r29 = function r(e, t) {
        return (_r29 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r29(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.IncomingTaskCanvas = void 0;
    var a = n(1),
      s = n(15),
      l = n(406),
      c = n(2),
      u = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.friendlyName = l.displayName, n.displayName = l.displayName, n.Content = l.contentStore, n;
      }(a.PureComponent);
    t.IncomingTaskCanvas = u, t.Connected = c.withTheme(s.withTaskContext(l.IncomingTaskCanvasImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IncomingTaskCanvasActions = void 0;
    var r = n(407);
    Object.defineProperty(t, "IncomingTaskCanvasActions", {
      enumerable: !0,
      get: function get() {
        return r.IncomingTaskCanvasActions;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IncomingTaskIcon = void 0;
    var r = n(408);
    Object.defineProperty(t, "IncomingTaskIcon", {
      enumerable: !0,
      get: function get() {
        return r.IncomingTaskIcon;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallCanvasChildrenProps = t.CallCanvas = void 0;
    var i = n(206);
    Object.defineProperty(t, "CallCanvas", {
      enumerable: !0,
      get: function get() {
        return i.CallCanvas;
      }
    });
    var a = n(424);
    Object.defineProperty(t, "CallCanvasChildrenProps", {
      enumerable: !0,
      get: function get() {
        return a.CallCanvasChildrenProps;
      }
    }), o(n(207), t);
  }, function (e, t, n) {
    "use strict";

    var _r30,
      o = this && this.__extends || (_r30 = function r(e, t) {
        return (_r30 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r30(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.CallCanvas = void 0;
    var a = n(1),
      s = n(26),
      l = n(410),
      c = n(2),
      u = n(3),
      p = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.friendlyName = l.displayName, n.displayName = l.displayName, n.Content = l.contentStore, n;
      }(a.PureComponent);
    t.CallCanvas = p, t.Connected = s.withTaskContext(u.connect(function (e, t) {
      return {
        dialpadState: e.view.componentViewStates["CallCanvasDialpad" + t.task.sid]
      };
    })(c.withTheme(l.CallCanvasImpl)));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallCanvasActions = void 0;
    var r = n(411);
    Object.defineProperty(t, "CallCanvasActions", {
      enumerable: !0,
      get: function get() {
        return r.CallCanvasActions;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingOutboundCallCanvasActions = void 0;
    var r = n(429);
    Object.defineProperty(t, "ConnectingOutboundCallCanvasActions", {
      enumerable: !0,
      get: function get() {
        return r.ConnectingOutboundCallCanvasActions;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskInfoPanel = void 0;
    var r = n(434);
    Object.defineProperty(t, "TaskInfoPanel", {
      enumerable: !0,
      get: function get() {
        return r.TaskInfoPanel;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskInfoPanelProps = t.TaskInfoPanel = void 0;
    var r = n(133);
    Object.defineProperty(t, "TaskInfoPanel", {
      enumerable: !0,
      get: function get() {
        return r.TaskInfoPanel;
      }
    });
    var o = n(435);
    Object.defineProperty(t, "TaskInfoPanelProps", {
      enumerable: !0,
      get: function get() {
        return o.TaskInfoPanelProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FilterData = t.TeamFiltersPanelProps = t.TeamFiltersPanel = void 0;
    var r = n(440);
    Object.defineProperty(t, "TeamFiltersPanel", {
      enumerable: !0,
      get: function get() {
        return r.TeamFiltersPanel;
      }
    }), Object.defineProperty(t, "TeamFiltersPanelProps", {
      enumerable: !0,
      get: function get() {
        return r.TeamFiltersPanelProps;
      }
    }), Object.defineProperty(t, "FilterData", {
      enumerable: !0,
      get: function get() {
        return r.FilterData;
      }
    });
  }, function (e, t) {
    e.exports = require("react-router-dom");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getTaskWaitingAgeFromTimestamp = t.getIconNameForChannel = void 0;
    t.getIconNameForChannel = function (e) {
      return e ? e.match(/phone|voice|call/i) ? "Call" : e.match(/mail/i) ? "Email" : e.match(/sms/i) ? "SmsAlt" : e.match(/chat|messaging|messenger/i) ? "Messaging" : e.match(/video/i) ? "Video" : "Channel" : "Channel";
    }, t.getTaskWaitingAgeFromTimestamp = function (e) {
      return e ? Date.now() - new Date(e).getTime() : 0;
    };
  }, function (e, t, n) {
    "use strict";

    var _r31,
      o = this && this.__extends || (_r31 = function r(e, t) {
        return (_r31 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r31(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Ticker = void 0;
    var i = n(1),
      a = n(138),
      s = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.tick = function () {
            t.forceUpdate();
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          a.addTickListener(this.tick);
        }, t.prototype.componentWillUnmount = function () {
          a.removeTickListener(this.tick);
        }, t.prototype.render = function () {
          return this.props.children();
        }, t;
      }(i.Component);
    t.Ticker = s;
  }, function (e, t, n) {
    "use strict";

    var _r32,
      o = this && this.__extends || (_r32 = function r(e, t) {
        return (_r32 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r32(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesDataTableCell = t.QueuesDataTableCellContext = void 0;
    var a = n(1),
      s = n(2),
      l = n(137);
    t.QueuesDataTableCellContext = a.createContext({
      hideChannels: {},
      toggleChannels: function toggleChannels() {}
    });
    var c = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this;
        return a.createElement(t.QueuesDataTableCellContext.Consumer, null, function (t) {
          var n = t.hideChannels,
            r = t.toggleChannels,
            o = e.props.queue,
            i = o.channels,
            s = o.key,
            c = !n[s],
            u = "function" == typeof e.props.renderChannelData && c && i && i.length > 1;
          return a.createElement(l.QueuesDataTableCellComponent, null, a.createElement("li", {
            key: s,
            "data-queue-name": e.props.queue.friendly_name
          }, e.props.renderQueueData(e.props.queue, function () {
            return r(s);
          }, c)), u && i.map(function (t, n) {
            return a.createElement("li", {
              key: t.sid || n,
              "data-channel-name": t.friendly_name,
              "data-queue-name": e.props.queue.friendly_name
            }, e.props.renderChannelData(t, e.props.queue, function () {
              return r(s);
            }));
          }));
        });
      }, n = i([s.withTheme], n);
    }(a.PureComponent);
    t.QueuesDataTableCell = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesStatsSubscriptionService = t.DEFAULT_QUEUES_STATS_CONFIG = void 0;
    var a = n(32),
      s = n(13),
      l = n(9),
      c = n(7),
      u = n(3),
      p = n(5),
      d = n(181),
      f = n(89),
      h = n(460);
    t.DEFAULT_QUEUES_STATS_CONFIG = {
      tasksNowKey: "tasks_now",
      tasks30minKey: "tasks_thirty_minutes",
      tasksTodayKey: "tasks_today",
      workerActivitiesStatsKey: "worker_activities_statistics",
      workspaceStatsMapName: "realtime_statistics_v1",
      workspaceStatsKey: "workspace",
      queueMapNameSuffix: "realtime_statistics.v1"
    };
    var m = function () {
      function e() {
        this.channelMetadata = {}, this.isInitialized = !1, this.syncClient = u.FlexModule.insightsClient, this.config = r(r({}, t.DEFAULT_QUEUES_STATS_CONFIG), l.getQueuesStatsConfig(s.Manager.getInstance().configuration));
      }
      return Object.defineProperty(e, "filter", {
        get: function get() {
          return this._filter;
        },
        set: function set(e) {
          this._filter = e, this.instance && this.instance.isInitialized && (this.close(), this.init());
        },
        enumerable: !1,
        configurable: !0
      }), e.getInstance = function () {
        return e.instance || (e.instance = new e()), e.instance;
      }, e.init = function () {
        u.FlexModule.insightsClient && !a.FlexClientManager.isDegraded(u.FlexModule.insightsClient) && this.getInstance().init().catch(function (e) {
          p.log.error(e), u.FlexModule.dispatch({
            type: f.QUEUES_ERROR,
            payload: e
          });
        });
      }, e.close = function () {
        this.getInstance().close();
      }, e.prototype.findQueueByMap = function (e) {
        var t,
          n = e.uniqueName.split(".")[0];
        return null === (t = this.queues) || void 0 === t ? void 0 : t.find(function (e) {
          return n && e.sid === n;
        });
      }, e.prototype.init = function () {
        return o(this, void 0, void 0, function () {
          var e,
            t,
            n = this;
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return this.isInitialized ? [2] : (e = this, [4, d.Actions.fetchQueues()]);
              case 1:
                return e.queues = r.sent(), [4, Promise.all([this.subscribeMaps(), this.initializeChannelMetadata()])];
              case 2:
                return t = r.sent(), this.maps = t[0], this.channelMetadata = t[1], this.maps.forEach(function (e) {
                  return o(n, void 0, void 0, function () {
                    var t,
                      n,
                      r,
                      _o2,
                      a = this;
                    return i(this, function (i) {
                      switch (i.label) {
                        case 0:
                          return (null == (t = this.findQueueByMap(e)) ? void 0 : t.sid) ? (n = new h.QueuesStatsMediator(null == t ? void 0 : t.sid, (null == t ? void 0 : t.friendly_name) || "Unknown", function () {
                            return a.channelMetadata;
                          }, {
                            workerActivitiesStatsKey: this.config.workerActivitiesStatsKey,
                            tasksNowKey: this.config.tasksNowKey,
                            tasks30minKey: this.config.tasks30minKey,
                            tasksTodayKey: this.config.tasksTodayKey
                          }), [4, e.getItems()]) : [3, 2];
                        case 1:
                          r = i.sent(), (_o2 = function o(e) {
                            return e.items.forEach(function (e) {
                              n.notify(e.key, e.value);
                            }), e.hasNextPage ? e.nextPage().then(_o2) : null;
                          })(r), e.on("itemAdded", function (e) {
                            return a.handleItemUpdated(n, e);
                          }), e.on("itemUpdated", function (e) {
                            return a.handleItemUpdated(n, e);
                          }), i.label = 2;
                        case 2:
                          return [2];
                      }
                    });
                  });
                }), [4, this.initializeWorkspaceStats()];
              case 3:
                return r.sent(), this.isInitialized = !0, [2];
            }
          });
        });
      }, e.prototype.close = function () {
        this.maps && this.maps.length && this.maps.forEach(function (e) {
          return e.close();
        }), this.workspaceStatsMap && this.workspaceStatsMap.close(), this.isInitialized = !1;
      }, e.prototype.initializeWorkspaceStats = function () {
        return o(this, void 0, void 0, function () {
          var e,
            t,
            n,
            r,
            o = this;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return i.trys.push([0, 2,, 3]), e = this, [4, this.syncClient.map({
                  id: this.config.workspaceStatsMapName,
                  mode: "open_existing"
                })];
              case 1:
                return e.workspaceStatsMap = i.sent(), [3, 3];
              case 2:
                throw t = i.sent(), c.ErrorManager.createAndProcessError("Could not find and subscribe to map " + this.config.workspaceStatsMapName, {
                  type: c.FlexErrorType.syncSDK,
                  description: "Could not find and subscribe to " + this.config.workspaceStatsMapName + ": " + t.message,
                  context: "QueueStatsSubscriptionService",
                  wrappedError: t
                });
              case 3:
                return i.trys.push([3, 5,, 6]), [4, this.workspaceStatsMap.get(this.config.workspaceStatsKey)];
              case 4:
                return n = i.sent(), u.FlexModule.dispatch({
                  type: f.SET_WORKSPACE_STATS,
                  payload: n.value
                }), [3, 6];
              case 5:
                return r = i.sent(), c.ErrorManager.createAndProcessError("Unable to read Workspace Statistics.", {
                  type: c.FlexErrorType.syncSDK,
                  description: "Workspace Statistics are unavailable. Please try to reload the application and contact support if the issue persists.",
                  context: "QueueStatsSubscriptionService",
                  wrappedError: r
                }), [3, 6];
              case 6:
                return this.workspaceStatsMap.on("itemUpdated", function (e) {
                  var t = e.item;
                  t.key === o.config.workspaceStatsKey && u.FlexModule.dispatch({
                    type: f.SET_WORKSPACE_STATS,
                    payload: t.value
                  });
                }), [2];
            }
          });
        });
      }, e.prototype.initializeChannelMetadata = function () {
        return o(this, void 0, Promise, function () {
          var e;
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return t.trys.push([0, 2,, 3]), [4, d.Actions.fetchChannels()];
              case 1:
                return [2, t.sent().reduce(function (e, t) {
                  return e[t.sid] = t, e;
                }, {})];
              case 2:
                return e = t.sent(), p.log.error(e), [2, {}];
              case 3:
                return [2];
            }
          });
        });
      }, e.prototype.handleItemUpdated = function (e, t) {
        var n = t.item;
        e.notify(n.key, n.value);
      }, e.prototype.subscribeMaps = function () {
        var t;
        return o(this, void 0, void 0, function () {
          var n,
            r,
            o = this;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return (null === (t = this.queues) || void 0 === t ? void 0 : t.length) ? (n = this.queues.filter(e.filter).map(function (e) {
                  return e.sid;
                }), r = n.map(function (e) {
                  var t = e + "." + o.config.queueMapNameSuffix;
                  return o.syncClient.map({
                    id: t,
                    mode: "open_existing"
                  }).catch(function (e) {
                    if (!e.message.includes("Unique name not found")) throw c.ErrorManager.createAndProcessError("Could not find and subscribe to map", {
                      type: c.FlexErrorType.syncSDK,
                      description: "Could not find and subscribe to map " + t + ": " + e.message,
                      context: "QueueStatsSubscriptionService",
                      wrappedError: e
                    });
                  });
                }), [4, Promise.all(r)]) : (u.FlexModule.dispatch({
                  type: f.SET_QUEUES,
                  payload: []
                }), [2, []]);
              case 1:
                return [2, i.sent().filter(function (e) {
                  return !!e;
                })];
            }
          });
        });
      }, e._filter = function () {
        return !0;
      }, e;
    }();
    t.QueuesStatsSubscriptionService = m;
  }, function (e, t, n) {
    "use strict";

    var _r33,
      o = this && this.__extends || (_r33 = function r(e, t) {
        return (_r33 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r33(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DashboardsSidebar = t.ConnectedDashboardsSidebar = t.DashboardsSidebarImpl = void 0;
    var s = n(0),
      l = n(1),
      c = n(3),
      u = n(2),
      p = n(56),
      d = n(38),
      f = n(462),
      h = n(464),
      m = n(218),
      g = n(466),
      y = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            myDashboardsSelected: !1
          }, t.onMyDashboardsSelected = function (e) {
            t.setState({
              myDashboardsSelected: e
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.selectedCategory,
            r = t.currentDashboardId,
            o = this.props,
            i = o.analyticalDashboards,
            a = o.projectDashboards;
          return this.state.myDashboardsSelected && (a = a.filter(function (t) {
            return t.author === e.props.currentAuthor;
          }), i = i.filter(function (t) {
            return t.author === e.props.currentAuthor;
          })), l.createElement(g.StyledMenu, {
            theme: this.props.theme,
            "data-test-id": "DashboardsSidebar"
          }, l.createElement("li", null, l.createElement(f.CategorySelector, {
            filter: this.props.dashboardsFilter,
            onMyDashboardsSelected: this.onMyDashboardsSelected,
            isMyDashboardsSelected: this.state.myDashboardsSelected
          })), l.createElement(g.ScrollableLi, null, l.createElement("ul", null, !n && l.createElement(l.Fragment, null, i.map(function (t) {
            return l.createElement(m.StyledMenuItem, {
              key: t.identifier,
              onClick: function onClick() {
                return d.navigateToDashboard(t.identifier);
              },
              selected: e.props.currentDashboardId === t.identifier
            }, t.title);
          }), i.length && a.length ? l.createElement(g.Divider, {
            theme: this.props.theme
          }) : null), a.map(function (t) {
            return n ? t.identifier === n && l.createElement(h.CategoryView, {
              dashboard: t,
              key: t.identifier,
              onClick: d.navigateToDashboard,
              currentDashboardId: r,
              filter: e.props.dashboardTabFilter,
              showNoDataIfEmpty: !0,
              hideTitle: !0
            }) : l.createElement(h.CategoryView, {
              dashboard: t,
              key: t.identifier,
              onClick: d.navigateToDashboard,
              currentDashboardId: r,
              filter: e.props.dashboardTabFilter
            });
          }))), l.createElement(g.Divider, {
            theme: this.props.theme,
            margin: "0 16px"
          }), l.createElement("li", null, l.createElement(g.SidebarButton, {
            onClick: d.navigateToCreateNewDashboard
          }, "New Dashboard")));
        }, t = a([u.withTheme], t);
      }(l.PureComponent);
    t.DashboardsSidebarImpl = y;
    t.ConnectedDashboardsSidebar = c.connect(function (e, t) {
      return {
        analyticalDashboards: p.filteredAnalyticalDashboards(e, t),
        projectDashboards: p.filteredProjectDashboards(e, t),
        selectedCategory: p.dashboardCategorySelector(e),
        currentAuthor: p.dashboardAuthorSelector(e)
      };
    })(y);
    var v = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n, n.prototype.render = function () {
        return l.createElement(t.ConnectedDashboardsSidebar, i({}, this.props));
      }, n.defaultProps = {
        dashboardsFilter: function dashboardsFilter() {
          return !0;
        },
        dashboardTabFilter: function dashboardTabFilter() {
          return !0;
        }
      }, n = a([s.withDefaultPropsUpdate], n);
    }(l.Component);
    t.DashboardsSidebar = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledMenuItem = t.Title = void 0;
    var o,
      i,
      a = n(0),
      s = n(2);
    t.Title = s.default("li")(o || (o = r(["\n    padding: 6px 16px;\n    font-weight: bold;\n    margin: 0.5em 0;\n    font-size: 10px;\n    font-weight: bold;\n"], ["\n    padding: 6px 16px;\n    font-weight: bold;\n    margin: 0.5em 0;\n    font-size: 10px;\n    font-weight: bold;\n"]))), t.StyledMenuItem = s.default(a.MenuItem)(i || (i = r(["\n    font-size: 12px;\n    letter-spacing: 0;\n    padding: 6px 16px;\n    border-right: 2px solid transparent;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    ", "\n    ", "\n"], ["\n    font-size: 12px;\n    letter-spacing: 0;\n    padding: 6px 16px;\n    border-right: 2px solid transparent;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    ", "\n    ", "\n"])), function (e) {
      return e.theme.Dashboards.Sidebar.Item;
    }, function (e) {
      var t = e.selected,
        n = e.theme;
      return t && n.Dashboards.Sidebar.SelectedItem;
    });
  }, function (e, t, n) {
    "use strict";

    var _r34,
      o = this && this.__extends || (_r34 = function r(e, t) {
        return (_r34 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r34(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Dashboard = void 0;
    var l = n(1),
      c = n(21),
      u = n(45),
      p = n(13),
      d = n(9),
      f = n(3),
      h = n(5),
      m = n(139),
      g = n(60),
      y = n(56),
      v = n(221),
      b = n(187),
      C = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getUrl = function (e, t) {
          var n = d.getAnalyticsUrl(p.Manager.getInstance().configuration),
            r = new URLSearchParams(i({
              nochrome: "true",
              override: "ui.link",
              preventDefault: "true"
            }, this.props.queryParams)).toString();
          return this.props.dashboardByTabId ? n + "/dashboard.html#project=/gdc/projects/" + e + "&dashboard=" + this.props.dashboardByTabId.link + "&tab=" + t + "&" + r : n + "/dashboards/embedded/#/project/" + e.trim() + "/dashboard/" + t + "/?" + r;
        }, t.prototype.componentDidMount = function () {
          var e;
          null === (e = u.InsightsService.getInstance()) || void 0 === e || e.getAnalyticalDashboardDrillableItems(this.props.dashboardId);
        }, t.prototype.componentDidUpdate = function (e) {
          var t;
          return a(this, void 0, void 0, function () {
            return s(this, function (n) {
              return e.dashboardId !== this.props.dashboardId && (null === (t = u.InsightsService.getInstance()) || void 0 === t || t.getAnalyticalDashboardDrillableItems(this.props.dashboardId)), [2];
            });
          });
        }, t.prototype.render = function () {
          var e = this;
          return l.createElement(m.GoodDataGate, null, l.createElement(g.InsightsController, null, function (t) {
            var n,
              r = t.client,
              o = t.status,
              i = null === (n = null == r ? void 0 : r.user) || void 0 === n ? void 0 : n.workspace_id;
            return i ? l.createElement(v.IframeController, {
              dashboardId: e.props.dashboardId,
              events: e.props.events
            }, function (t) {
              var n = t.refFn;
              return e.props.dashboardId ? l.createElement("iframe", {
                title: "dashboard_" + e.props.dashboardId,
                src: e.getUrl(i, e.props.dashboardId),
                ref: n,
                style: {
                  flex: 1
                },
                "data-test-id": "GoodData-iframe"
              }) : e.props.enableRedirectOnEmptyDashboardId && l.createElement(b.RedirectToFirstDashboard, null);
            }) : (o === c.InsightsServiceStatus.Ready && h.log.error("Missing workspace_id in user info."), null);
          }));
        }, t.defaultProps = {
          enableRedirectOnEmptyDashboardId: !1
        }, t;
      }(l.PureComponent);
    t.Dashboard = f.connect(function () {
      var e = y.createDashboardByTabIdSelector();
      return function (t, n) {
        return {
          dashboardByTabId: e(t, n)
        };
      };
    })(C);
  }, function (e, t, n) {
    "use strict";

    var _r35,
      o = this && this.__extends || (_r35 = function r(e, t) {
        return (_r35 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r35(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InsightsGate = void 0;
    var i = n(1),
      a = n(212),
      s = n(0),
      l = n(21),
      c = n(60),
      u = n(140),
      p = n(61),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return i.createElement(c.InsightsController, null, function (t) {
            var n = t.status;
            return n === l.InsightsServiceStatus.Ready ? e.props.children : n === l.InsightsServiceStatus.Error ? i.createElement(u.NotAvailable, null) : n === l.InsightsServiceStatus.Initializing ? i.createElement(p.LoadingContainer, null, i.createElement(s.CircularProgress, {
              animating: !0,
              size: 80,
              borderWidth: 3
            })) : n === l.InsightsServiceStatus.Inactive && e.props.redirectToWhenInactive ? i.createElement(a.Redirect, {
              to: e.props.redirectToWhenInactive
            }) : null;
          });
        }, t;
      }(i.PureComponent);
    t.InsightsGate = d;
  }, function (e, t, n) {
    "use strict";

    var _r36,
      o = this && this.__extends || (_r36 = function r(e, t) {
        return (_r36 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r36(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IframeController = t._IframeController = void 0;
    var s = n(0),
      l = n(1),
      c = n(19),
      u = n(45),
      p = n(9),
      d = n(7),
      f = n(3),
      h = n(5),
      m = n(24),
      g = n(29),
      y = n(56),
      v = n(38),
      b = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          n.state = {
            listeningForDrillableItems: !1
          }, n.handleListeningForDrillableItems = function () {
            n.setState({
              listeningForDrillableItems: !0
            });
          }, n.handleUiLink = function (e, t) {
            return i(n, void 0, void 0, function () {
              var n, r;
              return a(this, function (o) {
                switch (o.label) {
                  case 0:
                    return o.trys.push([0, 2,, 3]), n = e, [4, s.Actions.invokeAction("HistoricalReporting:view", n.uri)];
                  case 1:
                    return o.sent(), [3, 3];
                  case 2:
                    return r = o.sent(), h.log.info("Cannot parse URL. Falling back to original handler.", r.message), this.delegateEventToOriginal(t), [3, 3];
                  case 3:
                    return [2];
                }
              });
            });
          }, n.handleDashboardCreated = function (e) {
            return i(n, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                return (null == (t = e) ? void 0 : t.dashboard) && v.navigateToDashboard(t.dashboard), [2];
              });
            });
          }, n.handleDashboardSaved = function () {
            return i(n, void 0, void 0, function () {
              return a(this, function (e) {
                return u.InsightsService.getInstance().fetchAnalyticalDashboards(), [2];
              });
            });
          }, n.handleDrillDown = function (e) {
            return i(n, void 0, void 0, function () {
              var t, n, r;
              return a(this, function (o) {
                return (t = e).drillTo && t.drillTo.uri && (n = t.drillTo.uri, null !== (r = n.match(/(tab=)([a-zA-Z0-9]+)/)) && 3 === r.length && r[2] && v.navigateToDashboard(r[2])), [2];
              });
            });
          }, n.handleDashboardDeleted = function (e) {
            return i(n, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                return t = e, m.Actions.deleteDashboard(t.dashboard), m.Actions.navigateToFirstDashboard(), [2];
              });
            });
          }, n.handleIncomingMessage = function (e) {
            if (n.iframe && e.source === n.iframe.contentWindow) {
              var t;
              try {
                t = JSON.parse(e.data);
              } catch (n) {
                t = e.data;
              }
              if (t.gdc) try {
                var r = t.gdc.event,
                  o = r.name,
                  i = r.data,
                  a = r.eventId;
                n.handle(o, i, a);
              } catch (e) {
                try {
                  var s = t.gdc;
                  o = s.name, i = s.data, a = s.eventId;
                  n.handle(o, i, a);
                } catch (e) {
                  h.log.warn("IframeController: Unable to parse event.name and event.data");
                }
              } else h.log.warn("IframeController: Missing gdc property on message");
            }
          }, n.ref = function (e) {
            n.iframe = e;
          }, n.gdEventHandlers = new Map(), n.gdEventHandlers.set("ui.link", n.handleUiLink), n.gdEventHandlers.set("listeningForDrillableItems", n.handleListeningForDrillableItems), n.gdEventHandlers.set("dashboardDeleted", n.handleDashboardDeleted), n.gdEventHandlers.set("dashboardCreated", n.handleDashboardCreated), n.gdEventHandlers.set("dashboardSaved", n.handleDashboardSaved), n.gdEventHandlers.set("drill", n.handleDrillDown);
          var r = t.events || {};
          return Object.keys(r).forEach(function (e) {
            var t = r[e];
            "function" == typeof t ? n.gdEventHandlers.set(e, t) : d.ErrorManager.createAndProcessError(g.ErrorMessages.INSIGHTS_DASHBOARDS_INVALID_HANDLER_TYPE, {
              type: d.FlexErrorType.app,
              context: "Insights",
              description: 'The event handler for "' + e + '" is not a function. It is of type ' + typeof t + "."
            });
          }), n;
        }
        return o(t, e), t.prototype.handle = function (e, t, n) {
          h.log.info("IframeController: handling post message:", e, t);
          var r = this.gdEventHandlers.get(e);
          r && r(t, n);
        }, t.prototype.sendDrillableItems = function () {
          return i(this, void 0, void 0, function () {
            return a(this, function (e) {
              return this.iframe && this.iframe.contentWindow ? (this.iframe.contentWindow.postMessage({
                gdc: {
                  product: "dashboard",
                  event: {
                    name: "drillableItems",
                    data: {
                      uris: this.props.drillableItems
                    }
                  }
                }
              }, p.getAnalyticsUrl(c.Manager.getInstance().configuration)), this.setState({
                listeningForDrillableItems: !1
              }), [2]) : [2];
            });
          });
        }, t.prototype.delegateEventToOriginal = function (e) {
          this.iframe && this.iframe.contentWindow && this.iframe.contentWindow.postMessage({
            gdc: {
              handleEvent: e
            }
          }, "*");
        }, t.prototype.componentDidMount = function () {
          window.addEventListener("message", this.handleIncomingMessage);
        }, t.prototype.componentWillUnmount = function () {
          window.removeEventListener("message", this.handleIncomingMessage);
        }, t.prototype.componentDidUpdate = function (e) {
          return i(this, void 0, void 0, function () {
            return a(this, function (e) {
              switch (e.label) {
                case 0:
                  return this.state.listeningForDrillableItems && this.props.drillableItems && this.props.drillableItems.length ? [4, this.sendDrillableItems()] : [3, 2];
                case 1:
                  e.sent(), e.label = 2;
                case 2:
                  return [2];
              }
            });
          });
        }, t.prototype.render = function () {
          return this.props.children({
            refFn: this.ref
          });
        }, t;
      }(l.PureComponent);
    t._IframeController = b, t.IframeController = f.connect(function () {
      var e = y.createDrillableItemsByIdSelector();
      return function (t, n) {
        return {
          drillableItems: e(t, n)
        };
      };
    })(b);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FindingService = void 0;
    var a = n(45),
      s = n(119),
      l = n(9),
      c = n(3),
      u = n(13),
      p = n(40),
      d = n(5),
      f = function () {
        function e() {
          this.playerConfig = l.getFlexInsightsPlayerConfig(u.Manager.getInstance().configuration), this.insightsService = a.InsightsService.getInstance(), this.dispatch = c.FlexModule.dispatch;
        }
        return e.getInstance = function () {
          return e.instance || (e.instance = new e()), e.instance;
        }, e.prototype.canViewFindings = function () {
          return a.InsightsService.hasPermission(p.InsightsPermission.Player.ViewFindings);
        }, e.prototype.fetchFindings = function (e) {
          return o(this, void 0, void 0, function () {
            var t, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return i.trys.push([0, 2,, 3]), [4, this.insightsService.identityClient.axios.get(this.playerConfig.mediaApiUrl + "/findings/" + e)];
                case 1:
                  return t = i.sent(), n = t.data.findings.map(function (t) {
                    return r(r({}, t), {
                      speaker: t.speaker.toLowerCase(),
                      segment_id: e
                    });
                  }), this.dispatch({
                    type: s.FINDINGS_SET,
                    payload: {
                      segmentId: e,
                      findings: n
                    }
                  }), [3, 3];
                case 2:
                  return o = i.sent(), d.log.warn("Failed to fetch findings for " + e, o), [3, 3];
                case 3:
                  return [2];
              }
            });
          });
        }, e.prototype.fetchConversationFindings = function (e) {
          return o(this, void 0, Promise, function () {
            var t = this;
            return i(this, function (n) {
              return this.canViewFindings() ? (e.forEach(function (e) {
                return t.fetchFindings(e);
              }), [2]) : [2];
            });
          });
        }, e;
      }();
    t.FindingService = f;
  }, function (e, t, n) {
    "use strict";

    var _r37,
      o = this && this.__extends || (_r37 = function r(e, t) {
        return (_r37 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r37(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationInfo = void 0;
    var a = n(1),
      s = n(50),
      l = n(3),
      c = n(476),
      u = l.connect(function (e, t) {
        var n = e.insights.segmentsById[t.segmentId].data;
        if (!n) throw Error("Trying to render a segment that was not fetched.");
        var r = n.conversation.segments.find(function (e) {
            return e.segment_id === t.segmentId;
          }),
          o = r ? r.talk_time : 0;
        return {
          agentName: n.agent_name,
          agentTeam: n.agent_team_name,
          queueName: n.queue,
          numberFrom: n.customer_phone,
          numberTo: n.agent_phone,
          segmentDuration: s.defaultTimeFormatter(o)
        };
      })(c.ConversationInfoImpl),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(u, i({}, this.props));
        }, t.friendlyName = c.displayName, t.displayName = c.displayName, t.Content = c.Content, t;
      }(a.PureComponent);
    t.ConversationInfo = p;
  }, function (e, t, n) {
    "use strict";

    var _r38,
      o = this && this.__extends || (_r38 = function r(e, t) {
        return (_r38 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r38(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationViewPanelContainer = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(479),
      c = n(486),
      u = n(490),
      p = n(225),
      d = n(497),
      f = n(21),
      h = n(18),
      m = n(498),
      g = n(499),
      y = n(11),
      v = n(10),
      b = n(500);
    function C(e) {
      return ("" + e.title + e.type + (e.sid || "") + (e.url || "") + (e.conversation_sid || "")).replace(/[^a-zA-Z\d\s]/g, "");
    }
    t.displayName = "ConversationViewPanel", t.contentStore = new s.DynamicContentStore(t.displayName);
    var _ = function (e) {
      function n(t) {
        var n = e.call(this, t) || this;
        return n.onPanelSelected = function (e) {
          n.setState({
            selectedPanel: e
          }), e.startsWith(h.InsightsPlayerMediaLinkType.EmailTranscript + "-") || e.startsWith(h.InsightsPlayerMediaLinkType.ChatTranscript + "-") || e.startsWith(h.InsightsPlayerMediaLinkType.Embedded + "-") ? localStorage.removeItem("ConversationViewPanelContainer:selected:" + n.props.id) : localStorage.setItem("ConversationViewPanelContainer:selected:" + n.props.id, e);
        }, n.registerPanel = function (e, t) {
          n.state.siblings[e] || n.setState(function (n) {
            var r;
            return {
              siblings: i(i({}, n.siblings), (r = {}, r[e] = t, r))
            };
          });
        }, n.state = {
          selectedPanel: t.defaultPanel || localStorage.getItem("ConversationViewPanelContainer:selected:" + t.id) || void 0,
          siblings: {}
        }, n;
      }
      return o(n, e), n.prototype.renderMediaLinks = function () {
        return this.props.mediaLinks ? this.props.mediaLinks.reduce(function (e, t) {
          switch (t.type) {
            case h.InsightsPlayerMediaLinkType.ChatTranscript:
              e.push(a.createElement(d.ChatTranscriptPanel, {
                key: C(t),
                mediaLink: t
              }));
              break;
            case h.InsightsPlayerMediaLinkType.Embedded:
              e.push(a.createElement(m.EmbeddedContentPanel, {
                key: C(t),
                mediaLink: t
              }));
              break;
            case h.InsightsPlayerMediaLinkType.Referenced:
              e.push(a.createElement(g.ReferencedContentPanel, {
                key: C(t),
                mediaLink: t
              }));
              break;
            case h.InsightsPlayerMediaLinkType.EmailTranscript:
              y.FeatureFlags.isEnabled(v.FeatureFlag.EmailPOC) && e.push(a.createElement(b.EmailTranscriptPanel, {
                key: C(t),
                mediaLink: t
              }));
          }
          return e;
        }, []) : null;
      }, n.prototype.render = function () {
        var e,
          n = Object.keys(this.state.siblings)[0],
          r = this.state.selectedPanel;
        return e = r && this.state.siblings[r] ? r : n, a.createElement(p.ConversationViewPanelContext.Provider, {
          value: {
            selectedPanel: e,
            onPanelSelected: this.onPanelSelected,
            siblings: this.state.siblings,
            registerPanel: this.registerPanel
          }
        }, a.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          name: t.displayName,
          rootContainerStyles: "flex: 1; display: flex;",
          noContainers: !0
        }, a.createElement("div", null, f.InsightsService.hasPermission(f.InsightsPermission.Assessment.Add) && a.createElement(l.AssessConversationViewPanel, {
          key: "assess"
        }), f.InsightsService.hasPermission(f.InsightsPermission.Comment.View) && a.createElement(c.AgentConversationViewPanel, {
          key: "agent"
        }), f.InsightsService.hasPermission(f.InsightsPermission.Player.ViewFindings) && a.createElement(u.FindingsConversationViewPanel, {
          key: "findings"
        }), this.renderMediaLinks())));
      }, n;
    }(a.PureComponent);
    t.ConversationViewPanelContainer = _;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationViewPanelContext = void 0;
    var r = n(1);
    t.ConversationViewPanelContext = r.createContext({
      selectedPanel: void 0,
      siblings: {},
      onPanelSelected: function onPanelSelected() {
        return null;
      },
      registerPanel: function registerPanel() {
        return null;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r39,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r39 = function r(e, t) {
        return (_r39 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r39(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AssessPanelContent = t.AssessPanelContentComponent = void 0;
    var a,
      s,
      l = n(0),
      c = n(1),
      u = n(144),
      p = n(3),
      d = n(2),
      f = n(227),
      h = n(481),
      m = n(482),
      g = n(485),
      y = d.default("div")(a || (a = o(["\n    flex: 1;\n"], ["\n    flex: 1;\n"]))),
      v = d.default("div")(s || (s = o(["\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"], ["\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"]))),
      b = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {}, t.onAnswerSubmitted = function (e) {
            e.questionnaire_id = t.state.selectedQuestionnaireId || "";
            var n = t.props.segmentId;
            n && u.QuestionnaireService.getInstance().submitAssessment(n, e);
          }, t;
        }
        return i(t, e), t.getDerivedStateFromProps = function (e, t) {
          return t.selectedQuestionnaireId ? t : {
            selectedQuestionnaireId: e.questionnaires[0] ? e.questionnaires[0].id : void 0
          };
        }, t.prototype.renderQuestionnaire = function () {
          var e = this,
            t = this.props.questionnaires.find(function (t) {
              return t.id === e.state.selectedQuestionnaireId;
            });
          return t ? c.createElement(m.Questionnaire, {
            questionnaire: t,
            onAnswerSubmitted: this.onAnswerSubmitted
          }) : c.createElement("div", null, "No questionnaires found.");
        }, t.prototype.render = function () {
          var e = this;
          return this.props.agentName ? c.createElement(y, null, c.createElement(v, null, !!this.props.questionnaires.length && c.createElement(g.QuestionnaireSelector, {
            questionnaires: this.props.questionnaires,
            selectedId: this.state.selectedQuestionnaireId,
            onSelect: function onSelect(t) {
              return e.setState({
                selectedQuestionnaireId: t
              });
            }
          }), c.createElement(h.AnswerCount, {
            questionnaireId: this.state.selectedQuestionnaireId
          })), this.renderQuestionnaire()) : c.createElement(l.Template, {
            code: "AssessPanelNoAgentAssociated"
          });
        }, t;
      }(c.PureComponent);
    t.AssessPanelContentComponent = b, t.AssessPanelContent = p.connect(function (e, t) {
      return {
        questionnaires: e.insights.questionnaires || [],
        segmentId: t.segmentId || e.insights.segmentId,
        agentName: f.agentNameSelector(e, t)
      };
    })(b);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.agentNameSelector = t.currentSegmentSelector = t.segmentIdSelector = t.segmentsSelector = void 0;
    var r = n(31);
    t.segmentsSelector = function (e) {
      return e.insights.segmentsById;
    };
    t.segmentIdSelector = function (e, t) {
      return t.segmentId || e.insights.segmentId;
    }, t.currentSegmentSelector = r.createSelector(t.segmentsSelector, t.segmentIdSelector, function (e, t) {
      if (t) return e[t];
    }), t.agentNameSelector = r.createSelector(t.currentSegmentSelector, function (e) {
      var t;
      return null === (t = null == e ? void 0 : e.data) || void 0 === t ? void 0 : t.agent_name;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
      var r = Array(e),
        o = 0;
      for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
      return r;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.answerCountTotalSelector = t.answerCountAsweredSelector = t.assessmentsForQuestionnaireSelector = t.assessmentsForSegmentSelector = t.segmentIdSelector = t.questionnairesSelector = t.assessmentsSelector = void 0;
    var o = n(31);
    t.assessmentsSelector = function (e) {
      return e.insights.assessments;
    };
    t.questionnairesSelector = function (e) {
      return e.insights.questionnaires;
    };
    t.segmentIdSelector = function (e, t) {
      return t.segmentId || e.insights.segmentId;
    }, t.assessmentsForSegmentSelector = o.createSelector(t.assessmentsSelector, t.segmentIdSelector, function (e, t) {
      return t && e[t] || [];
    }), t.assessmentsForQuestionnaireSelector = o.createSelector(function (e, t) {
      return t.questionnaire.id;
    }, t.assessmentsForSegmentSelector, function (e, t) {
      return t.filter(function (t) {
        return t.questionnaire_id === e;
      });
    });
    var i = function i(e, t) {
        return t.questionnaireId;
      },
      a = o.createSelector(i, t.questionnairesSelector, function (e, t) {
        return t.find(function (t) {
          return t.id === e;
        });
      });
    t.answerCountAsweredSelector = o.createSelector(i, t.assessmentsForSegmentSelector, function (e, t) {
      return Object.values(t.filter(function (t) {
        return t.questionnaire_id === e;
      }).sort(function (e, t) {
        return (e.timestamp_updated || 0) - (t.timestamp_updated || 0);
      }).reduce(function (e, t) {
        return t.metric_id && (e[t.metric_id] = t), e;
      }, {})).filter(function (e) {
        return e.answer_id;
      }).length;
    }), t.answerCountTotalSelector = o.createSelector(a, function (e) {
      return e ? e.categories.reduce(function (e, t) {
        return r(e, t.metrics);
      }, []).length : 0;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(230), t), o(n(491), t), o(n(493), t), o(n(495), t), o(n(222), t), o(n(119), t);
  }, function (e, t, n) {
    "use strict";

    var _r40,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r40 = function r(e, t) {
        return (_r40 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r40(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FindingMarker = void 0;
    var a,
      s = n(1),
      l = n(50),
      c = n(145),
      u = n(2).default("div", {
        shouldForwardProp: function shouldForwardProp(e) {
          return "color" !== e;
        }
      })(a || (a = o(["\n    display: inline-block;\n    max-width: 60px;\n    padding: 0.05em 0.3em;\n    border-radius: 3px;\n    border-bottom-left-radius: 0;\n    border-left: 1px solid #fff;\n    transform: translate(-1px, calc(-100% - 9px));\n    cursor: pointer;\n    pointer-events: auto;\n    font-size: 10px;\n    line-height: 11px;\n    font-weight: 500;\n    color: white;\n    background-color: ", ';\n\n    &:after {\n        content: "";\n        display: block;\n        position: absolute;\n        bottom: -5px;\n        left: 0;\n        width: 0;\n        border-width: 6px 6px 0 0;\n        border-style: solid;\n        border-color: ', " transparent;\n        box-shadow: -1px 0 0 #fff;\n    }\n"], ["\n    display: inline-block;\n    max-width: 60px;\n    padding: 0.05em 0.3em;\n    border-radius: 3px;\n    border-bottom-left-radius: 0;\n    border-left: 1px solid #fff;\n    transform: translate(-1px, calc(-100% - 9px));\n    cursor: pointer;\n    pointer-events: auto;\n    font-size: 10px;\n    line-height: 11px;\n    font-weight: 500;\n    color: white;\n    background-color: ", ';\n\n    &:after {\n        content: "";\n        display: block;\n        position: absolute;\n        bottom: -5px;\n        left: 0;\n        width: 0;\n        border-width: 6px 6px 0 0;\n        border-style: solid;\n        border-color: ', " transparent;\n        box-shadow: -1px 0 0 #fff;\n    }\n"])), function (e) {
        return e.color;
      }, function (e) {
        return e.color;
      }),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleClick = function () {
            return t.props.onClick(t.props.finding);
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this.props.finding;
          return s.createElement(l.Mark, {
            offset: e.offset,
            duration: e.duration,
            color: "rgba(0, 0, 0, 0.2)"
          }, s.createElement(u, {
            color: c.getChannelColor(e.speaker, this.props.theme),
            title: e.speech_phrase + " (" + e.speech_search + ")",
            "data-id": e.id,
            onClick: this.handleClick
          }, this.getFindingAcronym()));
        }, t.prototype.getFindingAcronym = function () {
          return this.props.finding.speech_search ? this.props.finding.speech_search.match(/\b(\w)/g).join("") : "—";
        }, t;
      }(s.PureComponent);
    t.FindingMarker = p;
  }, function (e, t, n) {
    "use strict";

    var _r41,
      o = this && this.__extends || (_r41 = function r(e, t) {
        return (_r41 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r41(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Player = void 0;
    var a = n(1),
      s = n(3),
      l = n(5),
      c = n(24),
      u = n(101),
      p = n(501),
      d = n(41).contextTypes,
      f = s.connect(function (e, t) {
        var n = e.insights.segmentsById[t.segmentId].data;
        if (!n) throw new Error("Trying to render a segment that was not fetched");
        return {
          recordingUrl: n.recordingUrl,
          recordingUrlExpiresAt: n.recordingUrlExpiresAt,
          peaks: n.peaks,
          segments: c.segmentListSelector(e, t.segmentId)
        };
      })(p.PlayerImpl),
      h = function (e) {
        function t(t, n) {
          var r = e.call(this, t, n) || this;
          return r.state = {}, r;
        }
        return o(t, e), t.prototype.componentWillUnmount = function () {
          -1 !== this.unsubscribeId && this.context.__EMOTION_THEMING__.unsubscribe(this.unsubscribeId);
        }, t.prototype.componentDidMount = function () {
          var e = this,
            t = this.context.__EMOTION_THEMING__;
          void 0 !== t ? this.unsubscribeId = t.subscribe(function (t) {
            e.setState({
              theme: t
            });
          }) : l.log.error("[withTheme] Please use ThemeProvider to be able to use withTheme");
        }, t.prototype.render = function () {
          return this.state.theme ? a.createElement(u.default, null, a.createElement(f, i({}, this.props, {
            theme: this.state.theme,
            playerRef: this.props.playerRef
          }))) : null;
        }, t.friendlyName = p.displayName, t.displayName = p.displayName, t.contextTypes = d, t;
      }(a.Component);
    t.Player = a.forwardRef(function (e, t) {
      return a.createElement(h, i({}, e, {
        playerRef: t
      }));
    });
  }, function (e, t, n) {
    "use strict";

    var _r42,
      o = this && this.__extends || (_r42 = function r(e, t) {
        return (_r42 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r42(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SegmentInfo = void 0;
    var s = n(0),
      l = n(1),
      c = n(3),
      u = n(24),
      p = n(507),
      d = c.connect(function (e, t) {
        var n = e.insights.segmentsById[t.segmentId].data;
        if (!n) throw new Error("Trying to render a segment that was not fetched");
        return {
          timestamp: n.timestamp,
          canCommentAndAssess: !!n.agent_name,
          segments: u.segmentListSelector(e, t.segmentId) || []
        };
      })(p.SegmentInfoImpl),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return l.createElement(d, i({}, this.props));
        }, t.friendlyName = p.displayName, t.displayName = p.displayName, t.Content = p.Content, t = a([s.withDefaultPropsUpdate], t);
      }(l.PureComponent);
    t.SegmentInfo = f;
  }, function (e, t, n) {
    "use strict";

    var _r43,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r43 = function r(e, t) {
        return (_r43 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r43(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SLAPreferencesView = void 0;
    var a,
      s = n(1),
      l = n(49),
      c = n(2),
      u = n(234),
      p = n(102),
      d = n(236),
      f = c.default("div")(a || (a = o(["\n    background: ", ";\n    color: ", ";\n    display: flex;\n    flex: 1;\n"], ["\n    background: ", ";\n    color: ", ";\n    display: flex;\n    flex: 1;\n"])), function (e) {
        return e.theme.colors.base1;
      }, function (e) {
        return e.theme.calculated.textColor;
      }),
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.render = function () {
          return s.createElement(f, null, s.createElement(l.Switch, null, s.createElement(l.Route, {
            exact: !0,
            path: p.SLAPreferencesHomePage.path
          }, s.createElement(p.SLAPreferencesHomePage, null)), s.createElement(l.Route, {
            exact: !0,
            path: u.SLAPreferencesGlobalPage.path
          }, s.createElement(u.SLAPreferencesGlobalPage, null)), s.createElement(l.Route, {
            exact: !0,
            path: d.SLAPreferencesQueuePage.path + "/:queue_sid",
            render: function render(e) {
              var t = e.match;
              return s.createElement(d.SLAPreferencesQueuePage, {
                queueSid: t.params.queue_sid
              });
            }
          }), s.createElement(l.Redirect, {
            to: p.SLAPreferencesHomePage.path
          })));
        }, t;
      }(s.PureComponent);
    t.SLAPreferencesView = h;
  }, function (e, t, n) {
    "use strict";

    var _r44,
      o = this && this.__extends || (_r44 = function r(e, t) {
        return (_r44 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r44(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SLAPreferencesGlobalPage = void 0;
    var i = n(1),
      a = n(51),
      s = n(511),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), Object.defineProperty(t, "path", {
          get: function get() {
            return a.slaPreferencesPath("/global-service-level");
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.render = function () {
          return i.createElement(s.GlobalSLForm, null);
        }, t;
      }(i.PureComponent);
    t.SLAPreferencesGlobalPage = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SLAPreferencesService = void 0;
    var s = n(0),
      l = n(3),
      c = n(25),
      u = function () {
        function e() {}
        return e.updateDefaultSLAPreferences = function (e) {
          return o(this, void 0, void 0, function () {
            var t, n;
            return i(this, function (r) {
              return t = l.FlexModule.state.realtimeQueues.queuesConfig, n = {
                default: e,
                queue_configurations: t.queue_configurations,
                queue_channel_configurations: t.queue_channel_configurations
              }, [2, this.saveQueuesConfig(n)];
            });
          });
        }, e.updateQueueSLAPreferences = function (e) {
          return o(this, void 0, void 0, function () {
            var t, n, r, o, s;
            return i(this, function (i) {
              return t = e.queue_sid, n = l.FlexModule.state.realtimeQueues.queuesConfig, r = n.queue_configurations ? n.queue_configurations.filter(function (e) {
                return e.queue_sid !== t;
              }) : [], e.queue && r.push({
                queue_sid: t,
                reset_time: e.queue.reset_time,
                reset_timezone: e.queue.reset_timezone
              }), o = a(n.queue_channel_configurations ? n.queue_channel_configurations.filter(function (e) {
                return e.queue_sid !== t;
              }) : [], e.channels.map(function (e) {
                return {
                  queue_sid: t,
                  channel_sid: e.channel_sid,
                  service_level_threshold: e.service_level_threshold,
                  short_abandoned_threshold: e.short_abandoned_threshold
                };
              })), s = {
                default: n.default,
                queue_configurations: r,
                queue_channel_configurations: o
              }, [2, this.saveQueuesConfig(s)];
            });
          });
        }, e.saveQueuesConfig = function (e) {
          return o(this, void 0, void 0, function () {
            return i(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, this.postQueuesConfig(e)];
                case 1:
                  return t.sent(), c.Actions.updateQueuesConfiguration(e), [2];
              }
            });
          });
        }, e.postQueuesConfig = function (e) {
          return s.FlexSDKManager.setAccountConfig({
            queueStatsConfiguration: r(r({}, e), {
              queue_channel_configurations: e.queue_channel_configurations || [],
              queue_configurations: e.queue_configurations || []
            })
          });
        }, e;
      }();
    t.SLAPreferencesService = u;
  }, function (e, t, n) {
    "use strict";

    var _r45,
      o = this && this.__extends || (_r45 = function r(e, t) {
        return (_r45 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r45(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SLAPreferencesQueuePage = t.SLAPreferencesQueuePageImpl = void 0;
    var i = n(0),
      a = n(1),
      s = n(3),
      l = n(6),
      c = n(25),
      u = n(4),
      p = n(61),
      d = n(517),
      f = n(51),
      h = n(102),
      m = n(130),
      g = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.onCancel = function () {
            return i.Actions.invokeAction("HistoryPush", h.SLAPreferencesHomePage.path);
          }, t.hasFetched && !t.error && null !== t.queueName || c.Actions.fetchMetadata(), n;
        }
        return o(t, e), Object.defineProperty(t, "path", {
          get: function get() {
            return f.slaPreferencesPath("/queues");
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.render = function () {
          return this.props.hasFetched ? this.props.error || null === this.props.queueName ? a.createElement(i.ErrorMessage, {
            title: u.templates.SLAPreferencesCustomLevelsError(),
            hideBranding: !0,
            secondaryAction: this.onCancel,
            secondaryActionTitle: "Back",
            primaryActionTitle: "Reload",
            primaryAction: function primaryAction() {
              l.tryInvokeAction("ReloadWindow");
            }
          }) : a.createElement(d.QueuesSLAPreferencesForm, {
            queueSid: this.props.queueSid,
            queueName: this.props.queueName
          }) : a.createElement(p.LoadingContainer, null, a.createElement(i.CircularProgress, {
            animating: !0,
            size: 80,
            borderWidth: 3
          }));
        }, t;
      }(a.PureComponent);
    t.SLAPreferencesQueuePageImpl = g, t.SLAPreferencesQueuePage = m(s.connect(function (e, t) {
      return {
        queueName: t.queueSid in e.realtimeQueues.metadata.queuesBySid ? e.realtimeQueues.metadata.queuesBySid[t.queueSid].friendly_name : null,
        hasFetched: e.realtimeQueues.metadata.hasFetched,
        error: e.realtimeQueues.metadata.error
      };
    })(g), g);
  }, function (e, t, n) {
    "use strict";

    var _r46,
      o = this && this.__extends || (_r46 = function r(e, t) {
        return (_r46 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r46(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SlaPrefsTimezonePicker = void 0;
    var i = n(1),
      a = n(30),
      s = n(103),
      l = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {}, t.onChange = function (e) {
            e ? "function" == typeof t.props.onTimezoneSelect && t.props.onTimezoneSelect(e.value) : t.setState({
              isEmpty: !0
            });
          }, t.onBlur = function () {
            t.setState({
              isEmpty: void 0
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.state.isEmpty ? void 0 : s.timezones.find(function (t) {
              return t.value === e.props.value;
            });
          return i.createElement("div", {
            "data-test": "SLA_TimezonePicker"
          }, i.createElement(a.Select, {
            options: s.timezones,
            value: t,
            onChange: this.onChange,
            width: "400px",
            onBlur: this.onBlur,
            isClearable: !0
          }));
        }, t;
      }(i.PureComponent);
    t.SlaPrefsTimezonePicker = l;
  }, function (e, t, n) {
    "use strict";

    var _r47,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r47 = function r(e, t) {
        return (_r47 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r47(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SLATimePicker = void 0;
    var a,
      s = n(1),
      l = n(30),
      c = n(2),
      u = n(22).withStyles(function () {
        return {
          root: {
            width: "auto"
          }
        };
      })(l.Input),
      p = c.default("div")(a || (a = o(["\n    ", "\n\n    input {\n        line-height: 20px;\n    }\n"], ["\n    ", "\n\n    input {\n        line-height: 20px;\n    }\n"])), function (e) {
        return !e.theme.calculated.lightTheme && "input::-webkit-calendar-picker-indicator {\n            filter: invert(1);\n         }";
      }),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onChange = function (e) {
            "function" == typeof t.props.onTimeSelect && t.props.onTimeSelect(e.target.value);
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          return s.createElement(p, null, s.createElement(u, {
            "data-test": "SLA_TimePicker",
            type: "time",
            value: this.props.value || "",
            onChange: this.onChange
          }));
        }, t;
      }(s.PureComponent);
    t.SLATimePicker = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NoTasksCanvas = void 0;
    var r = n(526);
    Object.defineProperty(t, "NoTasksCanvas", {
      enumerable: !0,
      get: function get() {
        return r.NoTasksCanvas;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasChildrenProps = t.TaskCanvas = void 0;
    var r = n(529);
    Object.defineProperty(t, "TaskCanvas", {
      enumerable: !0,
      get: function get() {
        return r.TaskCanvas;
      }
    });
    var o = n(539);
    Object.defineProperty(t, "TaskCanvasChildrenProps", {
      enumerable: !0,
      get: function get() {
        return o.TaskCanvasChildrenProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Paper = t.MenuItem = t.MenuList = t.EndCallMenuButtonContainer = t.EndCallForAllButton = t.LeaveCallButton = t.EndTaskButton = t.EndTaskButtonContainer = t.DownChevron = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d,
      f = n(22),
      h = n(0),
      m = n(2);
    t.DownChevron = m.default(h.Icon)(o || (o = r(["\n    margin-left: 4px;\n"], ["\n    margin-left: 4px;\n"]))), t.EndTaskButtonContainer = m.default(h.Button)(i || (i = r([""], [""]))), t.EndTaskButton = m.default(f.Button)(a || (a = r(["\n    &.root {\n        border: ", ";\n        border-radius: 2px;\n        color: ", ";\n        font-weight: 600;\n        font-size: 14px;\n        height: max-content;\n        line-height: 20px;\n        margin: auto 0;\n        padding: 4px 8px;\n        text-transform: none;\n\n        &:active {\n            box-shadow: none;\n        }\n\n        &:hover {\n            background-color: ", ";\n            border: ", ";\n            color: ", ";\n            text-decoration: none;\n        }\n    }\n"], ["\n    &.root {\n        border: ", ";\n        border-radius: 2px;\n        color: ", ";\n        font-weight: 600;\n        font-size: 14px;\n        height: max-content;\n        line-height: 20px;\n        margin: auto 0;\n        padding: 4px 8px;\n        text-transform: none;\n\n        &:active {\n            box-shadow: none;\n        }\n\n        &:hover {\n            background-color: ", ";\n            border: ", ";\n            color: ", ";\n            text-decoration: none;\n        }\n    }\n"])), function (e) {
      return e.theme.calculated.lightTheme ? "1px solid #8891aa" : "1px solid #626b83";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#121c2d" : "#f4f4f6";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#ebf4ff" : "rgba(255,255,255,0.1)";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "1px solid #030b5d" : "1px solid #ffffff";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#030b5d" : "#ffffff";
    }), t.LeaveCallButton = m.default(t.EndTaskButton)(s || (s = r(["\n    &.root {\n        border: ", ";\n        border-radius: 4px;\n        padding: 8px;\n        color: ", ";\n\n        &:hover {\n            background-color: ", ";\n            border: ", ";\n            color: ", ";\n            text-decoration: none;\n        }\n    }\n"], ["\n    &.root {\n        border: ", ";\n        border-radius: 4px;\n        padding: 8px;\n        color: ", ";\n\n        &:hover {\n            background-color: ", ";\n            border: ", ";\n            color: ", ";\n            text-decoration: none;\n        }\n    }\n"])), function (e) {
      return e.theme.calculated.lightTheme ? "1px solid #d61f1f" : "1px solid #eb5656";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#d61f1f" : "#eb5656";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#feecec" : "rgba(255,255,255,0.1)";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "1px solid #4a0b0b" : "1px solid #ffffff";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#4a0b0b" : "#ffffff";
    }), t.EndCallForAllButton = m.default(t.LeaveCallButton)(l || (l = r(["\n    &.root {\n        background: ", ";\n        box-shadow: none;\n        color: ", ";\n\n        &:hover {\n            background-color: ", ";\n            border-color: ", ";\n            color: ", ";\n            text-decoration: none;\n        }\n    }\n"], ["\n    &.root {\n        background: ", ";\n        box-shadow: none;\n        color: ", ";\n\n        &:hover {\n            background-color: ", ";\n            border-color: ", ";\n            color: ", ";\n            text-decoration: none;\n        }\n    }\n"])), function (e) {
      return e.theme.calculated.lightTheme ? "#d61f1f" : "#eb5656";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#ffffff" : "#000000";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#4a0b0b" : "#feecec";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#4a0b0b" : "#feecec";
    }, function (e) {
      return e.theme.calculated.lightTheme ? "#ffffff" : "#121c2d";
    }), t.EndCallMenuButtonContainer = m.default("section")(c || (c = r(["\n    margin: auto 0;\n"], ["\n    margin: auto 0;\n"]))), t.MenuList = m.default(f.MenuList)(u || (u = r(["\n    &.root {\n        padding: 8px 16px;\n    }\n"], ["\n    &.root {\n        padding: 8px 16px;\n    }\n"]))), t.MenuItem = m.default(f.MenuItem)(p || (p = r(["\n    &.root {\n        height: auto;\n        padding: 8px 0;\n\n        &:hover {\n            background: transparent;\n        }\n    }\n"], ["\n    &.root {\n        height: auto;\n        padding: 8px 0;\n\n        &:hover {\n            background: transparent;\n        }\n    }\n"]))), t.Paper = m.default(f.Paper)(d || (d = r(["\n    &.root {\n        background-color: ", ";\n        border: 1px solid ", ";\n        box-shadow: 0px 4px 16px rgba(18, 28, 45, 0.2);\n        border-radius: 4px;\n        margin-top: 4px;\n    }\n"], ["\n    &.root {\n        background-color: ", ";\n        border: 1px solid ", ";\n        box-shadow: 0px 4px 16px rgba(18, 28, 45, 0.2);\n        border-radius: 4px;\n        margin-top: 4px;\n    }\n"])), function (e) {
      return e.theme.calculated.lightTheme ? "#ffffff" : "#000000";
    }, "#cacdd8");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MainHeaderChildrenProps = t.MainHeaderProps = t.MainHeader = t.UserControlsImplProps = t.UserControls = void 0;
    var r = n(243);
    Object.defineProperty(t, "UserControls", {
      enumerable: !0,
      get: function get() {
        return r.UserControls;
      }
    }), Object.defineProperty(t, "UserControlsImplProps", {
      enumerable: !0,
      get: function get() {
        return r.UserControlsImplProps;
      }
    });
    var o = n(546);
    Object.defineProperty(t, "MainHeader", {
      enumerable: !0,
      get: function get() {
        return o.MainHeader;
      }
    });
    var i = n(554);
    Object.defineProperty(t, "MainHeaderProps", {
      enumerable: !0,
      get: function get() {
        return i.MainHeaderProps;
      }
    }), Object.defineProperty(t, "MainHeaderChildrenProps", {
      enumerable: !0,
      get: function get() {
        return i.MainHeaderChildrenProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserControlsImplProps = t.UserControlsChildrenProps = t.UserControls = void 0;
    var r = n(542);
    Object.defineProperty(t, "UserControls", {
      enumerable: !0,
      get: function get() {
        return r.UserControls;
      }
    }), Object.defineProperty(t, "UserControlsChildrenProps", {
      enumerable: !0,
      get: function get() {
        return r.UserControlsChildrenProps;
      }
    }), Object.defineProperty(t, "UserControlsImplProps", {
      enumerable: !0,
      get: function get() {
        return r.UserControlsChildrenProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledIconButton = t.StyledIconContainer = t.HeaderLogoImage = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l = n(0),
      c = n(2);
    t.Container = c.default("div")(o || (o = r(["\n    padding-left: 8px;\n    height: 44px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex: 0 0 auto;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    overflow: hidden;\n    ", "\n"], ["\n    padding-left: 8px;\n    height: 44px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex: 0 0 auto;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    overflow: hidden;\n    ", "\n"])), function (e) {
      return e.theme.MainHeader.Container;
    }), t.HeaderLogoImage = c.default("img")(i || (i = r(["\n    margin-left: 12px;\n    margin-top: auto;\n    margin-bottom: auto;\n    display: block;\n    max-width: 240px;\n    max-height: 36px;\n    width: auto;\n    height: auto;\n"], ["\n    margin-left: 12px;\n    margin-top: auto;\n    margin-bottom: auto;\n    display: block;\n    max-width: 240px;\n    max-height: 36px;\n    width: auto;\n    height: auto;\n"]))), t.StyledIconContainer = c.default("div")(a || (a = r(["\n    display: flex;\n    align-items: center;\n    position: relative;\n    background: ", ";\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Main-Header-IconButton,\n        & .Twilio-Badge-OuterCircle {\n            cursor: pointer;\n            ", "\n        }\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    position: relative;\n    background: ", ";\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Main-Header-IconButton,\n        & .Twilio-Badge-OuterCircle {\n            cursor: pointer;\n            ", "\n        }\n    }\n"])), function (e) {
      return e.theme.MainHeader.Container.background;
    }, function (e) {
      return l.getBackgroundWithHoverCSS(e.theme.MainHeader.Container.background, e.theme.MainHeader.Button.lightHover, !0);
    }), t.StyledIconButton = c.default(l.IconButton)(s || (s = r(["\n    margin-right: 8px;\n"], ["\n    margin-right: 8px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListItemProps = t.TaskListItem = t.TaskListFilterProps = t.TaskListFilter = t.TaskListBaseItem = t.TaskListProps = t.TaskList = void 0;
    var r = n(150);
    Object.defineProperty(t, "TaskList", {
      enumerable: !0,
      get: function get() {
        return r.TaskList;
      }
    }), Object.defineProperty(t, "TaskListProps", {
      enumerable: !0,
      get: function get() {
        return r.TaskListProps;
      }
    });
    var o = n(249);
    Object.defineProperty(t, "TaskListBaseItem", {
      enumerable: !0,
      get: function get() {
        return o.TaskListBaseItem;
      }
    });
    var i = n(247);
    Object.defineProperty(t, "TaskListFilter", {
      enumerable: !0,
      get: function get() {
        return i.TaskListFilter;
      }
    }), Object.defineProperty(t, "TaskListFilterProps", {
      enumerable: !0,
      get: function get() {
        return i.TaskListFilterProps;
      }
    });
    var a = n(248);
    Object.defineProperty(t, "TaskListItem", {
      enumerable: !0,
      get: function get() {
        return a.TaskListItem;
      }
    }), Object.defineProperty(t, "TaskListItemProps", {
      enumerable: !0,
      get: function get() {
        return a.TaskListItemProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r48,
      o = this && this.__extends || (_r48 = function r(e, t) {
        return (_r48 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r48(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      s = this && this.__metadata || function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListImpl = t.TaskListContext = t.contentStore = t.displayName = void 0;
    var l = n(2),
      c = n(1),
      u = n(0),
      p = n(247),
      d = n(560),
      f = n(15),
      h = n(248),
      m = n(150),
      g = {
        from: {
          transform: "translateY(-45px)"
        },
        to: {
          transform: ""
        }
      };
    t.displayName = "TaskList", t.contentStore = new u.DynamicContentStore(t.displayName), t.TaskListContext = c.createContext(void 0);
    var y = function (e) {
      function n(t) {
        var n = e.call(this, t) || this;
        return n._isFilterChanging = !1, n.handleFilterChange = function (e) {
          n._isFilterChanging = !0, n.setState({
            selectedFilter: e
          }, function () {
            n._isFilterChanging = !1;
          }), n.props.onFilterChange && n.props.onFilterChange(e);
        }, n.state = i(i({}, t), {
          onFilterChange: n.handleFilterChange,
          selectedFilter: t.filters && t.filters.length > 0 && t.filters[0] || null
        }), n;
      }
      var r;
      return o(n, e), n.getDerivedStateFromProps = function (e, t) {
        return i(i({}, t), e);
      }, n.prototype.render = function () {
        var e = this,
          n = this.props,
          r = n.tasks,
          o = n.staticFilter,
          i = this.state,
          a = i.compareFunction,
          s = i.selectedFilter,
          l = Array.from(r.values()),
          f = o ? l.filter(function (e) {
            return o(e);
          }).sort(function (e, t) {
            return a(e, t);
          }).map(function (t) {
            return e.createTaskListItem(t);
          }) : [],
          h = l.filter(function (e) {
            return s.callback(e) && !o(e);
          }).sort(function (e, t) {
            return a(e, t);
          }).map(function (t) {
            return e.createTaskListItem(t);
          }),
          m = f.concat(c.createElement(p.TaskListFilter, {
            key: "TaskListFilter",
            filters: this.state.filters,
            value: this.state.selectedFilter
          })).concat(h);
        return c.createElement(t.TaskListContext.Provider, {
          value: this.state
        }, c.createElement(u.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.state,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, c.createElement(u.FlexBox, {
          vertical: !0,
          noShrink: !0
        }, c.createElement(d.default, {
          key: "contents",
          easing: "ease-in",
          disableAllAnimations: this._isFilterChanging,
          duration: 300,
          appearAnimation: "fade",
          enterAnimation: g,
          leaveAnimation: "none"
        }, m))));
      }, n.prototype.createTaskListItem = function (e) {
        return c.createElement(f.TaskContextSource, {
          key: e.sid,
          taskSid: e.sid
        }, c.createElement(h.TaskListItem, {
          selectedTaskSid: this.state.selectedTaskSid,
          onSelected: this.props.onTaskSelected
        }));
      }, n = a([l.withTheme, s("design:paramtypes", ["function" == typeof (r = void 0 !== m.TaskListProps && m.TaskListProps) ? r : Object])], n);
    }(c.PureComponent);
    t.TaskListImpl = y;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListFilter = t.TaskListFilterProps = void 0;
    var r = n(555);
    Object.defineProperty(t, "TaskListFilterProps", {
      enumerable: !0,
      get: function get() {
        return r.TaskListFilterProps;
      }
    }), Object.defineProperty(t, "TaskListFilter", {
      enumerable: !0,
      get: function get() {
        return r.TaskListFilter;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListItemProps = t.TaskListItemChildrenProps = t.TaskListItem = void 0;
    var r = n(561);
    Object.defineProperty(t, "TaskListItem", {
      enumerable: !0,
      get: function get() {
        return r.TaskListItem;
      }
    });
    var o = n(574);
    Object.defineProperty(t, "TaskListItemChildrenProps", {
      enumerable: !0,
      get: function get() {
        return o.TaskListItemChildrenProps;
      }
    }), Object.defineProperty(t, "TaskListItemProps", {
      enumerable: !0,
      get: function get() {
        return o.TaskListItemProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListBaseItem = void 0;
    var r = n(250);
    Object.defineProperty(t, "TaskListBaseItem", {
      enumerable: !0,
      get: function get() {
        return r.TaskListBaseItem;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r49,
      o = this && this.__extends || (_r49 = function r(e, t) {
        return (_r49 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r49(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || a(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.TaskListBaseItem = void 0;
    var l = n(1),
      c = n(15),
      u = n(563);
    s(n(251), t);
    var p = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        return l.createElement(t.Connected, i({}, this.props));
      }, n.displayName = "TaskListBaseItem", n;
    }(l.PureComponent);
    t.TaskListBaseItem = p, t.Connected = c.withTaskContext(u.TaskListBaseItemImpl);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconAreaContainer = t.FirstLineContainer = t.SecondLineStyledTemplate = t.SecondLineContainer = t.ActionsContainer = t.LowerArea = t.Content = t.UpperArea = t.Container = t.TaskListIcon = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d,
      f,
      h = n(0),
      m = n(2);
    t.TaskListIcon = m.default(h.Icon)(o || (o = r(["\n    flex: 0 0 44px;\n    ", "\n"], ["\n    flex: 0 0 44px;\n    ", "\n"])), function (e) {
      return e.theme.TaskList.Item.Icon;
    }), t.Container = m.default("div")(i || (i = r(["\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: ", ";\n    user-select: none;\n    height: 44px;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    overflow-y: hidden;\n    cursor: pointer;\n    height: ", ";\n\n    ", "\n    ", "\n    ", "\n    ", "\n    & .Twilio-TaskListBaseItem-IconAreaContainer {\n        background: ", ";\n    };\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-TaskListBaseItem-IconAreaContainer, & .Twilio-Badge-OuterCircle {\n            ", ";\n            }\n        }"], ["\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: ", ";\n    user-select: none;\n    height: 44px;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    overflow-y: hidden;\n    cursor: pointer;\n    height: ", ";\n\n    ", "\n    ", "\n    ", "\n    ", "\n    & .Twilio-TaskListBaseItem-IconAreaContainer {\n        background: ", ";\n    };\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-TaskListBaseItem-IconAreaContainer, & .Twilio-Badge-OuterCircle {\n            ", ";\n            }\n        }"])), function (e) {
      return e.vertical ? "column" : "row";
    }, function (e) {
      return e.large ? "200px" : "44px";
    }, function (e) {
      return e.theme.TaskList.Item.Container;
    }, function (e) {
      return e.selected ? e.theme.TaskList.Item.SelectedContainer : {};
    }, function (e) {
      return h.getBackgroundWithHoverCSS(e.theme.TaskList.Item.Container.background, e.theme.TaskList.Item.Container.lightHover);
    }, function (e) {
      return e.selected ? h.getBackgroundWithHoverCSS(e.theme.TaskList.Item.SelectedContainer.background, e.theme.TaskList.Item.SelectedContainer.lightHover) : {};
    }, function (e) {
      return e.iconColor;
    }, function (e) {
      return e.iconColor && h.getBackgroundWithHoverCSS(e.iconColor, !1, !0);
    }), t.UpperArea = m.default("div")(a || (a = r(["\n    height: 44px;\n    display: flex;\n    flex: auto 0 0;\n"], ["\n    height: 44px;\n    display: flex;\n    flex: auto 0 0;\n"]))), t.Content = m.default("div")(s || (s = r(["\n    flex: 1 1 auto;\n    overflow: hidden;\n"], ["\n    flex: 1 1 auto;\n    overflow: hidden;\n"]))), t.LowerArea = m.default("div")(l || (l = r(["\n    display: flex;\n    height: 156px;\n\n    p {\n        overflow-y: hidden;\n        text-overflow: ellipsis;\n    }\n\n    div {\n        width: 100%;\n        height: 100%;\n    }\n\n    iframe {\n        width: 100%;\n        height: 100%;\n    }\n"], ["\n    display: flex;\n    height: 156px;\n\n    p {\n        overflow-y: hidden;\n        text-overflow: ellipsis;\n    }\n\n    div {\n        width: 100%;\n        height: 100%;\n    }\n\n    iframe {\n        width: 100%;\n        height: 100%;\n    }\n"]))), t.ActionsContainer = m.default("div")(c || (c = r(["\n    height: 44px;\n    flex: 0 0 auto;\n    display: flex;\n    margin-right: 8px;\n\n    button {\n        margin-left: 4px;\n        margin-right: 4px;\n    }\n"], ["\n    height: 44px;\n    flex: 0 0 auto;\n    display: flex;\n    margin-right: 8px;\n\n    button {\n        margin-left: 4px;\n        margin-right: 4px;\n    }\n"]))), t.SecondLineContainer = m.default("div")(u || (u = r(["\n    font-size: 10px;\n    margin: 1px 4px 4px 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    font-size: 10px;\n    margin: 1px 4px 4px 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.SecondLineStyledTemplate = m.default(h.Template)(p || (p = r(["\n    display: inline-flex;\n    align-items: center;\n    .Twilio-Template-Icon {\n        margin-right: 4px;\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n    .Twilio-Template-Icon {\n        margin-right: 4px;\n    }\n"]))), t.FirstLineContainer = m.default("div")(d || (d = r(["\n    font-size: 12px;\n    font-weight: bold;\n    margin: 4px 4px 0px 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    font-size: 12px;\n    font-weight: bold;\n    margin: 4px 4px 0px 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.IconAreaContainer = m.default("div")(f || (f = r(["\n    position: relative;\n    flex: 0 0 44px;\n    display: flex;\n"], ["\n    position: relative;\n    flex: 0 0 44px;\n    display: flex;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListButtons = void 0;
    var r = n(564);
    Object.defineProperty(t, "TaskListButtons", {
      enumerable: !0,
      get: function get() {
        return r.TaskListButtons;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SplitterOrientation = t.AgentDesktopViewChildrenProps = t.AgentDesktopViewProps = t.AgentDesktopView = void 0;
    var r = n(576);
    Object.defineProperty(t, "AgentDesktopView", {
      enumerable: !0,
      get: function get() {
        return r.AgentDesktopView;
      }
    }), Object.defineProperty(t, "AgentDesktopViewProps", {
      enumerable: !0,
      get: function get() {
        return r.AgentDesktopViewProps;
      }
    }), Object.defineProperty(t, "AgentDesktopViewChildrenProps", {
      enumerable: !0,
      get: function get() {
        return r.AgentDesktopViewChildrenProps;
      }
    });
    var o = n(255);
    Object.defineProperty(t, "SplitterOrientation", {
      enumerable: !0,
      get: function get() {
        return o.SplitterOrientation;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Panel1 = void 0;
    var r = n(255);
    Object.defineProperty(t, "Panel1", {
      enumerable: !0,
      get: function get() {
        return r.Panel1;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r50,
      o = this && this.__extends || (_r50 = function r(e, t) {
        return (_r50 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r50(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Panel1 = t.SplitterOrientation = void 0;
    var s,
      l = n(1),
      c = n(0),
      u = n(3),
      p = n(28),
      d = n(256),
      f = n(240),
      h = n(239),
      m = n(257),
      g = n(594),
      y = n(597),
      v = n(6);
    !function (e) {
      e.auto = "auto", e.vertical = "vertical", e.horizontal = "horizontal";
    }(s = t.SplitterOrientation || (t.SplitterOrientation = {}));
    var b = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleResize = function (e) {
          setTimeout(function () {
            t.forceUpdate();
          }, 0);
        }, t.handleParentSplitterChange = function () {
          setTimeout(function () {
            t.forceUpdate();
          }, 0);
        }, t.handleSelectedViewChanged = function (e, n) {
          n || setTimeout(function () {
            t.forceUpdate();
          }, 0);
        }, t.makeInnerRef = function (e) {
          t.container = e;
        }, t.handleTaskSelected = function (e) {
          v.tryInvokeAction("SelectTask", {
            sid: e
          });
        }, t;
      }
      var n;
      return o(t, e), n = t, t.prototype.componentDidMount = function () {
        var e = this;
        u.FlexModule.events.addListener(p.FlexEvent.flexSplitterResize, this.handleParentSplitterChange), u.FlexModule.events.addListener(p.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), u.FlexModule.events.addListener(p.FlexEvent.viewResized, this.handleResize), this.timeout = setTimeout(function () {
          return e.forceUpdate();
        }, 1);
      }, t.prototype.componentWillUnmount = function () {
        u.FlexModule.events.removeListener(p.FlexEvent.flexSplitterResize, this.handleParentSplitterChange), u.FlexModule.events.removeListener(p.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), u.FlexModule.events.removeListener(p.FlexEvent.viewResized, this.handleResize), clearTimeout(this.timeout);
      }, t.prototype.render = function () {
        var e = !0;
        switch (this.props.splitterOrientation) {
          case s.auto:
            if (this.container) e = this.container.getBoundingClientRect().width < 552;
            break;
          default:
            e = this.props.splitterOrientation === s.vertical;
        }
        return l.createElement(c.DynamicComponent, {
          name: n.friendlyName,
          contentStore: n.Content,
          childProps: this.props,
          customChildren: this.props.children,
          vertical: !0
        }, l.createElement(y.LeftPanelRootContainer, i({}, this.props, {
          innerRef: this.makeInnerRef
        }), this.props.tasks.size > 0 ? l.createElement(g.ContentSplitter, {
          key: "splitter",
          vertical: e
        }, l.createElement(d.TaskListContainer, {
          tasks: this.props.tasks,
          selectedTaskSid: this.props.selectedTaskSid,
          onTaskSelected: this.handleTaskSelected
        }), l.createElement(f.TaskCanvas, {
          key: "taskCanvas"
        })) : l.createElement(h.NoTasksCanvas, {
          key: "no-tasks"
        }), l.createElement(m.WorkerDirectory, {
          key: "worker-directory"
        })));
      }, t.friendlyName = "AgentDesktopView.Panel1", t.displayName = n.friendlyName, t.Content = new c.DynamicContentStore(n.friendlyName), t.defaultProps = {
        splitterOrientation: s.auto
      }, t = n = a([c.withDefaultPropsUpdate], t);
    }(l.Component);
    t.Panel1 = b;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListContainerProps = t.TaskListContainer = void 0;
    var r = n(577);
    Object.defineProperty(t, "TaskListContainer", {
      enumerable: !0,
      get: function get() {
        return r.TaskListContainer;
      }
    }), Object.defineProperty(t, "TaskListContainerProps", {
      enumerable: !0,
      get: function get() {
        return r.TaskListContainerProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerDirectoryTabs = t.WorkerDirectoryTabsProps = t.WorkerDirectoryChildrenProps = t.WorkerDirectoryProps = t.WorkerDirectory = void 0;
    var r = n(580);
    Object.defineProperty(t, "WorkerDirectory", {
      enumerable: !0,
      get: function get() {
        return r.WorkerDirectory;
      }
    }), Object.defineProperty(t, "WorkerDirectoryProps", {
      enumerable: !0,
      get: function get() {
        return r.WorkerDirectoryProps;
      }
    }), Object.defineProperty(t, "WorkerDirectoryChildrenProps", {
      enumerable: !0,
      get: function get() {
        return r.WorkerDirectoryChildrenProps;
      }
    });
    var o = n(593);
    Object.defineProperty(t, "WorkerDirectoryTabsProps", {
      enumerable: !0,
      get: function get() {
        return o.WorkerDirectoryTabsProps;
      }
    });
    var i = n(151);
    Object.defineProperty(t, "WorkerDirectoryTabs", {
      enumerable: !0,
      get: function get() {
        return i.WorkerDirectoryTabs;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Panel2 = void 0;
    var r = n(598);
    Object.defineProperty(t, "Panel2", {
      enumerable: !0,
      get: function get() {
        return r.Panel2;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CRMContainerChildrenProps = t.CRMContainerProps = t.CRMContainer = void 0;
    var r = n(599);
    Object.defineProperty(t, "CRMContainer", {
      enumerable: !0,
      get: function get() {
        return r.CRMContainer;
      }
    }), Object.defineProperty(t, "CRMContainerProps", {
      enumerable: !0,
      get: function get() {
        return r.CRMContainerProps;
      }
    }), Object.defineProperty(t, "CRMContainerChildrenProps", {
      enumerable: !0,
      get: function get() {
        return r.CRMContainerChildrenProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(2);
    t.Container = i.default("div")(o || (o = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n    border-style: solid;\n    border-width: 0 0 0 1px;\n    ", "\n\n    iframe {\n        border: none;\n        display: flex;\n        flex: 1 0 auto;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n    border-style: solid;\n    border-width: 0 0 0 1px;\n    ", "\n\n    iframe {\n        border: none;\n        display: flex;\n        flex: 1 0 auto;\n    }\n"])), function (e) {
      return e.theme.CRMContainer.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoadingContainer = t.LoginButton = t.ControlsContainer = t.LogoContainer = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c = n(0),
      u = n(2);
    t.Container = u.default("div")(o || (o = r(["\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 0 auto;\n    justify-content: center;\n    ", "\n"], ["\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 0 auto;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.LoginView.Container;
    }), t.LogoContainer = u.default("div")(i || (i = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.LoginView.Logo;
    }), t.ControlsContainer = u.default("div")(a || (a = r(["\n    margin-top: 29px;\n    text-align: center;\n"], ["\n    margin-top: 29px;\n    text-align: center;\n"]))), t.LoginButton = u.default(c.Button)(s || (s = r(["\n    margin-top: 28px;\n    padding-left: 16px;\n    padding-right: 16px;\n"], ["\n    margin-top: 28px;\n    padding-left: 16px;\n    padding-right: 16px;\n"]))), t.LoadingContainer = u.default("div")(l || (l = r(["\n    margin-top: 34px;\n    font-size: 12px;\n    font-weight: 600;\n"], ["\n    margin-top: 34px;\n    font-size: 12px;\n    font-weight: 600;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r51,
      o = this && this.__extends || (_r51 = function r(e, t) {
        return (_r51 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r51(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginFormView = void 0;
    var a = n(1),
      s = n(62),
      l = n(263),
      c = n(613),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(s.StorelessThemeProvider, {
            themeConf: {
              baseName: "BlueDarkTheme"
            }
          }, a.createElement(c.LoginFormViewImpl, i({}, this.props)));
        }, t.defaultProps = {
          userConfig: {},
          initialRuntimeDomain: l.parseRuntimeDomainFromPathName() || "",
          userLoggedOut: !1
        }, t;
      }(a.Component);
    t.LoginFormView = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getDestinationURLFromLocation = t.getUserParamsFromSearch = t.parseDestinationPathFromSearch = t.parseRuntimeDomainFromPathName = t.RUNTIME_DOMAIN_REGEXP = void 0;
    var r = n(34),
      o = /^\/?(login\/)?([^/]*)\/?/;
    function i() {
      var e = window.location.search || "";
      if (!e) return "/";
      var t = r.parse(e),
        n = Array.isArray(t.path) ? t.path[0] : t.path;
      return n ? (n.endsWith("/") || (n += "/"), n.startsWith("/") || (n = "/" + n), n) : "/";
    }
    function a() {
      var e = r.parse(window.location.search);
      return Array.isArray(e.path) ? e.path.shift() : "string" == typeof e.path && delete e.path, r.stringify(e);
    }
    t.RUNTIME_DOMAIN_REGEXP = /^([a-z]+-[a-z]+-\d+)$/, t.parseRuntimeDomainFromPathName = function () {
      var e = window.location.pathname.match(o),
        n = e && e[2],
        r = e && !!e[1];
      if (!n) return "";
      if (r) return n;
      var i = n.match(t.RUNTIME_DOMAIN_REGEXP);
      return i && i[1] ? i[1] : "";
    }, t.parseDestinationPathFromSearch = i, t.getUserParamsFromSearch = a, t.getDestinationURLFromLocation = function () {
      var e = i();
      "/" === e && ((e = window.location.pathname).endsWith("/") || (e += "/"));
      var t = a();
      return t && (t = "?" + t), "" + window.location.origin + e + t;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginLogo = void 0;
    var r = n(616);
    Object.defineProperty(t, "LoginLogo", {
      enumerable: !0,
      get: function get() {
        return r.LoginLogo;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FilterDefinitionFactory = t.TeamsView = void 0;
    var r = n(619);
    Object.defineProperty(t, "TeamsView", {
      enumerable: !0,
      get: function get() {
        return r.TeamsView;
      }
    }), Object.defineProperty(t, "FilterDefinitionFactory", {
      enumerable: !0,
      get: function get() {
        return r.FilterDefinitionFactory;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r52,
      o = this && this.__extends || (_r52 = function r(e, t) {
        return (_r52 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r52(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCardList = void 0;
    var i = n(0),
      a = n(1),
      s = n(267),
      l = n(268),
      c = n(270),
      u = function u(e, t) {
        var n = e.dateUpdated.getTime();
        return t.dateUpdated.getTime() - n;
      },
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            n = this.props,
            r = n.tasks,
            o = n.filter,
            u = n.compareFunction,
            p = Array.from(r).filter(function (e) {
              return !o || o(e);
            });
          return 0 === p.length ? a.createElement(c.TaskCardPlaceholder, null) : a.createElement(i.DynamicComponent, {
            contentStore: t.Content,
            childProps: this.props,
            name: t.displayName,
            customChildren: this.props.children,
            subContainer: a.createElement(i.FlexBox, {
              allowWrap: !0
            })
          }, a.createElement(i.FlexBox, {
            className: "Twilio-TaskCardList-Container"
          }, p.sort(u).map(function (t) {
            return a.createElement(s.SupervisorTaskContextSource, {
              taskSid: t.sid,
              key: t.sid
            }, a.createElement(l.TaskCard, {
              selected: e.props.selectedTaskSid === t.sid,
              highlighted: e.props.highlightedTaskSid === t.taskSid,
              onClick: e.props.onCardSelected
            }));
          })));
        }, t.displayName = "TaskCardList", t.Content = new i.DynamicContentStore(t.displayName), t.defaultProps = {
          compareFunction: u
        }, t;
      }(a.Component);
    t.TaskCardList = p;
  }, function (e, t, n) {
    "use strict";

    var _r53,
      o = this && this.__extends || (_r53 = function r(e, t) {
        return (_r53 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r53(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SupervisorTaskContextSource = void 0;
    var s = n(1),
      l = n(26),
      c = n(20),
      u = n(3),
      p = n(8),
      d = n(155),
      f = function f(e, t) {
        var n,
          r = d.SupervisorStateHelper.getTaskBySid(t.taskSid);
        return p.TaskHelper.isCallTask(r) && (n = e.conferences.states.get(r.taskSid)), {
          task: r,
          conference: n,
          chatChannel: r && p.TaskHelper.isChatBasedTask(r) ? e.chat.channels[p.TaskHelper.getTaskChatChannelSid(r)] : void 0
        };
      },
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.children,
            n = a(e, ["children"]);
          return n.channelDefinition = n.task ? c.TaskChannels.getForTask(n.task) : void 0, s.createElement(l.TaskContext.Provider, {
            value: n
          }, t);
        }, t = i([u.connect(f)], t);
      }(s.PureComponent);
    t.SupervisorTaskContextSource = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCardChildrenProps = t.TaskCardProps = t.TaskCard = void 0;
    var r = n(269);
    Object.defineProperty(t, "TaskCard", {
      enumerable: !0,
      get: function get() {
        return r.TaskCard;
      }
    });
    var o = n(626);
    Object.defineProperty(t, "TaskCardProps", {
      enumerable: !0,
      get: function get() {
        return o.TaskCardProps;
      }
    }), Object.defineProperty(t, "TaskCardChildrenProps", {
      enumerable: !0,
      get: function get() {
        return o.TaskCardChildrenProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r54,
      o = this && this.__extends || (_r54 = function r(e, t) {
        return (_r54 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r54(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.TaskCard = void 0;
    var a = n(1),
      s = n(15),
      l = n(625),
      c = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.displayName = l.displayName, n.Content = l.contentStore, n;
      }(a.PureComponent);
    t.TaskCard = c, t.Connected = s.withTaskContext(l.TaskCardImpl);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCardPlaceholder = t.StyledButton = t.IconContainer = t.Content = t.FirstLineContainer = t.SecondLineContainer = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p = n(2),
      d = n(0);
    t.Container = p.default("div")(o || (o = r(["\n    display: flex;\n    height: 38px;\n    width: 132px;\n    overflow-y: hidden;\n    margin-top: 6px;\n    margin-bottom: 6px;\n    margin-left: 6px;\n    margin-right: 6px;\n\n    &:first-child {\n        margin-left: 0px;\n    }\n\n    border-radius: 2px;\n    border-style: solid;\n    cursor: pointer;\n    border-width: 1px;\n    ", "\n    ", "\n    & .Twilio-TaskCard-IconContainer {\n        background: ", ";\n        color: ", ";\n    }\n    & .Twilio-TaskCard-Content {\n        ", ";\n    }\n    &:hover {\n        ", "\n        & .Twilio-TaskCard-IconContainer {\n            ", ";\n        }\n        & .Twilio-TaskCard-Content {\n            ", ";\n        }\n    }\n"], ["\n    display: flex;\n    height: 38px;\n    width: 132px;\n    overflow-y: hidden;\n    margin-top: 6px;\n    margin-bottom: 6px;\n    margin-left: 6px;\n    margin-right: 6px;\n\n    &:first-child {\n        margin-left: 0px;\n    }\n\n    border-radius: 2px;\n    border-style: solid;\n    cursor: pointer;\n    border-width: 1px;\n    ", "\n    ", "\n    & .Twilio-TaskCard-IconContainer {\n        background: ", ";\n        color: ", ";\n    }\n    & .Twilio-TaskCard-Content {\n        ", ";\n    }\n    &:hover {\n        ", "\n        & .Twilio-TaskCard-IconContainer {\n            ", ";\n        }\n        & .Twilio-TaskCard-Content {\n            ", ";\n        }\n    }\n"])), function (e) {
      return e.theme.TaskCard.Container.Default;
    }, function (e) {
      return e.selected ? e.theme.TaskCard.Container.Selected : {};
    }, function (e) {
      return e.iconAreaStyleOverride.backgroundColor;
    }, function (e) {
      return e.iconAreaStyleOverride.color;
    }, function (e) {
      return e.contentAreaStyleOverride;
    }, function (e) {
      return e.theme.TaskCard.Container.Hover;
    }, function (e) {
      return d.getBackgroundWithHoverCSS(e.iconAreaStyleOverride.backgroundColor, e.theme.TaskCard.Container.Default.lightHover, !0);
    }, function (e) {
      return d.getBackgroundWithHoverCSS(e.contentAreaStyleOverride.backgroundColor, e.theme.TaskCard.Container.Default.lightHover, !0);
    }), t.SecondLineContainer = p.default("div")(i || (i = r(["\n    font-size: 10px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-bottom: 4px;\n    text-align: left;\n"], ["\n    font-size: 10px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-bottom: 4px;\n    text-align: left;\n"]))), t.FirstLineContainer = p.default("div")(a || (a = r(["\n    font-size: 10px;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-top: 4px;\n    text-align: left;\n"], ["\n    font-size: 10px;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-top: 4px;\n    text-align: left;\n"]))), t.Content = p.default("div")(s || (s = r(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    padding-left: 8px;\n    padding-right: 8px;\n    flex: 1 1 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    padding-left: 8px;\n    padding-right: 8px;\n    flex: 1 1 100%;\n"]))), t.IconContainer = p.default(d.Icon)(l || (l = r(["\n    flex: 0 0 36px;\n"], ["\n    flex: 0 0 36px;\n"]))), t.StyledButton = p.default("button")(c || (c = r(["\n    padding: 0;\n    display: flex;\n    color: inherit;\n    outline: none;\n    background: none;\n    border: none;\n    font-family: inherit;\n    svg {\n        margin: auto;\n    }\n"], ["\n    padding: 0;\n    display: flex;\n    color: inherit;\n    outline: none;\n    background: none;\n    border: none;\n    font-family: inherit;\n    svg {\n        margin: auto;\n    }\n"]))), t.TaskCardPlaceholder = p.default("div")(u || (u = r(["\n    height: 38px;\n    width: 132px;\n    margin: 6px 6px 6px 0;\n    border-radius: 2px;\n    border-style: solid;\n    border-width: 1px;\n    ", "\n    ", "\n"], ["\n    height: 38px;\n    width: 132px;\n    margin: 6px 6px 6px 0;\n    border-radius: 2px;\n    border-style: solid;\n    border-width: 1px;\n    ", "\n    ", "\n"])), function (e) {
      return "\n        background: repeating-linear-gradient(\n            127deg,\n            " + e.theme.colors.base2 + ",\n            " + e.theme.colors.base2 + " 3px,\n            " + e.theme.colors.base1 + " 3px,\n            " + e.theme.colors.base1 + " 6px\n        );\n    ";
    }, function (e) {
      return e.theme.TaskCardPlaceholder;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerCanvasProps = t.WorkerCanvas = void 0;
    var r = n(631);
    Object.defineProperty(t, "WorkerCanvas", {
      enumerable: !0,
      get: function get() {
        return r.WorkerCanvas;
      }
    }), Object.defineProperty(t, "WorkerCanvasProps", {
      enumerable: !0,
      get: function get() {
        return r.WorkerCanvasProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerProfile = void 0;
    var r = n(634);
    Object.defineProperty(t, "WorkerProfile", {
      enumerable: !0,
      get: function get() {
        return r.WorkerProfile;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerSkills = void 0;
    var r = n(637);
    Object.defineProperty(t, "WorkerSkills", {
      enumerable: !0,
      get: function get() {
        return r.WorkerSkills;
      }
    });
  }, function (e, t) {
    e.exports = require("@material-ui/core/FormHelperText");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesStatsView = void 0, o(n(276), t);
    var i = n(661);
    Object.defineProperty(t, "QueuesStatsView", {
      enumerable: !0,
      get: function get() {
        return i.FullscreenableQueuesStatsView;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r55,
      o = this && this.__extends || (_r55 = function r(e, t) {
        return (_r55 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r55(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesStatsViewComponent = void 0;
    var a = n(1),
      s = n(3),
      l = n(136),
      c = n(657),
      u = s.connect(function (e) {
        var t = e.realtimeQueues,
          n = t.queuesList && !Object.keys(t.queuesList).length;
        return {
          isLoading: n && !t.hasFetchedList,
          hasNoData: n && t.hasFetchedList,
          error: t.error
        };
      })(c.QueuesStatsViewImpl),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(u, i({}, this.props));
        }, t.displayName = c.displayName, t.Content = c.Content, t.Tiles = l.AggregatedQueuesDataTiles, t.Table = l.QueuesDataTable, t;
      }(a.PureComponent);
    t.QueuesStatsViewComponent = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCardListProps = t.TaskCardList = void 0, o(n(268), t);
    var i = n(266);
    Object.defineProperty(t, "TaskCardList", {
      enumerable: !0,
      get: function get() {
        return i.TaskCardList;
      }
    }), Object.defineProperty(t, "TaskCardListProps", {
      enumerable: !0,
      get: function get() {
        return i.TaskCardListProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RootContainerChildrenProps = t.RootContainer = void 0;
    var r = n(671);
    Object.defineProperty(t, "RootContainer", {
      enumerable: !0,
      get: function get() {
        return r.RootContainer;
      }
    });
    var o = n(753);
    Object.defineProperty(t, "RootContainerChildrenProps", {
      enumerable: !0,
      get: function get() {
        return o.RootContainerChildrenProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r56,
      o = this && this.__extends || (_r56 = function r(e, t) {
        return (_r56 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r56(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MainContainer = void 0;
    var s = n(1),
      l = n(0),
      c = n(3),
      u = n(674),
      p = n(2),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
          return s.createElement(f, i({}, this.props));
        }, t.displayName = u.displayName, t.Content = u.contentStore, t.defaultProps = {
          keepSideNavOpen: !1,
          showNotificationBar: !0,
          showLiveCommsBar: !0
        }, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.MainContainer = d;
    var f = c.connect(function (e) {
      return {
        activeView: e.view.activeView,
        showOutboundDialer: e.view.isOutboundDialerOpen
      };
    })(p.withTheme(u.MainContainerImpl));
  }, function (e, t, n) {
    "use strict";

    var _r57,
      o = this && this.__extends || (_r57 = function r(e, t) {
        return (_r57 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r57(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.OpenInNewWindowBtn = void 0;
    var a = n(1),
      s = n(0),
      l = n(34),
      c = n(6),
      u = n(4),
      p = n(18),
      d = n(38),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onClick = function () {
            var e;
            c.tryInvokeAction("InsightsPlayer:hide");
            var n,
              r,
              o = t.props.mediaLink;
            if (o) switch (o.type) {
              case p.InsightsPlayerMediaLinkType.ChatTranscript:
                n = p.InsightsPlayerMediaLinkType.ChatTranscript, r = o.sid;
                break;
              case p.InsightsPlayerMediaLinkType.EmailTranscript:
                n = p.InsightsPlayerMediaLinkType.EmailTranscript, r = o.conversation_sid;
                break;
              case p.InsightsPlayerMediaLinkType.Embedded:
                n = p.InsightsPlayerMediaLinkType.Embedded, r = o.url;
                break;
              case p.InsightsPlayerMediaLinkType.Referenced:
                n = p.InsightsPlayerMediaLinkType.Referenced, r = o.url;
            }
            var a = i({
                timeFrom: t.props.player && t.props.player.getCurrentTime(),
                mediaLinkType: n,
                mediaLinkId: r
              }, (null === (e = t.props.player) || void 0 === e ? void 0 : e.isPlaying()) && {
                autoplay: !0
              }),
              s = d.getLastVisitedDashboard();
            s && (a.dashboardId = s), c.tryInvokeAction("HistoryPush", "/segments/" + t.props.segmentId + "?" + l.stringify(a));
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(s.IconButton, {
            "data-test": "InsightsPlayer-OpenInNewWindow",
            icon: "OpenInNewWindow",
            title: u.templates.OpenInNewWindow(),
            sizeMultiplier: .75,
            onClick: this.onClick
          });
        }, t;
      }(a.PureComponent);
    t.OpenInNewWindowBtn = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CloseButton = t.WrapperSidebar = t.WrapperPlayer = void 0;
    var o,
      i,
      a,
      s = n(0);
    t.WrapperPlayer = s.styled("div")(o || (o = r(["\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 180px;\n    background: #fff;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.35);\n    z-index: 10;\n    background: ", ";\n    border-top: 1px solid ", ";\n    color: ", ";\n"], ["\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 180px;\n    background: #fff;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.35);\n    z-index: 10;\n    background: ", ";\n    border-top: 1px solid ", ";\n    color: ", ";\n"])), function (e) {
      return e.theme.colors.base1;
    }, function (e) {
      return e.theme.colors.base3;
    }, function (e) {
      return e.theme.calculated.textColor;
    }), t.WrapperSidebar = s.styled("div")(i || (i = r(["\n    display: flex;\n    padding: 0 17px;\n    flex-direction: column;\n    flex: 1 1 auto;\n"], ["\n    display: flex;\n    padding: 0 17px;\n    flex-direction: column;\n    flex: 1 1 auto;\n"]))), t.CloseButton = s.styled("div")(a || (a = r(["\n    position: absolute;\n    top: 3px;\n    right: 4px;\n    font-size: 32px;\n    line-height: 32px;\n    color: #969696;\n    outline: none;\n    padding: 0 5px;\n    cursor: pointer;\n"], ["\n    position: absolute;\n    top: 3px;\n    right: 4px;\n    font-size: 32px;\n    line-height: 32px;\n    color: #969696;\n    outline: none;\n    padding: 0 5px;\n    cursor: pointer;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsBarItemActionsProps = t.LiveCommsBarItemActions = t.LiveCommsBarItemAction = t.LiveCommsBarItem = t.LiveCommsBarChildrenProps = t.LiveCommsBar = void 0;
    var r = n(698);
    Object.defineProperty(t, "LiveCommsBar", {
      enumerable: !0,
      get: function get() {
        return r.LiveCommsBar;
      }
    }), Object.defineProperty(t, "LiveCommsBarChildrenProps", {
      enumerable: !0,
      get: function get() {
        return r.LiveCommsBarChildrenProps;
      }
    });
    var o = n(283);
    Object.defineProperty(t, "LiveCommsBarItem", {
      enumerable: !0,
      get: function get() {
        return o.LiveCommsBarItem;
      }
    });
    var i = n(284);
    Object.defineProperty(t, "LiveCommsBarItemAction", {
      enumerable: !0,
      get: function get() {
        return i.LiveCommsBarItemAction;
      }
    }), Object.defineProperty(t, "LiveCommsBarItemActions", {
      enumerable: !0,
      get: function get() {
        return i.LiveCommsBarItemActions;
      }
    }), Object.defineProperty(t, "LiveCommsBarItemActionsProps", {
      enumerable: !0,
      get: function get() {
        return i.LiveCommsBarItemActionsProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsBarItem = void 0;
    var r = n(701);
    Object.defineProperty(t, "LiveCommsBarItem", {
      enumerable: !0,
      get: function get() {
        return r.LiveCommsBarItem;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsBarItemActionsProps = t.LiveCommsBarItemActions = t.LiveCommsBarItemAction = void 0;
    var r = n(706);
    Object.defineProperty(t, "LiveCommsBarItemAction", {
      enumerable: !0,
      get: function get() {
        return r.LiveCommsBarItemAction;
      }
    }), Object.defineProperty(t, "LiveCommsBarItemActions", {
      enumerable: !0,
      get: function get() {
        return r.LiveCommsBarItemActions;
      }
    }), Object.defineProperty(t, "LiveCommsBarItemActionsProps", {
      enumerable: !0,
      get: function get() {
        return r.LiveCommsBarItemActionsProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r58,
      o = this && this.__extends || (_r58 = function r(e, t) {
        return (_r58 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r58(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.OutboundDialerPanel = void 0;
    var a = n(1),
      s = n(3),
      l = n(23),
      c = n(2),
      u = n(708),
      p = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.displayName = u.displayName, n.Content = u.contentStore, n;
      }(a.PureComponent);
    t.OutboundDialerPanel = p, t.Connected = c.withTheme(s.connect(function (e) {
      return {
        worker: e.worker,
        hasIncomingCallReservation: l.StateHelper.hasPendingCall()
      };
    })(u.OutboundDialerPanelImpl));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorIcon = t.ErrorMessage = t.CallAnimation = t.CallControls = t.StyledSelect = t.CallButton = t.Caption = t.OfflineContainer = t.DialerContainer = t.Container = t.StyledSidePanel = void 0;
    var o = n(1),
      i = n(59),
      a = n(0),
      s = n(2);
    t.StyledSidePanel = s.default(a.SidePanel)(l || (l = r(["\n    width: 276px;\n"], ["\n    width: 276px;\n"]))), t.Container = s.default("div")(c || (c = r(["\n    display: flex;\n    position: absolute;\n    height: 100%;\n    right: 0px;\n    z-index: 10;\n"], ["\n    display: flex;\n    position: absolute;\n    height: 100%;\n    right: 0px;\n    z-index: 10;\n"]))), t.DialerContainer = s.default("div")(u || (u = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 276px;\n    padding: 0 11px;\n    box-sizing: border-box;\n    ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 276px;\n    padding: 0 11px;\n    box-sizing: border-box;\n    ", ";\n"])), function (e) {
      var t = e.disabled,
        n = e.theme;
      return t && n.OutboundDialerPanel.Container.disabled;
    }), t.OfflineContainer = s.default("div")(p || (p = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 276px;\n    padding: 0 11px 80px;\n    box-sizing: border-box;\n    flex-grow: 1;\n    text-align: center;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 276px;\n    padding: 0 11px 80px;\n    box-sizing: border-box;\n    flex-grow: 1;\n    text-align: center;\n"]))), t.Caption = s.default("label")(d || (d = r(["\n    display: block;\n    text-transform: uppercase;\n    font-size: 10px;\n    line-height: 1.6;\n    letter-spacing: 2px;\n    margin-top: 16px;\n    margin-bottom: 8px;\n    width: 100%;\n"], ["\n    display: block;\n    text-transform: uppercase;\n    font-size: 10px;\n    line-height: 1.6;\n    letter-spacing: 2px;\n    margin-top: 16px;\n    margin-bottom: 8px;\n    width: 100%;\n"]))), t.CallButton = s.default(a.IconButton)(f || (f = r(["\n    box-sizing: content-box;\n    padding: 8px;\n    ", ";\n    ", ";\n    ", ";\n"], ["\n    box-sizing: content-box;\n    padding: 8px;\n    ", ";\n    ", ";\n    ", ";\n"])), function (e) {
      return e.theme.Dialer.CallButton;
    }, function (e) {
      return e.disabled && e.theme.Dialer.CallButton.disabled;
    }, function (e) {
      return a.getBackgroundWithHoverCSS(e.theme.Dialer.CallButton.backgroundColor, e.theme.Dialer.CallButton.lightHover, !1, e.disabled);
    }), t.StyledSelect = s.default(i.default)(h || (h = r(["\n    width: 252px;\n"], ["\n    width: 252px;\n"]))), t.CallControls = s.default("div")(m || (m = r(["\n    position: relative;\n    margin-top: 24px;\n"], ["\n    position: relative;\n    margin-top: 24px;\n"]))), t.CallAnimation = s.default("div")(g || (g = r(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"]))), t.ErrorMessage = s.default("div")(y || (y = r(["\n    margin-top: 16px;\n    text-align: center;\n    ", "\n"], ["\n    margin-top: 16px;\n    text-align: center;\n    ", "\n"])), function (e) {
      return "color: " + e.theme.colors.errorColor + ";";
    });
    var l, c, u, p, d, f, h, m, g, y;
    t.ErrorIcon = function (e) {
      return o.createElement("svg", {
        width: "64px",
        height: "64px",
        viewBox: "0 0 64 64",
        version: "1.1"
      }, o.createElement("g", {
        id: "icn-nodialpad",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("g", {
        id: "Group",
        transform: "translate(13.000000, 10.000000)",
        fill: "currentcolor",
        fillRule: "nonzero"
      }, o.createElement("path", {
        d: "M40.2393529,0.577227648 C40.4217651,0.741472373 40.457097,1.0073275 40.3350858,1.20610476 L40.2819361,1.27717249 L1.46120874,44.3919581 C1.27951301,44.5937517 0.965860889,44.6075477 0.760647112,44.4227724 C0.578234866,44.2585276 0.542903019,43.9926725 0.664914216,43.7938952 L0.718063914,43.7228275 L39.5387913,0.608041884 C39.720487,0.406248337 40.0341391,0.392452334 40.2393529,0.577227648 Z M18.5,37 C19.8807119,37 21,38.1192881 21,39.5 C21,40.8254834 19.9684641,41.9100387 18.6643757,41.9946823 L18.5,42 C17.1192881,42 16,40.8807119 16,39.5 C16,38.1745166 17.0315359,37.0899613 18.3356243,37.0053177 L18.5,37 Z M18.5,38 C17.6715729,38 17,38.6715729 17,39.5 C17,40.3284271 17.6715729,41 18.5,41 C19.3284271,41 20,40.3284271 20,39.5 C20,38.6715729 19.3284271,38 18.5,38 Z M3.5,25 C4.88071187,25 6,26.1192881 6,27.5 C6,28.8254834 4.96846406,29.9100387 3.66437569,29.9946823 L3.5,30 C2.11928813,30 1,28.8807119 1,27.5 C1,26.1745166 2.03153594,25.0899613 3.33562431,25.0053177 L3.5,25 Z M21,27.5 C21,28.8254834 19.9684641,29.9100387 18.6643757,29.9946823 L18.5,30 C17.7272816,30 17.0364439,29.6494271 16.577861,29.0986556 L17.258901,28.3426832 C17.5288069,28.7394275 17.9839734,29 18.5,29 C19.3284271,29 20,28.3284271 20,27.5 C20,26.927513 19.6792876,26.4299325 19.2077278,26.1771232 L19.8890896,25.4211202 C20.5589691,25.8696169 21,26.6333043 21,27.5 Z M33.5,25 C34.8807119,25 36,26.1192881 36,27.5 C36,28.8254834 34.9684641,29.9100387 33.6643757,29.9946823 L33.5,30 C32.1192881,30 31,28.8807119 31,27.5 C31,26.1745166 32.0315359,25.0899613 33.3356243,25.0053177 L33.5,25 Z M3.5,26 C2.67157288,26 2,26.6715729 2,27.5 C2,28.3284271 2.67157288,29 3.5,29 C4.32842712,29 5,28.3284271 5,27.5 C5,26.6715729 4.32842712,26 3.5,26 Z M33.5,26 C32.6715729,26 32,26.6715729 32,27.5 C32,28.3284271 32.6715729,29 33.5,29 C34.3284271,29 35,28.3284271 35,27.5 C35,26.6715729 34.3284271,26 33.5,26 Z M3.5,14 C4.88071187,14 6,15.1192881 6,16.5 C6,17.8254834 4.96846406,18.9100387 3.66437569,18.9946823 L3.5,19 C2.11928813,19 1,17.8807119 1,16.5 C1,15.1745166 2.03153594,14.0899613 3.33562431,14.0053177 L3.5,14 Z M18.5,14 C19.8807119,14 21,15.1192881 21,16.5 C21,17.8254834 19.9684641,18.9100387 18.6643757,18.9946823 L18.5,19 C17.1192881,19 16,17.8807119 16,16.5 C16,15.1745166 17.0315359,14.0899613 18.3356243,14.0053177 L18.5,14 Z M33.5,14 C34.8807119,14 36,15.1192881 36,16.5 C36,17.8254834 34.9684641,18.9100387 33.6643757,18.9946823 L33.5,19 C32.1192881,19 31,17.8807119 31,16.5 C31,15.1745166 32.0315359,14.0899613 33.3356243,14.0053177 L33.5,14 Z M3.5,15 C2.67157288,15 2,15.6715729 2,16.5 C2,17.3284271 2.67157288,18 3.5,18 C4.32842712,18 5,17.3284271 5,16.5 C5,15.6715729 4.32842712,15 3.5,15 Z M18.5,15 C17.6715729,15 17,15.6715729 17,16.5 C17,17.3284271 17.6715729,18 18.5,18 C19.3284271,18 20,17.3284271 20,16.5 C20,15.6715729 19.3284271,15 18.5,15 Z M33.5,15 C32.6715729,15 32,15.6715729 32,16.5 C32,17.3284271 32.6715729,18 33.5,18 C34.3284271,18 35,17.3284271 35,16.5 C35,15.6715729 34.3284271,15 33.5,15 Z M3.5,2 C4.88071187,2 6,3.11928813 6,4.5 C6,5.8254834 4.96846406,6.91003867 3.66437569,6.99468232 L3.5,7 C2.11928813,7 1,5.88071187 1,4.5 C1,3.1745166 2.03153594,2.08996133 3.33562431,2.00531768 L3.5,2 Z M18.5,2 C19.8807119,2 21,3.11928813 21,4.5 C21,5.8254834 19.9684641,6.91003867 18.6643757,6.99468232 L18.5,7 C17.1192881,7 16,5.88071187 16,4.5 C16,3.1745166 17.0315359,2.08996133 18.3356243,2.00531768 L18.5,2 Z M33.5,2 C34.4672987,2 35.3062876,2.54935997 35.7219874,3.35310076 L34.9680567,4.19060837 C34.8254692,3.51062085 34.2223655,3 33.5,3 C32.6715729,3 32,3.67157288 32,4.5 C32,5.27624002 32.5896259,5.91476552 33.3454347,5.99213342 L32.5915533,6.82982407 C31.6599959,6.46632258 31,5.56023644 31,4.5 C31,3.1745166 32.0315359,2.08996133 33.3356243,2.00531768 L33.5,2 Z M3.5,3 C2.67157288,3 2,3.67157288 2,4.5 C2,5.32842712 2.67157288,6 3.5,6 C4.32842712,6 5,5.32842712 5,4.5 C5,3.67157288 4.32842712,3 3.5,3 Z M18.5,3 C17.6715729,3 17,3.67157288 17,4.5 C17,5.32842712 17.6715729,6 18.5,6 C19.3284271,6 20,5.32842712 20,4.5 C20,3.67157288 19.3284271,3 18.5,3 Z",
        id: "Combined-Shape"
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkProps = t.SideLink = t.SideNavChildrenProps = t.SideNavProps = t.SideNav = void 0;
    var r = n(712);
    Object.defineProperty(t, "SideNav", {
      enumerable: !0,
      get: function get() {
        return r.SideNav;
      }
    }), Object.defineProperty(t, "SideNavProps", {
      enumerable: !0,
      get: function get() {
        return r.SideNavProps;
      }
    }), Object.defineProperty(t, "SideNavChildrenProps", {
      enumerable: !0,
      get: function get() {
        return r.SideNavChildrenProps;
      }
    });
    var o = n(80);
    Object.defineProperty(t, "SideLink", {
      enumerable: !0,
      get: function get() {
        return o.SideLink;
      }
    }), Object.defineProperty(t, "SideLinkProps", {
      enumerable: !0,
      get: function get() {
        return o.SideLinkProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkAgentDesktop = void 0;
    var r = n(715);
    Object.defineProperty(t, "SideLinkAgentDesktop", {
      enumerable: !0,
      get: function get() {
        return r.SideLinkAgentDesktop;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkTeams = void 0;
    var r = n(720);
    Object.defineProperty(t, "SideLinkTeams", {
      enumerable: !0,
      get: function get() {
        return r.SideLinkTeams;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkQueuesStats = void 0;
    var r = n(721);
    Object.defineProperty(t, "SideLinkQueuesStats", {
      enumerable: !0,
      get: function get() {
        return r.SideLinkQueuesStats;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ViewMountRule = t.ViewProps = t.View = t.ViewAdditionalProps = t.ViewCollectionChildrenProps = t.ViewCollectionProps = t.ViewCollection = void 0;
    var r = n(736);
    Object.defineProperty(t, "ViewCollection", {
      enumerable: !0,
      get: function get() {
        return r.ViewCollection;
      }
    }), Object.defineProperty(t, "ViewCollectionProps", {
      enumerable: !0,
      get: function get() {
        return r.ViewCollectionProps;
      }
    }), Object.defineProperty(t, "ViewCollectionChildrenProps", {
      enumerable: !0,
      get: function get() {
        return r.ViewCollectionChildrenProps;
      }
    }), Object.defineProperty(t, "ViewAdditionalProps", {
      enumerable: !0,
      get: function get() {
        return r.ViewAdditionalProps;
      }
    });
    var o = n(292);
    Object.defineProperty(t, "View", {
      enumerable: !0,
      get: function get() {
        return o.View;
      }
    }), Object.defineProperty(t, "ViewProps", {
      enumerable: !0,
      get: function get() {
        return o.ViewProps;
      }
    }), Object.defineProperty(t, "ViewMountRule", {
      enumerable: !0,
      get: function get() {
        return o.ViewMountRule;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ViewImpl = t.ViewMountRule = t.ViewProps = t.ViewFC = t.View = void 0;
    var r = n(738);
    Object.defineProperty(t, "View", {
      enumerable: !0,
      get: function get() {
        return r.View;
      }
    }), Object.defineProperty(t, "ViewFC", {
      enumerable: !0,
      get: function get() {
        return r.ViewFC;
      }
    }), Object.defineProperty(t, "ViewProps", {
      enumerable: !0,
      get: function get() {
        return r.ViewProps;
      }
    }), Object.defineProperty(t, "ViewMountRule", {
      enumerable: !0,
      get: function get() {
        return r.ViewMountRule;
      }
    });
    var o = n(739);
    Object.defineProperty(t, "ViewImpl", {
      enumerable: !0,
      get: function get() {
        return o.ViewImpl;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledAcceptButton = t.StyledRejectButton = t.StyledDialogContentText = t.StyledDialogContent = t.StyledDialogActions = t.StyledDialogTitle = t.StyledFlexBox = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p = n(741),
      d = n(742),
      f = n(743),
      h = n(0),
      m = n(2);
    t.StyledFlexBox = m.default(h.FlexBox)(o || (o = r(["\n    position: relative;\n    ", "\n"], ["\n    position: relative;\n    ", "\n"])), function (e) {
      return e.theme.MainContainer;
    }), t.StyledDialogTitle = m.default("div")(i || (i = r(["\n    padding: 16px 16px 0 16px;\n    font-size: 20px;\n    font-weight: bold;\n"], ["\n    padding: 16px 16px 0 16px;\n    font-size: 20px;\n    font-weight: bold;\n"]))), t.StyledDialogActions = m.default(p.default)(a || (a = r(["\n    padding: 0 16px 20px 16px;\n    margin: 0;\n"], ["\n    padding: 0 16px 20px 16px;\n    margin: 0;\n"]))), t.StyledDialogContent = m.default(d.default)(s || (s = r(["\n    padding: 16px 16px 20px 16px;\n    width: 400px;\n"], ["\n    padding: 16px 16px 20px 16px;\n    width: 400px;\n"]))), t.StyledDialogContentText = m.default(f.default)(l || (l = r(["\n    font-size: 14px;\n"], ["\n    font-size: 14px;\n"]))), t.StyledRejectButton = m.default(h.Button)(c || (c = r(["\n    text-transform: uppercase;\n    border: 1px solid ", ";\n"], ["\n    text-transform: uppercase;\n    border: 1px solid ", ";\n"])), function (e) {
      return e.theme.colors.base6;
    }), t.StyledAcceptButton = m.default(h.Button)(u || (u = r(["\n    background: ", ";\n    color: ", ";\n    text-transform: uppercase;\n    ", "\n"], ["\n    background: ", ";\n    color: ", ";\n    text-transform: uppercase;\n    ", "\n"])), function (e) {
      return e.theme.colors.declineColor;
    }, function (e) {
      return e.theme.colors.declineTextColor;
    }, function (e) {
      return h.getBackgroundWithHoverCSS(e.theme.colors.declineColor, e.theme.MainHeader.Button.lightHover);
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n(296), n(297), n(298), o(n(81), t);
  }, function (e, t) {
    e.exports = require("core-js/features/symbol");
  }, function (e, t) {
    e.exports = require("core-js/features/symbol/iterator");
  }, function (e, t) {
    e.exports = require("core-js/features/object/assign");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    n(7);
    t.default = function () {
      0;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatListener = void 0;
    var r = n(0),
      o = n(5),
      i = n(8),
      a = n(164);
    function s(e) {
      r.ChatChannelState.Actions.unload(e.sid);
    }
    var l = function () {
      function e() {}
      return e.init = function (e) {
        e.addListener("channelJoined", this.handleChannelJoined), e.addListener("channelLeft", this.handleChannelLeft), e.addListener("channelRemoved", this.handleChannelRemoved);
      }, e.handleChannelJoined = function (e) {
        var t = i.TaskHelper.getTaskFromChannelSid(e.sid);
        t ? (o.log.debug("channel joined, loading", e.sid), a.loadTaskChatChannel(t)) : o.log.warn("Task for chat channel does not exist - not loading yet", e.sid);
      }, e.handleChannelLeft = function (e) {
        return o.log.debug("handleChannelLeft for channel", e.sid), s(e);
      }, e.handleChannelRemoved = function (e) {
        return o.log.debug("handleChannelRemoved for channel", e.sid), s(e);
      }, e;
    }();
    t.ChatListener = l;
  }, function (e, t, n) {
    "use strict";

    var _r59,
      o = this && this.__extends || (_r59 = function r(e, t) {
        return (_r59 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r59(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ClassProxySpy = void 0;
    var i = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.stopped = !1, n.methods = t.methods || [], n;
      }
      return o(t, e), t.prototype.start = function () {
        var e = this,
          t = this.trigger,
          n = this.methods,
          r = this.targetAlias,
          o = {
            get: function get(o, i) {
              var a = o[i];
              return e.stopped || n.length && n.indexOf(i) < 0 || "function" != typeof a ? a : function () {
                for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
                var s = a.apply(o, e);
                return t({
                  target: o,
                  args: e,
                  result: s,
                  targetAlias: r,
                  subject: i,
                  timestamp: Date.now()
                }), s;
              };
            }
          };
        this.onStart && this.onStart(new Proxy(this.target, o));
      }, t.prototype.stop = function () {
        this.stopped = !0;
      }, t;
    }(n(67).Spy);
    t.ClassProxySpy = i;
  }, function (e, t, n) {
    "use strict";

    var _r60,
      o = this && this.__extends || (_r60 = function r(e, t) {
        return (_r60 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r60(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EventEmitterSpy = void 0;
    var i = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        if (n.events = t.events, !n.events) throw Error("EventEmitterSpy requires some events to listen to.");
        return n;
      }
      return o(t, e), t.prototype.start = function () {
        var e = this;
        this.events.forEach(function (t) {
          e.target.addListener(t, e.trigger);
        }), this.onStart && this.onStart();
      }, t.prototype.stop = function () {
        var e = this;
        this.events.forEach(function (t) {
          e.target.removeListener(t, e.trigger);
        });
      }, t;
    }(n(67).Spy);
    t.EventEmitterSpy = i;
  }, function (e, t, n) {
    "use strict";

    var _r61,
      o = this && this.__extends || (_r61 = function r(e, t) {
        return (_r61 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r61(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DOMEventsSpy = void 0;
    var i = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        if (n.applyMiddleware = function (e) {
          n.trigger({
            targetAlias: n.targetAlias || "Window event listener",
            args: [e.message + " in " + e.filename + " at " + e.lineno + ":" + e.colno],
            subject: "Error Event",
            result: "",
            timestamp: Date.now()
          });
        }, n.events = t.events, !n.events) throw Error("DOMEventsSpy requires some events to listen to.");
        return n;
      }
      return o(t, e), t.prototype.start = function () {
        var e = this;
        this.events.forEach(function (t) {
          e.target.addEventListener(t, e.applyMiddleware);
        }), this.onStart && this.onStart();
      }, t.prototype.stop = function () {
        var e = this;
        this.events.forEach(function (t) {
          e.target.removeEventListener(t, e.applyMiddleware);
        });
      }, t;
    }(n(67).Spy);
    t.DOMEventsSpy = i;
  }, function (e, t, n) {
    "use strict";

    var _r62,
      o = this && this.__extends || (_r62 = function r(e, t) {
        return (_r62 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r62(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoglevelSpy = void 0;
    var i = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.stopped = !1, n.methods = t.methods || [], n;
      }
      return o(t, e), t.prototype.start = function () {
        var e = this,
          t = this.target,
          n = this.targetAlias,
          r = this.trigger,
          o = this.methods,
          i = t.methodFactory;
        t.methodFactory = function (a, s, l) {
          var c = i(a, s, l);
          return o.indexOf(a) < 0 ? c : function () {
            for (var o = [], i = 0; i < arguments.length; i++) o[i] = arguments[i];
            var s = c.apply(t, o);
            return e.stopped || r({
              target: t,
              args: o,
              result: s,
              targetAlias: n,
              subject: a,
              timestamp: Date.now()
            }), s;
          };
        }, t.setLevel(t.getLevel()), this.onStart && this.onStart(t);
      }, t.prototype.stop = function () {
        this.stopped = !0;
      }, t;
    }(n(67).Spy);
    t.LoglevelSpy = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getFormatter = t.PredefinedFormatters = void 0;
    var r,
      o = n(306);
    !function (e) {
      e.String = "String";
    }(r = t.PredefinedFormatters || (t.PredefinedFormatters = {}));
    t.getFormatter = function (e) {
      var t = e.type,
        n = e.maxLineLength;
      if (t === r.String) return o.getStringFormatter({
        maxLineLength: n
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getStringFormatter = void 0;
    var i = n(109);
    t.getStringFormatter = function (e) {
      return function (t) {
        var n, a;
        return t.reduce((n = function n(e, t) {
          return e.subject === t.subject && JSON.stringify(e.args) === JSON.stringify(t.args);
        }, a = {}, function (e, t, i, s) {
          if (!e.length) return [t];
          var l = e,
            c = e.length - 1,
            u = e[c];
          return n(u, t) ? a[c] ? a[c]++ : a[c] = 1 : l = o(e, [t]), i === s.length - 1 && (l = l.map(function (e, t) {
            var n = a[t];
            return n ? r(r({}, e), {
              repeats: n
            }) : e;
          })), l;
        }), []).map(function (e) {
          return function (t) {
            var n = t.timestamp,
              r = t.subject,
              o = t.args,
              a = t.repeats;
            return [new Date(n).toLocaleTimeString(), r, Array.isArray(o) ? i.stringifyArguments(o).map(i.cutLong(void 0 !== e.maxLineLength ? e.maxLineLength : 100)).join(" ") : o, a ? "(repeats " + a + " more " + (a > 1 ? "times" : "time") + ")" : ""].reduce(function (e, t) {
              return t ? e ? e + " | " + t : t : e;
            }, "");
          };
        }(e)).join("\n");
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getStorage = t.PredefinedStorages = t.Storage = void 0;
    var r,
      o = n(308),
      i = n(309),
      a = n(110);
    Object.defineProperty(t, "Storage", {
      enumerable: !0,
      get: function get() {
        return a.Storage;
      }
    }), function (e) {
      e.LocalStorage = "LocalStorage", e.MemoryStorage = "MemoryStorage";
    }(r = t.PredefinedStorages || (t.PredefinedStorages = {}));
    t.getStorage = function (e) {
      switch (e.type) {
        case r.LocalStorage:
          return new o.LocalStorage(e);
        case r.MemoryStorage:
          return new i.MemoryStorage(e);
        default:
          return;
      }
    };
  }, function (e, t, n) {
    "use strict";

    var _r63,
      o = this && this.__extends || (_r63 = function r(e, t) {
        return (_r63 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r63(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LocalStorage = void 0;
    var i = n(110),
      a = n(109),
      s = n(83),
      l = function (e) {
        function t(t) {
          var n = e.call(this) || this;
          return n.maxLocalStorageSize = 4e3, n.cache = [], n.localStorageKey = "FLEX_LOG_CONTENT_" + t.identifier, n.cache = n.get(), n.set = s(n.set.bind(n), 1e3, {
            maxWait: 100
          }), n;
        }
        return o(t, e), t.calculateUsedSpace = function (e) {
          return Number((new Blob([e]).size / 1024).toFixed());
        }, t.prototype.set = function (e, n) {
          for (var r = a.stringify(this.cache), o = 0; t.calculateUsedSpace(r) >= this.getMaxLocalStorageSize() && o < 10;) this.cache = this.truncate(this.cache), r = a.stringify(this.cache), o++;
          t.calculateUsedSpace(r) >= this.getMaxLocalStorageSize() ? n(Error("The object you're trying to store is too big. The maximum allowed size is\n                    " + this.getMaxLocalStorageSize() / 1024 + "Mb")) : (window.localStorage.setItem(this.localStorageKey, r), e(this.get()));
        }, t.prototype.truncate = function (e) {
          var t = Math.floor(e.length / 2);
          return e.slice(t, e.length);
        }, t.prototype.setMaxLocalStorageSize = function (e) {
          this.maxLocalStorageSize = e;
        }, t.prototype.getMaxLocalStorageSize = function () {
          return this.maxLocalStorageSize;
        }, t.prototype.add = function (e) {
          return this.cache.push(e), new Promise(this.set);
        }, t.prototype.get = function () {
          var e = window.localStorage.getItem(this.localStorageKey) || "[]";
          return JSON.parse(e);
        }, t.prototype.clear = function () {
          return this.cache = [], new Promise(this.set);
        }, t;
      }(i.Storage);
    t.LocalStorage = l;
  }, function (e, t, n) {
    "use strict";

    var _r64,
      o = this && this.__extends || (_r64 = function r(e, t) {
        return (_r64 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r64(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      l = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MemoryStorage = void 0;
    var c = n(110),
      u = n(109),
      p = n(83),
      d = function (e) {
        function t(t) {
          var n = e.call(this) || this;
          return n.maxMemoryStorageSize = 2e3, n.cache = [], n.memorisedLogs = [], n.cacheSize = 0, n.extendedLogs = !1, n.extendedLogs = t.extendedLogs, n.maxLineLength = t.maxLineLength || 1e3, n.set = p(n.set.bind(n), 1e3, {
            maxWait: 100
          }), n;
        }
        return o(t, e), t.calculateUsedSpace = function (e) {
          return Number(new Blob([e]).size.toFixed());
        }, t.prototype.set = function () {
          return a(this, void 0, Promise, function () {
            var e, t, n;
            return s(this, function (r) {
              for (e = 0, t = this.cache, n = this.cacheSize; n >= this.getMaxMemoryStorageSize() && e < 10;) t = this.cache.slice(Math.floor(this.cache.length / 2)), n = this.getCacheSize(t), e++;
              if (n >= this.getMaxMemoryStorageSize()) throw Error("The object you're trying to store is too big. The maximum allowed size is\n                    " + this.getMaxMemoryStorageSize() / 1024 + "Mb");
              return this.cache = t, this.cacheSize = n, this.memorisedLogs = l(t), [2, this.get()];
            });
          });
        }, t.prototype.setMaxMemoryStorageSize = function (e) {
          this.maxMemoryStorageSize = e;
        }, t.prototype.getMaxMemoryStorageSize = function () {
          return this.maxMemoryStorageSize;
        }, t.prototype.add = function (e) {
          var n = this.extendedLogs ? e.target : {},
            r = this.extendedLogs ? e.args : u.stringifyArguments(e.args).map(u.cutLong(this.maxLineLength)),
            o = i(i({}, e), {
              target: n,
              args: r
            }),
            a = t.calculateUsedSpace(u.stringify(o)) / 1024;
          return this.cache.push(i(i({}, o), {
            size: a
          })), this.cacheSize += a, this.set();
        }, t.prototype.get = function () {
          return this.memorisedLogs;
        }, t.prototype.clear = function () {
          this.cache = [], this.memorisedLogs = [], this.cacheSize = 0;
        }, t.prototype.getCacheSize = function (e) {
          return e.reduce(function (e, t) {
            return e + t.size;
          }, 0);
        }, t;
      }(c.Storage);
    t.MemoryStorage = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getTransport = t.PredefinedTransports = t.Transport = void 0;
    var r = n(111);
    Object.defineProperty(t, "Transport", {
      enumerable: !0,
      get: function get() {
        return r.Transport;
      }
    });
    var o,
      i = n(311),
      a = n(312);
    !function (e) {
      e.File = "File", e.ReturnToCode = "ReturnToCode";
    }(o = t.PredefinedTransports || (t.PredefinedTransports = {}));
    t.getTransport = function (e) {
      switch (e.type) {
        case o.File:
          return new i.DownloadableFile();
        case o.ReturnToCode:
          return new a.ReturnToCode();
        default:
          return;
      }
    };
  }, function (e, t, n) {
    "use strict";

    var _r65,
      o = this && this.__extends || (_r65 = function r(e, t) {
        return (_r65 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r65(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DownloadableFile = void 0;
    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.flush = function (e) {
        var t = this.getAnchorTag(),
          n = new Blob([e], {
            type: "octet/stream"
          }),
          r = window.URL.createObjectURL(n);
        t.href = r, t.download = new Date().toISOString() + ".txt", t.click(), window.URL.revokeObjectURL(r);
      }, t.prototype.getAnchorTag = function () {
        return this.anchorElement ? this.anchorElement : (this.anchorElement = document.createElement("a"), document.body.appendChild(this.anchorElement), this.anchorElement.style.display = "none", this.anchorElement);
      }, t;
    }(n(111).Transport);
    t.DownloadableFile = i;
  }, function (e, t, n) {
    "use strict";

    var _r66,
      o = this && this.__extends || (_r66 = function r(e, t) {
        return (_r66 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r66(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ReturnToCode = void 0;
    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.flush = function (e) {
        return e;
      }, t;
    }(n(111).Transport);
    t.ReturnToCode = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createChatTaskChannel = t.ChatEmail = t.ChatSms = t.ChatWhatsApp = t.ChatLine = t.ChatMessenger = t.Chat = void 0;
    var o = n(0),
      i = n(112),
      a = n(52),
      s = n(84),
      l = n(115),
      c = n(6),
      u = n(114),
      p = n(8),
      d = {
        Pending: "TaskLineQueue",
        Accepted: "TaskLineChatAssigned",
        Wrapping: "TaskLineChatAssigned"
      };
    function f(e, t, n, f, h, m, g, y, v, b, C, _, k) {
      void 0 === n && (n = "Message"), void 0 === f && (f = "MessageBold"), void 0 === h && (h = s.defaultChannelColors.chat), void 0 === m && (m = "TaskLineChatReserved"), void 0 === g && (g = 32768), void 0 === y && (y = "TaskHeaderStatusAccepted"), void 0 === v && (v = "TaskLineChatAssigned"), void 0 === b && (b = "IncomingChatNotificationTitle"), void 0 === C && (C = "IncomingChatBrowserNotificationTitle"), void 0 === _ && (_ = "IncomingChatBrowserNotificationBody"), void 0 === k && (k = "TaskTabHeaderChat");
      var w = {
          IncomingTask: {
            content: b,
            type: o.NotificationType.information,
            timeout: 0,
            icon: "Message",
            actions: u.incomingTaskNotificationActions,
            options: {
              browser: {
                title: C,
                body: _,
                onClick: function onClick(e, t) {
                  c.tryInvokeAction("SelectTask", {
                    task: e.context.task
                  });
                },
                options: {
                  requireInteraction: !0
                }
              }
            }
          }
        },
        S = r(r({}, d), {
          Pending: m,
          Accepted: v
        });
      return o.Utils.merge(i.Default, {
        name: e,
        isApplicable: t,
        charLimit: g,
        capabilities: new Set([a.TaskChannelCapability.Chat, a.TaskChannelCapability.Info, a.TaskChannelCapability.Wrapup]),
        colors: {
          main: {
            Accepted: h,
            Pending: h,
            Reserved: h,
            Assigned: h
          }
        },
        icons: {
          list: {
            Pending: f,
            Accepted: f,
            Canceled: n,
            Wrapping: n,
            Completed: n,
            Reserved: f,
            Assigned: f
          },
          active: f,
          main: n
        },
        templates: {
          IncomingTaskCanvas: {
            secondLine: d,
            titleLine: {
              Pending: m
            }
          },
          TaskListItem: {
            secondLine: S
          },
          TaskCanvasHeader: {
            secondLine: {
              Pending: "TaskHeaderStatusPending",
              Accepted: y,
              Wrapping: "TaskHeaderStatusWrapup",
              Completed: "TaskHeaderStatusCompleted"
            },
            endButton: {
              Assigned: "TaskHeaderEndChat",
              Accepted: "TaskHeaderEndChat",
              Wrapping: "TaskHeaderComplete"
            }
          },
          TaskCanvasTabs: {
            contentTabHeader: k
          },
          Supervisor: {
            TaskCanvasHeader: {
              secondLine: {
                Pending: "TaskHeaderStatusPending",
                Accepted: y,
                Wrapping: "TaskHeaderStatusWrapup",
                Completed: "TaskHeaderStatusCompleted"
              }
            }
          }
        },
        componentProps: {
          TaskListItem: {
            Badge: {
              children: function children(e, t) {
                return new l.AppStateHelper(e).getUnconsumedMessagesCountForTask(t.task);
              },
              variant: function variant(e, t) {
                var n = new p.TaskHelper(t.task);
                if (new l.AppStateHelper(e).getUnconsumedMessagesCountForTask(t.task)) return o.Badge.variants.standard;
                var r = n.chat && n.chat.lastMessage;
                return r && r.error ? o.Badge.variants.danger : o.Badge.variants.standard;
              }
            }
          }
        },
        notifications: {
          override: w
        }
      });
    }
    t.Chat = f("chat", function (e) {
      return "chat" === e.taskChannelUniqueName;
    }, "Message", "MessageBold", s.defaultChannelColors.chat, void 0, void 0, "TaskHeaderWebChatStatusAccepted", "TaskLineWebChatAssigned"), t.ChatMessenger = f("chat-messenger", function (e) {
      return t.Chat.isApplicable(e) && ("facebook" === e.channelType || "messenger" === e.channelType);
    }, "Facebook", "FacebookBold", s.defaultChannelColors.facebook, "TaskLineChatMessengerReserved", 4e3, void 0, void 0, "IncomingMessengerNotificationTitle", "IncomingMessengerBrowserNotificationTitle"), t.ChatMessenger.templates.TaskCanvasTabs.contentTabHeader = "TaskTabHeaderMessenger", t.ChatLine = f("chat-line", function (e) {
      return t.Chat.isApplicable(e) && "line" === e.channelType;
    }, "Line", "LineBold", s.defaultChannelColors.line, "TaskLineChatLineReserved", 4e3, void 0, void 0, "IncomingLineNotificationTitle", "IncomingLineBrowserNotificationTitle"), t.ChatMessenger.templates.TaskCanvasTabs.contentTabHeader = "TaskTabHeaderLine", t.ChatWhatsApp = f("chat-whatsapp", function (e) {
      return t.Chat.isApplicable(e) && "whatsapp" === e.channelType;
    }, "Whatsapp", "WhatsappBold", s.defaultChannelColors.whatsapp, "TaskLineChatWhatsAppReserved", 4e3, void 0, void 0, "IncomingWhatsAppNotificationTitle", "IncomingWhatsAppBrowserNotificationTitle"), t.ChatMessenger.templates.TaskCanvasTabs.contentTabHeader = "TaskTabHeaderWhatsApp", t.ChatSms = f("chat-sms", function (e) {
      return "sms" === e.taskChannelUniqueName || t.Chat.isApplicable(e) && "sms" === e.channelType;
    }, "Sms", "SmsBold", s.defaultChannelColors.sms, "TaskLineSmsReserved", 1600, void 0, void 0, "IncomingSmsNotificationTitle", "IncomingSmsBrowserNotificationTitle"), t.ChatMessenger.templates.TaskCanvasTabs.contentTabHeader = "TaskTabHeaderSMS", t.ChatEmail = f("chat-email", function (e) {
      return t.Chat.isApplicable(e) && "email" === e.channelType;
    }, "Email", "EmailBold", "#380E78", "TaskLineEmailReserved", 3200, void 0, void 0, "IncomingEmailNotificationTitle", "IncomingEmailBrowserNotificationTitle", "IncomingEmailBrowserNotificationBody", "TaskTabHeaderEmail"), t.createChatTaskChannel = f;
  }, function (e, t, n) {
    "use strict";

    var _r67,
      o = this && this.__extends || (_r67 = function r(e, t) {
        return (_r67 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r67(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorEventDelegate = void 0;
    var l = n(0),
      c = n(5),
      u = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.errorMap = {
            user: "warning",
            normal: "error",
            severe: "fatal"
          }, t;
        }
        return o(t, e), t.prototype.getErrorSeverity = function (e) {
          return e ? this.errorMap[e] : "warning";
        }, t.prototype.getSchemaName = function () {
          return "error-v1";
        }, t.prototype.getEventName = function () {
          return "ui-error";
        }, t.prototype.report = function (e) {
          return a(this, void 0, Promise, function () {
            var t;
            return s(this, function (n) {
              switch (n.label) {
                case 0:
                  if (!this.eventGroup) return [2];
                  n.label = 1;
                case 1:
                  return n.trys.push([1, 3,, 4]), [4, this.eventGroup.addErrorEvent(i({
                    eventName: this.getEventName()
                  }, e))];
                case 2:
                  return n.sent(), [3, 4];
                case 3:
                  return t = n.sent(), c.log.error("FlexSDK: Can't report a \"" + this.getEventName() + '" event', t), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, t.prototype.format = function (e) {
          var t, n, r;
          return {
            eventName: this.getEventName(),
            eventSource: "flex-ui",
            error: {
              source: e.content.type,
              wrappedErrorMessage: null === (t = e.content.wrappedError) || void 0 === t ? void 0 : t.message,
              wrappedErrorCode: void 0,
              plugin: null === (n = e.content.plugin) || void 0 === n ? void 0 : n.name,
              pluginVersion: null === (r = e.content.plugin) || void 0 === r ? void 0 : r.version,
              module: void 0,
              message: e.message,
              description: e.content.description,
              stackTrace: e.stack,
              code: 45600,
              reporter: "flex-ui",
              debugger: !0,
              severity: this.getErrorSeverity(e.content.severity),
              resourceSid: void 0,
              unhandled: void 0
            }
          };
        }, t;
      }(l.AbstractTelemetryEventsDelegate);
    t.ErrorEventDelegate = u;
  }, function (e, t, n) {
    "use strict";

    var _r68,
      o = this && this.__extends || (_r68 = function r(e, t) {
        return (_r68 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r68(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ProgrammabilityEventsDelegate = void 0;
    var l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.events = [], t.currentOptions = {}, t.eventGroupEnabled = !0, t;
      }
      return o(t, e), t.prototype.getSchemaName = function () {
        return "flex-ui-programmability-v1";
      }, t.prototype.getEventName = function () {
        return "ui-programmability";
      }, t.prototype.report = function (t) {
        return a(this, void 0, void 0, function () {
          return s(this, function (n) {
            switch (n.label) {
              case 0:
                return this.eventGroupEnabled ? (this.events.push(t), [2]) : [4, e.prototype.report.call(this, t)];
              case 1:
                return n.sent(), [2];
            }
          });
        });
      }, t.prototype.stopProgrammabilityGrouping = function () {
        this.eventGroupEnabled = !1, this.groupReport(this.events);
      }, t.prototype.format = function (e) {
        var t = {};
        if (e.options) {
          var n = i({}, e.options);
          this.currentOptions && (n = i(i({}, n), this.currentOptions)), Object.keys(n).forEach(function (e) {
            var r = n[e];
            t[e] = r instanceof Function ? "(function)" : String(n[e]);
          });
        }
        return {
          plugin: e.pluginName || this.currentPlugin || "",
          plugin_version: e.pluginVersion || this.currentPluginVersion || "",
          call_type: e.callType,
          name: e.name,
          command: e.command,
          listenee: e.listenee || "",
          options_map: t
        };
      }, t;
    }(n(0).AbstractTelemetryEventsDelegate);
    t.ProgrammabilityEventsDelegate = l;
  }, function (e, t, n) {
    "use strict";

    var _r69,
      o = this && this.__extends || (_r69 = function r(e, t) {
        return (_r69 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r69(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SessionStartEventDelegate = void 0;
    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.getSchemaName = function () {
        return "flex-ui-session-start-v1";
      }, t.prototype.getEventName = function () {
        return "ui-session-start";
      }, t.prototype.format = function (e) {
        return {
          enabled_features: e.enabledFeatureFlags,
          plugins_loaded: e.plugins.map(function (e) {
            return {
              name: e.name || "",
              version: e.version || ""
            };
          }),
          config: JSON.stringify(e.config) || "",
          flex_version: e.flexVersion,
          react_version: window.React.version,
          bundling_type: "library",
          is_iframed: window.self !== window.top,
          screen_height: window.screen.height,
          screen_width: window.screen.width
        };
      }, t;
    }(n(0).AbstractTelemetryEventsDelegate);
    t.SessionStartEventDelegate = i;
  }, function (e, t, n) {
    "use strict";

    var _r70,
      o = this && this.__extends || (_r70 = function r(e, t) {
        return (_r70 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r70(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UIInteractionEventsDelegate = void 0;
    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.getSchemaName = function () {
        return "flex-ui-interaction-v1";
      }, t.prototype.getEventName = function () {
        return "ui-interaction";
      }, t.prototype.format = function (e) {
        var t = e.name,
          n = e.status,
          r = e.category,
          o = void 0 === r ? "" : r,
          i = e.details,
          a = void 0 === i ? {} : i;
        return {
          interaction_name: t,
          interaction_status: n,
          interaction_category: o,
          interaction_duration_ms: e.duration,
          interaction_details_map: a
        };
      }, t;
    }(n(0).AbstractTelemetryEventsDelegate);
    t.UIInteractionEventsDelegate = i;
  }, function (e, t, n) {
    "use strict";

    var _r71,
      o = this && this.__extends || (_r71 = function r(e, t) {
        return (_r71 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r71(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TelemetryWrapper = void 0;
    var a = n(1),
      s = n(166),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.report = function (e, t) {
          var n = this.props,
            r = n.name,
            o = n.category;
          s.TelemetryManager.reportUIInteractionEvent({
            name: r,
            status: t ? "complete" : "start",
            category: o,
            details: i({}, e),
            duration: t
          });
        }, t.prototype.componentDidMount = function () {
          var e = this.props,
            t = e.data,
            n = e.details;
          t && !this.startTime && (this.report(n), this.startTime = new Date().getTime());
        }, t.prototype.componentDidUpdate = function (e) {
          this.props.data !== e.data && (this.startTime && this.report(e.details, new Date().getTime() - this.startTime), this.props.data && (this.report(this.props.details), this.startTime = new Date().getTime()));
        }, t.prototype.componentWillUnmount = function () {
          var e = this.props,
            t = e.data,
            n = e.details;
          t && this.startTime && this.report(n, new Date().getTime() - this.startTime);
        }, t.prototype.render = function () {
          return this.props.children;
        }, t;
      }(a.Component);
    t.TelemetryWrapper = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.initialState = void 0;
    var o = n(3),
      i = n(10);
    t.initialState = {
      localOverrides: {},
      features: {}
    }, t.reduce = function (e, n) {
      var o;
      switch (void 0 === e && (e = t.initialState), n.type) {
        case i.FEATURE_FLAGS_UPDATE:
          var a = n.payload.reduce(function (e, t) {
            return e[t.id] = t, e;
          }, {});
          return r(r({}, e), {
            features: r(r({}, e.features), a)
          });
        case i.FEATURE_FLAGS_OVERRIDES_UPDATE:
          return r(r({}, e), {
            localOverrides: n.payload
          });
        case i.FEATURE_FLAG_OVERRIDE:
          return n.payload.id ? r(r({}, e), {
            localOverrides: r(r({}, e.localOverrides), (o = {}, o[n.payload.id] = n.payload, o))
          }) : e;
        default:
          return e;
      }
    };
    var a = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || o.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.setFeatures = function (t) {
        t && e.dispatcher({
          type: i.FEATURE_FLAGS_UPDATE,
          payload: t
        });
      }, e.setFeatureOverrides = function (t) {
        t && e.dispatcher({
          type: i.FEATURE_FLAGS_OVERRIDES_UPDATE,
          payload: t
        });
      }, e.overrideFeatureFlag = function (t) {
        t && e.dispatcher({
          type: i.FEATURE_FLAG_OVERRIDE,
          payload: t
        });
      }, e;
    }();
    t.Actions = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasHeader = t.TaskCanvasTabs = t.TaskInfoPanel = t.TaskCanvas = t.TaskOverviewCanvas = void 0;
    var i = n(170);
    Object.defineProperty(t, "TaskOverviewCanvas", {
      enumerable: !0,
      get: function get() {
        return i.TaskOverviewCanvas;
      }
    });
    var a = n(197);
    Object.defineProperty(t, "TaskCanvas", {
      enumerable: !0,
      get: function get() {
        return a.TaskCanvas;
      }
    }), Object.defineProperty(t, "TaskInfoPanel", {
      enumerable: !0,
      get: function get() {
        return a.TaskInfoPanel;
      }
    }), Object.defineProperty(t, "TaskCanvasTabs", {
      enumerable: !0,
      get: function get() {
        return a.TaskCanvasTabs;
      }
    }), Object.defineProperty(t, "TaskCanvasHeader", {
      enumerable: !0,
      get: function get() {
        return a.TaskCanvasHeader;
      }
    }), o(n(211), t);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SupervisorTaskOverviewActions = void 0;
    var r = n(322);
    Object.defineProperty(t, "SupervisorTaskOverviewActions", {
      enumerable: !0,
      get: function get() {
        return r.SupervisorTaskOverviewActions;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r72,
      o = this && this.__extends || (_r72 = function r(e, t) {
        return (_r72 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r72(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.SupervisorTaskOverviewActions = void 0;
    var a = n(3),
      s = n(1),
      l = n(323),
      c = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return s.createElement(t.Connected, i({}, this.props));
        }, n;
      }(s.Component);
    t.SupervisorTaskOverviewActions = c, t.Connected = a.connect(function (e) {
      return {
        monitoring: e.supervisor.callMonitoring
      };
    })(l.SupervisorTaskOverviewActionsImpl);
  }, function (e, t, n) {
    "use strict";

    var _r73,
      o = this && this.__extends || (_r73 = function r(e, t) {
        return (_r73 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r73(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SupervisorTaskOverviewActionsImpl = void 0;
    var a = n(1),
      s = n(0),
      l = n(8),
      c = n(3),
      u = n(36),
      p = n(4),
      d = n(2),
      f = n(6),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onMonitorClick = function () {
            var e = t.props,
              n = e.monitoring,
              r = e.task,
              o = !!n.task && n.status === u.CallMonitoringStatus.monitoring && r.sid === n.task.sid;
            n.status === u.CallMonitoringStatus.none ? f.tryInvokeAction("MonitorCall", {
              task: r
            }) : o && f.tryInvokeAction("StopMonitoringCall", {
              task: r
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.task,
            n = e.monitoring;
          if (!l.TaskHelper.isLiveCall(t)) return null;
          if (t.workerSid === c.FlexModule.workerClient.sid) return null;
          if (!t.conference) return null;
          var r = !!n.task && n.status === u.CallMonitoringStatus.monitoring && t.sid === n.task.sid,
            o = !!n.task && n.status === u.CallMonitoringStatus.monitoring && t.sid !== n.task.sid;
          return a.createElement(s.IconButton, {
            className: "Twilio-SupervisorTaskOverviewActions-MonitorButton",
            icon: r ? "MonitorOffLarge" : "MonitorBoldLarge",
            disabled: o || r && n.status === u.CallMonitoringStatus.waiting,
            onClick: this.onMonitorClick,
            themeOverride: r ? this.props.theme.Supervisor.TaskCanvas.MonitorActiveButton : this.props.theme.Supervisor.TaskCanvas.Button,
            title: p.templates.MonitorCallTooltip()
          });
        }, t = i([d.withTheme], t);
      }(a.Component);
    t.SupervisorTaskOverviewActionsImpl = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexClientManagerImpl = void 0;
    var s = n(0),
      l = n(325),
      c = n(363),
      u = n(107),
      p = n(364),
      d = n(7),
      f = n(3),
      h = n(5),
      m = n(10),
      g = n(87),
      y = n(175),
      v = n(24),
      b = n(126),
      C = n(39),
      _ = n(388),
      k = n(36),
      w = n(91),
      S = n(46),
      P = n(11),
      T = n(389),
      O = n(95),
      x = n(12),
      E = n(188),
      A = function () {
        function e() {
          var e = this;
          this.clientMap = new Map(), this.offline = !1, this.setClientOffline = function (t) {
            e.offline = !0;
          }, this.setClientOnline = function (t) {
            e.offline = !1;
          }, this.shutdownClients = function () {
            w.Actions.shutdown(), f.FlexModule.state.config.disableBrowserVoice || b.Actions.shutdown(), s.ChatSessionState.Actions.shutdown(), v.Actions.shutdown(), k.Actions.shutdown(), g.Actions.shutdown(), f.FlexModule.workerClient = void 0, f.FlexModule.chatClient = void 0, f.FlexModule.insightsClient = void 0, f.FlexModule.cbmClient = void 0, window.removeEventListener("offline", e.setClientOffline), window.removeEventListener("online", e.setClientOnline);
          }, window.addEventListener("offline", this.setClientOffline), window.addEventListener("online", this.setClientOnline);
        }
        return Object.defineProperty(e.prototype, "degradedMode", {
          get: function get() {
            return Array.from(this.clientMap.values()).some(function (e) {
              return e.degraded;
            });
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.setDegradedMode = function (e, t) {
          this.offline ? d.ErrorManager.createAndProcessError("Worker error intercepted", {
            type: d.FlexErrorType.app,
            context: "FlexClientManager - setDegradedMode",
            description: "Cannot set degraded mode while user is offline"
          }) : (this.clientMap.has(e) ? this.clientMap.set(e, r(r({}, this.clientMap.get(e)), {
            degraded: t
          })) : this.clientMap.set(e, {
            degraded: t
          }), !E.ClientManagerHelpers.isForcedDegraded() && t && d.ErrorManager.createAndProcessError("Degraded mode has been activated", {
            type: d.FlexErrorType.app,
            context: "FlexClientManager - setDegradedMode",
            description: "Degraded mode has been activated"
          }), C.Actions.updateDegradedMode());
        }, e.prototype.isDegraded = function (e) {
          var t;
          return this.clientMap.has(e) && !!(null === (t = this.clientMap.get(e)) || void 0 === t ? void 0 : t.degraded);
        }, e.prototype.init = function (e) {
          return o(this, void 0, Promise, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return n.trys.push([0, 2,, 3]), [4, this.initFlexSDK(e)];
                case 1:
                  return n.sent(), [3, 3];
                case 2:
                  return n.sent(), h.log.error("Flex SDK failed to initialize. Telemetry events won't be enabled for this session"), [3, 3];
                case 3:
                  return this.initCBMSDK(e), t = this.initTaskRouterSDK(e), [2, Promise.allSettled([t, this.initChatSDK(e, t), this.initSyncSDK(e), this.initVoiceSDK(e, t)])];
              }
            });
          });
        }, e.prototype.fetchFlexFeatures = function (e) {
          return o(this, void 0, Promise, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  if (n.trys.push([0, 2,, 3]), this.setDegradedMode(P.FeatureFlags, !1), E.ClientManagerHelpers.isForcedDegraded(E.ClientManagerInstance.FlexFeatures)) throw new Error("Flex Features is forced disabled. Failing initialisation");
                  return [4, T.fetchFlexFeatures(e)];
                case 1:
                  return n.sent(), [2, Promise.resolve()];
                case 2:
                  return t = n.sent(), this.setDegradedMode(P.FeatureFlags, !0), [2, Promise.reject(t)];
                case 3:
                  return [2];
              }
            });
          });
        }, e.prototype.initFlexPlugins = function (e, t) {
          return o(this, void 0, Promise, function () {
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  if (n.trys.push([0, 2,, 3]), this.setDegradedMode(O.Plugins, !1), E.ClientManagerHelpers.isForcedDegraded(E.ClientManagerInstance.PluginManager)) throw new Error("Flex Plugin Manager is forced disabled. Failing initialisation");
                  return [4, O.loadPlugins(e, t)];
                case 1:
                  return n.sent(), [3, 3];
                case 2:
                  return n.sent(), this.setDegradedMode(O.Plugins, !0), [3, 3];
                case 3:
                  return [2];
              }
            });
          });
        }, e.prototype.initCBMSDK = function (e) {
          var t;
          try {
            var n = new l.CbmSdk(e, (null === (t = f.FlexModule.state.config.sdkOptions) || void 0 === t ? void 0 : t.worker) || {});
            f.FlexModule.cbmClient = this.initCbmClientProxy(n);
          } catch (e) {
            f.FlexModule.cbmClient || (f.FlexModule.cbmClient = this.initCbmClientProxy({})), this.setDegradedMode(f.FlexModule.cbmClient, !0), d.ErrorManager.createAndProcessError("Failed to initialize CBM SDK", {
              context: "initCBMSDK",
              type: d.FlexErrorType.taskrouterSDK,
              wrappedError: e
            });
          }
        }, e.prototype.initCbmClientProxy = function (e) {
          return new Proxy(e, {
            get: function get(e, t) {
              var n = e[t];
              return "function" == typeof n ? n.bind(e) : n;
            }
          });
        }, e.prototype.initWorkerClientProxy = function (e) {
          return new Proxy(e, {
            get: function get(e, t, n) {
              return Reflect.get(e, t, n);
            }
          });
        }, e.prototype.initTaskRouterSDK = function (e) {
          return o(this, void 0, Promise, function () {
            var t = this;
            return i(this, function (n) {
              return [2, new Promise(function (n, o) {
                var i;
                if (E.ClientManagerHelpers.isForcedDegraded(E.ClientManagerInstance.TaskRouterClient)) throw new Error("Twilio Task Router is forced disabled. Failing initialisation");
                var a = r(r({}, null === (i = f.FlexModule.state.config.sdkOptions) || void 0 === i ? void 0 : i.worker), {
                    eventHandlerClass: l.ParticipantEventHandler
                  }),
                  s = new _.Supervisor(e, a).getProxy(),
                  c = t.initWorkerClientProxy(s);
                t.setDegradedMode(c, !1), f.FlexModule.workerClient = c, c.addListener("ready", function () {
                  h.log.debug("Worker " + c.sid + " is now ready for work"), c.removeAllListeners(), w.Actions.init(c), n();
                }), c.addListener("error", function (e) {
                  t.offline || (c.removeAllListeners(), o(d.ErrorManager.createAndProcessError("Worker error intercepted", {
                    type: d.FlexErrorType.taskrouterSDK,
                    context: "FlexClientManager - TaskRouter SDK",
                    description: "Worker error intercepted: a connection error has been thrown from TaskRouter SDK",
                    wrappedError: e
                  })));
                });
              }).catch(function (e) {
                if (f.FlexModule.workerClient || (f.FlexModule.workerClient = t.initWorkerClientProxy({})), t.setDegradedMode(f.FlexModule.workerClient, !0), w.Actions.init(f.FlexModule.workerClient), d.isFlexError(e)) throw e;
                throw d.ErrorManager.createAndProcessError("Error initializing Taskrouter SDK", {
                  context: "initTaskRouterSDK",
                  type: d.FlexErrorType.taskrouterSDK,
                  wrappedError: e
                });
              })];
            });
          });
        }, e.prototype.generateFlexSDKClientProxy = function (e) {
          return new Proxy(e, {
            get: function get(e, t) {
              var n = e[t];
              return "function" == typeof n ? n.bind(e) : n;
            }
          });
        }, e.prototype.initFlexSDK = function (e) {
          var t;
          return o(this, void 0, Promise, function () {
            var n,
              r,
              o = this;
            return i(this, function (i) {
              return n = (null === (t = f.FlexModule.state.config.sdkOptions) || void 0 === t ? void 0 : t.flex) || {}, n.environmentConfig, r = a(n, ["environmentConfig"]), [2, s.FlexSDKManager.initialize(e, s.Utils.merge(r, {
                telemetry: {
                  reportErrors: !P.FeatureFlags.isEnabled(m.FeatureFlag.DisableErrorTelemetry)
                }
              })).then(function () {
                if (E.ClientManagerHelpers.isForcedDegraded(E.ClientManagerInstance.FlexSDKClient)) throw new Error("FlexSDK Client is forced disabled. Failing initialisation");
                var e = o.generateFlexSDKClientProxy(s.FlexSDKManager.getClient());
                s.FlexSDKManager.setClient(e);
              }).then(function () {
                f.FlexModule.state.config.disableTelemetry || x.TelemetryManager.initialize(s.FlexSDKManager.getClient());
              }).catch(function (e) {
                var t = s.FlexSDKManager.getClient();
                throw t || (t = o.generateFlexSDKClientProxy({
                  token: "degradedModeFlexSDKToken"
                }), s.FlexSDKManager.setClient(t)), o.setDegradedMode(t, !0), d.ErrorManager.createAndProcessError("Failed to init Flex SDK", {
                  context: "initFlexSDK",
                  type: d.FlexErrorType.flexSDK,
                  wrappedError: e
                });
              })];
            });
          });
        }, e.prototype.generateSyncClientProxy = function (e) {
          return new Proxy(e, {
            get: function get(e, t, n) {
              return Reflect.get(e, t, n);
            }
          });
        }, e.prototype.initSyncSDK = function (e) {
          var t,
            n = this;
          return new Promise(function (o, i) {
            var a = r(r({}, f.FlexModule.state.config.sdkOptions.insights), {
              productId: "flex_insights",
              clientMetadata: {
                type: "flex-ui",
                app: "flex-ui",
                appv: S.VERSION
              }
            });
            if (t = n.generateSyncClientProxy(new p.SyncClient(e, a)), n.setDegradedMode(t, !1), E.ClientManagerHelpers.isForcedDegraded(E.ClientManagerInstance.InsightsClient)) throw new Error("Insights Client is forced disabled. Failing initialisation");
            var s = setTimeout(function () {
              i(d.ErrorManager.createAndProcessError("Unable to initialize insights client within allowed time frame", {
                type: d.FlexErrorType.syncSDK,
                context: "initSyncSDK",
                description: "Unable to initialize insights client in " + C.INSIGHTS_INIT_TIMEOUT + " ms"
              }));
            }, C.INSIGHTS_INIT_TIMEOUT);
            h.log.debug("Insights Client initial connection state: " + t.connectionState);
            var l = function l(e) {
                h.log.debug("Insights Client new state: " + e), "connected" === e && (f.FlexModule.insightsClient = t, v.Actions.init(t), k.Actions.assignInsights(t), g.Actions.assignInsights(t), t.removeListener("connectionStateChanged", l), t.removeListener("connectionError", c), y.ConnectionStatusState.init(), clearTimeout(s), o(void 0));
              },
              c = function c(e) {
                t.removeListener("connectionStateChanged", l), t.removeListener("connectionError", c), i(d.ErrorManager.createAndProcessError("Failed to initialize Insights SDK", {
                  type: d.FlexErrorType.syncSDK,
                  context: "initSyncSDK",
                  description: "Failed to initialize Insights SDK: a connection error has been thrown from Sync SDK",
                  wrappedError: e
                }));
              };
            t.on("connectionStateChanged", l), t.on("connectionError", c);
          }).catch(function (e) {
            if (f.FlexModule.insightsClient = t, n.setDegradedMode(t, !0), v.Actions.init(t), d.isFlexError(e)) throw e;
            throw d.ErrorManager.createAndProcessError("Failed to initialize Insights SDK", {
              context: "initSyncSDK",
              type: d.FlexErrorType.syncSDK,
              wrappedError: e
            });
          });
        }, e.prototype.generateChatClientProxy = function (e) {
          return new Proxy(e, {
            get: function get(e, t, n) {
              return Reflect.get(e, t, n);
            }
          });
        }, e.prototype.initChatSDK = function (e, t) {
          var n,
            o = this,
            i = r(r({}, null === (n = f.FlexModule.state.config.sdkOptions) || void 0 === n ? void 0 : n.chat), {
              clientMetadata: {
                type: "flex-ui",
                app: "flex-ui",
                appv: S.VERSION
              }
            });
          return c.Client.create(e, i).then(function (e) {
            if (E.ClientManagerHelpers.isForcedDegraded(E.ClientManagerInstance.ChatClient)) throw new Error("chat Client is forced disabled. Failing initialisation");
            t.then(function () {
              var e,
                t,
                r = (null === (e = f.FlexModule.workerClient) || void 0 === e ? void 0 : e.attributes.public_identity) || (null === (t = f.FlexModule.workerClient) || void 0 === t ? void 0 : t.attributes.full_name);
              r && n.user.updateFriendlyName(r);
            }).catch(function (e) {
              if (d.isFlexError(e)) throw e;
              throw d.ErrorManager.createAndProcessError("Cannot init TaskRouter SDK", {
                type: d.FlexErrorType.taskrouterSDK,
                context: "SessionState - SDKs",
                description: "Cannot init Chat SDK friendly name Taskrouter SDK init failed.",
                wrappedError: e
              });
            });
            var n = o.generateChatClientProxy(e);
            f.FlexModule.chatClient = n, o.setDegradedMode(n, !1), s.ChatSessionState.Actions.init(n), n.addListener("connectionError", function (e) {
              return d.ErrorManager.createAndProcessError("Connection error intercepted", {
                type: d.FlexErrorType.chatSDK,
                context: "SessionState - Chat SDK",
                description: "A connection error has been thrown from Chat SDK",
                wrappedError: e
              });
            }), h.log.debug("FlexClientManager: chat SDK initialized");
          }).catch(function (e) {
            if (f.FlexModule.chatClient || (f.FlexModule.chatClient = o.generateChatClientProxy({})), o.setDegradedMode(f.FlexModule.chatClient, !0), s.ChatSessionState.Actions.init(f.FlexModule.chatClient), d.isFlexError(e)) throw e;
            throw d.ErrorManager.createAndProcessError("Failed to initialize Chat SDK", {
              context: "SessionState - SDKs",
              type: d.FlexErrorType.chatSDK,
              wrappedError: e
            });
          });
        }, e.prototype.initVoiceSDK = function (e, t) {
          return o(this, void 0, Promise, function () {
            var n = this;
            return i(this, function (o) {
              return [2, f.FlexModule.state.config.disableBrowserVoice ? Promise.resolve() : new Promise(function (o, i) {
                var a,
                  s = function s() {
                    f.FlexModule.voiceClient.removeListener(u.Device.EventName.Ready, l), f.FlexModule.voiceClient.removeListener(u.Device.EventName.Error, s), i();
                  },
                  l = function l() {
                    f.FlexModule.voiceClient.removeListener(u.Device.EventName.Ready, l), f.FlexModule.voiceClient.removeListener(u.Device.EventName.Error, s), o(void 0);
                  },
                  c = r(r({
                    allowIncomingWhileBusy: !0
                  }, null === (a = f.FlexModule.state.config.sdkOptions) || void 0 === a ? void 0 : a.voice), {
                    appName: "flex-ui",
                    appVersion: S.VERSION
                  }),
                  p = f.FlexModule.state.config.locations;
                if (!p || 0 === p.length) {
                  if (n.setDegradedMode(f.FlexModule.voiceClient, !1), b.Actions.init(e, c), E.ClientManagerHelpers.isForcedDegraded(E.ClientManagerInstance.VoiceClient)) throw new Error("Voice Client is forced disabled. Failing initialisation");
                  return f.FlexModule.voiceClient.addListener("ready", l), void f.FlexModule.voiceClient.addListener("error", s);
                }
                t.catch(function (e) {
                  throw d.ErrorManager.createAndProcessError("Error initializing TaskRouter SDK", {
                    context: "SessionState - SDKs",
                    type: d.FlexErrorType.taskrouterSDK,
                    description: "Error initializing TaskRouter SDK. Cannot init Voice SDK as Taskrouter SDK init failed.",
                    wrappedError: e
                  });
                }).then(function () {
                  var t = f.FlexModule.workerClient.attributes.flex_location;
                  if (t) {
                    var n = p.find(function (e) {
                      return e.name === t;
                    });
                    if (!n) throw d.ErrorManager.createAndProcessError("Invalid edge - Worker's flex_location", {
                      context: "SessionState - SDKs",
                      type: d.FlexErrorType.taskrouterSDK,
                      description: "Invalid edge - Worker's flex_location " + t + " is not registered in edges config"
                    });
                    c = r(r({}, c), {
                      edge: n.edge
                    });
                  }
                  b.Actions.init(e, c), f.FlexModule.voiceClient.addListener("ready", l), f.FlexModule.voiceClient.addListener("error", s);
                }).catch(function (e) {
                  d.isFlexError(e) ? i(e) : i(d.ErrorManager.createAndProcessError("Error initializing TaskRouter SDK", {
                    context: "SessionState - SDKs",
                    type: d.FlexErrorType.taskrouterSDK,
                    wrappedError: e
                  }));
                });
              }).catch(function (e) {
                if (n.setDegradedMode(f.FlexModule.voiceClient, !0), d.isFlexError(e)) throw e;
                throw d.ErrorManager.createAndProcessError("Failed to initialize Voice SDK", {
                  context: "SessionState - SDKs",
                  type: d.FlexErrorType.voiceSDK,
                  wrappedError: e
                });
              })];
            });
          });
        }, e;
      }();
    t.FlexClientManagerImpl = A;
  }, function (e, t, n) {
    /*!
     * 
     * @twiliointernal/cbm-sdk.js 1.0.10
     * The following license applies to all parts of this software except as
     * documented below.
     * 
     *     Copyright (c) 2017, Twilio, inc.
     *     All rights reserved.
     * 
     *     Redistribution and use in source and binary forms, with or without
     *     modification, are permitted provided that the following conditions are
     *     met:
     * 
     *       1. Redistributions of source code must retain the above copyright
     *          notice, this list of conditions and the following disclaimer.
     * 
     *       2. Redistributions in binary form must reproduce the above copyright
     *          notice, this list of conditions and the following disclaimer in
     *          the documentation and/or other materials provided with the
     *          distribution.
     * 
     *       3. Neither the name of Twilio nor the names of its contributors may
     *          be used to endorse or promote products derived from this software
     *          without specific prior written permission.
     * 
     *     THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
     *     "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
     *     LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
     *     A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
     *     HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
     *     SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
     *     LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
     *     DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
     *     THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
     *     (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
     *     OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
     *     
     * This software includes buffer.js under the following license.
     * 
     *     Copyright (c) 2014 Junction Networks, Inc. <http://www.onsip.com>
     * 
     *     License: The MIT License
     * 
     *     Permission is hereby granted, free of charge, to any person obtaining
     *     a copy of this software and associated documentation files (the
     *     "Software"), to deal in the Software without restriction, including
     *     without limitation the rights to use, copy, modify, merge, publish,
     *     distribute, sublicense, and/or sell copies of the Software, and to
     *     permit persons to whom the Software is furnished to do so, subject to
     *     the following conditions:
     * 
     *     The above copyright notice and this permission notice shall be
     *     included in all copies or substantial portions of the Software.
     * 
     *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     *     EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
     *     MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     *     NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
     *     LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
     *     OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
     *     WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     * 
     * 
     * 
     */
    e.exports = function (e) {
      var t = {};
      function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
      }
      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 45);
    }([function (e, t) {
      e.exports = n(326);
    }, function (e, t) {
      e.exports = n(327);
    }, function (e, t) {
      e.exports = n(328);
    }, function (e, t, n) {
      "use strict";

      function r(e) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function o(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function i(e, t) {
        if (t && ("object" === r(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }
      function a(e) {
        var t = "function" == typeof Map ? new Map() : void 0;
        return (a = function a(e) {
          if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
          var n;
          if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
          if (void 0 !== t) {
            if (t.has(e)) return t.get(e);
            t.set(e, r);
          }
          function r() {
            return s(e, arguments, u(this).constructor);
          }
          return r.prototype = Object.create(e.prototype, {
            constructor: {
              value: r,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), c(r, e);
        })(e);
      }
      function s(e, t, n) {
        return (s = l() ? Reflect.construct : function (e, t, n) {
          var r = [null];
          r.push.apply(r, t);
          var o = new (Function.bind.apply(e, r))();
          return n && c(o, n.prototype), o;
        }).apply(null, arguments);
      }
      function l() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      function c(e, t) {
        return (c = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function u(e) {
        return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      n(24), n(21), n(0), n(35), n(22), n(8), n(36), n(9), n(10), n(5), n(18), n(19);
      var p = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          Object.defineProperty(e, "prototype", {
            value: Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }),
            writable: !1
          }), t && c(e, t);
        }(p, e);
        var t,
          n,
          r,
          a,
          s = (t = p, n = l(), function () {
            var e,
              r = u(t);
            if (n) {
              var o = u(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return i(this, e);
          });
        function p(e, t) {
          var n;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, p), (n = s.call(this)).errorData = e, n.name = e.name, n.message = null != t ? t : e.message, n;
        }
        return r = p, (a = [{
          key: "clone",
          value: function value(e) {
            return new p(this.errorData, e);
          }
        }]) && o(r.prototype, a), Object.defineProperty(r, "prototype", {
          writable: !1
        }), p;
      }(a(Error));
      t.a = p;
    }, function (e, t) {
      e.exports = n(329);
    }, function (e, t) {
      e.exports = n(330);
    }, function (e, t, n) {
      (function (e) {
        function r(e, t) {
          for (var n = 0, r = e.length - 1; r >= 0; r--) {
            var o = e[r];
            "." === o ? e.splice(r, 1) : ".." === o ? (e.splice(r, 1), n++) : n && (e.splice(r, 1), n--);
          }
          if (t) for (; n--; n) e.unshift("..");
          return e;
        }
        function o(e, t) {
          if (e.filter) return e.filter(t);
          for (var n = [], r = 0; r < e.length; r++) t(e[r], r, e) && n.push(e[r]);
          return n;
        }
        n(41), n(25), n(26), n(42), n(23), n(11), n(12), n(0), t.resolve = function () {
          for (var t = "", n = !1, i = arguments.length - 1; i >= -1 && !n; i--) {
            var a = i >= 0 ? arguments[i] : e.cwd();
            if ("string" != typeof a) throw new TypeError("Arguments to path.resolve must be strings");
            a && (t = a + "/" + t, n = "/" === a.charAt(0));
          }
          return (n ? "/" : "") + (t = r(o(t.split("/"), function (e) {
            return !!e;
          }), !n).join("/")) || ".";
        }, t.normalize = function (e) {
          var n = t.isAbsolute(e),
            a = "/" === i(e, -1);
          return (e = r(o(e.split("/"), function (e) {
            return !!e;
          }), !n).join("/")) || n || (e = "."), e && a && (e += "/"), (n ? "/" : "") + e;
        }, t.isAbsolute = function (e) {
          return "/" === e.charAt(0);
        }, t.join = function () {
          var e = Array.prototype.slice.call(arguments, 0);
          return t.normalize(o(e, function (e, t) {
            if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
            return e;
          }).join("/"));
        }, t.relative = function (e, n) {
          function r(e) {
            for (var t = 0; t < e.length && "" === e[t]; t++);
            for (var n = e.length - 1; n >= 0 && "" === e[n]; n--);
            return t > n ? [] : e.slice(t, n - t + 1);
          }
          e = t.resolve(e).substr(1), n = t.resolve(n).substr(1);
          for (var o = r(e.split("/")), i = r(n.split("/")), a = Math.min(o.length, i.length), s = a, l = 0; l < a; l++) if (o[l] !== i[l]) {
            s = l;
            break;
          }
          var c = [];
          for (l = s; l < o.length; l++) c.push("..");
          return (c = c.concat(i.slice(s))).join("/");
        }, t.sep = "/", t.delimiter = ":", t.dirname = function (e) {
          if ("string" != typeof e && (e += ""), 0 === e.length) return ".";
          for (var t = e.charCodeAt(0), n = 47 === t, r = -1, o = !0, i = e.length - 1; i >= 1; --i) if (47 === (t = e.charCodeAt(i))) {
            if (!o) {
              r = i;
              break;
            }
          } else o = !1;
          return -1 === r ? n ? "/" : "." : n && 1 === r ? "/" : e.slice(0, r);
        }, t.basename = function (e, t) {
          var n = function (e) {
            "string" != typeof e && (e += "");
            var t,
              n = 0,
              r = -1,
              o = !0;
            for (t = e.length - 1; t >= 0; --t) if (47 === e.charCodeAt(t)) {
              if (!o) {
                n = t + 1;
                break;
              }
            } else -1 === r && (o = !1, r = t + 1);
            return -1 === r ? "" : e.slice(n, r);
          }(e);
          return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
        }, t.extname = function (e) {
          "string" != typeof e && (e += "");
          for (var t = -1, n = 0, r = -1, o = !0, i = 0, a = e.length - 1; a >= 0; --a) {
            var s = e.charCodeAt(a);
            if (47 !== s) -1 === r && (o = !1, r = a + 1), 46 === s ? -1 === t ? t = a : 1 !== i && (i = 1) : -1 !== t && (i = -1);else if (!o) {
              n = a + 1;
              break;
            }
          }
          return -1 === t || -1 === r || 0 === i || 1 === i && t === r - 1 && t === n + 1 ? "" : e.slice(t, r);
        };
        var i = "b" === "ab".substr(-1) ? function (e, t, n) {
          return e.substr(t, n);
        } : function (e, t, n) {
          return t < 0 && (t = e.length + t), e.substr(t, n);
        };
      }).call(this, n(40));
    }, function (e, t) {
      e.exports = n(331);
    }, function (e, t) {
      e.exports = n(332);
    }, function (e, t) {
      e.exports = n(333);
    }, function (e, t) {
      e.exports = n(334);
    }, function (e, t) {
      e.exports = n(335);
    }, function (e, t) {
      e.exports = n(336);
    }, function (e, t) {
      e.exports = n(337);
    }, function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "RESERVATION_STATUS_ACCEPTED", function () {
        return o;
      }), n.d(t, "RESERVATION_STATUS_COMPLETED", function () {
        return i;
      }), n.d(t, "RESERVATION_STATUS_REJECTED", function () {
        return a;
      }), n.d(t, "RESERVATION_STATUS_WRAPPING", function () {
        return s;
      }), n.d(t, "RESERVATION_INSTRUCTION_CALL", function () {
        return l;
      }), n.d(t, "RESERVATION_INSTRUCTION_DEQUEUE", function () {
        return c;
      }), n.d(t, "RESERVATION_INSTRUCTION_REDIRECT", function () {
        return u;
      }), n.d(t, "RESERVATION_INSTRUCTION_CONFERENCE", function () {
        return p;
      }), n.d(t, "TRANSFER_STATUS", function () {
        return d;
      }), n.d(t, "RESERVATION_REJECT_OPTIONS", function () {
        return f;
      }), n.d(t, "WORKER_UPDATE_OPTIONS", function () {
        return h;
      }), n.d(t, "RESERVATION_CALL_OPTIONS", function () {
        return m;
      }), n.d(t, "RESERVATION_DEQUEUE_OPTIONS", function () {
        return g;
      }), n.d(t, "RESERVATION_REDIRECT_OPTIONS", function () {
        return y;
      }), n.d(t, "CREATE_TASK_OPTIONS", function () {
        return v;
      }), n.d(t, "TASK_STATUS_COMPLETED", function () {
        return b;
      }), n.d(t, "TASK_STATUS_WRAPPING", function () {
        return C;
      }), n.d(t, "reservationEventTypes", function () {
        return _;
      }), n.d(t, "taskEventTypes", function () {
        return k;
      }), n.d(t, "reservationToSDKEventsMapping", function () {
        return w;
      }), n.d(t, "transferFields", function () {
        return S;
      }), n.d(t, "TRANSFER_INITIATED", function () {
        return P;
      }), n.d(t, "taskTransferEventTypes", function () {
        return T;
      }), n.d(t, "taskTransferEventEmitterMapping", function () {
        return O;
      }), n.d(t, "participantEventEmitterMapping", function () {
        return x;
      }), n.d(t, "API_V2", function () {
        return E;
      }), n.d(t, "DEFAULT_PAGE_SIZE", function () {
        return A;
      }), n.d(t, "DEFAULT_HTTP_TIMEOUT", function () {
        return I;
      }), n.d(t, "DEFAULT_EVENTS_TIMEOUT", function () {
        return j;
      }), n.d(t, "EB_URL_PARAMS", function () {
        return L;
      }), n.d(t, "twilioErrors", function () {
        return M;
      }), n(33), n(34), n(0), n(24);
      var r = n(3),
        o = "accepted",
        i = "completed",
        a = "rejected",
        s = "wrapping",
        l = "call",
        c = "dequeue",
        u = "redirect",
        p = "conference",
        d = Object.freeze({
          canceled: "canceled",
          complete: "complete",
          failed: "failed",
          initiated: "initiated"
        }),
        f = {
          activitySid: "WorkerActivitySid"
        };
      Object.freeze(f);
      var h = {
        rejectPendingReservations: "RejectPendingReservations"
      };
      Object.freeze(h);
      var m = {
        accept: "CallAccept",
        record: "CallRecord",
        statusCallbackUrl: "CallStatusCallbackUrl",
        timeout: "CallTimeout",
        to: "CallTo"
      };
      Object.freeze(m);
      var g = {
        to: "DequeueTo",
        from: "DequeueFrom",
        postWorkActivitySid: "DequeuePostWorkActivitySid",
        record: "DequeueRecord",
        timeout: "DequeueTimeout",
        statusCallbackUrl: "DequeueStatusCallbackUrl",
        statusCallbackEvents: "DequeueStatusCallbackEvents"
      };
      Object.freeze(g);
      var y = {
        accept: "RedirectAccept"
      };
      Object.freeze(y);
      var v = {
          taskChannelUniqueName: "TaskChannelUniqueName",
          taskChannelSid: "TaskChannelSid",
          attributes: "Attributes"
        },
        b = "completed",
        C = "wrapping",
        _ = {
          accepted: 0,
          rejected: 1,
          timeout: 2,
          canceled: 3,
          rescinded: 4,
          completed: 5,
          wrapup: 6
        };
      Object.freeze(_);
      var k = {
        "task.updated": "updated",
        "task.canceled": "canceled",
        "task.completed": "completed",
        "task.wrapup": "wrapup"
      };
      Object.freeze(k);
      var w = {
        "reservation.completed": "completed",
        "reservation.rejected": "rejected",
        "reservation.timeout": "timeout",
        "reservation.canceled": "canceled",
        "reservation.rescinded": "rescinded",
        "reservation.accepted": "accepted",
        "reservation.wrapup": "wrapup"
      };
      Object.freeze(w);
      var S = Object.freeze({
          taskTransfer: "task_transfer",
          activeOutgoingTaskTransfer: "active_outgoing_task_transfer"
        }),
        P = "transfer-initiated",
        T = {
          "transfer-attempt-failed": "attemptFailed",
          "transfer-completed": "completed",
          "transfer-failed": "failed",
          "transfer-initiated": "transferInitiated",
          "transfer-canceled": "canceled"
        };
      Object.freeze(T);
      var O = {
        "task.transfer-attempt-failed": "transfer-attempt-failed",
        "task.transfer-completed": "transfer-completed",
        "task.transfer-failed": "transfer-failed",
        "task.transfer-initiated": "transfer-initiated",
        "task.transfer-canceled": "transfer-canceled"
      };
      Object.freeze(O);
      var x = {
        "participant.added": "participantAdded",
        "participant.add.failed": "participantAddFailed",
        "participant.removed": "participantRemoved",
        "participant.remove.failed": "participantRemoveFailed",
        "participant.modified": "participantModified",
        "participant.modify.failed": "participantModifyFailed"
      };
      Object.freeze(x);
      var E = "v2",
        A = 1e3,
        I = 5e3,
        j = 1e4,
        L = {
          TOKEN: "token",
          CLOSE_EXISTING_SESSIONS: "closeExistingSessions",
          CLIENT_VERSION: "clientVersion"
        },
        M = [{
          name: "INVALID_ARGUMENT",
          message: "One or more arguments passed were invalid."
        }, {
          name: "INVALID_TOKEN",
          message: "The token is invalid or malformed."
        }, {
          name: "TOKEN_EXPIRED",
          message: "CbmSdkClient's active token has expired."
        }, {
          name: "GATEWAY_CONNECTION_FAILED",
          message: "Could not connect to Twilio's servers."
        }, {
          name: "GATEWAY_DISCONNECTED",
          message: "Connection to Twilio's servers was lost."
        }, {
          name: "INVALID_GATEWAY_MESSAGE",
          message: "The JSON message received was malformed."
        }, {
          name: "TASKROUTER_ERROR",
          message: "TaskRouter failed to complete the request."
        }].reduce(function (e, t) {
          return e[t.name] = new r.a(t), e;
        }, {});
    }, function (e, t) {
      e.exports = n(338);
    }, function (e, t) {
      e.exports = n(339);
    }, function (e, t) {
      e.exports = n(340);
    }, function (e, t) {
      e.exports = n(341);
    }, function (e, t) {
      e.exports = n(342);
    }, function (e, t) {
      e.exports = n(343);
    }, function (e, t) {
      e.exports = n(344);
    }, function (e, t) {
      e.exports = n(345);
    }, function (e, t) {
      e.exports = n(346);
    }, function (e, t) {
      e.exports = n(347);
    }, function (e, t) {
      e.exports = n(348);
    }, function (e, t) {
      e.exports = n(349);
    }, function (e, t) {
      e.exports = n(116);
    }, function (e, t) {
      e.exports = n(108);
    }, function (e) {
      e.exports = JSON.parse('{"a":"1.0.10"}');
    }, function (e, t) {
      e.exports = n(350);
    }, function (e, t) {
      e.exports = n(351);
    }, function (e, t) {
      e.exports = n(174);
    }, function (e, t) {
      e.exports = n(352);
    }, function (e, t) {
      e.exports = n(353);
    }, function (e, t) {
      e.exports = n(354);
    }, function (e, t) {
      e.exports = n(355);
    }, function (e, t) {
      e.exports = n(356);
    }, function (e, t) {
      e.exports = n(357);
    }, function (e, t) {
      e.exports = n(358);
    }, function (e, t, n) {
      n(11);
      var r,
        o,
        i = e.exports = {};
      function a() {
        throw new Error("setTimeout has not been defined");
      }
      function s() {
        throw new Error("clearTimeout has not been defined");
      }
      function l(e) {
        if (r === setTimeout) return setTimeout(e, 0);
        if ((r === a || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);
        try {
          return r(e, 0);
        } catch (t) {
          try {
            return r.call(null, e, 0);
          } catch (t) {
            return r.call(this, e, 0);
          }
        }
      }
      !function () {
        try {
          r = "function" == typeof setTimeout ? setTimeout : a;
        } catch (e) {
          r = a;
        }
        try {
          o = "function" == typeof clearTimeout ? clearTimeout : s;
        } catch (e) {
          o = s;
        }
      }();
      var c,
        u = [],
        p = !1,
        d = -1;
      function f() {
        p && c && (p = !1, c.length ? u = c.concat(u) : d = -1, u.length && h());
      }
      function h() {
        if (!p) {
          var e = l(f);
          p = !0;
          for (var t = u.length; t;) {
            for (c = u, u = []; ++d < t;) c && c[d].run();
            d = -1, t = u.length;
          }
          c = null, p = !1, function (e) {
            if (o === clearTimeout) return clearTimeout(e);
            if ((o === s || !o) && clearTimeout) return o = clearTimeout, clearTimeout(e);
            try {
              o(e);
            } catch (t) {
              try {
                return o.call(null, e);
              } catch (t) {
                return o.call(this, e);
              }
            }
          }(e);
        }
      }
      function m(e, t) {
        this.fun = e, this.array = t;
      }
      function g() {}
      i.nextTick = function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
        u.push(new m(e, t)), 1 !== u.length || p || l(h);
      }, m.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (e) {
        return [];
      }, i.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, i.cwd = function () {
        return "/";
      }, i.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, i.umask = function () {
        return 0;
      };
    }, function (e, t) {
      e.exports = n(359);
    }, function (e, t) {
      e.exports = n(360);
    }, function (e, t) {
      e.exports = n(361);
    }, function (e, t) {
      e.exports = n(362);
    }, function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "CbmSdk", function () {
        return an;
      }), n.d(t, "addEmailParticipant", function () {
        return et;
      }), n.d(t, "addSmsParticipant", function () {
        return nt;
      }), n.d(t, "addWhatsAppParticipant", function () {
        return ot;
      }), n.d(t, "addWebChatParticipant", function () {
        return at;
      }), n.d(t, "addVoiceParticipant", function () {
        return ut;
      }), n.d(t, "removeParticipant", function () {
        return ht;
      }), n.d(t, "removeVoiceParticipant", function () {
        return vt;
      }), n.d(t, "getChannels", function () {
        return Ie;
      }), n.d(t, "getParticipants", function () {
        return Oe;
      }), n.d(t, "acceptReservation", function () {
        return ee;
      }), n.d(t, "completeReservation", function () {
        return Y;
      }), n.d(t, "holdParticipant", function () {
        return Qe;
      }), n.d(t, "unHoldParticipant", function () {
        return Ke;
      }), n.d(t, "endConference", function () {
        return Fe;
      }), n.d(t, "setEndConferenceOnExit", function () {
        return Be;
      }), n.d(t, "rejectReservation", function () {
        return oe;
      }), n.d(t, "wrapReservation", function () {
        return le;
      }), n.d(t, "createEmailTask", function () {
        return kt;
      }), n.d(t, "createSmsTask", function () {
        return Et;
      }), n.d(t, "createWhatsAppTask", function () {
        return Dt;
      }), n.d(t, "createWebTask", function () {
        return Vt;
      }), n.d(t, "Logger", function () {
        return m;
      }), n.d(t, "CbmParticipant", function () {
        return _e;
      }), n.d(t, "RoutingProperties", function () {
        return pe;
      }), n.d(t, "Configuration", function () {
        return b;
      }), n.d(t, "ParticipantEventHandler", function () {
        return yn;
      }), n(8), n(0), n(9), n(20), n(10), n(21), n(22), n(5), n(18), n(19);
      var r = n(4),
        o = n.n(r),
        i = n(27),
        a = (n(23), n(28)),
        s = n.n(a);
      function l(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function c(e, t) {
        return function (e, t) {
          return t.get ? t.get.call(e) : t.value;
        }(e, u(e, t, "get"));
      }
      function u(e, t, n) {
        if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
        return t.get(e);
      }
      var p,
        d = n(14).twilioErrors,
        f = ["trace", "debug", "info", "warn", "error", "silent"];
      !function (e) {
        e.Trace = "trace", e.Debug = "debug", e.Info = "info", e.Warn = "warn", e.Error = "error", e.Silent = "silent";
      }(p || (p = {}));
      var h = new WeakMap(),
        m = function () {
          function e(t, n) {
            if (function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, e), function (e, t, n) {
              !function (e, t) {
                if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
              }(e, t), t.set(e, n);
            }(this, h, {
              writable: !0,
              value: void 0
            }), !t) throw d.INVALID_ARGUMENT.clone("Error instantiating Logger. <string>moduleName is a required parameter.");
            (function (e, t, n) {
              (function (e, t, n) {
                if (t.set) t.set.call(e, n);else {
                  if (!t.writable) throw new TypeError("attempted to set read only private field");
                  t.value = n;
                }
              })(e, u(e, t, "set"), n);
            })(this, h, s.a.getLogger(t)), n && this.setLevel(n);
          }
          var t, n;
          return t = e, (n = [{
            key: "trace",
            value: function value() {
              var e;
              (e = c(this, h)).trace.apply(e, arguments);
            }
          }, {
            key: "debug",
            value: function value() {
              var e;
              (e = c(this, h)).debug.apply(e, arguments);
            }
          }, {
            key: "info",
            value: function value() {
              var e;
              (e = c(this, h)).info.apply(e, arguments);
            }
          }, {
            key: "warn",
            value: function value() {
              var e;
              (e = c(this, h)).warn.apply(e, arguments);
            }
          }, {
            key: "error",
            value: function value() {
              var e;
              (e = c(this, h)).error.apply(e, arguments);
            }
          }, {
            key: "setLevel",
            value: function value(e) {
              if (-1 === f.indexOf(e)) throw d.INVALID_ARGUMENT.clone("Error setting Logger level. <string>level must be one of ['trace', 'debug', 'info', 'warn', 'error', 'silent']");
              c(this, h).setLevel(e, !1), c(this, h).setDefaultLevel(e);
            }
          }, {
            key: "getLogger",
            value: function value() {
              return c(this, h);
            }
          }, {
            key: "getLevel",
            value: function value() {
              return f[c(this, h).getLevel()];
            }
          }]) && l(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e;
        }();
      function g(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      var y,
        v = new WeakMap(),
        b = function () {
          function e(t, n) {
            var r, i, a;
            if (function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, e), function (e, t, n) {
              !function (e, t) {
                if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
              }(e, t), t.set(e, n);
            }(this, v, {
              writable: !0,
              value: void 0
            }), !o.a.isString(t) || !t) throw new TypeError("Failed to initialize Configuration. <string>token is a required parameter.");
            if (this.token = t, this.logIdentifier = new Date(), this.logLevel = null !== (r = null == n ? void 0 : n.logLevel) && void 0 !== r ? r : p.Error, function (e, t, n) {
              (function (e, t, n) {
                if (t.set) t.set.call(e, n);else {
                  if (!t.writable) throw new TypeError("attempted to set read only private field");
                  t.value = n;
                }
              })(e, function (e, t, n) {
                if (!t.has(e)) throw new TypeError("attempted to set private field on non-instance");
                return t.get(e);
              }(e, t), n);
            }(this, v, new m("Configuration-".concat(this.logIdentifier), this.logLevel)), this.ebServer = null !== (i = null == n ? void 0 : n.ebServer) && void 0 !== i ? i : "https://event-bridge.twilio.com/v1/wschannels", this.wsServer = null !== (a = null == n ? void 0 : n.wsServer) && void 0 !== a ? a : "wss://event-bridge.twilio.com/v1/wschannels", null != n && n.region) {
              var s = "".concat(n.region, ".us1."),
                l = this.ebServer.indexOf("twilio.com"),
                c = this.wsServer.indexOf("twilio.com");
              this.ebServer = this.ebServer.slice(0, l) + s + this.ebServer.slice(l), this.wsServer = this.wsServer.slice(0, c) + s + this.wsServer.slice(c);
            }
          }
          var t, n;
          return t = e, (n = [{
            key: "updateToken",
            value: function value(e) {
              if (!o.a.isString(e) || !e) throw new TypeError("To update the Twilio token, a new Twilio token must be passed in. <string>newToken is a required parameter.");
              this.token = e;
            }
          }, {
            key: "getLogIdentifier",
            value: function value() {
              return this.logIdentifier;
            }
          }]) && g(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e;
        }(),
        C = (n(1), n(11), n(37), n(15), n(12), n(13), n(7), n(16), n(2), n(14)),
        _ = n(29);
      function k(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function w(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? k(Object(n), !0).forEach(function (t) {
            S(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : k(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function S(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function P(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function T(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              P(i, r, o, a, s, "next", e);
            }
            function s(e) {
              P(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      !function (e) {
        e.Get = "GET", e.Post = "POST";
      }(y || (y = {}));
      var O,
        x = {
          clientVersion: _.a,
          apiVersion: C.API_V2
        };
      function E(e) {
        return A.apply(this, arguments);
      }
      function A() {
        return (A = T(_regeneratorRuntime().mark(function e(t) {
          var n, r, o, i, a, s, l, c;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (n = t.method, r = t.server, o = t.url, i = t.params, a = t.token, O) {
                  e.next = 3;
                  break;
                }
                throw new Error("Failed to make ".concat(n, " request. Make sure 'configureRequest' is invoked prior to making a request ."));
              case 3:
                if (o) {
                  e.next = 5;
                  break;
                }
                throw new Error("Failed to make ".concat(n, " request. <string>url is a required parameter."));
              case 5:
                return s = JSON.stringify({
                  url: o,
                  params: i,
                  method: n,
                  token: a
                }), e.next = 8, L(r, {
                  body: s,
                  method: y.Post,
                  headers: x
                });
              case 8:
                if ((l = e.sent).ok) {
                  e.next = 11;
                  break;
                }
                throw new Error("".concat(n, " request failed: ").concat(l.statusText));
              case 11:
                return e.next = 13, l.json();
              case 13:
                return c = e.sent, e.abrupt("return", c.payload);
              case 15:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      var I = function () {
          var e = T(_regeneratorRuntime().mark(function e(t) {
            var n,
              r = arguments;
            return _regeneratorRuntime().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return n = r.length > 1 && void 0 !== r[1] ? r[1] : {}, e.abrupt("return", E({
                    url: t,
                    params: n,
                    method: y.Get,
                    server: O.ebServer,
                    token: O.token
                  }));
                case 2:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        j = function () {
          var e = T(_regeneratorRuntime().mark(function e(t, n) {
            return _regeneratorRuntime().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (O) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("Failed to make POST request. Make sure `configureRequest` is invoked prior to `post` .");
                case 2:
                  if (o.a.isObject(n)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("Failed to make POST request. <object>params is a required parameter.");
                case 4:
                  return e.abrupt("return", E({
                    url: t,
                    params: n,
                    method: y.Post,
                    server: O.ebServer,
                    token: O.token
                  }));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, n) {
            return e.apply(this, arguments);
          };
        }();
      function L(e, t) {
        return M.apply(this, arguments);
      }
      function M() {
        return (M = T(_regeneratorRuntime().mark(function e(t, n) {
          var r, o, i, a;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return r = w({}, n), void 0 !== globalThis.AbortController && (i = new globalThis.AbortController(), r = w(w({}, r), {}, {
                  signal: i.signal
                }), o = setTimeout(function () {
                  return i.abort();
                }, C.DEFAULT_HTTP_TIMEOUT)), e.next = 4, fetch(t, r);
              case 4:
                return a = e.sent, void 0 !== o && clearTimeout(o), e.abrupt("return", a);
              case 7:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      n(25), n(26), n(38), n(39);
      var F,
        D = n(6),
        N = n.n(D);
      function R(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function B(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? R(Object(n), !0).forEach(function (t) {
            U(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function U(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      var H,
        W = n(14).twilioErrors,
        V = (U(F = {}, "createInteraction", {
          path: N.a.join("v1/Interactions")
        }), U(F, "interactionInstance", {
          path: N.a.join("v1", "Interactions", "%s")
        }), U(F, "interactionChannelInviteAccept", {
          path: N.a.join("v1", "Interactions", "%s", "Channels", "%s", "Invites", "%s")
        }), U(F, "interactionChannelInviteDecline", {
          path: N.a.join("v1", "Interactions", "%s", "Channels", "%s", "Invites", "%s")
        }), U(F, "interactionGetChannels", {
          path: N.a.join("v1", "Interactions", "%s", "Channels")
        }), U(F, "interactionChannel", {
          path: N.a.join("v1", "Interactions", "%s", "Channels", "%s")
        }), U(F, "interactionGetChannelParticipants", {
          path: N.a.join("v1", "Interactions", "%s", "Channels", "%s", "Participants")
        }), U(F, "interactionAddParticipant", {
          path: N.a.join("v1", "Interactions", "%s", "Channels", "%s", "Participants")
        }), U(F, "interactionModifyParticipant", {
          path: N.a.join("v1", "Interactions", "%s", "Channels", "%s", "Participants", "%s")
        }), F);
      function z(e) {
        if (!V[e]) throw W.INVALID_ARGUMENT.clone('Invalid route fetched <string>route "'.concat(e, '" does not exist.'));
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
        if (n.length) {
          var o = B({}, V[e]);
          if (n.length !== (o.path.match(/%s/g) || []).length) throw W.INVALID_ARGUMENT.clone("Invalid number of positional arguments supplied for route ".concat(e));
          return n.forEach(function (e) {
            o.path = o.path.replace(/%s/, e);
          }), o;
        }
        return V[e];
      }
      function G(e) {
        if (!e) throw new Error("No task specified for getting interaction sid");
        if (!e.attributes) throw new Error("Task's attributes are not set");
        var t = e.attributes.flexInteractionSid;
        return t || (t = "KD".concat(e.sid.slice(2))), t;
      }
      function q(e, t, n) {
        var r = new Promise(function (e, r) {
          setTimeout(function () {
            r(new Error("Event not received: ".concat(t)));
          }, n || H);
        });
        return Promise.race([e, r]);
      }
      function Q(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function K(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Q(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Q(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Y(e) {
        return X.apply(this, arguments);
      }
      function X() {
        return (X = K(_regeneratorRuntime().mark(function e(t) {
          var n, r, o, i, a;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (t.task) {
                  e.next = 2;
                  break;
                }
                throw new Error("Failed to complete Reservation. Task is missing from Reservation.");
              case 2:
                if (n = new Promise(function (e) {
                  t.once("completed", e);
                }), !t.task.attributes || !t.task.attributes.flexInteractionChannelSid) {
                  e.next = 13;
                  break;
                }
                return r = G(t.task), o = t.task.attributes.flexInteractionChannelSid, i = z("interactionChannel", r, o).path, a = {
                  status: "close",
                  routing: {
                    status: "close"
                  }
                }, e.next = 11, j(i, a);
              case 11:
                e.next = 15;
                break;
              case 13:
                return e.next = 15, t.complete();
              case 15:
                return e.abrupt("return", q(n, "Reservation.completed"));
              case 16:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      var J = n(3);
      function Z(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function $(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Z(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Z(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function ee(e) {
        return te.apply(this, arguments);
      }
      function te() {
        return (te = $(_regeneratorRuntime().mark(function e(t) {
          var n, r, o, i, a, s, l;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (n = new Promise(function (e, n) {
                  t.once("accepted", e), t.task.once("participantAddFailed", function (e, r) {
                    var o = r.error_data && r.error_data.error_message;
                    n(new J.a(r, "Failed to add Participant to Task sid=".concat(t.task.sid, ", Participant sid=").concat(r.participant_sid, ". Reason: ").concat(o)));
                  });
                }), !(r = t.task.attributes) || !r.flexInteractionChannelSid) {
                  e.next = 14;
                  break;
                }
                if (r.flexChannelInviteSid) {
                  e.next = 5;
                  break;
                }
                throw new Error("flexChannelInviteSid is missing in CBM task attributes");
              case 5:
                return o = G(t.task), i = r.flexInteractionChannelSid, a = r.flexChannelInviteSid, s = z("interactionChannelInviteAccept", o, i, a).path, l = {
                  action: "accept",
                  routing: {
                    type: "taskrouter",
                    reservation: {
                      sid: t.sid
                    }
                  }
                }, e.next = 12, j(s, l);
              case 12:
                e.next = 16;
                break;
              case 14:
                return e.next = 16, t.accept();
              case 16:
                return e.abrupt("return", q(n, "Reservation.accepted"));
              case 17:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function ne(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function re(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              ne(i, r, o, a, s, "next", e);
            }
            function s(e) {
              ne(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function oe(e) {
        return ie.apply(this, arguments);
      }
      function ie() {
        return (ie = re(_regeneratorRuntime().mark(function e(t) {
          var n, r, o, i, a, s, l;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (n = new Promise(function (e) {
                  t.once("rejected", e);
                }), !(r = t.task.attributes) || !r.flexInteractionChannelSid) {
                  e.next = 14;
                  break;
                }
                if (r.flexChannelInviteSid) {
                  e.next = 5;
                  break;
                }
                throw new Error("flexChannelInviteSid is missing in CBM task attributes");
              case 5:
                return o = G(t.task), i = r.flexInteractionChannelSid, a = r.flexChannelInviteSid, s = z("interactionChannelInviteDecline", o, i, a).path, l = {
                  action: "decline",
                  routing: {
                    type: "taskrouter",
                    reservation: {
                      sid: t.sid
                    }
                  }
                }, e.next = 12, j(s, l);
              case 12:
                e.next = 16;
                break;
              case 14:
                return e.next = 16, t.reject();
              case 16:
                return e.abrupt("return", q(n, "Reservation.rejected"));
              case 17:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function ae(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function se(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              ae(i, r, o, a, s, "next", e);
            }
            function s(e) {
              ae(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function le(e) {
        return ce.apply(this, arguments);
      }
      function ce() {
        return (ce = se(_regeneratorRuntime().mark(function e(t) {
          var n, r, o, i, a;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (n = new Promise(function (e) {
                  t.once("wrapup", e);
                }), !t.task.attributes || !t.task.attributes.flexInteractionChannelSid) {
                  e.next = 10;
                  break;
                }
                return r = G(t.task), o = t.task.attributes.flexInteractionChannelSid, i = z("interactionChannel", r, o).path, a = {
                  status: "close",
                  routing: {
                    status: "wrapup"
                  }
                }, e.next = 8, j(i, a);
              case 8:
                e.next = 12;
                break;
              case 10:
                return e.next = 12, t.wrap();
              case 12:
                return e.abrupt("return", q(n, "Reservation.wrapup"));
              case 13:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function ue(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      n(43);
      var pe = function (e, t, n) {
          return t && ue(e.prototype, t), n && ue(e, n), Object.defineProperty(e, "prototype", {
            writable: !1
          }), e;
        }(function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.taskSid = t.task_sid, this.workerSid = t.worker_sid, this.reservationSid = t.reservation_sid;
        }),
        de = n(30),
        fe = n.n(de),
        he = n(31),
        me = n.n(he);
      function ge(e) {
        return (ge = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      var ye,
        ve = function e(t, n) {
          return me()(t, function (t, r, o) {
            Array.isArray(r) ? t["".concat(n(o))] = function e(t, n) {
              var r = [];
              return t.forEach(function (t) {
                var o;
                o = Array.isArray(t) ? e(t, n) : "object" === ge(t) ? ve(t, n) : t, r.push(o);
              }), r;
            }(r, n) : r instanceof Object && !(r instanceof Date) ? t["".concat(n(o))] = e(r, n) : t["".concat(n(o))] = r;
          }, {});
        };
      function be(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      !function (e) {
        e.Agent = "agent", e.Customer = "customer", e.Supervisor = "supervisor", e.External = "external";
      }(ye || (ye = {}));
      var Ce,
        _e = function (e, t, n) {
          return t && be(e.prototype, t), n && be(e, n), Object.defineProperty(e, "prototype", {
            writable: !1
          }), e;
        }(function e(t) {
          var n;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.participantSid = t.participant_sid, this.channelSid = t.channel_sid, this.interactionSid = t.interaction_sid, this.type = t.type, null !== t.routing_properties && (this.routingProperties = new pe(t.routing_properties)), null !== t.media_properties && (this.mediaProperties = (n = t.media_properties, ve(n, function (e) {
            return fe()(e);
          })));
        });
      function ke(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function we(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ke(Object(n), !0).forEach(function (t) {
            Se(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ke(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function Se(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function Pe(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function Te(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Pe(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Pe(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Oe(e, t) {
        return xe.apply(this, arguments);
      }
      function xe() {
        return (xe = Te(_regeneratorRuntime().mark(function e(t, n) {
          var r, o, i;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (n) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Failed to get Participants in a channel in Task sid=".concat(t.sid, ". Missing a channel sid."));
              case 2:
                if (t.attributes) {
                  e.next = 4;
                  break;
                }
                throw new TypeError("Failed to get Participants in a channel in Task sid=".concat(t.sid, ". Missing attributes."));
              case 4:
                return r = G(t), o = z("interactionGetChannelParticipants", r, n).path, e.next = 8, I(o);
              case 8:
                if (!(i = e.sent).participants) {
                  e.next = 11;
                  break;
                }
                return e.abrupt("return", i.participants.map(function (e) {
                  return new _e(we(we({}, e), {}, {
                    participant_sid: e.sid
                  }));
                }));
              case 11:
                throw new TypeError("Failed to get Participants in a channel in Task sid=".concat(t.sid, ". ") + "Response does not contain participants object.");
              case 12:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function Ee(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function Ae(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Ee(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Ee(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Ie(e) {
        return je.apply(this, arguments);
      }
      function je() {
        return (je = Ae(_regeneratorRuntime().mark(function e(t) {
          var n, r, o, i;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (t.attributes) {
                  e.next = 2;
                  break;
                }
                throw new Error("Task attributes missing - getChannels expects the task to have attributes");
              case 2:
                return n = G(t), r = z("interactionGetChannels", n).path, e.next = 6, I(r);
              case 6:
                return o = e.sent, i = [], o.channels && o.channels.forEach(function (e) {
                  i.push(e);
                }), e.abrupt("return", i);
              case 10:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function Le(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function Me(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Le(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Le(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Fe(e) {
        return De.apply(this, arguments);
      }
      function De() {
        return (De = Me(_regeneratorRuntime().mark(function e(t) {
          var n, r, o, i, a, s, l;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, Ie(t);
              case 2:
                if (n = e.sent, r = n.find(function (e) {
                  return "voice" === e.type;
                })) {
                  e.next = 6;
                  break;
                }
                throw new TypeError("Failed to close the conference in a channel in Task sid=".concat(t.sid, ". ") + "The task is expected to have a voice channel.");
              case 6:
                return o = G(t), i = z("interactionChannel", o, r.sid).path, a = {
                  status: "close"
                }, l = new Promise(function (e) {
                  t.once("wrapup", function () {
                    e(s);
                  });
                }), e.next = 12, j(i, a);
              case 12:
                return s = e.sent, e.abrupt("return", q(l, "Task.wrapup"));
              case 14:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function Ne(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function Re(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Ne(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Ne(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Be(e, t, n) {
        return Ue.apply(this, arguments);
      }
      function Ue() {
        return (Ue = Re(_regeneratorRuntime().mark(function e(t, n, r) {
          var o, i, a, s, l;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (n) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Error calling method setEndConferenceOnExit(). <string>participantSid is a required parameter.");
              case 2:
                if (void 0 !== t.attributes) {
                  e.next = 4;
                  break;
                }
                throw new Error("Task's attributes are not set");
              case 4:
                return e.next = 6, Ie(t);
              case 6:
                return o = e.sent, i = o.find(function (e) {
                  return "voice" === e.type;
                }).sid, a = G(t), s = z("interactionModifyParticipant", a, i, n).path, l = {
                  media_properties: {
                    end_conference_on_exit: r
                  }
                }, e.abrupt("return", j(s, l));
              case 12:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function He(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function We(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              He(i, r, o, a, s, "next", e);
            }
            function s(e) {
              He(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Ve(e, t, n, r) {
        return ze.apply(this, arguments);
      }
      function ze() {
        return (ze = We(_regeneratorRuntime().mark(function e(t, n, r, o) {
          var i, a, s, l, c;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (n) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Error calling method ".concat(o, "(). <string>participantSid is a required parameter."));
              case 2:
                if (void 0 !== t.attributes) {
                  e.next = 4;
                  break;
                }
                throw new Error("Task's attributes are not set");
              case 4:
                return e.next = 6, Ie(t);
              case 6:
                return i = e.sent, a = i.find(function (e) {
                  return "voice" === e.type;
                }).sid, s = G(t), l = z("interactionModifyParticipant", s, a, n).path, c = {
                  media_properties: r
                }, e.abrupt("return", j(l, c));
              case 12:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function Ge(e, t, n, r) {
        return qe.apply(this, arguments);
      }
      function qe() {
        return (qe = We(_regeneratorRuntime().mark(function e(t, n, r, o) {
          var i, a;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return a = new Promise(function (e, n) {
                  t.on("participantModified", function n(r, o) {
                    var a;
                    o.participant_sid === (null === (a = i) || void 0 === a ? void 0 : a.sid) && (t.removeListener("participantModified", n), e(new _e(o)));
                  }), t.on("participantModifyFailed", function e(r, o) {
                    var a;
                    o.participant_sid === (null === (a = i) || void 0 === a ? void 0 : a.sid) && (t.removeListener("participantModifyFailed", e), n(new J.a(o, "Failed to modify Participant to Task sid=".concat(t.sid))));
                  });
                }), e.next = 3, Ve(t, n, r, o);
              case 3:
                return i = e.sent, e.abrupt("return", q(a, "Task.participantModified"));
              case 5:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function Qe(e, t) {
        return Ge(e, t, {
          hold: !0
        }, "holdParticipant");
      }
      function Ke(e, t) {
        return Ge(e, t, {
          hold: !1
        }, "unHoldParticipant");
      }
      function Ye(e) {
        return e.participant_sid;
      }
      function Xe(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function Je(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Xe(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Xe(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Ze(e, t) {
        return $e.apply(this, arguments);
      }
      function $e() {
        return ($e = Je(_regeneratorRuntime().mark(function e(t, n) {
          var r, o, i, a, s;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return o = new Promise(function (e, n) {
                  t.on("participantAdded", function n(o, i) {
                    var a;
                    Ye(i) === (null === (a = r) || void 0 === a ? void 0 : a.sid) && (t.removeListener("participantAdded", n), e(new _e(i)));
                  }), t.on("participantAddFailed", function e(o, i) {
                    var a;
                    if (Ye(i) === (null === (a = r) || void 0 === a ? void 0 : a.sid)) {
                      t.removeListener("participantAddFailed", e);
                      var s = i.error_data && i.error_data.error_message;
                      n(new J.a(i, "Failed to add Participant to Task sid=".concat(t.sid, ". Reason: ").concat(s)));
                    }
                  });
                }), i = G(t), a = t.attributes.flexInteractionChannelSid, s = z("interactionAddParticipant", i, a).path, e.next = 6, j(s, n);
              case 6:
                return r = e.sent, e.abrupt("return", q(o, "Task.participantAdded"));
              case 8:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function et(e, t) {
        return tt.apply(this, arguments);
      }
      function tt() {
        return (tt = Je(_regeneratorRuntime().mark(function e(t, n) {
          var r;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (t.attributes && "email" === t.attributes.channelType) {
                  e.next = 2;
                  break;
                }
                throw new Error("Wrong channel type - addParticipant expects the task to have an email channel");
              case 2:
                if (t.attributes && t.attributes.flexInteractionChannelSid) {
                  e.next = 4;
                  break;
                }
                throw new TypeError("Failed to add Participant to Task sid=".concat(t.sid, ". Missing flexInteractionChannelSid."));
              case 4:
                return r = {
                  type: ye.Customer,
                  media_properties: {
                    level: n.level,
                    name: n.toName,
                    address: n.address,
                    type: Ce.Email
                  }
                }, e.abrupt("return", Ze(t, r));
              case 6:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function nt(e, t) {
        return rt.apply(this, arguments);
      }
      function rt() {
        return (rt = Je(_regeneratorRuntime().mark(function e(t, n) {
          var r;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (o.a.isString(n.from) && n.from) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Error calling method addSmsParticipant(). <string>from is a required parameter.");
              case 2:
                if (o.a.isString(n.to) && n.to) {
                  e.next = 4;
                  break;
                }
                throw new TypeError("Error calling method addSmsParticipant(). <string>to is a required parameter.");
              case 4:
                if (t.attributes && "sms" === t.attributes.channelType) {
                  e.next = 6;
                  break;
                }
                throw new Error("Wrong channel type - addSmsParticipant expects the task to have a sms channel");
              case 6:
                if (t.attributes && t.attributes.flexInteractionChannelSid) {
                  e.next = 8;
                  break;
                }
                throw new Error("Failed to add Participant to Task sid=".concat(t.sid, ". Missing flexInteractionChannelSid."));
              case 8:
                return r = {
                  type: ye.Customer,
                  media_properties: {
                    address: n.to,
                    proxy_address: n.from,
                    type: Ce.Sms
                  }
                }, e.abrupt("return", Ze(t, r));
              case 10:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function ot(e, t) {
        return it.apply(this, arguments);
      }
      function it() {
        return (it = Je(_regeneratorRuntime().mark(function e(t, n) {
          var r;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (o.a.isString(n.from) && n.from) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Error calling method addWhatsAppParticipant(). <string>from is a required parameter.");
              case 2:
                if (o.a.isString(n.to) && n.to) {
                  e.next = 4;
                  break;
                }
                throw new TypeError("Error calling method addWhatsAppParticipant(). <string>to is a required parameter.");
              case 4:
                if (t.attributes && "whatsapp" === t.attributes.channelType) {
                  e.next = 6;
                  break;
                }
                throw new Error("Wrong channel type - addWhatsAppParticipant expects the task to have a whatsapp channel");
              case 6:
                if (t.attributes && t.attributes.flexInteractionChannelSid) {
                  e.next = 8;
                  break;
                }
                throw new Error("Failed to addWhatsAppParticipant to Task sid=".concat(t.sid, ". Missing flexInteractionChannelSid."));
              case 8:
                return r = {
                  type: ye.Customer,
                  media_properties: {
                    address: n.to,
                    proxy_address: n.from,
                    type: Ce.WhatsApp
                  }
                }, e.abrupt("return", Ze(t, r));
              case 10:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function at(e, t) {
        return st.apply(this, arguments);
      }
      function st() {
        return (st = Je(_regeneratorRuntime().mark(function e(t, n) {
          var r;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (o.a.isString(n.identity) && n.identity) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Error calling method addWebChatParticipant(). <string>participantIdentity is a required parameter.");
              case 2:
                if (t.attributes && "web" === t.attributes.channelType) {
                  e.next = 4;
                  break;
                }
                throw new Error("Wrong channel type - addWebChatParticipant expects the task to have a web channel");
              case 4:
                if (t.attributes && t.attributes.flexInteractionChannelSid) {
                  e.next = 6;
                  break;
                }
                throw new Error("Failed to addWebChatParticipant to Task sid=".concat(t.sid, ". Missing flexInteractionChannelSid."));
              case 6:
                return r = {
                  type: ye.Customer,
                  media_properties: {
                    identity: n.identity,
                    type: Ce.Web
                  }
                }, e.abrupt("return", Ze(t, r));
              case 8:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function lt(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function ct(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              lt(i, r, o, a, s, "next", e);
            }
            function s(e) {
              lt(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function ut(e, t) {
        return pt.apply(this, arguments);
      }
      function pt() {
        return (pt = ct(_regeneratorRuntime().mark(function e(t, n) {
          var r, o, i, a, s, l, c;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (t.attributes) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Failed to addVoiceParticipant in Task sid=".concat(t.sid, ". Missing attributes."));
              case 2:
                return o = new Promise(function (e, n) {
                  t.on("participantAdded", function n(o, i) {
                    var a;
                    i.participant_sid === (null === (a = r) || void 0 === a ? void 0 : a.sid) && (t.removeListener("participantAdded", n), e(new _e(i)));
                  }), t.on("participantAddFailed", function e(o, i) {
                    var a;
                    i.participant_sid === (null === (a = r) || void 0 === a ? void 0 : a.sid) && (t.removeListener("participantAddFailed", e), n(new J.a(i, "Failed to add Participant from Task sid=".concat(t.sid, "."))));
                  });
                }), i = G(t), e.next = 6, Ie(t);
              case 6:
                return a = e.sent, s = a.find(function (e) {
                  return "voice" === e.type;
                }).sid, l = z("interactionAddParticipant", i, s).path, c = {
                  type: n.type,
                  media_properties: {
                    coordinates: {
                      from: n.from,
                      to: n.to
                    }
                  }
                }, e.next = 12, j(l, c);
              case 12:
                return r = e.sent, e.abrupt("return", {
                  pendingParticipantResponse: r,
                  waitForParticipantToSettle: q(o, "Task.participantAdded", 3e5)
                });
              case 15:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function dt(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function ft(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              dt(i, r, o, a, s, "next", e);
            }
            function s(e) {
              dt(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function ht(e, t) {
        return mt.apply(this, arguments);
      }
      function mt() {
        return (mt = ft(_regeneratorRuntime().mark(function e(t, n) {
          var r, o, i, a, s, l, c;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (null !== (r = t.attributes) && void 0 !== r && r.flexInteractionChannelSid) {
                  e.next = 2;
                  break;
                }
                throw new Error("Failed to remove a participant from the Task sid=".concat(t.sid, ". Missing flexInteractionChannelSid."));
              case 2:
                return i = new Promise(function (e, n) {
                  t.on("participantRemoved", function n(r, i) {
                    var a;
                    Ye(i) === (null === (a = o) || void 0 === a ? void 0 : a.sid) && (t.removeListener("participantRemoved", n), e(new _e(i)));
                  }), t.on("participantRemoveFailed", function e(r, i) {
                    var a;
                    Ye(i) === (null === (a = o) || void 0 === a ? void 0 : a.sid) && (t.removeListener("participantRemoveFailed", e), n(new J.a(i, "Failed to remove Participant from Task sid=".concat(t.sid, ". Reason: ").concat(i.reason))));
                  });
                }), a = t.attributes.flexInteractionChannelSid, s = G(t), l = z("interactionModifyParticipant", s, a, n).path, c = {
                  status: "close"
                }, e.next = 9, j(l, c);
              case 9:
                return o = e.sent, e.abrupt("return", q(i, "Task.participantRemoved"));
              case 11:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function gt(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function yt(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              gt(i, r, o, a, s, "next", e);
            }
            function s(e) {
              gt(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function vt(e, t) {
        return bt.apply(this, arguments);
      }
      function bt() {
        return (bt = yt(_regeneratorRuntime().mark(function e(t, n) {
          var r, o, i, a, s, l, c;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return o = new Promise(function (e, n) {
                  t.on("participantRemoved", function n(o, i) {
                    var a;
                    Ye(i) === (null === (a = r) || void 0 === a ? void 0 : a.sid) && (t.removeListener("participantRemoved", n), e(new _e(i)));
                  }), t.on("participantRemoveFailed", function e(o, i) {
                    var a;
                    Ye(i) === (null === (a = r) || void 0 === a ? void 0 : a.sid) && (t.removeListener("participantRemoveFailed", e), n(new J.a(i, "Failed to remove Participant from Task sid=".concat(t.sid, ". Reason: ").concat(i.reason))));
                  });
                }), e.next = 3, Ie(t);
              case 3:
                return i = e.sent, a = i.find(function (e) {
                  return "voice" === e.type;
                }).sid, s = G(t), l = z("interactionModifyParticipant", s, a, n).path, c = {
                  status: "close"
                }, e.next = 10, j(l, c);
              case 10:
                return r = e.sent, e.abrupt("return", q(o, "Task.participantRemoved"));
              case 12:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function Ct(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function _t(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Ct(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Ct(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function kt(e, t, n, r) {
        return wt.apply(this, arguments);
      }
      function wt() {
        return (wt = _t(_regeneratorRuntime().mark(function e(t, n, r, o) {
          var i, a, s, l, c, u;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (o.to) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>to is a required parameter.");
              case 2:
                if (o.from) {
                  e.next = 4;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>from is a required parameter.");
              case 4:
                if (n) {
                  e.next = 6;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>workflowSid is a required parameter.");
              case 6:
                if (r) {
                  e.next = 8;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>taskQueueSid is a required parameter.");
              case 8:
                return a = z("createInteraction").path, s = {
                  channel: {
                    type: Ce.Email,
                    initiated_by: "agent",
                    properties: {
                      type: Ce.Email,
                      direction: "outbound",
                      from_name: o.fromName || "",
                      from: o.from
                    },
                    participants: [{
                      level: "to",
                      name: o.toName || "",
                      address: o.to,
                      type: Ce.Email
                    }]
                  },
                  routing: {
                    type: "TaskRouter",
                    properties: {
                      workspace_sid: t.workspaceSid,
                      workflow_sid: n,
                      task_channel_unique_name: "email",
                      queue_sid: r,
                      worker_sid: t.sid,
                      attributes: {}
                    }
                  }
                }, l = o.taskChannelSid, c = o.taskUniqueChannelName, s.taskChannelSid = l, s.taskUniqueChannelName = c, s.routing.properties.attributes = null !== (i = o.attributes) && void 0 !== i ? i : {}, e.next = 16, j(a, s);
              case 16:
                return u = e.sent, e.abrupt("return", {
                  interactionSid: u.sid,
                  taskSid: u.routing.properties.sid
                });
              case 18:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function St(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function Pt(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? St(Object(n), !0).forEach(function (t) {
            Tt(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : St(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function Tt(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function Ot(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function xt(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Ot(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Ot(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Et(e, t, n, r) {
        return At.apply(this, arguments);
      }
      function At() {
        return (At = xt(_regeneratorRuntime().mark(function e(t, n, r, o) {
          var i, a, s, l, c;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (o.to) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>to is a required parameter.");
              case 2:
                if (o.from) {
                  e.next = 4;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>from is a required parameter.");
              case 4:
                if (n) {
                  e.next = 6;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>workflowSid is a required parameter.");
              case 6:
                if (r) {
                  e.next = 8;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>taskQueueSid is a required parameter.");
              case 8:
                return i = z("createInteraction").path, a = {
                  channel: {
                    type: Ce.Sms,
                    initiated_by: "agent",
                    properties: {
                      type: Ce.Sms
                    },
                    participants: [{
                      address: o.to,
                      proxy_address: o.from
                    }]
                  },
                  routing: {
                    type: "TaskRouter",
                    properties: {
                      workspace_sid: t.workspaceSid,
                      workflow_sid: n,
                      task_channel_unique_name: "sms",
                      queue_sid: r,
                      worker_sid: t.sid,
                      attributes: {
                        customerName: o.toName || "",
                        customerAddress: o.to
                      }
                    }
                  }
                }, s = o.taskChannelSid, l = o.taskUniqueChannelName, a.taskChannelSid = s, a.taskUniqueChannelName = l, a.routing.properties.attributes = Pt(Pt({}, a.routing.properties.attributes), o.attributes), e.next = 16, j(i, a);
              case 16:
                return c = e.sent, e.abrupt("return", {
                  interactionSid: c.sid,
                  taskSid: c.routing.properties.sid
                });
              case 18:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function It(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function jt(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? It(Object(n), !0).forEach(function (t) {
            Lt(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : It(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function Lt(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function Mt(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function Ft(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Mt(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Mt(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Dt(e, t, n, r) {
        return Nt.apply(this, arguments);
      }
      function Nt() {
        return (Nt = Ft(_regeneratorRuntime().mark(function e(t, n, r, o) {
          var i, a, s, l, c;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (o.to) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>to is a required parameter.");
              case 2:
                if (o.from) {
                  e.next = 4;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>from is a required parameter.");
              case 4:
                if (n) {
                  e.next = 6;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>workflowSid is a required parameter.");
              case 6:
                if (r) {
                  e.next = 8;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>taskQueueSid is a required parameter.");
              case 8:
                return i = z("createInteraction").path, a = {
                  channel: {
                    type: Ce.WhatsApp,
                    initiated_by: "agent",
                    properties: {
                      type: Ce.WhatsApp
                    },
                    participants: [{
                      address: o.to,
                      proxy_address: o.from
                    }]
                  },
                  routing: {
                    type: "TaskRouter",
                    properties: {
                      workspace_sid: t.workspaceSid,
                      workflow_sid: n,
                      queue_sid: r,
                      worker_sid: t.sid,
                      attributes: {
                        customerName: o.toName || "",
                        customerAddress: o.to
                      }
                    }
                  }
                }, s = o.taskChannelSid, l = o.taskUniqueChannelName, a.taskChannelSid = s, a.taskUniqueChannelName = l, a.routing.properties.attributes = jt(jt({}, a.routing.properties.attributes), o.attributes), e.next = 16, j(i, a);
              case 16:
                return c = e.sent, e.abrupt("return", {
                  interactionSid: c.sid,
                  taskSid: c.routing.properties.sid
                });
              case 18:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function Rt(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function Bt(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Rt(Object(n), !0).forEach(function (t) {
            Ut(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rt(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function Ut(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function Ht(e, t, n, r, o, i, a) {
        try {
          var s = e[i](a),
            l = s.value;
        } catch (e) {
          return void n(e);
        }
        s.done ? t(l) : Promise.resolve(l).then(r, o);
      }
      function Wt(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Ht(i, r, o, a, s, "next", e);
            }
            function s(e) {
              Ht(i, r, o, a, s, "throw", e);
            }
            a(void 0);
          });
        };
      }
      function Vt(e, t, n, r) {
        return zt.apply(this, arguments);
      }
      function zt() {
        return (zt = Wt(_regeneratorRuntime().mark(function e(t, n, r, o) {
          var i, a, s, l, c;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (o.to) {
                  e.next = 2;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>to is a required parameter.");
              case 2:
                if (n) {
                  e.next = 4;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>workflowSid is a required parameter.");
              case 4:
                if (r) {
                  e.next = 6;
                  break;
                }
                throw new TypeError("Error calling method createTask(). <string>taskQueueSid is a required parameter.");
              case 6:
                return i = z("createInteraction").path, a = {
                  channel: {
                    type: Ce.Web,
                    initiated_by: "agent",
                    properties: {
                      type: Ce.Web
                    },
                    participants: [{
                      identity: o.to
                    }]
                  },
                  routing: {
                    type: "TaskRouter",
                    properties: {
                      workspace_sid: t.workspaceSid,
                      workflow_sid: n,
                      task_channel_unique_name: "chat",
                      queue_sid: r,
                      worker_sid: t.sid,
                      attributes: {
                        identity: o.to
                      }
                    }
                  }
                }, s = o.taskChannelSid, l = o.taskUniqueChannelName, a.taskChannelSid = s, a.taskUniqueChannelName = l, a.routing.properties.attributes = Bt(Bt({}, a.routing.properties.attributes), o.attributes), e.next = 14, j(i, a);
              case 14:
                return c = e.sent, e.abrupt("return", {
                  interactionSid: c.sid,
                  taskSid: c.routing.properties.sid
                });
              case 16:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      function Gt(e) {
        return (Gt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function qt(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function Qt(e, t) {
        return (Qt = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function Kt(e, t) {
        if (t && ("object" === Gt(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return Yt(e);
      }
      function Yt(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function Xt(e) {
        return (Xt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function Jt(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function Zt(e, t, n) {
        !function (e, t) {
          if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
        }(e, t), t.set(e, n);
      }
      function $t(e, t) {
        return function (e, t) {
          return t.get ? t.get.call(e) : t.value;
        }(e, tn(e, t, "get"));
      }
      function en(e, t, n) {
        return function (e, t, n) {
          if (t.set) t.set.call(e, n);else {
            if (!t.writable) throw new TypeError("attempted to set read only private field");
            t.value = n;
          }
        }(e, tn(e, t, "set"), n), n;
      }
      function tn(e, t, n) {
        if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
        return t.get(e);
      }
      n(17), function (e) {
        e.Email = "email", e.Sms = "sms", e.WhatsApp = "whatsapp", e.Web = "web", e.Voice = "voice";
      }(Ce || (Ce = {}));
      var nn = new WeakMap(),
        rn = new WeakMap(),
        on = new WeakMap(),
        an = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            Object.defineProperty(e, "prototype", {
              value: Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }),
              writable: !1
            }), t && Qt(e, t);
          }(i, e);
          var t,
            n,
            r = function (e) {
              var t = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }();
              return function () {
                var n,
                  r = Xt(e);
                if (t) {
                  var o = Xt(this).constructor;
                  n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return Kt(this, n);
              };
            }(i);
          function i(e, t) {
            var n, a;
            if (function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, i), Zt(Yt(n = r.call(this)), nn, {
              writable: !0,
              value: void 0
            }), Zt(Yt(n), rn, {
              writable: !0,
              value: void 0
            }), Zt(Yt(n), on, {
              writable: !0,
              value: void 0
            }), Jt(Yt(n), "addEmailParticipant", et), Jt(Yt(n), "addSmsParticipant", nt), Jt(Yt(n), "addWhatsAppParticipant", ot), Jt(Yt(n), "addWebChatParticipant", at), Jt(Yt(n), "addVoiceParticipant", ut), Jt(Yt(n), "removeParticipant", ht), Jt(Yt(n), "removeVoiceParticipant", vt), Jt(Yt(n), "getChannels", Ie), Jt(Yt(n), "getParticipants", Oe), Jt(Yt(n), "acceptReservation", ee), Jt(Yt(n), "completeReservation", Y), Jt(Yt(n), "holdParticipant", Qe), Jt(Yt(n), "unHoldParticipant", Ke), Jt(Yt(n), "endConference", Fe), Jt(Yt(n), "setEndConferenceOnExit", Be), Jt(Yt(n), "rejectReservation", oe), Jt(Yt(n), "wrapReservation", le), Jt(Yt(n), "createEmailTask", kt), Jt(Yt(n), "createWhatsAppTask", Dt), Jt(Yt(n), "createSmsTask", Et), Jt(Yt(n), "createWebTask", Vt), !o.a.isString(e) || !e) throw new TypeError("Failed to instantiate CbmSdkClient. <string>token is a required parameter.");
            return en(Yt(n), nn, t.logLevel || p.Error), en(Yt(n), rn, new b(e, t)), en(Yt(n), on, new m("Worker-".concat($t(Yt(n), rn).getLogIdentifier()), $t(Yt(n), nn))), function (e) {
              if (!(e instanceof b)) throw new TypeError("Failed to initialize Request. <Configuration>userConfig is a required parameter.");
              O = e;
            }($t(Yt(n), rn)), a = t.eventsTimeout, H = a || C.DEFAULT_EVENTS_TIMEOUT, n;
          }
          return t = i, (n = [{
            key: "getLogger",
            value: function value(e) {
              return new m("".concat(e), $t(this, rn).logLevel);
            }
          }, {
            key: "updateToken",
            value: function value(e) {
              if (!o.a.isString(e) || !e) throw new TypeError("To update the Twilio token, a new Twilio token must be passed in. <string>newToken is a required parameter.");
              $t(this, on).info("Proceeding to update the CbmSdkClient's current active token with a new token."), $t(this, on).debug("New token: ".concat(e));
              try {
                $t(this, rn).updateToken(e), this.emit("tokenUpdated");
              } catch (e) {
                this.emit("error", e);
              }
            }
          }]) && qt(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), i;
        }(i.EventEmitter),
        sn = (n(44), n(32));
      function ln(e) {
        return (ln = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function cn(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function un(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function pn() {
        return (pn = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
          var r = dn(e, t);
          if (r) {
            var o = Object.getOwnPropertyDescriptor(r, t);
            return o.get ? o.get.call(arguments.length < 3 ? e : n) : o.value;
          }
        }).apply(this, arguments);
      }
      function dn(e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = mn(e)););
        return e;
      }
      function fn(e, t) {
        return (fn = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function hn(e, t) {
        if (t && ("object" === ln(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }
      function mn(e) {
        return (mn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      var gn = {
          "participant.added": "participantAdded",
          "participant.add.failed": "participantAddFailed",
          "participant.removed": "participantRemoved",
          "participant.remove.failed": "participantRemoveFailed",
          "participant.modified": "participantModified",
          "participant.modify.failed": "participantModifyFailed"
        },
        yn = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            Object.defineProperty(e, "prototype", {
              value: Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }),
              writable: !1
            }), t && fn(e, t);
          }(o, e);
          var t,
            n,
            r = function (e) {
              var t = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }();
              return function () {
                var n,
                  r = mn(e);
                if (t) {
                  var o = mn(this).constructor;
                  n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return hn(this, n);
              };
            }(o);
          function o(e) {
            var t,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return cn(this, o), (t = r.call(this, e, n))._worker = e, t._logLevel = n.logLevel || p.Error, t._log = new m("ParticipantEventHandler", t._logLevel), t;
          }
          return t = o, (n = [{
            key: "getTREventsToHandlerMapping",
            value: function value() {
              var e = pn(mn(o.prototype), "getTREventsToHandlerMapping", this).call(this);
              return e["participant.added"] = "_participantEventHandler", e["participant.add.failed"] = "_participantEventHandler", e["participant.removed"] = "_participantEventHandler", e["participant.remove.failed"] = "_participantEventHandler", e["participant.modified"] = "_participantEventHandler", e["participant.modify.failed"] = "_participantEventHandler", e;
            }
          }, {
            key: "_participantEventHandler",
            value: function value(e, t) {
              var n = gn[t];
              this._log.info("Worker %s received Event: %s mapped to %s.", this._worker.sid, t, n);
              var r = e.routing_properties && e.routing_properties.task_sid;
              if (!r) throw this._log.error("Event: participant.%s did not contain a Task sid. Unable to emit event for Worker %s.", n, this._worker.sid), new Error("Failed to emit event for Worker ".concat(this._worker.sid, "."));
              var o = this._worker._dataServices.reservationsEntity.getTasks(r);
              o && o.length > 0 ? o[0]._emitEvent(n, e) : this._log.warn("The task specified by Event: participant.%s does not exist in Worker %s Reservations map. Skipping event.", n, this._worker.sid);
            }
          }]) && un(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), o;
        }(sn.TaskRouterEventHandler);
    }]);
  }, function (e, t) {
    e.exports = require("core-js/modules/es.object.to-string.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.promise.js");
  }, function (e, t) {
    e.exports = require("regenerator-runtime/runtime.js");
  }, function (e, t) {
    e.exports = require("lodash");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.symbol.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/web.dom-collections.for-each.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.array.iterator.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.string.iterator.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/web.dom-collections.iterator.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.array.concat.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.array.filter.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.object.get-own-property-descriptor.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.object.keys.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.object.get-own-property-descriptors.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.array.find.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.symbol.description.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.symbol.iterator.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.weak-map.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.object.get-prototype-of.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.reflect.construct.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.array.slice.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.function.name.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.array.join.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.regexp.exec.js");
  }, function (e, t) {
    e.exports = require("lodash/camelCase");
  }, function (e, t) {
    e.exports = require("lodash/transform");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.object.freeze.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.array.reduce.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.regexp.to-string.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.map.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/esnext.global-this.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.string.match.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.string.replace.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.array.splice.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.string.split.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.array.map.js");
  }, function (e, t) {
    e.exports = require("core-js/modules/es.reflect.get.js");
  }, function (e, t) {
    e.exports = require("twilio-chat");
  }, function (e, t) {
    e.exports = require("twilio-sync");
  }, function (e, t) {
    e.exports = require("history");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
      i = '\n<h1>TASK CONTEXT</h1>\n<h2>Task type</h2>\n<p data-test="task-type">{{task.channelType}}</p>\n<h2>Task created on</h2>\n<p data-test="task-created-on">{{task.dateCreated}}</p>\n<h2>Task priority</h2>\n<p data-test="task-priority">{{task.priority}}</p>\n<h2>Task queue</h2>\n<p data-test="task-queue">{{task.queueName}}</p>\n<h2>Task Sid</h2>\n<p data-test="task-sid">{{task.taskSid}}</p>\n<h2>Reservation Sid</h2>\n<p data-test="reservation-sid">{{task.sid}}</p>\n{{#if task.attributes.subject}}\n<h2>Subject</h2>\n<p data-test="reservation-sid">{{task.attributes.subject}}</p>\n{{/if}}\n<hr />\n<h1>CUSTOMER CONTEXT</h1>\n<h2>Customer name / {{#if task.attributes.senderAddress}}email address{{else}}phone number{{/if}}</h2>\n<p data-test="customer-name-number">{{task.defaultFrom}}</p>\n<h2>Country</h2>\n<p data-test="customer-country">{{task.attributes.caller_country}}</p>\n<hr />\n<h1>ADDONS</h1>\n<p>\n    No add-ons enabled.\n    To expand your experience, visit\n</p>\n<a href="https://www.twilio.com/marketplace/add-ons" target="blank">Twilio Marketplace</a>',
      a = r(r({}, o.languages.default), {
        SetYourStatus: "Set your status",
        LogOut: "Log out",
        SigningIn: "Signing in",
        SessionExpired: "Your session has expired. <a href='#' onClick='window.location.reload()'>Click here to log in again</a>",
        NoTasksTitle: "Status",
        NoTasks: "No active tasks",
        NoTasksHintNotAvailable: "Change activity state to start receiving tasks.",
        NoTasksHintAvailable: "You are ready to start receiving tasks.",
        NoCRMConfigured: "No CRM configured",
        NoCRMConfiguredAction: "HOW TO CONFIGURE",
        NoCRMTitle: "CRM config",
        NoCRMHint: "Our docs can help you get started.",
        LoginUsername: "User Name",
        LoginPassword: "Password",
        LoginLoading: "Loading ...",
        LoginWelcome: "Hi there, welcome to Flex!",
        LoginLogin: "LOGIN",
        LoginContinue: "Continue anyway",
        LoginAgain: "Log in again",
        LoginLaunch: "Launch",
        LoginTitle: "Twilio Flex",
        LoginErrorDomain: "Oops! Your runtime domain is incorrect.",
        LoginErrorDomainDetails: "Find your runtime domain <a href='https://www.twilio.com/console/runtime/overview'>here</a>",
        LoginErrorSso: "Hmm, Single Sign-On has not been configured.",
        LoginErrorSsoDetails: "Find out how to configure Single Sign-On <a href='https://www.twilio.com/console/flex/users/single-sign-on'>here</a>",
        LoginErrorPopupBlocked: "Sorry, pop-ups are blocked.",
        LoginErrorPopupBlockedDetails: "<a href='https://support.google.com/chrome/answer/95472'>Find out how to enable pop-ups in your browser</a>",
        LoginErrorUntrustedDomain: "Trusted Login has not been enabled for this domain.",
        LoginErrorUntrustedDomainDetails: "Find out how to configure Single Sign-On <a href='https://www.twilio.com/docs/flex/configuring-single-sign-and-identity-provider-integration#how-do-i-login-to-a-self-hosted-domain' target='_blank'>here</a>",
        LoginErrorInvalidCertificate: "Invalid SSO Settings",
        LoginErrorInvalidCertificateDetails: "This may be caused by malformed urls or missing/invalid certificates.<br><br>Please reconfigure the <a href='https://www.twilio.com/docs/api/errors/70251' target='_blank'>SSO settings</a> and retry.",
        LoginErrorGeneric: "Oops! Well, that didn't work :( Please double check your configuration.",
        LoginIsAdmin: "Flex Admin?",
        LoginWithTwilio: "Log in with Twilio.",
        ErrorPageRetryButton: "RETRY",
        ErrorPageDownloadReportButton: "DOWNLOAD REPORT",
        TaskHeaderLeaveCall: "LEAVE CALL",
        TaskHeaderEndCall: "HANG UP",
        TaskHeaderXWTEndCall: "End call",
        TaskHeaderXWTLeaveCall: "Leave the call",
        TaskHeaderXWTEndForAll: "End call for everyone",
        TaskHeaderWrapup: "WRAP UP",
        TaskHeaderComplete: "COMPLETE",
        TaskHeaderEndChat: "END CHAT",
        TaskHeaderStatusPending: "",
        TaskHeaderStatusAccepted: "Live | {{helper.durationSinceUpdate}}",
        TaskHeaderWebChatStatusAccepted: "{{#if helper.chat.isCustomerOnline}} {{{icon name='GreenIndicator'}}} {{else}} {{{icon name='GreyIndicator'}}} {{/if}} Live | {{helper.durationSinceUpdate}}",
        TaskHeaderGroupCallAccepted: "Live | {{helper.durationSinceUpdate}} | {{{icon name='Participant'}}} {{task.conference.liveParticipantCount}}",
        TaskHeaderStatusWrapup: "Wrap up | {{helper.durationSinceUpdate}}",
        TaskHeaderStatusCompleted: "Completed | {{helper.durationSinceUpdate}}",
        SideNavInsightsAgentsView: "Agents",
        SideNavInsightsAnalyzeView: "Analyze",
        SideNavInsightsDashboardsView: "Dashboards",
        SideNavInsightsInspectionsView: "Inspections",
        SideNavInsightsQuestionnairesView: "Questionnaires",
        SideNavInsightsSpeechSearchesView: "Speech Searches",
        SideNavTaskView: "Agent Desktop",
        SideNavTeamsView: "Teams",
        SideNavAgentDashboard: "Agent Dashboard",
        SideNavSupervisorInspections: "Supervisor Inspections",
        SideNavSupervisorDashboard: "Supervisor Dashboard",
        SideNavSupervisorReports: "Supervisor Reports",
        SideNavSettings: "Settings",
        SideNavQueuesStatsView: "Queues Stats",
        TaskHeaderLine: "{{task.defaultFrom}}",
        TaskExtraInfo: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        TaskLineCallIncomingTitle: "Incoming call",
        TaskLineCallTransferTitle: "Transfer request",
        TaskLineCallEndedTitle: "Call ended",
        TaskLineQueue: "Queue: {{task.queueName}}",
        TaskLineCallDuration: "{{helper.durationSinceUpdate}}",
        TaskLineCallReserved: "Incoming call from queue {{task.queueName}}",
        TaskLineCallAssigned: "Live | {{helper.durationSinceUpdate}}",
        TaskLineCallWrapup: "Wrap up | {{helper.durationSinceUpdate}}",
        TaskLineGroupCallAssigned: "Live | {{helper.durationSinceUpdate}} | {{{icon name='Participant'}}} {{task.conference.liveParticipantCount}}",
        TaskLineCallTransferWorker: "Request from {{task.incomingTransferObject.worker.fullName}} (direct)",
        TaskLineCallTransferWorkerDetail: "From: {{task.incomingTransferObject.worker.fullName}} (direct)<br />Queue: {{task.queueName}}",
        TaskLineCallTransferQueue: "Request from {{task.incomingTransferObject.worker.fullName}} ({{task.incomingTransferObject.queue.name}})",
        TaskLineCallTransferQueueDetail: "From: {{task.incomingTransferObject.worker.fullName}}<br />Queue: {{task.queueName}}",
        TaskLineOutboundCallTitle: "Connecting Call",
        TaskLineOutboundCallHeader: "{{task.attributes.outbound_to}}",
        TaskLineOutboundCallDetail: "Your caller ID: {{task.attributes.from}}<br />Queue: {{task.queueName}}",
        TaskLineChatReserved: "Incoming chat request",
        TaskLineChatLineReserved: "Incoming Line request",
        TaskLineChatMessengerReserved: "Incoming Messenger request",
        TaskLineChatWhatsAppReserved: "Incoming WhatsApp request",
        TaskLineSmsReserved: "Incoming SMS request",
        TaskLineEmailReserved: "Incoming Email request",
        TaskLineChatAssigned: "{{helper.durationSinceUpdate}} | {{#if helper.chat.typers.length}} typing … {{else}} {{#if helper.chat.lastMessage}} {{helper.chat.lastMessage.authorName}}: {{helper.chat.lastMessage.source.body}}{{else}}No messages{{/if}}{{/if}}",
        TaskLineWebChatAssigned: "{{#if helper.chat.isCustomerOnline}} {{{icon name='GreenIndicator'}}} {{else}} {{{icon name='GreyIndicator'}}} {{/if}}{{helper.durationSinceUpdate}} | {{#if helper.chat.typers.length}} typing …{{else}} {{#if helper.chat.lastMessage}} {{helper.chat.lastMessage.authorName}}: {{#if helper.chat.lastMessage.source.body}}{{helper.chat.lastMessage.source.body}}{{else}}{{#if helper.chat.lastMessage.error}}<span class='error'>Sending failed</span>{{else}}File sent{{/if}}{{/if}}{{else}}No messages{{/if}}{{/if}}",
        TaskLineTitle: "",
        TaskReserved: "Reserved",
        TaskAssigned: "Assigned",
        TaskWrapup: "In wrap up",
        TaskCompleted: "Completed",
        TaskCanceled: "Canceled",
        TaskFilterAll: "ALL TASKS",
        TaskFilterActive: "ACTIVE TASKS",
        TaskFilterWrapping: "TASKS IN WRAP UP",
        TaskInfoPanelContent: i,
        ColumnHeaderAgent: "AGENT",
        ColumnHeaderCalls: "CALLS",
        ColumnHeaderTasks: "OTHER TASKS",
        SupervisorUserCardFirstLine: "{{worker.fullName}}",
        SupervisorUserCardSecondLine: "{{worker.activityName}} | {{worker.activityDuration}}",
        SupervisorTaskViewContentHeader: "{{worker.fullName}}, {{task.defaultFrom}}",
        SupervisorTaskHeaderLine: "{{task.defaultFrom}}",
        SupervisorTaskLive: "{{helper.durationSinceUpdateShort}}",
        SupervisorTaskGroupCall: "{{helper.durationSinceUpdateShort}} | ({{task.conference.liveParticipantCount}})",
        SupervisorTaskWrapUp: "Wrap up | {{helper.durationSinceUpdateShort}}",
        SupervisorTaskCompleted: "Completed | {{helper.durationSinceUpdateShort}}",
        SupervisorTaskCardHeader: "{{task.defaultFrom}}",
        SupervisorTaskInfoPanelContent: i,
        LiveCommsMonitoringMessage: "You are listening to a call with {{task.defaultFrom}} and {{worker.fullName}}",
        LiveCommsMonitoringMessageMoreWorkers: "You are listening to a call with {{task.defaultFrom}} and {{workers.length}} workers",
        LiveCommsMonitoringMessageNoWorkers: "You are listening to a call with {{task.defaultFrom}}",
        LiveCommsOngoingCallMessage: "You are on a call with {{task.defaultFrom}}",
        LiveCommsBarReturnToCall: "RETURN",
        LiveCommsBarStopListening: "STOP LISTENING",
        LiveCommsBarHold: "HOLD",
        LiveCommsBarUnHold: "UNHOLD",
        WorkerDirectoryTitle: "Transfer",
        WorkerDirectoryItemFirstLine: "{{worker.fullName}}",
        WorkerDirectoryItemSecondLine: "{{worker.activityName}}",
        WorkerDirectoryAgentsTabLabel: "AGENTS",
        WorkerDirectoryQueuesTabLabel: "QUEUES",
        WorkerDirectoryDirectoryTabLabel: "DIRECTORY",
        WorkerDirectoryDialpadTabLabel: "DIALPAD",
        WorkerDirectoryQueueItemText: "{{queue.name}}",
        WorkerDirectorySearchPlaceholder: "Search",
        ChatInputDisabledText: "Conversation ended",
        WorkerCanvasHeader: "Profile",
        WorkerCanvasDetailsHeader: "Agent Details",
        WorkerCanvasSkillsHeader: "Skills",
        WorkerSkillLevelInvalid: "Please select a skill level between {{min}} - {{max}}",
        WorkerSkillPleaseSelect: "Add skill",
        WorkerSkillsNoSkills: "No skills attributed",
        WorkerSkillsSchemaMismatch: "Worker skills schema mismatch",
        WorkerSkillsSaved: "Changes saved successfully",
        WorkerSkillsError: "Failed to save changes",
        WorkerSkillsReverted: "Changes reverted",
        ChatWelcomeText: "Conversation started with customer",
        UiVersionDeprecated: "{{message}}",
        RuntimeLoginLabel: "Runtime domain",
        RuntimeLoginPlaceholder: "Your Runtime Domain",
        RuntimeLoginLaunch: "Launch",
        RuntimeLoginWithTwilio: "Login with Twilio.",
        RuntimeLoginIsAdmin: "Flex Admin?",
        RuntimeLoginErrorDomain: "Oops! Well, that didn’t work :( Check your <b>domain</b>.",
        RuntimeLoginErrorSso: "Oops! Well, that didn’t work :( Check your <b>SSO</b> setup.",
        TransferFailedNotification: "Transfer failed: {{reason}}",
        TaskCannotBeTransferredNotification: "Task cannot be transferred",
        SupervisorTaskCanvasHeader: "TASK DETAILS",
        TaskTabAgentIncomingLabel: "Incoming",
        TaskTabAgentInfoLabel: "Info",
        TaskTabSupervisorOverviewLabel: "Overview",
        TaskTabSupervisorCallLabel: "Call",
        TaskTabSupervisorChatLabel: "Chat",
        TaskTabSupervisorInfoLabel: "Info",
        MicNotAvailableNotification: "Unable to access microphone, please check browser settings.",
        BrowserVoiceDisabledNotification: "Call cannot be accepted. Twilio Voice SDK has been disabled.",
        MessageSizeExceeded: "The entered character number exceeds the limit - {{currentCharCount}}/{{maxCharCount}}",
        UserControlWorkerSecondLine: "{{worker.activityName}} | {{worker.activityDuration}}",
        UserLoggedOutSuccess: "You have logged out successfully!",
        CannotChangeOtherWorkerActivity: "You cannot change an agent’s activity while they have a pending task/reservation.",
        CallCanvasWorkerOnHold: "You are on hold",
        CallCanvasUnholdWorker: "Unhold",
        CallParticipantStatusOnHold: "On Hold",
        CallParticipantStatusLive: "Live",
        CallParticipantStatusConnecting: "Calling...",
        CallParticipantStatusLeft: "Caller left",
        CallParticipantStatusTransferFailed: "No Answer",
        CallParticipantStatusKickConfirmation: "Remove from call?",
        LiveCommsIncomingDirectCallTransfer: "Request from {{task.incomingTransferObject.worker.fullName}} (direct)",
        LiveCommsIncomingQueueCallTransfer: "Request from {{task.incomingTransferObject.worker.fullName}} ({{task.incomingTransferObject.queue.name}})",
        CallParticipantCustomerName: "{{task.defaultFrom}}",
        MonitoringFailedNotification: "Monitoring attempt has failed",
        PredefinedChatMessageAuthorName: "Bot",
        PredefinedChatMessageBody: "Hi there! How can we help you today?",
        AgentStatusAvailable: "Available",
        AgentStatusBusy: "Busy",
        AgentStatusUnavailable: "Unavailable",
        AgentStatusOffline: "Offline",
        ActiveTasksTileTitle: "Active tasks",
        WaitingTasksTileTitle: "Waiting tasks",
        AgentsByActivityTileTitle: "Agents",
        LongestWaitTimeTileTitle: "Longest wait",
        QueuesNoDataHeading: "Queues",
        QueuesNoDataBodyForAdmin: "You have no Queues set up. Please configure your Queues.",
        QueuesNoDataBodyForSupervisor: "There are no Queues set up. Please contact your Administrator.",
        QueuesNoDataLinkLabelForAdmin: "Add Queue",
        PendingReservationsOnLogoutNotification: "You cannot logout while you have a pending task/reservation",
        PendingReservationsOnActivityStateChangeNotification: "You cannot update your activity while you have a pending task/reservation",
        WorkerActivityUpdateFailedNotification: "Updating activity failed (ERROR {{statusCode}}). Please try again or contact your administrator.",
        AcceptTaskTooltip: "Accept",
        RejectTaskTooltip: "Reject",
        HangupCallTooltip: "Hang up",
        LeaveCallTooltip: "Leave",
        MuteCallTooltip: "Mute",
        HoldCustomerTooltip: "Hold Customer",
        UnholdCustomerTooltip: "Unhold Customer",
        HoldAgentTooltip: "Hold {{worker.fullName}}",
        UnholdAgentTooltip: "Unhold {{worker.fullName}}",
        CancelTransferTooltip: "Cancel Consult",
        KickAgentTooltip: "Hang up {{worker.fullName}}",
        ColdTransferTooltip: "Transfer",
        WarmTransferTooltip: "Consult",
        MonitorCallTooltip: "Monitor Call",
        OpenDialpadTooltip: "Open dialpad",
        CloseDialpadTooltip: "Close dialpad",
        OpenDirectoryTooltip: "Open directory",
        LogStatusReport: "Status report",
        LogSingleErrorTitleText: "Issue detected",
        LogSingleErrorDescriptionText: "This issue could affect your workflow. Please contact your support team.",
        LogMultipleErrorsTitleText: "Issues detected",
        LogMultipleErrorsDescriptionText: "These issues could affect your workflow. Please contact your support team.",
        LogDegradedModeErrorsDescriptionText: "You are now running in degraded mode and some functionality might be affected. Refresh or contact your administrator.",
        LogViewSingleErrorText: "View issue",
        LogHideSingleErrorText: "Hide issue",
        LogViewMultipleErrorsText: "View issues",
        LogHideMultipleErrorText: "Hide issues",
        LogSingleErrorCopyToClipboardText: "Copy to clipboard",
        LogMultipleErrorsCopyToClipboardText: "Copy all to clipboard",
        LogNoErrorsTitleText: "No issues detected",
        LogNoErrorsDescriptionText: "If you experience an issue, please download the report and send it to your support team.",
        LogDownloadReport: "Download report",
        LogClearSingleError: "Clear issue",
        LogClearMultipleErrors: "Clear issues",
        LogToFileStartLoggingText: "<div>\n    <h2>Capture logs</h2>\n    <ul>\n        <li>When you enable logging, your browser will be refreshed and logs capturing will start.</li>\n        <li>Once you are ready to finish - stop logging. All captured logs will be saved to a text file.</li>\n    </ul>\n  </div>",
        LogToFileStartLoggingLabel: "Refresh and start",
        LogToFileStopLoggingText: "<div>\n    <h2>Logging is active</h2>\n    <p>\n    If you've repeated your actions and reproduced the issue, stop logging to download the file with captured logs.\n    </p>\n  </div>",
        LogToFileStopLoggingLabel: "Finish and download",
        ChatOrchestrationAddToChatChannelFailed: "Failed to add worker to the chat channel.",
        ChatOrchestrationDeactivateChatChannelFailed: "Failed to deactivate the chat channel.",
        ChatOrchestrationLeaveChatChannelFailed: "Failed to remove worker from the chat channel.",
        TeamsViewFilterAction: "Filter{{#if filterCount}} ({{filterCount}}){{/if}}",
        TeamsViewClearSearchAction: "Clear search result",
        TeamsViewClearSearchPlaceholder: "Search Agents",
        TeamsViewResultsSummaryErrorTitle: "Something went wrong",
        TeamsViewResultsSummaryErrorMessage: "We could not load the data. Please try again or refresh the browser. If this persits, please contact your administrator.",
        TeamsViewResultsSummaryLongQueryErrorTitle: "Unable to filter results",
        TeamsViewResultsSummaryLongQueryErrorMessage: "Too many filters applied. Please select less filters and try again. If this persists, please contact your administrator.",
        TeamsViewResultsSummaryNoWorkersDisplayedTitle: "No results found",
        TeamsViewResultsSummaryNoWorkersDisplayed: "We couldn't find any agents that matched your filter criteria. You can retry with different filters.",
        TeamsViewResultsSummaryMaxWorkersDisplayed: "Showing maximum number of agents. Refine results via search or ",
        TeamsViewResultsSummaryFilterCTA: "filter",
        TeamFiltersPanelTitle: "Filters",
        TeamFiltersPanelSingularLabel: "Viewing <strong>{{number}}</strong> agent",
        TeamFiltersPanelPluralLabel: "Viewing <strong>{{number}}</strong> agents",
        TeamFiltersApply: "Apply",
        TeamFiltersReset: "Reset",
        OutboundCallFailedNotificationTitleDisabledCountry: "Calls to this country are not enabled. To enable calls and change geo permissions, contact your administrator.",
        OutboundDialerPanelTitle: "Call",
        OutboundDialerPanelPhoneInputCaption: "Enter a number",
        OutboundDialerPanelQueueSelectCaption: "Assign a queue",
        OutboundCallFailedNotificationTitle: "Unable to connect your call. Please try again or contact support. [{{reasonCode}}]",
        OutboundCallFailedNotificationTitleBusy: "This number is currently busy. Please try again.",
        OutboundCallFailedNotificationTitleNoAnswer: "No answer from this number. Please try again.",
        OutboundCallFailedNotificationTitleInvalidNumber: "Dialed number is invalid. Please check the number and try again.",
        OutboundCallFailedNotificationTitleFromNumberUnverified: "Unable to connect your call. The number being used to make outbound calls is not a verified caller ID.",
        OutboundCallFailedNotificationAction: "redial",
        OutboundErrorNotInQueue: "Cannot make call on behalf of queue ‘{{queue}}‘, because you are not assigned to this queue.",
        AudioPlayerDeniedError: "Cannot play sound, because permissions for playback of media were not given or denied. To find out more about how to fix this error, go to <a href='https://www.twilio.com/docs/flex/audio-player' target='blank'>FlexDocs</a>.",
        AudioPlayerInvalidMediaError: "Cannot play sound, because provided media is invalid.",
        AudioPlayerGenericError: "Error playing media.",
        RequestBrowserNotificationPermissions: "We need your permission to <a href='#'>enable browser notifications</a>",
        IncomingCallBrowserNotificationTitle: "Incoming call",
        IncomingCallBrowserNotificationBody: "From: {{task.defaultFrom}}",
        IncomingCallNotificationTitle: "Incoming call from {{task.defaultFrom}}",
        IncomingCallTransferNotificationTitle: "Transfer request from {{task.defaultFrom}}",
        IncomingCallTransferBrowserNotificationTitle: "Transfer request",
        IncomingCallTransferWorkerBrowserNotificationBody: "From {{task.incomingTransferObject.worker.fullName}} (direct)",
        IncomingCallTransferQueueBrowserNotificationBody: "From {{task.incomingTransferObject.worker.fullName}} ({{task.incomingTransferObject.queue.name}})",
        IncomingNotificationAccept: "accept",
        IncomingNotificationReject: "reject",
        IncomingUnregisteredTaskNotificationTitle: "Incoming task from {{task.defaultFrom}}",
        IncomingCBMTaskNotSupportedTitle: "This task isn’t fully supported in this version of Flex. Ask your admin to contact support.",
        IncomingChatNotificationTitle: "Incoming chat request from {{task.defaultFrom}}",
        IncomingLineNotificationTitle: "Incoming Line request from {{task.defaultFrom}}",
        IncomingMessengerNotificationTitle: "Incoming Messenger request from {{task.defaultFrom}}",
        IncomingWhatsAppNotificationTitle: "Incoming WhatsApp request from {{task.defaultFrom}}",
        IncomingSmsNotificationTitle: "Incoming SMS request from {{task.defaultFrom}}",
        IncomingEmailNotificationTitle: "Incoming Email request from {{task.defaultFrom}}",
        IncomingChatBrowserNotificationTitle: "Incoming chat request",
        IncomingLineBrowserNotificationTitle: "Incoming Line request",
        IncomingMessengerBrowserNotificationTitle: "Incoming Messenger request",
        IncomingWhatsAppBrowserNotificationTitle: "Incoming WhatsApp request",
        IncomingSmsBrowserNotificationTitle: "Incoming SMS request",
        IncomingEmailBrowserNotificationTitle: "Incoming Email request",
        IncomingChatBrowserNotificationBody: "From: {{task.defaultFrom}}",
        TaskTabHeaderChat: "Chat",
        TaskTabHeaderCall: "Call",
        TaskTabHeaderSMS: "SMS",
        TaskTabHeaderEmail: "Conversation",
        TaskTabHeaderMessenger: "Messenger",
        TaskTabHeaderLine: "Line",
        TaskTabHeaderWhatsApp: "WhatsApp",
        QueuesStatsHeaderQueueName: "Queues",
        QueuesStatsHeaderActiveTasks: "Active",
        QueuesStatsHeaderWaitingTasks: "Waiting",
        QueuesStatsHeaderLongestWait: "Longest",
        QueuesStatsHeaderAgentsActivity: "Agents",
        QueuesStatsHeaderSLA: "SLA",
        QueuesStatsHeaderHandled: "Handled",
        QueuesStatsHeaderAbandoned: "Abandoned",
        QueuesStatsSubHeaderNow: "Now",
        QueuesStatsSubHeader30Mins: "30 min",
        QueuesStatsSubHeaderToday: "Today",
        InsightsPlayerLoadingSegmentFailed: "Failed to fetch conversation data",
        InsightsPlayerPlaybackFailed: "Playback of the recording has failed",
        FlexInsightsLoginFailedNotificationTitle: "Flex Insights has been unable to load, please reload Flex to gain access",
        FlexInsightsDataFetchFailedNotificationTitle: "Flex Insights has been unable to fetch some of your dashboards, please try again.",
        EmptyDashboardList: "No Dashboards to show",
        FlexInsightsLoginFailedNotificationAction: "Reload",
        InputDeviceErrorNotification: "Unable to find or initialize audio input device",
        AnonymousParticipant: "Anonymous",
        TaskLineOutboundCallConnecting: "Connecting call…",
        OutboundErrorGeneral: "Unable to connect your call. Please try again or contact support.",
        OutboundErrorMissingDestination: "Unable to connect your call. Please check the number and try again.",
        OutboundErrorMissingQueue: "Unable to connect your call. Please select a queue and try again.",
        NoOutboundCallingWhenOffline: "To make a call, please change your status from '{{offlineName}}'",
        QueueAssignmentDialogTitle: "Do you want to add the selected {{count}} agents to {{queueName}}?",
        QueueAssignmentDialogDescription: "This action may affect the SLA of other queues that these agents are assigned to. You can undo this action in the History tab.",
        QueueAssignmentDialogCancel: "Cancel",
        QueueAssignmentDialogConfirm: "Confirm",
        QueueAssignmentUndo: "Undo",
        QueueAgentsInQueue: "Agents in {{queueName}}",
        QueueHeaderTitle: "Manage Agents",
        QueueSelectionBanner: "Select up to 50 at a time. You have selected <b class='{{bold}}'>{{count}} {{selectedAgentText}}</b>. To confirm click on the Add button.",
        QueueDeselectAll: "Deselect all",
        QueueAssign: "Assign",
        QueueSuccessBanner: "<b class='{{bold}}'>You have successfully assigned {{assigned}} {{agentText}} to this queue.</b> To undo this action and review previous changes, go to ",
        QueueUndoSuccessBanner: "You have removed <b class='{{bold}}'>{{assigned}} agents</b> from {{queueName}}. They will remain in their other queues.",
        QueueSuccessBannerMeta: "There were {{skipped}} skipped assignments and {{failed}} failures.",
        QueueAssignmentError: " Failed to assign {{count}} agents to {{queueName}}. Please ",
        QueueAssignmentCTA: "try again",
        QueueEmptyTitle: "There are no agents in this queue",
        QueueEmptyDescription: "When you assign agents to this queue, they will be shown here",
        AssignmentsEmptyTitle: "There are no actions to show",
        AssignmentsEmptytDescription: "When you assign agents to this queue, the changes will be shown here",
        QueueStatsContactCenter: "Contact Center Queue Stats",
        LoadingChatCanvas: "Loading ...",
        ReconnectingConnection: "Connection lost. Attempting to reconnect.",
        DegradedWarning: "<b style='font-weight:bold;'>Issues detected.</b> You are now running in degraded mode and some functionality might be affected. Refresh or contact your administrator.",
        DegradedNotificationRefreshAction: "refresh",
        DegradedNotificationDownloadReportAction: "download report",
        FilterDrawerTitle: "Filter agents",
        FilterDrawerStatus: "Status",
        FilterDrawerAvailability: "Availability",
        FilterDrawerSkillsSubtitle: "Skills attributed",
        FilterDrawerSkillsSummaryTitle: "Skills attributed",
        FilterDrawerApply: "Apply",
        FilterDrawerReset: "Reset",
        FilterSectionRefine: "Showing 50 out of <b style='font-weight:bold;'>{{count}} results</b>, continue typing to refine your search",
        FilterSectionManage: "Manage Agents",
        FilterSectionButton: "Filter",
        PaginationPrev: "Prev",
        PaginationNext: "Next",
        AssignmentSuccessUndo: "Undo",
        AssignmentSuccessDetails: "View more details.",
        AssignmentUndoTitle: "Are you sure you want to undo this action",
        AssignmentUndoDescription: "<b style='font-weight:bold;'>{{count}}<b> agent(s) will be removed from {{queueName}}. They will remain in their other queues.",
        AssignmentUndoCancel: "Cancel",
        AssignmentUndoSubmit: "Submit",
        OpenInNewWindow: "Open in a new window",
        AddingCommentFailed: "Unable to add comment. Please try again later.",
        AddingAssessmentFailed: "Unable to add assessment. Please try again later.",
        ConversationCommentFormCategory: "Category",
        ConversationCommentFormCommentLabel: "Comment",
        ConversationCommentInputPlaceholder: "Write your comment here",
        ConversationCommentSaveButton: "Save",
        QuestionnaireSelectorLabel: "Select a Questionnaire:",
        ConversationInfoCommentButton: "Comment",
        ConversationInfoAssessButton: "Assess",
        SegmentSelectorLabel: "Segments",
        PlayerOptionSpeedSlow: "Slow",
        PlayerOptionSpeedNormal: "Normal",
        PlayerOptionSpeedFast: "Fast",
        PlayerOptionSpeedVeryFast: "Very fast",
        PlayerOptionCopyLink: "Copy Link",
        PlayerOptionDownloadLink: "Copy Download Link",
        PlayerOptionCurrentPosition: "Copy Current Position",
        ConversationViewAgentInTeam: "<strong>{{agent}}</strong> in <strong>{{team}}</strong>",
        ConversationViewCallerInfo: "{{caller}} via {{queue}}",
        AgentPanelTitle: "Agent",
        AgentPanelNoAgentAssociated: "No agent is associated with this part of the conversation.",
        AssessPanelTitle: "Assessment",
        AssessPanelNoAgentAssociated: "No agent is associated with this part of the conversation.",
        TranscriptPanelTitle: "Chat Transcript",
        EmailTranscriptPanelTitle: "Email Transcript",
        FindingsPanelTitle: "Findings",
        EmptyFindingsList: "No Findings to display",
        EmptyCommentListTitle: "No comments yet",
        EmptyCommentListSubtitle: "Give feedback to agents by commenting the conversation",
        CommentDurationAndAuthor: "{{duration}} - by {{author}}",
        InsightsPlayerPlaybackUnavailable: "Playback of this file is unavailable",
        InsightsPlayerPlaybackUnavailableSubtitle: "You can still perform assessments and other tasks",
        InsightsPlayerNoPermissionToPlayContent_Title: "No permission",
        InsightsPlayerNoPermissionToPlayContent_Body: "You don&apos;t have the permission to view conversation content.",
        SLAPreferencesHomePageTitle: "Service levels",
        SLAPreferencesHomePageSubtitle: "Set up and update all service levels preferences.",
        QuestionnaireAnswerCountOfTotal: "{{count}} of {{total}} Answered",
        QuestionnaireAnswerCountAllAnswered: "All Answered",
        QuestionnaireAnsweredCount: "{{count}} of {{total}} Answered",
        QuestionnaireAllAnswered: "All Answered",
        SLADailyMetricsResetTitle: "Daily Metrics Reset{{#if timezone}} - {{timezone}}{{/if}}",
        SLATitle: "Service Level Threshold",
        SLAShortAbandonsTitle: "Short Abandons",
        TimeSecondsFormatter: "{{time}}s",
        SLAEditGlobalButton: "Edit",
        SLAPreferencesGlobalLevelsTitle: "Global service levels",
        SLAPreferencesGlobalLevelsSubtitle: "This will apply to all queues and channels without custom levels.",
        SLAPreferencesCustomLevelsTitle: "Custom service levels",
        SLAPreferencesCustomLevelsSubtitle: "Set custom service levels for queues and channels. Custom settings will override the global service level",
        SLAPreferencesQueueNameColumn: "Queues",
        SLAPreferencesMetricsResetColumn: "Daily metrics reset",
        SLAPreferencesChannelLevelsColumn: "Channel service levels",
        SLAPreferencesDefaultSettingsIndicator: "Global",
        SLAPreferencesCustomSettingsIndicator: "Custom",
        SLAGlobalPageTitle: "Global service level",
        SLAGlobalPageSubtitle: "Set the default service level for all queues and channels.",
        SLAGlobalFormTimeInput: "Time",
        SLAGlobalFormTimeZoneInput: "Time zone",
        SLAGlobalFormServiceLevelThresholdSubtitle: "Tasks accepted within this time will meet the SLA.",
        SLAGlobalFormShortAbandonsSubtitle: "The SLA will exclude tasks abandoned by the customer within this time.",
        SLAPreferencesCustomLevelsError: "There was a problem loading queue data.",
        ConfirmableDialogConfirmButton: "Confirm",
        ConfirmableDialogCancelButton: "Cancel",
        GlobalSLConfirmDialogTitle: "Are you sure you want to change the global service level?",
        GlobalSLConfirmDialogAllQueues: "These settings will apply to all queues and channels without custom service levels set up.",
        GlobalSLConfirmDialogResetTimeInfo: "Real-time Metrics will be reset today at {{time}}.",
        GlobalSLConfirmDialogAllConversations: "Service Level Threshold and Short Abandon changes will take effect now.",
        GlobalSLConfirmDialogWarning: "Making these changes during a shift might lead to inconsistent reporting.",
        GlobalSLConfirmDialogError: "We're sorry, the save was unsuccessful. Please try again, or contact your support team if you continue to see this message.",
        SLAQueuePageSubtitle: "Set up and manage custom service levels for this queue. These will override the global service level.",
        SLAQueuePageTitle: "{{queue}} - custom service levels",
        SLAPreferencesCancelButton: "Cancel",
        SLAPreferencesSaveButton: "Save",
        SLAPreferencesAddChannelConfigurationButton: "Add custom levels",
        SLAPreferencesRemoveConfigurationButton: "Remove",
        SLADailyMetricsResetSubtitle: "Time at which the daily SLA metrics are reset.",
        SLADailyMetricsResetAddButton: "Set custom time",
        SLAChannelServiceLevelsTitle: "Custom channel service level",
        SLAChannelServiceLevelsSubtitle: "Set limits specific to this queue and its channels.",
        SLAChannelServiceLevelsValidationMessage: "Must be greater than Short abandons",
        GlobalSLSuccessNotification: "Successfully updated the global service level.",
        SLAPreferencesCustomLevelsSuccessNotification: "Successfully updated {{queue}} service level.",
        SLAPreferencesCustomLevelsErrorNotification: "Failed to update {{queue}} service level.",
        SessionInvalidated: "This session is no longer active.",
        LogIn: "Log in",
        SessionAlreadyExists: "You're logged in elsewhere",
        SessionAlreadyExistsDesc: "You can only log in on one tab or device at a time. <br />Do you want to log in here and close your other session?",
        SessionTimeoutMessage: "This screen will time out in {{timeout}} seconds",
        SessionOngoingCallMessage: "You’re on a call elsewhere",
        SessionOngoingCallDesc: "You can only be logged in on one tab or device at a time.<br />Logging in here will drop your ongoing call.",
        SessionDropOngoingCall: "Drop Call and Log In",
        LogInHere: "Log In Here",
        Cancel: "Cancel",
        SecondIncomingVoiceConnectionNotificationContent: "Incoming call. Do you want to accept this task and end your current voice connection?",
        SecondIncomingVoiceConnectionNotificationAccept: "Accept",
        SecondIncomingVoiceConnectionNotificationReject: "Reject",
        CopyClipboardFailed: "Copying the text to clipboard failed. Select and copy the text manually: {{clipboardText}}",
        BackButton: "Back",
        NoTokenErrorNotificationBody: "Your session will expire in 10 minutes. Please refresh the page to restore your session before it expires. If this happens again, contact your administrator.",
        NoTokenErrorNotificationAction: "Refresh",
        ExternalWarmTransferFailed: "Unable to add external participant to this conference.",
        FailedToFetchParticipants: "Failed to fetch call participants. This may result in degraded call performance.",
        CancelExternalWarmTransfer: "Cancel External Call",
        MultipleCallAlertDialogTitle: "New Incoming call",
        MultipleCallAlertDialogContent: "You have a new incoming call, would you like to accept it and cancel the call to {{task.defaultFrom}}?",
        MultipleCallAlertDialogActionAccept: "Accept",
        MultipleCallAlertDialogActionReject: "Reject"
      });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOfflineAgentsCount = t.getUnavailableAgentsCount = t.getAvailableAgentsCount = void 0;
    var r = n(13),
      o = n(3);
    function i(e, t, n) {
      return e.activity_statistics.filter(function (e) {
        return function (e) {
          var t,
            n,
            r = null === (n = null === (t = o.FlexModule.workerClient) || void 0 === t ? void 0 : t.activities) || void 0 === n ? void 0 : n.get(e.sid);
          return r ? r.available : void 0;
        }(e) === t && function (e) {
          var t = r.Manager.getInstance().serviceConfiguration.taskrouter_offline_activity_sid;
          return t && t === e.sid || "Offline" === e.friendly_name;
        }(e) === n;
      }).reduce(function (e, t) {
        return e + t.workers;
      }, 0);
    }
    t.getAvailableAgentsCount = function (e) {
      return e ? i(e, !0, !1) : 0;
    }, t.getUnavailableAgentsCount = function (e) {
      return e ? i(e, !1, !1) : 0;
    }, t.getOfflineAgentsCount = function (e) {
      return e ? i(e, !1, !0) : 0;
    };
  }, function (e, t) {
    e.exports = require("@gooddata/gooddata-js");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(27),
      a = n(371),
      s = n(29),
      l = n(7),
      c = n(3),
      u = n(46),
      p = n(9),
      d = function () {
        function e(e) {
          var t,
            n,
            d = this;
          if (this.fetchToken = function () {
            return r(d, void 0, void 0, function () {
              var e, t, n;
              return o(this, function (r) {
                switch (r.label) {
                  case 0:
                    return this.loading = !0, e = this.manager.store.getState().flex.session.ssoTokenPayload.token, [4, i.default.post(this.ssoLoginUrl, {
                      token: e,
                      account_sid: this.flexAccountSid,
                      flex_ui_version: u.VERSION
                    }, {})];
                  case 1:
                    return t = r.sent(), this.insightsToken = t.data.authorization_token, this.decodedInsightsToken = a.default(this.insightsToken), this.goodDataSessionId = t.data.gooddata_session_id, this.goodDataSSOProvider = t.data.gooddata_sso_provider, this.insightsTokenExpiresAt = new Date(t.data.expire), this.tokenPair = {
                      accessToken: this.insightsToken,
                      refreshToken: t.data.refresh_token
                    }, this.isLoggedIn = !0, this.loading = !1, c.FlexModule.events.emitYticaTokenUpdated(this.tokenPair), (n = Math.floor(.9 * (this.insightsTokenExpiresAt.getTime() - Date.now()))) > 0 && (this.tokenRefreshTimeout && window.clearTimeout(this.tokenRefreshTimeout), this.tokenRefreshTimeout = window.setTimeout(this.refreshToken, n)), [2];
                }
              });
            });
          }, this.refreshToken = function () {
            return r(d, void 0, void 0, function () {
              var e;
              return o(this, function (t) {
                switch (t.label) {
                  case 0:
                    return t.trys.push([0, 2,, 3]), [4, this.fetchToken()];
                  case 1:
                    return t.sent(), [3, 3];
                  case 2:
                    return e = t.sent(), this.logout(), l.ErrorManager.createAndProcessError(s.ErrorMessages.INSIGHTS_TOKEN_REFRESH_FAILED, {
                      type: l.FlexErrorType.app,
                      wrappedError: e,
                      context: "IdentityClient"
                    }), [3, 3];
                  case 3:
                    return [2];
                }
              });
            });
          }, this.ssoLogin = function () {
            return r(d, void 0, void 0, function () {
              return o(this, function (e) {
                switch (e.label) {
                  case 0:
                    if (this.isLoggedIn) return [2];
                    if (this.loading) throw new Error("Insights identity client login already in progress");
                    return [4, this.fetchToken()];
                  case 1:
                    return e.sent(), [2];
                }
              });
            });
          }, this.logout = function () {
            return d.isLoggedIn = !1, d.loading = !1, d.insightsToken = void 0, d.decodedInsightsToken = void 0, d.insightsTokenExpiresAt = void 0, d.goodDataSessionId = void 0, d.tokenRefreshTimeout && (window.clearTimeout(d.tokenRefreshTimeout), d.tokenRefreshTimeout = void 0), Promise.resolve();
          }, this.hasPermission = function (e) {
            var t,
              n,
              r,
              o,
              i,
              a = e.split("."),
              s = a[0] && a[1] && (null === (r = null === (n = null === (t = d.decodedInsightsToken) || void 0 === t ? void 0 : t.allow) || void 0 === n ? void 0 : n[a[0]]) || void 0 === r ? void 0 : r[a[1]]);
            if (3 === a.length && s) {
              if (s.includes("*")) return !0;
              if (a[2] && s.includes(a[2])) return !0;
            }
            if (2 === a.length && s && s.length > 0) return !0;
            if (1 === a.length && a[0]) {
              var l = null === (i = null === (o = d.decodedInsightsToken) || void 0 === o ? void 0 : o.allow) || void 0 === i ? void 0 : i[a[0]];
              if (l && Object.keys(l).length > 0) return !0;
            }
            return !1;
          }, this.getServiceSsoUrl = function (e, t, n) {
            return void 0 === n && (n = {}), r(d, void 0, void 0, function () {
              return o(this, function (r) {
                switch (r.label) {
                  case 0:
                    return [4, this.axios.post(this.insightsIdentityUrl + "/sso-url", {
                      target_sso: e,
                      target_url: t,
                      params: n
                    })];
                  case 1:
                    return [2, r.sent().data.url];
                }
              });
            });
          }, this.getWorkspaceEncryptedClaims = function () {
            return Promise.resolve(d.goodDataSessionId);
          }, this.getSSOProvider = function () {
            return Promise.resolve(d.goodDataSSOProvider || "ytica");
          }, this.isLoggedIn = !1, this.loading = !1, this.tokenPair = {
            accessToken: null,
            refreshToken: null
          }, this.manager = e, this.flexAccountSid = e.serviceConfiguration.account_sid, !this.flexAccountSid) throw new Error("Unable to initialize Insights identity. Missing flexAccountSid.");
          var f = this.manager.store.getState().flex.worker;
          this.userEmail = (null === (t = f.attributes) || void 0 === t ? void 0 : t.email) || "", this.userName = (null === (n = f.worker) || void 0 === n ? void 0 : n.fullName) || "", this.ssoLoginUrl = p.getFlexInsightsSSOUrl(e.configuration), this.insightsIdentityUrl = p.getFlexInsightsIdentityUrl(e.configuration), this.axios = i.default.create(), this.axios.interceptors.request.use(function (e) {
            return r(d, void 0, void 0, function () {
              return o(this, function (t) {
                if (!this.insightsToken) throw new Error("Cannot send API requests before logging in");
                return e.headers.common.Authorization = "Bearer " + this.insightsToken, [2, e];
              });
            });
          });
        }
        return Object.defineProperty(e.prototype, "user", {
          get: function get() {
            var e, t;
            return {
              workspace_id: null === (e = this.decodedInsightsToken) || void 0 === e ? void 0 : e.workspace_id,
              account_id: null === (t = this.decodedInsightsToken) || void 0 === t ? void 0 : t.account_id,
              name: this.userName,
              email: this.userEmail
            };
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
    t.default = d;
  }, function (e, t) {
    e.exports = require("jwt-decode");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.YticaIdentityClient = void 0;
    var i = n(373),
      a = n(27),
      s = n(13),
      l = n(9),
      c = function () {
        function e(e) {
          var t = l.getFlexInsightsSSOUrl(e.configuration),
            n = new URL(l.getFlexInsightsIdentityUrl(e.configuration));
          this.axios = a.default.create(), this.yticaClient = new i.default({
            url: n.href,
            baseUrl: n.origin,
            axios: this.axios,
            ssoLoginUrl: t
          }), this.yticaClient.initialize();
        }
        return Object.defineProperty(e.prototype, "isLoggedIn", {
          get: function get() {
            return !!this.yticaClient.isLoggedIn;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "loading", {
          get: function get() {
            return !!this.yticaClient.loading;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "user", {
          get: function get() {
            var e,
              t,
              n,
              r,
              o,
              i = null === (e = s.Manager.getInstance().store) || void 0 === e ? void 0 : e.getState().flex.worker;
            return {
              account_id: null === (t = this.yticaClient.user) || void 0 === t ? void 0 : t.account_id,
              workspace_id: null === (n = this.yticaClient.user) || void 0 === n ? void 0 : n.workspace_id,
              email: null === (r = null == i ? void 0 : i.attributes) || void 0 === r ? void 0 : r.email,
              name: null === (o = null == i ? void 0 : i.worker) || void 0 === o ? void 0 : o.fullName
            };
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "tokenPair", {
          get: function get() {
            return this.yticaClient.tokenPair;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.hasPermission = function (e) {
          return this.isLoggedIn && this.yticaClient.hasPermission(e);
        }, e.prototype.ssoLogin = function (e) {
          return this.yticaClient.ssoLogin(e);
        }, e.prototype.getServiceSsoUrl = function (e, t, n) {
          return this.yticaClient.getServiceSsoUrl(e, t, n);
        }, e.prototype.logout = function () {
          return this.yticaClient.logout();
        }, e.prototype.initDashboardServiceUrl = function () {
          return r(this, void 0, void 0, function () {
            var e;
            return o(this, function (t) {
              switch (t.label) {
                case 0:
                  return this.urlObj ? [2] : [4, this.yticaClient.getServiceSsoUrl("dashboards", "/")];
                case 1:
                  return e = t.sent(), this.urlObj = new URL(e), [2];
              }
            });
          });
        }, e.prototype.getWorkspaceEncryptedClaims = function () {
          var e;
          return r(this, void 0, void 0, function () {
            return o(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, this.initDashboardServiceUrl()];
                case 1:
                  return t.sent(), [2, (null === (e = this.urlObj) || void 0 === e ? void 0 : e.searchParams.get("sessionId")) || void 0];
              }
            });
          });
        }, e.prototype.getSSOProvider = function () {
          var e;
          return r(this, void 0, void 0, function () {
            return o(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, this.initDashboardServiceUrl()];
                case 1:
                  return t.sent(), [2, (null === (e = this.urlObj) || void 0 === e ? void 0 : e.searchParams.get("serverURL")) || "ytica"];
              }
            });
          });
        }, e;
      }();
    t.YticaIdentityClient = c;
  }, function (e, t) {
    e.exports = require("@twilio/flex-insights-identity-client-js");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskRouterWorker = t.TaskRouterTask = void 0;
    var o = n(0),
      i = n(11),
      a = n(7),
      s = n(3),
      l = n(5),
      c = n(14),
      u = n(4),
      p = n(183),
      d = n(10),
      f = function () {
        function e(e) {
          var t = this;
          this.transfer = function (e, n) {
            var r = function r(n) {
              var r = n.response && n.response.statusText ? n.response.statusText : "Unknown error";
              throw o.Notifications.showNotification(c.TransferFailed, {
                reason: r
              }), a.ErrorManager.createAndProcessError("Could not transfer task", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not transfer task " + t._task.sid + " to " + e + " unsuccessful: " + r,
                context: "TaskRouterModel",
                wrappedError: n
              });
            };
            return n.mode && "COLD" === n.mode ? t._reservation.updateParticipant({
              endConferenceOnExit: !1
            }).then(function () {
              return t._task.transfer(e, n).catch(function (e) {
                throw t._reservation.updateParticipant({
                  endConferenceOnExit: !0
                }), e;
              });
            }).then(function () {
              l.log.debug("transfer of task " + t._task.sid + " to " + e + " successful");
            }).catch(function (e) {
              r(e);
            }) : t._task.transfer(e, n).then(function () {
              l.log.debug("transfer of task " + t._task.sid + " to " + e + " successful");
            }).catch(function (e) {
              r(e);
            });
          }, this.setAttributes = function (e) {
            return t._task.setAttributes(e).catch(function (e) {
              return a.ErrorManager.createAndProcessError("Could not set task attributes", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not set task attributes for task " + t._task.sid + ": " + e.message,
                context: "TaskRouterModel",
                wrappedError: e
              }), Promise.reject(e);
            });
          }, this.wrapUp = function () {
            return t._reservation.wrap().catch(function (e) {
              return a.ErrorManager.createAndProcessError("Could not wrap up reservation", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not wrap up reservation " + t._reservation.sid + ": " + e.message,
                context: "TaskRouterModel",
                wrappedError: e
              }), Promise.reject(e);
            });
          }, this.complete = function () {
            return t._reservation.complete().catch(function (e) {
              return a.ErrorManager.createAndProcessError("Could not complete reservation", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not complete reservation " + t._reservation.sid + ": " + e.message,
                context: "TaskRouterModel",
                wrappedError: e
              }), Promise.reject(e);
            });
          }, this.hold = function (e, n) {
            return void 0 === n && (n = "GET"), t._task.updateParticipant(r(r({
              hold: !0
            }, e && {
              holdUrl: e
            }), {
              holdMethod: n
            })).catch(function (e) {
              return a.ErrorManager.createAndProcessError("error holding call", {
                type: a.FlexErrorType.taskrouterSDK,
                context: "VoiceActions",
                wrappedError: e,
                description: "Error holding call " + t._task.sid + ": " + e.message
              }), Promise.reject(e);
            });
          }, this.unhold = function () {
            return t._task.updateParticipant({
              hold: !1
            }).catch(function (e) {
              return a.ErrorManager.createAndProcessError("error unholding call", {
                type: a.FlexErrorType.taskrouterSDK,
                context: "VoiceActions",
                wrappedError: e,
                description: "Error unholding call " + t._task.sid + ": " + e.message
              }), Promise.reject(e);
            });
          }, this.holdParticipant = function (e, n, o) {
            var i;
            if ("external" === (null === (i = s.FlexModule.state.participants.bySid[e]) || void 0 === i ? void 0 : i.type)) return s.FlexModule.cbmClient.holdParticipant(t._task, e).catch(function (n) {
              throw a.ErrorManager.createAndProcessError("Could not hold participant", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not hold external participant " + e + " for conference associated with task " + t._task.sid,
                context: "TaskRouterModel",
                wrappedError: n
              });
            });
            var l = t.conference.participants.find(function (t) {
              return t.workerSid === e;
            });
            return l && "worker" === l.participantType ? t._task.hold(l.workerSid, !0, r(r({}, n && {
              holdUrl: n
            }), o && {
              holdMethod: o
            })) : t.hold(n, o);
          }, this.unholdParticipant = function (e) {
            var n;
            if ("external" === (null === (n = s.FlexModule.state.participants.bySid[e]) || void 0 === n ? void 0 : n.type)) return s.FlexModule.cbmClient.unHoldParticipant(t._task, e).catch(function (n) {
              throw a.ErrorManager.createAndProcessError("Could not unhold participant", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not unhold external participant " + e + " for conference associated with task " + t._task.sid,
                context: "TaskRouterModel",
                wrappedError: n
              });
            });
            var r = t.conference.participants.find(function (t) {
              return t.workerSid === e;
            });
            return r && "worker" === r.participantType ? t._task.hold(r.workerSid, !1) : t.unhold();
          }, this.kick = function (e) {
            var n;
            return "external" === (null === (n = s.FlexModule.state.participants.bySid[e]) || void 0 === n ? void 0 : n.type) ? s.FlexModule.cbmClient.removeVoiceParticipant(t._task, e).catch(function (n) {
              throw a.ErrorManager.createAndProcessError("Could not remove voice participant", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not remove voice participant " + e + " from task " + t._task.sid,
                context: "TaskRouterModel",
                wrappedError: n
              });
            }) : t._task.kick(e).catch(function (t) {
              return a.ErrorManager.createAndProcessError("Could not kick participant", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not kick participant " + e + ": " + t.message,
                context: "TaskRouterModel",
                wrappedError: t
              }), Promise.reject(t);
            });
          }, this.cancelTransfer = function () {
            return t._outgoingTransferObject.cancel();
          }, this.addVoiceParticipant = function (e, n, r) {
            return s.FlexModule.cbmClient.addVoiceParticipant(t._task, {
              from: e,
              to: n,
              type: r
            }).catch(function (n) {
              throw a.ErrorManager.createAndProcessError("Could not add voice participant", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not add voice participant of caller " + e + " to task " + t._task.sid,
                context: "TaskRouterModel",
                wrappedError: n
              });
            });
          }, this.endConference = function () {
            return s.FlexModule.cbmClient.endConference(t._task).catch(function (e) {
              throw a.ErrorManager.createAndProcessError("Could not end conference", {
                type: a.FlexErrorType.taskrouterSDK,
                description: "Could not end conference associated with task " + t._task.sid,
                context: "TaskRouterModel",
                wrappedError: e
              });
            });
          }, this._reservation = e, this._task = e.task, this._task.transfers && (this._task.transfers.incoming && (this._incomingTransferObject = new p.TaskTransfer(this._task.transfers.incoming)), this._task.transfers.outgoing && (this._outgoingTransferObject = new p.TaskTransfer(this._task.transfers.outgoing)));
        }
        return Object.defineProperty(e.prototype, "source", {
          get: function get() {
            return this._task;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "sourceObject", {
          get: function get() {
            return this._reservation;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "addOns", {
          get: function get() {
            return this._task.addOns;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "age", {
          get: function get() {
            return this._task.age;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "attributes", {
          get: function get() {
            return this._task.attributes;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "dateCreated", {
          get: function get() {
            return this._reservation.dateCreated;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "dateUpdated", {
          get: function get() {
            return this._reservation.dateUpdated;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "priority", {
          get: function get() {
            return this._task.priority;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "queueName", {
          get: function get() {
            return this._task.queueName;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "queueSid", {
          get: function get() {
            return this._task.queueSid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "reason", {
          get: function get() {
            return this._task.reason;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "sid", {
          get: function get() {
            return this._reservation.sid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "taskSid", {
          get: function get() {
            return this._task.sid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "status", {
          get: function get() {
            return this._reservation.status;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "taskStatus", {
          get: function get() {
            return this._task.status;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "taskChannelSid", {
          get: function get() {
            return this._task.taskChannelSid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "taskChannelUniqueName", {
          get: function get() {
            return this._task.taskChannelUniqueName;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "timeout", {
          get: function get() {
            return this._task.timeout;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "workflowName", {
          get: function get() {
            return this._task.workflowName;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "workflowSid", {
          get: function get() {
            return this._task.workflowSid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "workerSid", {
          get: function get() {
            return this._reservation.workerSid;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "routingTarget", {
          get: function get() {
            return this._task.routingTarget;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "defaultFrom", {
          get: function get() {
            var e = this.attributes,
              t = void 0 === e ? {} : e;
            return (t.name ? t.name : this.routingTarget && "outbound" === t.direction ? t.outbound_to : i.FeatureFlags.isEnabled(d.FeatureFlag.EmailPOC) && "email" === t.channelType ? t.senderName + " - " + t.senderAddress : t.from) || u.templates.AnonymousParticipant();
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "channelType", {
          get: function get() {
            return this.attributes.channelType || this.taskChannelUniqueName;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "incomingTransferObject", {
          get: function get() {
            return this._incomingTransferObject;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "outgoingTransferObject", {
          get: function get() {
            return this._outgoingTransferObject;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "conference", {
          get: function get() {
            var e = s.FlexModule.state.conferences.states.get(this.taskSid);
            return e ? e.source : void 0;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.setEndConferenceOnExit = function (e, t) {
          var n = this;
          return s.FlexModule.cbmClient.setEndConferenceOnExit(this._task, e, t).catch(function (t) {
            throw a.ErrorManager.createAndProcessError("Could not ensure conference ends on exit", {
              type: a.FlexErrorType.taskrouterSDK,
              description: "Could not ensure conference associated with task " + n._task.sid + " ends after participant " + e + " exits",
              context: "TaskRouterModel",
              wrappedError: t
            });
          });
        }, e.prototype.getChannels = function () {
          var e = this;
          return s.FlexModule.cbmClient.getChannels(this._task).catch(function (t) {
            throw a.ErrorManager.createAndProcessError("Could not fetch channels", {
              type: a.FlexErrorType.taskrouterSDK,
              description: "Could not fetch channels for task " + e._task.sid,
              context: "TaskRouterModel",
              wrappedError: t
            });
          });
        }, e.prototype.getParticipants = function (e) {
          var t = this;
          return s.FlexModule.cbmClient.getParticipants(this._task, e).catch(function (e) {
            throw a.ErrorManager.createAndProcessError("Could not fetch participants", {
              type: a.FlexErrorType.taskrouterSDK,
              description: "Could not fetch participants for task " + t._task.sid,
              context: "TaskRouterModel",
              wrappedError: e
            });
          });
        }, e;
      }();
    t.TaskRouterTask = f;
    var h = function () {
      function e(e) {
        this._source = e;
      }
      return Object.defineProperty(e.prototype, "source", {
        get: function get() {
          return this._source;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sid", {
        get: function get() {
          return this.source.sid;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "name", {
        get: function get() {
          return this.source.name;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "fullName", {
        get: function get() {
          var e;
          return (null === (e = this.source.attributes) || void 0 === e ? void 0 : e.full_name) || this.name;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "activityName", {
        get: function get() {
          var e;
          return null === (e = this.source.activity) || void 0 === e ? void 0 : e.name;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributes", {
        get: function get() {
          return this.source.attributes;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateUpdated", {
        get: function get() {
          return this.source.dateUpdated;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isAvailable", {
        get: function get() {
          var e;
          return !!(null === (e = this.source.activity) || void 0 === e ? void 0 : e.available);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "activityDuration", {
        get: function get() {
          return this.source && this.source.dateStatusChanged ? o.Utils.formatTimeDuration(Math.max(Date.now() - new Date(this.source.dateStatusChanged).getTime(), 0), "short") : "";
        },
        enumerable: !1,
        configurable: !0
      }), e;
    }();
    t.TaskRouterWorker = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatJoiner = void 0;
    var r = n(3),
      o = n(8),
      i = n(0),
      a = n(23),
      s = n(92),
      l = n(5),
      c = n(12),
      u = n(11),
      p = n(10),
      d = {},
      f = function () {
        function e() {}
        return e.prototype.verifyChatParticipation = function (t) {
          var n = this,
            f = r.FlexModule.state.config.UNSAFEAutojoinChat,
            h = u.FeatureFlags.isEnabled(p.FeatureFlag.ChatAutoJoin);
          (f || h) && (f && !e.UNSAFEAutojoinChatDeprecationWarningShown && (l.log.warn("From the next minor release of Flex, config.UNSAFEAutojoinChat will be deprecated.\nContact Twilio support to enable chat auto join through a feature flag."), e.UNSAFEAutojoinChatDeprecationWarningShown = !0), "accepted" === t.status && o.TaskHelper.isChatBasedTask(t) && setTimeout(function () {
            i.ChatChannelState.ChannelHelper.isUserMemberOfChannel(a.StateHelper.getChatChannelStateForTask(t)) || (l.log.warn("ChatJoiner: Agent not in channel task " + t.sid + ". Rejoining..."), void 0 === d[t.sid] ? (d[t.sid] = 1, c.TelemetryManager.reportChatAutoJoinRetryStart(t.sid)) : d[t.sid]++, r.FlexModule.events.emitChatChannelJoining("joining"), s.ChatOrchestrator.handleReservationEvent("accepted", t).then(function () {
              l.log.warn("ChatJoiner: Rejoin successful for task " + t.sid), r.FlexModule.events.emitChatChannelJoining("joined"), c.TelemetryManager.reportChatAutoJoinRetryComplete(t.sid, d[t.sid]), delete d[t.sid];
            }).catch(function (e) {
              l.log.warn("ChatJoiner: Rejoin unsuccessful for task " + t.sid, e), r.FlexModule.events.emitChatChannelJoining("failed"), n.verifyChatParticipation(t);
            }));
          }, 3e3));
        }, e.UNSAFEAutojoinChatDeprecationWarningShown = !1, e;
      }();
    t.ChatJoiner = new f();
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    function o(e) {
      return ["type", "payload", "error", "meta"].indexOf(e) > -1;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getType = t.isFSA = t.createAction = void 0, t.createAction = function (e, t) {
      function n() {
        for (var n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
        if (t) {
          var i = t.apply(void 0, n);
          if (!i) throw new Error("prepareAction did not return an object");
          return r(r({
            type: e,
            payload: i.payload
          }, "meta" in i && {
            meta: i.meta
          }), "error" in i && {
            error: i.error
          });
        }
        return {
          type: e,
          payload: n[0]
        };
      }
      return n.toString = function () {
        return "" + e;
      }, n.type = e, n.match = function (t) {
        return t.type === e;
      }, n;
    }, t.isFSA = function (e) {
      return function (e) {
        if ("object" != typeof e || null === e) return !1;
        for (var t = e; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
        return Object.getPrototypeOf(e) === t;
      }(e) && "string" == typeof e.type && Object.keys(e).every(o);
    }, t.getType = function (e) {
      return "" + e;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.decodeParticipantClass = void 0, t.decodeParticipantClass = function (e) {
      var t, n, r, o, i, a, s, l, c, u, p, d, f, h, m, g, y, v, b, C, _, k, w, S, P, T;
      return {
        channelSid: e.channelSid,
        channelType: e.channelType,
        interactionSid: e.interactionSid,
        participantSid: e.participantSid,
        type: e.type,
        mediaProperties: {
          accountSid: null === (n = null === (t = e.mediaProperties) || void 0 === t ? void 0 : t.accountSid) || void 0 === n ? void 0 : n[0],
          callSid: null === (o = null === (r = e.mediaProperties) || void 0 === r ? void 0 : r.callSid) || void 0 === o ? void 0 : o[0],
          coaching: "true" === (null === (a = null === (i = e.mediaProperties) || void 0 === i ? void 0 : i.coaching) || void 0 === a ? void 0 : a[0]),
          conferenceSid: null === (l = null === (s = e.mediaProperties) || void 0 === s ? void 0 : s.conferenceSid) || void 0 === l ? void 0 : l[0],
          endConferenceOnExit: "true" === (null === (u = null === (c = e.mediaProperties) || void 0 === c ? void 0 : c.endConferenceOnExit) || void 0 === u ? void 0 : u[0]),
          friendlyName: null === (d = null === (p = e.mediaProperties) || void 0 === p ? void 0 : p.friendlyName) || void 0 === d ? void 0 : d[0],
          hold: "true" === (null === (h = null === (f = e.mediaProperties) || void 0 === f ? void 0 : f.hold) || void 0 === h ? void 0 : h[0]),
          muted: "true" === (null === (g = null === (m = e.mediaProperties) || void 0 === m ? void 0 : m.muted) || void 0 === g ? void 0 : g[0]),
          sequenceNumber: Number(null === (v = null === (y = e.mediaProperties) || void 0 === y ? void 0 : y.sequenceNumber) || void 0 === v ? void 0 : v[0]),
          startConferenceOnEnter: "true" === (null === (C = null === (b = e.mediaProperties) || void 0 === b ? void 0 : b.startConferenceOnEnter) || void 0 === C ? void 0 : C[0]),
          statusCallbackEvent: null === (_ = e.mediaProperties) || void 0 === _ ? void 0 : _.statusCallbackEvent[0],
          timestamp: null === (k = e.mediaProperties) || void 0 === k ? void 0 : k.timestamp[0],
          from: null === (S = null === (w = e.mediaProperties) || void 0 === w ? void 0 : w.from) || void 0 === S ? void 0 : S[0],
          to: null === (T = null === (P = e.mediaProperties) || void 0 === P ? void 0 : P.to) || void 0 === T ? void 0 : T[0]
        },
        routingProperties: e.routingProperties
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__rest || function (e, t) {
      var n = {};
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
      }
      return n;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.decodeParticipantEvent = void 0, t.decodeParticipantEvent = function (e) {
      var t,
        n,
        o,
        i,
        a,
        s,
        l,
        c,
        u,
        p,
        d,
        f,
        h = e.media_properties,
        m = e.routing_properties,
        g = r(e, ["media_properties", "routing_properties"]);
      return {
        channelSid: g.channel_sid,
        channelType: g.channel_type,
        interactionSid: g.interaction_sid,
        participantSid: g.participant_sid,
        type: g.type,
        mediaProperties: {
          accountSid: null === (t = h.AccountSid) || void 0 === t ? void 0 : t[0],
          callSid: null === (n = h.CallSid) || void 0 === n ? void 0 : n[0],
          coaching: "true" === (null === (o = h.Coaching) || void 0 === o ? void 0 : o[0]),
          conferenceSid: null === (i = h.ConferenceSid) || void 0 === i ? void 0 : i[0],
          endConferenceOnExit: "true" === (null === (a = h.EndConferenceOnExit) || void 0 === a ? void 0 : a[0]),
          friendlyName: null === (s = h.FriendlyName) || void 0 === s ? void 0 : s[0],
          hold: "true" === (null === (l = h.Hold) || void 0 === l ? void 0 : l[0]),
          muted: "true" === (null === (c = h.Muted) || void 0 === c ? void 0 : c[0]),
          sequenceNumber: Number(null === (u = h.SequenceNumber) || void 0 === u ? void 0 : u[0]),
          startConferenceOnEnter: "true" === (null === (p = h.StartConferenceOnEnter) || void 0 === p ? void 0 : p[0]),
          statusCallbackEvent: h.StatusCallbackEvent[0],
          timestamp: h.Timestamp[0],
          from: null === (d = null == h ? void 0 : h.From) || void 0 === d ? void 0 : d[0],
          to: null === (f = null == h ? void 0 : h.To) || void 0 === f ? void 0 : f[0]
        },
        routingProperties: {
          reservationSid: m.reservation_sid,
          taskSid: m.task_sid,
          workerSid: m.worker_sid
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectionStatusActionTypes = t.ConnectionStatus = t.CONNECTION_STATUS_CHANGE = t.ConnectionStatusState = t.reduce = void 0;
    var r = n(175);
    Object.defineProperty(t, "reduce", {
      enumerable: !0,
      get: function get() {
        return r.reduce;
      }
    }), Object.defineProperty(t, "ConnectionStatusState", {
      enumerable: !0,
      get: function get() {
        return r.ConnectionStatusState;
      }
    });
    var o = n(176);
    Object.defineProperty(t, "CONNECTION_STATUS_CHANGE", {
      enumerable: !0,
      get: function get() {
        return o.CONNECTION_STATUS_CHANGE;
      }
    }), Object.defineProperty(t, "ConnectionStatus", {
      enumerable: !0,
      get: function get() {
        return o.ConnectionStatus;
      }
    }), Object.defineProperty(t, "ConnectionStatusActionTypes", {
      enumerable: !0,
      get: function get() {
        return o.ConnectionStatusActionTypes;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.reduce = t.initialState = void 0;
    var o = n(72),
      i = n(381),
      a = n(382);
    t.initialState = {
      isLoading: !0,
      bySid: {},
      byCallSid: {},
      sids: []
    }, t.reduce = function (e, n) {
      var s, l, c, u, p;
      switch (void 0 === e && (e = t.initialState), n.type) {
        case o.getParticipantsPending.type:
          return r(r({}, e), {
            isLoading: !0
          });
        case o.getParticipantsRejected.type:
          return r(r({}, e), {
            isLoading: !1
          });
        case o.addPendingParticipant.type:
          return r(r({}, e), {
            bySid: r(r({}, e.bySid), (s = {}, s[n.payload.sid] = i.createPendingParticipant(n.payload), s)),
            sids: a.unique(e.sids, n.payload.sid)
          });
        case o.removeParticipant.type:
          return r(r({}, e), {
            sids: e.sids.filter(function (e) {
              return e !== n.payload;
            })
          });
        case o.addParticipant.type:
          return r(r({}, e), {
            bySid: r(r({}, e.bySid), (l = {}, l[n.payload.participantSid] = n.payload, l)),
            byCallSid: r(r({}, e.byCallSid), (c = {}, c[null === (p = null === (u = n.payload) || void 0 === u ? void 0 : u.mediaProperties) || void 0 === p ? void 0 : p.callSid] = n.payload, c)),
            sids: a.unique(e.sids, n.payload.participantSid)
          });
        case o.getParticipantsFulfilled.type:
          return r(r({}, e), {
            bySid: r(r({}, e.bySid), n.payload.reduce(function (e, t) {
              return e[t.participantSid] = t, e;
            }, {})),
            byCallSid: r(r({}, e.byCallSid), n.payload.reduce(function (e, t) {
              var n;
              return e[null === (n = t.mediaProperties) || void 0 === n ? void 0 : n.callSid] = t, e;
            }, {})),
            sids: a.unique(e.sids, n.payload.map(function (e) {
              return e.participantSid;
            }))
          });
        case o.clearPendingParticipants.type:
          return r(r({}, e), {
            sids: e.sids.map(function (t) {
              return e.bySid[t];
            }).filter(function (e) {
              return !e.isPending;
            }).map(function (e) {
              return e.participantSid;
            })
          });
        default:
          return e;
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createPendingParticipant = void 0, t.createPendingParticipant = function (e) {
      return {
        routingProperties: {
          workerSid: "",
          taskSid: "",
          reservationSid: ""
        },
        mediaProperties: {
          accountSid: "",
          callSid: "",
          coaching: !1,
          conferenceSid: "",
          endConferenceOnExit: !1,
          friendlyName: "",
          hold: !1,
          muted: !1,
          sequenceNumber: 0,
          startConferenceOnEnter: !1,
          statusCallbackEvent: "",
          timestamp: new Date().toISOString(),
          from: e.phoneNumber,
          to: ""
        },
        participantSid: e.sid,
        type: "external",
        channelType: "voice",
        channelSid: e.channel_sid,
        interactionSid: e.interaction_sid,
        isPending: !0
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
      var r = Array(e),
        o = 0;
      for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
      return r;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.unique = void 0, t.unique = function (e, t) {
      return Array.from(new Set(r(e).concat(t)));
    };
  }, function (e, t) {
    e.exports = require("redux-logger");
  }, function (e, t) {
    e.exports = require("redux-promise-middleware");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isCompatible = t.CompatibilityOptions = void 0;
    var r = n(46),
      o = n(5),
      i = n(16),
      a = n(14);
    !function (e) {
      e.yes = "yes", e.no = "no", e.deprecated = "deprecated";
    }(t.CompatibilityOptions || (t.CompatibilityOptions = {})), t.isCompatible = function (e, t) {
      switch (void 0 === t && (t = void 0), e) {
        case "yes":
          return !0;
        case "deprecated":
          return i.Notifications.showNotification(a.FlexUiVersionDeprecated, {
            message: t
          }), o.log.warn("This version of Flex is deprecated and will not work with future version of back end services. Please contact your administrator. UI version", r.VERSION, t), !0;
        default:
          return o.log.error("This version of Flex is not compatible with back end services. UI version", r.VERSION, t), !1;
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.default = {
      language: "en-US",
      colorTheme: "BlueMediumTheme",
      pluginService: {
        enabled: !0
      },
      logLevel: "debug",
      rejectPendingReservations: !0,
      initialDeviceCheck: !0,
      notifications: {
        browser: !1,
        mode: "whenNotInFocus"
      },
      enableClientCalling: !1
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createPluginProxy = t.setupPluginProxy = t.getPluginProxy = t.enablePluginActivityConsoleLogging = t.enablePluginProxy = void 0;
    var o = n(108),
      i = n(10),
      a = n(11),
      s = n(95),
      l = n(12),
      c = ["Content.add", "Content.remove", "Content.replace"],
      u = ["__esModule", "registeredFragments", "name", "_name", "length", "_proxiedInstance", "constructor", "prototype", "Symbol(Symbol.toStringTag)"],
      p = ["Actions"],
      d = function () {
        function e(e) {
          this.activityCount = 0, this.eventName = "", this.inDynamicComponent = !1, this.inAction = !1, this.finishDynamicComponent = !1, this.consoleLogEnabled = !1, this.plugin = e, this.consoleLogEnabled = t.enablePluginActivityConsoleLogging();
        }
        return Object.defineProperty(e.prototype, "currentComponentName", {
          get: function get() {
            var e, t, n, r, o;
            return (null === (t = null === (e = this.currentComponent) || void 0 === e ? void 0 : e.type) || void 0 === t ? void 0 : t.name) || (null === (o = null === (r = null === (n = this.currentComponent) || void 0 === n ? void 0 : n.type) || void 0 === r ? void 0 : r.WrappedComponent) || void 0 === o ? void 0 : o.name);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "pluginInfoHeader", {
          get: function get() {
            return this.plugin.name + "@" + this.plugin.version;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.incrementCounter = function () {
          this.activityCount++;
        }, e.prototype.getTelemetryOptions = function (e) {
          return s.PluginManager.getTelemetryOptions(this.plugin, r({
            pluginProxy: !0,
            pluginProxyTimestamp: new Date().toISOString().replace("T", " ").replace("Z", ""),
            pluginProxyEventOrder: this.activityCount
          }, e));
        }, e.prototype.logActivity = function (e) {
          var t = this.eventName.split(".")[0] || "",
            n = this.eventName.split(".")[1] || "";
          -1 !== p.indexOf(t) && (this.incrementCounter(), this.consoleLogEnabled && o.info("%cPLUGIN ACTIVITY LOG\n %c" + this.pluginInfoHeader + "\n %c" + this.eventName + ('("' + e + '")' || !1), "font-size: 12px", "font-size: 14px", "font-size: 12px"), l.TelemetryManager.reportProgrammabilityEvent({
            name: e || "",
            command: n || "",
            callType: l.ProgrammabilityEventCallType.Action,
            options: this.getTelemetryOptions()
          }));
        }, e.prototype.logDynamicComponent = function (e, t) {
          var n = this.eventName.split(".Content.")[0] || "",
            r = this.eventName.split(".Content.")[1] || "",
            i = e ? "(<" + e + " key=" + t + " />)" : "(<unknown>)";
          this.incrementCounter(), this.consoleLogEnabled && o.info("%cPLUGIN ACTIVITY LOG\n %c" + this.pluginInfoHeader + "\n %c" + this.eventName + i, "font-size: 12px", "font-size: 14px", "font-size: 12px"), l.TelemetryManager.reportProgrammabilityEvent({
            callType: l.ProgrammabilityEventCallType.DynamicComponent,
            pluginName: this.plugin.name,
            pluginVersion: this.plugin.version,
            name: n,
            command: r,
            options: this.getTelemetryOptions({
              key: t,
              componentName: e
            })
          });
        }, e.prototype.updateEventName = function (e) {
          -1 === u.indexOf(e) && (this.eventName = "" === this.eventName ? e : this.eventName + "." + e);
        }, e.prototype.reset = function () {
          this.eventName = "", this.inAction = !1, this.inDynamicComponent = !1, this.finishDynamicComponent = !1, this.currentComponent = void 0;
        }, e.prototype.startGetTrap = function (e) {
          var t = this;
          this.updateEventName(e), c.some(function (e) {
            return t.eventName.endsWith(e);
          }) ? this.inDynamicComponent = !0 : "Actions" !== e && "DefaultTaskChannels" !== e && "Manager" !== e || (this.inAction = !0);
        }, e;
      }();
    t.enablePluginProxy = function () {
      return a.FeatureFlags.isEnabled(i.FeatureFlag.PluginsUsePluginProxy) || !1;
    };
    t.enablePluginActivityConsoleLogging = function () {
      return a.FeatureFlags.isEnabled(i.FeatureFlag.PluginActivityConsoleLogging) || !1;
    };
    t.getPluginProxy = function (e) {
      var n;
      return t.enablePluginProxy() ? null === (n = window.Twilio.FlexProxy) || void 0 === n ? void 0 : n[e] : void 0;
    };
    t.setupPluginProxy = function (e) {
      window.Twilio && t.enablePluginProxy() && (window.Twilio.FlexProxy || (window.Twilio.FlexProxy = {}), Object.prototype.hasOwnProperty.call(window.Twilio.FlexProxy, e.name) && o.warn("Proxy for plugin " + e.name + " already exists, multiple plugins with same name using the same proxy!"), window.Twilio.FlexProxy[e.name] = t.createPluginProxy(e));
    };
    t.createPluginProxy = function (e) {
      var t = new d(e),
        n = {
          get: function get(e, r, o) {
            var i = String(r);
            t.startGetTrap(i);
            var a = Object.getOwnPropertyDescriptor(e, r);
            if (a && !1 === a.configurable && !1 === a.writable) return Reflect.get(e, r, o);
            var s = e;
            return null === s[i] || ("object" != typeof s[i] || t.inDynamicComponent) && "function" != typeof s[i] ? (t.inDynamicComponent && t.finishDynamicComponent && !t.eventName.endsWith("Content.replace.add") ? (t.logDynamicComponent(t.currentComponentName, t.currentComponent.key), t.finishDynamicComponent = !1) : "registeredFragments" === r ? t.reset() : -1 === u.indexOf(i) && (t.logActivity(), t.reset()), Reflect.get(e, r, o)) : new Proxy(s[i], n);
          },
          apply: function apply(e, n, r) {
            var o;
            if (t.inDynamicComponent && (t.currentComponent = r[0], t.finishDynamicComponent = !0), t.inAction) {
              var i = null !== (o = null == r ? void 0 : r[0]) && void 0 !== o ? o : "";
              t.logActivity(i), t.reset();
            }
            var a = e;
            return Reflect.apply(a, n, r);
          }
        };
      return new Proxy(window.Twilio.Flex, n);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
      var r = Array(e),
        o = 0;
      for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
      return r;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Supervisor = void 0;
    var o = n(3),
      i = n(174),
      a = function () {
        function e(e, t) {
          var n = this;
          this.handlerMirror = new Map(), this.proxyReservation = function (e) {
            var t = n;
            return new Proxy(e, {
              get: function get(e, n, r) {
                var o = Reflect.get(e, n, r);
                return "function" == typeof o ? function () {
                  for (var r = [], i = 0; i < arguments.length; i++) r[i] = arguments[i];
                  switch (n) {
                    case "call":
                      var a = r[0],
                        s = void 0 === a ? "" : a,
                        l = r[1],
                        c = void 0 === l ? "" : l,
                        u = r[2],
                        p = void 0 === u ? {} : u,
                        d = t.updateExtraOptions(p);
                      return o.apply(e, [s, c, d]);
                    case "conference":
                      var f = r[0];
                      p = void 0 === f ? {} : f, d = t.updateExtraOptions(p);
                      return o.apply(e, [d]);
                  }
                  return o.apply(e, r);
                } : o;
              }
            });
          }, this.on = function (e, t) {
            if (!n.shouldProxyEventListener(e)) return n.supervisor.on(e, t);
            var r = n,
              o = new Proxy(t, {
                apply: function apply(e, t, n) {
                  var o = n[0];
                  Reflect.apply(e, t, [r.proxyReservation(o)]);
                }
              });
            return n.handlerMirror.set(t, o), n.supervisor.on(e, o);
          }, this.removeListener = function (e, t) {
            if (!n.shouldProxyEventListener(e)) return n.supervisor.removeListener(e, t);
            var r = n.handlerMirror.get(t);
            return r ? (n.handlerMirror.delete(t), n.supervisor.removeListener(e, r)) : n.supervisor.removeListener(e, t);
          }, this.removeAllListeners = function (e) {
            return n.shouldProxyEventListener(e) && n.handlerMirror.clear(), n.supervisor.removeAllListeners(e);
          }, this.addListener = this.on, this.supervisor = new i.Supervisor(e, t);
          var r = this;
          this.proxy = new Proxy(this.supervisor, {
            get: function get(e, t) {
              return r[t] ? r[t] : Reflect.get(e, t);
            }
          });
        }
        return e.prototype.shouldProxyEventListener = function (e) {
          return "reservationCreated" === e;
        }, e.prototype.updateExtraOptions = function (e) {
          if (!e.to) {
            var t = o.FlexModule.workerClient.attributes.contact_uri;
            e.to = t;
          }
          return e;
        }, e.prototype.updateExtraOptionsForMonitor = function (e) {
          if (!e.To) {
            var t = o.FlexModule.workerClient.attributes.contact_uri;
            e.To = t;
          }
          return e;
        }, Object.defineProperty(e.prototype, "reservations", {
          get: function get() {
            var e = this,
              t = new Map();
            return this.supervisor.reservations.forEach(function (n, r) {
              t.set(r, e.proxyReservation(n));
            }), t;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.monitor = function (e, t, n) {
          void 0 === n && (n = {});
          var r = this.updateExtraOptionsForMonitor(n);
          this.supervisor.monitor(e, t, r);
        }, e.prototype.getProxy = function () {
          return this.proxy;
        }, e.prototype.emit = function (e) {
          for (var t, n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
          return (t = this.supervisor).emit.apply(t, r([e], n));
        }, e;
      }();
    t.Supervisor = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.fetchFlexFeatures = void 0;
    var i = n(27),
      a = n(5),
      s = n(10),
      l = n(53),
      c = n(46),
      u = n(9),
      p = n(71);
    t.fetchFlexFeatures = function (e) {
      return r(this, void 0, Promise, function () {
        var t, n, r, d, f, h, m;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return [4, p.TokenManager.getActiveTokenPayload()];
            case 1:
              if (!(t = o.sent())) return a.log.error("Failed to fetch feature flag config due to the access token issue"), [2, Promise.reject()];
              n = u.getSessionUrl(e.configuration), l.Actions.setFeatureOverrides(e.configuration.featureOverrides), o.label = 2;
            case 2:
              return o.trys.push([2, 5,, 6]), [4, i.default.get(n, {
                headers: {
                  "X-Flex-Version": c.VERSION,
                  "X-Flex-JWE": t.token
                }
              })];
            case 3:
              return r = o.sent(), d = r.data, f = d.insightsActive, h = d.features, l.Actions.setFeatures(h), l.Actions.overrideFeatureFlag({
                id: s.FeatureFlag.FlexInsights,
                enabled: f,
                name: s.FeatureFlag.FlexInsights,
                description: "Whether Flex Insights is enabled",
                stage: s.FeatureStage.Private
              }), [4, Promise.resolve()];
            case 4:
              return [2, o.sent()];
            case 5:
              return m = o.sent(), a.log.error("Failed to fetch feature flag configuration", m), [2, Promise.reject(m)];
            case 6:
              return [2];
          }
        });
      });
    };
  }, function (e, t) {
    e.exports = require("async-sema");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
      var r = Array(e),
        o = 0;
      for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
      return r;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerListener = void 0;
    var o = n(73),
      i = function () {
        function e(e, t, n, r) {
          this._state = void 0, this._state = {
            worker: e,
            tasks: []
          }, this.taskFilter = r, this.initInsightsQuery(t), this.onTasksUpdated = n;
        }
        return Object.defineProperty(e.prototype, "state", {
          get: function get() {
            return this._state;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.updateWorker = function (e) {
          this._state.worker = e;
        }, e.prototype.getTasksFromItems = function (e) {
          return Object.keys(e).map(function (t) {
            return new o.InsightsTask(e[t]);
          });
        }, e.prototype.updateTasksInState = function (e) {
          this._state = {
            tasks: e,
            worker: this.state.worker
          }, this.onTasksUpdated(this);
        }, e.prototype.onTasksItemsUpdated = function (e) {
          var t = this.getTasksFromItems(e);
          this.updateTasksInState(t);
        }, e.prototype.onTaskItemUpdated = function (e) {
          var t = new o.InsightsTask(e.value),
            n = r(this._state.tasks),
            i = n.findIndex(function (e) {
              return e.sid === t.sid;
            });
          i >= 0 ? n[i] = t : n.push(t), this.updateTasksInState(n);
        }, e.prototype.onTaskItemRemoved = function (e) {
          var t = this._state.tasks.filter(function (t) {
            return t.sid !== e.key;
          });
          this.updateTasksInState(t);
        }, e.prototype.initInsightsQuery = function (e) {
          var t = this,
            n = 'data.worker_sid == "' + this.state.worker.sid + '"';
          this.taskFilter && (n = n + " && (" + this.taskFilter + ")"), e.liveQuery("tr-reservation", n).then(function (e) {
            t.liveQuery = e, t.onTasksItemsUpdated(e.getItems()), e.on("itemUpdated", function (e) {
              t.onTaskItemUpdated(e);
            }), e.on("itemRemoved", function (e) {
              t.onTaskItemRemoved(e);
            });
          });
        }, e.prototype.unInit = function () {
          this.liveQuery && (this.liveQuery.removeAllListeners(), this.liveQuery.close());
        }, e;
      }();
    t.WorkerListener = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskOverviewIcon = void 0;
    var r = n(393);
    Object.defineProperty(t, "TaskOverviewIcon", {
      enumerable: !0,
      get: function get() {
        return r.TaskOverviewIcon;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskOverviewIcon = void 0;
    var r = n(1),
      o = n(20),
      i = n(171),
      a = n(74),
      s = n(395);
    t.TaskOverviewIcon = function (e) {
      var t = e.task,
        n = o.TaskChannels.getForTask(t),
        l = o.TaskChannelHelper.getIcon(t, n.icons.active, i.TaskOverviewCanvas),
        c = o.TaskChannelHelper.getColor(t, n.colors.main, i.TaskOverviewCanvas);
      return r.createElement(a.IconContainerWithStyle, {
        background: c
      }, r.createElement(s.StyledIcon, {
        icon: l,
        sizeMultiplier: 2
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledIcon = void 0;
    var o,
      i = n(0),
      a = n(2);
    t.StyledIcon = a.default(i.Icon)(o || (o = r(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (e) {
      return e.color;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.canvasParticipants = void 0;
    var r = n(31),
      o = r.createSelector(function (e) {
        return e.sids;
      }, function (e) {
        return e.bySid;
      }, function (e, t) {
        return e.map(function (e) {
          return t[e];
        });
      });
    function i(e) {
      var t, n, r, o, i, a;
      return {
        queue: null,
        worker: null,
        callSid: null === (t = null == e ? void 0 : e.mediaProperties) || void 0 === t ? void 0 : t.callSid,
        isMyself: !1,
        onHold: null === (n = null == e ? void 0 : e.mediaProperties) || void 0 === n ? void 0 : n.hold,
        muted: null === (r = null == e ? void 0 : e.mediaProperties) || void 0 === r ? void 0 : r.muted,
        connecting: !0,
        status: "",
        participantType: null == e ? void 0 : e.type,
        reservationSid: null === (o = null == e ? void 0 : e.routingProperties) || void 0 === o ? void 0 : o.reservationSid,
        workerSid: null === (i = null == e ? void 0 : e.routingProperties) || void 0 === i ? void 0 : i.workerSid,
        uniqueId: null == e ? void 0 : e.participantSid,
        participantSid: null == e ? void 0 : e.participantSid,
        phoneNumber: null === (a = null == e ? void 0 : e.mediaProperties) || void 0 === a ? void 0 : a.from
      };
    }
    t.canvasParticipants = r.createSelector(o, function (e) {
      return e.filter(function (e) {
        return e.isPending;
      }).map(i);
    });
  }, function (e, t, n) {
    "use strict";

    var _r74,
      o = this && this.__extends || (_r74 = function r(e, t) {
        return (_r74 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r74(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ParticipantsCanvasImpl = t.contentStore = t.displayName = void 0;
    var a = n(0),
      s = n(1),
      l = n(76),
      c = n(28),
      u = n(3),
      p = n(6),
      d = n(8),
      f = n(196),
      h = n(402);
    t.displayName = "ParticipantsCanvas", t.contentStore = new a.DynamicContentStore(t.displayName);
    var m = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          participantWidth: 50,
          listMode: !1
        }, t.handleSelectedViewChanged = function (e, n) {
          n || t.handleParticipantWidthNeedsUpdate();
        }, t.handleParticipantWidthNeedsUpdate = function () {
          if (t.container) {
            var e = t.container.offsetWidth,
              n = t.container.offsetHeight,
              r = 4;
            e <= 340 ? r = 1 : e <= 510 ? r = 2 : e <= 680 && (r = 3);
            var o = t.getParticipants();
            r = Math.min(r, o.length);
            var i = 190 * Math.ceil(o.length / r) > n;
            t.setState({
              listMode: i,
              participantWidth: 100 / r
            });
          }
        }, t.setContainerRef = function (e) {
          t.container = e;
        }, t.renderParticipants = function () {
          var e = t.props,
            n = e.task,
            r = e.hideActions;
          return t.getParticipants().map(function (e) {
            return s.createElement(f.ParticipantCanvas, {
              key: e.uniqueId,
              participant: e,
              participantWidth: t.state.participantWidth,
              task: n,
              hideActions: r,
              listMode: t.state.listMode
            });
          });
        }, t.unHoldMyself = function () {
          p.tryInvokeAction("UnholdParticipant", {
            task: t.props.task,
            targetSid: u.FlexModule.state.worker.worker.sid
          });
        }, t;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        var e = this;
        u.FlexModule.events.addListener(c.FlexEvent.flexSplitterResize, this.handleParticipantWidthNeedsUpdate), u.FlexModule.events.addListener(c.FlexEvent.viewResized, this.handleParticipantWidthNeedsUpdate), u.FlexModule.events.addListener(c.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), setTimeout(function () {
          e.handleParticipantWidthNeedsUpdate();
        }, 0);
      }, n.prototype.componentWillUnmount = function () {
        u.FlexModule.events.removeListener(c.FlexEvent.flexSplitterResize, this.handleParticipantWidthNeedsUpdate), u.FlexModule.events.removeListener(c.FlexEvent.viewResized, this.handleParticipantWidthNeedsUpdate), u.FlexModule.events.removeListener(c.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged);
      }, n.prototype.render = function () {
        var e = this,
          n = this.props.task,
          r = this.state.listMode ? h.ParticipantsContainerList : h.ParticipantsContainerNormal;
        return s.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          rootContainerStyles: "display: flex;\n                        position: relative;"
        }, s.createElement(h.Container, {
          key: "container"
        }, d.TaskHelper.amIOnHold(n) && s.createElement(h.WorkerOnHoldContainer, {
          key: "onHold",
          className: "ParticipantsCanvas-Container-ImOnHold"
        }, s.createElement(a.Template, {
          code: "CallCanvasWorkerOnHold"
        }), s.createElement(a.ActionStateListener, {
          key: "onHoldAction",
          action: "UnholdParticipant",
          payload: l.isValidWorkerParticipantActionPayload(n, u.FlexModule.state.worker.worker.sid)
        }, function (t) {
          return s.createElement(h.ActionButton, {
            onClick: e.unHoldMyself,
            disabled: t.disabled
          }, s.createElement(a.Template, {
            code: "CallCanvasUnholdWorker"
          }));
        })), s.createElement(h.Scroll, {
          innerRef: this.setContainerRef,
          key: "participantsContainer",
          className: "ParticipantsCanvas-Container"
        }, s.createElement(r, null, this.renderParticipants()))));
      }, n.prototype.getParticipants = function () {
        var e = this.props,
          t = e.conference,
          n = e.external,
          r = e.participantsByCallSid,
          o = t.source.participants;
        return o.forEach(function (e) {
          var t,
            n,
            o,
            i,
            a = e.callSid;
          e.participantSid = null === (t = r[a]) || void 0 === t ? void 0 : t.participantSid, e.phoneNumber = null === (o = null === (n = r[a]) || void 0 === n ? void 0 : n.mediaProperties) || void 0 === o ? void 0 : o.to, e.participantType = "unknown" === e.participantType ? null === (i = r[a]) || void 0 === i ? void 0 : i.type : e.participantType;
        }), this.props.includeMyself || (o = o.filter(function (e) {
          return !e.isMyself;
        })), o = o.filter(function (e) {
          return "left" !== e.status;
        }), i(o, n);
      }, n;
    }(s.PureComponent);
    t.ParticipantsCanvasImpl = m;
  }, function (e, t, n) {
    "use strict";

    var _r75,
      o = this && this.__extends || (_r75 = function r(e, t) {
        return (_r75 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r75(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ParticipantCanvas = void 0;
    var a = n(0),
      s = n(41),
      l = n(1),
      c = n(77),
      u = n(76),
      p = n(12),
      d = n(6),
      f = n(72),
      h = n(8),
      m = n(4),
      g = n(2),
      y = n(400),
      v = n(401),
      b = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            showKickConfirmation: !1
          }, t.getThemeForButtons = function () {
            return function (e) {
              return a.Utils.merge(e, {
                Button: e.ParticipantsCanvas.ParticipantCanvas.Button
              });
            };
          }, t.showKickConfirmation = function () {
            return t.setState({
              showKickConfirmation: !0
            });
          }, t.hideKickConfirmation = function () {
            return t.setState({
              showKickConfirmation: !1
            });
          }, t.onCancelTransferClick = function () {
            var e = t.props,
              n = e.task,
              r = e.participant;
            if ("external" === r.participantType) return d.tryInvokeAction("KickParticipant", {
              task: n,
              targetSid: r.participantSid
            }), void f.dispatch(f.removeParticipant(r.participantSid));
            d.tryInvokeAction("CancelTransfer", {
              task: n
            });
          }, t.onHoldParticipantClick = function () {
            var e = t.props,
              n = e.task,
              r = e.participant;
            "worker" === r.participantType ? d.tryInvokeAction(r.onHold ? "UnholdParticipant" : "HoldParticipant", {
              task: n,
              targetSid: r.workerSid
            }) : "external" === r.participantType ? d.tryInvokeAction(r.onHold ? "UnholdParticipant" : "HoldParticipant", {
              task: n,
              targetSid: r.participantSid
            }) : d.tryInvokeAction(r.onHold ? "UnholdCall" : "HoldCall", {
              task: n,
              participantCallSid: r.callSid
            }), r.onHold && p.TelemetryManager.reportCallParticipantUnhold({
              type: r.participantType
            }), r.onHold || p.TelemetryManager.reportCallParticipantHold({
              type: r.participantType
            });
          }, t.onKickParticipantConfirmClick = function () {
            var e = t.props,
              n = e.task,
              r = e.participant;
            d.tryInvokeAction("KickParticipant", {
              task: n,
              targetSid: r.participantSid || r.workerSid
            }), t.hideKickConfirmation();
          }, t;
        }
        var n;
        return o(t, e), n = t, t.prototype.render = function () {
          var e = this.props,
            t = e.task,
            n = e.participant,
            r = "recently_left" === n.status || h.TaskHelper.amIOnHold(t),
            o = "",
            i = "",
            a = m.templates.CallParticipantStatusLive;
          if ("customer" === this.props.participant.participantType) o = l.createElement(m.Template, {
            code: "CallParticipantCustomerName",
            task: t
          });else if ("worker" === n.participantType || "transfer" === n.participantType) {
            var s = n.worker;
            s ? (o = s.fullName, i = s.attributes.image_url) : n.queue && (o = n.queue.name);
          } else "external" === n.participantType && (o = n.phoneNumber);
          return n.onHold && (a = m.templates.CallParticipantStatusOnHold), "recently_left" === n.status && (a = "transfer" === n.participantType ? m.templates.CallParticipantStatusTransferFailed : m.templates.CallParticipantStatusLeft), n.connecting && (a = m.templates.CallParticipantStatusConnecting), this.state.showKickConfirmation && (a = m.templates.CallParticipantStatusKickConfirmation), this.props.listMode ? this.renderContentList(r, o, i, a) : this.renderContent(r, o, i, a);
        }, t.prototype.renderContent = function (e, t, r, o) {
          var i = this.props,
            c = i.task,
            u = i.participant,
            p = i.theme,
            d = i.hideActions,
            f = p.ParticipantsCanvas.ParticipantCanvas.ConnectingAnimation.color,
            g = this.getThemeForButtons();
          return l.createElement(s.ThemeProvider, {
            theme: g
          }, l.createElement(a.DynamicComponent, {
            contentStore: n.Content,
            childProps: this.props,
            name: n.displayName,
            customChildren: this.props.children,
            vertical: !0
          }, l.createElement(y.Container, {
            "data-test": "string" == typeof t ? t.replace("+", "") : "unknown",
            participantWidth: this.props.participantWidth,
            isDisabled: e
          }, l.createElement(y.StyledAvatar, {
            key: "avatar",
            className: "ParticipantCanvas-Avatar",
            imageUrl: r,
            large: !0,
            showAvailabilityIcon: !1,
            noStyling: !0,
            hold: u.onHold,
            "data-test": "participant-canvas-avatar"
          }), (u.onHold || u.connecting) && l.createElement(y.AvatarHover, {
            key: "avatar-hover",
            className: "ParticipantCanvas-Hover"
          }, u.connecting && l.createElement(a.ConnectingAnimation, {
            color: f,
            sizeMultiplier: 3
          }), u.onHold && l.createElement(a.Icon, {
            icon: "HoldBold",
            sizeMultiplier: 2
          })), l.createElement(y.Name, {
            key: "name",
            className: "ParticipantCanvas-Name"
          }, t, " "), l.createElement(y.Status, {
            key: "status",
            className: "ParticipantCanvas-Status"
          }, l.createElement(m.Template, {
            source: o
          })), !d && h.TaskHelper.isMyTask(c) && l.createElement(y.ActionsContainer, {
            key: "actions",
            className: "ParticipantCanvas-Actions"
          }, l.createElement(a.DynamicComponent, {
            contentStore: n.Actions.Content,
            childProps: this.props,
            name: n.Actions.displayName,
            noContainers: !0
          }, this.renderActions())))));
        }, t.prototype.renderContentList = function (e, t, r, o) {
          var i = this.props,
            c = i.task,
            u = i.participant,
            p = i.theme,
            d = i.hideActions,
            f = p.ParticipantsCanvas.ParticipantCanvas.ConnectingAnimation.color,
            g = this.getThemeForButtons();
          return l.createElement(s.ThemeProvider, {
            theme: g
          }, l.createElement(a.DynamicComponent, {
            contentStore: n.ListItem.Content,
            childProps: this.props,
            name: n.ListItem.displayName,
            customChildren: this.props.children,
            noContainers: !0
          }, l.createElement(v.Container, {
            isDisabled: e
          }, l.createElement(v.StyledAvatar, {
            key: "avatar",
            className: "ParticipantCanvas-Avatar",
            imageUrl: r,
            showAvailabilityIcon: !1,
            noStyling: !0,
            hold: u.onHold
          }), (u.onHold || u.connecting) && l.createElement(v.AvatarHover, {
            key: "avatar-hover",
            className: "ParticipantCanvas-Hover"
          }, u.connecting && l.createElement(a.ConnectingAnimation, {
            color: f
          }), u.onHold && l.createElement(a.Icon, {
            icon: "HoldBold",
            sizeMultiplier: 1
          })), l.createElement(v.StatusContainer, {
            key: "statusContainer"
          }, l.createElement(v.Name, {
            key: "name",
            className: "ParticipantCanvas-Name"
          }, t, " "), l.createElement(v.Status, {
            key: "status",
            className: "ParticipantCanvas-Status"
          }, l.createElement(m.Template, {
            source: o
          }))), !d && h.TaskHelper.isMyTask(c) && l.createElement(v.ActionsContainer, {
            key: "actions",
            className: "ParticipantCanvas-Actions"
          }, l.createElement(a.DynamicComponent, {
            contentStore: n.Actions.Content,
            childProps: this.props,
            name: n.Actions.displayName,
            noContainers: !0
          }, this.renderActions())))));
        }, t.prototype.renderActions = function () {
          var e = this;
          if (this.state.showKickConfirmation) return this.renderKickConfirmation();
          var t = this.props,
            n = t.participant,
            r = t.theme,
            o = t.task;
          if (n.connecting && ("transfer" === n.participantType || "external" === n.participantType)) return l.createElement(l.Fragment, null, l.createElement(a.ActionStateListener, {
            key: "cancel-transfer",
            action: "CancelTransfer",
            payload: u.isValidWorkerActionPayload(o)
          }, function (t) {
            return l.createElement(a.IconButton, {
              icon: "CloseLarge",
              className: "ParticipantCanvas-CancelButton",
              onClick: e.onCancelTransferClick,
              themeOverride: r.ParticipantsCanvas.ParticipantCanvas.HangUpButton,
              title: n.connecting && "transfer" === n.participantType ? m.templates.CancelTransferTooltip() : m.templates.CancelExternalWarmTransfer(),
              disabled: t.disabled
            });
          }));
          var i = n.onHold ? m.templates.UnholdCustomerTooltip() : m.templates.HoldCustomerTooltip(),
            s = ["HoldCall", "UnholdCall"],
            p = c.isValidVoiceActionPayload(o);
          return "worker" === n.participantType && (i = n.onHold ? m.templates.UnholdAgentTooltip({
            worker: n.worker
          }) : m.templates.HoldAgentTooltip({
            worker: n.worker
          }), s = ["HoldParticipant", "UnholdParticipant"], p = u.isValidWorkerParticipantActionPayload(o, n.workerSid)), l.createElement(l.Fragment, null, l.createElement(a.ActionStateListener, {
            key: "hold",
            action: s,
            payload: p
          }, function (t) {
            return l.createElement(a.IconButton, {
              "data-test": "participant-toggle-hold",
              icon: n.onHold ? "HoldOff" : "Hold",
              className: "ParticipantCanvas-HoldButton",
              disabled: !h.TaskHelper.canHold(o) || "joined" !== n.status || t.disabled,
              onClick: e.onHoldParticipantClick,
              title: i
            });
          }), ("worker" === n.participantType || "external" === n.participantType) && l.createElement(a.ActionStateListener, {
            key: "kick",
            action: "KickParticipant",
            payload: u.isValidWorkerActionPayload(o)
          }, function (t) {
            return l.createElement(a.IconButton, {
              "data-test": "participant-kick",
              icon: "Hangup",
              className: "ParticipantCanvas-HangupButton",
              disabled: !h.TaskHelper.canKickWorkerParticipant(o, n) || t.disabled,
              onClick: e.showKickConfirmation,
              themeOverride: r.ParticipantsCanvas.ParticipantCanvas.HangUpButton,
              title: m.templates.KickAgentTooltip({
                worker: n.worker
              })
            });
          }));
        }, t.prototype.renderKickConfirmation = function () {
          return l.createElement(l.Fragment, null, l.createElement(a.IconButton, {
            "data-test": "participant-accept-kick",
            key: "accept-kick",
            icon: "Accept",
            className: "ParticipantCanvas-AcceptAction",
            onClick: this.onKickParticipantConfirmClick
          }), l.createElement(a.IconButton, {
            key: "cancel-kick",
            icon: "Close",
            className: "ParticipantCanvas-DeclineAction",
            onClick: this.hideKickConfirmation
          }));
        }, t.displayName = "ParticipantCanvas", t.Content = new a.DynamicContentStore(n.displayName), t.ListItem = {
          displayName: "ParticipantCanvasListItem",
          Content: new a.DynamicContentStore("ParticipantCanvasListItem")
        }, t.Actions = {
          displayName: "ParticipantCanvasActions",
          Content: new a.DynamicContentStore("ParticipantCanvasActions")
        }, t = n = i([g.withTheme], t);
      }(l.Component);
    t.ParticipantCanvas = b;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.handleVOErrors = void 0;
    var r = n(0),
      o = n(14);
    t.handleVOErrors = function (e) {
      switch (null == e ? void 0 : e.error_code) {
        case 13223:
        case 21211:
          r.Notifications.showNotification(o.OutboundCallCanceledInvalidNumber);
          break;
        case 21210:
          r.Notifications.showNotification(o.OutboundCallCanceledFromNumberUnverified);
          break;
        case 21215:
          r.Notifications.showNotification(o.OutboundCallCanceledDisabledCountry);
          break;
        case 45305:
          r.Notifications.showNotification(o.OutboundCallCanceledNoAnswer);
          break;
        case 45303:
          r.Notifications.showNotification(o.OutboundCallCanceledBusy);
          break;
        case 45302:
        case 45306:
        case 45307:
          break;
        default:
          r.Notifications.showNotification(o.OutboundCallCanceledGeneric, {
            reasonCode: (null == e ? void 0 : e.message) || "Unable to complete External Call."
          });
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionsContainer = t.AvatarHover = t.StyledAvatar = t.Status = t.Name = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u = n(0),
      p = n(2);
    t.Container = p.default("div")(o || (o = r(["\n    flex-grow: 0;\n    padding: 8px;\n    font-size: 30px;\n    text-align: center;\n    box-sizing: border-box;\n    min-width: 170px;\n    width: ", ";\n    opacity: ", ";\n    ", "\n"], ["\n    flex-grow: 0;\n    padding: 8px;\n    font-size: 30px;\n    text-align: center;\n    box-sizing: border-box;\n    min-width: 170px;\n    width: ", ";\n    opacity: ", ";\n    ", "\n"])), function (e) {
      return e.participantWidth + "%";
    }, function (e) {
      return e.isDisabled && .4;
    }, function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.Container;
    }), t.Name = p.default("div")(i || (i = r(["\n    font-size: 14px;\n    font-weight: bold;\n    margin-top: 10px;\n    margin-bottom: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    font-size: 14px;\n    font-weight: bold;\n    margin-top: 10px;\n    margin-bottom: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))), t.Status = p.default("div")(a || (a = r(["\n    font-size: 12px;\n"], ["\n    font-size: 12px;\n"]))), t.StyledAvatar = p.default(u.Avatar)(s || (s = r(["\n    margin: 0 auto;\n    width: 72px;\n    height: 72px;\n    border-radius: 1000px;\n    position: relative;\n    border-style: solid;\n    border-width: 1px;\n    ", ";\n    background: ", ";\n"], ["\n    margin: 0 auto;\n    width: 72px;\n    height: 72px;\n    border-radius: 1000px;\n    position: relative;\n    border-style: solid;\n    border-width: 1px;\n    ", ";\n    background: ", ";\n"])), function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.Avatar;
    }, function (e) {
      return e.hold && e.theme.colors.holdColor;
    }), t.AvatarHover = p.default(u.FlexBox)(l || (l = r(["\n    left: 50%;\n    transform: translateX(-50%);\n    margin: 1px auto;\n    border-radius: 1000px;\n    width: 72px;\n    height: 72px;\n    position: absolute;\n    justify-content: center;\n    ", "\n"], ["\n    left: 50%;\n    transform: translateX(-50%);\n    margin: 1px auto;\n    border-radius: 1000px;\n    width: 72px;\n    height: 72px;\n    position: absolute;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.StateHover;
    }), t.ActionsContainer = p.default("div")(c || (c = r(["\n    margin-top: 10px;\n    button {\n        width: 30px;\n        height: 30px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"], ["\n    margin-top: 10px;\n    button {\n        width: 30px;\n        height: 30px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionsContainer = t.AvatarHover = t.StyledAvatar = t.Status = t.StatusContainer = t.Name = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p = n(0),
      d = n(2);
    t.Container = d.default("div")(o || (o = r(["\n    flex-grow: 0;\n    overflow: hidden;\n    padding: 8px 16px 0px 16px;\n    font-size: 12px;\n    box-sizing: border-box;\n    opacity: ", ";\n    ", ";\n"], ["\n    flex-grow: 0;\n    overflow: hidden;\n    padding: 8px 16px 0px 16px;\n    font-size: 12px;\n    box-sizing: border-box;\n    opacity: ", ";\n    ", ";\n"])), function (e) {
      return e.isDisabled && .4;
    }, function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.Container;
    }), t.Name = d.default("div")(i || (i = r(["\n    font-size: 12px;\n    font-weight: bold;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    font-size: 12px;\n    font-weight: bold;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))), t.StatusContainer = d.default(p.FlexBoxColumn)(a || (a = r(["\n    overflow: hidden;\n"], ["\n    overflow: hidden;\n"]))), t.Status = d.default("div")(s || (s = r(["\n    font-size: 10px;\n"], ["\n    font-size: 10px;\n"]))), t.StyledAvatar = d.default(p.Avatar)(l || (l = r(["\n    margin: 0 auto;\n    width: 30px;\n    height: 30px;\n    border-radius: 1000px;\n    position: relative;\n    border-style: solid;\n    border-width: 1px;\n    margin-right: 12px;\n    ", ";\n    background: ", ";\n"], ["\n    margin: 0 auto;\n    width: 30px;\n    height: 30px;\n    border-radius: 1000px;\n    position: relative;\n    border-style: solid;\n    border-width: 1px;\n    margin-right: 12px;\n    ", ";\n    background: ", ";\n"])), function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.Avatar;
    }, function (e) {
      return e.hold && e.theme.colors.holdColor;
    }), t.AvatarHover = d.default(p.FlexBox)(c || (c = r(["\n    left: 17px;\n    border-radius: 1000px;\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    justify-content: center;\n    ", "\n"], ["\n    left: 17px;\n    border-radius: 1000px;\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.StateHover;
    }), t.ActionsContainer = d.default("div")(u || (u = r(["\n    display: flex;\n    flex-grow: 0;\n    button {\n        width: 32px;\n        height: 32px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"], ["\n    display: flex;\n    flex-grow: 0;\n    button {\n        width: 32px;\n        height: 32px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionButton = t.WorkerOnHoldContainer = t.Scroll = t.ParticipantsContainerList = t.ParticipantsContainerNormal = t.Container = void 0;
    var o = n(2),
      i = n(33);
    t.Container = o.default("div")(a || (a = r(["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    flex-grow: 1;\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    flex-grow: 1;\n"]))), t.ParticipantsContainerNormal = o.default("div")(s || (s = r(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    flex: 1;\n    justify-content: center;\n    align-content: center;\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    flex: 1;\n    justify-content: center;\n    align-content: center;\n"]))), t.ParticipantsContainerList = o.default("div")(l || (l = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex-grow: 1;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex-grow: 1;\n"]))), t.Scroll = o.default("div")(c || (c = r(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-wrap: nowrap;\n    overflow-y: scroll;\n    overflow-x: hidden;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-wrap: nowrap;\n    overflow-y: scroll;\n    overflow-x: hidden;\n"])));
    var a,
      s,
      l,
      c,
      u,
      p,
      d,
      f = i.keyframes(u || (u = r(["\n    from {\n        opacity: 0.3;\n        transform: translate3d(0, -30px, 0);\n    }\n\n    to {\n        opacity: 1;\n        transform: translate3d(0);\n    }\n"], ["\n    from {\n        opacity: 0.3;\n        transform: translate3d(0, -30px, 0);\n    }\n\n    to {\n        opacity: 1;\n        transform: translate3d(0);\n    }\n"])));
    t.WorkerOnHoldContainer = o.default("div")(p || (p = r(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 32px;\n    padding: 0 12px;\n    flex-shrink: 0;\n    animation: ", " 0.15s ease 1;\n    ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 32px;\n    padding: 0 12px;\n    flex-shrink: 0;\n    animation: ", " 0.15s ease 1;\n    ", ";\n"])), f, function (e) {
      return e.theme.ParticipantsCanvas.Notification.Container;
    }), t.ActionButton = o.default("button")(d || (d = r(["\n    padding: 0px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    border: none;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"], ["\n    padding: 0px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    border: none;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r76,
      o = this && this.__extends || (_r76 = function r(e, t) {
        return (_r76 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r76(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasTabs = void 0;
    var s = n(1),
      l = n(0),
      c = n(405),
      u = n(3),
      p = n(26),
      d = n(2),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(h, i({}, this.props));
        }, t.displayName = c.displayName, t.Content = c.contentStore, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.TaskCanvasTabs = f;
    var h = u.connect(function (e) {
      var t,
        n,
        r = e.view.componentViewStates.SupervisorCanvasTabs;
      return {
        selectedTabName: !!r && r.selectedTabName,
        uniqueName: "SupervisorCanvasTabs",
        hasMarkdownSupport: null === (n = null === (t = e.config) || void 0 === t ? void 0 : t.markdown) || void 0 === n ? void 0 : n.enabled
      };
    })(p.withTaskContext(d.withTheme(c.TaskCanvasTabsImpl)));
  }, function (e, t, n) {
    "use strict";

    var _r77,
      o = this && this.__extends || (_r77 = function r(e, t) {
        return (_r77 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r77(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasTabsImpl = t.contentStore = t.displayName = void 0;
    var i = n(0),
      a = n(41),
      s = n(1),
      l = n(12),
      c = n(6),
      u = n(17),
      p = n(20),
      d = n(8),
      f = n(4),
      h = n(199),
      m = n(170),
      g = n(209);
    t.displayName = "SupervisorTaskCanvasTabs", t.contentStore = new i.DynamicContentStore(t.displayName);
    var y = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleTabSelection = function (e) {
          c.tryInvokeAction("SetComponentState", {
            name: "SupervisorCanvasTabs",
            state: {
              selectedTabName: e
            }
          });
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = e.task,
          r = e.selectedTabName,
          o = f.templates.TaskTabSupervisorOverviewLabel;
        return d.TaskHelper.isCallTask(n) ? o = f.templates.TaskTabSupervisorCallLabel : d.TaskHelper.isChatBasedTask(n) && (o = f.templates.TaskTabSupervisorChatLabel), s.createElement(i.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          vertical: !0
        }, s.createElement(i.Tabs, {
          className: "Twilio-TaskCanvasTabs",
          selectedTabName: r,
          onTabSelected: this.handleTabSelection
        }, s.createElement(i.Tab, {
          key: "overview",
          uniqueName: "overview",
          label: s.createElement(i.Template, {
            source: o
          })
        }, this.renderOverviewTab()), s.createElement(i.Tab, {
          key: "info",
          uniqueName: "info",
          label: s.createElement(i.Template, {
            source: f.templates.TaskTabSupervisorInfoLabel
          })
        }, s.createElement(g.TaskInfoPanel, {
          task: n
        }))));
      }, n.prototype.renderOverviewTab = function () {
        var e = this.props,
          t = e.task,
          r = e.hasMarkdownSupport;
        if (d.TaskHelper.isChatBasedTask(t)) {
          if (!this.props.chatChannel || this.props.chatChannel.isLoadingChannel) return null;
          if (this.props.chatChannel.errorWhileLoadingChannel) return s.createElement(m.TaskOverviewCanvas, {
            task: t
          });
          var o = p.TaskChannels.getForTask(t),
            c = u.TaskChannelHelper.getColor(t, o.colors.main, n),
            g = h.getThemeForChat(c),
            y = d.TaskHelper.getTaskChatChannelSid(t);
          return s.createElement(a.ThemeProvider, {
            theme: g
          }, s.createElement(l.TelemetryWrapper, {
            name: "chat_monitoring",
            data: y,
            details: {
              medium: "supervisor-teams-view",
              sid: y
            }
          }, s.createElement(i.MessagingCanvas, {
            sid: y,
            inputDisabledReason: d.TaskHelper.isCompleted(t) || d.TaskHelper.isInWrapupMode(t) ? f.templates.ChatInputDisabledText() : void 0,
            hasMarkdownSupport: r
          })));
        }
        return s.createElement(m.TaskOverviewCanvas, {
          task: t
        });
      }, n;
    }(s.PureComponent);
    t.TaskCanvasTabsImpl = y;
  }, function (e, t, n) {
    "use strict";

    var _r78,
      o = this && this.__extends || (_r78 = function r(e, t) {
        return (_r78 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r78(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IncomingTaskCanvasImpl = t.contentStore = t.displayName = void 0;
    var s = n(2),
      l = n(1),
      c = n(0),
      u = n(74),
      p = n(203),
      d = n(204),
      f = n(17),
      h = n(11),
      m = n(10);
    t.displayName = "IncomingTaskCanvas", t.contentStore = new c.DynamicContentStore(t.displayName);
    var g = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      var r;
      return o(n, e), r = n, n.prototype.render = function () {
        var e = this.props,
          n = e.firstLine,
          o = e.secondLine,
          a = e.channelDefinition,
          s = e.titleLine,
          c = this.props.task;
        return l.createElement(u.TaskDetailsPanel, i({
          content: t.contentStore,
          IconComponent: d.IncomingTaskIcon,
          ActionsComponent: p.IncomingTaskCanvasActions,
          titleLine: s || f.TaskChannelHelper.getTemplateForStatus(c, a.templates.IncomingTaskCanvas.titleLine, r),
          firstLine: n || f.TaskChannelHelper.getTemplateForStatus(c, a.templates.IncomingTaskCanvas.firstLine, r),
          subjectLine: h.FeatureFlags.isEnabled(m.FeatureFlag.EmailPOC) && "email" === c.attributes.channelType && c.attributes.subject,
          secondLine: o || f.TaskChannelHelper.getTemplateForStatus(c, a.templates.IncomingTaskCanvas.secondLine, r)
        }, this.props));
      }, n = r = a([s.withTheme], n);
    }(l.PureComponent);
    t.IncomingTaskCanvasImpl = g;
  }, function (e, t, n) {
    "use strict";

    var _r79,
      o = this && this.__extends || (_r79 = function r(e, t) {
        return (_r79 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r79(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IncomingTaskCanvasActions = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(4),
      u = n(6),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onAcceptClick = function () {
            u.tryInvokeAction("AcceptTask", {
              task: t.props.task
            });
          }, t.onDeclineClick = function () {
            u.tryInvokeAction("RejectTask", {
              task: t.props.task
            });
          }, t;
        }
        var n;
        return o(t, e), n = t, t.prototype.render = function () {
          var e = this;
          return s.createElement(l.DynamicComponent, {
            contentStore: n.Content,
            childProps: this.props,
            customChildren: this.props.children,
            name: n.displayName,
            noContainers: !0
          }, s.createElement(l.ContentFragment, null, s.createElement(l.ActionStateListener, {
            key: "Accept",
            action: ["AcceptTask", "RejectTask"],
            payload: {
              task: this.props.task
            }
          }, function (t) {
            return s.createElement(l.IconButton, {
              className: "Twilio-IncomingTask-Accept",
              icon: "AcceptLarge",
              themeOverride: e.props.theme.IncomingTaskCanvas.AcceptTaskButton,
              onClick: e.onAcceptClick,
              disabled: t.disabled,
              title: c.templates.AcceptTaskTooltip()
            });
          }), s.createElement(l.ActionStateListener, {
            key: "Reject",
            action: ["AcceptTask", "RejectTask"],
            payload: {
              task: this.props.task
            }
          }, function (t) {
            return s.createElement(l.IconButton, {
              className: "Twilio-IncomingTask-Reject",
              icon: "CloseLarge",
              themeOverride: e.props.theme.IncomingTaskCanvas.RejectTaskButton,
              onClick: e.onDeclineClick,
              disabled: t.disabled,
              title: c.templates.RejectTaskTooltip()
            });
          })));
        }, t.displayName = "IncomingTaskCanvasActions", t.Content = new l.DynamicContentStore(n.displayName), t = n = i([a.withTheme], t);
      }(s.Component);
    t.IncomingTaskCanvasActions = p;
  }, function (e, t, n) {
    "use strict";

    var _r80,
      o = this && this.__extends || (_r80 = function r(e, t) {
        return (_r80 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r80(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IncomingTaskIcon = void 0;
    var a = n(2),
      s = n(1),
      l = n(15),
      c = n(75),
      u = n(17),
      p = n(202),
      d = n(0),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.task;
          return s.createElement(l.TaskContext.Consumer, null, function (t) {
            return s.createElement(c.IconContainerWithStyle, {
              background: u.TaskChannelHelper.getColor(e, t.channelDefinition.colors.main, p.IncomingTaskCanvas)
            }, s.createElement(d.Icon, {
              icon: u.TaskChannelHelper.getIcon(e, t.channelDefinition.icons.active, p.IncomingTaskCanvas),
              sizeMultiplier: 2
            }));
          });
        }, t = i([a.withTheme], t);
      }(s.Component);
    t.IncomingTaskIcon = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r81,
      o = this && this.__extends || (_r81 = function r(e, t) {
        return (_r81 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r81(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallCanvasImpl = t.contentStore = t.displayName = void 0;
    var a = n(0),
      s = n(1),
      l = n(120),
      c = n(28),
      u = n(3),
      p = n(6),
      d = n(17),
      f = n(8),
      h = n(195),
      m = n(193),
      g = n(207),
      y = n(417),
      v = n(421);
    t.displayName = "CallCanvas", t.contentStore = new a.DynamicContentStore(t.displayName);
    var b = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.refCallback = function (e) {
          if (e) {
            var n = l.findDOMNode(e);
            t.containerElement = n.parentElement, t.handleParticipantWidthNeedsUpdate();
          }
        }, t.state = {
          height: 0
        }, t.handleParticipantWidthNeedsUpdate = function () {
          t.containerElement && t.setState({
            height: t.containerElement.getBoundingClientRect().height
          });
        }, t;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        u.FlexModule.events.addListener(c.FlexEvent.flexSplitterResize, this.handleParticipantWidthNeedsUpdate), u.FlexModule.events.addListener(c.FlexEvent.viewResized, this.handleParticipantWidthNeedsUpdate);
      }, n.prototype.componentWillUnmount = function () {
        u.FlexModule.events.removeListener(c.FlexEvent.flexSplitterResize, this.handleParticipantWidthNeedsUpdate), u.FlexModule.events.removeListener(c.FlexEvent.viewResized, this.handleParticipantWidthNeedsUpdate);
      }, n.prototype.componentDidUpdate = function () {
        var e = this.props.task;
        this.props.dialpadState && !f.TaskHelper.isLiveCall(e) && p.tryInvokeAction("ToggleDTMFDialpad", {
          task: e,
          open: !1
        });
      }, n.prototype.render = function () {
        var e,
          r = this.props,
          o = r.task,
          a = r.channelDefinition,
          l = r.conference,
          c = r.dialpadState,
          u = this.state.height < 370;
        return l && f.TaskHelper.isLiveCall(o) && (e = s.createElement(h.ParticipantsCanvas, null)), c && (e = s.createElement(y.CallCanvasDialpad, {
          compact: u,
          dialpadState: c
        })), s.createElement(m.TaskDetailsPanel, i({
          ref: this.refCallback,
          compact: u,
          content: t.contentStore,
          IconComponent: v.CallCanvasIcon,
          ActionsComponent: g.CallCanvasActions,
          contentComponent: e,
          titleLine: d.TaskChannelHelper.getTemplateForStatus(o, a.templates.CallCanvas.titleLine, n),
          firstLine: d.TaskChannelHelper.getTemplateForStatus(o, a.templates.CallCanvas.firstLine, n),
          secondLine: d.TaskChannelHelper.getTemplateForStatus(o, a.templates.CallCanvas.secondLine, n)
        }, this.props));
      }, n;
    }(s.PureComponent);
    t.CallCanvasImpl = b;
  }, function (e, t, n) {
    "use strict";

    var _r82,
      o = this && this.__extends || (_r82 = function r(e, t) {
        return (_r82 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r82(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallCanvasActions = void 0;
    var s = n(1),
      l = n(412),
      c = n(15),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(l.CallCanvasActionsImpl, i({}, this.props));
        }, t.displayName = l.displayName, t.Content = l.contentStore, t = a([c.withTaskContext], t);
      }(s.Component);
    t.CallCanvasActions = u;
  }, function (e, t, n) {
    "use strict";

    var _r83,
      o = this && this.__extends || (_r83 = function r(e, t) {
        return (_r83 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r83(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallCanvasActionsImpl = t.contentStore = t.displayName = void 0;
    var a = n(0),
      s = n(41),
      l = n(1),
      c = n(77),
      u = n(12),
      p = n(3),
      d = n(6),
      f = n(8),
      h = n(4),
      m = n(132),
      g = n(2),
      y = n(415);
    t.displayName = "CallCanvasActions", t.contentStore = new a.DynamicContentStore(t.displayName);
    var v = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onHoldClick = function () {
          var e = f.TaskHelper.isCallOnHold(t.props.task);
          d.tryInvokeAction(e ? "UnholdCall" : "HoldCall", {
            task: t.props.task
          });
        }, t.onHangupClick = function () {
          d.tryInvokeAction("HangupCall", {
            task: t.props.task
          });
        }, t.onDirectoryClick = function () {
          u.TelemetryManager.reportTransferPanelOpen(), d.tryInvokeAction("ShowDirectory", {
            task: t.props.task
          });
        }, t.onDialpadClick = function () {
          var e = t.props.task;
          d.tryInvokeAction("ToggleDTMFDialpad", {
            task: e
          });
        }, t.getThemeForButtons = function () {
          return function (e) {
            return a.Utils.merge(e, {
              Button: e.CallCanvas.Button
            });
          };
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this,
          n = this.props,
          r = n.task,
          o = n.theme,
          i = f.TaskHelper.isLiveCall(r),
          u = f.TaskHelper.isRegularConferenceCall(r),
          d = f.TaskHelper.isCallOnHold(r),
          g = f.TaskHelper.canHold(r),
          v = f.TaskHelper.canTransfer(r),
          b = c.isValidVoiceActionPayload(r),
          C = h.templates.HangupCallTooltip(),
          _ = "HangupLarge";
        r.conference && r.conference.liveParticipantCount > 2 && (_ = "LeaveCallLarge", C = h.templates.LeaveCallTooltip());
        var k = d ? h.templates.UnholdCustomerTooltip() : h.templates.HoldCustomerTooltip(),
          w = "CallCanvasDialpad" + this.props.task.sid,
          S = Boolean(p.FlexModule.state.view.componentViewStates[w]),
          P = this.getThemeForButtons();
        return l.createElement(s.ThemeProvider, {
          theme: P
        }, l.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          name: t.displayName,
          noContainers: !0
        }, l.createElement(a.ContentFragment, null, !u && l.createElement(a.ActionStateListener, {
          key: "hold",
          action: ["HoldCall", "UnholdCall"],
          payload: b
        }, function (t) {
          return l.createElement(y.HoldButton, {
            className: "Twilio-CallCanvas-HoldButton",
            disabled: !i || !g || t.disabled,
            isOnHold: d,
            onClick: e.onHoldClick,
            title: k
          });
        }), l.createElement(a.ActionStateListener, {
          key: "toggleMute",
          action: "ToggleMute"
        }, function (e) {
          return l.createElement(m.MuteButton, {
            className: "Twilio-CallCanvas-MuteButton",
            disabled: !i || e.disabled,
            large: !0,
            title: h.templates.MuteCallTooltip()
          });
        }), l.createElement(a.IconButton, {
          "data-test": "call-transfer",
          className: "Twilio-CallCanvas-Directory",
          icon: "TransferLarge",
          key: "directory",
          disabled: !i || !v,
          onClick: this.onDirectoryClick,
          title: h.templates.OpenDirectoryTooltip()
        }), l.createElement(a.IconButton, {
          className: "Twilio-CallCanvas-Dialpad",
          icon: S ? "CloseLarge" : "DialpadLarge",
          key: "dialpad",
          disabled: !i,
          onClick: this.onDialpadClick,
          title: S ? h.templates.CloseDialpadTooltip() : h.templates.OpenDialpadTooltip()
        }), l.createElement(a.ActionStateListener, {
          key: "hangup",
          action: "HangupCall",
          payload: b
        }, function (t) {
          return l.createElement(a.IconButton, {
            className: "Twilio-CallCanvas-HangupButton",
            icon: _,
            disabled: !i || t.disabled,
            onClick: e.onHangupClick,
            themeOverride: o.CallCanvas.HangUpButton,
            title: C
          });
        }))));
      }, n = i([g.withTheme], n);
    }(l.PureComponent);
    t.CallCanvasActionsImpl = v;
  }, function (e, t, n) {
    "use strict";

    var _r84,
      o = this && this.__extends || (_r84 = function r(e, t) {
        return (_r84 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r84(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MuteButton = void 0;
    var a = n(1),
      s = n(3),
      l = n(414),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(u, i({}, this.props));
        }, t;
      }(a.PureComponent);
    t.MuteButton = c;
    var u = s.connect(function (e, t) {
      return {
        muted: !!e.phone.connection && e.phone.connection.source.isMuted(),
        disabled: !e.phone.connection || t.disabled
      };
    })(l.MuteButtonImpl);
  }, function (e, t, n) {
    "use strict";

    var _r85,
      o = this && this.__extends || (_r85 = function r(e, t) {
        return (_r85 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r85(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MuteButtonImpl = void 0;
    var s = n(1),
      l = n(0),
      c = n(33),
      u = n(4),
      p = n(6),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onMuteClick = function () {
            p.tryInvokeAction("ToggleMute");
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.large,
            n = e.className,
            r = e.muted,
            o = (e.children, a(e, ["large", "className", "muted", "children"])),
            p = t ? "MuteLarge" : "Mute";
          return r && (p += "Bold"), s.createElement(l.IconButton, i({
            className: c.cx("Twilio-MuteButton", n),
            icon: p,
            onClick: this.onMuteClick,
            title: u.templates.MuteCallTooltip()
          }, o));
        }, t;
      }(s.PureComponent);
    t.MuteButtonImpl = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HoldButtonProps = t.HoldButton = void 0;
    var r = n(416);
    Object.defineProperty(t, "HoldButton", {
      enumerable: !0,
      get: function get() {
        return r.HoldButton;
      }
    }), Object.defineProperty(t, "HoldButtonProps", {
      enumerable: !0,
      get: function get() {
        return r.HoldButtonProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r86,
      o = this && this.__extends || (_r86 = function r(e, t) {
        return (_r86 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r86(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HoldButton = void 0;
    var s = n(1),
      l = n(0),
      c = n(33),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.className,
            n = e.isOnHold,
            r = e.onClick,
            o = a(e, ["className", "isOnHold", "onClick"]),
            u = n ? "HoldOffLarge" : "HoldLarge";
          return s.createElement(l.IconButton, i({
            className: c.cx("Twilio-HoldButton", t),
            icon: u,
            onClick: r
          }, o));
        }, t;
      }(s.PureComponent);
    t.HoldButton = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallCanvasDialpad = void 0;
    var r = n(418);
    Object.defineProperty(t, "CallCanvasDialpad", {
      enumerable: !0,
      get: function get() {
        return r.CallCanvasDialpad;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r87,
      o = this && this.__extends || (_r87 = function r(e, t) {
        return (_r87 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r87(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.CallCanvasDialpad = void 0;
    var a = n(1),
      s = n(15),
      l = n(419),
      c = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.displayName = l.displayName, n.Content = l.contentStore, n;
      }(a.PureComponent);
    t.CallCanvasDialpad = c, t.Connected = s.withTaskContext(l.CallCanvasDialpadImpl);
  }, function (e, t, n) {
    "use strict";

    var _r88,
      o = this && this.__extends || (_r88 = function r(e, t) {
        return (_r88 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r88(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallCanvasDialpadImpl = t.contentStore = t.displayName = void 0;
    var i = n(1),
      a = n(0),
      s = n(6),
      l = n(420);
    t.displayName = "CallCanvasDialpad", t.contentStore = new a.DynamicContentStore(t.displayName);
    var c = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleKeyClick = function (e) {
          s.tryInvokeAction("SendDTMFDigits", {
            task: t.props.task,
            digits: e
          });
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        return i.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          rootContainerStyles: "overflow: visible;"
        }, i.createElement(l.Container, {
          className: "Twilio-CallCanvas-Dialpad"
        }, i.createElement(l.DigitsContainer, {
          key: "digits"
        }, i.createElement(l.Digits, null, this.props.dialpadState.digits)), i.createElement(a.Dialpad, {
          compact: this.props.compact,
          key: "dialpad",
          onClick: this.handleKeyClick
        })));
      }, n;
    }(i.PureComponent);
    t.CallCanvasDialpadImpl = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.Digits = t.DigitsContainer = void 0;
    var o,
      i,
      a,
      s,
      l = n(33),
      c = n(2),
      u = l.keyframes(o || (o = r(["\n    from {\n        opacity: 0.3;\n        transform: translate3d(0, -30px, 0);\n    }\n\n    to {\n        opacity: 1;\n        transform: translate3d(0);\n    }\n"], ["\n    from {\n        opacity: 0.3;\n        transform: translate3d(0, -30px, 0);\n    }\n\n    to {\n        opacity: 1;\n        transform: translate3d(0);\n    }\n"])));
    t.DigitsContainer = c.default("div")(i || (i = r(["\n    height: 44px;\n    display: flex;\n    overflow: hidden;\n    justify-content: center;\n    width: 100%;\n"], ["\n    height: 44px;\n    display: flex;\n    overflow: hidden;\n    justify-content: center;\n    width: 100%;\n"]))), t.Digits = c.default("span")(a || (a = r(["\n    font-size: 18px;\n    line-height: 1.33;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    align-self: center;\n"], ["\n    font-size: 18px;\n    line-height: 1.33;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    align-self: center;\n"]))), t.Container = c.default("div")(s || (s = r(["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    animation: ", " 0.15s ease 1;\n    width: 100%;\n    max-width: 252px;\n    margin: 0 auto;\n"], ["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    animation: ", " 0.15s ease 1;\n    width: 100%;\n    max-width: 252px;\n    margin: 0 auto;\n"])), u);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallCanvasIcon = void 0;
    var r = n(422);
    Object.defineProperty(t, "CallCanvasIcon", {
      enumerable: !0,
      get: function get() {
        return r.CallCanvasIcon;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallCanvasIcon = void 0;
    var r = n(1),
      o = n(20),
      i = n(206),
      a = n(75),
      s = n(423);
    t.CallCanvasIcon = function (e) {
      var t = e.task,
        n = o.TaskChannels.getForTask(t),
        l = o.TaskChannelHelper.getIcon(t, n.icons.active, i.CallCanvas),
        c = o.TaskChannelHelper.getColor(t, n.colors.main, i.CallCanvas);
      return r.createElement(a.IconContainerWithStyle, {
        background: c
      }, r.createElement(s.StyledIcon, {
        icon: l,
        sizeMultiplier: 2
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledIcon = void 0;
    var o,
      i = n(0),
      a = n(2);
    t.StyledIcon = a.default(i.Icon)(o || (o = r(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (e) {
      return e.color;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r89,
      o = this && this.__extends || (_r89 = function r(e, t) {
        return (_r89 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r89(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskInfoPanelImpl = void 0;
    var i = n(1),
      a = n(8),
      s = n(0),
      l = n(426),
      c = n(17),
      u = n(133),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.task,
            n = e.content,
            r = e.templateCode,
            o = e.channelDefinition,
            p = new a.TaskHelper(t);
          return i.createElement(s.DynamicComponent, {
            contentStore: n,
            childProps: this.props,
            name: n.name,
            customChildren: this.props.children,
            vertical: !0
          }, i.createElement(l.Container, null, i.createElement(s.Template, {
            key: "content",
            code: r || c.TaskChannelHelper.getTemplateForStatus(t, o.templates.TaskInfoPanel.content, u.TaskInfoPanel),
            task: t,
            helper: p
          })));
        }, t;
      }(i.PureComponent);
    t.TaskInfoPanelImpl = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(2);
    t.Container = i.default("div")(o || (o = r(["\n    display: flex;\n    flex: 1 1 auto;\n    overflow: auto;\n    padding-left: 12px;\n    padding-right: 12px;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    ", "\n\n    hr {\n        border-color: ", ";\n    }\n"], ["\n    display: flex;\n    flex: 1 1 auto;\n    overflow: auto;\n    padding-left: 12px;\n    padding-right: 12px;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    ", "\n\n    hr {\n        border-color: ", ";\n    }\n"])), function (e) {
      return e.theme.TaskInfoPanel.Container;
    }, function (e) {
      return e.theme.Tabs.LabelsContainer.borderColor;
    });
  }, function (e, t, n) {
    "use strict";

    var _r90,
      o = this && this.__extends || (_r90 = function r(e, t) {
        return (_r90 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r90(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.ConnectingOutboundCallCanvas = void 0;
    var a = n(1),
      s = n(15),
      l = n(428),
      c = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.displayName = l.displayName, n.Content = l.contentStore, n;
      }(a.PureComponent);
    t.ConnectingOutboundCallCanvas = c, t.Connected = s.withTaskContext(l.ConnectingOutboundCallCanvasImpl);
  }, function (e, t, n) {
    "use strict";

    var _r91,
      o = this && this.__extends || (_r91 = function r(e, t) {
        return (_r91 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r91(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingOutboundCallCanvasImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(74),
      c = n(208),
      u = n(430),
      p = n(17),
      d = n(8),
      f = n(23);
    t.displayName = "ConnectingOutboundCallCanvas", t.contentStore = new s.DynamicContentStore(t.displayName);
    var h = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        var e,
          r = this.props,
          o = r.firstLine,
          s = r.secondLine,
          h = r.channelDefinition,
          m = r.titleLine,
          g = r.task;
        return d.TaskHelper.isInitialOutboundAttemptTask(g) && f.StateHelper.getCurrentPhoneCallState() && (e = c.ConnectingOutboundCallCanvasActions), a.createElement(l.TaskDetailsPanel, i({
          content: t.contentStore,
          IconComponent: u.ConnectingOutboundCallIcon,
          ActionsComponent: e,
          titleLine: m || p.TaskChannelHelper.getTemplateForStatus(g, h.templates.ConnectingOutboundCallCanvas.titleLine, n),
          firstLine: o || p.TaskChannelHelper.getTemplateForStatus(g, h.templates.ConnectingOutboundCallCanvas.firstLine, n),
          secondLine: s || p.TaskChannelHelper.getTemplateForStatus(g, h.templates.ConnectingOutboundCallCanvas.secondLine, n)
        }, this.props));
      }, n;
    }(a.PureComponent);
    t.ConnectingOutboundCallCanvasImpl = h;
  }, function (e, t, n) {
    "use strict";

    var _r92,
      o = this && this.__extends || (_r92 = function r(e, t) {
        return (_r92 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r92(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingOutboundCallCanvasActions = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(4),
      u = n(6),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onCancelCall = function () {
            u.tryInvokeAction("HangupCall", {
              task: t.props.task
            });
          }, t;
        }
        var n;
        return o(t, e), n = t, t.prototype.render = function () {
          var e = this;
          return s.createElement(l.DynamicComponent, {
            contentStore: n.Content,
            childProps: this.props,
            customChildren: this.props.children,
            name: n.displayName,
            noContainers: !0
          }, s.createElement(l.ContentFragment, null, s.createElement(l.ActionStateListener, {
            key: "Cancel",
            action: "HangupCall"
          }, function (t) {
            return s.createElement(l.IconButton, {
              className: "Twilio-OutboundCall-Cancel",
              icon: "HangupLarge",
              themeOverride: e.props.theme.ConnectingOutboundCallCanvas.CancelCallButton,
              onClick: e.onCancelCall,
              disabled: t.disabled,
              title: c.templates.HangupCallTooltip()
            });
          })));
        }, t.displayName = "ConnectingOutboundCallCanvasActions", t.Content = new l.DynamicContentStore(n.displayName), t = n = i([a.withTheme], t);
      }(s.Component);
    t.ConnectingOutboundCallCanvasActions = p;
  }, function (e, t, n) {
    "use strict";

    var _r93,
      o = this && this.__extends || (_r93 = function r(e, t) {
        return (_r93 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r93(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallAnimation = t.StyledIcon = t.ConnectingOutboundCallIcon = void 0;
    var a,
      s,
      l = n(1),
      c = n(15),
      u = n(75),
      p = n(17),
      d = n(134),
      f = n(0),
      h = n(2),
      m = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          var e = this.props.task;
          return l.createElement(c.TaskContext.Consumer, null, function (n) {
            return l.createElement(u.IconContainerWithStyle, {
              background: p.TaskChannelHelper.getColor(e, n.channelDefinition.colors.main, d.ConnectingOutboundCallCanvas)
            }, l.createElement(t.StyledIcon, {
              icon: p.TaskChannelHelper.getIcon(e, n.channelDefinition.icons.active, d.ConnectingOutboundCallCanvas),
              sizeMultiplier: 2
            }), l.createElement(t.CallAnimation, null, l.createElement(f.ConnectingAnimation, {
              sizeMultiplier: 3
            })));
          });
        }, n;
      }(l.Component);
    t.ConnectingOutboundCallIcon = m, t.StyledIcon = h.default(f.Icon)(a || (a = i(["\n    opacity: 6 0%;\n"], ["\n    opacity: 6 0%;\n"]))), t.CallAnimation = h.default("div")(s || (s = i(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.JoiningLabel = t.CenterContentContainer = void 0;
    var o,
      i,
      a = n(2),
      s = n(0);
    t.CenterContentContainer = a.default("div")(o || (o = r(["\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    margin: auto;\n    width: 100%;\n"], ["\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    margin: auto;\n    width: 100%;\n"]))), t.JoiningLabel = a.default(s.Template)(i || (i = r(["\n    font-size: 14px;\n    margin-top: 16px;\n"], ["\n    font-size: 14px;\n    margin-top: 16px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r94,
      o = this && this.__extends || (_r94 = function r(e, t) {
        return (_r94 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r94(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskInfoPanel = void 0;
    var s = n(1),
      l = n(0),
      c = n(210),
      u = n(15),
      p = n(17),
      d = n(198),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        var n;
        return o(t, e), n = t, t.prototype.render = function () {
          var e = this,
            t = this.props,
            r = t.templateCode,
            o = t.task;
          return s.createElement(u.TaskContext.Consumer, null, function (t) {
            return s.createElement(c.TaskInfoPanel, i({}, e.props, {
              templateCode: r || p.TaskChannelHelper.getTemplateForStatus(o, t.channelDefinition.templates.Supervisor.TaskInfoPanel.content, d.TaskCanvas),
              content: n.Content
            }));
          });
        }, t.displayName = "SupervisorTaskInfoPanel", t.Content = new l.DynamicContentStore(n.displayName), t.defaultProps = {}, t = n = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.TaskInfoPanel = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r95,
      o = this && this.__extends || (_r95 = function r(e, t) {
        return (_r95 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r95(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.TaskCanvasHeader = void 0;
    var a = n(1),
      s = n(15),
      l = n(437),
      c = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.displayName = l.displayName, n.Content = l.contentStore, n;
      }(a.PureComponent);
    t.TaskCanvasHeader = c, t.Connected = s.withTaskContext(l.TaskCanvasHeaderImpl);
  }, function (e, t, n) {
    "use strict";

    var _r96,
      o = this && this.__extends || (_r96 = function r(e, t) {
        return (_r96 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r96(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasHeaderImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(2),
      c = n(438),
      u = n(8),
      p = n(17),
      d = n(6);
    t.displayName = "SupervisorTaskCanvasHeader", t.contentStore = new s.DynamicContentStore(t.displayName);
    var f = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.refreshTimer = void 0, t.handleCloseTask = function () {
          d.tryInvokeAction("SelectTaskInSupervisor", {
            task: void 0
          }), d.tryInvokeAction("SetComponentState", {
            name: "SupervisorCanvasTabs",
            state: {
              selectedTabName: void 0
            }
          });
        }, t;
      }
      var r;
      return o(n, e), r = n, n.prototype.componentDidMount = function () {
        var e = this;
        this.refreshTimer = window.setInterval(function () {
          return e.forceUpdate();
        }, 1e3);
      }, n.prototype.componentWillUnmount = function () {
        void 0 !== this.refreshTimer && window.clearInterval(this.refreshTimer);
      }, n.prototype.render = function () {
        var e = this.props,
          n = e.task,
          o = e.channelDefinition,
          i = new u.TaskHelper(n);
        return a.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.contentStore.name,
          customChildren: this.props.children
        }, a.createElement(c.HeaderContainer, {
          noShrink: !0,
          noGrow: !0,
          className: "Twilio-SupervisorTaskCanvasHeader"
        }, a.createElement(c.HeaderCloseIconButton, {
          key: "close-button",
          icon: "Close",
          onClick: this.handleCloseTask,
          themeOverride: this.props.theme.Supervisor.TaskCanvas.HeaderButton
        }), a.createElement(c.HeaderContentContainer, {
          vertical: !0,
          key: "title",
          className: "Twilio-SupervisorTaskCanvasHeader-Content"
        }, a.createElement(c.TitleContainer, {
          className: "Twilio-SupervisorTaskCanvasHeader-Title"
        }, a.createElement(s.Template, {
          code: p.TaskChannelHelper.getTemplateForStatus(n, o.templates.Supervisor.TaskCanvasHeader.title, r),
          task: n
        })), a.createElement(c.ActivityStatusContainer, {
          key: "activity",
          className: "Twilio-SupervisorTaskCanvasHeader-Activity"
        }, a.createElement(s.Template, {
          code: p.TaskChannelHelper.getTemplateForStatus(n, o.templates.Supervisor.TaskCanvasHeader.secondLine, r),
          task: n,
          helper: i
        })))));
      }, n = r = i([l.withTheme], n);
    }(a.PureComponent);
    t.TaskCanvasHeaderImpl = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HeaderCloseIconButton = t.HeaderContentContainer = t.HeaderContainer = t.ActivityStatusContainer = t.TitleContainer = t.Text = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u = n(0),
      p = n(2);
    t.Text = p.default(u.FlexBox)(o || (o = r(["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 44px;\n    text-transform: uppercase;\n"], ["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 44px;\n    text-transform: uppercase;\n"]))), t.TitleContainer = p.default(u.FlexBox)(i || (i = r(["\n    overflow: hidden;\n    font-size: 14px;\n    font-weight: bold;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    overflow: hidden;\n    font-size: 14px;\n    font-weight: bold;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.ActivityStatusContainer = p.default("div")(a || (a = r(["\n    font-size: 12px;\n    font-weight: normal;\n    margin-top: 2px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    margin-top: 2px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.HeaderContainer = p.default(u.FlexBox)(s || (s = r(["\n    height: 56px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n"], ["\n    height: 56px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n"])), function (e) {
      return e.theme.Supervisor.TaskCanvas.Header;
    }), t.HeaderContentContainer = p.default(u.FlexBox)(l || (l = r(["\n    overflow: hidden;\n    margin: 0 40px 0 10px;\n    align-items: center;\n"], ["\n    overflow: hidden;\n    margin: 0 40px 0 10px;\n    align-items: center;\n"]))), t.HeaderCloseIconButton = p.default(u.IconButton)(c || (c = r(["\n    flex-shrink: 0;\n"], ["\n    flex-shrink: 0;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r97,
      o = this && this.__extends || (_r97 = function r(e, t) {
        return (_r97 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r97(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(131),
      c = n(4),
      u = n(2),
      p = n(135),
      d = n(6);
    t.displayName = "TaskCanvas", t.contentStore = new s.DynamicContentStore(t.displayName);
    var f = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleCloseTask = function () {
          d.tryInvokeAction("SelectTaskInSupervisor", {
            task: void 0
          });
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = (e.task, e.theme);
        return a.createElement(s.SidePanel, {
          contentStore: t.contentStore,
          displayName: t.displayName,
          handleCloseClick: this.handleCloseTask,
          title: a.createElement(s.Template, {
            source: c.templates.SupervisorTaskCanvasHeader
          }),
          themeOverride: n.Supervisor.TaskCanvas,
          HeaderComponent: a.createElement(p.TaskCanvasHeader, {
            key: "customHeader"
          })
        }, a.createElement(l.TaskCanvasTabs, {
          key: "tabs"
        }));
      }, n.displayName = t.displayName, n = i([u.withTheme], n);
    }(a.PureComponent);
    t.TaskCanvasImpl = f;
  }, function (e, t, n) {
    "use strict";

    var _r98,
      o = this && this.__extends || (_r98 = function r(e, t) {
        return (_r98 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r98(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TeamFiltersPanel = void 0;
    var a = n(0),
      s = n(1),
      l = n(4),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            n = e.workers,
            r = e.filters,
            o = e.isHidden,
            i = e.appliedFilters,
            c = e.isLoadingWorkers,
            u = e.handleApplyFilters,
            p = e.handleResetFilters,
            d = e.handleCloseClick,
            f = i && i.filters ? this.getSimplifiedFiltersMap(i.filters) : [];
          return s.createElement(a.SidePanel, {
            handleCloseClick: d,
            title: s.createElement(l.Template, {
              source: l.templates.TeamFiltersPanelTitle
            }),
            displayName: t.displayName,
            themeOverride: {},
            contentStore: t.Content,
            isHidden: o
          }, s.createElement(a.FiltersList, {
            key: "filter-list",
            headerLabel: s.createElement(l.Template, {
              source: 1 === n.length ? l.templates.TeamFiltersPanelSingularLabel : l.templates.TeamFiltersPanelPluralLabel,
              number: n.length
            }),
            applyLabel: s.createElement(l.Template, {
              source: l.templates.TeamFiltersApply
            }),
            resetLabel: s.createElement(l.Template, {
              source: l.templates.TeamFiltersReset
            }),
            filters: r,
            legacyFilters: this.props.legacyFilters,
            actionsDisabled: c,
            appliedFilters: f,
            appliedLegacyFilterQuery: this.props.appliedLegacyFilterQuery,
            handleApplyClick: u,
            handleResetClick: p,
            defaultFilters: a.FiltersList.getDefaultFilterValues(r)
          }));
        }, t.prototype.getSimplifiedFiltersMap = function (e) {
          return e.reduce(function (e, t) {
            var n;
            return i(i({}, e), ((n = {})[t.name] = t.values, n));
          }, {});
        }, t.displayName = "TeamFiltersPanel", t.Content = new a.DynamicContentStore(t.displayName), t;
      }(s.PureComponent);
    t.TeamFiltersPanel = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(442), t);
  }, function (e, t, n) {
    "use strict";

    var _r99,
      o = this && this.__extends || (_r99 = function r(e, t) {
        return (_r99 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r99(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AggregatedQueuesDataTiles = void 0;
    var a = n(1),
      s = n(0),
      l = n(443),
      c = n(444),
      u = n(447),
      p = n(450),
      d = n(453),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            n = e.children,
            r = i(e, ["children"]);
          return a.createElement(s.DynamicComponent, {
            name: t.displayName,
            contentStore: t.Content,
            customChildren: n,
            childProps: r,
            noContainers: !0
          }, a.createElement(l.Grid, {
            className: "Twilio-AggregatedQueuesDataTiles-Grid",
            key: "aggregated-data-view"
          }, a.createElement(c.ActiveTasksTile, {
            key: "active-tasks-tile"
          }), a.createElement(u.WaitingTasksTile, {
            key: "waiting-tasks-tile"
          }), a.createElement(d.LongestWaitTimeTile, {
            key: "longest-wait-time-tile"
          }), a.createElement(p.AgentsByActivityChartTile, {
            key: "agents-by-activity-chart-tile"
          })));
        }, t.displayName = "AggregatedQueuesDataTiles", t.Content = new s.DynamicContentStore(t.displayName), t;
      }(a.PureComponent);
    t.AggregatedQueuesDataTiles = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Grid = void 0;
    var o,
      i = n(129);
    t.Grid = i.default("div")(o || (o = r(["\n    display: flex;\n    padding: 0 16px;\n    width: 100%;\n    margin-top: 0;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;\n    height: auto;\n    box-sizing: border-box;\n    flex: 0 0 auto;\n\n    > * {\n        flex: 1 1 25%;\n    }\n\n    > * + * {\n        margin-left: 16px;\n    }\n\n    ", "\n"], ["\n    display: flex;\n    padding: 0 16px;\n    width: 100%;\n    margin-top: 0;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;\n    height: auto;\n    box-sizing: border-box;\n    flex: 0 0 auto;\n\n    > * {\n        flex: 1 1 25%;\n    }\n\n    > * + * {\n        margin-left: 16px;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.QueuesStats.TilesGrid;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(445), t);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActiveTasksTile = void 0;
    var r = n(446),
      o = n(3),
      i = n(25);
    t.ActiveTasksTile = o.connect(function (e) {
      return {
        activeTasks: i.workspaceActiveTasksSelector(e)
      };
    })(r.ActiveTasksTileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r100,
      o = this && this.__extends || (_r100 = function r(e, t) {
        return (_r100 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r100(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActiveTasksTileImpl = void 0;
    var i = n(1),
      a = n(0),
      s = n(4),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(a.AggregatedDataTile, {
            title: i.createElement(s.Template, {
              source: s.templates.ActiveTasksTileTitle
            }),
            content: this.props.activeTasks.toString()
          });
        }, t;
      }(i.PureComponent);
    t.ActiveTasksTileImpl = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(448), t);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WaitingTasksTile = void 0;
    var r = n(449),
      o = n(3),
      i = n(25);
    t.WaitingTasksTile = o.connect(function (e) {
      return {
        waitingTasks: i.workspaceWaitingTasksSelector(e)
      };
    })(r.WaitingTasksTileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r101,
      o = this && this.__extends || (_r101 = function r(e, t) {
        return (_r101 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r101(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WaitingTasksTileImpl = void 0;
    var i = n(1),
      a = n(0),
      s = n(4),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(a.AggregatedDataTile, {
            title: i.createElement(s.Template, {
              source: s.templates.WaitingTasksTileTitle
            }),
            content: this.props.waitingTasks.toString()
          });
        }, t;
      }(i.PureComponent);
    t.WaitingTasksTileImpl = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(451), t);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AgentsByActivityChartTile = void 0;
    var r = n(452),
      o = n(3),
      i = n(25);
    t.AgentsByActivityChartTile = o.connect(function (e) {
      var t = i.workspaceStatsSelector(e);
      return {
        availableAgents: i.getAvailableAgentsCount(t),
        unavailableAgents: i.getUnavailableAgentsCount(t),
        offlineAgents: i.getOfflineAgentsCount(t)
      };
    })(r.AgentsByActivityChartTileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r102,
      o = this && this.__extends || (_r102 = function r(e, t) {
        return (_r102 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r102(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AgentsByActivityChartTileImpl = void 0;
    var a = n(1),
      s = n(0),
      l = n(4),
      c = n(2),
      u = n(137),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.availableAgents,
            n = e.unavailableAgents,
            r = e.offlineAgents,
            o = e.theme,
            i = [{
              value: t,
              label: l.templates.AgentStatusAvailable ? l.templates.AgentStatusAvailable() : "Available",
              color: o ? o.colors.agentAvailableColor : "",
              renderMarker: function renderMarker(e) {
                return a.createElement(u.Marker, {
                  color: e.color,
                  icon: "Accept",
                  "aria-label": l.templates.AgentStatusAvailable ? l.templates.AgentStatusAvailable() : "Available"
                });
              }
            }, {
              value: n,
              label: l.templates.AgentStatusUnavailable ? l.templates.AgentStatusUnavailable() : "Unavailable",
              color: o ? o.colors.agentUnavailableColor : "",
              renderMarker: function renderMarker(e) {
                return a.createElement(u.Marker, {
                  color: e.color,
                  icon: "Close",
                  "aria-label": l.templates.AgentStatusUnavailable ? l.templates.AgentStatusUnavailable() : "Unavailable"
                });
              }
            }, {
              value: r,
              label: l.templates.AgentStatusOffline ? l.templates.AgentStatusOffline() : "Offline",
              color: o ? o.colors.agentOfflineColor : "",
              renderMarker: function renderMarker(e) {
                return a.createElement(u.Marker, {
                  color: e.color,
                  icon: "Minus",
                  "aria-label": l.templates.AgentStatusOffline ? l.templates.AgentStatusOffline() : "Offline"
                });
              }
            }];
          return a.createElement(s.AggregatedDataTile, {
            title: a.createElement(l.Template, {
              source: l.templates.AgentsByActivityTileTitle
            })
          }, a.createElement(s.StackedBarChart, {
            items: i
          }), a.createElement(s.Legend, {
            items: i,
            labelPosition: s.LegendLabelPosition.Start,
            showLabels: !0
          }));
        }, t = i([c.withTheme], t);
      }(a.PureComponent);
    t.AgentsByActivityChartTileImpl = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(454), t);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LongestWaitTimeTile = void 0;
    var r = n(455),
      o = n(3),
      i = n(25);
    t.LongestWaitTimeTile = o.connect(function (e) {
      var t = i.workspaceLongestQueueSelector(e);
      return {
        waitFrom: t ? t.longest_task_waiting_from : null,
        queueName: t ? t.friendly_name : null
      };
    })(r.LongestWaitTimeTileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r103,
      o = this && this.__extends || (_r103 = function r(e, t) {
        return (_r103 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r103(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LongestWaitTimeTileImpl = void 0;
    var i = n(1),
      a = n(0),
      s = n(4),
      l = n(213),
      c = n(214),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return this.props.waitFrom ? i.createElement(c.Ticker, null, function () {
            return i.createElement(a.AggregatedDataTile, {
              title: i.createElement(s.Template, {
                source: s.templates.LongestWaitTimeTileTitle
              }),
              content: a.Utils.formatTimeDuration(l.getTaskWaitingAgeFromTimestamp(e.props.waitFrom), "short"),
              description: e.props.queueName || String.fromCharCode(160)
            });
          }) : i.createElement(a.AggregatedDataTile, {
            title: i.createElement(s.Template, {
              source: s.templates.LongestWaitTimeTileTitle
            }),
            content: "0",
            description: this.props.queueName || String.fromCharCode(160)
          });
        }, t;
      }(i.PureComponent);
    t.LongestWaitTimeTileImpl = u;
  }, function (e, t) {
    e.exports = require("eventemitter3");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesDataTableCellProps = t.QueuesDataTableCell = t.QueuesDataTable = t.QueuesDataTableProps = void 0;
    var r = n(458);
    Object.defineProperty(t, "QueuesDataTableProps", {
      enumerable: !0,
      get: function get() {
        return r.QueuesDataTableProps;
      }
    }), Object.defineProperty(t, "QueuesDataTable", {
      enumerable: !0,
      get: function get() {
        return r.QueuesDataTable;
      }
    });
    var o = n(215);
    Object.defineProperty(t, "QueuesDataTableCell", {
      enumerable: !0,
      get: function get() {
        return o.QueuesDataTableCell;
      }
    }), Object.defineProperty(t, "QueuesDataTableCellProps", {
      enumerable: !0,
      get: function get() {
        return o.QueuesDataTableCellProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r104,
      o = this && this.__extends || (_r104 = function r(e, t) {
        return (_r104 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r104(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesDataTable = void 0;
    var s = n(1),
      l = n(3),
      c = n(459),
      u = n(0),
      p = n(55),
      d = l.connect(function (e) {
        return {
          queuesList: p.queuesListArrayWithoutEmptyChannelsSelector(e)
        };
      })(c.QueuesDataTableImpl),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        var n;
        return o(t, e), n = t, t.prototype.componentDidMount = function () {
          n.instance = this;
        }, t.prototype.componentWillUnmount = function () {
          n.instance = void 0;
        }, t.prototype.render = function () {
          return s.createElement(d, i({}, this.props));
        }, t.friendlyName = c.displayName, t.displayName = c.displayName, t.Content = c.Content, t.defaultProps = {
          defaultSortColumn: "friendly-name"
        }, t = n = a([u.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.QueuesDataTable = f;
  }, function (e, t, n) {
    "use strict";

    var _r105,
      o = this && this.__extends || (_r105 = function r(e, t) {
        return (_r105 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r105(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesDataTableImpl = t.Content = t.displayName = void 0;
    var s = n(0),
      l = n(1),
      c = n(25),
      u = n(4),
      p = n(2),
      d = n(214),
      f = n(213),
      h = n(137),
      m = n(215);
    t.displayName = "QueuesDataTable", t.Content = new s.DynamicContentStore(t.displayName);
    var g = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return this.props.renderContent(this.props.item);
      }, t;
    }(l.PureComponent);
    function y(e) {
      return function (t) {
        return l.createElement(g, {
          item: t,
          renderContent: e
        });
      };
    }
    function v(e) {
      return function (t, n) {
        return e(t) - e(n);
      };
    }
    var b = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          hideChannels: {}
        }, t.toggleChannels = function (e) {
          t.setState(function (t) {
            var n;
            return {
              hideChannels: i(i({}, t.hideChannels), (n = {}, n[e] = !t.hideChannels[e], n))
            };
          });
        }, t.getTaskQueueSid = function (e) {
          return e.key;
        }, t.renderFriendlyName = y(function (e) {
          return l.createElement(m.QueuesDataTableCell, {
            queue: e,
            renderQueueData: function renderQueueData(e, n, r) {
              if (e.channels && e.channels.length > 1) return l.createElement(h.ChannelName, {
                clickable: !0,
                onClick: n
              }, l.createElement(s.IconButton, {
                icon: r ? "ArrowUp" : "ArrowDown"
              }), l.createElement(s.Icon, {
                icon: "Folder"
              }), t.queueTitle(e.friendly_name, e.key));
              var o = e.channels && e.channels[0];
              return o ? l.createElement(h.ChannelName, null, l.createElement(s.Icon, {
                icon: f.getIconNameForChannel(o.unique_name)
              }), e.friendly_name + " - " + o.friendly_name) : l.createElement(h.ChannelName, null, t.queueTitle(e.friendly_name, e.key));
            },
            renderChannelData: function renderChannelData(e) {
              return l.createElement(h.ChannelName, null, l.createElement(s.Icon, {
                icon: f.getIconNameForChannel(e.unique_name)
              }), e.friendly_name || "Unknown");
            }
          });
        }), t.renderActiveTasks = y(function (e) {
          return l.createElement(m.QueuesDataTableCell, {
            queue: e,
            renderQueueData: function renderQueueData(e) {
              return e.tasks_by_status.assigned + e.tasks_by_status.wrapping;
            },
            renderChannelData: function renderChannelData(e) {
              return e.tasks_now ? e.tasks_now.assigned_tasks + e.tasks_now.wrapping_tasks : "-";
            }
          });
        }), t.renderWaitingTasks = y(function (e) {
          return l.createElement(m.QueuesDataTableCell, {
            queue: e,
            renderQueueData: function renderQueueData(e) {
              return e.tasks_by_status.pending + e.tasks_by_status.reserved;
            },
            renderChannelData: function renderChannelData(e) {
              return e.tasks_now ? e.tasks_now.pending_tasks + e.tasks_now.reserved_tasks : "-";
            }
          });
        }), t.renderSlaPercentage = function (e) {
          return y(function (t) {
            var n = function n(t) {
              var n = e(t);
              return void 0 !== n && -1 !== n ? Math.round(1e3 * n) / 10 + "%" : "-";
            };
            return l.createElement(m.QueuesDataTableCell, {
              queue: t,
              renderQueueData: n,
              renderChannelData: n
            });
          });
        }, t.renderSlaCount = function (e) {
          return y(function (t) {
            var n = function n(t) {
              var n = e(t);
              return void 0 !== n && -1 !== n ? n : "-";
            };
            return l.createElement(m.QueuesDataTableCell, {
              queue: t,
              renderQueueData: n,
              renderChannelData: n
            });
          });
        }, t.renderSlaThirty = t.renderSlaPercentage(function (e) {
          return e.sla_30_min && e.sla_30_min.sla_percentage;
        }), t.renderSlaToday = t.renderSlaPercentage(function (e) {
          return e.sla_today && e.sla_today.sla_percentage;
        }), t.renderHandledTasks = t.renderSlaCount(function (e) {
          return e.sla_30_min && e.sla_30_min.handled_tasks_count;
        }), t.renderHandledTasksToday = t.renderSlaCount(function (e) {
          return e.sla_today && e.sla_today.handled_tasks_count;
        }), t.renderAbandonedTasks = t.renderSlaCount(function (e) {
          return e.sla_30_min && e.sla_30_min.abandoned_tasks_count;
        }), t.renderAbandonedTasksToday = t.renderSlaCount(function (e) {
          return e.sla_today && e.sla_today.abandoned_tasks_count;
        }), t.renderLongestWaitingTimeTicker = function (e) {
          return l.createElement(d.Ticker, null, function () {
            return s.Utils.formatTimeDuration(f.getTaskWaitingAgeFromTimestamp(e), "short");
          });
        }, t.renderLongestWaitingTime = y(function (e) {
          return l.createElement(m.QueuesDataTableCell, {
            queue: e,
            renderQueueData: function renderQueueData() {
              return t.renderLongestWaitingTimeTicker(e.longest_task_waiting_from);
            },
            renderChannelData: function renderChannelData(e) {
              return e.tasks_now ? t.renderLongestWaitingTimeTicker(e.tasks_now.longest_task_waiting_from) : "-";
            }
          });
        }), t.renderAgents = y(function (e) {
          return l.createElement(m.QueuesDataTableCell, {
            queue: e,
            renderQueueData: function renderQueueData() {
              var n = [{
                label: u.templates.AgentStatusAvailable ? u.templates.AgentStatusAvailable() : "Available",
                value: c.getAvailableAgentsCount(e),
                color: t.props.theme.colors.agentAvailableColor,
                renderMarker: function renderMarker(e) {
                  return l.createElement(h.Marker, {
                    color: e.color,
                    icon: "Accept",
                    "aria-label": u.templates.AgentStatusAvailable ? u.templates.AgentStatusAvailable() : "Available"
                  });
                }
              }, {
                label: u.templates.AgentStatusUnavailable ? u.templates.AgentStatusUnavailable() : "Unavailable",
                value: c.getUnavailableAgentsCount(e),
                color: t.props.theme.colors.agentUnavailableColor,
                renderMarker: function renderMarker(e) {
                  return l.createElement(h.Marker, {
                    color: e.color,
                    icon: "Close",
                    "aria-label": u.templates.AgentStatusUnavailable ? u.templates.AgentStatusUnavailable() : "Unavailable"
                  });
                }
              }, {
                label: u.templates.AgentStatusOffline ? u.templates.AgentStatusOffline() : "Offline",
                value: c.getOfflineAgentsCount(e),
                color: t.props.theme.colors.agentOfflineColor,
                renderMarker: function renderMarker(e) {
                  return l.createElement(h.Marker, {
                    color: e.color,
                    icon: "Minus",
                    "aria-label": u.templates.AgentStatusOffline ? u.templates.AgentStatusOffline() : "Offline"
                  });
                }
              }];
              return l.createElement(s.Legend, {
                items: n,
                showLabels: !1
              });
            },
            renderChannelData: function renderChannelData() {
              return "-";
            }
          });
        }), t;
      }
      return o(n, e), n.prototype.render = function () {
        var e,
          n = this.props.queuesList;
        return l.createElement(m.QueuesDataTableCellContext.Provider, {
          value: {
            hideChannels: this.state.hideChannels,
            toggleChannels: this.toggleChannels
          }
        }, l.createElement(h.TableContainer, {
          className: "Twilio-QueuesDataTable"
        }, l.createElement(s.DynamicComponent, {
          childProps: this.props,
          contentStore: t.Content,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0
        }, l.createElement(s.DataTable, {
          items: n,
          itemKey: this.getTaskQueueSid,
          columnDataCreationContext: {},
          hasHoverStyle: !1,
          defaultSortColumn: this.props.defaultSortColumn
        }, l.createElement(s.ColumnDefinition, {
          key: "friendly-name",
          name: "Friendly-Name",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderQueueName
          }),
          content: this.renderFriendlyName,
          sortingFn: (e = function e(_e2) {
            return _e2.friendly_name;
          }, function (t, n) {
            return e(t).localeCompare(e(n));
          }),
          sortDirection: "asc"
        }), l.createElement(s.ColumnDefinition, {
          key: "active-tasks",
          name: "Active-Tasks",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderActiveTasks
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeaderNow
          }),
          content: this.renderActiveTasks,
          sortingFn: v(function (e) {
            return e.tasks_by_status.assigned + e.tasks_by_status.wrapping;
          })
        }), l.createElement(s.ColumnDefinition, {
          key: "waiting-tasks",
          name: "Waiting-Tasks",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderWaitingTasks
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeaderNow
          }),
          content: this.renderWaitingTasks,
          sortingFn: v(function (e) {
            return e.tasks_by_status.pending + e.tasks_by_status.reserved;
          })
        }), l.createElement(s.ColumnDefinition, {
          key: "longest-wait-time",
          name: "Longest-Wait-Time",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderLongestWait
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeaderNow
          }),
          content: this.renderLongestWaitingTime,
          sortingFn: v(function (e) {
            return f.getTaskWaitingAgeFromTimestamp(e.longest_task_waiting_from);
          })
        }), l.createElement(s.ColumnDefinition, {
          key: "sla-30min",
          name: "SLA-30min",
          headerColSpanKey: "SLA",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderSLA
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeader30Mins
          }),
          content: this.renderSlaThirty,
          sortingFn: v(function (e) {
            return e.sla_30_min && e.sla_30_min.sla_percentage || 0;
          })
        }), l.createElement(s.ColumnDefinition, {
          key: "sla-today",
          name: "SLA-Today",
          headerColSpanKey: "SLA",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderSLA
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeaderToday
          }),
          content: this.renderSlaToday,
          sortingFn: v(function (e) {
            return e.sla_today && e.sla_today.sla_percentage || 0;
          })
        }), l.createElement(s.ColumnDefinition, {
          key: "handled-tasks-30min",
          name: "Handled-Tasks-30min",
          headerColSpanKey: "Handled-Tasks",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderHandled
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeader30Mins
          }),
          content: this.renderHandledTasks,
          sortingFn: v(function (e) {
            return e.sla_30_min && e.sla_30_min.handled_tasks_count || 0;
          })
        }), l.createElement(s.ColumnDefinition, {
          key: "handled-tasks-today",
          name: "Handled-Tasks-Today",
          headerColSpanKey: "Handled-Tasks",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderHandled
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeaderToday
          }),
          content: this.renderHandledTasksToday,
          sortingFn: v(function (e) {
            return e.sla_today && e.sla_today.handled_tasks_count || 0;
          })
        }), l.createElement(s.ColumnDefinition, {
          key: "abandoned-tasks-30min",
          name: "Abandoned-Tasks-30min",
          headerColSpanKey: "Abandoned-Tasks",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderAbandoned
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeader30Mins
          }),
          content: this.renderAbandonedTasks,
          sortingFn: v(function (e) {
            return e.sla_30_min && e.sla_30_min.abandoned_tasks_count || 0;
          })
        }), l.createElement(s.ColumnDefinition, {
          key: "abandoned-tasks-today",
          name: "Abandoned-Tasks-Today",
          headerColSpanKey: "Abandoned-Tasks",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderAbandoned
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeaderToday
          }),
          content: this.renderAbandonedTasksToday,
          sortingFn: v(function (e) {
            return e.sla_today && e.sla_today.abandoned_tasks_count || 0;
          })
        }), l.createElement(s.ColumnDefinition, {
          key: "agents",
          name: "Agents",
          header: l.createElement(s.Template, {
            source: u.templates.QueuesStatsHeaderAgentsActivity
          }),
          subHeader: l.createElement(s.Template, {
            source: u.templates.QueuesStatsSubHeaderNow
          }),
          content: this.renderAgents
        })))));
      }, n.prototype.queueTitle = function (e, t) {
        return e;
      }, n = a([p.withTheme], n);
    }(l.PureComponent);
    t.QueuesDataTableImpl = b;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesStatsMediator = void 0;
    var i = n(168),
      a = n(3),
      s = n(89),
      l = function () {
        function e(e, t, n, o) {
          var i = this;
          this.dispatchUpdate = function () {
            if (i.sid) {
              var e = i.toWorkerQueue();
              a.FlexModule.dispatch({
                type: s.UPDATE_QUEUE,
                payload: e
              });
            }
          }, this.sid = e, this.friendlyName = t, this.getChannelMetadata = n, this.channels = {}, this.config = r({}, o);
        }
        return e.prototype.notify = function (e, t) {
          switch (e) {
            case this.config.tasksNowKey:
              var n = t.queue,
                r = o(t, ["queue"]);
              this.tasksNow = n, this.saveChannelValue(r, "tasks_now"), this.dispatchUpdate();
              break;
            case this.config.tasks30minKey:
              n = t.queue, r = o(t, ["queue"]);
              this.tasksThirtyMinutes = n, this.saveChannelValue(r, "sla_30_min"), this.dispatchUpdate();
              break;
            case this.config.tasksTodayKey:
              n = t.queue, r = o(t, ["queue"]);
              this.tasksToday = n, this.saveChannelValue(r, "sla_today"), this.dispatchUpdate();
              break;
            case this.config.workerActivitiesStatsKey:
              this.workerStats = t, this.dispatchUpdate();
          }
        }, e.prototype.saveChannelValue = function (e, t) {
          var n = this,
            o = Object.keys(e).reduce(function (o, i) {
              var a,
                s = n.getChannelMetadata()[i] || {};
              return o[i] = r(r({}, s), ((a = {})[t] = e[i], a)), o;
            }, {});
          i(this.channels, o);
        }, e.prototype.toWorkerQueue = function () {
          return {
            key: this.sid,
            friendly_name: this.friendlyName,
            total_available_workers: this.workerStats ? this.workerStats.total_available_workers : 0,
            total_eligible_workers: this.workerStats ? this.workerStats.total_eligible_workers : 0,
            activity_statistics: this.workerStats ? this.workerStats.activity_statistics : [],
            tasks_by_priority: this.tasksNow ? this.tasksNow.tasks_by_priority : {},
            tasks_by_status: {
              reserved: this.tasksNow ? this.tasksNow.reserved_tasks : 0,
              pending: this.tasksNow ? this.tasksNow.pending_tasks : 0,
              assigned: this.tasksNow ? this.tasksNow.assigned_tasks : 0,
              wrapping: this.tasksNow ? this.tasksNow.wrapping_tasks : 0
            },
            total_tasks: this.tasksNow ? this.tasksNow.total_tasks : 0,
            longest_task_waiting_sid: this.tasksNow ? this.tasksNow.longest_task_waiting_sid : null,
            longest_task_waiting_from: this.tasksNow ? this.tasksNow.longest_task_waiting_from : null,
            sla_30_min: this.tasksThirtyMinutes,
            sla_today: this.tasksToday,
            channels: Object.keys(this.channels).length ? Object.values(this.channels) : void 0
          };
        }, e;
      }();
    t.QueuesStatsMediator = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IframeEventHandler = t.Dashboard = t.DashboardsSidebar = void 0;
    var r = n(217);
    Object.defineProperty(t, "DashboardsSidebar", {
      enumerable: !0,
      get: function get() {
        return r.DashboardsSidebar;
      }
    });
    var o = n(219);
    Object.defineProperty(t, "Dashboard", {
      enumerable: !0,
      get: function get() {
        return o.Dashboard;
      }
    });
    var i = n(221);
    Object.defineProperty(t, "IframeEventHandler", {
      enumerable: !0,
      get: function get() {
        return i.IframeEventHandler;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r106,
      o = this && this.__extends || (_r106 = function r(e, t) {
        return (_r106 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r106(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CategorySelector = t.CategorySelectorComponent = void 0;
    var i = n(58),
      a = n(1),
      s = n(3),
      l = n(54),
      c = n(56),
      u = n(463),
      p = n(31),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleChange = function (e) {
            var n = "__all" === e.target.value ? void 0 : e.target.value;
            "__my" === e.target.value ? (t.props.selectCategory(void 0), t.props.onMyDashboardsSelected(!0)) : (t.props.onMyDashboardsSelected(!1), t.props.selectCategory(n));
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.categories;
          return a.createElement(u.StyledSelect, {
            onChange: this.handleChange,
            value: this.props.isMyDashboardsSelected ? "__my" : this.props.selectedCategory
          }, a.createElement(i.default, {
            key: "all",
            value: "__all"
          }, "All Dashboards"), a.createElement(i.default, {
            key: "my",
            value: "__my"
          }, "My Dashboards"), e.map(function (e) {
            var t = e.identifier,
              n = e.title;
            return a.createElement(i.default, {
              key: t,
              value: t
            }, n);
          }));
        }, t;
      }(a.PureComponent);
    t.CategorySelectorComponent = d;
    var f = p.createSelector(c.projectDashboardsArraySelector, function (e, t) {
      return t.filter;
    }, function (e, t) {
      return e.filter(function (e) {
        return t(e);
      });
    });
    t.CategorySelector = s.connect(function (e, t) {
      return {
        categories: f(e, t),
        selectedCategory: c.dashboardCategorySelector(e) || "__all"
      };
    }, function (e) {
      return {
        selectCategory: function selectCategory(t) {
          return e({
            type: l.UPDATE_DASHBOARD_CATEGORY,
            payload: t
          });
        }
      };
    })(d);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledSelect = t.StyledSelectWithFontSize = void 0;
    var o,
      i = n(22),
      a = n(59),
      s = n(2);
    t.StyledSelectWithFontSize = i.withStyles({
      selectMenu: {
        fontSize: "10px"
      }
    })(a.default), t.StyledSelect = s.default(t.StyledSelectWithFontSize)(o || (o = r(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r107,
      o = this && this.__extends || (_r107 = function r(e, t) {
        return (_r107 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r107(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CategoryView = void 0;
    var a = n(1),
      s = n(2),
      l = n(218),
      c = n(465),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props.filter ? (this.props.dashboard.tabs || []).filter(function (t) {
              return e.props.filter(t, e.props.dashboard);
            }) : this.props.dashboard.tabs || [];
          return a.createElement(a.Fragment, null, !this.props.hideTitle && !!t.length && a.createElement(l.Title, null, this.props.dashboard.title), (t || []).map(function (t) {
            return a.createElement(l.StyledMenuItem, {
              key: t.identifier,
              onClick: function onClick() {
                return e.props.onClick(t.identifier);
              },
              selected: e.props.currentDashboardId === t.identifier,
              theme: e.props.theme
            }, t.title);
          }), !t.length && this.props.showNoDataIfEmpty && a.createElement(c.EmptyDashboardList, null));
        }, t.defaultProps = {
          filter: function filter() {
            return !0;
          }
        }, t = i([s.withTheme], t);
      }(a.PureComponent);
    t.CategoryView = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmptyDashboardList = void 0;
    var o,
      i = n(1),
      a = n(0),
      s = n(4),
      l = n(2).default("div")(o || (o = r(["\n    text-align: center;\n    > * {\n        margin: 8px;\n    }\n"], ["\n    text-align: center;\n    > * {\n        margin: 8px;\n    }\n"])));
    t.EmptyDashboardList = function () {
      return i.createElement(l, null, i.createElement(a.Icon, {
        icon: "EmptyContent",
        sizeMultiplier: 1.6
      }), i.createElement(a.Template, {
        source: s.templates.EmptyDashboardList
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SidebarButton = t.Divider = t.ScrollableLi = t.StyledMenu = void 0;
    var o,
      i,
      a,
      s,
      l = n(0),
      c = n(2);
    t.StyledMenu = c.default(l.Menu)(o || (o = r(["\n    width: 242px;\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid transparent;\n    ", "\n    > li:first-child,\n    > li:last-child {\n        padding: 16px 16px;\n    }\n"], ["\n    width: 242px;\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid transparent;\n    ", "\n    > li:first-child,\n    > li:last-child {\n        padding: 16px 16px;\n    }\n"])), function (e) {
      return e.theme.Dashboards.Sidebar.Container;
    }), t.ScrollableLi = c.default("ul")(i || (i = r(["\n    overflow: auto;\n    flex: 1;\n"], ["\n    overflow: auto;\n    flex: 1;\n"]))), t.Divider = c.default("hr")(a || (a = r(["\n    margin: ", ";\n    border: 0;\n    border-bottom: 1px solid transparent;\n    ", "\n"], ["\n    margin: ", ";\n    border: 0;\n    border-bottom: 1px solid transparent;\n    ", "\n"])), function (e) {
      return e.margin || "16px";
    }, function (e) {
      return e.theme.Dashboards.Sidebar.Divider;
    }), t.SidebarButton = c.default(l.Button)(s || (s = r(["\n    font-size: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0;\n    border: 1px solid transparent;\n    display: block;\n    border-radius: 3px;\n    width: 100%;\n    &:hover {\n        cursor: pointer;\n    }\n    ", "\n"], ["\n    font-size: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0;\n    border: 1px solid transparent;\n    display: block;\n    border-radius: 3px;\n    width: 100%;\n    &:hover {\n        cursor: pointer;\n    }\n    ", "\n"])), function (e) {
      return e.theme.Dashboards.Sidebar.ActionButton;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GreyLight = void 0;
    var o = n(0),
      i = n(78),
      a = {
        colors: r(r({}, i.default.colors), o.GreyLight.colors),
        lightTheme: !0
      };
    t.GreyLight = a, t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GreyDark = void 0;
    var o = n(0),
      i = n(78),
      a = {
        colors: r(r({}, i.default.colors), o.GreyDark.colors),
        lightTheme: !1
      };
    t.GreyDark = a, t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexDark = void 0;
    var o = n(0),
      i = n(78),
      a = {
        colors: r(r({}, i.default.colors), o.FlexDark.colors),
        lightTheme: !1
      };
    t.FlexDark = a, t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexLight = void 0;
    var o = n(0),
      i = n(78),
      a = {
        colors: r(r({}, i.default.colors), o.FlexLight.colors),
        lightTheme: !0
      };
    t.FlexLight = a, t.default = a;
  }, function (e, t) {
    e.exports = require("@material-ui/core/styles");
  }, function (e, t) {
    e.exports = require("react-jss");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(474), t);
  }, function (e, t, n) {
    "use strict";

    var _r108,
      o = this && this.__extends || (_r108 = function r(e, t) {
        return (_r108 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r108(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationViewBehindFeatureFlag = t.ConversationView = void 0;
    var a = n(1),
      s = n(49),
      l = n(34),
      c = n(53),
      u = n(3),
      p = n(475),
      d = n(220),
      f = n(24),
      h = n(54),
      m = n(10),
      g = n(18),
      y = u.connect(function (e, t) {
        var n,
          r,
          o = t.segmentId,
          i = e.insights.segmentsById[o],
          a = f.segmentListSelector(e, o),
          s = i && i.data && i.data.agent_id,
          c = null === (n = null == i ? void 0 : i.data) || void 0 === n ? void 0 : n.links.content,
          u = l.parse(t.route.location.search).mediaLinkId,
          p = l.parse(t.route.location.search).mediaLinkType;
        if (p = Array.isArray(p) ? p[0] : p) switch (p.toLowerCase()) {
          case g.InsightsPlayerMediaLinkType.ChatTranscript.toLowerCase():
            r = g.InsightsPlayerMediaLinkType.ChatTranscript;
            break;
          case g.InsightsPlayerMediaLinkType.Embedded.toLowerCase():
            r = g.InsightsPlayerMediaLinkType.Embedded;
            break;
          case g.InsightsPlayerMediaLinkType.Referenced.toLowerCase():
            r = g.InsightsPlayerMediaLinkType.Referenced;
            break;
          case g.InsightsPlayerMediaLinkType.EmailTranscript.toLowerCase():
            r = g.InsightsPlayerMediaLinkType.EmailTranscript;
        }
        return {
          segment: i,
          segmentList: a,
          agentId: s,
          mediaLinks: c,
          mediaLinkId: Array.isArray(u) ? u[0] : u,
          mediaLinkType: r
        };
      }, function (e) {
        return {
          updateSegmentId: function updateSegmentId(t) {
            return e({
              type: h.UPDATE_CURRENT_SEGMENT_ID,
              payload: t
            });
          }
        };
      })(p.ConversationViewImpl),
      v = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.getBaseRoute = function () {
            return t.props.route.match && t.props.route.match.url.replace(/\/$/, "");
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            n = this.getBaseRoute();
          return a.createElement(s.Switch, null, a.createElement(s.Route, {
            path: n,
            exact: !0
          }, a.createElement(s.Redirect, {
            to: "/"
          })), a.createElement(d.InsightsGate, {
            redirectToWhenInactive: "/"
          }, a.createElement(s.Route, {
            path: n + "/:segmentId"
          }, function (n) {
            return a.createElement(y, i({}, e.props, {
              route: n,
              segmentId: n.match.params.segmentId,
              playerRef: function playerRef(e) {
                t.Player = e;
              }
            }));
          })));
        }, t.displayName = p.displayName, t.Content = p.Content, t.Player = null, t;
      }(a.PureComponent);
    t.ConversationView = v, t.ConversationViewBehindFeatureFlag = u.connect(function (e) {
      return {
        isFlagEnabled: c.featureEnabledSelector(m.FeatureFlag.ConversationScreen)(e)
      };
    })(function (e) {
      return e.isFlagEnabled ? a.createElement(v, i({}, e)) : a.createElement(s.Redirect, {
        to: "/"
      });
    });
  }, function (e, t, n) {
    "use strict";

    var _r109,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r109 = function r(e, t) {
        return (_r109 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r109(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      l = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationViewImpl = t.Content = t.displayName = void 0;
    var c = n(0),
      u = n(34),
      p = n(1),
      d = n(11),
      f = n(143),
      h = n(144),
      m = n(7),
      g = n(44),
      y = n(10),
      v = n(6),
      b = n(2),
      C = n(61),
      _ = n(29),
      k = n(18),
      w = n(38),
      S = n(223),
      P = n(63),
      T = n(224),
      O = n(231),
      x = n(232);
    t.displayName = "ConversationView", t.Content = new c.DynamicContentStore(t.displayName);
    var E,
      A,
      I,
      j = b.default("div")(E || (E = o(["\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    padding: 0 8px 16px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n"], ["\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    padding: 0 8px 16px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n"]))),
      L = b.default("div")(A || (A = o(["\n    position: relative;\n    flex: 1;\n"], ["\n    position: relative;\n    flex: 1;\n"]))),
      M = b.default(c.StyledButton)(I || (I = o(['\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    letter-spacing: 3px;\n    font-weight: 400;\n    font-family: "Open Sans";\n    background: transparent !important;\n    align-self: flex-start;\n    cursor: pointer;\n    margin-top: 14px;\n    text-transform: uppercase;\n\n    & > div {\n        margin-right: 6px;\n        position: relative;\n        top: 1px; // visual alignment with the text\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    letter-spacing: 3px;\n    font-weight: 400;\n    font-family: "Open Sans";\n    background: transparent !important;\n    align-self: flex-start;\n    cursor: pointer;\n    margin-top: 14px;\n    text-transform: uppercase;\n\n    & > div {\n        margin-right: 6px;\n        position: relative;\n        top: 1px; // visual alignment with the text\n    }\n']))),
      F = function (e) {
        function n() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            player: null
          }, t.handleSegmentSelect = function (e) {
            var n = t.props.route.match.url.split("/");
            n.pop();
            var r = n.join("/"),
              o = t.tryParseDashboardId();
            c.Actions.invokeAction("HistoryPush", {
              pathname: r + "/" + e,
              search: o ? "?dashboardId=" + o : ""
            });
          }, t.handleSegmentMarkClick = function (e) {
            c.Actions.invokeAction("InsightsPlayer:hide");
            var n = t.tryParseDashboardId();
            c.Actions.invokeAction("HistoryPush", {
              pathname: "/segments/" + e,
              search: n ? "?dashboardId=" + n : ""
            });
          }, t.handleBackButton = function () {
            try {
              var e = u.parse(t.props.route.location.search).dashboardId;
              if (Array.isArray(e) && (e = e[0]), e) return w.navigateToDashboard(e);
              throw new Error("Couldn't parse dashboardId");
            } catch (e) {
              return c.Actions.invokeAction("NavigateToView", {
                viewName: "dashboards"
              });
            }
            return null;
          }, t;
        }
        return i(n, e), n.getDerivedStateFromProps = function (e, t) {
          var n = e.route.location.search.match(/timeFrom=([0-9.]*)/);
          return n && n[1] && !Number.isNaN(Number(n[1])) ? {
            seekToSecond: Number(n[1])
          } : {};
        }, n.prototype.componentDidMount = function () {
          h.QuestionnaireService.getInstance().fetchQuestionnaires(), h.QuestionnaireService.getInstance().fetchSettings(), h.QuestionnaireService.getInstance().fetchAssessment(this.props.segmentId), this.props.agentId && h.QuestionnaireService.getInstance().fetchComments(this.props.agentId), this.fetchChatTranscripts(), this.props.updateSegmentId(this.props.segmentId);
        }, n.prototype.componentDidUpdate = function (e, t) {
          return a(this, void 0, void 0, function () {
            var n = this;
            return s(this, function (r) {
              switch (r.label) {
                case 0:
                  return this.props.segment ? [3, 2] : [4, f.ConversationsService.getInstance().fetchSegment(this.props.segmentId)];
                case 1:
                  r.sent(), r.label = 2;
                case 2:
                  return this.props.agentId && this.props.agentId !== e.agentId && h.QuestionnaireService.getInstance().fetchComments(this.props.agentId), e.segmentId !== this.props.segmentId && (this.props.updateSegmentId(this.props.segmentId), h.QuestionnaireService.getInstance().fetchAssessment(this.props.segmentId)), t.player !== this.state.player && this.state.player && this.state.player.on("ready", function () {
                    var e, t;
                    n.seekPlayer();
                    var r = new URLSearchParams(n.props.route.location.search);
                    r.has("autoplay") && (null === (t = null === (e = n.state.player) || void 0 === e ? void 0 : e.core) || void 0 === t || t.play(), r.delete("autoplay"), g.default().replace({
                      search: r.toString()
                    }));
                  }), this.state.seekToSecond !== t.seekToSecond && this.props.segmentId === e.segmentId && this.seekPlayer(), this.props.mediaLinks !== e.mediaLinks && this.fetchChatTranscripts(), [2];
              }
            });
          });
        }, n.prototype.fetchChatTranscripts = function () {
          this.props.mediaLinks && this.props.mediaLinks.forEach(function (e) {
            e.type !== k.InsightsPlayerMediaLinkType.ChatTranscript && e.type !== k.InsightsPlayerMediaLinkType.EmailTranscript || c.ChatChannelState.Actions.initWithChannelSid(e.sid || e.conversation_sid);
          });
        }, n.prototype.seekPlayer = function () {
          if (void 0 !== this.state.seekToSecond && this.state.player) try {
            this.state.player.seekToSecond(this.state.seekToSecond);
          } catch (e) {
            m.ErrorManager.createAndProcessError(_.ErrorMessages.INSIGHTS_PLAYER_PLAYBACK_FAILED, {
              description: "Error seeking to " + this.state.seekToSecond + "s in segment " + this.props.segmentId,
              type: m.FlexErrorType.app,
              context: "Player",
              wrappedError: e
            });
          }
        }, n.prototype.componentWillUnmount = function () {
          this.props.updateSegmentId(void 0);
        }, n.prototype.tryParseDashboardId = function () {
          var e = u.parse(this.props.route.location.search).dashboardId;
          return Array.isArray(e) && (e = e[0]), e;
        }, n.prototype.getSegmentListIds = function () {
          return this.props.segmentList ? this.props.segmentList.map(function (e) {
            return e.id;
          }) : [];
        }, n.prototype.render = function () {
          var e = this,
            n = this.props,
            r = n.children,
            o = l(n, ["children"]);
          if (!this.props.segment) return p.createElement(C.LoadingContainer, null, p.createElement(c.CircularProgress, {
            animating: !0,
            size: 80,
            borderWidth: 3
          }));
          if (!this.props.segment.hasFetched) return p.createElement(C.LoadingContainer, null, p.createElement(c.CircularProgress, {
            animating: !0,
            size: 80,
            borderWidth: 3
          }));
          if (this.props.segment.error) {
            var i = this.props.segment.error.response;
            return i && 404 === i.status ? p.createElement(c.ErrorMessage, {
              title: "The conversation is not available.",
              description: "The conversation does not exist or you do not have privileges to view it.",
              primaryAction: function primaryAction() {
                return v.tryInvokeAction("NavigateToView", {
                  viewName: "dashboards"
                });
              },
              primaryActionTitle: "Go to Dashboards",
              hideBranding: !0
            }) : p.createElement(c.ErrorMessage, {
              title: "We couldn't load the conversation.",
              description: "Please refresh the page and try again. If the issue persists, please contact support.",
              primaryAction: function primaryAction() {
                return v.tryInvokeAction("ReloadWindow");
              },
              primaryActionTitle: "Refresh",
              hideBranding: !0
            });
          }
          return p.createElement(c.DynamicComponent, {
            name: t.displayName,
            contentStore: t.Content,
            childProps: o,
            customChildren: r,
            vertical: !0,
            noContainers: !0
          }, p.createElement(P.Container, {
            vertical: !0
          }, (d.FeatureFlags.isEnabled(y.FeatureFlag.InsightsNativeDashboards) || d.FeatureFlags.isEnabled(y.FeatureFlag.InsightsNativeDashboardsBeta)) && p.createElement(M, {
            onClick: this.handleBackButton,
            key: "back-button",
            title: c.templates.BackButton()
          }, p.createElement(c.Icon, {
            icon: "BackArrow"
          }), p.createElement(c.Template, {
            source: c.templates.BackButton
          })), p.createElement(x.SegmentInfo, {
            key: "segment-info",
            segmentId: this.props.segment.id,
            onSegmentSelect: this.handleSegmentSelect
          }), p.createElement(O.Player, {
            key: "player",
            segmentId: this.props.segment.id,
            sticky: !0,
            ref: function ref(t) {
              t && e.setState({
                player: t
              }), e.props.playerRef && e.props.playerRef(t);
            },
            onSegmentMarkClick: this.handleSegmentMarkClick
          }), p.createElement(S.ConversationInfo, {
            key: "conversation-info",
            segmentId: this.props.segment.id,
            player: this.state.player,
            noGrow: !0
          }), p.createElement(L, {
            key: "conversation-content"
          }, p.createElement(j, null, p.createElement(T.ConversationViewPanelContainer, {
            key: "panel1-" + this.props.segmentId,
            id: "left-panel",
            mediaLinks: this.props.mediaLinks,
            defaultPanel: this.props.mediaLinkId && this.props.mediaLinkType && this.props.mediaLinkType + "-" + this.props.mediaLinkId
          }), p.createElement(T.ConversationViewPanelContainer, {
            key: "panel2-" + this.props.segmentId,
            id: "right-panel",
            mediaLinks: this.props.mediaLinks
          })))));
        }, n;
      }(p.PureComponent);
    t.ConversationViewImpl = F;
  }, function (e, t, n) {
    "use strict";

    var _r110,
      o = this && this.__extends || (_r110 = function r(e, t) {
        return (_r110 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r110(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationInfoImpl = t.Content = t.displayName = void 0;
    var a = n(0),
      s = n(1),
      l = n(63),
      c = n(477);
    t.displayName = "ConversationInfo", t.Content = new a.DynamicContentStore(t.displayName);
    var u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = e.children,
          r = i(e, ["children"]);
        return s.createElement(a.DynamicComponent, {
          name: t.displayName,
          contentStore: t.Content,
          childProps: r,
          customChildren: n,
          noContainers: !0
        }, s.createElement(l.ConversationInfoContainer, {
          noGrow: this.props.noGrow,
          noShrink: !0,
          "data-test": "ConversationInfo-Agent"
        }, this.props.agentName && s.createElement(l.AgentsInfoContainer, {
          key: "agent-info"
        }, s.createElement(a.Icon, {
          icon: "AgentsView"
        }), s.createElement("div", null, this.props.agentTeam ? s.createElement(a.Template, {
          source: a.templates.ConversationViewAgentInTeam,
          agent: this.props.agentName,
          team: this.props.agentTeam
        }) : s.createElement("strong", null, this.props.agentName))), this.props.numberFrom && s.createElement(l.CallerInfoContainer, {
          key: "caller-info",
          "data-test": "ConversationInfo-Caller"
        }, s.createElement(l.ThemedTooltip, {
          title: this.props.numberTo ? "calling " + this.props.numberTo : "",
          placement: "right",
          interactive: !0
        }, s.createElement("div", null, s.createElement(a.Icon, {
          icon: "Call"
        }), s.createElement(a.Template, {
          source: a.templates.ConversationViewCallerInfo,
          caller: this.props.numberFrom,
          queue: this.props.queueName
        })))), s.createElement(l.RecordingInfoContainer, {
          key: "recording-info",
          "data-test": "ConversationInfo-Time"
        }, this.props.player && s.createElement(c.CurrentTime, {
          player: this.props.player
        }), s.createElement(a.Icon, {
          icon: "Clock"
        }), s.createElement("div", null, this.props.segmentDuration))));
      }, n;
    }(s.PureComponent);
    t.ConversationInfoImpl = u;
  }, function (e, t, n) {
    "use strict";

    var _r111,
      o = this && this.__extends || (_r111 = function r(e, t) {
        return (_r111 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r111(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CurrentTime = void 0;
    var i = n(1),
      a = n(50),
      s = n(478),
      l = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            time: a.defaultTimeFormatter(0)
          }, t.subscribePlayer = function (e) {
            t.throttledHandleCurrentTimeChange = s(t.handleCurrentTimeChange, 1e3), e.on("process", t.throttledHandleCurrentTimeChange), e.on("seek", t.handleCurrentTimeChange);
          }, t.unsubscribePlayer = function (e) {
            t.throttledHandleCurrentTimeChange.cancel(), e.off("process", t.throttledHandleCurrentTimeChange), e.off("seek", t.handleCurrentTimeChange);
          }, t.handleCurrentTimeChange = function () {
            t.setState({
              time: a.defaultTimeFormatter(t.props.player.getCurrentTime() || 0)
            });
          }, t;
        }
        return o(t, e), t.prototype.componentDidUpdate = function (e) {
          this.props.player !== e.player && (this.unsubscribePlayer(e.player), this.subscribePlayer(this.props.player));
        }, t.prototype.componentDidMount = function () {
          this.subscribePlayer(this.props.player);
        }, t.prototype.componentWillUnmount = function () {
          this.unsubscribePlayer(this.props.player);
        }, t.prototype.render = function () {
          return i.createElement("div", null, i.createElement("strong", null, this.state.time));
        }, t;
      }(i.Component);
    t.CurrentTime = l;
  }, function (e, t) {
    e.exports = require("lodash.throttle");
  }, function (e, t, n) {
    "use strict";

    var _r112,
      o = this && this.__extends || (_r112 = function r(e, t) {
        return (_r112 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r112(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AssessConversationViewPanel = void 0;
    var i = n(1),
      a = n(42),
      s = n(226),
      l = n(0),
      c = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.render = function () {
            return i.createElement(a.ConversationViewPanel, {
              id: "assess",
              title: l.templates.AssessPanelTitle(),
              name: l.templates.AssessPanelTitle(),
              icon: "GenericTask"
            }, i.createElement(s.AssessPanelContent, null));
          }, t;
        }
        return o(t, e), t;
      }(i.PureComponent);
    t.AssessConversationViewPanel = c;
  }, function (e, t, n) {
    "use strict";

    var _r113,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r113 = function r(e, t) {
        return (_r113 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r113(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationViewPanelNavigation = void 0;
    var a,
      s,
      l,
      c,
      u = n(1),
      p = n(2),
      d = n(64),
      f = n(22),
      h = n(0),
      m = p.default("div")(a || (a = o(["\n    position: absolute;\n    right: 16px;\n    top: 16px;\n"], ["\n    position: absolute;\n    right: 16px;\n    top: 16px;\n"]))),
      g = p.default(f.ListItem)(s || (s = o(["\n    font-size: 14px;\n    line-height: 14px;\n    height: 30px;\n    padding: 8px 16px;\n    color: ", ";\n    cursor: pointer;\n    margin-right: 32px;\n\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    font-size: 14px;\n    line-height: 14px;\n    height: 30px;\n    padding: 8px 16px;\n    color: ", ";\n    cursor: pointer;\n    margin-right: 32px;\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), function (e) {
        return e.theme.calculated.textColor;
      }, function (e) {
        return e.theme.colors.base3;
      }),
      y = p.default(f.List)(l || (l = o(["\n    background-color: ", ";\n    border: 1px solid ", ";\n"], ["\n    background-color: ", ";\n    border: 1px solid ", ";\n"])), function (e) {
        return e.theme.colors.base1;
      }, function (e) {
        return e.theme.colors.base4;
      }),
      v = p.default(h.Icon)(c || (c = o(["\n    margin-left: auto;\n    position: absolute;\n    right: 8px;\n"], ["\n    margin-left: auto;\n    position: absolute;\n    right: 8px;\n"]))),
      b = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.wrapper = u.createRef(), t.state = {
            isPopoverOpen: !1
          }, t.open = function () {
            t.setState({
              isPopoverOpen: !0
            });
          }, t.close = function () {
            t.setState({
              isPopoverOpen: !1
            });
          }, t.onClick = function (e) {
            t.props.onPanelSelected(e.currentTarget.id);
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this;
          return u.createElement(m, null, u.createElement("div", {
            ref: this.wrapper
          }, u.createElement(d.InsightsIconButton, {
            key: "conversationView-panelNavigation-button",
            icon: "More",
            onClick: this.open,
            className: this.state.isPopoverOpen ? "active" : void 0,
            "data-test": "ConversationViewPanel-NavigationButton"
          }), u.createElement(f.Popover, {
            open: this.state.isPopoverOpen,
            onClose: this.close,
            anchorEl: this.wrapper.current,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "right"
            }
          }, u.createElement(y, {
            "data-test": "ConversationViewPanel-NavigationPopup"
          }, Object.keys(this.props.panels).map(function (t) {
            return u.createElement(g, {
              id: t,
              key: t,
              onClick: e.onClick,
              "data-test": e.props.panels[t]
            }, e.props.panels[t], e.props.selected === t && u.createElement(v, {
              icon: "Accept"
            }));
          })))));
        }, t;
      }(u.PureComponent);
    t.ConversationViewPanelNavigation = b;
  }, function (e, t, n) {
    "use strict";

    var _r114,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r114 = function r(e, t) {
        return (_r114 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r114(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AnswerCount = t.AnswerCountImpl = void 0;
    var a = n(1),
      s = n(0),
      l = n(3),
      c = n(228),
      u = n(4),
      p = n(2).default("div")(f || (f = o(["\n    font-size: 12px;\n\n    ", "\n"], ["\n    font-size: 12px;\n\n    ", "\n"])), function (e) {
        return e.allAnswered && "\n            color: green;\n        ";
      }),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this.props.count === this.props.total;
          return a.createElement(p, {
            allAnswered: e
          }, e ? a.createElement(s.Template, {
            source: u.templates.QuestionnaireAllAnswered
          }) : a.createElement(s.Template, {
            source: u.templates.QuestionnaireAnsweredCount,
            count: this.props.count,
            total: this.props.total
          }));
        }, t;
      }(a.PureComponent);
    t.AnswerCountImpl = d;
    var f;
    t.AnswerCount = l.connect(function (e, t) {
      return {
        count: c.answerCountAsweredSelector(e, t),
        total: c.answerCountTotalSelector(e, t)
      };
    })(d);
  }, function (e, t, n) {
    "use strict";

    var _r115,
      o = this && this.__extends || (_r115 = function r(e, t) {
        return (_r115 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r115(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Questionnaire = t._Questionnaire = void 0;
    var i = n(1),
      a = n(3),
      s = n(483),
      l = n(228),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return i.createElement("div", {
            "data-test": "Questionnaire",
            "data-test-id": this.props.questionnaire.id
          }, this.props.questionnaire.categories.map(function (t) {
            return i.createElement(s.QuestionCategoryComponent, {
              key: t.id,
              category: t,
              assessments: e.props.assessments.filter(function (e) {
                return e.category_id === t.id;
              }),
              onAnswerSubmitted: e.props.onAnswerSubmitted
            });
          }));
        }, t;
      }(i.PureComponent);
    t._Questionnaire = c, t.Questionnaire = a.connect(function (e, t) {
      return {
        assessments: l.assessmentsForQuestionnaireSelector(e, t)
      };
    })(c);
  }, function (e, t, n) {
    "use strict";

    var _r116,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r116 = function r(e, t) {
        return (_r116 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r116(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QuestionCategoryComponent = void 0;
    var a,
      s,
      l = n(1),
      c = n(484),
      u = n(2),
      p = u.default("div")(a || (a = o(["\n    font-weight: bold;\n    font-size: 14px;\n"], ["\n    font-weight: bold;\n    font-size: 14px;\n"]))),
      d = u.default("div")(s || (s = o(["\n    margin-bottom: 32px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n"], ["\n    margin-bottom: 32px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n"]))),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onAnswerSubmitted = function (e) {
            e.category_id = t.props.category.id, e.category_name = t.props.category.name, t.props.onAnswerSubmitted(e);
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this;
          return l.createElement(d, {
            "data-test": "Questionnaire-QuestionCategory " + this.props.category.name,
            "data-test-id": this.props.category.id
          }, l.createElement(p, null, this.props.category.name), l.createElement("div", null, this.props.category.metrics.map(function (t) {
            return l.createElement(c.QuestionComponent, {
              key: t.id,
              question: t,
              onAnswerSubmitted: e.onAnswerSubmitted,
              assessments: e.props.assessments.filter(function (e) {
                return e.metric_id === t.id;
              })
            });
          })));
        }, t;
      }(l.PureComponent);
    t.QuestionCategoryComponent = f;
  }, function (e, t, n) {
    "use strict";

    var _r117,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r117 = function r(e, t) {
        return (_r117 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r117(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QuestionComponent = t._QuestionComponent = t.ClearInputButton = void 0;
    var s = n(1),
      l = n(2),
      c = n(0),
      u = n(3),
      p = n(22),
      d = l.default("div")(b || (b = o(["\n    border-bottom: 1px solid ", ";\n    padding: 16px 0 14px;\n    &:last-child {\n        border-bottom: 0;\n        padding-bottom: 0;\n    }\n"], ["\n    border-bottom: 1px solid ", ";\n    padding: 16px 0 14px;\n    &:last-child {\n        border-bottom: 0;\n        padding-bottom: 0;\n    }\n"])), function (e) {
        return e.theme.colors.base3;
      }),
      f = l.default("div")(C || (C = o(["\n    padding-bottom: 4px;\n    font-size: 14px;\n"], ["\n    padding-bottom: 4px;\n    font-size: 14px;\n"]))),
      h = l.default("div")(_ || (_ = o(["\n    display: flex;\n    flex-direction: row;\n    margin: 0 -4px;\n    align-items: center;\n"], ["\n    display: flex;\n    flex-direction: row;\n    margin: 0 -4px;\n    align-items: center;\n"]))),
      m = l.default("div")(k || (k = o(["\n    display: flex;\n    padding: 5px 16px;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    margin: 4px;\n    font-size: 14px;\n    cursor: pointer;\n\n    ", "\n    ", "\n\n    &:hover {\n        ", "\n    }\n"], ["\n    display: flex;\n    padding: 5px 16px;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    margin: 4px;\n    font-size: 14px;\n    cursor: pointer;\n\n    ", "\n    ", "\n\n    &:hover {\n        ", "\n    }\n"])), function (e) {
        return e.theme.colors.base3;
      }, function (e) {
        return e.theme.ConversationView.Questionnaire.Answer;
      }, function (e) {
        var t = e.theme;
        return e.selected && t.ConversationView.Questionnaire.AnswerSelected;
      }, function (e) {
        return e.theme.ConversationView.Questionnaire.AnswerHover;
      });
    t.ClearInputButton = l.default("div")(w || (w = o(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: ", ";\n    transform: translateX(", "px);\n    transition: all 200ms ease-out;\n    padding: 4px;\n    cursor: pointer;\n    margin-left: 4px;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: ", ";\n    transform: translateX(", "px);\n    transition: all 200ms ease-out;\n    padding: 4px;\n    cursor: pointer;\n    margin-left: 4px;\n"])), function (e) {
      return e.isVisible ? 1 : 0;
    }, function (e) {
      return e.isVisible ? 0 : -10;
    });
    var g = l.default("div")(S || (S = o(["\n    display: flex;\n    flex-flow: row-reverse;\n"], ["\n    display: flex;\n    flex-flow: row-reverse;\n"]))),
      y = function y(e) {
        return "{\n    color: " + e + ' !important;\n    &:before {\n        content: "★" !important;\n    }\n}';
      };
    function v(e) {
      return "{\n        " + y(e) + "\n        & + * " + y(e) + "\n        & + * + * " + y(e) + "\n        & + * + * + * " + y(e) + "\n        & + * + * + * + * " + y(e) + "\n    }\n";
    }
    var b,
      C,
      _,
      k,
      w,
      S,
      P,
      T = l.default("div")(P || (P = o(["\n    font-size: 30px;\n    padding: 0 2px;\n    cursor: pointer;\n    transition: all 200ms ease-out;\n    color: ", ';\n\n    &:before {\n        content: "☆";\n    }\n\n    ', "\n\n    &:hover {\n        transform: scale(1.1);\n        ", "\n    }\n"], ["\n    font-size: 30px;\n    padding: 0 2px;\n    cursor: pointer;\n    transition: all 200ms ease-out;\n    color: ", ';\n\n    &:before {\n        content: "☆";\n    }\n\n    ', "\n\n    &:hover {\n        transform: scale(1.1);\n        ", "\n    }\n"])), function (e) {
        return e.theme.colors.base7;
      }, function (e) {
        var t = e.selected,
          n = e.theme;
        return t && v(n.colors.base7);
      }, function (e) {
        return v(e.theme.colors.base9);
      }),
      O = p.withStyles(function (e) {
        return {
          tooltip: {
            backgroundColor: e.colors.base3,
            color: e.colors.base10,
            padding: "8px",
            fontSize: "12px",
            position: "relative",
            top: "40px"
          }
        };
      })(p.Tooltip),
      x = function x(e) {
        return !!e;
      },
      E = function (e) {
        function n() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            hovering: !1
          }, t.submitAnswer = function (e) {
            var n = {
              answer_id: e.id,
              answer_text: e.name.toString(),
              metric_id: t.props.question.id,
              metric_name: t.props.question.name
            };
            t.props.onAnswerSubmitted(n);
          }, t.resetAnswer = function () {
            t.submitAnswer({
              id: "",
              name: ""
            });
          }, t.hover = function (e) {
            return function () {
              t.setState({
                hovering: e
              });
            };
          }, t;
        }
        return i(n, e), n.prototype.render = function () {
          var e = this,
            n = this.props.assessments.sort(function (e, t) {
              return (t.timestamp_updated || 0) - (e.timestamp_updated || 0);
            })[0];
          return s.createElement(O, {
            title: this.props.question.description || "",
            placement: "top"
          }, s.createElement(d, {
            onMouseOver: this.hover(!0),
            onFocus: this.hover(!0),
            onMouseOut: this.hover(!1),
            onBlur: this.hover(!1),
            "data-test": "Questionnaire-Question",
            "data-test-id": this.props.question.id
          }, s.createElement(f, {
            "data-test": "Questionnaire-QuestionTitle"
          }, this.props.question.name), s.createElement(h, {
            "data-test": "Questionnaire-QuestionAnswers " + this.props.question.name
          }, "select" === this.props.question.answers_type ? a(this.props.question.answers, [this.props.NAanswer]).filter(x).map(function (t) {
            return s.createElement(m, {
              key: t.id,
              onClick: function onClick() {
                return e.submitAnswer(t);
              },
              selected: n && t.id === n.answer_id,
              "data-test": "Questionnaire-Answer",
              "data-selected": !(!n || t.id !== n.answer_id) || null
            }, t.name);
          }) : s.createElement(s.Fragment, null, s.createElement(g, null, a(this.props.question.answers).reverse().map(function (t) {
            return s.createElement(T, {
              role: "button",
              key: t.id,
              onClick: function onClick() {
                return e.submitAnswer(t);
              },
              selected: n && t.id === n.answer_id,
              "data-selected": !(!n || t.id !== n.answer_id) || null
            });
          })), this.props.NAanswer && s.createElement(m, {
            key: this.props.NAanswer.id,
            onClick: function onClick() {
              return e.submitAnswer(e.props.NAanswer);
            },
            selected: n && this.props.NAanswer.id === n.answer_id,
            "data-test": "Questionnaire-Answer",
            "data-selected": !(!n || this.props.NAanswer.id !== n.answer_id) || null
          }, this.props.NAanswer.name)), n && n.answer_id && s.createElement(t.ClearInputButton, {
            isVisible: this.state.hovering,
            onClick: this.resetAnswer
          }, s.createElement(c.Icon, {
            icon: "Close",
            sizeMultiplier: 1.2
          })))));
        }, n;
      }(s.PureComponent);
    t._QuestionComponent = E, t.QuestionComponent = u.connect(function (e, t) {
      return {
        NAanswer: t.question.NA && e.insights.assessmentSettings ? e.insights.assessmentSettings.NA : void 0
      };
    })(E);
  }, function (e, t, n) {
    "use strict";

    var _r118,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r118 = function r(e, t) {
        return (_r118 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r118(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QuestionnaireSelector = void 0;
    var a,
      s,
      l = n(1),
      c = n(2),
      u = n(22),
      p = n(0),
      d = c.default("div")(a || (a = o(["\n    margin-bottom: 20px;\n"], ["\n    margin-bottom: 20px;\n"]))),
      f = c.default("div")(s || (s = o(["\n    font-size: 10px;\n    margin-bottom: 6px;\n"], ["\n    font-size: 10px;\n    margin-bottom: 6px;\n"]))),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onChange = function (e) {
            t.props.onSelect(e.target.value);
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          return l.createElement(d, {
            "data-test": "Assessments-QuestionnaireSelector"
          }, l.createElement(f, null, l.createElement(p.Template, {
            source: p.templates.QuestionnaireSelectorLabel
          })), l.createElement(u.Select, {
            value: this.props.selectedId,
            onChange: this.onChange
          }, this.props.questionnaires.map(function (e) {
            return l.createElement(u.MenuItem, {
              value: e.id,
              key: e.id,
              "data-test": "QuestionnaireSelector-Item"
            }, e.name);
          })));
        }, t;
      }(l.PureComponent);
    t.QuestionnaireSelector = h;
  }, function (e, t, n) {
    "use strict";

    var _r119,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r119 = function r(e, t) {
        return (_r119 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r119(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AgentConversationViewPanel = void 0;
    var a,
      s,
      l = n(0),
      c = n(1),
      u = n(3),
      p = n(2),
      d = n(487),
      f = n(227),
      h = n(42),
      m = p.default("div")(a || (a = o(["\n    width: 100%;\n"], ["\n    width: 100%;\n"]))),
      g = p.default("div")(s || (s = o(["\n    text-align: center;\n"], ["\n    text-align: center;\n"]))),
      y = function y() {
        return c.createElement(g, null, c.createElement(l.Template, {
          code: "AgentPanelNoAgentAssociated"
        }));
      },
      v = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.render = function () {
            return c.createElement(h.ConversationViewPanel, {
              id: "agent-view",
              title: t.props.agentName || l.templates.AgentPanelTitle(),
              name: l.templates.AgentPanelTitle(),
              icon: "AgentsView"
            }, c.createElement(m, null, t.props.agentName ? c.createElement(d.CommentsListContainer, null) : c.createElement(y, null)));
          }, t;
        }
        return i(t, e), t;
      }(c.PureComponent);
    t.AgentConversationViewPanel = u.connect(function (e, t) {
      return {
        agentName: f.agentNameSelector(e, t)
      };
    })(v);
  }, function (e, t, n) {
    "use strict";

    var _r120,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r120 = function r(e, t) {
        return (_r120 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r120(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CommentsListContainer = t.CommentsList = void 0;
    var s = n(22),
      l = n(0),
      c = n(1),
      u = n(31),
      p = n(7),
      d = n(57),
      f = n(3),
      h = n(44),
      m = n(2),
      g = n(29),
      y = n(488),
      v = n(489),
      b = m.default("div")(_ || (_ = o(["\n    justify-content: center;\n    display: flex;\n    height: 140px;\n"], ["\n    justify-content: center;\n    display: flex;\n    height: 140px;\n"]))),
      C = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onClick = function (e) {
            var t = e.segment_id,
              n = e.offset || 0;
            if (!t) throw new Error("Unknown segment id for the comment.");
            if (d.ConversationView.Player) {
              h.default().push("/segments/" + t + "?timeFrom=" + n);
              try {
                d.ConversationView.Player.seekToSecond(n);
              } catch (e) {
                p.ErrorManager.createAndProcessError(g.ErrorMessages.INSIGHTS_PLAYER_PLAYBACK_FAILED, {
                  description: "Failed to seek to comment at " + n + "s in " + t + ".",
                  type: p.FlexErrorType.app,
                  context: "Player",
                  wrappedError: e
                });
              }
            } else h.default().push("/segments/" + t);
          }, t;
        }
        return i(t, e), t.prototype.renderCommentList = function () {
          var e = this;
          return this.props.comments && this.props.comments.length ? this.props.comments.map(function (t) {
            return c.createElement(s.Grow, {
              key: t.assessment_id || t.timestamp_updated,
              in: !0,
              timeout: 400,
              style: {
                transformOrigin: "0 0 0"
              }
            }, c.createElement(y.Comment, {
              comment: t,
              key: t.assessment_id || t.timestamp_updated,
              onClick: function onClick() {
                return e.onClick(t);
              }
            }));
          }) : c.createElement(v.EmptyCommentList, null);
        }, t.prototype.render = function () {
          return c.createElement("div", {
            "data-test": "Assessments-CommentList"
          }, this.props.comments ? this.renderCommentList() : c.createElement(b, null, c.createElement(l.CircularProgress, {
            animating: !0,
            size: 80
          })));
        }, t;
      }(c.Component);
    t.CommentsList = C;
    var _,
      k = function k(e, t) {
        return t.segmentId || e.insights.segmentId;
      },
      w = u.createSelector(k, function (e) {
        return e.insights.segmentsById;
      }, function (e, t) {
        return t && e && t[e] && t[e].data ? t[e].data.agent_id : void 0;
      }),
      S = u.createSelector(function (e) {
        return e.insights.comments;
      }, w, function (e, t) {
        return t && e && e[t] ? a(e[t]).sort(function (e, t) {
          return (t.timestamp_updated || 0) - (e.timestamp_updated || 0);
        }) : void 0;
      });
    t.CommentsListContainer = f.connect(function (e, t) {
      return {
        segmentId: k(e, t),
        comments: S(e, t)
      };
    })(C);
  }, function (e, t, n) {
    "use strict";

    var _r121,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r121 = function r(e, t) {
        return (_r121 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r121(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Comment = void 0;
    var a,
      s,
      l,
      c,
      u = n(1),
      p = n(2),
      d = n(0),
      f = n(63),
      h = p.default("div")(a || (a = o(["\n    font-size: 14px;\n    font-weight: bold;\n"], ["\n    font-size: 14px;\n    font-weight: bold;\n"]))),
      m = p.default("div")(s || (s = o(["\n    padding-bottom: 16px;\n    margin: 16px 0;\n    border-bottom: 1px solid ", ";\n    font-size: 14px;\n    ", "\n\n    &:last-child {\n        margin-bottom: 0;\n        border-bottom: 0;\n    }\n"], ["\n    padding-bottom: 16px;\n    margin: 16px 0;\n    border-bottom: 1px solid ", ";\n    font-size: 14px;\n    ", "\n\n    &:last-child {\n        margin-bottom: 0;\n        border-bottom: 0;\n    }\n"])), function (e) {
        return e.theme.colors.base3;
      }, function (e) {
        return e.onClick && "cursor: pointer;";
      }),
      g = p.default("div")(l || (l = o(["\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n"], ["\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n"]))),
      y = p.default("div")(c || (c = o(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (e) {
        return e.theme.colors.base5;
      }),
      v = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.getTooltipTitle = function () {
          var e = this.props.comment.offset || 0;
          return d.templates.CommentDurationAndAuthor({
            duration: d.Utils.formatTimeDuration(1e3 * e),
            author: this.props.comment.user_name
          });
        }, t.prototype.render = function () {
          return u.createElement(f.ThemedTooltip, {
            title: this.getTooltipTitle(),
            placement: "top",
            interactive: !0
          }, u.createElement(m, {
            onClick: this.props.onClick,
            "data-test": "Assessments-Comment"
          }, u.createElement(g, null, u.createElement(h, null, this.props.comment.category_name), u.createElement(y, null, d.Utils.formatSeparatorDate(new Date(this.props.comment.timestamp_updated || 0)))), u.createElement(d.Markdown, null, this.props.comment.comment || "")));
        }, t;
      }(u.Component);
    t.Comment = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmptyCommentList = void 0;
    var o,
      i,
      a = n(1),
      s = n(0),
      l = n(2),
      c = l.default("div")(o || (o = r(["\n    text-align: center;\n    margin: 25px 0;\n"], ["\n    text-align: center;\n    margin: 25px 0;\n"]))),
      u = l.default("div")(i || (i = r(["\n    display: flex;\n    font-size: 14px;\n    font-weight: bold;\n    justify-content: center;\n    align-items: center;\n    > * {\n        margin: 8px;\n    }\n"], ["\n    display: flex;\n    font-size: 14px;\n    font-weight: bold;\n    justify-content: center;\n    align-items: center;\n    > * {\n        margin: 8px;\n    }\n"])));
    t.EmptyCommentList = function () {
      return a.createElement(c, null, a.createElement(u, null, a.createElement(s.Icon, {
        icon: "NoChat"
      }), a.createElement(s.Template, {
        source: s.templates.EmptyCommentListTitle
      })), a.createElement("div", null, a.createElement(s.Template, {
        source: s.templates.EmptyCommentListSubtitle
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var _r122,
      o = this && this.__extends || (_r122 = function r(e, t) {
        return (_r122 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r122(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FindingsConversationViewPanel = void 0;
    var i = n(1),
      a = n(42),
      s = n(229),
      l = n(3),
      c = n(24),
      u = n(0),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.render = function () {
            return i.createElement(a.ConversationViewPanel, {
              id: "findings",
              title: u.templates.FindingsPanelTitle(),
              name: u.templates.FindingsPanelTitle(),
              icon: "SpeechSearches"
            }, i.createElement(s.FindingsList, {
              findings: t.props.findings,
              currentSegmentOffset: t.props.currentSegmentOffset
            }));
          }, t;
        }
        return o(t, e), t;
      }(i.PureComponent);
    t.FindingsConversationViewPanel = l.connect(function (e) {
      return {
        findings: e.insights.segmentId ? c.displayedFindingsSelector(e, e.insights.segmentId) : [],
        currentSegmentOffset: c.currentSegmentOffsetSelector(e)
      };
    })(p);
  }, function (e, t, n) {
    "use strict";

    var _r123,
      o = this && this.__extends || (_r123 = function r(e, t) {
        return (_r123 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r123(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FindingsList = void 0;
    var s = n(1),
      l = n(0),
      c = n(57),
      u = n(492),
      p = n(145),
      d = n(2),
      f = n(7),
      h = n(29),
      m = n(16),
      g = n(14),
      y = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onFindingClick = function (e) {
            return i(t, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (!c.ConversationView.Player || !e.offset) return [3, 4];
                    n.label = 1;
                  case 1:
                    return n.trys.push([1, 3,, 4]), c.ConversationView.Player.seekToSecond(e.offset, !1), [4, c.ConversationView.Player.play()];
                  case 2:
                    return n.sent(), [3, 4];
                  case 3:
                    return t = n.sent(), f.ErrorManager.createAndProcessError(h.ErrorMessages.INSIGHTS_PLAYER_PLAYBACK_FAILED, {
                      description: "Error emitted upon clicking on a finding in the findings panel",
                      type: f.FlexErrorType.app,
                      context: "Player",
                      wrappedError: t
                    }), m.Notifications.showNotification(g.InsightsPlayerPlaybackFailed), [3, 4];
                  case 4:
                    return [2];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props.findings,
            n = function n(t) {
              var n = t.finding;
              return s.createElement(u.FindingsListItem, {
                className: "Twilio-Findings-ListItem",
                onClick: function onClick() {
                  return e.onFindingClick(n);
                }
              }, s.createElement(u.FindingPhrase, {
                color: p.getChannelColor(n.speaker, e.props.theme)
              }, s.createElement("span", null, n.speech_search, ":"), " ", n.speech_phrase), s.createElement(u.FindingOffset, null, l.Utils.formatTimeDuration(1e3 * (n.offset - e.props.currentSegmentOffset))));
            },
            r = t && t.map(function (e) {
              return s.createElement(n, {
                key: e.id,
                finding: e
              });
            });
          return t && t.length ? s.createElement(u.FindingsListContainer, {
            className: "Twilio-Findings-List"
          }, r) : s.createElement(function () {
            return s.createElement(u.EmptyFindingsContainer, null, s.createElement(l.Template, {
              source: l.templates.EmptyFindingsList
            }));
          }, null);
        }, t;
      }(s.PureComponent);
    t.FindingsList = d.withTheme(y);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FindingOffset = t.FindingPhrase = t.FindingsListItem = t.FindingsListContainer = t.EmptyFindingsContainer = void 0;
    var o,
      i,
      a,
      s,
      l,
      c = n(2);
    t.EmptyFindingsContainer = c.default("div")(o || (o = r(["\n    display: flex;\n    justify-content: center;\n    padding: 15px 0 55px;\n"], ["\n    display: flex;\n    justify-content: center;\n    padding: 15px 0 55px;\n"]))), t.FindingsListContainer = c.default("ul")(i || (i = r(["\n    padding-top: 10px;\n    width: 100%;\n"], ["\n    padding-top: 10px;\n    width: 100%;\n"]))), t.FindingsListItem = c.default("li")(a || (a = r(["\n    display: flex;\n    padding-bottom: 16px;\n    margin: 16px 0;\n    border-bottom: 1px solid #dddddd;\n    font-size: 14px;\n    cursor: pointer;\n\n    &:last-of-type {\n        margin-bottom: 0;\n        border-bottom: none;\n    }\n"], ["\n    display: flex;\n    padding-bottom: 16px;\n    margin: 16px 0;\n    border-bottom: 1px solid #dddddd;\n    font-size: 14px;\n    cursor: pointer;\n\n    &:last-of-type {\n        margin-bottom: 0;\n        border-bottom: none;\n    }\n"]))), t.FindingPhrase = c.default("div", {
      shouldForwardProp: function shouldForwardProp(e) {
        return "color" !== e;
      }
    })(s || (s = r(["\n    color: ", ";\n\n    & span {\n        font-weight: bold;\n        margin-right: 8px;\n    }\n"], ["\n    color: ", ";\n\n    & span {\n        font-weight: bold;\n        margin-right: 8px;\n    }\n"])), function (e) {
      return e.color;
    }), t.FindingOffset = c.default("div")(l || (l = r(["\n    flex-grow: 1;\n    text-align: right;\n"], ["\n    flex-grow: 1;\n    text-align: right;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FindingsMarks = void 0;
    var r = n(3),
      o = n(494),
      i = n(24),
      a = n(2);
    t.FindingsMarks = r.connect(function (e, t) {
      return {
        findings: i.displayedFindingsSelector(e, t.segmentId)
      };
    })(a.withTheme(o.FindingsMarksImpl));
  }, function (e, t, n) {
    "use strict";

    var _r124,
      o = this && this.__extends || (_r124 = function r(e, t) {
        return (_r124 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r124(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FindingsMarksImpl = void 0;
    var i = n(1),
      a = n(230),
      s = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return this.props.findings.map(function (t) {
            return i.createElement(a.FindingMarker, {
              key: t.id,
              finding: t,
              onClick: e.props.onFindingClick,
              theme: e.props.theme
            });
          });
        }, t;
      }(i.Component);
    t.FindingsMarksImpl = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SilencesAndCrosstalksMarks = void 0;
    var r = n(3),
      o = n(496),
      i = n(24);
    t.SilencesAndCrosstalksMarks = r.connect(function (e, t) {
      return {
        findings: i.silencesAndCrosstalksSelector(e, t.segmentId)
      };
    })(o.SilencesAndCrosstalksMarksImpl);
  }, function (e, t, n) {
    "use strict";

    var _r125,
      o = this && this.__extends || (_r125 = function r(e, t) {
        return (_r125 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r125(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SilencesAndCrosstalksMarksImpl = void 0;
    var i = n(1),
      a = n(50),
      s = n(0),
      l = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.getRegionTitle = function (e) {
            return e.speech_search + ", " + s.Utils.formatTimeDuration(1e3 * e.offset) + "-" + s.Utils.formatTimeDuration(1e3 * (e.offset + e.duration));
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return this.props.findings.map(function (t) {
            return i.createElement(a.Mark, {
              key: t.id,
              offset: t.offset,
              duration: t.duration,
              color: "Silence" === t.speech_search ? "rgba(255, 141, 6, 0.2)" : "rgba(200, 0, 0, 0.2)",
              title: e.getRegionTitle(t)
            });
          });
        }, t;
      }(i.Component);
    t.SilencesAndCrosstalksMarksImpl = l;
  }, function (e, t, n) {
    "use strict";

    var _r126,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r126 = function r(e, t) {
        return (_r126 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r126(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatTranscriptPanel = void 0;
    var a,
      s = n(1),
      l = n(4),
      c = n(2),
      u = n(18),
      p = n(100),
      d = n(101),
      f = n(42),
      h = c.default("div")(a || (a = o(["\n    width: 100%;\n    display: flex;\n    flex: 1;\n\n    .Twilio-MessagingCanvas {\n        max-width: 100%;\n        width: 100%;\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    flex: 1;\n\n    .Twilio-MessagingCanvas {\n        max-width: 100%;\n        width: 100%;\n    }\n"]))),
      m = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.render = function () {
            return s.createElement(f.ConversationViewPanel, {
              id: u.InsightsPlayerMediaLinkType.ChatTranscript + "-" + t.props.mediaLink.sid + "-" + t.props.mediaLink.title,
              title: l.templates.TranscriptPanelTitle(),
              name: l.templates.TranscriptPanelTitle(),
              icon: "Message",
              keepMounted: !0
            }, s.createElement(d.default, null, s.createElement(h, null, s.createElement(p.TranscriptContent, {
              mediaLink: t.props.mediaLink,
              autoInitChannel: !1
            }))));
          }, t;
        }
        return i(t, e), t;
      }(s.PureComponent);
    t.ChatTranscriptPanel = m;
  }, function (e, t, n) {
    "use strict";

    var _r127,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r127 = function r(e, t) {
        return (_r127 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r127(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmbeddedContentPanel = void 0;
    var a,
      s = n(1),
      l = n(146),
      c = n(18),
      u = n(42),
      p = n(2).default("div")(a || (a = o(["\n    height: calc(100vh - 176px);\n    width: 100%;\n"], ["\n    height: calc(100vh - 176px);\n    width: 100%;\n"]))),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.render = function () {
            return s.createElement(u.ConversationViewPanel, {
              id: c.InsightsPlayerMediaLinkType.Embedded + "-" + t.props.mediaLink.url + "-" + t.props.mediaLink.title,
              title: t.props.mediaLink.title || t.props.mediaLink.url,
              name: t.props.mediaLink.title || t.props.mediaLink.url,
              icon: "Dashboard",
              keepMounted: !0
            }, s.createElement(p, null, s.createElement(l.EmbeddedContent, {
              mediaLink: t.props.mediaLink
            })));
          }, t;
        }
        return i(t, e), t;
      }(s.PureComponent);
    t.EmbeddedContentPanel = d;
  }, function (e, t, n) {
    "use strict";

    var _r128,
      o = this && this.__extends || (_r128 = function r(e, t) {
        return (_r128 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r128(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ReferencedContentPanel = void 0;
    var i = n(1),
      a = n(147),
      s = n(18),
      l = n(42),
      c = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.render = function () {
            return i.createElement(l.ConversationViewPanel, {
              id: s.InsightsPlayerMediaLinkType.Referenced + "-" + t.props.mediaLink.url + "-" + t.props.mediaLink.title,
              title: t.props.mediaLink.title || t.props.mediaLink.url,
              name: t.props.mediaLink.title || t.props.mediaLink.url,
              icon: "Dashboard",
              keepMounted: !0
            }, i.createElement(a.ReferencedContent, {
              mediaLink: t.props.mediaLink
            }));
          }, t;
        }
        return o(t, e), t;
      }(i.PureComponent);
    t.ReferencedContentPanel = c;
  }, function (e, t, n) {
    "use strict";

    var _r129,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r129 = function r(e, t) {
        return (_r129 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r129(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailTranscriptPanel = void 0;
    var a,
      s = n(1),
      l = n(4),
      c = n(2),
      u = n(18),
      p = n(100),
      d = n(101),
      f = n(42),
      h = c.default("div")(a || (a = o(["\n    width: 100%;\n    display: flex;\n    flex: 1;\n\n    .Twilio-MessagingCanvas {\n        max-width: 100%;\n        width: 100%;\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    flex: 1;\n\n    .Twilio-MessagingCanvas {\n        max-width: 100%;\n        width: 100%;\n    }\n"]))),
      m = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.render = function () {
            return s.createElement(f.ConversationViewPanel, {
              id: u.InsightsPlayerMediaLinkType.EmailTranscript + "-" + t.props.mediaLink.conversation_sid + "-" + t.props.mediaLink.title,
              title: l.templates.EmailTranscriptPanelTitle(),
              name: l.templates.EmailTranscriptPanelTitle(),
              icon: "Email",
              keepMounted: !0
            }, s.createElement(d.default, null, s.createElement(h, null, s.createElement(p.TranscriptContent, {
              mediaLink: t.props.mediaLink,
              autoInitChannel: !1
            }))));
          }, t;
        }
        return i(t, e), t;
      }(s.PureComponent);
    t.EmailTranscriptPanel = m;
  }, function (e, t, n) {
    "use strict";

    var _r130,
      o = this && this.__extends || (_r130 = function r(e, t) {
        return (_r130 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r130(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PlayerImpl = t.displayName = void 0;
    var s = n(1),
      l = n(50),
      c = n(502),
      u = n(229),
      p = n(503),
      d = n(143),
      f = n(63),
      h = n(504),
      m = n(505),
      g = n(145),
      y = n(16),
      v = n(14),
      b = n(29),
      C = n(7);
    t.displayName = "Player";
    var _ = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.urlRefreshTimeout = null, n.handlePlayerReady = function () {
          n.scheduleRecordingUrlRefresh();
        }, n.handlePlaybackRateChange = function (e) {
          n.setState({
            playbackRate: e
          });
        }, n.handlePlayerError = function (e) {
          return i(n, void 0, void 0, function () {
            var t;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  if (!(this.props.recordingUrlExpiresAt && this.props.recordingUrlExpiresAt > 0 && this.props.recordingUrlExpiresAt <= Date.now())) return [3, 5];
                  n.label = 1;
                case 1:
                  return n.trys.push([1, 3,, 4]), [4, d.ConversationsService.getInstance().refreshPresignedRecordingUrl(this.props.segmentId)];
                case 2:
                  return n.sent(), [3, 4];
                case 3:
                  return t = n.sent(), C.ErrorManager.createAndProcessError(b.ErrorMessages.INSIGHTS_PLAYER_PLAYBACK_FAILED, {
                    type: C.FlexErrorType.app,
                    context: "Player",
                    wrappedError: t
                  }), y.Notifications.showNotification(v.InsightsPlayerPlaybackFailed), [3, 4];
                case 4:
                  return [3, 6];
                case 5:
                  C.ErrorManager.createAndProcessError(b.ErrorMessages.INSIGHTS_PLAYER_PLAYBACK_FAILED, {
                    type: C.FlexErrorType.app,
                    context: "Player",
                    wrappedError: e
                  }), y.Notifications.showNotification(v.InsightsPlayerPlaybackFailed), n.label = 6;
                case 6:
                  return [2];
              }
            });
          });
        }, n.handleFindingClick = function (e) {
          return i(n, void 0, void 0, function () {
            var t;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  if (!(this.state.player && e && e.offset)) return [3, 4];
                  n.label = 1;
                case 1:
                  return n.trys.push([1, 3,, 4]), this.state.player.seekToSecond(e.offset, !1), [4, this.state.player.play()];
                case 2:
                  return n.sent(), [3, 4];
                case 3:
                  return t = n.sent(), C.ErrorManager.createAndProcessError(b.ErrorMessages.INSIGHTS_PLAYER_PLAYBACK_FAILED, {
                    description: "Error upon clicking on a finding",
                    type: C.FlexErrorType.app,
                    context: "Player",
                    wrappedError: t
                  }), y.Notifications.showNotification(v.InsightsPlayerPlaybackFailed), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, n.scheduleRecordingUrlRefresh = function () {
          if (null !== n.urlRefreshTimeout && (clearTimeout(n.urlRefreshTimeout), n.urlRefreshTimeout = null), n._isMounted && n.props.recordingUrl && n.props.recordingUrlExpiresAt && n.props.recordingUrlExpiresAt > 0) {
            var e = n.props.recordingUrlExpiresAt - Date.now();
            e = e >= 0 ? e : 0, n.urlRefreshTimeout = window.setTimeout(n.refreshPresignedRecordingUrl, .9 * e);
          }
        }, n.refreshPresignedRecordingUrl = function () {
          return i(n, void 0, void 0, function () {
            return a(this, function (e) {
              switch (e.label) {
                case 0:
                  return e.trys.push([0, 3,, 4]), this.props.recordingUrl ? [4, d.ConversationsService.getInstance().refreshPresignedRecordingUrl(this.props.segmentId)] : [3, 2];
                case 1:
                  e.sent(), this.scheduleRecordingUrlRefresh(), e.label = 2;
                case 2:
                  return [3, 4];
                case 3:
                  return e.sent(), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, n.state = {
          playbackRate: "normal",
          player: null
        }, n;
      }
      return o(t, e), t.prototype.componentDidMount = function () {
        this._isMounted = !0;
      }, t.prototype.componentWillUnmount = function () {
        this._isMounted = !1;
      }, t.prototype.render = function () {
        var e = this;
        if (!this.props.recordingUrl) return s.createElement(f.PlayerContainer, {
          noGrow: !0,
          noShrink: !0,
          hasFindings: !1
        }, s.createElement(h.PlaybackUnavailable, null));
        var t = {
            customer: g.getChannelColor("customer", this.props.theme),
            agent: g.getChannelColor("agent", this.props.theme)
          },
          n = this.props.recordingUrl.startsWith("https://api.twilio.com") && this.props.recordingUrl.endsWith(".mp3") ? this.props.recordingUrl.slice(0, -4) : this.props.recordingUrl,
          r = this.props.peaks && this.props.peaks[0] && this.props.peaks[1] && [{
            name: "Customer",
            peaks: this.props.peaks[0],
            color: t.customer
          }, {
            name: "Agent",
            peaks: this.props.peaks[1],
            color: t.agent
          }],
          o = function o() {
            var t, o, i, a, d, h, g, y;
            return s.createElement(f.PlayerContainer, {
              noGrow: !0,
              noShrink: !0,
              hasFindings: u.FindingService.getInstance().canViewFindings()
            }, e.state.player && s.createElement(c.PlayPauseButton, {
              player: e.state.player
            }), s.createElement(f.WaveformContainer, null, s.createElement(l.Player, {
              ref: function ref(t) {
                e.setState({
                  player: t
                }), e.props.playerRef && e.props.playerRef(t);
              },
              recordingUrl: n,
              segments: (null === (t = e.props.segments) || void 0 === t ? void 0 : t.length) ? e.props.segments : void 0,
              currentSegment: e.props.segmentId,
              playbackRate: e.state.playbackRate,
              channels: r,
              options: {
                progressBackgroundColor: null === (o = e.props.theme) || void 0 === o ? void 0 : o.colors.base3,
                backgroundColor: null === (i = e.props.theme) || void 0 === i ? void 0 : i.colors.base1,
                cursorColor: null === (a = e.props.theme) || void 0 === a ? void 0 : a.colors.base10,
                timeline: {
                  primaryFontColor: null === (d = e.props.theme) || void 0 === d ? void 0 : d.calculated.textColor,
                  primaryColor: null === (h = e.props.theme) || void 0 === h ? void 0 : h.calculated.textColor,
                  secondaryFontColor: null === (g = e.props.theme) || void 0 === g ? void 0 : g.calculated.textColor,
                  secondaryColor: null === (y = e.props.theme) || void 0 === y ? void 0 : y.calculated.textColor
                }
              },
              onReady: e.handlePlayerReady,
              onError: e.handlePlayerError
            }, e.props.children, u.FindingService.getInstance().canViewFindings() && s.createElement(u.FindingsMarks, {
              onFindingClick: e.handleFindingClick,
              segmentId: e.props.segmentId
            }), s.createElement(u.SilencesAndCrosstalksMarks, {
              segmentId: e.props.segmentId
            }), s.createElement(m.SegmentMarks, {
              segments: e.props.segments,
              onMarkClick: e.props.onSegmentMarkClick
            }))), s.createElement(p.PlayerOptions, {
              player: e.state.player,
              recordingUrl: e.props.recordingUrl,
              segmentId: e.props.segmentId,
              playbackRate: e.state.playbackRate,
              onPlaybackRateChange: e.handlePlaybackRateChange
            }));
          };
        return this.props.sticky ? s.createElement(f.Sticky, null, o()) : o();
      }, t;
    }(s.PureComponent);
    t.PlayerImpl = _;
  }, function (e, t, n) {
    "use strict";

    var _r131,
      o = this && this.__extends || (_r131 = function r(e, t) {
        return (_r131 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r131(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PlayPauseButton = void 0;
    var s = n(1),
      l = n(7),
      c = n(64),
      u = n(29),
      p = n(16),
      d = n(14),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            isPlaying: t.props.player.isPlaying()
          }, t.handlePlay = function () {
            t.state.isPlaying || t.setState({
              isPlaying: !0
            });
          }, t.handlePause = function () {
            t.state.isPlaying && t.setState({
              isPlaying: !1
            });
          }, t.handleFinish = function () {
            t.handlePause();
          }, t.handlePlayPause = function () {
            return i(t, void 0, void 0, function () {
              var e;
              return a(this, function (t) {
                switch (t.label) {
                  case 0:
                    return t.trys.push([0, 5,, 6]), this.props.player.isPlaying() ? [4, this.props.player.pause()] : [3, 2];
                  case 1:
                    return t.sent(), [3, 4];
                  case 2:
                    return [4, this.props.player.play()];
                  case 3:
                    t.sent(), t.label = 4;
                  case 4:
                    return [3, 6];
                  case 5:
                    return e = t.sent(), l.ErrorManager.createAndProcessError(u.ErrorMessages.INSIGHTS_PLAYER_PLAYBACK_FAILED, {
                      description: "Error emitted upon clicking on the playpause button",
                      type: l.FlexErrorType.app,
                      context: "Player",
                      wrappedError: e
                    }), p.Notifications.showNotification(d.InsightsPlayerPlaybackFailed), [3, 6];
                  case 6:
                    return [2];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this.props.player.on("play", this.handlePlay), this.props.player.on("pause", this.handlePause), this.props.player.on("finish", this.handleFinish);
        }, t.prototype.componentWillUnmount = function () {
          this.props.player.off("play", this.handlePlay), this.props.player.off("pause", this.handlePause), this.props.player.off("finish", this.handleFinish);
        }, t.prototype.render = function () {
          return s.createElement(c.InsightsIconButton, {
            icon: this.state.isPlaying ? "Pause" : "Play",
            onClick: this.handlePlayPause
          });
        }, t;
      }(s.Component);
    t.PlayPauseButton = f;
  }, function (e, t, n) {
    "use strict";

    var _r132,
      o = this && this.__extends || (_r132 = function r(e, t) {
        return (_r132 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r132(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PlayerOptions = void 0;
    var s = n(22),
      l = n(0),
      c = n(1),
      u = n(21),
      p = n(5),
      d = n(14),
      f = n(64),
      h = n(63),
      m = n(9),
      g = n(13),
      y = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.wrapper = c.createRef(), t.state = {
            isPopoverOpen: !1
          }, t.copyToClipboard = function (e) {
            return i(t, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                switch (n.label) {
                  case 0:
                    return n.trys.push([0, 2,, 3]), [4, navigator.clipboard.writeText(e)];
                  case 1:
                    return n.sent(), [3, 3];
                  case 2:
                    return t = n.sent(), p.log.warn(t), l.Notifications.showNotification(d.CopyClipboardFailed, {
                      clipboardText: e
                    }), [3, 3];
                  case 3:
                    return [2];
                }
              });
            });
          }, t.handleOpen = function () {
            t.setState({
              isPopoverOpen: !0
            });
          }, t.handleClose = function () {
            t.setState({
              isPopoverOpen: !1
            });
          }, t.handleClick = function (e) {
            switch (e.currentTarget.id) {
              case "player-playback-rate-slow":
                t.props.onPlaybackRateChange("slow");
                break;
              case "player-playback-rate-normal":
                t.props.onPlaybackRateChange("normal");
                break;
              case "player-playback-rate-fast":
                t.props.onPlaybackRateChange("fast");
                break;
              case "player-playback-rate-very-fast":
                t.props.onPlaybackRateChange("very_fast");
                break;
              case "player-copy-link":
                t.copyToClipboard(t.getLinkBaseUrl());
                break;
              case "player-copy-link-with-time":
                var n = new URL(t.getLinkBaseUrl()),
                  r = t.props.player && t.props.player.getCurrentTime() || 0;
                n.searchParams.set("timeFrom", r.toString()), t.copyToClipboard(n.toString());
                break;
              case "player-copy-download-link":
                t.copyToClipboard(t.props.recordingUrl);
            }
            t.handleClose();
          }, t;
        }
        return o(t, e), t.prototype.getLinkBaseUrl = function () {
          return m.getRedirectServiceApi(g.Manager.getInstance().configuration, g.Manager.getInstance().serviceConfiguration.account_sid) + "/segments/" + this.props.segmentId;
        }, t.prototype.render = function () {
          return c.createElement("div", {
            ref: this.wrapper,
            style: {
              display: "flex",
              alignItems: "center"
            }
          }, c.createElement(f.InsightsIconButton, {
            key: "options-button",
            icon: "More",
            onClick: this.handleOpen,
            className: this.state.isPopoverOpen ? "active" : void 0
          }), c.createElement(s.Popover, {
            open: this.state.isPopoverOpen,
            onClose: this.handleClose,
            anchorEl: this.wrapper.current,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "right"
            }
          }, c.createElement(h.PopoverWrapper, null, c.createElement(s.List, {
            subheader: c.createElement(h.ThemedListSubheader, null, "Speed")
          }, c.createElement(h.ThemedListItem, {
            id: "player-playback-rate-slow",
            onClick: this.handleClick
          }, l.templates.PlayerOptionSpeedSlow(), " ", "slow" === this.props.playbackRate && c.createElement(h.ThemedIcon, {
            icon: "Accept"
          })), c.createElement(h.ThemedListItem, {
            id: "player-playback-rate-normal",
            onClick: this.handleClick
          }, l.templates.PlayerOptionSpeedNormal(), " ", "normal" === this.props.playbackRate && c.createElement(h.ThemedIcon, {
            icon: "Accept"
          })), c.createElement(h.ThemedListItem, {
            id: "player-playback-rate-fast",
            onClick: this.handleClick
          }, l.templates.PlayerOptionSpeedFast(), " ", "fast" === this.props.playbackRate && c.createElement(h.ThemedIcon, {
            icon: "Accept"
          })), c.createElement(h.ThemedListItem, {
            id: "player-playback-rate-very-fast",
            onClick: this.handleClick
          }, l.templates.PlayerOptionSpeedVeryFast(), " ", "very_fast" === this.props.playbackRate && c.createElement(h.ThemedIcon, {
            icon: "Accept"
          }))), c.createElement(h.PopoverDivider, null), c.createElement(s.List, {
            subheader: c.createElement(h.ThemedListSubheader, null, "Share")
          }, c.createElement(h.ThemedListItem, {
            id: "player-copy-link",
            onClick: this.handleClick
          }, l.templates.PlayerOptionCopyLink(), " "), c.createElement(h.ThemedListItem, {
            id: "player-copy-link-with-time",
            onClick: this.handleClick
          }, l.templates.PlayerOptionCurrentPosition(), " "), u.InsightsService.hasPermission(u.InsightsPermission.Player.CopyDownloadLink) && c.createElement(h.ThemedListItem, {
            id: "player-copy-download-link",
            onClick: this.handleClick
          }, l.templates.PlayerOptionDownloadLink(), " ")))));
        }, t;
      }(c.PureComponent);
    t.PlayerOptions = y;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PlaybackUnavailable = void 0;
    var o,
      i = n(1),
      a = n(0),
      s = n(2).default("div")(o || (o = r(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex: 1;\n    flex-direction: column;\n    min-height: 68px;\n\n    > div:first-child {\n        font-weight: bold;\n    }\n\n    > div {\n        display: flex;\n        align-items: center;\n    }\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex: 1;\n    flex-direction: column;\n    min-height: 68px;\n\n    > div:first-child {\n        font-weight: bold;\n    }\n\n    > div {\n        display: flex;\n        align-items: center;\n    }\n"])));
    t.PlaybackUnavailable = function () {
      return i.createElement(s, null, i.createElement("div", null, i.createElement(a.Icon, {
        icon: "Error"
      }), i.createElement(a.Template, {
        source: a.templates.InsightsPlayerPlaybackUnavailable
      })), i.createElement("div", null, i.createElement(a.Icon, {
        icon: "AcceptLarge"
      }), i.createElement(a.Template, {
        source: a.templates.InsightsPlayerPlaybackUnavailableSubtitle
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var _r133,
      o = this && this.__extends || (_r133 = function r(e, t) {
        return (_r133 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r133(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SegmentMarks = void 0;
    var i = n(1),
      a = n(506),
      s = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props.segments;
          return t && t.length > 0 ? t.reduce(function (n, r, o) {
            return 0 !== o && n.push(i.createElement(a.SegmentMarker, {
              key: "start" + r.id,
              mark: {
                segmentId: r.id,
                agentName: r.agentName,
                segmentStart: !0,
                offset: r.offset
              },
              onClick: e.props.onMarkClick
            })), o !== t.length - 1 && n.push(i.createElement(a.SegmentMarker, {
              key: "end" + r.id,
              mark: {
                segmentId: r.id,
                agentName: r.agentName,
                segmentStart: !1,
                offset: r.offset + r.duration
              },
              onClick: e.props.onMarkClick
            })), n;
          }, []) : null;
        }, t;
      }(i.Component);
    t.SegmentMarks = s;
  }, function (e, t, n) {
    "use strict";

    var _r134,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r134 = function r(e, t) {
        return (_r134 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r134(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SegmentMarker = void 0;
    var s,
      l = n(1),
      c = n(50),
      u = n(2),
      p = u.default("div", {
        shouldForwardProp: function shouldForwardProp(e) {
          return "color" !== e;
        }
      })(s || (s = o(["\n    width: 16px;\n    height: 20px;\n    cursor: pointer;\n    pointer-events: auto;\n    text-align: center;\n    line-height: 1;\n    font-size: 12px;\n    color: ", ';\n    transform: translateX(-50%);\n\n    &:after {\n        content: "";\n        display: block;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 15px 8px 0 8px;\n        border-color: ', ";\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: -1;\n    }\n"], ["\n    width: 16px;\n    height: 20px;\n    cursor: pointer;\n    pointer-events: auto;\n    text-align: center;\n    line-height: 1;\n    font-size: 12px;\n    color: ", ';\n    transform: translateX(-50%);\n\n    &:after {\n        content: "";\n        display: block;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 15px 8px 0 8px;\n        border-color: ', ";\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: -1;\n    }\n"])), function (e) {
        return e.contrastColor;
      }, function (e) {
        return e.color + " transparent transparent transparent;";
      }),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleClick = function (e) {
            t.props.onClick(t.props.mark.segmentId);
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.mark,
            n = e.theme,
            r = (null == n ? void 0 : n.colors.base10) || "#222222";
          return l.createElement(c.Mark, {
            offset: t.offset
          }, l.createElement(p, {
            color: t.segmentStart ? r : "#c80000",
            contrastColor: (null == n ? void 0 : n.colors.base1) || "#ffffff",
            onClick: this.handleClick,
            title: t.agentName + " " + (t.segmentStart ? "joined" : "left")
          }, t.segmentStart ? "+" : "-"));
        }, t = a([u.withTheme], t);
      }(l.PureComponent);
    t.SegmentMarker = d;
  }, function (e, t, n) {
    "use strict";

    var _r135,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r135 = function r(e, t) {
        return (_r135 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r135(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SegmentInfoImpl = t.Content = t.displayName = void 0;
    var s = n(22),
      l = n(0),
      c = n(1),
      u = n(21),
      p = n(2),
      d = n(508),
      f = n(226),
      h = n(64),
      m = n(63),
      g = n(510),
      y = p.default("div")(b || (b = o(["\n    padding: 16px;\n    width: 240px;\n    box-sizing: border-box;\n    background: ", ";\n    border: 1px solid ", ";\n"], ["\n    padding: 16px;\n    width: 240px;\n    box-sizing: border-box;\n    background: ", ";\n    border: 1px solid ", ";\n"])), function (e) {
        return e.theme.colors.base1;
      }, function (e) {
        return e.theme.colors.base4;
      }),
      v = p.default("div")(C || (C = o(["\n    padding: 16px;\n    box-sizing: border-box;\n    background: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n"], ["\n    padding: 16px;\n    box-sizing: border-box;\n    background: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n"])), function (e) {
        return e.theme.colors.base1;
      }, function (e) {
        return e.theme.colors.base4;
      }, function (e) {
        return e.theme.calculated.textColor;
      });
    t.displayName = "SegmentInfo", t.Content = new l.DynamicContentStore(t.displayName);
    var b,
      C,
      _ = function (e) {
        function n() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.commentButtonRef = c.createRef(), t.assessButtonRef = c.createRef(), t.state = {
            isAssessPopoverOpen: !1,
            isCommentPopoverOpen: !1
          }, t.closeCommentPopover = function () {
            t.setState({
              isCommentPopoverOpen: !1
            });
          }, t.openCommentPopover = function () {
            t.setState({
              isCommentPopoverOpen: !0
            });
          }, t.closeAssessPopover = function () {
            t.setState({
              isAssessPopoverOpen: !1
            });
          }, t.openAssessPopover = function () {
            t.setState({
              isAssessPopoverOpen: !0
            });
          }, t;
        }
        return i(n, e), n.prototype.render = function () {
          var e = this.props,
            n = e.children,
            r = e.hideCommentAndAssess,
            o = a(e, ["children", "hideCommentAndAssess"]),
            i = new Date(this.props.timestamp);
          return c.createElement(l.DynamicComponent, {
            name: t.displayName,
            contentStore: t.Content,
            childProps: o,
            customChildren: n,
            noContainers: !0
          }, c.createElement(m.SegmentInfoContainer, {
            noGrow: !0,
            noShrink: !0
          }, !r && u.InsightsService.hasPermission(u.InsightsPermission.Comment.Add) && c.createElement("div", {
            key: "comment-button-section",
            ref: this.commentButtonRef
          }, c.createElement(h.InsightsButton, {
            key: "comment-button",
            roundCorners: !0,
            onClick: this.openCommentPopover,
            "data-test": "SegmentInfo-CommentButton",
            disabled: !this.props.canCommentAndAssess
          }, c.createElement(l.Template, {
            source: l.templates.ConversationInfoCommentButton
          })), c.createElement(s.Popover, {
            key: "comments-popover",
            open: this.state.isCommentPopoverOpen,
            onClose: this.closeCommentPopover,
            anchorEl: this.commentButtonRef.current,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left"
            }
          }, c.createElement(y, {
            "data-test": "SegmentInfo-CommentPopup"
          }, c.createElement(d.CommentForm, {
            updateComment: function updateComment() {},
            onSubmit: this.closeCommentPopover,
            segmentId: this.props.segmentId
          })))), !r && u.InsightsService.hasPermission(u.InsightsPermission.Assessment.Add) && c.createElement("div", {
            key: "assess-button-section",
            ref: this.assessButtonRef
          }, c.createElement(h.InsightsButton, {
            key: "assess-button",
            roundCorners: !0,
            onClick: this.openAssessPopover,
            "data-test": "SegmentInfo-AssessButton",
            disabled: !this.props.canCommentAndAssess
          }, c.createElement(l.Template, {
            source: l.templates.ConversationInfoAssessButton
          })), c.createElement(s.Popover, {
            key: "assess-popover",
            open: this.state.isAssessPopoverOpen,
            onClose: this.closeAssessPopover,
            anchorEl: this.assessButtonRef.current,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left"
            }
          }, c.createElement(v, {
            "data-test": "SegmentInfo-AssessPopup"
          }, c.createElement(f.AssessPanelContent, null)))), c.createElement("div", {
            key: "timestamp",
            style: {
              display: "flex",
              alignItems: "baseline"
            },
            "data-test": "SegmentInfo-Timestamp"
          }, c.createElement("span", null, i.toLocaleString())), c.createElement(g.SegmentsSelector, {
            key: "segments-selector",
            segments: this.props.segments,
            currentSegment: this.props.segmentId,
            onSegmentSelect: this.props.onSegmentSelect
          })));
        }, n.defaultProps = {
          hideCommentAndAssess: !1
        }, n;
      }(c.PureComponent);
    t.SegmentInfoImpl = _;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CommentForm = void 0;
    var r = n(3),
      o = n(144),
      i = n(509),
      a = n(118);
    t.CommentForm = r.connect(function (e) {
      return {
        commentCategories: e.insights.assessmentSettings ? e.insights.assessmentSettings.comments.categories : [],
        submitComment: function submitComment(e, t, n, r) {
          return o.QuestionnaireService.getInstance().submitComment(e, {
            category_id: n,
            category_name: r,
            comment: t
          });
        }
      };
    }, function (e) {
      return {
        updateComment: function updateComment(t) {
          return e({
            type: a.COMMENTS_ADD,
            payload: t
          });
        }
      };
    })(i.CommentFormImpl);
  }, function (e, t, n) {
    "use strict";

    var _r136,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r136 = function r(e, t) {
        return (_r136 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r136(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CommentFormImpl = t.CommentInput = void 0;
    var l = n(1),
      c = n(22),
      u = n(2),
      p = n(64),
      d = n(0),
      f = n(14),
      h = u.default("div")(y || (y = o(["\n    display: flex;\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex-direction: column;\n"]))),
      m = u.default("div")(v || (v = o(["\n    font-size: 12px;\n    line-height: 16px;\n    margin-bottom: 4px;\n    color: ", ";\n"], ["\n    font-size: 12px;\n    line-height: 16px;\n    margin-bottom: 4px;\n    color: ", ";\n"])), function (e) {
        return e.theme.calculated.textColor;
      }),
      g = u.default("div")(b || (b = o(["\n    margin-bottom: 16px;\n"], ["\n    margin-bottom: 16px;\n"])));
    t.CommentInput = u.default("textarea")(C || (C = o(["\n    padding: 8px;\n    font-size: 12px;\n    border-color: ", ";\n    box-sizing: border-box;\n    width: 100%;\n    height: 85px;\n    background: ", ";\n    color: ", ";\n"], ["\n    padding: 8px;\n    font-size: 12px;\n    border-color: ", ";\n    box-sizing: border-box;\n    width: 100%;\n    height: 85px;\n    background: ", ";\n    color: ", ";\n"])), function (e) {
      return e.theme.colors.base4;
    }, function (e) {
      return e.theme.colors.base1;
    }, function (e) {
      return e.theme.calculated.textColor;
    });
    var y,
      v,
      b,
      C,
      _,
      k = u.default(p.InsightsButton)(_ || (_ = o(["\n    width: 100px;\n    height: 32px;\n    align-self: flex-end;\n    margin-top: -8px;\n    ", ";\n"], ["\n    width: 100px;\n    height: 32px;\n    align-self: flex-end;\n    margin-top: -8px;\n    ", ";\n"])), function (e) {
        return e.disabled && "pointer-events: none";
      }),
      w = function (e) {
        function n() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            value: "",
            selectedCategory: "",
            submitting: !1
          }, t.onChange = function (e) {
            t.setState({
              value: e.target.value
            });
          }, t.onCategorySelect = function (e) {
            t.setState({
              selectedCategory: e.target.value
            });
          }, t.onSubmit = function () {
            return a(t, void 0, void 0, function () {
              var e,
                t,
                n = this;
              return s(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (e = this.props.commentCategories.find(function (e) {
                      return e.id === n.state.selectedCategory;
                    }), !(this.props.segmentId && e && this.state.value && this.state.value.trim().length)) return [3, 5];
                    r.label = 1;
                  case 1:
                    return r.trys.push([1, 3,, 4]), this.setState({
                      submitting: !0
                    }), [4, this.props.submitComment(this.props.segmentId, this.state.value, e.id, e.name)];
                  case 2:
                    return t = r.sent(), this.props.updateComment(t), this.setState({
                      value: "",
                      selectedCategory: ""
                    }), this.props.onSubmit(), [3, 4];
                  case 3:
                    return r.sent(), d.Notifications.showNotification(f.AddingCommentFailed), [3, 4];
                  case 4:
                    this.setState({
                      submitting: !1
                    }), r.label = 5;
                  case 5:
                    return [2];
                }
              });
            });
          }, t;
        }
        return i(n, e), n.getDerivedStateFromProps = function (e, t) {
          if (!t.selectedCategory && e.commentCategories.length) {
            var n = e.commentCategories.find(function (e) {
              return !!e.default;
            });
            if (n) return {
              selectedCategory: n.id
            };
          }
          return t;
        }, n.prototype.render = function () {
          return l.createElement(h, null, l.createElement(g, null, l.createElement(m, null, l.createElement(d.Template, {
            source: d.templates.ConversationCommentFormCategory
          })), l.createElement(c.Select, {
            value: this.state.selectedCategory,
            onChange: this.onCategorySelect,
            style: {
              width: "100%"
            },
            "data-test": "CommentForm-CategorySelector"
          }, this.props.commentCategories.map(function (e) {
            return l.createElement(c.MenuItem, {
              value: e.id,
              key: e.id
            }, e.name);
          }))), l.createElement(g, null, l.createElement(m, null, l.createElement(d.Template, {
            source: d.templates.ConversationCommentFormCommentLabel
          })), l.createElement(t.CommentInput, {
            onChange: this.onChange,
            value: this.state.value,
            placeholder: d.templates.ConversationCommentInputPlaceholder(),
            "data-test": "CommentForm-Textarea"
          })), l.createElement(k, {
            type: "submit",
            onClick: this.onSubmit,
            primary: !0,
            "data-test": "CommentForm-SubmitBtn",
            disabled: !!this.state.submitting || !(this.state.value && this.state.value.trim().length)
          }, this.state.submitting ? l.createElement(c.CircularProgress, {
            size: 15,
            color: "inherit"
          }) : d.templates.ConversationCommentSaveButton()));
        }, n;
      }(l.PureComponent);
    t.CommentFormImpl = w;
  }, function (e, t, n) {
    "use strict";

    var _r137,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r137 = function r(e, t) {
        return (_r137 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r137(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SegmentsSelector = void 0;
    var a,
      s,
      l,
      c = n(0),
      u = n(50),
      p = n(1),
      d = n(64),
      f = c.styled("div")(a || (a = o(["\n    display: flex;\n    align-items: baseline;\n    margin-left: auto;\n"], ["\n    display: flex;\n    align-items: baseline;\n    margin-left: auto;\n"]))),
      h = c.styled("div")(s || (s = o(["\n    margin-left: 9px;\n"], ["\n    margin-left: 9px;\n"]))),
      m = c.styled(d.InsightsButton)(l || (l = o(["\n    display: inline-block;\n    border-radius: 0;\n    margin: -2px 0 0 -1px;\n    width: auto;\n    min-width: 0;\n\n    &:first-child {\n        border-top-left-radius: 3px;\n        border-bottom-left-radius: 3px;\n        border-left-width: 1px;\n        margin-left: -1px;\n    }\n\n    &:last-child {\n        border-top-right-radius: 3px;\n        border-bottom-right-radius: 3px;\n    }\n\n    &.active {\n        background-color: ", ";\n        cursor: default !important;\n    }\n"], ["\n    display: inline-block;\n    border-radius: 0;\n    margin: -2px 0 0 -1px;\n    width: auto;\n    min-width: 0;\n\n    &:first-child {\n        border-top-left-radius: 3px;\n        border-bottom-left-radius: 3px;\n        border-left-width: 1px;\n        margin-left: -1px;\n    }\n\n    &:last-child {\n        border-top-right-radius: 3px;\n        border-bottom-right-radius: 3px;\n    }\n\n    &.active {\n        background-color: ", ";\n        cursor: default !important;\n    }\n"])), function (e) {
        return e.theme.colors.base3;
      }),
      g = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleClick = function (e) {
            var n = e.currentTarget.getAttribute("data-segment-id");
            n && n !== t.props.currentSegment && t.props.onSegmentSelect(n);
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this;
          return p.createElement(f, {
            "data-test": "SegmentSelector"
          }, this.props.segments.length > 0 && p.createElement("div", null, p.createElement(c.Template, {
            source: c.templates.SegmentSelectorLabel
          }), " "), p.createElement(h, null, this.props.segments.map(function (t) {
            return p.createElement(m, {
              key: t.id,
              "data-segment-id": t.id,
              className: t.id === e.props.currentSegment ? "active" : "",
              onClick: e.handleClick
            }, t.duration ? u.defaultTimeFormatter(t.duration) : "--:--");
          })));
        }, t;
      }(p.PureComponent);
    t.SegmentsSelector = g;
  }, function (e, t, n) {
    "use strict";

    var _r138,
      o = this && this.__extends || (_r138 = function r(e, t) {
        return (_r138 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r138(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GlobalSLForm = t.GlobalSLFormImpl = void 0;
    var a = n(1),
      s = n(30),
      l = n(81),
      c = n(0),
      u = n(513),
      p = n(3),
      d = n(55),
      f = n(522),
      h = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.isFormValid = function () {
            return !(!n.state.form.selectedTime || !n.state.form.selectedTimezone) && (0 === n.state.form.shortAbandonedThreshold || n.state.form.serviceLevelThreshold > n.state.form.shortAbandonedThreshold);
          }, n.onSave = function () {
            n.setState({
              dialogOpen: !0
            });
          }, n.handleFieldChange = function (e, t) {
            var r;
            n.setState({
              form: i(i({}, n.state.form), (r = {}, r[e] = t, r))
            });
          }, n.onDialogClose = function () {
            n._isMounted && n.setState({
              dialogOpen: !1
            });
          }, n.onCancel = function () {
            return c.Actions.invokeAction("HistoryGo", -1);
          }, n.state = {
            dialogOpen: !1,
            form: {
              selectedTime: t.dailyReset || "",
              selectedTimezone: t.timezone || "",
              serviceLevelThreshold: t.serviceLevelThreshold || 0,
              shortAbandonedThreshold: t.shortAbandonedThreshold || 0
            }
          }, n;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this._isMounted = !0;
        }, t.prototype.componentWillUnmount = function () {
          this._isMounted = !1;
        }, t.prototype.render = function () {
          return a.createElement(s.Page, null, a.createElement(s.PageHeader, {
            renderTitle: function renderTitle() {
              return a.createElement(l.Template, {
                source: l.templates.SLAGlobalPageTitle
              });
            },
            renderSubtitle: function renderSubtitle() {
              return a.createElement(l.Template, {
                source: l.templates.SLAGlobalPageSubtitle
              });
            }
          }), a.createElement(s.PageContent, null, a.createElement(f.GlobalSLFormContent, {
            form: this.state.form,
            handleChange: this.handleFieldChange
          })), a.createElement(s.PageFooter, {
            onCancel: this.onCancel,
            onSave: this.onSave,
            saveDisabled: !this.isFormValid()
          }), a.createElement(u.ConfirmGlobalSLDialog, {
            open: this.state.dialogOpen,
            onClose: this.onDialogClose,
            dailyReset: this.state.form.selectedTime || "",
            timezone: this.state.form.selectedTimezone || "",
            serviceLevelThreshold: this.state.form.serviceLevelThreshold || 0,
            shortAbandonedThreshold: this.state.form.shortAbandonedThreshold || 0
          }));
        }, t;
      }(a.PureComponent);
    t.GlobalSLFormImpl = h, t.GlobalSLForm = p.connect(d.globalSLConfigSelector)(h);
  }, function (e, t) {
    e.exports = require("react-select");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConfirmGlobalSLDialog = void 0;
    var a,
      s,
      l,
      c = n(1),
      u = n(514),
      p = n(2),
      d = n(51),
      f = n(4),
      h = n(235),
      m = n(5),
      g = n(0),
      y = n(16),
      v = n(102),
      b = n(103),
      C = p.default("div")(a || (a = r(["\n    border-radius: 4px;\n    padding: 18px 8px;\n    border: 1px solid ", ";\n    margin: 24px 0;\n    display: flex;\n    justify-content: space-between;\n\n    & > * {\n        padding: 0 8px;\n    }\n"], ["\n    border-radius: 4px;\n    padding: 18px 8px;\n    border: 1px solid ", ";\n    margin: 24px 0;\n    display: flex;\n    justify-content: space-between;\n\n    & > * {\n        padding: 0 8px;\n    }\n"])), function (e) {
        return e.theme.colors.base5;
      }),
      _ = p.default("p")(s || (s = r(["\n    font-weight: bold;\n"], ["\n    font-weight: bold;\n"]))),
      k = p.default("div")(l || (l = r(["\n    margin-top: 1em;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n\n    .Twilio-Icon {\n        margin-right: 4px;\n        margin-left: -4px;\n        color: ", ";\n    }\n"], ["\n    margin-top: 1em;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n\n    .Twilio-Icon {\n        margin-right: 4px;\n        margin-left: -4px;\n        color: ", ";\n    }\n"])), function (e) {
        return e.theme.colors.errorColor;
      });
    t.ConfirmGlobalSLDialog = function (e) {
      var t = e.timezone && b.timezones.find(function (t) {
          return t.value === e.timezone;
        }),
        n = d.shortTimeCurrentLocaleFormatter(e.dailyReset) + " - " + (t ? t.label : "unknown");
      return c.createElement(u.ConfirmableDialogWithAsyncOperation, {
        onConfirm: function onConfirm() {
          return o(void 0, void 0, void 0, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return n.trys.push([0, 2,, 3]), [4, h.SLAPreferencesService.updateDefaultSLAPreferences({
                    service_level_threshold: e.serviceLevelThreshold,
                    short_abandoned_threshold: e.shortAbandonedThreshold,
                    reset_time: e.dailyReset,
                    reset_timezone: e.timezone
                  })];
                case 1:
                  return n.sent(), g.Actions.invokeAction("HistoryPush", v.SLAPreferencesHomePage.path), g.Notifications.showNotification(y.NotificationIds.GlobalSLSaveSuccess), [3, 3];
                case 2:
                  throw t = n.sent(), m.log.error(t), new Error(f.templates.GlobalSLConfirmDialogError());
                case 3:
                  return [2];
              }
            });
          });
        },
        title: f.templates.GlobalSLConfirmDialogTitle(),
        onClose: e.onClose,
        open: e.open
      }, c.createElement("p", null, c.createElement(f.Template, {
        source: f.templates.GlobalSLConfirmDialogAllQueues
      })), c.createElement(C, null, c.createElement("div", {
        "data-test": "ConfirmGlobalSL-dailyResetValue"
      }, c.createElement(_, null, f.templates.SLADailyMetricsResetTitle()), c.createElement("p", null, n)), c.createElement("div", {
        "data-test": "ConfirmGlobalSL-serviceThresholdValue"
      }, c.createElement(_, null, f.templates.SLATitle()), c.createElement("p", null, f.templates.TimeSecondsFormatter({
        time: e.serviceLevelThreshold
      }))), c.createElement("div", {
        "data-test": "ConfirmGlobalSL-shortAbandonedValue"
      }, c.createElement(_, null, f.templates.SLAShortAbandonsTitle()), c.createElement("p", null, f.templates.TimeSecondsFormatter({
        time: e.shortAbandonedThreshold
      })))), c.createElement("p", null, c.createElement(f.Template, {
        source: f.templates.GlobalSLConfirmDialogResetTimeInfo,
        time: n
      })), c.createElement("p", null, c.createElement(f.Template, {
        source: f.templates.GlobalSLConfirmDialogAllConversations
      })), c.createElement(k, null, c.createElement(g.Icon, {
        icon: "Alert"
      }), c.createElement(f.Template, {
        source: f.templates.GlobalSLConfirmDialogWarning
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var _r139,
      o = this && this.__extends || (_r139 = function r(e, t) {
        return (_r139 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r139(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConfirmableDialogWithAsyncOperation = void 0;
    var s = n(1),
      l = n(22),
      c = n(30),
      u = n(0),
      p = n(4),
      d = l.withStyles(function (e) {
        return {
          paper: {
            background: e.calculated.lightTheme ? e.colors.base0 : e.colors.base2,
            color: e.calculated.textColor,
            maxWidth: "674px"
          }
        };
      })(l.Dialog),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            isSaving: !1
          }, t.onCancel = function () {
            t.state.isSaving || (t.setState({
              isSaving: !1,
              error: void 0
            }), t.props.onClose());
          }, t.onSave = function () {
            return i(t, void 0, void 0, function () {
              var e;
              return a(this, function (t) {
                switch (t.label) {
                  case 0:
                    this.setState({
                      isSaving: !0,
                      error: void 0
                    }), t.label = 1;
                  case 1:
                    return t.trys.push([1, 3,, 4]), [4, this.props.onConfirm()];
                  case 2:
                    return t.sent(), this.props.onClose(), [3, 4];
                  case 3:
                    return e = t.sent(), this.setState({
                      error: e
                    }), [3, 4];
                  case 4:
                    return this._isMounted && this.setState({
                      isSaving: !1
                    }), [2];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this._isMounted = !0;
        }, t.prototype.componentWillUnmount = function () {
          this._isMounted = !1;
        }, t.prototype.render = function () {
          return s.createElement(d, {
            open: this.props.open,
            onBackdropClick: this.onCancel,
            onEscapeKeyDown: this.onCancel
          }, s.createElement(c.DialogHeader, null, s.createElement(c.SectionTitle, null, this.props.title), s.createElement(u.IconButton, {
            icon: "CloseLarge",
            onClick: this.onCancel
          })), s.createElement(c.DialogContent, null, this.state.error && s.createElement(c.DialogError, null, this.state.error.message), this.props.children), s.createElement(c.DialogFooter, null, s.createElement(c.FooterButtons, null, s.createElement(c.Button, {
            secondary: !0,
            onClick: this.onCancel,
            disabled: this.state.isSaving,
            "data-test": "ConfirmableDialog-CancelButton"
          }, this.props.cancelButtonTitle || p.templates.ConfirmableDialogCancelButton()), s.createElement(c.ButtonWithProgress, {
            onClick: this.onSave,
            disabled: this.state.isSaving,
            isProgressing: this.state.isSaving,
            "data-test": "ConfirmableDialog-ConfirmButton"
          }, this.props.confirmButtonTitle || p.templates.ConfirmableDialogConfirmButton()))));
        }, t;
      }(s.PureComponent);
    t.ConfirmableDialogWithAsyncOperation = f;
  }, function (e, t, n) {
    "use strict";

    var _r140,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r140 = function r(e, t) {
        return (_r140 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r140(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GlobalSLMetricsTiles = t.GlobalSLMetricsTilesImpl = void 0;
    var a,
      s,
      l = n(1),
      c = n(0),
      u = n(3),
      p = n(4),
      d = n(2),
      f = n(55),
      h = n(51),
      m = n(103),
      g = d.default("div")(a || (a = o(["\n    display: flex;\n    margin: 0 -8px;\n"], ["\n    display: flex;\n    margin: 0 -8px;\n"]))),
      y = d.default("div")(s || (s = o(["\n    flex: 1;\n    margin: 8px;\n"], ["\n    flex: 1;\n    margin: 8px;\n"]))),
      v = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this,
            t = m.timezones.find(function (t) {
              return t.value === e.props.timezone;
            });
          return l.createElement(g, null, l.createElement(y, {
            "data-test": "SLA_GlobalServiceLevels_DailyMetricsResetTile"
          }, l.createElement(c.AggregatedDataTile, {
            title: p.templates.SLADailyMetricsResetTitle({
              timezone: t ? t.label : ""
            }),
            content: h.shortTimeCurrentLocaleFormatter(this.props.dailyReset)
          })), l.createElement(y, {
            "data-test": "SLA_GlobalServiceLevels_ServiceLevelThresholdTile"
          }, l.createElement(c.AggregatedDataTile, {
            title: p.templates.SLATitle(),
            content: p.templates.TimeSecondsFormatter({
              time: this.props.serviceLevelThreshold
            })
          })), l.createElement(y, {
            "data-test": "SLA_GlobalServiceLevels_ShortAbandonsTile"
          }, l.createElement(c.AggregatedDataTile, {
            title: p.templates.SLAShortAbandonsTitle(),
            content: p.templates.TimeSecondsFormatter({
              time: this.props.shortAbandonedThreshold
            })
          })));
        }, t;
      }(l.PureComponent);
    t.GlobalSLMetricsTilesImpl = v, t.GlobalSLMetricsTiles = u.connect(f.globalSLConfigSelector)(v);
  }, function (e, t, n) {
    "use strict";

    var _r141,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r141 = function r(e, t) {
        return (_r141 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r141(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SLAQueuesList = t.SLAQueuesListImpl = void 0;
    var a,
      s,
      l,
      c,
      u,
      p = n(1),
      d = n(0),
      f = n(25),
      h = n(55),
      m = n(3),
      g = n(2),
      y = n(51),
      v = n(103),
      b = g.default("div")(a || (a = o(["\n    > table th:first-child {\n        padding-left: 6px;\n    }\n"], ["\n    > table th:first-child {\n        padding-left: 6px;\n    }\n"]))),
      C = g.default("span")(s || (s = o(["\n    display: flex;\n    align-items: center;\n    .Twilio-Icon {\n        display: inline-block;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    .Twilio-Icon {\n        display: inline-block;\n    }\n"]))),
      _ = g.default("div")(l || (l = o(["\n    text-align: center;\n"], ["\n    text-align: center;\n"]))),
      k = g.default("div")(c || (c = o(["\n    display: flex;\n    align-items: center;\n    color: ", ";\n\n    .Twilio-Icon {\n        display: inline-block;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    color: ", ";\n\n    .Twilio-Icon {\n        display: inline-block;\n    }\n"])), function (e) {
        return e.theme.colors.errorColor;
      }),
      w = g.default("span")(u || (u = o(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))),
      S = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.handleRowClick = function (e) {
            n.props.onEditQueue(e.sid);
          }, n.props.hasFetched || f.Actions.fetchMetadata(), n;
        }
        return i(t, e), t.prototype.renderDailyMetricsReset = function (e, t) {
          var n = this.props.queueConfigurations.find(function (t) {
            return t.queue_sid === e;
          });
          if (n) {
            var r = v.timezones.find(function (e) {
              return e.value === n.reset_timezone;
            });
            return p.createElement(C, {
              "data-queue-name": t
            }, p.createElement(d.Icon, {
              icon: "Edit"
            }), y.shortTimeCurrentLocaleFormatter(n.reset_time) + " - " + (r ? r.label : n.reset_timezone));
          }
          return p.createElement("span", {
            "data-queue-name": t
          }, p.createElement(d.Template, {
            source: d.templates.SLAPreferencesDefaultSettingsIndicator
          }));
        }, t.prototype.renderChannelServiceLevels = function (e, t) {
          var n = this,
            r = this.props.channelConfigurations.filter(function (t) {
              return t.queue_sid === e;
            });
          return r.length > 0 ? p.createElement(C, {
            "data-queue-name": t
          }, p.createElement(d.Icon, {
            icon: "Edit"
          }), p.createElement(w, {
            "data-test": "Custom-Channel-Service-Level-List"
          }, p.createElement(d.Template, {
            source: d.templates.SLAPreferencesCustomSettingsIndicator
          }), " - " + r.length + "/" + this.props.channelSids.length + " - ", r.map(function (e) {
            return n.props.channelsBySid[e.channel_sid].friendly_name;
          }).join(", "))) : p.createElement("span", {
            "data-queue-name": t
          }, p.createElement(d.Template, {
            source: d.templates.SLAPreferencesDefaultSettingsIndicator
          }));
        }, t.prototype.render = function () {
          var e = this;
          return this.props.error ? p.createElement(k, null, p.createElement(d.Icon, {
            icon: "Error"
          }), p.createElement(d.Template, {
            source: d.templates.SLAPreferencesCustomLevelsError
          })) : this.props.hasFetched ? p.createElement(b, {
            "data-test": "SLA_CustomSLQueuesTable"
          }, p.createElement(d.DataTable, {
            items: this.props.queues,
            onRowClick: this.handleRowClick
          }, p.createElement(d.ColumnDefinition, {
            key: "friendly-name",
            name: "Friendly-Name",
            header: p.createElement(d.Template, {
              source: d.templates.SLAPreferencesQueueNameColumn
            }),
            content: function content(e) {
              return p.createElement("span", {
                "data-queue-name": e.friendly_name
              }, e.friendly_name);
            }
          }), p.createElement(d.ColumnDefinition, {
            key: "daily-metrics-reset",
            name: "Daily-Metrics-Reset",
            header: p.createElement(d.Template, {
              source: d.templates.SLAPreferencesMetricsResetColumn
            }),
            content: function content(t) {
              return e.renderDailyMetricsReset(t.sid, t.friendly_name);
            }
          }), p.createElement(d.ColumnDefinition, {
            key: "channel-service-levels",
            name: "Channel-Service-Levels",
            header: p.createElement(d.Template, {
              source: d.templates.SLAPreferencesChannelLevelsColumn
            }),
            content: function content(t) {
              return e.renderChannelServiceLevels(t.sid, t.friendly_name);
            }
          }))) : p.createElement(_, null, p.createElement(d.CircularProgress, {
            size: 40,
            borderWidth: 2,
            animating: !0
          }));
        }, t;
      }(p.Component);
    t.SLAQueuesListImpl = S, t.SLAQueuesList = m.connect(function (e) {
      return {
        hasFetched: e.realtimeQueues.metadata.hasFetched,
        error: e.realtimeQueues.metadata.error,
        queues: h.queuesMetadataListSelector(e),
        channelsBySid: e.realtimeQueues.metadata.channelsBySid,
        channelSids: e.realtimeQueues.metadata.channelSids,
        queueConfigurations: e.realtimeQueues.queuesConfig.queue_configurations || [],
        channelConfigurations: h.validQueueChannelConfigurationsSelector(e)
      };
    })(S);
  }, function (e, t, n) {
    "use strict";

    var _r142,
      o = this && this.__extends || (_r142 = function r(e, t) {
        return (_r142 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r142(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesSLAPreferencesForm = t.QueuesSLAPreferencesFormImpl = void 0;
    var s = n(0),
      l = n(1),
      c = n(235),
      u = n(3),
      p = n(5),
      d = n(16),
      f = n(55),
      h = n(4),
      m = n(518),
      g = n(521),
      y = n(102),
      v = n(30),
      b = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          n.addQueueConfig = function () {
            n.setState({
              queue: {
                queue_sid: n.props.queueSid,
                reset_time: n.props.defaultConfig.reset_time,
                reset_timezone: n.props.defaultConfig.reset_timezone
              }
            });
          }, n.removeQueueConfig = function () {
            n.setState({
              queue: null
            });
          }, n.handleTimezoneChange = function (e) {
            n.setState({
              queue: {
                queue_sid: n.props.queueSid,
                reset_time: n.state.queue ? n.state.queue.reset_time : n.props.defaultConfig.reset_time,
                reset_timezone: e
              }
            });
          }, n.handleTimeChange = function (e) {
            n.setState({
              queue: {
                queue_sid: n.props.queueSid,
                reset_timezone: n.state.queue ? n.state.queue.reset_timezone : n.props.defaultConfig.reset_timezone,
                reset_time: e
              }
            });
          }, n.handleChannelConfigsUpdate = function (e) {
            n.setState({
              channels: e
            });
          }, n.onSave = function () {
            return i(n, void 0, void 0, function () {
              var e;
              return a(this, function (t) {
                switch (t.label) {
                  case 0:
                    return t.trys.push([0, 2,, 3]), this.setState({
                      isSaving: !0
                    }), [4, c.SLAPreferencesService.updateQueueSLAPreferences({
                      queue_sid: this.props.queueSid,
                      queue: this.state.queue,
                      channels: this.state.channels
                    })];
                  case 1:
                    return t.sent(), s.Actions.invokeAction("HistoryPush", y.SLAPreferencesHomePage.path), s.Notifications.showNotification(d.NotificationIds.SLAPreferencesCustomLevelsSuccess, {
                      queue: this.props.queueName
                    }), [3, 3];
                  case 2:
                    return e = t.sent(), p.log.error(e), s.Notifications.showNotification(d.NotificationIds.SLAPreferencesCustomLevelsError, {
                      queue: this.props.queueName
                    }), this.setState({
                      isSaving: !1
                    }), [3, 3];
                  case 3:
                    return [2];
                }
              });
            });
          }, n.onCancel = function () {
            return s.Actions.invokeAction("HistoryPush", y.SLAPreferencesHomePage.path);
          }, n.isFormValid = function () {
            return !n.state.channels.find(function (e) {
              var t = e.service_level_threshold,
                n = e.short_abandoned_threshold;
              return (0 !== t || 0 !== n) && !(t > n);
            });
          };
          var r = n.props.queueConfig ? {
            queue_sid: n.props.queueSid,
            reset_time: n.props.queueConfig.reset_time,
            reset_timezone: n.props.queueConfig.reset_timezone
          } : null;
          return n.state = {
            queue: r,
            channels: n.props.channelConfigs.map(function (e) {
              return {
                queue_sid: n.props.queueSid,
                channel_sid: e.channel_sid,
                service_level_threshold: e.service_level_threshold,
                short_abandoned_threshold: e.short_abandoned_threshold
              };
            }),
            isSaving: !1
          }, n;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return l.createElement(v.Page, null, l.createElement(v.PageHeader, {
            renderTitle: function renderTitle() {
              return l.createElement(h.Template, {
                source: h.templates.SLAQueuePageTitle,
                queue: e.props.queueName
              });
            },
            renderSubtitle: function renderSubtitle() {
              return l.createElement(h.Template, {
                source: h.templates.SLAQueuePageSubtitle
              });
            }
          }), l.createElement(v.PageContent, null, l.createElement(g.DailyMetricsReset, {
            queueConfig: this.state.queue,
            onAdd: this.addQueueConfig,
            onRemove: this.removeQueueConfig,
            onTimeChange: this.handleTimeChange,
            onTimezoneChange: this.handleTimezoneChange
          }), l.createElement(m.ChannelServiceLevels, {
            defaultConfig: this.props.defaultConfig,
            channelConfigs: this.state.channels,
            channelMetadata: this.props.channelMetadata,
            allChannelSids: this.props.allChannelSids,
            onUpdate: this.handleChannelConfigsUpdate
          })), l.createElement(v.PageFooter, {
            onCancel: this.onCancel,
            onSave: this.onSave,
            saveDisabled: !this.isFormValid(),
            isProgressing: this.state.isSaving
          }));
        }, t;
      }(l.PureComponent);
    t.QueuesSLAPreferencesFormImpl = b, t.QueuesSLAPreferencesForm = u.connect(function (e, t) {
      var n = f.queueConfigurationSelector(e, t),
        r = f.queueChannelConfigurationsSelector(e, t);
      return {
        queueConfig: n || null,
        defaultConfig: e.realtimeQueues.queuesConfig.default,
        channelConfigs: r,
        channelMetadata: e.realtimeQueues.metadata.channelsBySid,
        allChannelSids: e.realtimeQueues.metadata.channelSids
      };
    })(b);
  }, function (e, t, n) {
    "use strict";

    var _r143,
      o = this && this.__extends || (_r143 = function r(e, t) {
        return (_r143 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r143(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChannelServiceLevels = void 0;
    var a = n(1),
      s = n(4),
      l = n(519),
      c = n(520),
      u = n(30),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.ref = a.createRef(), t.removeChannel = function (e) {
            var n = t.props.channelConfigs.filter(function (t) {
              return t.channel_sid !== e;
            });
            t.props.onUpdate(n);
          }, t.addChannel = function (e) {
            var n = i([e], t.props.channelConfigs);
            t.props.onUpdate(n);
          }, t.updateChannel = function (e) {
            t.props.onUpdate(t.props.channelConfigs.map(function (t) {
              return t.channel_sid === e.channel_sid ? e : t;
            }));
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this.ref.current && this.ref.current.focus();
        }, t.prototype.render = function () {
          var e = this,
            t = this.props.channelConfigs.map(function (e) {
              return e.channel_sid;
            }),
            n = this.props.allChannelSids.filter(function (e) {
              return !t.includes(e);
            });
          return a.createElement(u.Section, {
            last: !0
          }, a.createElement(u.SectionHeader, null, a.createElement("div", null, a.createElement(u.SectionTitle, null, a.createElement(s.Template, {
            source: s.templates.SLAChannelServiceLevelsTitle
          })), a.createElement(u.SectionSubtile, null, a.createElement(s.Template, {
            source: s.templates.SLAChannelServiceLevelsSubtitle
          }))), a.createElement(l.AddChannelConfiguration, {
            channelSids: this.props.allChannelSids,
            channelSidsWithoutConfig: n,
            channelMetadata: this.props.channelMetadata,
            onAdd: this.addChannel,
            ref: this.ref
          })), a.createElement(u.SectionContent, null, this.props.channelConfigs.map(function (t) {
            return a.createElement(c.ChannelConfigurationListItem, {
              key: t.channel_sid,
              queueSid: t.queue_sid,
              channelSid: t.channel_sid,
              channelName: e.props.channelMetadata[t.channel_sid].friendly_name,
              serviceLevelThreshold: t.service_level_threshold,
              shortAbandonedThreshold: t.short_abandoned_threshold,
              onRemove: e.removeChannel,
              onUpdate: e.updateChannel
            });
          })));
        }, t;
      }(a.PureComponent);
    t.ChannelServiceLevels = p;
  }, function (e, t, n) {
    "use strict";

    var _r144,
      o = this && this.__extends || (_r144 = function r(e, t) {
        return (_r144 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r144(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AddChannelConfiguration = void 0;
    var i = n(1),
      a = n(4),
      s = n(30),
      l = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.ref = i.createRef(), t.focus = function () {
            t.ref.current && t.ref.current.focus();
          }, t.handleAddChannel = function (e) {
            t.props.onAdd({
              queue_sid: e.value,
              channel_sid: e.value,
              service_level_threshold: 0,
              short_abandoned_threshold: 0
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return i.createElement("label", {
            ref: this.ref,
            "data-test": "SLA_AddChannelConfig"
          }, i.createElement(s.Select, {
            options: this.props.channelSids.map(function (t) {
              return {
                value: t,
                label: e.props.channelMetadata[t].friendly_name,
                isDisabled: !e.props.channelSidsWithoutConfig.includes(t)
              };
            }),
            placeholder: a.templates.SLAPreferencesAddChannelConfigurationButton(),
            value: null,
            onChange: this.handleAddChannel,
            isSearchable: !1,
            asButton: !0,
            width: "210px"
          }));
        }, t;
      }(i.PureComponent);
    t.AddChannelConfiguration = l;
  }, function (e, t, n) {
    "use strict";

    var _r145,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r145 = function r(e, t) {
        return (_r145 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r145(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChannelConfigurationListItem = void 0;
    var a,
      s = n(1),
      l = n(4),
      c = n(2),
      u = n(30),
      p = c.default(u.InputLabel)(a || (a = o(["\n    padding-right: 32px;\n    padding-bottom: 0;\n"], ["\n    padding-right: 32px;\n    padding-bottom: 0;\n"]))),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.ref = s.createRef(), t.handleRemoveChannel = function () {
            t.props.onRemove(t.props.channelSid);
          }, t.handleSLAChange = function (e) {
            if ("" !== e.currentTarget.value) {
              var n = Math.trunc(parseInt(e.currentTarget.value, 10));
              n >= 0 && t.props.onUpdate({
                queue_sid: t.props.queueSid,
                channel_sid: t.props.channelSid,
                short_abandoned_threshold: t.props.shortAbandonedThreshold,
                service_level_threshold: n
              });
            } else t.props.onUpdate({
              queue_sid: t.props.queueSid,
              channel_sid: t.props.channelSid,
              short_abandoned_threshold: t.props.shortAbandonedThreshold,
              service_level_threshold: 0
            });
          }, t.handleShortAbandonedChange = function (e) {
            if ("" !== e.currentTarget.value) {
              var n = Math.trunc(parseInt(e.currentTarget.value, 10));
              n >= 0 && t.props.onUpdate({
                queue_sid: t.props.queueSid,
                channel_sid: t.props.channelSid,
                short_abandoned_threshold: n,
                service_level_threshold: t.props.serviceLevelThreshold
              });
            } else t.props.onUpdate({
              queue_sid: t.props.queueSid,
              channel_sid: t.props.channelSid,
              short_abandoned_threshold: 0,
              service_level_threshold: t.props.serviceLevelThreshold
            });
          }, t;
        }
        return i(t, e), t.prototype.componentDidMount = function () {
          this.ref.current && this.ref.current.focus();
        }, t.prototype.render = function () {
          return s.createElement(u.ChannelConfigurationListItemContent, {
            "data-test": "SLA_ChannelConfiguration",
            "data-test-channel_name": this.props.channelName
          }, s.createElement("h5", null, this.props.channelName), s.createElement("div", null, s.createElement(p, {
            text: s.createElement(l.Template, {
              source: l.templates.SLATitle
            })
          }, s.createElement(u.Input, {
            type: "number",
            value: this.props.serviceLevelThreshold,
            onChange: this.handleSLAChange,
            endAdornment: s.createElement(u.InputSuffix, null, "s"),
            "data-test": "SLA_ChannelConfiguration_serviceLevelThreshold",
            "data-test-channel_name": this.props.channelName
          }), " ", this.props.shortAbandonedThreshold >= this.props.serviceLevelThreshold && 0 !== this.props.shortAbandonedThreshold && s.createElement(u.ValidationMessage, null, s.createElement(l.Template, {
            source: l.templates.SLAChannelServiceLevelsValidationMessage
          }))), s.createElement(p, {
            text: s.createElement(l.Template, {
              source: l.templates.SLAShortAbandonsTitle
            })
          }, s.createElement(u.Input, {
            type: "number",
            value: this.props.shortAbandonedThreshold,
            onChange: this.handleShortAbandonedChange,
            endAdornment: s.createElement(u.InputSuffix, null, "s"),
            "data-test": "SLA_ChannelConfiguration_shortAbandonedThreshold",
            "data-test-channel_name": this.props.channelName
          }), " "), s.createElement(u.Button, {
            onClick: this.handleRemoveChannel,
            secondary: !0,
            "data-test": "SLA_ChannelConfiguration_removeBtn",
            "data-test-channel_name": this.props.channelName
          }, s.createElement(l.Template, {
            source: l.templates.SLAPreferencesRemoveConfigurationButton
          }))));
        }, t;
      }(s.PureComponent);
    t.ChannelConfigurationListItem = d;
  }, function (e, t, n) {
    "use strict";

    var _r146,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r146 = function r(e, t) {
        return (_r146 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r146(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DailyMetricsReset = void 0;
    var a,
      s = n(1),
      l = n(4),
      c = n(2),
      u = n(30),
      p = n(237),
      d = n(238),
      f = c.default(u.SectionContent)(a || (a = o(["\n    flex-direction: row;\n    input {\n        margin-right: 6px;\n    }\n\n    button {\n        margin: 0 36px;\n    }\n"], ["\n    flex-direction: row;\n    input {\n        margin-right: 6px;\n    }\n\n    button {\n        margin: 0 36px;\n    }\n"]))),
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.render = function () {
          return s.createElement(u.Section, null, s.createElement(u.SectionHeader, null, s.createElement("div", null, s.createElement(u.SectionTitle, null, s.createElement(l.Template, {
            source: l.templates.SLADailyMetricsResetTitle
          })), s.createElement(u.SectionSubtile, null, s.createElement(l.Template, {
            source: l.templates.SLADailyMetricsResetSubtitle
          }))), !this.props.queueConfig && s.createElement(u.Button, {
            onClick: this.props.onAdd,
            "data-test": "SLA_Queue_SetCustomTimeBtn"
          }, s.createElement(l.Template, {
            source: l.templates.SLADailyMetricsResetAddButton
          }))), this.props.queueConfig && s.createElement(f, null, s.createElement(d.SLATimePicker, {
            value: this.props.queueConfig.reset_time,
            onTimeSelect: this.props.onTimeChange
          }), s.createElement(p.SlaPrefsTimezonePicker, {
            value: this.props.queueConfig.reset_timezone,
            onTimezoneSelect: this.props.onTimezoneChange
          }), s.createElement(u.Button, {
            onClick: this.props.onRemove,
            secondary: !0,
            "data-test": "SLA_DailyMetrics_removeConfigBtn"
          }, s.createElement(l.Template, {
            source: l.templates.SLAPreferencesRemoveConfigurationButton
          }))));
        }, t;
      }(s.PureComponent);
    t.DailyMetricsReset = h;
  }, function (e, t, n) {
    "use strict";

    var _r147,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r147 = function r(e, t) {
        return (_r147 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r147(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GlobalSLFormContent = void 0;
    var a,
      s,
      l = n(1),
      c = n(30),
      u = n(237),
      p = n(238),
      d = n(81),
      f = n(2),
      h = f.default(c.Section)(a || (a = o(["\n    padding-top: 40px;\n    padding-bottom: 0;\n    border-bottom: none;\n"], ["\n    padding-top: 40px;\n    padding-bottom: 0;\n    border-bottom: none;\n"]))),
      m = f.default(c.SectionContent)(s || (s = o(["\n    flex-direction: row;\n"], ["\n    flex-direction: row;\n"]))),
      g = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.createChangeHandler = function (e) {
            return function (n) {
              var r = n.currentTarget.value ? Math.trunc(parseInt(n.currentTarget.value, 10)) : 0;
              t.props.handleChange(e, r);
            };
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          var e = this;
          return l.createElement("form", null, l.createElement(h, null, l.createElement(c.SectionHeader, null, l.createElement("div", null, l.createElement(c.SectionTitle, null, l.createElement(d.Template, {
            source: d.templates.SLADailyMetricsResetTitle
          })), l.createElement(c.SectionSubtile, null, l.createElement(d.Template, {
            source: d.templates.SLADailyMetricsResetSubtitle
          })))), l.createElement(m, null, l.createElement("div", null, l.createElement(c.InputLabel, {
            text: l.createElement(d.Template, {
              source: d.templates.SLAGlobalFormTimeInput
            })
          }, l.createElement(p.SLATimePicker, {
            value: this.props.form.selectedTime,
            onTimeSelect: function onTimeSelect(t) {
              return e.props.handleChange("selectedTime", t);
            }
          }))), l.createElement("div", null, l.createElement(c.InputLabel, {
            text: l.createElement(d.Template, {
              source: d.templates.SLAGlobalFormTimeZoneInput
            })
          }, l.createElement(u.SlaPrefsTimezonePicker, {
            value: this.props.form.selectedTimezone || "",
            onTimezoneSelect: function onTimezoneSelect(t) {
              return e.props.handleChange("selectedTimezone", t);
            }
          }))))), l.createElement(h, null, l.createElement(c.SectionHeader, null, l.createElement("div", null, l.createElement(c.SectionTitle, null, l.createElement(d.Template, {
            source: d.templates.SLATitle
          })), l.createElement(c.SectionSubtile, null, l.createElement(d.Template, {
            source: d.templates.SLAGlobalFormServiceLevelThresholdSubtitle
          })))), l.createElement(c.SectionContent, null, l.createElement("div", null, l.createElement(c.InputLabel, {
            text: l.createElement(d.Template, {
              source: d.templates.SLAGlobalFormTimeInput
            })
          }, l.createElement(c.Input, {
            type: "number",
            value: (this.props.form.serviceLevelThreshold || 0).toString(),
            onChange: this.createChangeHandler("serviceLevelThreshold"),
            inputProps: {
              min: 0
            },
            endAdornment: l.createElement(c.InputSuffix, null, "s"),
            "data-test": "SLA_GlobalConfiguration_serviceLevelThreshold"
          }), this.props.form.shortAbandonedThreshold >= this.props.form.serviceLevelThreshold && 0 !== this.props.form.shortAbandonedThreshold && l.createElement(c.ValidationMessage, null, l.createElement(d.Template, {
            source: d.templates.SLAChannelServiceLevelsValidationMessage
          })))))), l.createElement(h, null, l.createElement(c.SectionHeader, null, l.createElement("div", null, l.createElement(c.SectionTitle, null, l.createElement(d.Template, {
            source: d.templates.SLAShortAbandonsTitle
          })), l.createElement(c.SectionSubtile, null, l.createElement(d.Template, {
            source: d.templates.SLAGlobalFormShortAbandonsSubtitle
          })))), l.createElement(c.SectionContent, null, l.createElement("div", null, l.createElement(c.InputLabel, {
            text: l.createElement(d.Template, {
              source: d.templates.SLAGlobalFormTimeInput
            })
          }, l.createElement(c.Input, {
            type: "number",
            value: (this.props.form.shortAbandonedThreshold || 0).toString(),
            onChange: this.createChangeHandler("shortAbandonedThreshold"),
            inputProps: {
              min: 0
            },
            endAdornment: l.createElement(c.InputSuffix, null, "s"),
            "data-test": "SLA_GlobalConfiguration_shortAbandonedThreshold"
          }))))));
        }, t;
      }(l.PureComponent);
    t.GlobalSLFormContent = g;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Action = t.InsightsPlayerPlayActionPayload = void 0;
    var r = n(18);
    Object.defineProperty(t, "InsightsPlayerPlayActionPayload", {
      enumerable: !0,
      get: function get() {
        return r.InsightsPlayerPlayActionPayload;
      }
    });
    var o = n(70);
    t.Action = {
      INSIGHTS_PLAYER_PLAY: o.INSIGHTS_PLAYER_PLAY,
      INSIGHTS_PLAYER_SHOW: o.INSIGHTS_PLAYER_SHOW,
      INSIGHTS_PLAYER_HIDE: o.INSIGHTS_PLAYER_HIDE,
      INSIGHTS_PLAYER_INITIALIZED: o.INSIGHTS_PLAYER_INITIALIZED
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PanelProps = t.Panel = t.Content = void 0;
    var r = n(224);
    Object.defineProperty(t, "Content", {
      enumerable: !0,
      get: function get() {
        return r.contentStore;
      }
    });
    var o = n(42);
    Object.defineProperty(t, "Panel", {
      enumerable: !0,
      get: function get() {
        return o.ConversationViewPanel;
      }
    }), Object.defineProperty(t, "PanelProps", {
      enumerable: !0,
      get: function get() {
        return o.ConversationViewPanelProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ParticipantsCanvas = t.ParticipantCanvas = t.TaskInfoPanel = t.TaskDetailsPanel = t.TaskCanvasTabsChildrenProps = t.TaskCanvasTabs = t.TaskCanvasHeader = t.TaskCanvasChildrenProps = t.TaskCanvas = t.CallCanvasActions = t.CallCanvas = t.NoTasksCanvas = t.ConnectingOutboundCallCanvasActions = t.ConnectingOutboundCallCanvasProps = t.ConnectingOutboundCallCanvas = t.IncomingTaskCanvasActions = t.IncomingTaskCanvasProps = t.IncomingTaskCanvas = void 0;
    var r = n(201);
    Object.defineProperty(t, "IncomingTaskCanvas", {
      enumerable: !0,
      get: function get() {
        return r.IncomingTaskCanvas;
      }
    }), Object.defineProperty(t, "IncomingTaskCanvasProps", {
      enumerable: !0,
      get: function get() {
        return r.IncomingTaskCanvasProps;
      }
    }), Object.defineProperty(t, "IncomingTaskCanvasActions", {
      enumerable: !0,
      get: function get() {
        return r.IncomingTaskCanvasActions;
      }
    });
    var o = n(134);
    Object.defineProperty(t, "ConnectingOutboundCallCanvas", {
      enumerable: !0,
      get: function get() {
        return o.ConnectingOutboundCallCanvas;
      }
    }), Object.defineProperty(t, "ConnectingOutboundCallCanvasProps", {
      enumerable: !0,
      get: function get() {
        return o.ConnectingOutboundCallCanvasProps;
      }
    }), Object.defineProperty(t, "ConnectingOutboundCallCanvasActions", {
      enumerable: !0,
      get: function get() {
        return o.ConnectingOutboundCallCanvasActions;
      }
    });
    var i = n(239);
    Object.defineProperty(t, "NoTasksCanvas", {
      enumerable: !0,
      get: function get() {
        return i.NoTasksCanvas;
      }
    });
    var a = n(205);
    Object.defineProperty(t, "CallCanvas", {
      enumerable: !0,
      get: function get() {
        return a.CallCanvas;
      }
    }), Object.defineProperty(t, "CallCanvasActions", {
      enumerable: !0,
      get: function get() {
        return a.CallCanvasActions;
      }
    });
    var s = n(240);
    Object.defineProperty(t, "TaskCanvas", {
      enumerable: !0,
      get: function get() {
        return s.TaskCanvas;
      }
    }), Object.defineProperty(t, "TaskCanvasChildrenProps", {
      enumerable: !0,
      get: function get() {
        return s.TaskCanvasChildrenProps;
      }
    });
    var l = n(540);
    Object.defineProperty(t, "TaskCanvasHeader", {
      enumerable: !0,
      get: function get() {
        return l.TaskCanvasHeader;
      }
    });
    var c = n(199);
    Object.defineProperty(t, "TaskCanvasTabs", {
      enumerable: !0,
      get: function get() {
        return c.TaskCanvasTabs;
      }
    }), Object.defineProperty(t, "TaskCanvasTabsChildrenProps", {
      enumerable: !0,
      get: function get() {
        return c.TaskCanvasTabsChildrenProps;
      }
    });
    var u = n(74);
    Object.defineProperty(t, "TaskDetailsPanel", {
      enumerable: !0,
      get: function get() {
        return u.TaskDetailsPanel;
      }
    });
    var p = n(210);
    Object.defineProperty(t, "TaskInfoPanel", {
      enumerable: !0,
      get: function get() {
        return p.TaskInfoPanel;
      }
    });
    var d = n(196);
    Object.defineProperty(t, "ParticipantCanvas", {
      enumerable: !0,
      get: function get() {
        return d.ParticipantCanvas;
      }
    });
    var f = n(194);
    Object.defineProperty(t, "ParticipantsCanvas", {
      enumerable: !0,
      get: function get() {
        return f.ParticipantsCanvas;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r148,
      o = this && this.__extends || (_r148 = function r(e, t) {
        return (_r148 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r148(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.NoTasksCanvas = void 0;
    var a = n(1),
      s = n(3),
      l = n(527),
      c = n(2),
      u = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return a.createElement(t.Connected, i({}, this.props));
        }, n.friendlyName = l.displayName, n.displayName = l.displayName, n.Content = l.contentStore, n;
      }(a.PureComponent);
    t.NoTasksCanvas = u, t.Connected = s.connect(function (e) {
      return {
        worker: e.worker
      };
    })(c.withTheme(l.NoTasksCanvasImpl));
  }, function (e, t, n) {
    "use strict";

    var _r149,
      o = this && this.__extends || (_r149 = function r(e, t) {
        return (_r149 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r149(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NoTasksCanvasImpl = t.contentStore = t.displayName = void 0;
    var i = n(58),
      a = n(0),
      s = n(1),
      l = n(5),
      c = n(4),
      u = n(528);
    t.displayName = "NoTasksCanvas", t.contentStore = new a.DynamicContentStore(t.displayName);
    var p = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleChange = function (e) {
          a.Actions.invokeAction("SetActivity", {
            activitySid: e.target.value
          }).then(function () {
            l.log.debug("activity updated");
          }).catch(function (e) {
            l.log.error("failed to update activity:", e);
          });
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e,
          n,
          r,
          o,
          l,
          p,
          d = this.props.worker,
          f = Array.from(this.props.worker.activities.values()).filter(function (e) {
            return "Reserved" !== e.name;
          }),
          h = (null === (e = this.props.worker) || void 0 === e ? void 0 : e.activity) && (null === (r = null === (n = this.props.worker) || void 0 === n ? void 0 : n.activity) || void 0 === r ? void 0 : r.sid),
          m = !!d && !!d.activity && d.activity.available,
          g = (null === (o = null == d ? void 0 : d.attributes) || void 0 === o ? void 0 : o.full_name) || (null === (l = null == d ? void 0 : d.source) || void 0 === l ? void 0 : l.name) || "",
          y = !!d && (null === (p = d.attributes) || void 0 === p ? void 0 : p.image_url);
        return s.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          vertical: !0
        }, s.createElement(u.Container, null, s.createElement(u.FirstLineContainer, {
          key: "first-line"
        }, s.createElement(u.FirstLine, null, s.createElement(a.Template, {
          source: c.templates.NoTasksTitle
        }))), s.createElement(u.SecondLine, {
          key: "second-line"
        }, " ", s.createElement(a.Template, {
          source: c.templates.NoTasks
        }), " "), s.createElement(u.HintLine, {
          key: "hint"
        }, " ", s.createElement(a.Template, {
          source: m ? c.templates.NoTasksHintAvailable : c.templates.NoTasksHintNotAvailable
        }), " "), s.createElement(u.StyledWorkerAvatar, {
          key: "avatar",
          imageUrl: y,
          available: m,
          large: !0
        }), s.createElement(u.NameLine, {
          key: "name"
        }, g), s.createElement(u.StyledSelect, {
          key: "availability",
          className: "Twilio-NoTasks-WorkerActivity",
          value: h,
          onChange: this.handleChange
        }, f.map(function (e) {
          return s.createElement(i.default, {
            key: e.sid,
            value: e.sid
          }, e.name);
        }))));
      }, n;
    }(s.PureComponent);
    t.NoTasksCanvasImpl = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledSelect = t.NameLine = t.HintLine = t.SecondLine = t.FirstLine = t.FirstLineContainer = t.StyledWorkerAvatar = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d = n(59),
      f = n(0),
      h = n(2);
    t.Container = h.default("div")(o || (o = r(["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    ", "\n"], ["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.NoTasksCanvas.Container;
    }), t.StyledWorkerAvatar = h.default(f.Avatar)(i || (i = r(["\n    width: 60px;\n    height: 60px;\n"], ["\n    width: 60px;\n    height: 60px;\n"]))), t.FirstLineContainer = h.default("div")(a || (a = r(["\n    border-style: solid;\n    border-width: 0px 0px 4px 0px;\n    border-color: ", ";\n"], ["\n    border-style: solid;\n    border-width: 0px 0px 4px 0px;\n    border-color: ", ";\n"])), function (e) {
      return e.theme.colors.flexBlueColor;
    }), t.FirstLine = h.default("div")(s || (s = r(["\n    font-size: 10px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    margin: 0px 12px 4px 12px;\n"], ["\n    font-size: 10px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    margin: 0px 12px 4px 12px;\n"]))), t.SecondLine = h.default("div")(l || (l = r(["\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-align: center;\n    margin: 34px 20px 0px 20px;\n"], ["\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-align: center;\n    margin: 34px 20px 0px 20px;\n"]))), t.HintLine = h.default("div")(c || (c = r(["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 16px 20px;\n    text-align: center;\n    ", "\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 16px 20px;\n    text-align: center;\n    ", "\n"])), function (e) {
      return e.theme.NoTasksCanvas.Hint;
    }), t.NameLine = h.default("div")(u || (u = r(["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 0px 20px;\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 0px 20px;\n"]))), t.StyledSelect = h.default(d.default)(p || (p = r(["\n    margin-top: 20px;\n    width: 140px;\n"], ["\n    margin-top: 20px;\n    width: 140px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r150,
      o = this && this.__extends || (_r150 = function r(e, t) {
        return (_r150 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r150(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvas = void 0;
    var a = n(1),
      s = n(26),
      l = n(79),
      c = n(99),
      u = n(537),
      p = n(2),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(f, i({}, this.props));
        }, t.displayName = u.displayName, t.Content = u.contentStore, t.Header = l.TaskCanvasHeader, t.Tabs = c.TaskCanvasTabs, t;
      }(a.PureComponent);
    t.TaskCanvas = d;
    var f = p.withTheme(s.withTaskContext(u.TaskCanvasImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EndTaskButtonProps = t.EndTaskButton = void 0;
    var r = n(531);
    Object.defineProperty(t, "EndTaskButton", {
      enumerable: !0,
      get: function get() {
        return r.EndTaskButton;
      }
    }), Object.defineProperty(t, "EndTaskButtonProps", {
      enumerable: !0,
      get: function get() {
        return r.EndTaskButtonProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r151,
      o = this && this.__extends || (_r151 = function r(e, t) {
        return (_r151 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r151(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EndTaskButton = void 0;
    var a = n(0),
      s = n(1),
      l = n(76),
      c = n(11),
      u = n(10),
      p = n(6),
      d = n(23),
      f = n(17),
      h = n(20),
      m = n(8),
      g = n(15),
      y = n(2),
      v = n(79),
      b = n(532),
      C = n(241),
      _ = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onCompleteTaskButtonClick = function () {
            if (t.props.task) {
              var e = t.props.task,
                n = {
                  task: e,
                  reason: "Completed manually from button"
                },
                r = d.StateHelper.getCurrentPhoneCallState();
              m.TaskHelper.isLiveCall(e) && r ? p.tryInvokeAction("HangupCall", {
                task: e
              }) : m.TaskHelper.isInWrapupMode(e) ? p.tryInvokeAction("CompleteTask", n) : h.TaskChannels.getForTask(e).capabilities.has(h.TaskChannelCapability.Wrapup) ? p.tryInvokeAction("WrapupTask", n) : p.tryInvokeAction("CompleteTask", n);
            }
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.task,
            r = t.templateCode;
          return m.TaskHelper.isPending(n) || m.TaskHelper.isCompleted(n) ? null : s.createElement(a.ActionStateListener, {
            action: ["HangupCall", "CompleteTask", "WrapupTask"],
            payload: l.isValidTaskPayload(n)
          }, function (t) {
            return e.showEndCallMenu() ? s.createElement(b.default, {
              task: n
            }) : !m.TaskHelper.isCompleted(n) && s.createElement(C.EndTaskButtonContainer, {
              "data-test": "end-task-button",
              className: "Twilio-TaskCanvasHeader-EndButton",
              themeOverride: e.getEndTaskButtonStyle(),
              "data-status": n.status,
              onClick: e.onCompleteTaskButtonClick,
              disabled: t.disabled
            }, s.createElement(g.TaskContext.Consumer, null, function (e) {
              return s.createElement(a.Template, {
                task: n,
                code: r || f.TaskChannelHelper.getTemplateForStatus(n, e.channelDefinition.templates.TaskCanvasHeader.endButton, v.TaskCanvasHeader)
              });
            }));
          });
        }, t.prototype.getEndTaskButtonStyle = function () {
          var e = this.props.task;
          return m.TaskHelper.isInWrapupMode(e) ? this.props.theme.TaskCanvasHeader.EndTaskButton : h.TaskChannels.getForTask(e).capabilities.has(h.TaskChannelCapability.Wrapup) ? this.props.theme.TaskCanvasHeader.WrapupTaskButton : this.props.theme.TaskCanvasHeader.EndTaskButton;
        }, t.prototype.showEndCallMenu = function () {
          var e,
            t = this.props.task,
            n = (null === (e = t.conference) || void 0 === e ? void 0 : e.participants.filter(function (e) {
              return "joined" === e.status;
            }).length) > 2;
          return c.FeatureFlags.isEnabled(u.FeatureFlag.ExternalWarmTransfers) && !m.TaskHelper.isInWrapupMode(t) && m.TaskHelper.isLiveCall(t) && n;
        }, t = i([y.withTheme], t);
      }(s.Component);
    t.EndTaskButton = _;
  }, function (e, t, n) {
    "use strict";

    var _r152,
      o = this && this.__extends || (_r152 = function r(e, t) {
        return (_r152 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r152(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(533),
      a = n(534),
      s = n(0),
      l = n(1),
      c = n(6),
      u = n(4),
      p = n(241),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            open: !1,
            buttonRef: null
          }, t.handleToggle = function () {
            t.setState({
              open: !t.state.open
            });
          }, t.handleClose = function () {
            t.setState({
              open: !1
            });
          }, t.setRef = function (e) {
            t.setState({
              buttonRef: e
            });
          }, t.onEndCall = function () {
            var e = t.props.task;
            c.tryInvokeAction("EndConferenceForAll", {
              task: e
            }), t.handleClose();
          }, t.onLeaveCall = function () {
            var e = t.props.task;
            c.tryInvokeAction("HangupCall", {
              task: e
            }), t.handleClose();
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.state,
            n = t.open,
            r = t.buttonRef;
          return l.createElement(l.Fragment, null, l.createElement(p.EndTaskButton, {
            className: "root",
            "data-test": "call-menu-toggle",
            "aria-owns": n ? "menu-list-grow" : void 0,
            buttonRef: this.setRef,
            "aria-haspopup": "true",
            onClick: this.handleToggle,
            variant: "outlined",
            color: "primary"
          }, l.createElement(s.Template, {
            source: u.templates.TaskHeaderXWTEndCall
          }), l.createElement(p.DownChevron, {
            sizeMultiplier: .8,
            icon: "ArrowDown"
          })), l.createElement(a.default, {
            open: n,
            anchorEl: r,
            placement: "bottom-end"
          }, function () {
            return l.createElement(p.Paper, {
              className: "root"
            }, l.createElement(i.default, {
              onClickAway: e.handleClose
            }, l.createElement(p.MenuList, {
              className: "root",
              id: "menu-list-grow"
            }, l.createElement(p.MenuItem, {
              className: "root"
            }, l.createElement(p.LeaveCallButton, {
              className: "root",
              "data-test": "leave-button",
              color: "secondary",
              variant: "outlined",
              onClick: e.onLeaveCall,
              fullWidth: !0
            }, l.createElement(s.Template, {
              source: u.templates.TaskHeaderXWTLeaveCall
            }))), l.createElement(p.MenuItem, {
              className: "root"
            }, l.createElement(p.EndCallForAllButton, {
              className: "root",
              "data-test": "end-button",
              color: "secondary",
              variant: "contained",
              onClick: e.onEndCall,
              fullWidth: !0
            }, l.createElement(s.Template, {
              source: u.templates.TaskHeaderXWTEndForAll
            }))))));
          }));
        }, t;
      }(l.Component);
    t.default = d;
  }, function (e, t) {
    e.exports = require("@material-ui/core/ClickAwayListener");
  }, function (e, t) {
    e.exports = require("@material-ui/core/Popper");
  }, function (e, t, n) {
    "use strict";

    var _r153,
      o = this && this.__extends || (_r153 = function r(e, t) {
        return (_r153 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r153(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasHeaderImpl = void 0;
    var a = n(0),
      s = n(1),
      l = n(11),
      c = n(10),
      u = n(17),
      p = n(8),
      d = n(79),
      f = n(536),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.refreshTimer = void 0, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          var e = this;
          this.refreshTimer = window.setInterval(function () {
            return e.forceUpdate();
          }, 1e3);
        }, t.prototype.componentWillUnmount = function () {
          void 0 !== this.refreshTimer && window.clearInterval(this.refreshTimer);
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.ActionsComponent,
            n = e.content,
            r = e.icon,
            o = e.titleTemplateCode,
            h = e.titleTemplateContext,
            m = e.task,
            g = e.secondLineTemplateCode,
            y = e.secondLineTemplateContext,
            v = new p.TaskHelper(m),
            b = l.FeatureFlags.isEnabled(c.FeatureFlag.EmailPOC) && "email" === m.attributes.channelType;
          return s.createElement(a.DynamicComponent, {
            contentStore: n,
            childProps: this.props,
            name: n.name,
            customChildren: this.props.children
          }, s.createElement(f.Container, {
            icon: r,
            emailPOCSpecificTweaks: b
          }, !!r && s.createElement(f.IconContainer, {
            key: "icon",
            className: "Twilio-TaskCanvasHeader-Icon"
          }, s.createElement(a.Icon, {
            icon: r
          })), s.createElement(f.ContentContainer, {
            vertical: !0,
            key: "header"
          }, s.createElement(f.TitleContainer, {
            key: "header-title",
            className: "Twilio-TaskCanvasHeader-Name"
          }, s.createElement(a.Template, i({
            code: o || u.TaskChannelHelper.getTemplateForStatus(this.props.task, this.props.channelDefinition.templates.TaskCanvasHeader.title, d.TaskCanvasHeader),
            task: m,
            helper: v
          }, h))), b && m.attributes.subject && s.createElement(f.SubjectContainer, null, s.createElement("strong", null, "Subject:"), " ", m.attributes.subject), s.createElement(f.ActivityStatusContainer, {
            key: "header-activity",
            className: "Twilio-TaskCanvasHeader-Activity"
          }, s.createElement(f.ActivityStatusStyledTemplate, i({
            code: g || u.TaskChannelHelper.getTemplateForStatus(this.props.task, this.props.channelDefinition.templates.TaskCanvasHeader.secondLine, d.TaskCanvasHeader),
            task: m,
            helper: v
          }, y)))), s.createElement(t, {
            key: "actions",
            task: m
          })));
        }, t;
      }(s.PureComponent);
    t.TaskCanvasHeaderImpl = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SubjectContainer = t.ActivityStatusStyledTemplate = t.ActivityStatusContainer = t.ContentContainer = t.Container = t.IconContainer = t.TitleContainer = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p = n(0),
      d = n(2);
    t.TitleContainer = d.default("div")(o || (o = r(["\n    overflow: hidden;\n    margin-left: 0px;\n    margin-right: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    font-weight: bold;\n"], ["\n    overflow: hidden;\n    margin-left: 0px;\n    margin-right: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    font-weight: bold;\n"]))), t.IconContainer = d.default("div")(i || (i = r(["\n    display: flex;\n    flex: 0 0 auto;\n    width: 36px;\n\n    .Twilio-Icon {\n        margin: auto;\n    }\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    width: 36px;\n\n    .Twilio-Icon {\n        margin: auto;\n    }\n"]))), t.Container = d.default("div")(a || (a = r(["\n    display: flex;\n    flex: 0 0 auto;\n    padding-top: ", ";\n    padding-bottom: 2px;\n    padding-left: ", ";\n    padding-right: 12px;\n    height: ", ";\n    ", "\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    padding-top: ", ";\n    padding-bottom: 2px;\n    padding-left: ", ";\n    padding-right: 12px;\n    height: ", ";\n    ", "\n"])), function (e) {
      return e.emailPOCSpecificTweaks ? "12px" : "2px";
    }, function (e) {
      return e.icon ? "2px" : "12px";
    }, function (e) {
      return e.emailPOCSpecificTweaks ? "auto" : "56px";
    }, function (e) {
      return e.theme.TaskCanvasHeader.Container;
    }), t.ContentContainer = d.default(p.FlexBox)(s || (s = r(["\n    justify-content: center;\n    overflow: hidden;\n"], ["\n    justify-content: center;\n    overflow: hidden;\n"]))), t.ActivityStatusContainer = d.default("div")(l || (l = r(["\n    font-size: 12px;\n    font-weight: normal;\n    margin-top: 2px;\n    overflow: hidden;\n    margin-left: 0px;\n    margin-right: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    margin-top: 2px;\n    overflow: hidden;\n    margin-left: 0px;\n    margin-right: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.ActivityStatusStyledTemplate = d.default(p.Template)(c || (c = r(["\n    display: inline-flex;\n    align-items: center;\n    .Twilio-Template-Icon {\n        margin-right: 4px;\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n    .Twilio-Template-Icon {\n        margin-right: 4px;\n    }\n"]))), t.SubjectContainer = d.default("div")(u || (u = r(["\n    margin-right: 14px;\n    font-size: 12px;\n    margin-top: 2px;\n    margin-bottom: 2px;\n\n    strong {\n        font-weight: bold;\n    }\n"], ["\n    margin-right: 14px;\n    font-size: 12px;\n    margin-top: 2px;\n    margin-bottom: 2px;\n\n    strong {\n        font-weight: bold;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r154,
      o = this && this.__extends || (_r154 = function r(e, t) {
        return (_r154 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r154(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasImpl = t.contentStore = t.displayName = void 0;
    var i = n(1),
      a = n(0),
      s = n(538),
      l = n(79),
      c = n(99);
    t.displayName = "TaskCanvas", t.contentStore = new a.DynamicContentStore(t.displayName);
    var u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props.task;
        return e ? i.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, i.createElement(s.Container, {
          vertical: !0,
          overflow: "hidden"
        }, i.createElement(l.TaskCanvasHeader, {
          key: "header",
          task: e
        }), i.createElement(c.TaskCanvasTabs, {
          key: "tabs"
        }))) : null;
      }, n;
    }(i.PureComponent);
    t.TaskCanvasImpl = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(2),
      a = n(0);
    t.Container = i.default(a.FlexBox)(o || (o = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.TaskCanvas.Container;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCanvasHeaderProps = t.TaskCanvasHeader = void 0;
    var r = n(79);
    Object.defineProperty(t, "TaskCanvasHeader", {
      enumerable: !0,
      get: function get() {
        return r.TaskCanvasHeader;
      }
    });
    var o = n(541);
    Object.defineProperty(t, "TaskCanvasHeaderProps", {
      enumerable: !0,
      get: function get() {
        return o.TaskCanvasHeaderProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r155,
      o = this && this.__extends || (_r155 = function r(e, t) {
        return (_r155 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r155(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || a(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.UserControls = void 0;
    var l = n(1),
      c = n(3),
      u = n(543);
    s(n(148), t);
    var p = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        return l.createElement(t.Connected, i({}, this.props));
      }, n;
    }(l.PureComponent);
    t.UserControls = p, t.Connected = c.connect(function (e) {
      return {
        worker: e.worker
      };
    })(u.UserControlsImpl);
  }, function (e, t, n) {
    "use strict";

    var _r156,
      o = this && this.__extends || (_r156 = function r(e, t) {
        return (_r156 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r156(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserControlsImpl = void 0;
    var a = n(0),
      s = n(1),
      l = n(5),
      c = n(6),
      u = n(4),
      p = n(2),
      d = n(148),
      f = n(544),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleWindowResize = function () {
            t.forceUpdate();
          }, t.onLogoutClick = function () {
            c.tryInvokeAction("Logout", {
              forceLogout: !1
            }), t.modalPopup.hide();
          }, t.setModalPopupRef = function (e) {
            t.modalPopup = e;
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          window.addEventListener("resize", this.handleWindowResize);
        }, t.prototype.componentWillUnmount = function () {
          window.removeEventListener("resize", this.handleWindowResize);
        }, t.prototype.render = function () {
          var e = this;
          return s.createElement(a.ModalPopupWithEntryControl, {
            className: "Twilio-UserControls",
            alignRight: !0,
            autoClose: !0,
            entryControl: s.createElement(f.UserControlsUserCard, {
              className: "Twilio-UserControlsUserCard-AccountButton",
              large: window.innerWidth > 552,
              worker: this.props.worker
            }),
            ref: this.setModalPopupRef
          }, s.createElement(d.UserActivityControls, {
            className: "Twilio-UserControls-AccountMenu",
            styleOverride: this.props.theme.UserActivityControls
          }, s.createElement(d.AccountMenuTitle, {
            className: "Twilio-AccountMenu-Title"
          }, s.createElement(a.Template, {
            source: u.templates.SetYourStatus
          })), Array.from(this.props.worker.activities.values()).filter(function (e) {
            return "Reserved" !== e.name;
          }).map(function (t) {
            return s.createElement(d.AccountMenuItem, {
              "data-test": "activity-" + t.name,
              className: "Twilio-AccountMenu-Item",
              key: t.sid,
              selected: e.props.worker.activity && t.sid === e.props.worker.activity.sid,
              onClick: function onClick() {
                return e.onActivityClick(t.sid);
              },
              styleOverride: e.props.theme.UserActivityControls
            }, t.name);
          }), s.createElement(d.AccountMenuDivider, null), s.createElement(d.AccountMenuItemLogout, {
            onClick: this.onLogoutClick,
            styleOverride: this.props.theme.UserActivityControls
          }, s.createElement(a.Template, {
            source: u.templates.LogOut
          }), s.createElement(a.Icon, {
            icon: "Logout"
          }))));
        }, t.prototype.onActivityClick = function (e) {
          this.modalPopup.hide(), a.Actions.invokeAction("SetActivity", {
            activitySid: e
          }).then(function () {
            l.log.debug("activity updated");
          }).catch(function (e) {
            l.log.error("failed to update activity:", e);
          });
        }, t.displayName = "UserControls", t = i([p.withTheme], t);
      }(s.PureComponent);
    t.UserControlsImpl = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserControlsUserCardProps = t.UserControlsUserCard = void 0;
    var r = n(545);
    Object.defineProperty(t, "UserControlsUserCard", {
      enumerable: !0,
      get: function get() {
        return r.UserControlsUserCard;
      }
    }), Object.defineProperty(t, "UserControlsUserCardProps", {
      enumerable: !0,
      get: function get() {
        return r.UserControlsUserCardProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r157,
      o = this && this.__extends || (_r157 = function r(e, t) {
        return (_r157 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r157(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserControlsUserCard = void 0;
    var s = n(0),
      l = n(1),
      c = n(4),
      u = n(148),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          var e = this;
          this.interval = window.setInterval(function () {
            return e.forceUpdate();
          }, 1e3);
        }, t.prototype.componentWillUnmount = function () {
          clearInterval(this.interval);
        }, t.prototype.render = function () {
          var e,
            t = this.props,
            n = (t.className, t.innerRef, t.worker),
            r = t.large,
            o = t.onClick,
            p = a(t, ["className", "innerRef", "worker", "large", "onClick"]),
            d = n.worker;
          return l.createElement(u.Container, {
            large: r
          }, l.createElement(s.UserCard, i({
            className: "Twilio-UserControls-UserCard",
            "data-test": "activity-toggle",
            large: r,
            firstLine: (null == d ? void 0 : d.fullName) || "",
            secondLine: l.createElement(s.Template, {
              source: c.templates.UserControlWorkerSecondLine,
              workerActivityName: (null == d ? void 0 : d.activityName) || "",
              worker: d
            }),
            imageUrl: (null === (e = null == d ? void 0 : d.attributes) || void 0 === e ? void 0 : e.image_url) || "",
            isAvailable: !!(null == d ? void 0 : d.isAvailable),
            onClick: o,
            lightHover: !0
          }, p)));
        }, t;
      }(l.PureComponent);
    t.UserControlsUserCard = p;
  }, function (e, t, n) {
    "use strict";

    var _r158,
      o = this && this.__extends || (_r158 = function r(e, t) {
        return (_r158 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r158(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      l = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || a(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MainHeader = void 0;
    var c = n(0),
      u = n(1),
      p = n(3),
      d = n(115),
      f = n(23),
      h = n(8),
      m = n(547);
    l(n(244), t);
    var g = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      var n;
      return o(t, e), n = t, t.updateAll = function () {}, t.prototype.render = function () {
        return u.createElement(y, i({}, this.props));
      }, t.getBadgeChildren = function (e) {
        var t = new d.AppStateHelper(e);
        return t.isAgentView() ? 0 : t.getPendingTasks() + t.getUnconsumedMessagesCount();
      }, t.displayName = m.displayName, t.Content = m.contentStore, t.defaultProps = {
        logoUrl: void 0,
        Badge: {
          children: n.getBadgeChildren,
          variant: c.Badge.variants.dot,
          position: {
            right: "10px",
            top: "5px"
          }
        }
      }, t = n = s([c.withDefaultPropsUpdate], t);
    }(u.PureComponent);
    t.MainHeader = g;
    var y = p.connect(function (e, t) {
      var n = t.Badge && t.Badge.children,
        r = f.StateHelper.hasPendingCall();
      return {
        incomingTasks: !!Array.from(e.worker.tasks.values()).find(function (e) {
          return h.TaskHelper.isPending(e);
        }),
        isLiveVoiceConnection: !!e.phone.connection,
        hasIncomingCallReservation: r,
        isSideNavOpen: e.view.isSideNavOpen,
        Badge: i(i({}, t.Badge), {
          children: "function" == typeof n ? n(e, t) : n
        })
      };
    })(m.MainHeaderImpl);
  }, function (e, t, n) {
    "use strict";

    var _r159,
      o = this && this.__extends || (_r159 = function r(e, t) {
        return (_r159 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r159(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MainHeaderImpl = t.contentStore = t.displayName = void 0;
    var s = n(0),
      l = n(1),
      c = n(47),
      u = n(11),
      p = n(10),
      d = n(6),
      f = n(548),
      h = n(132),
      m = n(2),
      g = n(550),
      y = n(244),
      v = n(243),
      b = n(149);
    t.displayName = "MainHeader", t.contentStore = new s.DynamicContentStore(t.displayName);
    var C = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onSidebarButtonClick = function () {
          d.tryInvokeAction("ToggleSidebar");
        }, t.onDialpadClick = function () {
          d.tryInvokeAction("ToggleOutboundDialer");
        }, t.onSidebarButtonBlur = function (e) {
          var n = document.getElementsByClassName("Twilio-SideNav-Container"),
            r = null;
          if (n.length > 0 && (r = n[0]), r) for (var o = e.relatedTarget; o;) {
            if (o === r) return;
            o = o.parentElement;
          }
          t.props.isSideNavOpen && d.tryInvokeAction("ToggleSidebar", {
            open: !1
          });
        }, t;
      }
      return o(n, e), n.prototype.shouldComponentUpdate = function (e) {
        return !b(this.props, e);
      }, n.prototype.render = function () {
        var e = this.props,
          n = e.theme,
          r = e.logoUrl,
          o = e.Badge,
          a = e.isLiveVoiceConnection,
          d = e.hasIncomingCallReservation,
          m = u.FeatureFlags.isEnabled(p.FeatureFlag.DebuggerUI);
        return l.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children
        }, l.createElement(y.Container, null, l.createElement(s.ContentFragment, {
          align: "start"
        }, l.createElement(y.StyledIconContainer, {
          key: "sidenav-button"
        }, l.createElement(y.StyledIconButton, {
          themeOverride: n.MainHeader.Button,
          icon: "Hamburger",
          onClick: this.onSidebarButtonClick,
          onBlur: this.onSidebarButtonBlur,
          className: "Twilio-Main-Header-IconButton"
        }), o && l.createElement(s.Badge, i({
          key: "badge"
        }, o))), r ? l.createElement(y.HeaderLogoImage, {
          key: "logo",
          src: r
        }) : l.createElement(f.HeaderLogo, {
          key: "logo"
        })), l.createElement(s.ContentFragment, {
          align: "end"
        }, m && l.createElement(g.ErrorUI, {
          key: "errorui-button"
        }), c.isOutboundCallingEnabled() && l.createElement(s.IconButton, {
          "data-test": "dialpad-toggle",
          key: "dialpad-button",
          themeOverride: n.MainHeader.Button,
          icon: "Dialpad",
          onClick: this.onDialpadClick,
          disabled: a || d
        }), l.createElement(h.MuteButton, {
          key: "mute-button",
          themeOverride: n.MainHeader.Button
        }), l.createElement(v.UserControls, {
          key: "user-controls"
        }))));
      }, n = a([m.withTheme], n);
    }(l.Component);
    t.MainHeaderImpl = C;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HeaderLogo = void 0;
    var r = n(549);
    Object.defineProperty(t, "HeaderLogo", {
      enumerable: !0,
      get: function get() {
        return r.HeaderLogo;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HeaderLogo = void 0;
    var o = n(1);
    t.HeaderLogo = function (e) {
      return o.createElement("svg", r({
        viewBox: "0 0 150 32",
        width: "150px",
        height: "32px"
      }, e), o.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h150v32H0z"
      }), o.createElement("g", {
        fill: "currentColor"
      }, o.createElement("path", {
        d: "M42.524 11.83h-3.472V21h-1.05v-9.17H34.6v-.98h7.77l.154.98zm17.54-.98l-3.192 10.192h-.924l-3.052-8.722-3.038 8.722h-.896L45.798 10.99l1.064-.238 2.618 8.61 2.898-8.512h1.078l2.94 8.512 2.576-8.512h1.092zM65.438 21h-1.064V10.85h1.064V21zm10.302 0h-5.264V10.85h1.05v9.17h4.06l.154.98zm5.136 0h-1.064V10.85h1.064V21zm14.096-5.082c0 3.108-1.96 5.278-4.788 5.278-2.828 0-4.76-2.156-4.76-5.25 0-3.122 1.96-5.278 4.788-5.278 2.828 0 4.76 2.142 4.76 5.25zm-1.106.014c0-2.576-1.456-4.312-3.682-4.312-2.212 0-3.668 1.736-3.668 4.298 0 2.59 1.47 4.312 3.682 4.312 2.226 0 3.668-1.722 3.668-4.298zm16.516-4.102h-4.242v3.542h3.388l.154.966h-3.542V21h-1.05V10.85h5.292v.98zM119.76 21h-5.264V10.85h1.05v9.17h4.06l.154.98zm9.616 0h-5.642V10.85h5.488v.98h-4.438v3.374h3.514l.154.98h-3.668v3.85h4.592V21zm11.926-.14l-1.064.224-3.22-4.62L133.91 21h-1.162l3.668-5.278-3.304-4.718 1.05-.224 2.87 4.172 2.8-4.102h1.162l-3.36 4.844 3.668 5.166zM8.852 14.253l4.324 4.325a.499.499 0 0 1 .146.353v4.568a.5.5 0 0 1-.852.354l-4.324-4.326A.495.495 0 0 1 8 19.174v-4.568a.5.5 0 0 1 .852-.353zM8.503 8h10.673c.132 0 .26.052.352.146l4.325 4.325a.5.5 0 0 1-.353.852H13.321a.49.49 0 0 0 0 .978h3.306c.132 0 .26.052.353.145l4.324 4.326a.5.5 0 0 1-.353.852h-5.1a.503.503 0 0 1-.353-.146l-7.352-7.34A.495.495 0 0 1 8 11.785V8.503C8 8.225 8.226 8 8.503 8z"
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(551), t);
  }, function (e, t, n) {
    "use strict";

    var _r160,
      o = this && this.__extends || (_r160 = function r(e, t) {
        return (_r160 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r160(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.ErrorUI = void 0;
    var a = n(0),
      s = n(3),
      l = n(1),
      c = n(552),
      u = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return l.createElement(t.Connected, i({}, this.props));
        }, n.getBadgeChildren = function (e) {
          return e.flexErrors.errors.length;
        }, n.defaultProps = {
          Badge: {
            children: n.getBadgeChildren,
            variant: a.Badge.variants.dot,
            position: {
              right: "8px",
              top: "8px"
            }
          }
        }, n;
      }(l.PureComponent);
    t.ErrorUI = u, t.Connected = s.connect(function (e, t) {
      var n = t.Badge && t.Badge.children;
      return {
        errors: e.flexErrors.errors,
        Badge: i(i({}, t.Badge), {
          children: "function" == typeof n ? n(e, t) : n
        })
      };
    })(a.withTheme(c.ErrorUIImpl));
  }, function (e, t, n) {
    "use strict";

    var _r161,
      o = this && this.__extends || (_r161 = function r(e, t) {
        return (_r161 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r161(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      l = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorUIImpl = void 0;
    var c = n(0),
      u = n(33),
      p = n(1),
      d = n(32),
      f = n(68),
      h = n(14),
      m = n(117),
      g = n(4),
      y = n(553),
      v = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.errorUITemplates = {
            noErrors: {
              title: g.templates.LogNoErrorsTitleText,
              description: g.templates.LogNoErrorsDescriptionText
            },
            singleError: {
              title: g.templates.LogSingleErrorTitleText,
              description: g.templates.LogSingleErrorDescriptionText,
              viewErrors: g.templates.LogViewSingleErrorText,
              hideErrors: g.templates.LogHideSingleErrorText,
              copyToClipboard: g.templates.LogSingleErrorCopyToClipboardText,
              clearError: g.templates.LogClearSingleError
            },
            multipleErrors: {
              title: g.templates.LogMultipleErrorsTitleText,
              description: g.templates.LogMultipleErrorsDescriptionText,
              viewErrors: g.templates.LogViewMultipleErrorsText,
              hideErrors: g.templates.LogHideMultipleErrorText,
              copyToClipboard: g.templates.LogMultipleErrorsCopyToClipboardText,
              clearError: g.templates.LogClearMultipleErrors
            }
          }, t.state = {
            isShowingErrors: !1
          }, t.maxErrorsToShow = 20, t.getErrorsToDisplay = function (e) {
            return e.length > t.maxErrorsToShow ? e.slice(0, t.maxErrorsToShow) : e;
          }, t.renderTriggerButton = function (e) {
            var n = t.props.Badge;
            return p.createElement(y.TogglePanelButtonContainer, {
              isModalOpen: e
            }, p.createElement(y.StyledIconButton, {
              isModalOpen: e,
              roundCorners: !1,
              className: u.cx("Twilio-ErrorUI-IconButton"),
              icon: "SupportabilityBold"
            }), p.createElement(c.Badge, i({
              key: "badge"
            }, n)));
          }, t.setModalPopupRef = function (e) {
            t.modalPopup = e;
          }, t.getContentTemplates = function (e) {
            return d.FlexClientManager.degradedMode ? i(i({}, t.errorUITemplates.multipleErrors), {
              description: g.templates.LogDegradedModeErrorsDescriptionText
            }) : 0 === e ? t.errorUITemplates.noErrors : 1 === e ? t.errorUITemplates.singleError : t.errorUITemplates.multipleErrors;
          }, t.renderHeaderContainer = function () {
            return p.createElement(y.HeaderContainer, {
              noShrink: !0,
              noGrow: !0,
              className: u.cx("Twilio-ErrorUI-HeaderContainer")
            }, p.createElement(y.CloseButton, {
              key: "close-log",
              icon: "Close",
              className: u.cx("ErrorUI-CloseModal"),
              themeOverride: t.props.theme.ErrorUI.CloseButton,
              onClick: t.closeModal
            }), p.createElement(y.HeaderText, {
              key: "title",
              className: u.cx("Twilio-ErrorUI-HeaderText")
            }, p.createElement(g.Template, {
              source: g.templates.LogStatusReport
            })));
          }, t.renderInfoContainer = function (e, n) {
            var r = t.state.isShowingErrors ? n.hideErrors : n.viewErrors;
            return p.createElement(y.InfoContainer, {
              className: u.cx("ErrorUI-InfoContainer")
            }, p.createElement(c.FlexBox, {
              vertical: !0
            }, t.renderInfoTitle(e.length, n.title), p.createElement(c.FlexBox, {
              className: u.cx("ErrorUI-ErrorDescription")
            }, p.createElement(g.Template, {
              source: n.description
            })), p.createElement(y.ActionText, {
              onClick: t.toogleErrorsDetails,
              className: u.cx("ErrorUI-ToggleErrorsDetails")
            }, p.createElement(g.Template, {
              source: r
            })), t.state.isShowingErrors && t.renderErrorsDetails(e, n)));
          }, t.renderInfoTitle = function (e, t) {
            var n = e > 0;
            return p.createElement(y.InfoTitleContainer, {
              className: u.cx("ErrorUI-InfoTitleContainer")
            }, n ? p.createElement(y.WarningIcon, {
              icon: "AlertTriangle"
            }) : p.createElement(y.NoErrorsIcon, {
              icon: "Accept"
            }), p.createElement(y.InfoTitleText, {
              className: u.cx("ErrorUI-InfoTitleText")
            }, p.createElement(g.Template, {
              source: t
            })));
          }, t.renderErrorsDetails = function (e, n) {
            return p.createElement(c.FlexBox, {
              vertical: !0,
              className: u.cx("Twilio-ErrorUI-ErrorsDetails")
            }, p.createElement(y.ErrorsContainer, {
              vertical: !0,
              className: u.cx("ErrorUI-ErrorsContainer")
            }, e.map(function (e) {
              return p.createElement(y.ErrorContainer, {
                key: e.logLine
              }, e.logLine);
            })), p.createElement(y.ActionText, {
              onClick: t.copyToClipboard,
              className: u.cx("ErrorUI-CopyToClipboard")
            }, p.createElement(g.Template, {
              source: n.copyToClipboard
            })));
          }, t.renderDownloadReportButton = function () {
            return p.createElement(y.DownloadReportButton, {
              roundCorners: !1,
              className: u.cx("Twilio-DownloadReport-IconButton"),
              onClick: t.handleDownloadReport
            }, p.createElement(g.Template, {
              source: g.templates.LogDownloadReport
            }));
          }, t.renderClearErrorsButton = function (e) {
            return p.createElement(y.ClearButton, {
              roundCorners: !1,
              className: u.cx("Twilio-ClearErrors-IconButton"),
              onClick: t.clearErrors
            }, p.createElement(g.Template, {
              source: e
            }));
          }, t.closeModal = function () {
            t.modalPopup.hide();
          }, t.toogleErrorsDetails = function () {
            t.setState({
              isShowingErrors: !t.state.isShowingErrors
            });
          }, t.copyToClipboard = function () {
            return a(t, void 0, void 0, function () {
              var e, t;
              return s(this, function (n) {
                switch (n.label) {
                  case 0:
                    e = this.props.errors, t = e.reduce(function (e, t) {
                      return "" + e + t.logLine + "\n\n";
                    }, ""), n.label = 1;
                  case 1:
                    return n.trys.push([1, 3,, 4]), [4, navigator.clipboard.writeText(t)];
                  case 2:
                    return n.sent(), [3, 4];
                  case 3:
                    return n.sent(), c.Notifications.showNotification(h.CopyClipboardFailed, {
                      clipboardText: t
                    }), [3, 4];
                  case 4:
                    return [2];
                }
              });
            });
          }, t.handleDownloadReport = function () {
            f.downloadReport(t.props.errors), t.modalPopup.hide();
          }, t.clearErrors = function () {
            m.Actions.clearAllErrors(), t.modalPopup.hide();
          }, t;
        }
        return o(t, e), t.prototype.shouldComponentUpdate = function (e, t) {
          if (!c.Utils.areEqual(this.state, t)) return !0;
          var n = this.props,
            r = n.errors,
            o = l(n, ["errors"]),
            i = e.errors,
            a = l(e, ["errors"]);
          return !(r.length >= this.maxErrorsToShow && i.length > r.length) || !!r.some(function (e, t) {
            return i[t] !== e;
          }) || !c.Utils.areEqual(o, a);
        }, t.prototype.render = function () {
          var e = this.props.errors,
            t = this.getErrorsToDisplay(e),
            n = t.length,
            r = this.getContentTemplates(n);
          return p.createElement(c.ModalPopupWithEntryControl, {
            className: u.cx("Twilio-ErrorUI"),
            alignRight: !0,
            ref: this.setModalPopupRef,
            entryControl: this.renderTriggerButton
          }, p.createElement(y.Panel, {
            className: u.cx("Twilio-ErrorUI-Panel")
          }, this.renderHeaderContainer(), this.renderInfoContainer(t, r), this.renderDownloadReportButton(), n > 0 && this.renderClearErrorsButton(r.clearError)));
        }, t;
      }(p.Component);
    t.ErrorUIImpl = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ClearButton = t.DownloadReportButton = t.ErrorContainer = t.ErrorsContainer = t.ActionText = t.InfoTitleText = t.NoErrorsIcon = t.WarningIcon = t.InfoTitleContainer = t.InfoContainer = t.HeaderText = t.CloseButton = t.HeaderContainer = t.StyledIconButton = t.TogglePanelButtonContainer = t.Panel = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d,
      f,
      h,
      m,
      g,
      y,
      v,
      b,
      C = n(2),
      _ = n(0);
    t.Panel = C.default("div")(o || (o = r(["\n    width: 260px;\n    color: ", ";\n    padding: 12px;\n    line-height: 20px;\n\n    ", "\n"], ["\n    width: 260px;\n    color: ", ";\n    padding: 12px;\n    line-height: 20px;\n\n    ", "\n"])), function (e) {
      return e.theme.calculated.textColor;
    }, function (e) {
      return e.theme.ErrorUI.Panel;
    }), t.TogglePanelButtonContainer = C.default("div")(i || (i = r(["\n    height: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    background: ", ";\n\n    // Hack to change outer circle color when modal is open\n    & .Twilio-Main-Header-IconButton,\n    & .Twilio-Badge-OuterCircle {\n        ", "\n    }\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Main-Header-IconButton,\n        & .Twilio-Badge-OuterCircle {\n            cursor: pointer;\n            ", "\n        }\n    }\n"], ["\n    height: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    background: ", ";\n\n    // Hack to change outer circle color when modal is open\n    & .Twilio-Main-Header-IconButton,\n    & .Twilio-Badge-OuterCircle {\n        ", "\n    }\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Main-Header-IconButton,\n        & .Twilio-Badge-OuterCircle {\n            cursor: pointer;\n            ", "\n        }\n    }\n"])), function (e) {
      return e.theme.MainHeader.Container.background;
    }, function (e) {
      return e.isModalOpen && _.getBackgroundWithHoverCSS(e.theme.MainHeader.Container.background, e.theme.MainHeader.Button.lightHover, !0);
    }, function (e) {
      return _.getBackgroundWithHoverCSS(e.theme.MainHeader.Container.background, e.theme.MainHeader.Button.lightHover, !0);
    }), t.StyledIconButton = C.default(_.IconButton)(a || (a = r(["\n    height: 44px;\n    width: 44px;\n    border-radius: 0;\n    background-color: ", ";\n\n    &:hover {\n        background-color: rgba(255, 255, 255, 0.2);\n    }\n\n    ", "\n"], ["\n    height: 44px;\n    width: 44px;\n    border-radius: 0;\n    background-color: ", ";\n\n    &:hover {\n        background-color: rgba(255, 255, 255, 0.2);\n    }\n\n    ", "\n"])), function (e) {
      return e.isModalOpen ? "rgba(255, 255, 255, 0.2)" : "none";
    }, function (e) {
      return e.theme.ErrorUI.IconButton;
    }), t.HeaderContainer = C.default(_.FlexBox)(s || (s = r(["\n    align-items: center;\n"], ["\n    align-items: center;\n"]))), t.CloseButton = C.default(_.IconButton)(l || (l = r(["\n    width: 24px;\n    height: 24px;\n"], ["\n    width: 24px;\n    height: 24px;\n"]))), t.HeaderText = C.default(_.FlexBox)(c || (c = r(["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 24px;\n    text-transform: uppercase;\n"], ["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 24px;\n    text-transform: uppercase;\n"]))), t.InfoContainer = C.default(_.FlexBox)(u || (u = r(["\n    flex-direction: column;\n    padding-top: 12px;\n"], ["\n    flex-direction: column;\n    padding-top: 12px;\n"]))), t.InfoTitleContainer = C.default(_.FlexBox)(p || (p = r(["\n    align-items: center;\n    padding-bottom: 12px;\n"], ["\n    align-items: center;\n    padding-bottom: 12px;\n"]))), t.WarningIcon = C.default(_.Icon)(d || (d = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.ErrorUI.WarningIcon;
    }), t.NoErrorsIcon = C.default(_.Icon)(f || (f = r(["\n    border-radius: 100px;\n    ", "\n"], ["\n    border-radius: 100px;\n    ", "\n"])), function (e) {
      return e.theme.ErrorUI.NoErrorsIcon;
    }), t.InfoTitleText = C.default("div")(h || (h = r(["\n    font-weight: bold;\n    padding-left: 8px;\n"], ["\n    font-weight: bold;\n    padding-left: 8px;\n"]))), t.ActionText = C.default("div")(m || (m = r(["\n    text-decoration: underline;\n    cursor: pointer;\n    ", "\n"], ["\n    text-decoration: underline;\n    cursor: pointer;\n    ", "\n"])), function (e) {
      return e.theme.ErrorUI.ActionText;
    }), t.ErrorsContainer = C.default(_.FlexBox)(g || (g = r(["\n    max-height: 192px;\n    overflow-y: auto;\n    margin-top: 8px;\n    margin-bottom: 8px;\n"], ["\n    max-height: 192px;\n    overflow-y: auto;\n    margin-top: 8px;\n    margin-bottom: 8px;\n"]))), t.ErrorContainer = C.default("div")(y || (y = r(["\n    padding-bottom: 16px;\n    ", "\n"], ["\n    padding-bottom: 16px;\n    ", "\n"])), function (e) {
      return e.theme.ErrorUI.ErrorContainer;
    }), t.DownloadReportButton = C.default(_.Button)(v || (v = r(["\n    margin-top: 16px;\n    width: 100%;\n    text-transform: uppercase;\n\n    ", "\n    ", ";\n"], ["\n    margin-top: 16px;\n    width: 100%;\n    text-transform: uppercase;\n\n    ", "\n    ", ";\n"])), function (e) {
      return e.theme.ErrorUI.DownloadButton;
    }, function (e) {
      return _.getBackgroundWithHoverCSS(e.theme.ErrorUI.DownloadButton.backgroundColor, e.theme.ErrorUI.DownloadButton.lightHover);
    }), t.ClearButton = C.default(_.Button)(b || (b = r(["\n    margin-top: 16px;\n    width: 100%;\n    text-transform: uppercase;\n\n    ", "\n    ", ";\n"], ["\n    margin-top: 16px;\n    width: 100%;\n    text-transform: uppercase;\n\n    ", "\n    ", ";\n"])), function (e) {
      return e.theme.ErrorUI.ClearButton;
    }, function (e) {
      return _.getBackgroundWithHoverCSS(e.theme.ErrorUI.ClearButton.backgroundColor, e.theme.ErrorUI.ClearButton.lightHover);
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r162,
      o = this && this.__extends || (_r162 = function r(e, t) {
        return (_r162 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r162(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListFilter = void 0;
    var a = n(1),
      s = n(4),
      l = n(0),
      c = n(556),
      u = n(557),
      p = n(150),
      d = n(2),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleModalChange = function () {
            t.forceUpdate();
          }, t.setModalPopupRef = function (e) {
            t.modalPopup = e;
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props.filters || [];
          return 0 === t.length ? null : a.createElement(p.TaskListContext.Consumer, null, function (n) {
            return a.createElement(c.StyledModalPopupWithEntryControl, {
              autoClose: !0,
              entryControl: a.createElement(u.TaskFilterButton, {
                className: "Twilio-TaskListFilter-TaskFilterButton",
                isOpen: e.isModalOpen(),
                content: e.getFilterText()
              }),
              innerRef: e.setModalPopupRef,
              onChange: e.handleModalChange
            }, a.createElement(c.StyledMenu, {
              className: "Twilio-TaskListFilter-Items",
              styleOverride: e.props.theme.TaskList.Filter.Menu
            }, t.map(function (t) {
              return a.createElement(l.MenuItem, {
                key: t.text,
                id: t.text,
                className: "Twilio-TaskListFilter-Item",
                onClick: function onClick() {
                  return e.onFilterClick(t, n.onFilterChange);
                },
                selected: t === e.props.value,
                styleOverride: e.props.theme.TaskList.Filter.Menu
              }, e.getFilterText(t));
            })));
          });
        }, t.prototype.isModalOpen = function () {
          return !!this.modalPopup && this.modalPopup.isOpen;
        }, t.prototype.getFilterText = function (e) {
          return void 0 === e && (e = this.props.value), e.text in s.templates ? a.createElement(s.Template, {
            source: s.templates[e.text]
          }) : e.text;
        }, t.prototype.onFilterClick = function (e, t) {
          t(e), this.modalPopup.hide();
        }, t.displayName = "TaskListFilter", t = i([d.withTheme], t);
      }(a.PureComponent);
    t.TaskListFilter = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledMenu = t.StyledModalPopupWithEntryControl = void 0;
    var o,
      i,
      a = n(2),
      s = n(0);
    t.StyledModalPopupWithEntryControl = a.default(s.ModalPopupWithEntryControl)(o || (o = r(["\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    z-index: 1;\n    position: relative;\n    ", "\n"], ["\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    z-index: 1;\n    position: relative;\n    ", "\n"])), function (e) {
      return e.theme.TaskList.Filter.Container;
    }), t.StyledMenu = a.default(s.Menu)(i || (i = r(["\n    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.25);\n"], ["\n    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.25);\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskFilterButton = void 0;
    var r = n(558);
    Object.defineProperty(t, "TaskFilterButton", {
      enumerable: !0,
      get: function get() {
        return r.TaskFilterButton;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskFilterButton = void 0;
    var i = n(1),
      a = n(559);
    t.TaskFilterButton = function (e) {
      var t = e.content,
        n = e.isOpen,
        s = o(e, ["content", "isOpen"]);
      return i.createElement(a.StyledEntryButton, r({}, s), t, i.createElement(a.StyledToggleIcon, {
        icon: n ? "FilterUp" : "Filter"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledToggleIcon = t.StyledEntryButton = void 0;
    var o,
      i,
      a = n(2),
      s = n(0);
    t.StyledEntryButton = a.default("button")(o || (o = r(["\n    margin-top: auto;\n    margin-bottom: auto;\n    padding: 0px 12px;\n    width: 100%;\n    white-space: nowrap;\n    border: none;\n    background: none;\n    outline: none;\n    text-align: left;\n\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n    width: auto;\n\n    :hover,\n    :focus {\n        background: initial;\n    }\n    ", "\n"], ["\n    margin-top: auto;\n    margin-bottom: auto;\n    padding: 0px 12px;\n    width: 100%;\n    white-space: nowrap;\n    border: none;\n    background: none;\n    outline: none;\n    text-align: left;\n\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n    width: auto;\n\n    :hover,\n    :focus {\n        background: initial;\n    }\n    ", "\n"])), function (e) {
      return e.theme.TaskList.Filter.EntryButton;
    }), t.StyledToggleIcon = a.default(s.Icon)(i || (i = r(["\n    margin-left: 4px;\n    margin-top: auto;\n    margin-bottom: auto;\n"], ["\n    margin-left: 4px;\n    margin-top: auto;\n    margin-bottom: auto;\n"])));
  }, function (e, t) {
    e.exports = require("react-flip-move");
  }, function (e, t, n) {
    "use strict";

    var _r163,
      o = this && this.__extends || (_r163 = function r(e, t) {
        return (_r163 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r163(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListItem = void 0;
    var s = n(1),
      l = n(0),
      c = n(26),
      u = n(562),
      p = n(2),
      d = n(3),
      f = n(20),
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
          return s.createElement(m, i({}, this.props));
        }, t.displayName = u.displayName, t.Content = u.contentStore, t.defaultProps = {
          itemSize: "Small"
        }, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.TaskListItem = h;
    var m = c.withTaskContext(d.connect(function (e, t) {
      var n,
        r,
        o = f.TaskChannels.getForTask(t.task),
        i = o && o.componentProps && o.componentProps.TaskListItem && o.componentProps.TaskListItem.Badge;
      return i && (n = i.children, r = i.variant), {
        Badge: {
          children: "function" == typeof n ? n(e, t) : n,
          variant: "function" == typeof r ? r(e, t) : r
        }
      };
    })(p.withTheme(u.TaskListItemImpl)));
  }, function (e, t, n) {
    "use strict";

    var _r164,
      o = this && this.__extends || (_r164 = function r(e, t) {
        return (_r164 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r164(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListItemImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(249),
      c = n(149);
    t.displayName = "TaskListItem", t.contentStore = new s.DynamicContentStore(t.displayName);
    var u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.shouldComponentUpdate = function (e) {
        return !c(this.props, e);
      }, n.prototype.render = function () {
        var e = void 0 !== this.props.selected ? this.props.selected : this.props.selectedTaskSid === (this.props.task && this.props.task.sid),
          n = "Large" === (e && "LargeSelected" === this.props.itemSize ? "Large" : this.props.itemSize),
          r = i(i({}, this.props), {
            selected: e,
            large: n
          });
        return a.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: r,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          vertical: !0
        }, a.createElement(a.Fragment, null, a.createElement(s.DefaultContentFragment, null, a.createElement(l.TaskListBaseItem, i({}, r)))));
      }, n;
    }(a.Component);
    t.TaskListItemImpl = u;
  }, function (e, t, n) {
    "use strict";

    var _r165,
      o = this && this.__extends || (_r165 = function r(e, t) {
        return (_r165 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r165(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListBaseItemImpl = void 0;
    var i = n(1),
      a = n(8),
      s = n(251),
      l = n(17),
      c = n(0),
      u = n(252),
      p = n(250),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.refreshTimer = void 0, t.handleContainerClick = function (e) {
            t.props.onSelected && t.props.onSelected(t.props.task.sid);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          if (!this.props.visible) return null;
          var e = this.props,
            t = e.actions,
            n = e.firstLine,
            r = e.secondLine,
            o = e.extraInfo,
            d = e.selected,
            f = e.large,
            h = e.icon,
            m = e.iconColor,
            g = e.task,
            y = e.channelDefinition,
            v = new a.TaskHelper(g),
            b = d ? y.icons.active : y.icons.list;
          return i.createElement(s.Container, {
            className: "Twilio-TaskListBaseItem",
            iconColor: m || l.TaskChannelHelper.getColor(g, y.colors.main, p.TaskListBaseItem),
            onClick: this.handleContainerClick,
            selected: d,
            large: f,
            vertical: !0
          }, i.createElement(s.UpperArea, {
            className: "Twilio-TaskListBaseItem-UpperArea"
          }, i.createElement(s.IconAreaContainer, {
            className: "Twilio-TaskListBaseItem-IconAreaContainer"
          }, i.createElement(s.TaskListIcon, {
            className: "Twilio-TaskListBaseItem-IconArea",
            icon: h || l.TaskChannelHelper.getIcon(g, b, p.TaskListBaseItem),
            selected: d
          }), this.props.Badge && i.createElement(c.Badge, {
            variant: this.props.Badge.variant
          }, this.props.Badge.children)), i.createElement(s.Content, {
            className: "Twilio-TaskListBaseItem-Content"
          }, i.createElement(s.FirstLineContainer, {
            className: "Twilio-TaskListBaseItem-FirstLine"
          }, n || i.createElement(c.Template, {
            code: l.TaskChannelHelper.getTemplateForStatus(g, y.templates.TaskListItem.firstLine, p.TaskListBaseItem),
            task: g,
            helper: v
          })), i.createElement(s.SecondLineContainer, {
            className: "Twilio-TaskListBaseItem-SecondLine"
          }, r || i.createElement(s.SecondLineStyledTemplate, {
            code: l.TaskChannelHelper.getTemplateForStatus(g, y.templates.TaskListItem.secondLine, p.TaskListBaseItem),
            task: g,
            helper: v
          }))), i.createElement(s.ActionsContainer, {
            className: "Twilio-TaskListBaseItem-Actions"
          }, t || i.createElement(u.TaskListButtons, null))), f && i.createElement(s.LowerArea, {
            className: "Twilio-TaskListBaseItem-LowerArea"
          }, o || i.createElement(c.Template, {
            code: l.TaskChannelHelper.getTemplateForStatus(g, y.templates.TaskListItem.extraInfo, p.TaskListBaseItem),
            task: g,
            helper: v
          })));
        }, t.prototype.componentDidMount = function () {
          var e = this;
          this.refreshTimer = window.setInterval(function () {
            return e.forceUpdate();
          }, 1e3);
        }, t.prototype.componentWillUnmount = function () {
          void 0 !== this.refreshTimer && window.clearInterval(this.refreshTimer);
        }, t.defaultProps = {
          visible: !0
        }, t.displayName = "TaskListBaseItem", t;
      }(i.PureComponent);
    t.TaskListBaseItemImpl = d;
  }, function (e, t, n) {
    "use strict";

    var _r166,
      o = this && this.__extends || (_r166 = function r(e, t) {
        return (_r166 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r166(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListButtons = void 0;
    var a = n(1),
      s = n(26),
      l = n(565),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(u, i({}, this.props));
        }, t.displayName = l.displayName, t.Content = l.contentStore, t;
      }(a.PureComponent);
    t.TaskListButtons = c;
    var u = s.withTaskContext(l.TaskListButtonsImpl);
  }, function (e, t, n) {
    "use strict";

    var _r167,
      o = this && this.__extends || (_r167 = function r(e, t) {
        return (_r167 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r167(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListButtonsImpl = t.contentStore = t.displayName = void 0;
    var i = n(1),
      a = n(0),
      s = n(8),
      l = n(566),
      c = n(568),
      u = n(570),
      p = n(572);
    t.displayName = "TaskListButtons", t.contentStore = new a.DynamicContentStore(t.displayName);
    var d = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = e.call,
          r = e.task,
          o = !s.TaskHelper.isRegularConferenceCall(r) && !s.TaskHelper.isOutboundCallTask(r) || s.TaskHelper.isRegularConferenceCall(r) && 2 === r.conference.liveParticipantCount;
        return i.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0
        }, i.createElement(i.Fragment, null, s.TaskHelper.isPending(r) && !s.TaskHelper.isInitialOutboundAttemptTask(r) && i.createElement(a.ContentFragment, null, i.createElement(l.AcceptTaskButton, {
          key: "accept",
          task: r
        }), i.createElement(c.RejectTaskButton, {
          key: "reject",
          task: r
        })), !!n && i.createElement(a.ContentFragment, null, o && i.createElement(u.HoldCallTaskButton, {
          key: "hold",
          task: r
        }), i.createElement(p.HangupCallTaskButton, {
          key: "hangup",
          task: r
        }))));
      }, n;
    }(i.PureComponent);
    t.TaskListButtonsImpl = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AcceptTaskButton = void 0;
    var r = n(567);
    Object.defineProperty(t, "AcceptTaskButton", {
      enumerable: !0,
      get: function get() {
        return r.AcceptTaskButton;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r168,
      o = this && this.__extends || (_r168 = function r(e, t) {
        return (_r168 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r168(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AcceptTaskButton = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(4),
      u = n(6),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onClick = function (e) {
            u.tryInvokeAction("AcceptTask", {
              task: t.props.task
            }), e.preventDefault();
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return s.createElement(l.ActionStateListener, {
            action: ["AcceptTask", "RejectTask"],
            payload: {
              task: this.props.task
            }
          }, function (t) {
            return s.createElement(l.IconButton, {
              className: "Twilio-TaskButton-Accept",
              themeOverride: e.props.theme.TaskList.Item.Buttons.AcceptButton,
              onClick: e.onClick,
              icon: "Accept",
              disabled: t.disabled,
              title: c.templates.AcceptTaskTooltip()
            });
          });
        }, t = i([a.withTheme], t);
      }(s.PureComponent);
    t.AcceptTaskButton = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RejectTaskButton = void 0;
    var r = n(569);
    Object.defineProperty(t, "RejectTaskButton", {
      enumerable: !0,
      get: function get() {
        return r.RejectTaskButton;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r169,
      o = this && this.__extends || (_r169 = function r(e, t) {
        return (_r169 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r169(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RejectTaskButton = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(4),
      u = n(6),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onClick = function (e) {
            var n = t.props.task;
            u.tryInvokeAction("RejectTask", {
              task: n
            }), e.preventDefault();
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props.theme;
          return s.createElement(l.ActionStateListener, {
            action: ["AcceptTask", "RejectTask"],
            payload: {
              task: this.props.task
            }
          }, function (n) {
            return s.createElement(l.IconButton, {
              className: "Twilio-TaskButton-Reject",
              onClick: e.onClick,
              themeOverride: t.TaskList.Item.Buttons.RejectButton,
              icon: "Close",
              disabled: n.disabled,
              title: c.templates.RejectTaskTooltip()
            });
          });
        }, t = i([a.withTheme], t);
      }(s.PureComponent);
    t.RejectTaskButton = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HoldCallTaskButton = void 0;
    var r = n(571);
    Object.defineProperty(t, "HoldCallTaskButton", {
      enumerable: !0,
      get: function get() {
        return r.HoldCallTaskButton;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r170,
      o = this && this.__extends || (_r170 = function r(e, t) {
        return (_r170 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r170(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HoldCallTaskButton = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(4),
      u = n(8),
      p = n(77),
      d = n(6),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onClick = function (e) {
            var n = t.props.task;
            d.tryInvokeAction(t.isOnHold() ? "UnholdCall" : "HoldCall", {
              task: n
            }), e.preventDefault();
          }, t;
        }
        return o(t, e), t.prototype.isOnHold = function () {
          return u.TaskHelper.isCallOnHold(this.props.task);
        }, t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.task,
            r = t.theme,
            o = this.isOnHold();
          return s.createElement(l.ActionStateListener, {
            action: ["HoldCall", "UnholdCall"],
            payload: p.isValidVoiceActionPayload(n)
          }, function (t) {
            return s.createElement(l.IconButton, {
              disabled: t.disabled || !u.TaskHelper.canHold(n),
              className: "Twilio-TaskButton-Hold",
              onClick: e.onClick,
              themeOverride: r.TaskList.Item.Buttons.DefaultButton,
              icon: o ? "HoldOff" : "Hold",
              title: o ? c.templates.UnholdCustomerTooltip() : c.templates.HoldCustomerTooltip()
            });
          });
        }, t = i([a.withTheme], t);
      }(s.Component);
    t.HoldCallTaskButton = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HangupCallTaskButton = void 0;
    var r = n(573);
    Object.defineProperty(t, "HangupCallTaskButton", {
      enumerable: !0,
      get: function get() {
        return r.HangupCallTaskButton;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r171,
      o = this && this.__extends || (_r171 = function r(e, t) {
        return (_r171 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r171(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HangupCallTaskButton = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(4),
      u = n(77),
      p = n(6),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onClick = function (e) {
            var n = t.props.task;
            p.tryInvokeAction("HangupCall", {
              task: n
            }), e.preventDefault();
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.task,
            r = t.theme,
            o = n.conference && n.conference.liveParticipantCount > 2 ? "LeaveCall" : "Hangup";
          return s.createElement(l.ActionStateListener, {
            action: "HangupCall",
            payload: u.isValidVoiceActionPayload(n)
          }, function (t) {
            return s.createElement(l.IconButton, {
              className: "Twilio-TaskButton-Hangup",
              onClick: e.onClick,
              icon: o,
              themeOverride: r.TaskList.Item.Buttons.RejectButton,
              disabled: t.disabled,
              title: c.templates.HangupCallTooltip()
            });
          });
        }, t = i([a.withTheme], t);
      }(s.Component);
    t.HangupCallTaskButton = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RuntimeLookupResponse = t.RuntimeLoginView = t.QueuesStatsViewChildrenProps = t.QueuesStatsView = t.TeamsView = t.LoginFormView = t.LoginViewProps = t.LoginView = t.SplitterOrientation = t.AgentDesktopViewChildrenProps = t.AgentDesktopViewProps = t.AgentDesktopView = void 0;
    var r = n(253);
    Object.defineProperty(t, "AgentDesktopView", {
      enumerable: !0,
      get: function get() {
        return r.AgentDesktopView;
      }
    }), Object.defineProperty(t, "AgentDesktopViewProps", {
      enumerable: !0,
      get: function get() {
        return r.AgentDesktopViewProps;
      }
    }), Object.defineProperty(t, "AgentDesktopViewChildrenProps", {
      enumerable: !0,
      get: function get() {
        return r.AgentDesktopViewChildrenProps;
      }
    }), Object.defineProperty(t, "SplitterOrientation", {
      enumerable: !0,
      get: function get() {
        return r.SplitterOrientation;
      }
    });
    var o = n(607);
    Object.defineProperty(t, "LoginView", {
      enumerable: !0,
      get: function get() {
        return o.LoginView;
      }
    }), Object.defineProperty(t, "LoginViewProps", {
      enumerable: !0,
      get: function get() {
        return o.LoginViewProps;
      }
    });
    var i = n(152);
    Object.defineProperty(t, "LoginFormView", {
      enumerable: !0,
      get: function get() {
        return i.LoginFormView;
      }
    });
    var a = n(265);
    Object.defineProperty(t, "TeamsView", {
      enumerable: !0,
      get: function get() {
        return a.TeamsView;
      }
    });
    var s = n(275);
    Object.defineProperty(t, "QueuesStatsView", {
      enumerable: !0,
      get: function get() {
        return s.QueuesStatsView;
      }
    }), Object.defineProperty(t, "QueuesStatsViewChildrenProps", {
      enumerable: !0,
      get: function get() {
        return s.QueuesStatsViewChildrenProps;
      }
    });
    var l = n(667);
    Object.defineProperty(t, "RuntimeLoginView", {
      enumerable: !0,
      get: function get() {
        return l.RuntimeLoginView;
      }
    }), Object.defineProperty(t, "RuntimeLookupResponse", {
      enumerable: !0,
      get: function get() {
        return l.RuntimeLookupResponse;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r172,
      o = this && this.__extends || (_r172 = function r(e, t) {
        return (_r172 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r172(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.AgentDesktopView = void 0;
    var s = n(1),
      l = n(49),
      c = n(0),
      u = n(3),
      p = n(254),
      d = n(258),
      f = n(605),
      h = function (e) {
        function n() {
          var n = null !== e && e.apply(this, arguments) || this;
          return n.getBaseRoute = function () {
            return n.props.route.match && n.props.route.match.url.replace(/\/$/, "");
          }, n.renderChildren = function (e) {
            return s.createElement(t.Connected, i({}, n.props, {
              route: e
            }));
          }, n;
        }
        return o(n, e), n.updateAll = function () {}, n.prototype.render = function () {
          var e = this.getBaseRoute();
          return s.createElement(l.Route, {
            path: e + "/:taskSid?",
            children: this.renderChildren
          });
        }, n.displayName = f.displayName, n.Content = f.contentStore, n.Panel1 = p.Panel1, n.Panel2 = d.Panel2, n.defaultProps = {
          showPanel2: !0,
          splitterOptions: void 0
        }, n = a([c.withDefaultPropsUpdate], n);
      }(s.PureComponent);
    t.AgentDesktopView = h, t.Connected = u.connect(function (e) {
      return {
        tasks: e.worker.tasks
      };
    })(f.AgentDesktopViewImpl);
  }, function (e, t, n) {
    "use strict";

    var _r173,
      o = this && this.__extends || (_r173 = function r(e, t) {
        return (_r173 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r173(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListContainer = void 0;
    var s = n(1),
      l = n(0),
      c = n(8),
      u = n(578),
      p = function p(e) {
        return c.TaskHelper.isIncomingCall(e) || c.TaskHelper.isLiveCall(e);
      },
      d = [{
        text: "TaskFilterAll",
        callback: function callback(e) {
          return !p(e);
        }
      }, {
        text: "TaskFilterActive",
        callback: function callback(e) {
          return !p(e) && "accepted" === e.status;
        }
      }, {
        text: "TaskFilterWrapping",
        callback: function callback(e) {
          return !p(e) && "wrapping" === e.status;
        }
      }],
      f = function f(e) {
        return p(e);
      },
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
          return s.createElement(u.TaskListContainerImpl, i({}, this.props));
        }, t.displayName = u.displayName, t.defaultTaskFilters = d, t.defaultStaticTaskFilter = f, t.Content = u.contentStore, t.defaultProps = {
          taskFilters: d,
          staticTaskFilter: f
        }, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.TaskListContainer = h;
  }, function (e, t, n) {
    "use strict";

    var _r174,
      o = this && this.__extends || (_r174 = function r(e, t) {
        return (_r174 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r174(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskListContainerImpl = t.contentStore = t.displayName = void 0;
    var i = n(1),
      a = n(0),
      s = n(245),
      l = n(579);
    t.displayName = "TaskListsContainer", t.contentStore = new a.DynamicContentStore(t.displayName);
    var c = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        return i.createElement(a.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          vertical: !0
        }, i.createElement(l.Container, null, i.createElement(s.TaskList, {
          key: "tasklist",
          staticFilter: this.props.staticTaskFilter,
          filters: this.props.taskFilters,
          tasks: this.props.tasks,
          selectedTaskSid: this.props.selectedTaskSid,
          onTaskSelected: this.props.onTaskSelected
        })));
      }, n;
    }(i.PureComponent);
    t.TaskListContainerImpl = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(0),
      a = n(2);
    t.Container = a.default(i.FlexBoxColumn)(o || (o = r(["\n    overflow-y: auto;\n"], ["\n    overflow-y: auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r175,
      o = this && this.__extends || (_r175 = function r(e, t) {
        return (_r175 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r175(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.mapStateToProps = t.WorkerDirectory = void 0;
    var s = n(1),
      l = n(3),
      c = n(0),
      u = n(581),
      p = n(151),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(f, i({}, this.props));
        }, t.friendlyName = u.displayName, t.displayName = u.displayName, t.Content = u.contentStore, t.Tabs = p.WorkerDirectoryTabs, t = a([c.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.WorkerDirectory = d;
    t.mapStateToProps = function (e) {
      return {
        task: e.worker.tasks.get(e.view.selectedTaskSid),
        isOpen: e.view.isDirectoryOpen,
        isWarmTransferEnabled: !!e.config.warmTransfers && e.config.warmTransfers.enabled
      };
    };
    var f = l.connect(t.mapStateToProps)(u.WorkerDirectoryImpl);
  }, function (e, t, n) {
    "use strict";

    var _r176,
      o = this && this.__extends || (_r176 = function r(e, t) {
        return (_r176 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r176(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerDirectoryImpl = t.contentStore = t.displayName = void 0;
    var a = n(0),
      s = n(1),
      l = n(12),
      c = n(2),
      u = n(104),
      p = n(151);
    t.displayName = "WorkerDirectory", t.contentStore = new a.DynamicContentStore(t.displayName);
    var d = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onCloseClick = function () {
          l.TelemetryManager.reportTransferPanelClose(), a.Actions.invokeAction("HideDirectory");
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = e.isOpen,
          r = e.children,
          o = e.theme,
          i = e.isWarmTransferEnabled;
        return s.createElement(u.PopupContainer, {
          className: "Twilio-WorkerDirectory-Popup",
          isOpen: n,
          "data-test": "worker-directory"
        }, s.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: r,
          vertical: !0,
          noContainers: !0
        }, s.createElement(u.Container, {
          className: "Twilio-WorkerDirectory",
          vertical: !0
        }, s.createElement(u.HeaderPanel, {
          key: "header",
          className: "Twilio-WorkerDirectory-Header",
          noGrow: !0,
          noShrink: !0
        }, s.createElement(a.IconButton, {
          icon: "Close",
          onClick: this.onCloseClick,
          themeOverride: o.WorkerDirectory.Header.Button,
          "data-test": "worker-directory-close"
        }), s.createElement(u.LabelContainer, null, s.createElement(u.Label, null, s.createElement(a.Template, {
          source: a.templates.WorkerDirectoryTitle
        })))), n ? s.createElement(p.WorkerDirectoryTabs, {
          key: "tabs",
          isWarmTransferEnabled: i
        }) : null)));
      }, n = i([c.withTheme], n);
    }(s.PureComponent);
    t.WorkerDirectoryImpl = d;
  }, function (e, t, n) {
    "use strict";

    var _r177,
      o = this && this.__extends || (_r177 = function r(e, t) {
        return (_r177 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r177(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerDirectoryTabsImpl = t.contentStore = t.displayName = void 0;
    var l = n(0),
      c = n(1),
      u = n(11),
      p = n(32),
      d = n(12),
      f = n(3),
      h = n(10),
      m = n(73),
      g = n(6),
      y = n(37),
      v = n(2),
      b = n(583),
      C = n(587),
      _ = n(104),
      k = n(590);
    t.displayName = "WorkerDirectoryTabs", t.contentStore = new l.DynamicContentStore(t.displayName);
    var w = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.queueSearchInputElementRef = c.createRef(), t.workerSearchInputElementRef = c.createRef(), t.onTransferQueueClick = function (e) {
          return function (n) {
            g.tryInvokeAction("TransferTask", {
              task: t.props.task,
              targetSid: e.sid,
              options: n
            }), g.tryInvokeAction("HideDirectory");
          };
        }, t.onTransferClick = function (e) {
          return function (n) {
            g.tryInvokeAction("TransferTask", {
              task: t.props.task,
              targetSid: e.sid,
              options: n
            }), g.tryInvokeAction("HideDirectory");
          };
        }, t.makeWorkerQuery = function (e) {
          var n,
            r = e ? 'data.attributes.full_name contains "' + e + '"' : "";
          t.props.hiddenWorkerFilter && (r = r ? "(" + t.props.hiddenWorkerFilter + ") and (" + r + ")" : t.props.hiddenWorkerFilter), null === (n = t.workersSearch) || void 0 === n || n.search(r);
        }, t.makeQueueQuery = function (e) {
          var n,
            r = e ? 'data.queue_name contains "' + e + '"' : "";
          t.props.hiddenQueueFilter && (r = r ? "(" + t.props.hiddenQueueFilter + ") and (" + r + ")" : t.props.hiddenQueueFilter), null === (n = t.queuesSearch) || void 0 === n || n.search(r);
        }, t.onWorkerSearchInputChange = function () {
          t.workersSearch && !t.workerSearchTimer && (t.workerSearchTimer = window.setTimeout(function () {
            if (null != t.workerSearchInputElementRef.current) {
              var e = t.workerSearchInputElementRef.current;
              t.makeWorkerQuery(null == e ? void 0 : e.value), t.workerSearchTimer = null;
            }
          }, 300));
        }, t.onQueueSearchInputChange = function () {
          t.queuesSearch && !t.queueSearchTimer && (t.queueSearchTimer = window.setTimeout(function () {
            if (null != t.queueSearchInputElementRef.current) {
              var e = t.queueSearchInputElementRef.current;
              t.makeQueueQuery(null == e ? void 0 : e.value), t.queueSearchTimer = null;
            }
          }, 300));
        }, t.state = {
          workers: [],
          queues: []
        }, t;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        return a(this, void 0, void 0, function () {
          var e,
            t,
            n = this;
          return s(this, function (r) {
            switch (r.label) {
              case 0:
                return !f.FlexModule.insightsClient || p.FlexClientManager.isDegraded(f.FlexModule.insightsClient) ? [2] : (e = this, [4, f.FlexModule.insightsClient.instantQuery("tr-worker")]);
              case 1:
                return e.workersSearch = r.sent().on("searchResult", function (e) {
                  var t = [];
                  Object.keys(e).forEach(function (n) {
                    var r;
                    if (n !== (null === (r = f.FlexModule.state.worker.source) || void 0 === r ? void 0 : r.sid)) {
                      var o = e[n],
                        i = new m.InsightsWorker(o);
                      y.InsightsEntityCache.updateCache(i), t.push(i);
                    }
                  }), t.sort(function (e, t) {
                    var n = e.fullName || "",
                      r = t.fullName || "";
                    return n.localeCompare(r);
                  }), n.setState({
                    workers: t
                  });
                }), this.makeWorkerQuery(), t = this, [4, f.FlexModule.insightsClient.instantQuery("tr-queue")];
              case 2:
                return t.queuesSearch = r.sent().on("searchResult", function (e) {
                  var t = [];
                  Object.keys(e).forEach(function (n) {
                    var r = e[n],
                      o = new m.InsightsQueue(r);
                    y.InsightsEntityCache.updateCache(o), t.push(o);
                  }), t.sort(function (e, t) {
                    var n = e.name || "",
                      r = t.name || "";
                    return n.localeCompare(r);
                  }), n.setState({
                    queues: t
                  });
                }), this.makeQueueQuery(), [2];
            }
          });
        });
      }, n.prototype.render = function () {
        var e = this,
          n = this.props.task;
        return c.createElement(l.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          vertical: !0,
          noContainers: !0
        }, c.createElement(l.Tabs, {
          key: "tabs",
          className: "Twilio-WorkerDirectory-Tabs"
        }, c.createElement(l.Tab, {
          key: "workers",
          label: c.createElement(l.Template, {
            source: l.templates.WorkerDirectoryAgentsTabLabel,
            onClick: function onClick() {
              d.TelemetryManager.reportDirectoryTabClick("agents");
            }
          })
        }, c.createElement(_.TabContainer, {
          key: "workers-container"
        }, c.createElement(_.InputContainer, {
          key: "workers-input-container"
        }, c.createElement(_.StyledInput, {
          key: "workers-input-field",
          inputRef: this.workerSearchInputElementRef,
          onChange: this.onWorkerSearchInputChange,
          placeholder: l.templates.WorkerDirectorySearchPlaceholder(),
          "data-test": "TransferCatalogue-WorkerSearch"
        })), c.createElement(_.ItemContainer, {
          key: "item-container",
          className: "Twilio-WorkerDirectory-Workers",
          vertical: !0
        }, Array.from(this.state.workers).map(function (t) {
          return c.createElement(k.WorkerItem, {
            worker: t,
            key: t.sid,
            isWarmTransferEnabled: e.props.isWarmTransferEnabled,
            onTransferClick: e.onTransferClick(t)
          });
        })))), c.createElement(l.Tab, {
          key: "queues",
          label: c.createElement(l.Template, {
            source: l.templates.WorkerDirectoryQueuesTabLabel,
            onClick: function onClick() {
              d.TelemetryManager.reportDirectoryTabClick("queues");
            }
          })
        }, c.createElement(_.TabContainer, {
          key: "queues-container"
        }, c.createElement(_.InputContainer, {
          key: "queues-input-container"
        }, c.createElement(_.StyledInput, {
          key: "queues-input-field",
          inputRef: this.queueSearchInputElementRef,
          onChange: this.onQueueSearchInputChange,
          placeholder: l.templates.WorkerDirectorySearchPlaceholder(),
          "data-test": "TransferCatalogue-QueueSearch"
        })), c.createElement(_.ItemContainer, {
          key: "item-container",
          className: "Twilio-WorkerDirectory-Queues",
          vertical: !0
        }, Array.from(this.state.queues).map(function (t) {
          return c.createElement(C.QueueItem, {
            queue: t,
            key: t.sid,
            isWarmTransferEnabled: e.props.isWarmTransferEnabled,
            onTransferClick: e.onTransferQueueClick(t)
          });
        })))), u.FeatureFlags.isEnabled(h.FeatureFlag.ExternalWarmTransfers) && c.createElement(l.Tab, {
          key: "directory",
          label: c.createElement(l.Template, {
            source: l.templates.WorkerDirectoryDialpadTabLabel,
            onClick: function onClick() {
              d.TelemetryManager.reportDirectoryTabClick("xwt");
            }
          })
        }, c.createElement(_.TabContainer, {
          key: "directory-container"
        }, c.createElement(b.ExternalTransferDialpad, {
          task: n
        })))));
      }, n = i([v.withTheme], n);
    }(c.PureComponent);
    t.WorkerDirectoryTabsImpl = w;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ExternalTransferDialpad = void 0;
    var r = n(584);
    Object.defineProperty(t, "ExternalTransferDialpad", {
      enumerable: !0,
      get: function get() {
        return r.ExternalTransferDialpad;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r178,
      o = this && this.__extends || (_r178 = function r(e, t) {
        return (_r178 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r178(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ExternalTransferDialpad = void 0;
    var s = n(0),
      l = n(41),
      c = n(1),
      u = n(19),
      p = n(6),
      d = n(585),
      f = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.onPhoneNumberChange = function (e) {
            n.setState({
              phoneNumber: e
            });
          }, n.onDial = function (e) {
            return i(n, void 0, void 0, function () {
              var t, n, r;
              return a(this, function (o) {
                switch (o.label) {
                  case 0:
                    return t = this.props.task, n = u.Manager.getInstance().serviceConfiguration.outbound_call_flows, this.setState({
                      isLoading: !0
                    }), p.tryInvokeAction("HideDirectory"), [4, p.tryInvokeAction("StartExternalWarmTransfer", {
                      task: t,
                      phoneNumber: e,
                      callerId: null === (r = null == n ? void 0 : n.default) || void 0 === r ? void 0 : r.caller_id
                    })];
                  case 1:
                    return o.sent(), this.setState({
                      isLoading: !1
                    }), [2];
                }
              });
            });
          }, n.state = {
            phoneNumber: "",
            isLoading: !1
          }, n;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t = this,
            n = this.state,
            r = n.phoneNumber,
            o = n.isLoading,
            i = u.Manager.getInstance().serviceConfiguration.outbound_call_flows,
            a = null === (e = null == i ? void 0 : i.default) || void 0 === e ? void 0 : e.location;
          return c.createElement(d.Container, null, c.createElement(d.Label, null, "Enter New Number"), c.createElement(s.Dialer, {
            key: "dialer",
            onDial: this.onDial,
            onPhoneNumberChange: this.onPhoneNumberChange,
            defaultPhoneNumber: r,
            defaultCountryAlpha2Code: a,
            hideActions: !0,
            disabled: !1
          }), c.createElement(d.CallControls, null, c.createElement(d.CallButton, {
            "data-test": "external-dialer-submit",
            id: "call",
            key: "call-button",
            icon: "Call",
            disabled: o || !r,
            onClick: function onClick() {
              return t.onDial(t.state.phoneNumber);
            },
            themeOverride: this.props.theme && this.props.theme.Dialer.CallButton
          }), o && c.createElement(d.CallAnimation, null, c.createElement(s.ConnectingAnimation, {
            sizeMultiplier: 2
          }))));
        }, t;
      }(c.Component),
      h = l.withTheme(f);
    t.ExternalTransferDialpad = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallAnimation = t.CallControls = t.CallButton = t.Label = t.BackLink = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u = n(586),
      p = n(0),
      d = n(2);
    t.Container = d.default("div")(o || (o = r(["\n    padding: 12px 12px 0 12px;\n"], ["\n    padding: 12px 12px 0 12px;\n"]))), t.BackLink = d.default(u.default)(i || (i = r(["\n    color: ", ";\n    font-size: 12px;\n    line-height: 20px;\n    margin: 0 0 12px 0;\n    text-decoration: underline;\n"], ["\n    color: ", ";\n    font-size: 12px;\n    line-height: 20px;\n    margin: 0 0 12px 0;\n    text-decoration: underline;\n"])), function (e) {
      return e.theme.colors.flexBlueColor;
    }), t.Label = d.default("label")(a || (a = r(["\n    display: block;\n    font-size: 10px;\n    letter-spacing: 2px;\n    line-height: 14px;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n"], ["\n    display: block;\n    font-size: 10px;\n    letter-spacing: 2px;\n    line-height: 14px;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n"]))), t.CallButton = d.default(p.IconButton)(s || (s = r(["\n    box-sizing: content-box;\n    padding: 8px;\n    ", ";\n    ", ";\n    ", ";\n"], ["\n    box-sizing: content-box;\n    padding: 8px;\n    ", ";\n    ", ";\n    ", ";\n"])), function (e) {
      return e.theme.Dialer.CallButton;
    }, function (e) {
      return e.disabled && e.theme.Dialer.CallButton.disabled;
    }, function (e) {
      return p.getBackgroundWithHoverCSS(e.theme.Dialer.CallButton.backgroundColor, e.theme.Dialer.CallButton.lightHover, !1, e.disabled);
    }), t.CallControls = d.default("div")(l || (l = r(["\n    justify-content: center;\n    display: flex;\n    margin-top: 24px;\n    position: relative;\n"], ["\n    justify-content: center;\n    display: flex;\n    margin-top: 24px;\n    position: relative;\n"]))), t.CallAnimation = d.default("div")(c || (c = r(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"])));
  }, function (e, t) {
    e.exports = require("@material-ui/core/ButtonBase");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueueItemProps = t.QueueItem = void 0;
    var r = n(588);
    Object.defineProperty(t, "QueueItem", {
      enumerable: !0,
      get: function get() {
        return r.QueueItem;
      }
    }), Object.defineProperty(t, "QueueItemProps", {
      enumerable: !0,
      get: function get() {
        return r.QueueItemProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r179,
      o = this && this.__extends || (_r179 = function r(e, t) {
        return (_r179 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r179(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueueItem = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(4),
      u = n(104),
      p = n(589),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onWarmTransferClick = function (e) {
            t.props.onTransferClick({
              mode: "WARM"
            });
          }, t.onColdTransferClick = function (e) {
            t.props.onTransferClick({
              mode: "COLD"
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.queue,
            n = e.isWarmTransferEnabled;
          return s.createElement(u.ItemInnerContainer, {
            className: "Twilio-WorkerDirectory-Queue",
            noGrow: !0,
            noShrink: !0
          }, s.createElement(p.QueueAvatar, {
            noGrow: !0,
            noShrink: !0,
            className: "Twilio-WorkerDirectory-QueueAvatar"
          }, s.createElement(l.Icon, {
            icon: "Queue"
          })), s.createElement(p.QueueTitleContainer, {
            className: "Twilio-WorkerDirectory-QueueContent"
          }, s.createElement(l.Template, {
            source: c.templates.WorkerDirectoryQueueItemText,
            queue: t
          })), s.createElement(u.ButtonContainer, {
            className: "Twilio-WorkerDirectory-ButtonContainer"
          }, n && s.createElement(u.CallButton, {
            icon: "Call",
            onClick: this.onWarmTransferClick,
            themeOverride: this.props.theme.WorkerDirectory.ItemActionButton,
            title: c.templates.WarmTransferTooltip()
          }), s.createElement(l.IconButton, {
            icon: "Transfer",
            onClick: this.onColdTransferClick,
            themeOverride: this.props.theme.WorkerDirectory.ItemActionButton,
            title: c.templates.ColdTransferTooltip()
          })));
        }, t = i([a.withTheme], t);
      }(s.Component);
    t.QueueItem = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueueAvatar = t.QueueTitleContainer = void 0;
    var o,
      i,
      a = n(2),
      s = n(0);
    t.QueueTitleContainer = a.default("div")(o || (o = r(["\n    flex: 1 1 auto;\n    overflow: hidden;\n    margin-top: auto;\n    margin-bottom: auto;\n    margin-left: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 12px;\n    font-weight: bold;\n"], ["\n    flex: 1 1 auto;\n    overflow: hidden;\n    margin-top: auto;\n    margin-bottom: auto;\n    margin-left: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 12px;\n    font-weight: bold;\n"]))), t.QueueAvatar = a.default(s.FlexBox)(i || (i = r(["\n    width: 44px;\n    justify-content: center;\n    ", ";\n"], ["\n    width: 44px;\n    justify-content: center;\n    ", ";\n"])), function (e) {
      return e.theme.WorkerDirectory.QueueItem.Avatar;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TransferClickPayload = t.WorkerItemProps = t.WorkerItem = void 0;
    var r = n(591);
    Object.defineProperty(t, "WorkerItem", {
      enumerable: !0,
      get: function get() {
        return r.WorkerItem;
      }
    }), Object.defineProperty(t, "WorkerItemProps", {
      enumerable: !0,
      get: function get() {
        return r.WorkerItemProps;
      }
    }), Object.defineProperty(t, "TransferClickPayload", {
      enumerable: !0,
      get: function get() {
        return r.TransferClickPayload;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r180,
      o = this && this.__extends || (_r180 = function r(e, t) {
        return (_r180 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r180(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerItem = void 0;
    var a = n(1),
      s = n(0),
      l = n(2),
      c = n(4),
      u = n(104),
      p = n(592),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onWarmTransferClick = function (e) {
            t.props.onTransferClick({
              mode: "WARM"
            });
          }, t.onColdTransferClick = function (e) {
            t.props.onTransferClick({
              mode: "COLD"
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.worker,
            n = e.isWarmTransferEnabled;
          return a.createElement(u.ItemInnerContainer, {
            className: "Twilio-WorkerDirectory-Worker",
            noGrow: !0,
            noShrink: !0
          }, a.createElement(p.WorkerMarginPlaceholder, {
            noGrow: !0,
            noShrink: !0
          }), a.createElement(s.UserCard, {
            className: "Twilio-WorkerDirectory-UserCard",
            firstLine: a.createElement(s.Template, {
              source: c.templates.WorkerDirectoryItemFirstLine,
              worker: t
            }),
            secondLine: a.createElement(s.Template, {
              source: c.templates.WorkerDirectoryItemSecondLine,
              worker: t
            }),
            isAvailable: t.isAvailable,
            imageUrl: t.attributes.image_url,
            large: !0
          }), a.createElement(u.ButtonContainer, {
            className: "Twilio-WorkerDirectory-ButtonContainer"
          }, n && a.createElement(u.CallButton, {
            icon: "Call",
            onClick: this.onWarmTransferClick,
            themeOverride: this.props.theme.WorkerDirectory.ItemActionButton,
            title: c.templates.WarmTransferTooltip(),
            disabled: !t.isAvailable
          }), a.createElement(s.IconButton, {
            icon: "Transfer",
            onClick: this.onColdTransferClick,
            themeOverride: this.props.theme.WorkerDirectory.ItemActionButton,
            title: c.templates.ColdTransferTooltip(),
            disabled: !t.isAvailable
          })));
        }, t = i([l.withTheme], t);
      }(a.Component);
    t.WorkerItem = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerMarginPlaceholder = void 0;
    var o,
      i = n(2),
      a = n(0);
    t.WorkerMarginPlaceholder = i.default(a.FlexBox)(o || (o = r(["\n    width: 6px;\n"], ["\n    width: 6px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ContentSplitterProps = t.ContentSplitter = void 0;
    var r = n(595);
    Object.defineProperty(t, "ContentSplitter", {
      enumerable: !0,
      get: function get() {
        return r.ContentSplitter;
      }
    }), Object.defineProperty(t, "ContentSplitterProps", {
      enumerable: !0,
      get: function get() {
        return r.ContentSplitterProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r181,
      o = this && this.__extends || (_r181 = function r(e, t) {
        return (_r181 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r181(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ContentSplitter = void 0;
    var i = n(1),
      a = n(0),
      s = n(3),
      l = n(28),
      c = n(596),
      u = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleSelectedViewChanged = function (e, n) {
            n || t.handleSplitterNeedsUpdate();
          }, t.handleSplitterNeedsUpdate = function () {
            setTimeout(function () {
              t.splitter && t.splitter.reInit();
            }, 0);
          }, t.makeSplitterRef = function (e) {
            t.splitter = e;
          }, t.handleResize = function () {
            s.FlexModule.events.emitSplitterResize();
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          s.FlexModule.events.addListener(l.FlexEvent.flexSplitterResize, this.handleSplitterNeedsUpdate), s.FlexModule.events.addListener(l.FlexEvent.viewResized, this.handleSplitterNeedsUpdate), s.FlexModule.events.addListener(l.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged);
        }, t.prototype.componentWillUnmount = function () {
          s.FlexModule.events.removeListener(l.FlexEvent.flexSplitterResize, this.handleSplitterNeedsUpdate), s.FlexModule.events.removeListener(l.FlexEvent.viewResized, this.handleSplitterNeedsUpdate), s.FlexModule.events.removeListener(l.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged);
        }, t.prototype.render = function () {
          var e = this,
            n = {
              vertical: !0,
              primMin: "20%",
              secMin: "100",
              initial: window.innerHeight > 600 ? "35%" : "20%"
            };
          this.props.vertical || (n = {
            vertical: !1,
            primMin: "276",
            secMin: "276",
            initial: "320"
          });
          return i.createElement(a.SplitContentContainer, {
            ref: this.makeSplitterRef,
            vertical: this.props.vertical,
            firstMinSize: n.primMin,
            secondMinSize: n.secMin,
            firstInitialSize: n.initial,
            separator: e.props.vertical ? i.createElement(c.SplitterSeparator, null, i.createElement(a.Icon, {
              icon: "Resize"
            })) : i.createElement(c.SplitterSeparatorVertical, null),
            lastSplitterState: t.lastSplitterState,
            onResize: this.handleResize
          }, this.props.children);
        }, t.lastSplitterState = new a.LastSplitterState(), t;
      }(i.PureComponent);
    t.ContentSplitter = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SplitterSeparatorVertical = t.SplitterSeparator = void 0;
    var o,
      i,
      a = n(2);
    t.SplitterSeparator = a.default("div")(o || (o = r(["\n    display: flex;\n    border-style: solid;\n    border-width: 1px 0 1px 0;\n    height: 24px;\n    width: 100%;\n    div {\n        margin: auto;\n    }\n    ", "\n"], ["\n    display: flex;\n    border-style: solid;\n    border-width: 1px 0 1px 0;\n    height: 24px;\n    width: 100%;\n    div {\n        margin: auto;\n    }\n    ", "\n"])), function (e) {
      return e.theme.AgentDesktopView.ContentSplitter;
    }), t.SplitterSeparatorVertical = a.default("div")(i || (i = r(["\n    height: 100%;\n    width: 1px;\n    background: ", ";\n"], ["\n    height: 100%;\n    width: 1px;\n    background: ", ";\n"])), function (e) {
      return e.theme.AgentDesktopView.ContentSplitter.borderColor;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LeftPanelRootContainer = void 0;
    var o,
      i = n(2);
    t.LeftPanelRootContainer = i.default("div")(o || (o = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    width: 100%;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    width: 100%;\n    ", "\n"])), function (e) {
      return e.theme.AgentDesktopView.Panel1;
    });
  }, function (e, t, n) {
    "use strict";

    var _r182,
      o = this && this.__extends || (_r182 = function r(e, t) {
        return (_r182 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r182(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Panel2 = void 0;
    var i = n(1),
      a = n(0),
      s = n(259),
      l = n(604),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(a.DynamicComponent, {
            name: t.friendlyName,
            contentStore: t.Content,
            childProps: this.props,
            customChildren: this.props.children,
            vertical: !0
          }, i.createElement(l.RightPanelRootContainer, null, i.createElement(s.CRMContainer, {
            key: "container"
          })));
        }, t.friendlyName = "AgentDesktopView.Panel2", t.displayName = t.friendlyName, t.Content = new a.DynamicContentStore(t.friendlyName), t;
      }(i.PureComponent);
    t.Panel2 = c;
  }, function (e, t, n) {
    "use strict";

    var _r183,
      o = this && this.__extends || (_r183 = function r(e, t) {
        return (_r183 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r183(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      l = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || a(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.CRMContainer = void 0;
    var c = n(1),
      u = n(0),
      p = n(15),
      d = n(600),
      f = n(2);
    l(n(260), t);
    var h = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.updateAll = function () {}, n.prototype.render = function () {
        return c.createElement(t.Connected, i({}, this.props));
      }, n.displayName = d.displayName, n.Content = d.contentStore, n.defaultProps = {
        uriCallback: void 0,
        uri: void 0
      }, n = s([u.withDefaultPropsUpdate], n);
    }(c.PureComponent);
    t.CRMContainer = h, t.Connected = f.withTheme(p.withTaskContext(d.CRMContainerImpl));
  }, function (e, t, n) {
    "use strict";

    var _r184,
      o = this && this.__extends || (_r184 = function r(e, t) {
        return (_r184 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r184(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CRMContainerImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(260),
      c = n(601);
    t.displayName = "CRMContainer", t.contentStore = new s.DynamicContentStore(t.displayName);
    var u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        var e = i(i({}, this.props), {
          uri: this.props.uri || (this.props.uriCallback ? this.props.uriCallback(this.props.task) : void 0)
        });
        return a.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: e,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, a.createElement(l.Container, null, !e.uri && a.createElement(c.CRMPlaceHolderView, {
          key: "placeholder"
        }), !!e.uri && a.createElement("iframe", {
          title: "CRMContainer",
          key: "iframe",
          src: e.uri
        })));
      }, n;
    }(a.PureComponent);
    t.CRMContainerImpl = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CRMPlaceHolderView = void 0;
    var r = n(602);
    Object.defineProperty(t, "CRMPlaceHolderView", {
      enumerable: !0,
      get: function get() {
        return r.CRMPlaceHolderView;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r185,
      o = this && this.__extends || (_r185 = function r(e, t) {
        return (_r185 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r185(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CRMPlaceHolderView = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(4),
      u = n(603),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleButtonClick = function () {
            window.open("https://www.twilio.com/docs/flex/ui-configuration-customization#configure-a-crm-integration", "_blank");
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.CRMContainerPlaceholder, {
            className: "Twilio-CRMContainer-PlaceHolder"
          }, s.createElement(u.FirstLineContainer, null, s.createElement(u.FirstLine, null, s.createElement(l.Template, {
            source: c.templates.NoCRMTitle
          }))), s.createElement(u.SecondLine, null, " ", s.createElement(l.Template, {
            source: c.templates.NoCRMConfigured
          }), " "), s.createElement(u.HintLine, null, " ", s.createElement(l.Template, {
            source: c.templates.NoCRMHint
          }), " "), s.createElement(u.StyledIcon, {
            icon: "NoCRM",
            sizeMultiplier: 3
          }), s.createElement(l.Button, {
            roundCorners: !1,
            onClick: this.handleButtonClick,
            themeOverride: this.props.theme.CRMContainer.Placeholder.Button
          }, s.createElement(l.Template, {
            source: c.templates.NoCRMConfiguredAction
          })));
        }, t = i([a.withTheme], t);
      }(s.PureComponent);
    t.CRMPlaceHolderView = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CRMContainerPlaceholder = t.StyledIcon = t.NameLine = t.HintLine = t.SecondLine = t.FirstLine = t.FirstLineContainer = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p = n(0),
      d = n(2);
    t.FirstLineContainer = d.default("div")(o || (o = r(["\n    border-style: solid;\n    border-width: 0px 0px 4px 0px;\n    border-color: ", ";\n"], ["\n    border-style: solid;\n    border-width: 0px 0px 4px 0px;\n    border-color: ", ";\n"])), function (e) {
      return e.theme.colors.flexBlueColor;
    }), t.FirstLine = d.default("div")(i || (i = r(["\n    font-size: 10px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    margin: 0px 12px 4px 12px;\n"], ["\n    font-size: 10px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    margin: 0px 12px 4px 12px;\n"]))), t.SecondLine = d.default("div")(a || (a = r(["\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-align: center;\n    margin: 34px 20px 0px 20px;\n"], ["\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-align: center;\n    margin: 34px 20px 0px 20px;\n"]))), t.HintLine = d.default("div")(s || (s = r(["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 16px 20px;\n    text-align: center;\n    ", "\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 16px 20px;\n    text-align: center;\n    ", "\n"])), function (e) {
      return e.theme.CRMContainer.Placeholder.Hint;
    }), t.NameLine = d.default("div")(l || (l = r(["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 0px 20px;\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 0px 20px;\n"]))), t.StyledIcon = d.default(p.Icon)(c || (c = r(["\n    ", "\n    margin-bottom: 26px;\n"], ["\n    ", "\n    margin-bottom: 26px;\n"])), function (e) {
      return e.theme.CRMContainer.Placeholder.Icon;
    }), t.CRMContainerPlaceholder = d.default("div")(u || (u = r(["\n    flex: 1 1 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    ", "\n"], ["\n    flex: 1 1 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    ", "\n"])), function (e) {
      return e.theme.CRMContainer.Placeholder.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RightPanelRootContainer = void 0;
    var o,
      i = n(0),
      a = n(2);
    t.RightPanelRootContainer = a.default(i.FlexBoxColumn)(o || (o = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.AgentDesktopView.Panel2;
    });
  }, function (e, t, n) {
    "use strict";

    var _r186,
      o = this && this.__extends || (_r186 = function r(e, t) {
        return (_r186 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r186(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AgentDesktopViewImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(3),
      c = n(28),
      u = n(606),
      p = n(15),
      d = n(254),
      f = n(258),
      h = n(2),
      m = n(14),
      g = n(6);
    t.displayName = "AgentDesktopView", t.contentStore = new s.DynamicContentStore(t.displayName);
    var y = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.notificationFilter = function (e) {
          return !t.props.isViewActive || e.id !== m.IncomingTask;
        }, t.handleSelectedViewChanged = function (e, n) {
          n || t.handleSplitterNeedsUpdate();
        }, t.handleSplitterNeedsUpdate = function () {
          setTimeout(function () {
            t.splitter && (t.splitter.reInit(), t.forceUpdate());
          }, 0);
        }, t.handleResize = function () {
          l.FlexModule.events.emitSplitterResize();
        }, t.makeSplitterRef = function (e) {
          t.splitter = e;
        }, t;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        l.FlexModule.events.addListener(c.FlexEvent.flexSplitterResize, this.handleSplitterNeedsUpdate), l.FlexModule.events.addListener(c.FlexEvent.viewResized, this.handleSplitterNeedsUpdate), l.FlexModule.events.addListener(c.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), this.removeFilter = s.Notifications.handlers.inapp.addFilter(this.notificationFilter);
      }, n.prototype.componentWillUnmount = function () {
        l.FlexModule.events.removeListener(c.FlexEvent.flexSplitterResize, this.handleSplitterNeedsUpdate), l.FlexModule.events.removeListener(c.FlexEvent.viewResized, this.handleSplitterNeedsUpdate), l.FlexModule.events.removeListener(c.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), this.removeFilter();
      }, n.prototype.componentDidUpdate = function (e) {
        this.props.isViewActive && !e.isViewActive && s.Notifications.dismissNotificationById(m.IncomingTask);
        var t = this.getTaskSidFromRoute(this.props.route);
        t && this.props.isViewActive && !l.FlexModule.state.worker.tasks.get(t) && setTimeout(function () {
          g.tryInvokeAction("SelectTask", {
            task: null
          });
        }, 0);
      }, n.prototype.getTaskSidFromRoute = function (e) {
        return e.match && e.match.params.taskSid;
      }, n.prototype.renderContents = function (e) {
        var t = {
          selectedTaskSid: e,
          route: this.props.route,
          tasks: this.props.tasks
        };
        if (!this.props.showPanel2) return a.createElement(d.Panel1, i({
          key: "splitter"
        }, t));
        var r = this.props.splitterOptions ? this.props.splitterOptions : {};
        return a.createElement(s.SplitContentContainer, {
          key: "splitter",
          onResize: this.handleResize,
          ref: this.makeSplitterRef,
          firstInitialSize: r.initialFirstPanelSize || "50%",
          firstMinSize: r.minimumFirstPanelSize || "276",
          secondMinSize: r.minimumSecondPanelSize || "40%",
          vertical: !1,
          separator: a.createElement(u.SplitterSeparator, null),
          lastSplitterState: n.splitterState
        }, a.createElement(v, i({
          key: "panel1"
        }, t)), a.createElement(b, i({
          key: "panel2"
        }, t)));
      }, n.prototype.render = function () {
        var e = this.getTaskSidFromRoute(this.props.route);
        return a.createElement(p.TaskContextSource, {
          key: "container",
          taskSid: e
        }, a.createElement(s.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children
        }, a.createElement(s.ContentFragment, {
          align: "start"
        }, this.renderContents(e))));
      }, n.splitterState = new s.LastSplitterState(), n;
    }(a.PureComponent);
    t.AgentDesktopViewImpl = y;
    var v = h.withTheme(d.Panel1),
      b = h.withTheme(f.Panel2);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SplitterSeparator = void 0;
    var o,
      i = n(2);
    t.SplitterSeparator = i.default("div")(o || (o = r(["\n    height: 100%;\n    width: 0;\n    background: ", ";\n"], ["\n    height: 100%;\n    width: 0;\n    background: ", ";\n"])), function (e) {
      return e.theme.AgentDesktopView.ContentSplitter.borderColor;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginViewProps = t.LoginView = void 0;
    var r = n(608);
    Object.defineProperty(t, "LoginView", {
      enumerable: !0,
      get: function get() {
        return r.LoginView;
      }
    }), Object.defineProperty(t, "LoginViewProps", {
      enumerable: !0,
      get: function get() {
        return r.LoginViewProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r187,
      o = this && this.__extends || (_r187 = function r(e, t) {
        return (_r187 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r187(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      l = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || a(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginView = void 0;
    var c = n(1),
      u = n(0),
      p = n(3),
      d = n(609);
    l(n(261), t);
    var f = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return c.createElement(h, i({}, this.props));
      }, t.displayName = "LoginView", t.defaultProps = {
        logoUrl: void 0
      }, t = s([u.withDefaultPropsUpdate], t);
    }(c.PureComponent);
    t.LoginView = f;
    var h = p.connect(function (e) {
      return {
        session: e.session,
        ssoConfig: e.config.sso
      };
    })(d.LoginViewImpl);
  }, function (e, t, n) {
    "use strict";

    var _r188,
      o = this && this.__extends || (_r188 = function r(e, t) {
        return (_r188 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r188(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginViewImpl = void 0;
    var a = n(0),
      s = n(1),
      l = n(96),
      c = n(39),
      u = n(4),
      p = n(2),
      d = n(261),
      f = n(610),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleLoginClick = function () {
            var e = t.props.ssoConfig;
            return l.SSOLoginHandler.create(e).then(function (e) {
              c.Actions.ssoLogin(e);
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.session,
            n = e.logoUrl;
          return s.createElement(d.Container, {
            className: "Twilio-LoginView-Container"
          }, s.createElement(d.LogoContainer, {
            className: "Twilio-LoginView-LogoContainer"
          }, s.createElement(f.LoginLogo, {
            url: n
          })), s.createElement(d.ControlsContainer, {
            className: "Twilio-LoginView-Controls"
          }, t.loginState !== c.LoginState.LoggingIn && s.createElement(d.LoginButton, {
            className: "Twilio-LoginView-LoginButton",
            themeOverride: this.props.theme.LoginView.LoginButton,
            onClick: this.handleLoginClick,
            roundCorners: !1
          }, s.createElement(a.Template, {
            source: u.templates.LoginLogin
          })), t.loginState === c.LoginState.LoggingIn && s.createElement(d.LoadingContainer, {
            className: "Twilio-LoginView-Loading"
          }, s.createElement(a.Template, {
            source: u.templates.LoginLoading
          }))));
        }, t = i([p.withTheme], t);
      }(s.PureComponent);
    t.LoginViewImpl = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginLogo = void 0;
    var r = n(611);
    Object.defineProperty(t, "LoginLogo", {
      enumerable: !0,
      get: function get() {
        return r.LoginLogo;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r189,
      o = this && this.__extends || (_r189 = function r(e, t) {
        return (_r189 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r189(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginLogo = void 0;
    var i = n(1),
      a = n(0),
      s = n(612),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.url;
          return e ? i.createElement(s.LoginLogoImage, {
            src: e
          }) : i.createElement(a.Icon, {
            icon: "Twilio",
            sizeMultiplier: 3
          });
        }, t;
      }(i.PureComponent);
    t.LoginLogo = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginLogoImage = void 0;
    var o,
      i = n(2);
    t.LoginLogoImage = i.default("img")(o || (o = r(["\n    display: block;\n    max-height: 80px;\n"], ["\n    display: block;\n    max-height: 80px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r190,
      o = this && this.__extends || (_r190 = function r(e, t) {
        return (_r190 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r190(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      s = this && this.__metadata || function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginFormViewImpl = void 0;
    var l,
      c = n(0),
      u = n(1),
      p = n(47),
      d = n(47),
      f = n(48),
      h = n(9),
      m = n(96),
      g = n(97),
      y = n(7),
      v = n(69),
      b = n(5),
      C = n(4),
      _ = n(2),
      k = n(262),
      w = n(614);
    !function (e) {
      e.Initial = "Initial", e.RuntimeLoginInput = "RuntimeLoginInput", e.AccountSidLoading = "AccountSidLoading", e.PublicConfigLoading = "PublicConfigLoading", e.LoggingIn = "LoggingIn", e.LoginForm = "LoginForm", e.Final = "Final";
    }(l || (l = {}));
    var S = new Set([l.AccountSidLoading, l.PublicConfigLoading, l.LoggingIn, l.Final]);
    var P = {
        runtimeLogin: {
          mapDomainToLookup: function mapDomainToLookup(e) {
            return h.flexPublicConfigServiceUrl + "?RuntimeDomain=" + e;
          },
          adminLoginUrl: h.twilioServiceLoginUrl + "?referer=" + window.location.origin + "&localPort=" + (window.location.protocol.indexOf("https") > -1 && !window.location.port ? 443 : window.location.port)
        }
      },
      T = function (e) {
        function t(t) {
          var r = e.call(this, t) || this;
          return r.handleAdminLoginClick = function (e) {
            return n.useAdminLogin = !0, e.preventDefault(), r.tryLogin();
          }, r.handleWindowResize = function () {
            r.setSizeFromContainer();
          }, r.setContainerRef = function (e) {
            r._containerRef = e, r.setSizeFromContainer();
          }, r.setDomain = function (e) {
            var t = e.target;
            r.setState({
              runtimeDomain: t.value
            });
          }, r.handleFatalError = function (e) {
            b.log.error("LoginFormView fatal error:", e), r.props.onError && r.props.onError(e);
          }, r.handleSubmit = function (e) {
            switch (e.preventDefault(), r.state.smState) {
              case l.RuntimeLoginInput:
                r.sm.transitionTo(l.AccountSidLoading);
                break;
              case l.LoginForm:
                r.tryLogin();
            }
          }, r.transitionToInit = function () {
            return r.getMergedConfig().sso.accountSid ? r.state.publicConfig ? r.sm.transitionTo(l.LoggingIn) : r.sm.transitionTo(l.PublicConfigLoading) : r.state.runtimeDomain ? r.sm.transitionTo(l.AccountSidLoading) : r.sm.transitionTo(l.RuntimeLoginInput);
          }, r.transitionToFetchingAccountSid = function () {
            var e;
            return p.fetchRuntimeDomainInfo(r.state.runtimeDomain, null === (e = r.props.userConfig.runtimeLogin) || void 0 === e ? void 0 : e.mapDomainToLookup).then(function (e) {
              r.setState({
                determinedConfig: {
                  sso: {
                    accountSid: e.account_sid
                  }
                }
              }), r.sm.transitionTo(l.PublicConfigLoading);
            }).catch(function (e) {
              r.sm.transitionTo(l.RuntimeLoginInput), r.setState({
                error: e
              }), b.log.warn("Error from fetchRuntimeDomainInfo", e);
            });
          }, r.transitionToFetchingPublicConfig = function () {
            var e = r.getMergedConfig();
            if (!e.sso.accountSid) throw y.ErrorManager.processError(new f.ConfigError(f.ConfigErrorKeys.accountSid));
            return d.fetchPublicConfiguration({
              accountSid: e.sso.accountSid
            }).then(function (e) {
              r.setState({
                publicConfig: e
              }), r.sm.transitionTo(l.LoggingIn);
            }).catch(function (e) {
              r.setState({
                error: e
              }), r.sm.transitionTo(l.LoginForm), b.log.warn("Error from fetchPublicConfiguration", e);
            });
          }, r.transitionToFinal = function () {
            var e = r.props.userConfig;
            c.Utils.mergeInto(e || {}, r.state.determinedConfig, !1);
            var t = c.Utils.merge(p.getStoredConfig(), r.state.determinedConfig);
            p.storeConfig(t), r.props.userLoggedOut && m.SSOLoginHandler.create(e.sso).then(function (e) {
              window.location.reload();
            }), r.props.onSuccess && r.props.onSuccess(r.state.determinedConfig);
          }, r.transitionToLoggingIn = function () {
            return r.tryLogin();
          }, r.state = {
            determinedConfig: {},
            error: null,
            runtimeDomain: t.initialRuntimeDomain,
            smState: null,
            publicConfig: void 0
          }, r.sm = new c.StateMachine("LoginFormView"), r.sm.onChange(function (e) {
            return r.setState(function (t) {
              return i(i({}, t), {
                smState: e
              });
            });
          }), r.sm.onEnter(l.Initial, r.transitionToInit), r.sm.onEnter(l.AccountSidLoading, r.transitionToFetchingAccountSid), r.sm.onEnter(l.PublicConfigLoading, r.transitionToFetchingPublicConfig), r.sm.onEnter(l.LoggingIn, r.transitionToLoggingIn), r.sm.onEnter(l.Final, r.transitionToFinal), Object.keys(C.templates).length || c.initWithStrings(v.languages.default), r;
        }
        var n, r;
        return o(t, e), n = t, t.prototype.componentDidMount = function () {
          return window.addEventListener("resize", this.handleWindowResize), this.props.userLoggedOut ? this.props.userConfig.sso && this.props.userConfig.sso.accountSid ? this.sm.transitionTo(l.LoginForm) : this.sm.transitionTo(l.RuntimeLoginInput) : this.sm.transitionTo(l.Initial);
        }, t.prototype.componentWillUnmount = function () {
          window.removeEventListener("resize", this.handleWindowResize);
        }, t.prototype.render = function () {
          var e = this.getDetailedErrorMessageTemplate();
          return u.createElement(w.Container, {
            className: "Twilio Twilio-LoginFormView",
            innerRef: this.setContainerRef
          }, u.createElement(w.VerticalContainer, {
            className: "Twilio-LoginFormView-Container",
            showBorder: this.state.containerWidth >= 1024
          }, u.createElement(w.ContentContainer, {
            className: "Twilio-LoginFormView-ContentContainer"
          }, u.createElement(w.StyledLogoWithCircle, {
            animating: this.isLoadingState()
          }), u.createElement(w.MessageContainer, {
            className: "Twilio-LoginFormView-Message"
          }, u.createElement(c.Template, {
            source: this.getMessageTemplate()
          })), u.createElement(w.FormContainer, {
            className: "Twilio-LoginFormView-FormContainer"
          }, u.createElement(w.Form, {
            onSubmit: this.handleSubmit,
            className: "Twilio-LoginFormView-Form"
          }, this.isRuntimeDomainInputState() && u.createElement(w.RuntimeDomainInput, {
            className: "Twilio-LoginFormView-Input",
            value: this.state.runtimeDomain,
            onChange: this.setDomain,
            autoFocus: !0,
            error: !!this.state.error,
            name: "runtime",
            type: "text",
            placeholder: C.templates.RuntimeLoginPlaceholder()
          }), !this.isLoadingState() && this.doesErrorAllowButton() && u.createElement(w.LoginButton, {
            className: "Twilio-LoginFormView-LoginButton",
            roundCorners: !1,
            disabled: this.isLoginButtonDisabled(),
            onClick: this.handleSubmit,
            themeOverride: this.props.theme.RuntimeLoginView.LoginButton
          }, u.createElement(c.Template, {
            source: this.getLoginButtonTemplate()
          })))), u.createElement(w.ErrorDetailsContainer, {
            className: "Twilio-LoginFormView-ErrorDetails"
          }, !!e && u.createElement(c.Template, {
            source: e
          })), !this.isLoadingState() && u.createElement(w.AdminLinkContainer, {
            className: "Twilio-LoginFormView-AdminLogin"
          }, u.createElement(c.Template, {
            source: C.templates.LoginIsAdmin
          }), u.createElement(w.LoginLink, {
            href: "#",
            onClick: this.handleAdminLoginClick
          }, u.createElement(c.Template, {
            source: C.templates.LoginWithTwilio
          }))))));
        }, t.prototype.setSizeFromContainer = function () {
          this._containerRef && this.setState({
            containerWidth: this._containerRef.clientWidth
          });
        }, t.prototype.getMergedConfig = function (e) {
          void 0 === e && (e = this.props);
          var t = c.Utils.merge(e.userConfig || {}, this.state.determinedConfig),
            n = this.getAdminLoginConfigOverride();
          return n && c.Utils.mergeInto(t, n), t;
        }, t.prototype.getAdminLoginConfigOverride = function () {
          if (n.useAdminLogin) {
            var e = {
              sso: {
                idpUrl: this.getRuntimeConfig().adminLoginUrl
              }
            };
            if (window.location !== window.parent.location) {
              e.sso.loginPopup = !0;
              var t = i(i({}, g.getDefaultLoginWindowFeatures()), {
                width: 1e3
              });
              e.sso.loginPopupFeatures = g.stringifyLoginWindowFeatures(t);
            }
            return e;
          }
        }, t.prototype.tryLogin = function () {
          var e = this,
            t = this.getMergedConfig();
          return m.SSOLoginHandler.tryLogin(t.sso).then(function () {
            e.sm.transitionTo(l.Final);
          }).catch(function (t) {
            t instanceof f.BrowserError && t.key === f.BrowserErrorKeys.redirecting ? b.log.debug("Browser redirecting soon") : (e.setState({
              error: t
            }), e.sm.transitionTo(l.LoginForm), b.log.warn("Error from tryLogin", t), function (e) {
              return e instanceof f.BrowserError || e instanceof f.ValidationError || e instanceof f.ConfigError || e instanceof f.ClientError;
            }(t) || e.handleFatalError(t));
          });
        }, t.prototype.getErrorMessageTemplate = function () {
          var e = this.state.error;
          return e ? e.key === f.ValidationErrorKeys.sso ? C.templates.LoginErrorSso : e.key === f.BrowserErrorKeys.popupBlocked || e.key === f.BrowserErrorKeys.windowClosed ? C.templates.LoginErrorPopupBlocked : e.key === f.ValidationErrorKeys.accountSid ? C.templates.LoginErrorDomain : e.key === f.ValidationErrorKeys.untrustedDomain ? C.templates.LoginErrorUntrustedDomain : e.key === f.ValidationErrorKeys.invalidCertificate ? C.templates.LoginErrorInvalidCertificate : C.templates.LoginErrorGeneric : null;
        }, t.prototype.getDetailedErrorMessageTemplate = function () {
          var e = this.state.error;
          return !e || this.isLoadingState() ? null : e.key === f.ValidationErrorKeys.sso ? C.templates.LoginErrorSsoDetails : e.key === f.BrowserErrorKeys.popupBlocked || e.key === f.BrowserErrorKeys.windowClosed ? C.templates.LoginErrorPopupBlockedDetails : e.key === f.ValidationErrorKeys.accountSid ? C.templates.LoginErrorDomainDetails : e.key === f.ValidationErrorKeys.untrustedDomain ? C.templates.LoginErrorUntrustedDomainDetails : e.key === f.ValidationErrorKeys.invalidCertificate ? C.templates.LoginErrorInvalidCertificateDetails : null;
        }, t.prototype.getLoginButtonTemplate = function () {
          return this.props.userLoggedOut ? C.templates.LoginAgain : this.state.smState === l.RuntimeLoginInput ? C.templates.LoginLaunch : C.templates.LoginContinue;
        }, t.prototype.doesErrorAllowButton = function () {
          return !(this.state.error && this.state.error instanceof f.ValidationError);
        }, t.prototype.isLoginButtonDisabled = function () {
          return this.isRuntimeDomainInputState() && !this.state.runtimeDomain || this.state.smState === l.LoginForm && this.state.error && !(this.state.error instanceof f.BrowserError);
        }, t.prototype.getMessageTemplate = function () {
          return this.isLoadingState() ? C.templates.LoginLoading : this.isErrorState() ? this.getErrorMessageTemplate() : this.props.userLoggedOut ? C.templates.UserLoggedOutSuccess : C.templates.LoginWelcome;
        }, t.prototype.isRuntimeDomainInputState = function () {
          return this.state.smState === l.RuntimeLoginInput;
        }, t.prototype.isLoadingState = function () {
          return S.has(this.state.smState);
        }, t.prototype.isErrorState = function () {
          return !!this.state.error && !this.isLoadingState();
        }, t.prototype.getRuntimeConfig = function () {
          return this.props.userConfig.runtimeLogin || P.runtimeLogin;
        }, t.useAdminLogin = !1, t = n = a([_.withTheme, s("design:paramtypes", ["function" == typeof (r = void 0 !== k.LoginFormViewProps && k.LoginFormViewProps) ? r : Object])], t);
      }(u.PureComponent);
    t.LoginFormViewImpl = T;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AdminLinkContainer = t.RuntimeDomainInput = t.ErrorDetailsContainer = t.MessageContainer = t.StyledLogoWithCircle = t.LoginButton = t.LoginLink = t.Form = t.FormContainer = t.ContentContainer = t.VerticalContainer = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d,
      f,
      h,
      m,
      g = n(0),
      y = n(105),
      v = n(2),
      b = n(153);
    t.Container = v.default("div")(o || (o = r(["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 1 auto;\n    justify-content: center;\n    ", "\n\n    a, a:active, a:hover, a:link, a:visited {\n        color: inherit;\n    }\n"], ["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 1 auto;\n    justify-content: center;\n    ", "\n\n    a, a:active, a:hover, a:link, a:visited {\n        color: inherit;\n    }\n"])), function (e) {
      return e.theme.LoginFormView.Container;
    }), t.VerticalContainer = v.default("div")(i || (i = r(["\n    width: ", ";\n    border-style: solid;\n    border-width: ", ";\n    min-height: 430px;\n    display: flex;\n    flex: 0 1 604px;\n    flex-direction: column;\n    ", "\n"], ["\n    width: ", ";\n    border-style: solid;\n    border-width: ", ";\n    min-height: 430px;\n    display: flex;\n    flex: 0 1 604px;\n    flex-direction: column;\n    ", "\n"])), function (e) {
      return e.showBorder ? "426px" : "100%";
    }, function (e) {
      return e.showBorder ? "1px" : "0px";
    }, function (e) {
      return e.theme.LoginFormView.Container;
    }), t.ContentContainer = v.default("div")(a || (a = r(["\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    align-items: center;\n    padding-left: 30px;\n    padding-right: 30px;\n    padding-top: 32px;\n    padding-bottom: 32px;\n"], ["\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    align-items: center;\n    padding-left: 30px;\n    padding-right: 30px;\n    padding-top: 32px;\n    padding-bottom: 32px;\n"]))), t.FormContainer = v.default("div")(s || (s = r(["\n    display: flex;\n    align-items: center;\n    width: 100%;\n"], ["\n    display: flex;\n    align-items: center;\n    width: 100%;\n"]))), t.Form = v.default("form")(l || (l = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    max-width: 348px;\n    margin: auto;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    max-width: 348px;\n    margin: auto;\n"]))), t.LoginLink = v.default("a")(c || (c = r(["\n    margin-left: 8px;\n"], ["\n    margin-left: 8px;\n"]))), t.LoginButton = v.default(g.Button)(u || (u = r(["\n    text-transform: uppercase;\n    margin-top: 16px;\n"], ["\n    text-transform: uppercase;\n    margin-top: 16px;\n"]))), t.StyledLogoWithCircle = v.default(b.LogoWithCircle)(p || (p = r(["\n    flex: 0 0 auto;\n    margin-top: 32px;\n"], ["\n    flex: 0 0 auto;\n    margin-top: 32px;\n"]))), t.MessageContainer = v.default("div")(d || (d = r(["\n    font-size: 18px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    text-align: center;\n\n    margin-top: 32px;\n    margin-bottom: 32px;\n"], ["\n    font-size: 18px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    text-align: center;\n\n    margin-top: 32px;\n    margin-bottom: 32px;\n"]))), t.ErrorDetailsContainer = v.default("div")(f || (f = r(["\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    text-align: center;\n\n    margin-top: 40px;\n"], ["\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    text-align: center;\n\n    margin-top: 40px;\n"]))), t.RuntimeDomainInput = v.default(y.default)(h || (h = r(["\n    margin-top: 16px;\n    margin-left: 2px;\n    margin-right: 2px;\n"], ["\n    margin-top: 16px;\n    margin-left: 2px;\n    margin-right: 2px;\n"]))), t.AdminLinkContainer = v.default("div")(m || (m = r(["\n    margin-top: auto;\n    font-size: 12px;\n    font-weight: lighter;\n    text-align: center;\n"], ["\n    margin-top: auto;\n    font-size: 12px;\n    font-weight: lighter;\n    text-align: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r191,
      o = this && this.__extends || (_r191 = function r(e, t) {
        return (_r191 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r191(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LogoWithCircle = void 0;
    var a = n(1),
      s = n(264),
      l = n(129),
      c = n(0),
      u = n(618),
      p = n(2),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.className,
            n = e.disabled,
            r = e.animating,
            o = e.theme,
            i = n ? o.colors.base3 : o.colors.base11;
          return a.createElement(u.CenterContainer, {
            className: l.cx("Twilio-LogoWithCircle", t)
          }, a.createElement(u.ProgressContainer, null, a.createElement(c.CircularProgress, {
            override: {
              staticBackgroundBorderColor: i
            },
            animating: r,
            size: 124,
            borderWidth: 3
          })), a.createElement(s.LoginLogo, {
            fill: i
          }));
        }, t = i([p.withTheme], t);
      }(a.PureComponent);
    t.LogoWithCircle = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginLogo = void 0;
    var o = n(1),
      i = n(617);
    t.LoginLogo = function (e) {
      return o.createElement(i.LogoContainer, null, o.createElement("svg", r({
        viewBox: "0 0 173 166",
        width: "173",
        height: "166"
      }, e), o.createElement("g", r({}, e, {
        fillRule: "evenodd"
      }), o.createElement("path", {
        d: "M69.449 59.978L81.88 72.413c.269.27.42.634.42 1.015v13.134c0 1.279-1.545 1.919-2.449 1.015L67.42 75.14a1.435 1.435 0 0 1-.42-1.014V60.992c0-1.278 1.545-1.918 2.449-1.014zM68.448 42H99.13c.38 0 .745.151 1.014.42l12.432 12.436c.904.904.264 2.45-1.014 2.45H82.3a1.405 1.405 0 0 0 0 2.81h9.503c.38 0 .745.15 1.014.42L105.25 72.97c.903.904.263 2.45-1.015 2.45H89.573c-.38 0-.745-.152-1.014-.421L67.42 53.898a1.435 1.435 0 0 1-.42-1.014v-9.436c0-.8.649-1.448 1.448-1.448zM15.752 146.59h-5.456V161h-1.65v-14.41H3.3v-1.54h12.21l.242 1.54zm27.42-1.54l-5.016 16.016h-1.452l-4.796-13.706-4.774 13.706h-1.408l-4.972-15.796 1.672-.374 4.114 13.53 4.554-13.376h1.694l4.62 13.376 4.048-13.376h1.716zM51.474 161h-1.672v-15.95h1.672V161zm16.046 0h-8.272v-15.95h1.65v14.41h6.38l.242 1.54zm7.928 0h-1.672v-15.95h1.672V161zm22.008-7.986c0 4.884-3.08 8.294-7.524 8.294s-7.48-3.388-7.48-8.25c0-4.906 3.08-8.294 7.524-8.294s7.48 3.366 7.48 8.25zm-1.738.022c0-4.048-2.288-6.776-5.786-6.776-3.476 0-5.764 2.728-5.764 6.754 0 4.07 2.31 6.776 5.786 6.776 3.498 0 5.764-2.706 5.764-6.754zm25.668-6.446h-6.666v5.566h5.324l.242 1.518h-5.566V161h-1.65v-15.95h8.316v1.54zM135.98 161h-8.272v-15.95h1.65v14.41h6.38l.242 1.54zm14.968 0h-8.866v-15.95h8.624v1.54h-6.974v5.302h5.522l.242 1.54h-5.764v6.05h7.216V161zm18.598-.22l-1.672.352-5.06-7.26L157.93 161h-1.826l5.764-8.294-5.192-7.414 1.65-.352 4.51 6.556 4.4-6.446h1.826l-5.28 7.612 5.764 8.118z"
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LogoContainer = void 0;
    var o,
      i = n(2);
    t.LogoContainer = i.default("div")(o || (o = r(["\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n"], ["\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ProgressContainer = t.CenterContainer = void 0;
    var o,
      i,
      a = n(2);
    t.CenterContainer = a.default("div")(o || (o = r(["\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 6px;\n    display: flex;\n    justify-content: center;\n"], ["\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 6px;\n    display: flex;\n    justify-content: center;\n"]))), t.ProgressContainer = a.default("div")(i || (i = r(["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    right: 0;\n    text-align: center;\n"], ["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    right: 0;\n    text-align: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r192,
      o = this && this.__extends || (_r192 = function r(e, t) {
        return (_r192 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r192(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.TeamsView = void 0;
    var s = n(0),
      l = n(1),
      c = n(49),
      u = n(3),
      p = n(10),
      d = n(53),
      f = n(36),
      h = n(154),
      m = n(94),
      g = n(630),
      y = n(656),
      v = n(184),
      b = function (e) {
        function n() {
          var n = null !== e && e.apply(this, arguments) || this;
          return n.getBaseRoute = function () {
            var e;
            return (null === (e = n.props.route) || void 0 === e ? void 0 : e.match) && n.props.route.match.url.replace(/\/$/, "");
          }, n.renderChildrenFromRoute = function (e) {
            return l.createElement(t.Connected, i({}, n.props, {
              route: e
            }));
          }, n;
        }
        var r;
        return o(n, e), r = n, n.prototype.render = function () {
          var e = this.getBaseRoute();
          return l.createElement(c.Route, {
            path: e + "/:resource?/:sid?",
            children: this.renderChildrenFromRoute
          });
        }, n.displayName = g.displayName, n.Content = g.contentStore, n.activitiesFilter = function (e) {
          var t = Array.from(e.worker.activities).map(function (e) {
            return {
              value: e[1].name,
              label: e[1].name,
              default: !1
            };
          });
          return {
            id: "data.activity_name",
            fieldName: "activity_name",
            type: s.FiltersListItemType.multiValue,
            title: "Activities",
            options: t
          };
        }, n.defaultProps = {
          filters: [r.activitiesFilter]
        }, n = r = a([s.withDefaultPropsUpdate], n);
      }(l.PureComponent);
    t.TeamsView = b, t.Connected = u.connect(function (e, t) {
      var n = [],
        r = y.selectSearchFilter(e),
        o = y.selectUserFilter(e);
      r && n.push.apply(n, r.filters), o && n.push.apply(n, o.filters), t.hiddenFilter && (Array.isArray(t.hiddenFilter) ? n.push.apply(n, t.hiddenFilter) : n.push(t.hiddenFilter));
      var i,
        a = d.featureEnabledSelector(p.FeatureFlag.AdvancedTeamsViewFilters)(e) || d.featureEnabledSelector(p.FeatureFlag.AdvancedTeamsViewFiltersGA)(e);
      return a && h.WorkersDataTable.defaultProps.filters && h.WorkersDataTable.defaultProps.filters.length > 0 && (i = h.WorkersDataTable.defaultProps.filters.map(function (t) {
        return "function" == typeof t ? t(e, h.WorkersDataTable.defaultProps) : t;
      }).filter(function (e) {
        return e && e.query;
      }), "" !== e.view.filters[m.FiltersType.legacy] && n.push(e.view.filters[m.FiltersType.legacy])), {
        filterQuery: v.filtersToQuery(n) || h.WorkersDataTable.IncludeAllFilter.query,
        filterCount: o ? o.count : 0,
        isSearchFilterApplied: !!r,
        appliedFilters: o,
        appliedLegacyFilterQuery: e.view.filters[m.FiltersType.legacy],
        filtersEnabled: a,
        monitoredTaskSid: e.supervisor.callMonitoring.status === f.CallMonitoringStatus.monitoring && e.supervisor.callMonitoring.task ? e.supervisor.callMonitoring.task.taskSid : "",
        workers: e.supervisor.workers,
        stickyWorker: e.supervisor.stickyWorker,
        isLoadingWorkers: e.supervisor.isLoadingWorkers,
        errorLoadingWorkers: e.supervisor.errorLoadingWorkers,
        filters: t.filters.map(function (n) {
          return "function" == typeof n ? n(e, t) : n;
        }).filter(function (e) {
          return !!e;
        }),
        legacyFilters: i
      };
    })(g.TeamsViewImpl);
  }, function (e, t, n) {
    "use strict";

    var _r193,
      o = this && this.__extends || (_r193 = function r(e, t) {
        return (_r193 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r193(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectedWorkersDataTableImpl = t.WorkersDataTable = t.defaultCompareFunction = void 0;
    var s = n(1),
      l = n(0),
      c = n(3),
      u = n(621);
    t.defaultCompareFunction = function (e, t) {
      var n = e.fullName || "",
        r = t.fullName || "";
      return n.localeCompare(r);
    };
    var p = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      var r;
      return o(n, e), r = n, n.updateAll = function () {}, n.prototype.render = function () {
        return s.createElement(t.ConnectedWorkersDataTableImpl, i({}, this.props));
      }, n.displayName = u.displayName, n.Content = u.contentStore, n.IncludeAllFilter = u.IncludeAllFilter, n.IncludeActiveWorkersFilter = function (e) {
        var t = e.worker.activities,
          n = t && Array.from(t.values()).filter(function (e) {
            return !!e.available;
          });
        if (n && n.length) return {
          query: "data.activity_name IN [" + ('"' + n.map(function (e) {
            return e.name;
          }).join('", "') + '"') + "]",
          text: "Active Agents"
        };
      }, n.defaultFilters = [r.IncludeActiveWorkersFilter, r.IncludeAllFilter], n.taskFilter = 'data.status not_in ["completed", "canceled", "rescinded", "rejected", "timeout"]', n.defaultProps = {
        tablePlaceHolder: void 0,
        initialCompareFunction: t.defaultCompareFunction,
        filters: r.defaultFilters,
        taskFilter: r.taskFilter
      }, n = r = a([l.withDefaultPropsUpdate], n);
    }(s.PureComponent);
    t.WorkersDataTable = p;
    var d = function d(e, t, n) {
      return "function" == typeof e ? e(t, n) : e;
    };
    t.ConnectedWorkersDataTableImpl = c.connect(function (e, t) {
      var n = t.filters.find(function (n) {
        return d(n, e, t).query === e.supervisor.listener.getActiveFilterQuery();
      });
      return {
        workers: e.supervisor.workers,
        legacyActiveFilter: !t.filtersEnabled && d(n || t.filters[0], e, t),
        filters: t.filters.map(function (n) {
          return d(n, e, t);
        }).filter(function (e) {
          return !!e;
        })
      };
    })(u.WorkersDataTableImpl);
  }, function (e, t, n) {
    "use strict";

    var _r194,
      o = this && this.__extends || (_r194 = function r(e, t) {
        return (_r194 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r194(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkersDataTableImpl = t.IncludeAllFilter = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(36),
      l = n(622),
      c = n(0),
      u = n(266),
      p = n(8),
      d = n(138),
      f = n(627),
      h = n(629);
    t.displayName = "WorkersDataTable", t.contentStore = new c.DynamicContentStore(t.displayName), t.IncludeAllFilter = {
      query: "",
      text: "All Agents"
    };
    var m = function (e) {
      function n() {
        var n = null !== e && e.apply(this, arguments) || this;
        return n.state = {
          legacyActiveFilter: n.props.legacyActiveFilter || t.IncludeAllFilter
        }, n.onUpdate = function () {
          n.forceUpdate();
        }, n.getItemWorkerSid = function (e) {
          return e.worker.sid;
        }, n.renderUserCard = function (e) {
          return a.createElement(f.UserCardWrapper, {
            item: e
          });
        }, n.renderTaskCardListForOthers = function (e, t) {
          return a.createElement(u.TaskCardList, {
            tasks: e.tasks,
            onCardSelected: t.onTaskSelected,
            selectedTaskSid: t.selectedTask && t.selectedTask.sid,
            highlightedTaskSid: t.monitoredTaskSid,
            filter: n.tasksFilter
          });
        }, n.renderTaskCardListForCall = function (e, t) {
          return a.createElement(u.TaskCardList, {
            tasks: e.tasks,
            onCardSelected: t.onTaskSelected,
            selectedTaskSid: t.selectedTask && t.selectedTask.sid,
            highlightedTaskSid: t.monitoredTaskSid,
            filter: n.callsFilter
          });
        }, n.callsFilter = function (e) {
          return p.TaskHelper.isCallTask(e) && p.TaskHelper.isTaskAccepted(e);
        }, n.tasksFilter = function (e) {
          return !p.TaskHelper.isCallTask(e) && p.TaskHelper.isTaskAccepted(e);
        }, n.onLegacyFilterChanged = function (e) {
          n.setState({
            legacyActiveFilter: e
          }), s.Actions.setActiveFilterQuery(e.query, n.props.taskFilter);
        }, n.handleRowClick = function (e) {
          var t = n.props,
            r = t.selectedWorker,
            o = t.onWorkerSelected;
          r && r.sid === e.worker.sid || o && o(e.worker);
        }, n;
      }
      return o(n, e), n.prototype.componentWillUnmount = function () {
        d.removeTickListener(this.onUpdate);
      }, n.prototype.componentDidMount = function () {
        var e = this.props,
          t = e.filtersEnabled,
          n = e.taskFilter,
          r = this.state.legacyActiveFilter.query;
        t || s.Actions.setActiveFilterQuery(r, n), d.addTickListener(this.onUpdate);
      }, n.prototype.render = function () {
        var e,
          n = this.props,
          r = n.tablePlaceHolder,
          o = n.filters,
          s = n.workers,
          u = n.filtersEnabled,
          p = n.selectedWorker,
          d = n.children,
          f = n.initialCompareFunction;
        f && (e = i(s)).sort(function (e, t) {
          return f(e.worker, t.worker, e.tasks, t.tasks);
        });
        var m = {
          selectedTask: this.props.selectedTask,
          monitoredTaskSid: this.props.monitoredTaskSid,
          onTaskSelected: this.props.onTaskSelected
        };
        return a.createElement(h.StyledTableContainer, {
          className: "Twilio-WorkersDataTable"
        }, !u && a.createElement(h.StyledFilterContainer, {
          className: "Twilio-WorkersDataTable-Filter",
          noGrow: !0
        }, a.createElement(l.WorkerListFilterSelect, {
          filters: o,
          activeFilter: this.state.legacyActiveFilter,
          onFilterChanged: this.onLegacyFilterChanged
        })), a.createElement(c.DynamicComponent, {
          childProps: this.props,
          contentStore: t.contentStore,
          name: t.displayName,
          customChildren: d,
          noContainers: !0
        }, a.createElement(c.DataTable, {
          items: e || s,
          itemKey: this.getItemWorkerSid,
          selectedItemKey: p && p.sid,
          placeholder: r,
          onRowClick: this.handleRowClick,
          columnDataCreationContext: m
        }, a.createElement(c.ColumnDefinition, {
          key: "worker",
          header: a.createElement(c.Template, {
            code: "ColumnHeaderAgent"
          }),
          content: this.renderUserCard,
          style: {
            width: "180px"
          }
        }), a.createElement(c.ColumnDefinition, {
          key: "calls",
          header: a.createElement(c.Template, {
            code: "ColumnHeaderCalls"
          }),
          content: this.renderTaskCardListForCall,
          style: {
            width: "180px"
          }
        }), a.createElement(c.ColumnDefinition, {
          key: "tasks",
          header: a.createElement(c.Template, {
            code: "ColumnHeaderTasks"
          }),
          content: this.renderTaskCardListForOthers
        }))));
      }, n.defaultProps = {
        filters: []
      }, n;
    }(a.Component);
    t.WorkersDataTableImpl = m;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerListFilterSelect = void 0;
    var r = n(623);
    Object.defineProperty(t, "WorkerListFilterSelect", {
      enumerable: !0,
      get: function get() {
        return r.WorkerListFilterSelect;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r195,
      o = this && this.__extends || (_r195 = function r(e, t) {
        return (_r195 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r195(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerListFilterSelect = void 0;
    var i = n(1),
      a = n(58),
      s = n(4),
      l = n(624),
      c = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleChange = function (e) {
            t.props.onFilterChanged(t.props.filters[e.target.value]);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            n = e.filters,
            r = e.activeFilter;
          return i.createElement(l.StyledSelect, {
            className: "Twilio-AgentListFilterSelect Twilio-WorkerListFilterSelect",
            value: n.findIndex(function (e) {
              return e.text === r.text;
            }),
            onChange: this.handleChange
          }, n.map(function (e, n) {
            return i.createElement(a.default, {
              key: e.query,
              value: n
            }, t.getFilterText(e));
          }));
        }, t.getFilterText = function (e) {
          return e.text in s.templates ? i.createElement(s.Template, {
            source: s.templates[e.text]
          }) : e.text;
        }, t;
      }(i.PureComponent);
    t.WorkerListFilterSelect = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledSelect = void 0;
    var o,
      i = n(2),
      a = n(59);
    t.StyledSelect = i.default(a.default)(o || (o = r(["\n    width: 252px;\n"], ["\n    width: 252px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r196,
      o = this && this.__extends || (_r196 = function r(e, t) {
        return (_r196 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r196(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TaskCardImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(8),
      c = n(17),
      u = n(269),
      p = n(270),
      d = n(2);
    t.displayName = "TaskCard", t.contentStore = new s.DynamicContentStore(t.displayName);
    var f = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleClick = function (e) {
          t.props.onClick && t.props.onClick(t.props.task), e.stopPropagation();
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = e.firstLine,
          r = e.secondLine,
          o = e.task,
          i = e.selected,
          d = e.icon,
          f = e.channelDefinition,
          h = new l.TaskHelper(o);
        return o && f ? a.createElement(p.StyledButton, {
          onClick: this.handleClick
        }, a.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0
        }, a.createElement(p.Container, {
          className: "Twilio-TaskCard-Container",
          selected: i,
          iconAreaStyleOverride: this.getIconAreaStyleOverride(f),
          contentAreaStyleOverride: this.getContentAreaStyleOverride(f)
        }, a.createElement(p.IconContainer, {
          key: "icon",
          className: "Twilio-TaskCard-IconContainer",
          icon: d || c.TaskChannelHelper.getIcon(o, i ? f.icons.active : f.icons.list, u.TaskCard)
        }), a.createElement(p.Content, {
          key: "content",
          className: "Twilio-TaskCard-Content"
        }, a.createElement(p.FirstLineContainer, {
          className: "Twilio-TaskCard-FirstLine"
        }, n || a.createElement(s.Template, {
          task: o,
          helper: h,
          code: c.TaskChannelHelper.getTemplateForStatus(o, f.templates.TaskCard.firstLine, u.TaskCard)
        })), a.createElement(p.SecondLineContainer, {
          className: "Twilio-TaskCard-SecondLine"
        }, r || a.createElement(s.Template, {
          task: o,
          helper: h,
          code: c.TaskChannelHelper.getTemplateForStatus(o, f.templates.TaskCard.secondLine, u.TaskCard)
        })))))) : a.createElement(p.TaskCardPlaceholder, null);
      }, n.prototype.getIconAreaStyleOverride = function (e) {
        var t = this.props.theme.TaskCard.IconArea.Default;
        return t.backgroundColor = c.TaskChannelHelper.getColor(this.props.task, e.colors.main, u.TaskCard), t;
      }, n.prototype.getContentAreaStyleOverride = function (e) {
        return this.props.highlighted ? this.getIconAreaStyleOverride(e) : l.TaskHelper.isInWrapupMode(this.props.task) || l.TaskHelper.isCompleted(this.props.task) ? this.props.theme.TaskCard.ContentArea.Inactive : this.props.theme.TaskCard.ContentArea.Default;
      }, n.defaultProps = {
        highlighted: !1,
        selected: !1
      }, n = i([d.withTheme], n);
    }(a.Component);
    t.TaskCardImpl = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserCardWrapper = void 0;
    var r = n(628);
    Object.defineProperty(t, "UserCardWrapper", {
      enumerable: !0,
      get: function get() {
        return r.UserCardWrapper;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r197,
      o = this && this.__extends || (_r197 = function r(e, t) {
        return (_r197 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r197(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserCardWrapper = void 0;
    var i = n(1),
      a = n(0),
      s = n(4),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.item;
          return i.createElement(a.UserCard, {
            className: "Twilio-AgentsDataTable-UserCard Twilio-WorkersDataTable-UserCard",
            imageUrl: e.worker.attributes.image_url,
            large: !0,
            firstLine: i.createElement(a.Template, {
              source: s.templates.SupervisorUserCardFirstLine,
              worker: e.worker
            }),
            secondLine: i.createElement(a.Template, {
              source: s.templates.SupervisorUserCardSecondLine,
              worker: e.worker
            }),
            isAvailable: e.worker.isAvailable
          });
        }, t;
      }(i.Component);
    t.UserCardWrapper = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledFilterContainer = t.StyledTableContainer = void 0;
    var o,
      i,
      a = n(2),
      s = n(0);
    t.StyledTableContainer = a.default("div")(o || (o = r(["\n    overflow-y: auto;\n"], ["\n    overflow-y: auto;\n"]))), t.StyledFilterContainer = a.default(s.FlexBox)(i || (i = r(["\n    margin-top: 12px;\n    margin-left: 12px;\n    margin-bottom: 32px;\n"], ["\n    margin-top: 12px;\n    margin-left: 12px;\n    margin-bottom: 32px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r198,
      o = this && this.__extends || (_r198 = function r(e, t) {
        return (_r198 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r198(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TeamsViewImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(155),
      l = n(0),
      c = n(154),
      u = n(267),
      p = n(197),
      d = n(271),
      f = n(94),
      h = n(652),
      m = n(211),
      g = n(35),
      y = n(653),
      v = n(4),
      b = n(8),
      C = n(6),
      _ = n(33),
      k = n(36),
      w = n(192),
      S = n(5),
      P = n(2);
    t.displayName = "TeamsView", t.contentStore = new l.DynamicContentStore(t.displayName);
    var T = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          isFilterPanelOpen: !1,
          searchText: ""
        }, t.applyFilters = function (e, n) {
          void 0 === n && (n = ""), C.tryInvokeAction("ApplyListFilters", {
            key: f.FiltersType.filter,
            filters: t.props.filters.filter(function (t) {
              return t.id in e;
            }).map(function (t) {
              return {
                name: t.id,
                condition: t.condition || g.FilterConditions.IN,
                values: e[t.id] || []
              };
            }),
            legacyFilterQuery: n
          });
        }, t.resetFilters = function (e) {
          Object.keys(e).length ? t.applyFilters(e) : C.tryInvokeAction("RemoveListFilters", {
            key: f.FiltersType.filter
          });
        }, t.onSearchTextChange = function (e) {
          return t.setState({
            searchText: e
          });
        }, t.onSearchClear = function () {
          C.tryInvokeAction("RemoveListFilters", {
            key: f.FiltersType.search
          }), t.setState({
            searchText: ""
          });
        }, t.onSearchSubmit = function (e) {
          e ? C.tryInvokeAction("ApplyListFilters", {
            key: f.FiltersType.search,
            filters: [{
              name: "data.attributes.full_name",
              condition: g.FilterConditions.CONTAINS,
              values: e
            }]
          }) : C.tryInvokeAction("RemoveListFilters", {
            key: f.FiltersType.search
          });
        }, t.onFilterButtonClick = function () {
          t.openFiltersPanel();
        }, t.openFiltersPanel = function () {
          t.setState({
            isFilterPanelOpen: !0
          }, function () {
            C.tryInvokeAction("SelectTaskInSupervisor", {}), C.tryInvokeAction("SelectWorkerInSupervisor", {});
          });
        }, t.closeFiltersPanel = function (e) {
          t.setState({
            isFilterPanelOpen: !1
          }, "function" == typeof e ? e : void 0);
        }, t.handleTaskSelection = function (e) {
          t.closeFiltersPanel(function () {
            C.tryInvokeAction("SelectTaskInSupervisor", {
              task: e
            });
          });
        }, t.handleWorkerSelection = function (e) {
          t.closeFiltersPanel(function () {
            C.tryInvokeAction("SelectWorkerInSupervisor", {
              worker: e
            });
          });
        }, t;
      }
      var r;
      return o(n, e), r = n, n.getTaskSidFromRoute = function (e) {
        return e.match && "tasks" === e.match.params.resource ? e.match.params.sid : void 0;
      }, n.prototype.componentDidMount = function () {
        this.loadChatChannel(), this.loadWorkers(), this.props.filtersEnabled && k.Actions.setActiveFilterQuery(this.props.filterQuery, c.WorkersDataTable.taskFilter), this.props.filtersEnabled && Array.isArray(this.props.legacyFilters) && this.props.legacyFilters.length > 0 && S.log.warn("The use of WorkersDataTable.defaultProps.filters API will be deprecated. Please migrate your filters to the new filter API: https://www.twilio.com/docs/flex/developer/ui/team-view-filters");
      }, n.prototype.componentDidUpdate = function (e, t) {
        (e.route && r.getTaskSidFromRoute(e.route)) === (this.props.route && r.getTaskSidFromRoute(this.props.route)) && t.selectedTask === this.state.selectedTask || this.loadChatChannel();
        var n = this.props,
          o = n.filterQuery;
        n.filtersEnabled && e.filterQuery !== o && k.Actions.setActiveFilterQuery(o, c.WorkersDataTable.taskFilter);
      }, n.getDerivedStateFromProps = function (e, t) {
        var n = e.route && s.SupervisorStateHelper.getTaskBySid(r.getTaskSidFromRoute(e.route)),
          o = e.route && s.SupervisorStateHelper.getWorkerBySid(r.getWorkerSidFromRoute(e.route));
        return t.selectedTask && n && t.selectedTask.sid === n.sid && t.selectedWorker && o && t.selectedWorker.sid === o.sid ? null : {
          selectedTask: n,
          selectedWorker: o
        };
      }, n.getWorkerSidFromRoute = function (e) {
        return e.match && "workers" === e.match.params.resource ? e.match.params.sid : void 0;
      }, n.prototype.loadChatChannel = function () {
        var e = this.state.selectedTask;
        if (e && b.TaskHelper.isChatBasedTask(e)) {
          var t = b.TaskHelper.getTaskChatChannelSid(e);
          l.ChatChannelState.Actions.initWithChannelSid(t);
        }
      }, n.prototype.loadWorkers = function () {
        var e = this.props,
          t = e.filters;
        if (e.filtersEnabled) {
          var n = l.FiltersList.getDefaultFilterValues(t);
          this.applyFilters(n);
        }
      }, n.prototype.renderDataTable = function (e, t) {
        return a.createElement(c.WorkersDataTable, {
          selectedTask: e,
          selectedWorker: t,
          monitoredTaskSid: this.props.monitoredTaskSid,
          onTaskSelected: this.handleTaskSelection,
          onWorkerSelected: this.handleWorkerSelection,
          filtersEnabled: this.props.filtersEnabled,
          appliedFilters: this.props.appliedFilters
        });
      }, n.prototype.render = function () {
        var e = this.props,
          n = e.isLoadingWorkers,
          r = e.filtersEnabled,
          o = this.state,
          i = o.selectedTask,
          s = o.selectedWorker;
        return a.createElement(l.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          noContainers: !0
        }, a.createElement(h.Container, null, a.createElement(l.FlexBox, {
          key: "agents-table",
          vertical: !0,
          className: _.cx({
            "Twilio-TeamsView-Loaded": !this.props.isLoadingWorkers
          })
        }, r && this.renderFilters(), this.props.isViewActive && this.renderDataTable(i, s), r && this.rendersResultsSummary()), !!i && a.createElement(u.SupervisorTaskContextSource, {
          key: "task-canvas",
          taskSid: i.sid
        }, a.createElement(p.TaskCanvas, null)), !!s && a.createElement(d.WorkerCanvas, {
          key: "worker-canvas",
          worker: s
        }), a.createElement(m.TeamFiltersPanel, {
          isHidden: Boolean(i) || Boolean(s) || !this.state.isFilterPanelOpen,
          key: "team-filter-panel",
          handleCloseClick: this.closeFiltersPanel,
          handleApplyFilters: this.applyFilters,
          handleResetFilters: this.resetFilters,
          isLoadingWorkers: Boolean(n),
          appliedFilters: this.props.appliedFilters,
          appliedLegacyFilterQuery: this.props.appliedLegacyFilterQuery,
          legacyFilters: this.props.legacyFilters,
          filters: this.props.filters,
          workers: this.props.workers || []
        })));
      }, n.prototype.renderFilters = function () {
        return a.createElement(h.FilterContainer, {
          key: "filters",
          className: "Twilio-TeamsView-Filter",
          noGrow: !0
        }, a.createElement(h.SearchContainer, null, a.createElement(y.SearchBar, {
          value: this.state.searchText,
          onChange: this.onSearchTextChange,
          onSubmit: this.onSearchSubmit,
          placeholder: v.templates.TeamsViewClearSearchPlaceholder && v.templates.TeamsViewClearSearchPlaceholder(),
          disabled: this.props.isLoadingWorkers
        }), this.props.isSearchFilterApplied && a.createElement(h.ClearSearchLink, {
          onClick: this.onSearchClear
        }, a.createElement(l.Template, {
          code: "TeamsViewClearSearchAction"
        }))), a.createElement(h.FilterButton, {
          onClick: this.onFilterButtonClick,
          roundCorners: !1
        }, a.createElement(l.Template, {
          code: "TeamsViewFilterAction",
          filterCount: this.props.appliedFilters ? this.props.appliedFilters.count : 0
        }), a.createElement(l.Icon, {
          icon: "FilterTrigger"
        })));
      }, n.prototype.rendersResultsSummary = function () {
        var e = this.props,
          t = e.workers,
          n = e.errorLoadingWorkers,
          r = e.isLoadingWorkers;
        return n === k.LiveQueryError.Other ? a.createElement(h.ResultsSummaryCard, null, a.createElement("h5", null, a.createElement(l.Template, {
          source: v.templates.TeamsViewResultsSummaryErrorTitle
        })), a.createElement(l.Template, {
          source: v.templates.TeamsViewResultsSummaryErrorMessage
        })) : n === k.LiveQueryError.LongQuery ? a.createElement(h.ResultsSummaryCard, null, a.createElement("h5", null, a.createElement(l.Template, {
          source: v.templates.TeamsViewResultsSummaryLongQueryErrorTitle
        })), a.createElement(l.Template, {
          source: v.templates.TeamsViewResultsSummaryLongQueryErrorMessage
        })) : r ? null : !t || t.length > 0 && t.length < w.maxWorkersNumberFromInitialLoad ? null : t.length >= w.maxWorkersNumberFromInitialLoad ? a.createElement(h.ResultsSummary, null, a.createElement(l.Template, {
          source: v.templates.TeamsViewResultsSummaryMaxWorkersDisplayed,
          amount: t.length
        }), t.length >= w.maxWorkersNumberFromInitialLoad && a.createElement(h.InlineButton, {
          role: "button",
          onClick: this.onFilterButtonClick
        }, a.createElement(l.Template, {
          source: v.templates.TeamsViewResultsSummaryFilterCTA
        }))) : a.createElement(h.ResultsSummaryCard, null, a.createElement("h5", null, a.createElement(l.Template, {
          source: v.templates.TeamsViewResultsSummaryNoWorkersDisplayedTitle
        })), a.createElement(l.Template, {
          source: v.templates.TeamsViewResultsSummaryNoWorkersDisplayed
        }));
      }, n = r = i([P.withTheme], n);
    }(a.PureComponent);
    t.TeamsViewImpl = T;
  }, function (e, t, n) {
    "use strict";

    var _r199,
      o = this && this.__extends || (_r199 = function r(e, t) {
        return (_r199 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r199(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerCanvas = void 0;
    var s = n(1),
      l = n(0),
      c = n(632),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(c.WorkerCanvasImpl, i({}, this.props));
        }, t.displayName = c.displayName, t.Content = c.contentStore, t.defaultProps = {
          showSkills: !0
        }, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.WorkerCanvas = u;
  }, function (e, t, n) {
    "use strict";

    var _r200,
      o = this && this.__extends || (_r200 = function r(e, t) {
        return (_r200 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r200(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerCanvasImpl = t.contentStore = t.displayName = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(633),
      u = n(4),
      p = n(272),
      d = n(273),
      f = n(649),
      h = n(6);
    t.displayName = "WorkerCanvas", t.contentStore = new l.DynamicContentStore(t.displayName);
    var m = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleClose = function () {
          h.tryInvokeAction("SelectWorkerInSupervisor", void 0);
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = e.worker,
          r = e.showSkills;
        return s.createElement(l.SidePanel, {
          displayName: t.displayName,
          contentStore: t.contentStore,
          themeOverride: this.props.theme.Supervisor.WorkerCanvas,
          HeaderComponent: s.createElement(f.WorkerCanvasHeader, {
            key: "header",
            worker: n
          }),
          childrenProps: this.props
        }, s.createElement(c.Caption, {
          key: "profile-title",
          className: "Twilio-WorkerCanvas-SectionHeader"
        }, s.createElement(l.Template, {
          source: u.templates.WorkerCanvasDetailsHeader
        })), s.createElement(p.WorkerProfile, {
          key: "profile",
          worker: n
        }), r && s.createElement(c.Caption, {
          key: "skills-title",
          className: "Twilio-WorkerCanvas-SectionHeader"
        }, s.createElement(l.Template, {
          source: u.templates.WorkerCanvasSkillsHeader
        })), r && s.createElement(d.WorkerSkills, {
          key: "skills",
          worker: n,
          onClose: this.handleClose
        }));
      }, n = i([a.withTheme], n);
    }(s.PureComponent);
    t.WorkerCanvasImpl = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Caption = void 0;
    var o,
      i = n(2);
    t.Caption = i.default("div")(o || (o = r(["\n    flex: 0 0 auto;\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n    border-style: solid;\n    padding-left: 11px;\n    align-items: center;\n    height: 24px;\n    border-width: 0 0 1px 0;\n    text-transform: uppercase;\n    ", "\n"], ["\n    flex: 0 0 auto;\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n    border-style: solid;\n    padding-left: 11px;\n    align-items: center;\n    height: 24px;\n    border-width: 0 0 1px 0;\n    text-transform: uppercase;\n    ", "\n"])), function (e) {
      return e.theme.Supervisor.WorkerCanvas.SectionCaption;
    });
  }, function (e, t, n) {
    "use strict";

    var _r201,
      o = this && this.__extends || (_r201 = function r(e, t) {
        return (_r201 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r201(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerProfile = void 0;
    var s = n(1),
      l = n(0),
      c = n(635),
      u = n(2),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(d, i({}, this.props));
        }, t.displayName = c.displayName, t.friendlyName = c.displayName, t.Content = c.contentStore, t.defaultProps = {}, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.WorkerProfile = p;
    var d = u.withTheme(c.WorkerProfileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r202,
      o = this && this.__extends || (_r202 = function r(e, t) {
        return (_r202 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r202(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerProfileImpl = t.contentStore = t.displayName = void 0;
    var i = n(1),
      a = n(3),
      s = n(0),
      l = n(58),
      c = n(5),
      u = n(6),
      p = n(636);
    t.displayName = "WorkerCanvasProfile", t.contentStore = new s.DynamicContentStore(t.displayName);
    var d = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.renderDetails = function () {
          return c.log.warn("WorkerProfile details prop is deprecated!"), i.createElement("table", null, i.createElement("tbody", null, t.props.details.map(function (e) {
            return i.createElement("tr", {
              key: "detail-row-" + e.name
            }, i.createElement("td", null, i.createElement(p.FirstTemplate, null, i.createElement(s.Template, {
              code: e.name
            }))), i.createElement("td", null, i.createElement(p.SecondTemplate, null, i.createElement(s.Template, {
              code: e.content
            }))));
          })));
        }, t.handleChange = function (e) {
          var n = e.target.value,
            r = t.props.worker.sid;
          u.tryInvokeAction("SetWorkerActivity", {
            workerSid: r,
            activitySid: n
          });
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props.worker,
          n = Array.from(a.FlexModule.state.worker.activities.values()).filter(function (e) {
            return "Reserved" !== e.name;
          });
        return i.createElement(p.StyledFlexBox, {
          className: "Twilio-WorkerProfile",
          vertical: !0,
          noGrow: !0,
          noShrink: !0
        }, i.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children
        }, i.createElement(s.FlexBox, null, i.createElement(p.AvatarContainer, {
          key: "avatar",
          className: "Twilio-WorkerProfile-Avatar",
          noGrow: !0,
          noShrink: !0
        }, i.createElement(p.StyledAvatar, {
          imageUrl: e.attributes.image_url,
          available: e.isAvailable,
          large: !0
        })), i.createElement(s.FlexBoxColumn, {
          key: "info",
          className: "Twilio-WorkerProfile-Info",
          overflow: "hidden"
        }, i.createElement(p.NameContainer, {
          className: "Twilio-WorkerProfile-Name"
        }, " ", e.fullName, " "), i.createElement(p.StyledSelect, {
          key: "availability",
          className: "Twilio-WorkerProfile-WorkerActivity",
          value: n.find(function (t) {
            return t.name === e.activityName;
          }).sid,
          onChange: this.handleChange
        }, n.map(function (e, t) {
          return i.createElement(l.default, {
            key: e.sid,
            value: e.sid
          }, e.name);
        }))))), !!this.props.details && this.renderDetails());
      }, n;
    }(i.PureComponent);
    t.WorkerProfileImpl = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledSelect = t.NameContainer = t.AvatarContainer = t.StyledFlexBox = t.StyledAvatar = t.SecondTemplate = t.FirstTemplate = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p = n(2),
      d = n(0),
      f = n(59);
    t.FirstTemplate = p.default("div")(o || (o = r(["\n    margin-left: 13px;\n    margin-bottom: 13px;\n"], ["\n    margin-left: 13px;\n    margin-bottom: 13px;\n"]))), t.SecondTemplate = p.default("div")(i || (i = r(["\n    font-weight: bold;\n"], ["\n    font-weight: bold;\n"]))), t.StyledAvatar = p.default(d.Avatar)(a || (a = r(["\n    width: 60px;\n    height: 60px;\n    margin-left: 14px;\n    margin-top: 14px;\n    margin-bottom: 12px;\n"], ["\n    width: 60px;\n    height: 60px;\n    margin-left: 14px;\n    margin-top: 14px;\n    margin-bottom: 12px;\n"]))), t.StyledFlexBox = p.default(d.FlexBox)(s || (s = r(["\n    margin-bottom: 32px;\n"], ["\n    margin-bottom: 32px;\n"]))), t.AvatarContainer = p.default(d.FlexBox)(l || (l = r(["\n    width: 100px;\n"], ["\n    width: 100px;\n"]))), t.NameContainer = p.default("div")(c || (c = r(["\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    font-size: 12px;\n    font-weight: bold;\n    margin-top: 14px;\n    margin-bottom: 14px;\n"], ["\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    font-size: 12px;\n    font-weight: bold;\n    margin-top: 14px;\n    margin-bottom: 14px;\n"]))), t.StyledSelect = p.default(f.default)(u || (u = r(["\n    margin-right: 16px;\n    margin-bottom: auto;\n    overflow-x: hidden;\n    flex: 1 1 auto;\n"], ["\n    margin-right: 16px;\n    margin-bottom: auto;\n    overflow-x: hidden;\n    flex: 1 1 auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r203,
      o = this && this.__extends || (_r203 = function r(e, t) {
        return (_r203 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r203(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerSkills = void 0;
    var s = n(1),
      l = n(0),
      c = n(19),
      u = n(638),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return s.createElement(c.FlexContext.Consumer, null, function (t) {
            return s.createElement(u.WorkerSkillsImpl, i({}, e.props, {
              availableSkills: e.props.availableSkills || t.manager.serviceConfiguration.taskrouter_skills
            }));
          });
        }, t.displayName = u.displayName, t.Content = u.contentStore, t.defaultProps = {}, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.WorkerSkills = p;
  }, function (e, t, n) {
    "use strict";

    var _r204,
      o = this && this.__extends || (_r204 = function r(e, t) {
        return (_r204 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r204(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerSkillsImpl = t.contentStore = t.displayName = void 0;
    var s,
      l = n(2),
      c = n(1),
      u = n(27),
      p = n(34),
      d = n(156),
      f = n(157),
      h = n(0),
      m = n(4),
      g = n(19),
      y = n(3),
      v = n(7),
      b = n(5),
      C = n(640),
      _ = n(645),
      k = n(9);
    !function (e) {
      e.Error = "WorkerSkillsError", e.Saved = "WorkerSkillsSaved", e.Reverted = "WorkerSkillsReverted";
    }(s || (s = {})), t.displayName = "WorkerSkills", t.contentStore = new h.DynamicContentStore(t.displayName);
    var w = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          workerSid: void 0,
          skillsByName: void 0,
          skillsByNameOriginal: void 0
        }, t.handleSaveClick = function () {
          var e = t.getMergedAttributes(),
            n = {
              Sid: t.props.worker.sid,
              WorkspaceSid: g.Manager.getInstance().serviceConfiguration.taskrouter_workspace_sid,
              Attributes: JSON.stringify(e)
            },
            r = {
              auth: {
                username: "token",
                password: y.FlexModule.state.session.ssoTokenPayload.token
              },
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            };
          b.log.debug("updating attributes for worker", n);
          var o = k.getFlexServiceUrl(y.FlexModule.state.config);
          u.default.post(o + "/Worker/Instance", p.stringify(n), r).then(function () {
            b.log.debug("worker attributes updated", t.props.worker.sid), t.setState(function (e) {
              return {
                skillsByNameOriginal: e.skillsByName,
                notificationTemplate: s.Saved
              };
            });
          }).catch(function (e) {
            v.ErrorManager.createAndProcessError("Failed to update worker attributes", {
              type: v.FlexErrorType.app,
              context: "WorkerSkills",
              wrappedError: e
            }), t.setState({
              notificationTemplate: s.Error
            });
          });
        }, t.handleCancelClick = function () {
          t.setState(function (e) {
            return {
              skillsByName: e.skillsByNameOriginal,
              notificationTemplate: s.Reverted
            };
          });
        }, t.handleSkillUpdate = function (e) {
          t.setState(function (t) {
            var n;
            return {
              skillsByName: i(i({}, t.skillsByName), (n = {}, n[e.name] = e, n)),
              notificationTemplate: void 0
            };
          });
        }, t.handleSkillRemove = function (e) {
          t.setState(function (t) {
            var n = i({}, t.skillsByName);
            return delete n[e.name], {
              skillsByName: n,
              notificationTemplate: void 0
            };
          });
        }, t;
      }
      var r;
      return o(n, e), r = n, n.getDerivedStateFromProps = function (e, t) {
        return e.worker.sid === t.workerSid ? null : {
          workerSid: e.worker.sid,
          skillsByName: r.getSkillsFromWorker(e.worker, e.availableSkills),
          skillsByNameOriginal: r.getSkillsFromWorker(e.worker, e.availableSkills)
        };
      }, n.prototype.render = function () {
        var e = this,
          n = this.props,
          r = n.availableSkills,
          o = n.theme,
          i = this.state,
          a = i.skillsByName,
          s = i.skillsByNameOriginal,
          l = i.notificationTemplate,
          u = !s,
          p = u ? [] : Object.keys(a).map(function (e) {
            return a[e];
          }).sort(function (e, t) {
            return e.name.localeCompare(t.name);
          }),
          g = !u && JSON.stringify(s) !== JSON.stringify(a),
          y = p.every(f.isSkillLevelOk);
        return c.createElement(h.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, c.createElement(d.Container, {
          className: "Twilio-WorkerSkills",
          vertical: !0,
          noGrow: !0,
          noShrink: !0
        }, c.createElement(C.AddSkillPanel, {
          key: "add-skills",
          allSkillsDefinitions: !u && r || [],
          selectedSkills: a || {},
          onAdd: this.handleSkillUpdate
        }), c.createElement(d.SkillsContainer, {
          key: "skills-container",
          className: "Twilio-WorkerSkills-SkillsContainer",
          vertical: !0,
          noGrow: !0
        }, p.map(function (t) {
          return c.createElement(_.WorkerSkill, {
            key: t.name,
            skill: t,
            onUpdate: e.handleSkillUpdate,
            onRemove: e.handleSkillRemove
          });
        })), 0 === p.length && c.createElement(d.NoSkillsContainer, {
          key: "no-skills",
          className: "Twilio-WorkerSkills-NoSkills",
          noGrow: !0
        }, c.createElement(h.Template, {
          source: u ? m.templates.WorkerSkillsSchemaMismatch : m.templates.WorkerSkillsNoSkills
        })), c.createElement(d.ButtonsContainer, {
          key: "buttons-container",
          className: "Twilio-WorkerSkills-ButtonsContainer",
          noGrow: !0,
          noShrink: !0
        }, c.createElement(h.Button, {
          className: "Twilio-WorkerSkills-SkillsSaveButton",
          disabled: !g || !y,
          onClick: this.handleSaveClick,
          themeOverride: o.WorkerSkills.SaveButton,
          roundCorners: !1
        }, c.createElement(h.Template, {
          source: m.templates.Save
        })), c.createElement(h.Button, {
          className: "Twilio-WorkerSkills-SkillsCancelButton",
          disabled: !g,
          onClick: this.handleCancelClick,
          themeOverride: o.WorkerSkills.CancelButton,
          roundCorners: !1
        }, c.createElement(h.Template, {
          source: m.templates.Reset
        }))), !!l && c.createElement(d.NotificationTextContainer, {
          key: "notification-container",
          className: "Twilio-WorkerSkills-Notification",
          noGrow: !0
        }, c.createElement(h.Template, {
          code: l
        }))));
      }, n.prototype.getMergedAttributes = function () {
        var e = this,
          t = function t(_t2, n) {
            var r = e.state.skillsByName;
            _t2.skills = [], _t2.levels = {}, Object.keys(r).forEach(function (e) {
              var o = r[e];
              o.disabled === n && (_t2.skills.push(o.name), o.multivalue && (_t2.levels[o.name] = o.level));
            });
          },
          n = this.props.worker.attributes || {},
          r = n.disabled_skills || {},
          o = n.routing || {};
        return t(r, !0), t(o, !1), i(i({}, n), {
          routing: o,
          disabled_skills: r
        });
      }, n.getSkillsFromWorker = function (e, t) {
        var n = {};
        if (t) {
          var r = function r(_r205, o) {
            if (void 0 === _r205) return !0;
            if ("object" != typeof _r205) return !1;
            if (!Array.isArray(_r205.skills)) return b.log.warn("skills is not an array", _r205), void 0 === _r205.skills;
            var a = !0;
            return _r205.skills.forEach(function (s) {
              if ("string" != typeof s) return b.log.warn("skill name is not a string", s), void (a = !1);
              var l,
                c,
                u,
                p = t.find(function (e) {
                  return e.name === s;
                }) || {
                  multivalue: (l = s, !!(null === (u = null === (c = null == e ? void 0 : e.attributes) || void 0 === c ? void 0 : c.routing) || void 0 === u ? void 0 : u.levels[l])),
                  minimum: 0,
                  maximum: 1 / 0
                };
              n[s] = i(i({}, p), {
                disabled: o,
                name: s,
                level: _r205.levels ? _r205.levels[s] : void 0
              });
            }), a;
          };
          if (e.attributes) {
            var o = r(e.attributes.disabled_skills, !0),
              a = r(e.attributes.routing, !1);
            if (o && a) return n;
          }
        } else v.ErrorManager.createAndProcessError("No `taskrouter_skills` array present in service configuration.", {
          type: v.FlexErrorType.app,
          context: "WorkerSkills"
        });
      }, n = r = a([l.withTheme], n);
    }(c.PureComponent);
    t.WorkerSkillsImpl = w;
  }, function (e, t) {
    e.exports = require("@material-ui/core/FormControlLabel");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AddSkillPanel = void 0;
    var r = n(641);
    Object.defineProperty(t, "AddSkillPanel", {
      enumerable: !0,
      get: function get() {
        return r.AddSkillPanel;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r206,
      o = this && this.__extends || (_r206 = function r(e, t) {
        return (_r206 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r206(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AddSkillPanel = void 0;
    var s = n(1),
      l = n(0),
      c = n(274),
      u = n(2),
      p = n(4),
      d = n(156),
      f = n(157),
      h = n(642),
      m = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {}, t.handleSkillSelected = function (e) {
            t.setState({
              current: e ? i(i({}, e), {
                disabled: !1
              }) : void 0
            });
          }, t.handleLevelChange = function (e) {
            var n = parseInt(e.target.value, 10);
            t.setState(function (e) {
              return {
                current: i(i({}, e.current), {
                  level: Number.isNaN(n) ? void 0 : n
                })
              };
            });
          }, t.handleAddClick = function () {
            t.props.onAdd(t.state.current), t.setState({
              current: void 0
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.state.current,
            t = this.props,
            n = t.allSkillsDefinitions,
            r = t.selectedSkills,
            o = t.theme,
            a = !!e && f.isSkillLevelOk(e),
            u = "";
          e && void 0 !== e.level && (u = String(e.level));
          var m = n.map(function (e) {
            return i(i({}, e), {
              disabled: !!r[e.name]
            });
          }).sort(function (e, t) {
            return e.name.localeCompare(t.name);
          });
          return s.createElement(d.AddPanelContainer, {
            className: "Twilio-WorkerSkills-AddSkillPanel",
            noGrow: !0,
            noShrink: !0,
            vertical: !0
          }, s.createElement(l.FlexBox, {
            noGrow: !0
          }, s.createElement(h.SkillsSelect, {
            values: m,
            selected: m.findIndex(function (t) {
              return t.name === (e && e.name);
            }),
            onChanged: this.handleSkillSelected
          }), s.createElement(d.LevelInputAndButtonContainer, {
            vertical: !0,
            noGrow: !0,
            noShrink: !0
          }, s.createElement(l.FlexBox, {
            noGrow: !0,
            noShrink: !0
          }, s.createElement(d.StyledSkillLevelInput, {
            disabled: !e || !e.multivalue,
            error: !!e && !a,
            value: u,
            placeholder: e && e.multivalue ? "" : "-",
            onChange: this.handleLevelChange
          }), s.createElement(d.RightButtonContainer, null, s.createElement(l.IconButton, {
            icon: "Add",
            themeOverride: o.WorkerSkills.SaveButton,
            onClick: this.handleAddClick,
            disabled: !a
          }))), !a && !!e && s.createElement(c.default, null, s.createElement(l.Template, {
            source: p.templates.WorkerSkillLevelInvalid,
            min: e.minimum,
            max: e.maximum
          })))));
        }, t = a([u.withTheme], t);
      }(s.PureComponent);
    t.AddSkillPanel = m;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SkillsSelect = void 0;
    var r = n(643);
    Object.defineProperty(t, "SkillsSelect", {
      enumerable: !0,
      get: function get() {
        return r.SkillsSelect;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r207,
      o = this && this.__extends || (_r207 = function r(e, t) {
        return (_r207 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r207(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SkillsSelect = void 0;
    var i = n(1),
      a = n(0),
      s = n(58),
      l = n(4),
      c = n(644),
      u = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleChange = function (e) {
            var n = -1 === e.target.value ? void 0 : t.props.values[e.target.value];
            t.props.onChanged(n);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.values,
            n = e.selected;
          return i.createElement(c.StyledSelect, {
            className: "Twilio-WorkerSkills-Select",
            value: n,
            onChange: this.handleChange,
            displayEmpty: !0
          }, i.createElement(s.default, {
            value: -1,
            disabled: !0
          }, i.createElement(a.Template, {
            source: l.templates.WorkerSkillPleaseSelect
          })), t.map(function (e, t) {
            return i.createElement(s.default, {
              key: e.name,
              value: t,
              disabled: e.disabled,
              className: e.disabled ? "Twilio-disabled" : ""
            }, i.createElement(a.Template, {
              code: e.name
            }));
          }));
        }, t;
      }(i.PureComponent);
    t.SkillsSelect = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledSelect = void 0;
    var o,
      i = n(2),
      a = n(59);
    t.StyledSelect = i.default(a.default)(o || (o = r(["\n    margin-right: 16px;\n    margin-bottom: auto;\n    overflow-x: hidden;\n    flex: 1 1 auto;\n"], ["\n    margin-right: 16px;\n    margin-bottom: auto;\n    overflow-x: hidden;\n    flex: 1 1 auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerSkill = void 0;
    var r = n(646);
    Object.defineProperty(t, "WorkerSkill", {
      enumerable: !0,
      get: function get() {
        return r.WorkerSkill;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r208,
      o = this && this.__extends || (_r208 = function r(e, t) {
        return (_r208 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r208(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      a = this && this.__assign || function () {
        return (a = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      s = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerSkill = void 0;
    var l,
      c = n(2),
      u = n(1),
      p = n(33),
      d = n(0),
      f = n(647),
      h = n(274),
      m = n(4),
      g = n(156),
      y = n(648),
      v = n(157),
      b = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleSkillChecked = function (e) {
            var n = !e.target.checked;
            t.props.onUpdate(a(a({}, t.props.skill), {
              disabled: n
            }));
          }, t.handleLevelChange = function (e) {
            var n = parseInt(e.target.value, 10);
            t.props.onUpdate(a(a({}, t.props.skill), {
              level: Number.isNaN(n) ? void 0 : n
            }));
          }, t.handleRemoveClick = function () {
            t.props.onRemove(t.props.skill);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.skill,
            t = {
              label: p.css(l || (l = i(["\n                opacity: 0.4;\n            "], ["\n                opacity: 0.4;\n            "])))
            },
            n = v.isSkillLevelOk(e);
          return u.createElement(y.WorkerSkillContainer, {
            className: "Twilio-WorkerSkill",
            vertical: !0,
            noGrow: !0,
            noShrink: !0
          }, u.createElement(d.FlexBox, {
            noShrink: !0
          }, u.createElement(g.StyledFormControlLabel, {
            classes: e.disabled ? t : void 0,
            control: u.createElement(f.default, {
              checked: !e.disabled,
              onChange: this.handleSkillChecked,
              value: "checked",
              color: "primary"
            }),
            label: u.createElement(d.Template, {
              code: e.name
            })
          }), u.createElement(g.LevelInputAndButtonContainer, {
            vertical: !0,
            noGrow: !0,
            noShrink: !0
          }, u.createElement(d.FlexBox, {
            noGrow: !0,
            noShrink: !0
          }, u.createElement(g.StyledSkillLevelInput, {
            disabled: !e.multivalue,
            error: !v.isSkillLevelOk(e),
            value: void 0 !== e.level || e.multivalue ? e.level || "" : "-",
            placeholder: e.multivalue ? "-" : "",
            onChange: this.handleLevelChange
          }), u.createElement(g.RightButtonContainer, null, u.createElement(d.IconButton, {
            icon: "Close",
            onClick: this.handleRemoveClick,
            themeOverride: this.props.theme.WorkerSkills.DeleteButton
          }))), !n && u.createElement(h.default, null, u.createElement(d.Template, {
            source: m.templates.WorkerSkillLevelInvalid,
            min: e.minimum,
            max: e.maximum
          })))));
        }, t = s([c.withTheme], t);
      }(u.PureComponent);
    t.WorkerSkill = b;
  }, function (e, t) {
    e.exports = require("@material-ui/core/Switch");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerSkillContainer = void 0;
    var o,
      i = n(2),
      a = n(0);
    t.WorkerSkillContainer = i.default(a.FlexBox)(o || (o = r(["\n    padding-top: 6px;\n    padding-bottom: 6px;\n"], ["\n    padding-top: 6px;\n    padding-bottom: 6px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerCanvasHeaderProps = t.WorkerCanvasHeader = void 0;
    var r = n(650);
    Object.defineProperty(t, "WorkerCanvasHeader", {
      enumerable: !0,
      get: function get() {
        return r.WorkerCanvasHeader;
      }
    }), Object.defineProperty(t, "WorkerCanvasHeaderProps", {
      enumerable: !0,
      get: function get() {
        return r.WorkerCanvasHeaderProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r209,
      o = this && this.__extends || (_r209 = function r(e, t) {
        return (_r209 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r209(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WorkerCanvasHeader = void 0;
    var a = n(2),
      s = n(1),
      l = n(0),
      c = n(4),
      u = n(651),
      p = n(6),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleCloseButton = function () {
            p.tryInvokeAction("SelectWorkerInSupervisor", {
              worker: void 0
            });
          }, t;
        }
        var n;
        return o(t, e), n = t, t.prototype.render = function () {
          return s.createElement(l.DynamicComponent, {
            contentStore: n.Content,
            childProps: this.props,
            name: n.friendlyName,
            customChildren: this.props.children,
            noContainers: !0
          }, s.createElement(u.HeaderContainer, {
            noShrink: !0,
            noGrow: !0
          }, s.createElement(l.IconButton, {
            key: "close-button",
            icon: "Close",
            themeOverride: this.props.theme.Supervisor.TaskCanvas.HeaderButton,
            onClick: this.handleCloseButton
          }), s.createElement(u.Text, {
            key: "title"
          }, s.createElement(l.Template, {
            source: c.templates.WorkerCanvasHeader
          }))));
        }, t.friendlyName = "WorkerCanvasHeader", t.displayName = n.friendlyName, t.Content = new l.DynamicContentStore(n.friendlyName), t = n = i([a.withTheme], t);
      }(s.PureComponent);
    t.WorkerCanvasHeader = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HeaderContainer = t.Text = void 0;
    var o,
      i,
      a = n(2),
      s = n(0);
    t.Text = a.default(s.FlexBox)(o || (o = r(["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 44px;\n    text-transform: uppercase;\n"], ["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 44px;\n    text-transform: uppercase;\n"]))), t.HeaderContainer = a.default(s.FlexBox)(i || (i = r(["\n    height: 56px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n"], ["\n    height: 56px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n"])), function (e) {
      return e.theme.Supervisor.WorkerCanvas.Header;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineButton = t.ResultsSummaryCard = t.ResultsSummary = t.ClearSearchLink = t.SearchContainer = t.FilterButton = t.FilterContainer = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d = n(0),
      f = n(2);
    t.Container = f.default(d.FlexBox)(o || (o = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.Supervisor.Container;
    }), t.FilterContainer = f.default(d.FlexBox)(i || (i = r(["\n    margin: 32px 18px;\n    justify-content: space-between;\n"], ["\n    margin: 32px 18px;\n    justify-content: space-between;\n"]))), t.FilterButton = f.default(d.Button)(a || (a = r(["\n    width: 107px;\n    height: 32px;\n    padding: 0 8px;\n    text-transform: uppercase;\n    font-weight: bold;\n    text-align: left;\n    letter-spacing: 1px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid;\n    ", ";\n    ", ";\n"], ["\n    width: 107px;\n    height: 32px;\n    padding: 0 8px;\n    text-transform: uppercase;\n    font-weight: bold;\n    text-align: left;\n    letter-spacing: 1px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid;\n    ", ";\n    ", ";\n"])), function (e) {
      return e.theme.Supervisor.FilterButton;
    }, function (e) {
      return d.getBackgroundWithHoverCSS(e.theme.Supervisor.FilterButton.background, e.theme.Supervisor.FilterButton.lightHover);
    }), t.SearchContainer = f.default("div")(s || (s = r(["\n    display: flex;\n    align-items: center;\n    ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    ", ";\n"])), function (e) {
      return e.theme.Supervisor.Search.Container;
    }), t.ClearSearchLink = f.default("div")(l || (l = r(["\n    text-decoration: underline;\n    margin-left: 8px;\n    cursor: pointer;\n"], ["\n    text-decoration: underline;\n    margin-left: 8px;\n    cursor: pointer;\n"]))), t.ResultsSummary = f.default("div")(c || (c = r(["\n    margin-top: 20px;\n    color: ", ";\n    text-align: center;\n    line-height: 20px;\n"], ["\n    margin-top: 20px;\n    color: ", ";\n    text-align: center;\n    line-height: 20px;\n"])), function (e) {
      return e.theme.calculated.textColor;
    }), t.ResultsSummaryCard = f.default("div")(u || (u = r(["\n    display: inline-block;\n    margin: 32px auto;\n    padding: 56px 75px;\n    color: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    text-align: center;\n    line-height: 20px;\n\n    h5 {\n        text-align: left;\n        font-size: 20px;\n        margin-bottom: 28px;\n        font-weight: bold;\n    }\n"], ["\n    display: inline-block;\n    margin: 32px auto;\n    padding: 56px 75px;\n    color: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    text-align: center;\n    line-height: 20px;\n\n    h5 {\n        text-align: left;\n        font-size: 20px;\n        margin-bottom: 28px;\n        font-weight: bold;\n    }\n"])), function (e) {
      return e.theme.calculated.textColor;
    }, function (e) {
      return e.theme.colors.base2;
    }), t.InlineButton = f.default("button")(p || (p = r(["\n    background: none;\n    font-weight: bold;\n    display: inline;\n    border-radius: 3px;\n    box-shadow: none;\n    font-size: inherit;\n    line-height: inherit;\n    padding: 0;\n    border: none;\n    text-decoration: underline;\n    cursor: pointer;\n\n    &:focus {\n        box-shadow: 0 0 0 2px ", ";\n        outline: none;\n    }\n\n    &:disabled {\n        color: ", ";\n        text-decoration: none;\n        font-weight: normal;\n        cursor: default;\n    }\n"], ["\n    background: none;\n    font-weight: bold;\n    display: inline;\n    border-radius: 3px;\n    box-shadow: none;\n    font-size: inherit;\n    line-height: inherit;\n    padding: 0;\n    border: none;\n    text-decoration: underline;\n    cursor: pointer;\n\n    &:focus {\n        box-shadow: 0 0 0 2px ", ";\n        outline: none;\n    }\n\n    &:disabled {\n        color: ", ";\n        text-decoration: none;\n        font-weight: normal;\n        cursor: default;\n    }\n"])), function (e) {
      return e.theme.colors.flexBlueColor;
    }, function (e) {
      return e.theme.calculated.textColor;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SearchBar = void 0;
    var r = n(654);
    Object.defineProperty(t, "SearchBar", {
      enumerable: !0,
      get: function get() {
        return r.SearchBar;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r210,
      o = this && this.__extends || (_r210 = function r(e, t) {
        return (_r210 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r210(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SearchBar = void 0;
    var i = n(1),
      a = n(0),
      s = n(655),
      l = n(5),
      c = function (e) {
        function t() {
          var n = null !== e && e.apply(this, arguments) || this;
          return n.onChange = function (e) {
            var r = e.target.value;
            r.length > t.MAX_CHARACTER_LIMIT ? l.log.debug("Search string exceeds max character limit of " + t.MAX_CHARACTER_LIMIT) : n.props.onChange && n.props.onChange(r);
          }, n.onSubmit = function (e) {
            e.preventDefault(), n.props.onSubmit && !n.props.disabled && n.props.onSubmit(n.props.value);
          }, n;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement("div", null, i.createElement(s.StyledForm, {
            onSubmit: this.onSubmit
          }, i.createElement(s.StyledInput, {
            value: this.props.value,
            onChange: this.onChange,
            placeholder: this.props.placeholder
          }), i.createElement(s.SearchButton, {
            roundCorners: !1,
            disabled: this.props.disabled
          }, i.createElement(a.Icon, {
            icon: "Search"
          }))));
        }, t.MAX_CHARACTER_LIMIT = 996, t;
      }(i.PureComponent);
    t.SearchBar = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SearchButton = t.StyledForm = t.StyledInput = t.StyledSearchIconButton = void 0;
    var o,
      i,
      a,
      s,
      l = n(2),
      c = n(22),
      u = n(0);
    t.StyledSearchIconButton = l.default("div")(o || (o = r(["\n    position: absolute;\n    right: 0;\n    height: 100%;\n    display: flex;\n    cursor: pointer;\n"], ["\n    position: absolute;\n    right: 0;\n    height: 100%;\n    display: flex;\n    cursor: pointer;\n"]))), t.StyledInput = l.default(c.Input)(i || (i = r(["\n    width: 252px;\n    input {\n        padding-right: 30px;\n    }\n"], ["\n    width: 252px;\n    input {\n        padding-right: 30px;\n    }\n"]))), t.StyledForm = l.default("form")(a || (a = r(["\n    display: flex;\n"], ["\n    display: flex;\n"]))), t.SearchButton = l.default(u.Button)(s || (s = r(["\n    height: 32px;\n    width: 32px;\n    padding: 0;\n    opacity: ", ";\n    ", ";\n    ", ";\n"], ["\n    height: 32px;\n    width: 32px;\n    padding: 0;\n    opacity: ", ";\n    ", ";\n    ", ";\n"])), function (e) {
      return e.disabled && .8;
    }, function (e) {
      return e.theme.Supervisor.Search.Button;
    }, function (e) {
      return u.getBackgroundWithHoverCSS(e.theme.Supervisor.Search.Button.background, e.theme.Supervisor.Search.Button.lightHover);
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.selectUserFilter = t.selectSearchFilter = void 0;
    var r = n(94);
    t.selectSearchFilter = function (e) {
      return e.view.filters[r.FiltersType.search];
    };
    t.selectUserFilter = function (e) {
      return e.view.filters[r.FiltersType.filter];
    };
  }, function (e, t, n) {
    "use strict";

    var _r211,
      o = this && this.__extends || (_r211 = function r(e, t) {
        return (_r211 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r211(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QueuesStatsViewImpl = t.Content = t.displayName = void 0;
    var a = n(0),
      s = n(1),
      l = n(141),
      c = n(13),
      u = n(9),
      p = n(6),
      d = n(216),
      f = n(4),
      h = n(658),
      m = n(136),
      g = n(61);
    t.displayName = "QueuesStatsView", t.Content = new a.DynamicContentStore(t.displayName);
    var y = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.timeout = null, t.state = {
            expired: !1
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          var e = this;
          this.timeout = window.setTimeout(function () {
            e.setState({
              expired: !0
            }), e.timeout = null;
          }, 1e4);
        }, t.prototype.componentWillUnmount = function () {
          null !== this.timeout && (clearTimeout(this.timeout), this.timeout = null);
        }, t.prototype.render = function () {
          return this.state.expired ? s.createElement(a.ErrorMessage, {
            title: "We couldn't load your queues.",
            description: "Please refresh the page and try again. If the issue persists, please contact support.",
            primaryAction: function primaryAction() {
              return p.tryInvokeAction("ReloadWindow");
            },
            primaryActionTitle: "Refresh",
            hideBranding: !0
          }) : s.createElement(g.LoadingContainer, null, s.createElement(a.CircularProgress, {
            animating: !0,
            size: 80,
            borderWidth: 3
          }));
        }, t;
      }(s.PureComponent),
      v = function (e) {
        function n() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.isAdmin = function (e) {
            return e.manager.user.roles.indexOf("admin") >= 0;
          }, t;
        }
        return o(n, e), n.prototype.componentDidMount = function () {
          d.QueuesStatsSubscriptionService.init();
        }, n.prototype.componentWillUnmount = function () {
          d.QueuesStatsSubscriptionService.close();
        }, n.prototype.render = function () {
          var e = this,
            n = this.props,
            r = n.children,
            o = i(n, ["children"]),
            d = o.isLoading,
            v = o.hasNoData,
            b = o.error;
          if (b) return s.createElement(a.ErrorMessage, {
            title: "We couldn't load your queues.",
            description: "There was an error loading Queues Stats. Please contact support with the following error: " + b.message,
            primaryAction: function primaryAction() {
              return p.tryInvokeAction("ReloadWindow");
            },
            primaryActionTitle: "Refresh",
            hideBranding: !0
          });
          if (d) return s.createElement(y, null);
          if (v) {
            var C = c.Manager.getInstance().serviceConfiguration.taskrouter_workspace_sid;
            return s.createElement(g.Container, null, s.createElement(l.FlexContext.Consumer, null, function (t) {
              return s.createElement(h.NoDataPlaceholder, {
                heading: s.createElement(f.Template, {
                  source: f.templates.QueuesNoDataHeading
                }),
                body: s.createElement(f.Template, {
                  source: e.isAdmin(t) ? f.templates.QueuesNoDataBodyForAdmin : f.templates.QueuesNoDataBodyForSupervisor
                }),
                linkText: e.isAdmin(t) ? s.createElement(f.Template, {
                  source: f.templates.QueuesNoDataLinkLabelForAdmin
                }) : void 0,
                linkUrl: e.isAdmin(t) ? u.getTwilioTaskQueuesUrl(C) : void 0,
                image: s.createElement(a.Icon, {
                  icon: "NoData",
                  sizeMultiplier: 3
                })
              });
            }));
          }
          return s.createElement(a.DynamicComponent, {
            name: t.displayName,
            contentStore: t.Content,
            childProps: o,
            customChildren: r,
            vertical: !0
          }, s.createElement(g.Container, {
            vertical: !0
          }, s.createElement(m.AggregatedQueuesDataTiles, {
            key: "tiles"
          }), s.createElement(m.QueuesDataTable, {
            key: "table"
          })));
        }, n;
      }(s.PureComponent);
    t.QueuesStatsViewImpl = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(659), t);
  }, function (e, t, n) {
    "use strict";

    var _r212,
      o = this && this.__extends || (_r212 = function r(e, t) {
        return (_r212 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r212(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NoDataPlaceholder = void 0;
    var i = n(1),
      a = n(660),
      s = n(33),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.heading,
            n = e.body,
            r = e.image,
            o = e.linkUrl,
            l = e.linkText;
          return i.createElement(a.Wrapper, {
            className: s.cx("Twilio-NoDataPlaceholder-Wrapper")
          }, r && i.createElement(a.ImageContainer, {
            className: s.cx("Twilio-NoDataPlaceholder-ImageContainer")
          }, r), i.createElement(a.Heading, {
            className: s.cx("Twilio-NoDataPlaceholder-Heading")
          }, t), i.createElement(a.Body, {
            className: s.cx("Twilio-NoDataPlaceholder-Body")
          }, n), o && l && i.createElement(a.StyledLink, {
            href: o,
            roundCorners: !1,
            className: s.cx("Twilio-NoDataPlaceholder-Link"),
            target: "_blank"
          }, l) || "");
        }, t;
      }(i.PureComponent);
    t.NoDataPlaceholder = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledLink = t.Body = t.Heading = t.ImageContainer = t.Wrapper = void 0;
    var o,
      i,
      a,
      s,
      l,
      c = n(2),
      u = n(0);
    t.Wrapper = c.default("div")(o || (o = r(["\n    max-width: 480px;\n    padding: 24px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-bottom: 72px;\n"], ["\n    max-width: 480px;\n    padding: 24px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-bottom: 72px;\n"]))), t.ImageContainer = c.default("div")(i || (i = r(["\n    margin-bottom: 24px;\n"], ["\n    margin-bottom: 24px;\n"]))), t.Heading = c.default("div")(a || (a = r(["\n    font-size: 14px;\n    margin-top: 0;\n    margin-bottom: 12px;\n    font-weight: normal;\n    line-height: 1;\n"], ["\n    font-size: 14px;\n    margin-top: 0;\n    margin-bottom: 12px;\n    font-weight: normal;\n    line-height: 1;\n"]))), t.Body = c.default("div")(s || (s = r(["\n    font-size: 32px;\n    line-height: 1.25;\n"], ["\n    font-size: 32px;\n    line-height: 1.25;\n"]))), t.StyledLink = c.default(u.Link)(l || (l = r(["\n    .Twilio &:link,\n    .Twilio &:visited {\n        background: ", ";\n        color: white;\n        margin-top: 32px;\n        text-transform: uppercase;\n        margin-left: 0;\n        margin-right: auto;\n    }\n"], ["\n    .Twilio &:link,\n    .Twilio &:visited {\n        background: ", ";\n        color: white;\n        margin-top: 32px;\n        text-transform: uppercase;\n        margin-left: 0;\n        margin-right: auto;\n    }\n"])), function (e) {
      return e.theme.colors.defaultButtonColor;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FullscreenableQueuesStatsView = void 0;
    var r = n(662),
      o = n(276);
    t.FullscreenableQueuesStatsView = r.makeFullscreenable(o.QueuesStatsViewComponent);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FullscreenConfig = t.isFullscreen = t.makeFullscreenable = void 0;
    var r = n(663);
    Object.defineProperty(t, "makeFullscreenable", {
      enumerable: !0,
      get: function get() {
        return r.makeFullscreenable;
      }
    }), Object.defineProperty(t, "isFullscreen", {
      enumerable: !0,
      get: function get() {
        return r.isFullscreen;
      }
    });
    var o = n(666);
    Object.defineProperty(t, "FullscreenConfig", {
      enumerable: !0,
      get: function get() {
        return o.FullscreenConfig;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r213,
      o = this && this.__extends || (_r213 = function r(e, t) {
        return (_r213 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r213(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isFullscreen = t.makeFullscreenable = void 0;
    var a = n(1),
      s = n(130),
      l = n(664),
      c = {
        enabled: !1,
        renderButton: null,
        wrapperStyles: {}
      };
    t.makeFullscreenable = function (e) {
      var t;
      return s(((t = function (t) {
        function n() {
          return null !== t && t.apply(this, arguments) || this;
        }
        return o(n, t), n.prototype.render = function () {
          var t = i(i({}, c), n.fullscreen);
          return document.fullscreenEnabled && t.enabled ? a.createElement(l.FullscreenableImpl, {
            renderButton: t.renderButton,
            wrapperStyles: t.wrapperStyles
          }, a.createElement(e, i({}, this.props))) : a.createElement(e, i({}, this.props));
        }, n;
      }(a.PureComponent)).displayName = "Fullscreenable(" + e.displayName + ")", t.fullscreen = i({}, c), t), e);
    };
    t.isFullscreen = function () {
      return !!document.fullscreenElement;
    };
  }, function (e, t, n) {
    "use strict";

    var _r214,
      o = this && this.__extends || (_r214 = function r(e, t) {
        return (_r214 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r214(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FullscreenableImpl = void 0;
    var i = n(1),
      a = n(665),
      s = n(0),
      l = function l(e) {
        return i.createElement(a.FullscreenButtonWrapper, {
          onClick: e.toggleFullscreen
        }, e.isFullscreen ? i.createElement(s.Icon, {
          icon: "Minimize"
        }) : i.createElement(s.Icon, {
          icon: "Fullscreen"
        }));
      },
      c = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.wrapper = i.createRef(), t.state = {
            isFullscreen: t.isFullscreen()
          }, t.handleButtonClick = function () {
            t.wrapper.current && (t.isFullscreen() ? document.exitFullscreen() : t.wrapper.current.requestFullscreen());
          }, t.fullscreenChangeHandler = function () {
            t.isFullscreen() ? t.setState({
              isFullscreen: !0
            }) : t.setState({
              isFullscreen: !1
            });
          }, t.fullscreenErrorHandler = function () {
            t.setState({
              isFullscreen: !1
            });
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this.wrapper.current && (this.wrapper.current.addEventListener("fullscreenchange", this.fullscreenChangeHandler), this.wrapper.current.addEventListener("fullscreenerror", this.fullscreenErrorHandler));
        }, t.prototype.componentWillUnmount = function () {
          this.wrapper.current && (this.wrapper.current.removeEventListener("fullscreenchange", this.fullscreenChangeHandler), this.wrapper.current.removeEventListener("fullscreenerror", this.fullscreenErrorHandler));
        }, t.prototype.isFullscreen = function () {
          return !!this.wrapper.current && document.fullscreenElement === this.wrapper.current;
        }, t.prototype.renderButton = function () {
          return (this.props.renderButton || l)({
            isFullscreen: this.state.isFullscreen,
            toggleFullscreen: this.handleButtonClick
          });
        }, t.prototype.render = function () {
          return i.createElement(a.FullscreenableWrapper, {
            style: this.props.wrapperStyles,
            innerRef: this.wrapper
          }, this.props.children, this.renderButton());
        }, t;
      }(i.PureComponent);
    t.FullscreenableImpl = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FullscreenButtonWrapper = t.FullscreenableWrapper = void 0;
    var o,
      i,
      a = n(0);
    t.FullscreenableWrapper = a.styled("div")(o || (o = r(["\n    display: flex;\n    width: 100%;\n    position: relative;\n    background-color: ", ";\n"], ["\n    display: flex;\n    width: 100%;\n    position: relative;\n    background-color: ", ";\n"])), function (e) {
      return e.theme.palette && e.theme.palette.background ? e.theme.palette.background.default : "#FFF";
    }), t.FullscreenButtonWrapper = a.styled("div")(i || (i = r(["\n    position: absolute;\n    bottom: 0em;\n    right: 0em;\n    width: 2em;\n    height: 2em;\n    z-index: 1;\n    color: ", ";\n"], ["\n    position: absolute;\n    bottom: 0em;\n    right: 0em;\n    width: 2em;\n    height: 2em;\n    z-index: 1;\n    color: ", ";\n"])), function (e) {
      return e.theme.palette && e.theme.palette.text ? e.theme.palette.text.primary : "#000";
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RuntimeLookupResponse = t.RuntimeLoginProps = t.RuntimeLoginView = void 0;
    var r = n(668);
    Object.defineProperty(t, "RuntimeLoginView", {
      enumerable: !0,
      get: function get() {
        return r.RuntimeLoginView;
      }
    }), Object.defineProperty(t, "RuntimeLoginProps", {
      enumerable: !0,
      get: function get() {
        return r.RuntimeLoginProps;
      }
    }), Object.defineProperty(t, "RuntimeLookupResponse", {
      enumerable: !0,
      get: function get() {
        return r.RuntimeLookupResponse;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RuntimeLoginView = void 0;
    var o = n(1),
      i = n(62),
      a = n(5),
      s = n(669);
    t.RuntimeLoginView = function (e) {
      return a.log.warn("Warning! RuntimeLoginView component has been deprecated, please use 'LoginFormView' component instead!"), o.createElement(i.StorelessThemeProvider, {
        themeConf: {
          baseName: "FlexDark"
        }
      }, o.createElement(s.RuntimeLoginViewImpl, r({}, e)));
    };
  }, function (e, t, n) {
    "use strict";

    var _r215,
      o = this && this.__extends || (_r215 = function r(e, t) {
        return (_r215 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r215(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      a = this && this.__metadata || function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RuntimeLoginViewImpl = void 0;
    var s = n(1),
      l = n(0),
      c = n(105),
      u = n(2),
      p = n(48),
      d = n(69),
      f = n(670),
      h = n(9),
      m = n(7),
      g = d.languages.default;
    var y = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.getErrorMessage = function () {
          return n.state.error ? n.state.error.key === p.ValidationErrorKeys.sso ? g.RuntimeLoginErrorSso : g.RuntimeLoginErrorDomain : "";
        }, n.state = {
          domain: "",
          error: null
        }, n.setDomain = n.setDomain.bind(n), n.fetchSid = n.fetchSid.bind(n), n.getErrorMessage = n.getErrorMessage.bind(n), n;
      }
      return o(t, e), t.prototype.setDomain = function (e) {
        var t = e.target;
        this.setState(function (e) {
          return {
            domain: t.value,
            error: null
          };
        });
      }, t.prototype.validate = function (e) {
        if (!e.sso) throw m.ErrorManager.processError(new p.ValidationError(p.ValidationErrorKeys.sso));
        if (!e.accountSid) throw m.ErrorManager.processError(new p.ValidationError(p.ValidationErrorKeys.accountSid));
        return e;
      }, t.prototype.fetchSid = function (e) {
        var t = this;
        e.preventDefault();
        var n = this.state.domain.endsWith("/") ? this.state.domain.replace(/\/$/, "") : this.state.domain,
          r = this.props.onSuccess,
          o = this.props.mapDomainToLookup(n),
          i = "https://" + n + "/";
        fetch(o).then(function (e) {
          return e.json();
        }).then(function (e) {
          return t.validate(e);
        }).then(function (e) {
          return r(e, i);
        }).catch(function (e) {
          t.setState(function () {
            return {
              error: e
            };
          });
        });
      }, t.prototype.render = function () {
        return s.createElement(f.Container, null, s.createElement(f.Logo, null), s.createElement(f.Form, {
          onSubmit: this.fetchSid
        }, s.createElement(f.Label, null, g.RuntimeLoginLabel), s.createElement(c.default, {
          onChange: this.setDomain,
          autoFocus: !0,
          error: !!this.state.error,
          name: "runtime",
          type: "text",
          placeholder: g.RuntimeLoginPlaceholder,
          fullWidth: !0
        }), s.createElement(f.ErrorMessage, null, s.createElement(l.Template, {
          source: this.getErrorMessage
        })), s.createElement(f.Controls, null, s.createElement(f.LoginButton, {
          className: "error",
          roundCorners: !1,
          disabled: !this.state.domain,
          onClick: this.fetchSid,
          themeOverride: this.props.theme.RuntimeLoginView.LoginButton
        }, g.RuntimeLoginLaunch), s.createElement(f.AdminLogin, null, g.RuntimeLoginIsAdmin, s.createElement(f.LoginLink, {
          href: this.props.adminLoginUrl
        }, g.RuntimeLoginWithTwilio)))));
      }, t.defaultProps = {
        mapDomainToLookup: function mapDomainToLookup(e) {
          return h.deprecatedFlexLookupServiceUrl + "/" + e;
        },
        adminLoginUrl: h.twilioServiceLoginUrl + "?referer=" + window.location.origin + "&localPort=" + (window.location.protocol.indexOf("https") > -1 && !window.location.port ? 443 : window.location.port)
      }, t = i([u.withTheme, a("design:paramtypes", [Object])], t);
    }(s.PureComponent);
    t.RuntimeLoginViewImpl = y;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoginButton = t.ErrorMessage = t.LoginLink = t.AdminLogin = t.Logo = t.Controls = t.Label = t.Form = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d,
      f = n(0),
      h = n(2),
      m = n(264);
    t.Container = h.default("div")(o || (o = r(["\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 0 auto;\n    justify-content: center;\n    ", "\n"], ["\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 0 auto;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.RuntimeLoginView.Container;
    }), t.Form = h.default("form")(i || (i = r(["\n    width: 342px;\n"], ["\n    width: 342px;\n"]))), t.Label = h.default("div")(a || (a = r(["\n    font-size: 10px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    font-weight: lighter;\n    margin-bottom: 8px;\n"], ["\n    font-size: 10px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    font-weight: lighter;\n    margin-bottom: 8px;\n"]))), t.Controls = h.default("div")(s || (s = r(["\n    margin-top: 22px;\n"], ["\n    margin-top: 22px;\n"]))), t.Logo = h.default(m.LoginLogo)(l || (l = r(["\n    margin-bottom: 53px;\n"], ["\n    margin-bottom: 53px;\n"]))), t.AdminLogin = h.default("div")(c || (c = r(["\n    display: inline-block;\n    margin-left: 16px;\n    font-size: 10px;\n    font-weight: lighter;\n"], ["\n    display: inline-block;\n    margin-left: 16px;\n    font-size: 10px;\n    font-weight: lighter;\n"]))), t.LoginLink = h.default("a")(u || (u = r(["\n    color: #fff;\n    font-weight: bold;\n    margin-left: 4px;\n"], ["\n    color: #fff;\n    font-weight: bold;\n    margin-left: 4px;\n"]))), t.ErrorMessage = h.default("div")(p || (p = r(["\n    font-size: 12px;\n    font-weight: lighter;\n    min-height: 17px;\n    margin-top: 9px;\n\n    b {\n        font-weight: bold;\n    }\n"], ["\n    font-size: 12px;\n    font-weight: lighter;\n    min-height: 17px;\n    margin-top: 9px;\n\n    b {\n        font-weight: bold;\n    }\n"]))), t.LoginButton = h.default(f.Button)(d || (d = r(["\n    text-transform: uppercase;\n"], ["\n    text-transform: uppercase;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r216,
      o = this && this.__extends || (_r216 = function r(e, t) {
        return (_r216 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r216(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RootContainer = void 0;
    var a = n(1),
      s = n(3),
      l = n(672),
      c = n(2),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(p, i({}, this.props));
        }, t.friendlyName = l.displayName, t.displayName = l.displayName, t.Content = l.contentStore, t;
      }(a.PureComponent);
    t.RootContainer = u;
    var p = s.connect(function (e) {
      return {
        identity: e.session.identity,
        singleSessionGuard: e.session.singleSessionGuard,
        currentLoginState: e.session.loginState,
        config: e.config
      };
    })(c.withTheme(l.RootContainerImpl));
  }, function (e, t, n) {
    "use strict";

    var _r217,
      o = this && this.__extends || (_r217 = function r(e, t) {
        return (_r217 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r217(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RootContainerImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(152),
      c = n(39),
      u = n(242),
      p = n(673),
      d = n(16),
      f = n(746),
      h = n(747),
      m = n(62),
      g = n(11),
      y = n(10),
      v = n(12),
      b = n(7);
    t.displayName = "RootContainer", t.contentStore = new s.DynamicContentStore(t.displayName);
    var C = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.containerRef = a.createRef(), t;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        d.Notifications.isNotificationHandlerEnabled(s.DefaultNotificationHandlerType.Browser) && window.Notification && "default" === window.Notification.permission && d.Notifications.showNotification(d.NotificationIds.RequestBrowserNotificationPermissions), this.containerRef && (this.containerRef.current.addEventListener("dragover", function (e) {
          return e.preventDefault();
        }), this.containerRef.current.addEventListener("drop", function (e) {
          return e.preventDefault();
        })), v.TelemetryManager.stopProgrammabilityGrouping();
      }, n.prototype.componentDidCatch = function (e) {
        if (b.isFlexError(e)) throw e;
        throw b.ErrorManager.createAndProcessError("Error rendering RootContainerImpl", {
          type: b.FlexErrorType.app,
          description: "Error rendering RootContainerImpl: " + e.message,
          wrappedError: e,
          context: "RootContainer"
        });
      }, n.prototype.render = function () {
        return this.props.identity ? a.createElement(s.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          vertical: !0
        }, a.createElement(f.Container, {
          innerRef: this.containerRef
        }, g.FeatureFlags.isEnabled(y.FeatureFlag.SingleSession) && a.createElement(m.StorelessThemeProvider, {
          key: "multi-session-alert",
          themeConf: {
            baseName: "FlexDark"
          }
        }, a.createElement(h.MultiSessionAlert, i({}, this.props.singleSessionGuard))), a.createElement(u.MainHeader, {
          key: "header"
        }), a.createElement(p.MainContainer, {
          key: "container"
        }))) : a.createElement(l.LoginFormView, {
          userConfig: this.props.config,
          userLoggedOut: this.props.currentLoginState === c.LoginState.LoggedOut
        });
      }, n;
    }(a.PureComponent);
    t.RootContainerImpl = C;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MainContainerChildrenProps = t.MainContainerProps = t.MainContainer = void 0;
    var r = n(279);
    Object.defineProperty(t, "MainContainer", {
      enumerable: !0,
      get: function get() {
        return r.MainContainer;
      }
    });
    var o = n(294);
    Object.defineProperty(t, "MainContainerProps", {
      enumerable: !0,
      get: function get() {
        return o.MainContainerProps;
      }
    }), Object.defineProperty(t, "MainContainerChildrenProps", {
      enumerable: !0,
      get: function get() {
        return o.MainContainerChildrenProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r218,
      o = this && this.__extends || (_r218 = function r(e, t) {
        return (_r218 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r218(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MainContainerImpl = t.contentStore = t.displayName = void 0;
    var i = n(0),
      a = n(1),
      s = n(19),
      l = n(11),
      c = n(21),
      u = n(10),
      p = n(675),
      d = n(57),
      f = n(676),
      h = n(678),
      m = n(683),
      g = n(689),
      y = n(233),
      v = n(43),
      b = n(282),
      C = n(285),
      _ = n(710),
      k = n(287),
      w = n(253),
      S = n(734),
      P = n(275),
      T = n(265),
      O = n(291),
      x = n(293),
      E = n(744);
    t.displayName = "MainContainer", t.contentStore = new i.DynamicContentStore(t.displayName);
    var A = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleWindowResize = function () {
          t.props.keepSideNavOpen || t.forceUpdate();
        }, t.isSupervisor = function (e) {
          var t = e.manager.user.roles;
          return t.indexOf("supervisor") >= 0 || t.indexOf("admin") >= 0;
        }, t.isAdmin = function (e) {
          var t = e.manager.user.roles;
          return (null == t ? void 0 : t.indexOf("admin")) >= 0;
        }, t;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.handleWindowResize);
      }, n.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleWindowResize);
      }, n.prototype.render = function () {
        var e = this,
          n = window.innerWidth > 640 || this.props.keepSideNavOpen;
        return a.createElement(_.Router, null, a.createElement(s.FlexContext.Consumer, null, function (r) {
          return a.createElement(i.DynamicComponent, {
            name: t.displayName,
            contentStore: t.contentStore,
            childProps: e.props,
            customChildren: e.props.children
          }, a.createElement(i.FlexBox, {
            className: "Twilio-MainContainer"
          }, a.createElement(k.SideNav, {
            key: "sidenav",
            reserveSpace: n
          }), e.props.showOutboundDialer && a.createElement(C.OutboundDialerPanel, {
            key: "outbound-dialer-panel"
          }), a.createElement(x.StyledFlexBox, {
            key: "content",
            className: "Twilio-MainContainer-Content",
            vertical: !0,
            overflow: "hidden"
          }, e.props.showLiveCommsBar && a.createElement(b.LiveCommsBar, null), a.createElement(i.FlexBox, {
            overflow: "hidden"
          }, e.props.showNotificationBar && a.createElement(i.NotificationBar, null), a.createElement(E.MultipleCallAlertDialog, null), a.createElement(O.ViewCollection, null, a.createElement(i.ContentFragment, null, a.createElement(O.View, {
            key: "agent-desktop",
            name: "agent-desktop",
            route: {
              path: "/agent-desktop"
            },
            mountRule: O.ViewMountRule.Always
          }, a.createElement(w.AgentDesktopView, null)), e.isSupervisor(r) && a.createElement(O.View, {
            key: "teams",
            name: "teams",
            route: {
              path: "/teams"
            },
            keepMounted: !0,
            mountRule: O.ViewMountRule.WhenHasBeenActive
          }, a.createElement(T.TeamsView, null)), e.isSupervisor(r) && a.createElement(O.View, {
            key: "queues-stats",
            name: "queues-stats",
            route: {
              path: "/queues-stats"
            },
            mountRule: O.ViewMountRule.WhenActive
          }, a.createElement(P.QueuesStatsView, null)), c.InsightsService.hasPermission(v.DashboardsView.permissions) && a.createElement(O.View, {
            key: "dashboards",
            name: "dashboards",
            route: {
              path: "/dashboards"
            },
            mountRule: O.ViewMountRule.WhenHasBeenActive
          }, l.FeatureFlags.isEnabled(u.FeatureFlag.InsightsNativeDashboards) || l.FeatureFlags.isEnabled(u.FeatureFlag.InsightsNativeDashboardsBeta) ? a.createElement(h.DashboardView, null) : a.createElement(v.DashboardsView, null)), c.InsightsService.hasPermission(v.AnalyzeView.permissions) && a.createElement(O.View, {
            key: "analyze",
            name: "analyze",
            route: {
              path: "/analyze"
            },
            mountRule: O.ViewMountRule.WhenHasBeenActive
          }, l.FeatureFlags.isEnabled(u.FeatureFlag.InsightsNativeDashboards) || l.FeatureFlags.isEnabled(u.FeatureFlag.InsightsNativeDashboardsBeta) ? a.createElement(f.AnalyzeView, null) : a.createElement(v.AnalyzeView, null)), c.InsightsService.hasPermission(v.QuestionnairesView.permissions) && a.createElement(O.View, {
            key: "questionnaires",
            name: "questionnaires",
            route: {
              path: "/questionnaires"
            },
            mountRule: O.ViewMountRule.WhenHasBeenActive
          }, a.createElement(v.QuestionnairesView, null)), c.InsightsService.hasPermission(v.InspectionsView.permissions) && a.createElement(O.View, {
            key: "inspections",
            name: "inspections",
            route: {
              path: "/inspections"
            },
            mountRule: O.ViewMountRule.WhenHasBeenActive
          }, a.createElement(v.InspectionsView, null)), c.InsightsService.hasPermission(v.AgentsView.permissions) && a.createElement(O.View, {
            key: "agents",
            name: "agents",
            route: {
              path: "/agents"
            },
            mountRule: O.ViewMountRule.WhenHasBeenActive
          }, a.createElement(v.AgentsView, null)), c.InsightsService.hasPermission(v.SpeechSearchesView.permissions) && a.createElement(O.View, {
            key: "speech-searches",
            name: "speech-searches",
            route: {
              path: "/speech-searches"
            },
            mountRule: O.ViewMountRule.WhenHasBeenActive
          }, a.createElement(v.SpeechSearchesView, null)), a.createElement(O.View, {
            key: "segments",
            name: "segments",
            route: {
              path: "/segments"
            },
            mountRule: O.ViewMountRule.WhenActive
          }, a.createElement(d.ConversationViewBehindFeatureFlag, {
            key: "conversation-view"
          })), e.isAdmin(r) && a.createElement(O.View, {
            key: "sla-preferences",
            name: "sla-preferences",
            route: {
              path: "/sla-preferences"
            },
            mountRule: O.ViewMountRule.WhenActive
          }, a.createElement(y.SLAPreferencesView, null)), a.createElement(O.View, {
            key: "logout",
            name: "logout"
          }, a.createElement(S.LogoutView, null)))))), a.createElement(p.FeatureFlagGuard, {
            id: u.FeatureFlag.InsightsPlayer,
            key: "player-module-feature-guard"
          }, a.createElement(p.FeatureFlagGuard, {
            id: u.FeatureFlag.ConversationScreen,
            disabledComponent: a.createElement(g.Player, {
              key: "player-module",
              onMediaLinksFetched: function onMediaLinksFetched() {},
              onPlayerClosed: function onPlayerClosed() {}
            })
          }, a.createElement(m.OverlayPlayer, {
            key: "player-module"
          })))));
        }));
      }, n;
    }(a.PureComponent);
    t.MainContainerImpl = A;
  }, function (e, t, n) {
    "use strict";

    var _r219,
      o = this && this.__extends || (_r219 = function r(e, t) {
        return (_r219 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r219(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FeatureFlagGuard = t.FeatureFlagGuardComponent = void 0;
    var i = n(1),
      a = n(3),
      s = n(53),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.children,
            n = e.feature,
            r = e.disabledComponent;
          return n && n.enabled ? t : r || null;
        }, t;
      }(i.Component);
    t.FeatureFlagGuardComponent = l, t.FeatureFlagGuard = a.connect(function (e, t) {
      return {
        feature: s.featureFlagsSelector(e)[t.id]
      };
    })(l);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(677), t);
  }, function (e, t, n) {
    "use strict";

    var _r220,
      o = this && this.__extends || (_r220 = function r(e, t) {
        return (_r220 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r220(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AnalyzeView = void 0;
    var i = n(0),
      a = n(1),
      s = n(19),
      l = n(21),
      c = n(9),
      u = n(139),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t,
            n = null === (t = null === (e = l.InsightsService.getInstance()) || void 0 === e ? void 0 : e.identityClient.user) || void 0 === t ? void 0 : t.workspace_id,
            r = c.getAnalyticsUrl(s.Manager.getInstance().configuration);
          return a.createElement(u.GoodDataGate, null, a.createElement(i.FlexBox, null, a.createElement("iframe", {
            title: "Analyze",
            style: {
              flex: 1
            },
            src: r + "/analyze/embedded/#/" + n + "/reportId/edit",
            "data-test": "GoodData-Analyze"
          })));
        }, t;
      }(a.PureComponent);
    t.AnalyzeView = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(679), t);
  }, function (e, t, n) {
    "use strict";

    var _r221,
      o = this && this.__extends || (_r221 = function r(e, t) {
        return (_r221 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r221(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DashboardView = void 0;
    var i = n(34),
      a = n(1),
      s = n(49),
      l = n(219),
      c = n(680),
      u = n(681),
      p = n(139),
      d = n(38),
      f = n(682),
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getBaseRoute = function () {
          try {
            return this.props.route.match.url.replace(/\/$/, "");
          } catch (e) {
            return "dashboards";
          }
        }, t.prototype.render = function () {
          var e = this.getBaseRoute();
          return a.createElement(p.GoodDataGate, null, a.createElement(s.Switch, null, a.createElement(s.Route, {
            path: e + "/new",
            component: c.default,
            exact: !0
          }), a.createElement(s.Route, {
            path: e + "/:dashboardId?",
            component: m,
            exact: !0
          }), a.createElement(s.Route, {
            path: "/segments/:segmentId",
            component: m,
            exact: !0
          })));
        }, t;
      }(a.PureComponent);
    t.DashboardView = h;
    var m = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        var e = i.parse(this.props.location.search).dashboardId;
        Array.isArray(e) && (e = e[0]);
        var t = this.props.match.params,
          n = t.dashboardId,
          r = t.segmentId,
          o = n || e;
        if (!o && !r) {
          var c = d.getLastVisitedDashboard();
          if (c) return a.createElement(s.Redirect, {
            to: "/dashboards/" + c
          });
        }
        return r && !o ? null : a.createElement(f.Wrapper, null, a.createElement(u.DashboardsSidebar, {
          currentDashboardId: o
        }), a.createElement(l.Dashboard, {
          dashboardId: o,
          enableRedirectOnEmptyDashboardId: !0
        }));
      }, t;
    }(a.PureComponent);
  }, function (e, t, n) {
    "use strict";

    var _r222,
      o = this && this.__extends || (_r222 = function r(e, t) {
        return (_r222 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r222(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
      a = n(44),
      s = n(38),
      l = n(21),
      c = n(9),
      u = n(19),
      p = n(0),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.iframe = i.createRef(), t.handleIncomingMessage = function (e) {
            if (t.iframe.current && e.source === t.iframe.current.contentWindow) try {
              "dashboardCreationCanceled" === e.data.gdc.event.name ? a.default().goBack() : "dashboardCreated" === e.data.gdc.event.name && (s.navigateToDashboard(e.data.gdc.event.data.dashboard), l.InsightsService.getInstance().fetchAnalyticalDashboards());
            } catch (e) {}
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          window.addEventListener("message", this.handleIncomingMessage);
        }, t.prototype.componentWillUnmount = function () {
          window.removeEventListener("message", this.handleIncomingMessage);
        }, t.prototype.render = function () {
          var e = l.InsightsService.getInstance().identityClient.user.workspace_id,
            t = c.getAnalyticsUrl(u.Manager.getInstance().configuration);
          return i.createElement(p.FlexBox, null, i.createElement("iframe", {
            title: "New Dashboard",
            style: {
              flex: 1
            },
            ref: this.iframe,
            src: t + "/dashboards/embedded/#/project/" + e.trim() + "/new-dashboard"
          }));
        }, t;
      }(i.Component);
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DashboardsSidebar = void 0;
    var r = n(217);
    Object.defineProperty(t, "DashboardsSidebar", {
      enumerable: !0,
      get: function get() {
        return r.DashboardsSidebar;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Wrapper = void 0;
    var o,
      i = n(0);
    t.Wrapper = i.styled("div")(o || (o = r(["\n    flex-direction: row;\n    display: flex;\n    flex: 1;\n"], ["\n    flex-direction: row;\n    display: flex;\n    flex: 1;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.OverlayPlayer = void 0;
    var r = n(684),
      o = n(3),
      i = n(54);
    t.OverlayPlayer = o.connect(function (e) {
      return {
        segmentId: e.insights.segmentId,
        segment: e.insights.segmentId ? e.insights.segmentsById[e.insights.segmentId] : void 0,
        selectedMediaLink: e.insights.selectedMediaLink
      };
    }, function (e) {
      return {
        updateSegmentId: function updateSegmentId(t) {
          return e({
            type: i.UPDATE_CURRENT_SEGMENT_ID,
            payload: t
          });
        }
      };
    })(r.OverlayPlayerImpl);
  }, function (e, t, n) {
    "use strict";

    var _r223,
      o = this && this.__extends || (_r223 = function r(e, t) {
        return (_r223 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r223(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.OverlayPlayerImpl = void 0;
    var l = n(0),
      c = n(1),
      u = n(21),
      p = n(143),
      d = n(7),
      f = n(14),
      h = n(2),
      m = n(61),
      g = n(101),
      y = n(29),
      v = n(60),
      b = n(158),
      C = n(70),
      _ = n(146),
      k = n(280),
      w = n(18),
      S = n(281),
      P = n(147),
      T = n(100),
      O = n(106),
      x = n(688),
      E = new l.DynamicContentStore("TranscriptPlayer"),
      A = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.handleClose = function () {
            l.Actions.invokeAction(C.INSIGHTS_PLAYER_HIDE), n.props.updateSegmentId(void 0);
          }, n.play = function (e) {
            return a(n, void 0, void 0, function () {
              var t, n, r;
              return s(this, function (o) {
                switch (o.label) {
                  case 0:
                    if (o.trys.push([0, 5,, 6]), t = void 0, !e) throw new Error("payload not provided");
                    return "segmentId" in e ? (t = e.segmentId, [3, 4]) : [3, 1];
                  case 1:
                    if (!("taskSid" in e)) return [3, 3];
                    if (!(n = u.InsightsService.getInstance())) throw new Error("unable to play recordings before Insights service is initialized");
                    return [4, O.getSegmentByTaskSid(e.taskSid, n.identityClient)];
                  case 2:
                    return t = o.sent(), [3, 4];
                  case 3:
                    throw new Error("segmentId or taskSid not provided");
                  case 4:
                    return this.props.updateSegmentId(t), l.Actions.invokeAction(C.INSIGHTS_PLAYER_SHOW), [3, 6];
                  case 5:
                    throw r = o.sent(), l.Notifications.showNotification(f.InsightsPlayerLoadingSegmentFailed), d.ErrorManager.createAndProcessError(y.ErrorMessages.INSIGHTS_PLAYER_PLAYBACK_FAILED, {
                      description: "Payload for the INSIGHTS_PLAYER_PLAY action is either malformed or the taskSid does not exist. Payload: " + JSON.stringify(e),
                      type: d.FlexErrorType.app,
                      context: "Player",
                      wrappedError: r
                    });
                  case 6:
                    return [2];
                }
              });
            });
          }, n.show = function () {
            return a(n, void 0, void 0, function () {
              return s(this, function (e) {
                return this.setState({
                  visible: !0
                }), !this.props.segment && this.props.segmentId && this.fetchSegmentData(this.props.segmentId), [2];
              });
            });
          }, n.hide = function () {
            return a(n, void 0, void 0, function () {
              return s(this, function (e) {
                return this.setState({
                  visible: !1,
                  loaderType: "none"
                }), [2];
              });
            });
          }, n.onInitialized = function () {
            return a(n, void 0, void 0, function () {
              return s(this, function (e) {
                return [2];
              });
            });
          }, n.state = {
            visible: !1,
            loaderType: "none"
          }, n;
        }
        return o(t, e), t.getDerivedStateFromProps = function (e) {
          var t = e.segment && e.segment.data && e.segment.data.links.content[e.selectedMediaLink || 0];
          return t ? t.type === w.InsightsPlayerMediaLinkType.VoiceRecording ? {
            loaderType: "bottom"
          } : {
            loaderType: "side"
          } : null;
        }, t.prototype.componentDidMount = function () {
          this.registerActions(), l.Actions.invokeAction(C.INSIGHTS_PLAYER_INITIALIZED, this);
        }, t.prototype.componentDidUpdate = function (e, t) {
          this.state.visible && e.segmentId !== this.props.segmentId && this.props.segmentId && !this.props.segment && this.fetchSegmentData(this.props.segmentId);
        }, t.prototype.fetchSegmentData = function (e) {
          return a(this, void 0, void 0, function () {
            return s(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, p.ConversationsService.getInstance().fetchSegment(e)];
                case 1:
                  return t.sent(), [2];
              }
            });
          });
        }, t.prototype.registerActions = function () {
          l.Actions.registerAction(C.INSIGHTS_PLAYER_PLAY, this.play), l.Actions.registerAction(C.INSIGHTS_PLAYER_SHOW, this.show), l.Actions.registerAction(C.INSIGHTS_PLAYER_HIDE, this.hide), l.Actions.registerAction(C.INSIGHTS_PLAYER_INITIALIZED, this.onInitialized);
        }, t.prototype.render = function () {
          var e = this;
          return c.createElement(v.InsightsController, null, function (t) {
            return t.status === u.InsightsServiceStatus.Ready && e.state.visible && e.props.segmentId ? e.props.segment && e.props.segment.hasFetched ? e.props.segment.error ? e.renderError() : e.renderByMediaType(e.props.segment) : e.renderLoader() : null;
          });
        }, t.prototype.renderLoader = function () {
          return "bottom" === this.state.loaderType ? c.createElement(N, {
            onClose: this.handleClose
          }, c.createElement(R, null, c.createElement(l.CircularProgress, {
            animating: !0,
            size: 64
          }))) : "side" === this.state.loaderType ? c.createElement(F, null, c.createElement(l.SidePanel, {
            handleCloseClick: this.handleClose
          }, c.createElement(m.LoadingContainer, null, c.createElement(l.CircularProgress, {
            animating: !0,
            size: 64
          })))) : null;
        }, t.prototype.renderError = function () {
          return c.createElement(N, {
            onClose: this.handleClose
          }, c.createElement(R, null, c.createElement(l.Icon, {
            icon: "Error"
          }), "There was a problem loading the conversation"));
        }, t.prototype.renderVoice = function (e) {
          var t = this;
          return c.createElement(N, {
            onClose: this.handleClose
          }, c.createElement(x.VoiceContent, {
            segmentId: e.id,
            onSegmentSelect: function onSegmentSelect(e) {
              t.props.updateSegmentId(e);
            }
          }));
        }, t.prototype.renderByMediaType = function (e) {
          if (!e.data) return this.renderError();
          var t = e.data.links.content[this.props.selectedMediaLink || 0];
          return t && t.type !== w.InsightsPlayerMediaLinkType.VoiceRecording ? c.createElement(F, null, c.createElement(l.SidePanel, {
            displayName: "TranscriptPlayer",
            contentStore: E,
            handleCloseClick: this.handleClose,
            title: O.getTitleForLink(t),
            rightButton: c.createElement(k.OpenInNewWindowBtn, {
              segmentId: e.id,
              mediaLink: t
            })
          }, c.createElement(S.WrapperSidebar, {
            key: "wrapper-sidebar"
          }, c.createElement(b.MediaSelectDropdown, {
            key: "select"
          }), function () {
            switch (t.type) {
              case w.InsightsPlayerMediaLinkType.Embedded:
                return c.createElement(_.EmbeddedContent, {
                  mediaLink: t,
                  key: "embedded-content"
                });
              case w.InsightsPlayerMediaLinkType.Referenced:
                return c.createElement(P.ReferencedContent, {
                  mediaLink: t,
                  key: "referenced-content"
                });
              case w.InsightsPlayerMediaLinkType.ChatTranscript:
                return c.createElement(g.default, {
                  key: "transcript-content"
                }, c.createElement(T.TranscriptContent, {
                  mediaLink: t
                }));
              case w.InsightsPlayerMediaLinkType.EmailTranscript:
                return c.createElement(g.default, {
                  key: "email-transcript-content"
                }, c.createElement(T.TranscriptContent, {
                  mediaLink: t
                }));
              default:
                return c.createElement("div", {
                  key: "unknown-media"
                }, "Unknown Media Link type.");
            }
          }()))) : this.renderVoice(e);
        }, t;
      }(c.Component);
    t.OverlayPlayerImpl = A;
    var I,
      j,
      L,
      M,
      F = h.default("div")(I || (I = i(["\n    display: flex;\n    ", "\n"], ["\n    display: flex;\n    ", "\n"])), function (e) {
        return e.theme.TranscriptPlayer.Sidepanel;
      }),
      D = h.default("div")(j || (j = i(["\n    position: absolute;\n    top: 16px;\n    right: 16px;\n"], ["\n    position: absolute;\n    top: 16px;\n    right: 16px;\n"]))),
      N = function N(e) {
        return c.createElement(B, {
          "data-test": "Insights-Player_overlay"
        }, e.children, c.createElement(D, {
          id: "Insights-Player_close-button"
        }, c.createElement(l.IconButton, {
          icon: "Close",
          onClick: e.onClose
        })));
      },
      R = h.default("div")(L || (L = i(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    font-weight: bold;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    font-weight: bold;\n"]))),
      B = h.default(S.WrapperPlayer)(M || (M = i(["\n    min-height: 220px;\n    height: auto;\n"], ["\n    min-height: 220px;\n    height: auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MediaSelectDropdown = void 0;
    var r = n(3),
      o = n(687),
      i = n(18),
      a = n(11),
      s = n(10),
      l = n(24);
    t.MediaSelectDropdown = r.connect(function (e) {
      return {
        mediaLinks: a.FeatureFlags.isEnabled(s.FeatureFlag.ConversationScreen) ? l.mediaLinksSelector(e) : e.insights.playerMediaLinks,
        selectedIndex: e.insights.selectedMediaLink
      };
    }, function (e) {
      return {
        onLinkSelected: function onLinkSelected(t) {
          return e({
            type: i.INSIGHTS_PLAYER_MEDIA_SELECT,
            payload: t
          });
        }
      };
    })(o.MediaSelectDropdownImpl);
  }, function (e, t, n) {
    "use strict";

    var _r224,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r224 = function r(e, t) {
        return (_r224 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r224(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MediaSelectDropdownImpl = void 0;
    var a,
      s,
      l = n(1),
      c = n(22),
      u = n(106),
      p = n(2),
      d = p.default("div")(a || (a = o(["\n    display: flex;\n    ", "\n\n    span {\n        ", "\n    }\n"], ["\n    display: flex;\n    ", "\n\n    span {\n        ", "\n    }\n"])), function (e) {
        return e.horizontal ? "padding: 16px 12px; flex-direction: row; white-space: nowrap;" : "margin-bottom: 17px; flex-direction: column;";
      }, function (e) {
        return e.horizontal && "padding-right: 8px; line-height: 32px;";
      }),
      f = p.default(c.MenuItem)(s || (s = o(["\n    box-sizing: border-box;\n"], ["\n    box-sizing: border-box;\n"]))),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleChange = function (e) {
            t.props.onLinkSelected(parseInt(e.target.value, 10));
          }, t.getMediaLink = function (e, t) {
            return l.createElement(f, {
              value: t,
              key: t
            }, u.getTitleForLink(e));
          }, t;
        }
        return i(t, e), t.prototype.render = function () {
          return this.props.mediaLinks.length < 2 ? null : l.createElement(d, {
            horizontal: this.props.horizontal
          }, l.createElement("span", null, "Select a conversation"), l.createElement(c.FormControl, null, l.createElement(c.Select, {
            value: this.props.selectedIndex || 0,
            onChange: this.handleChange
          }, this.props.mediaLinks.map(this.getMediaLink))));
        }, t;
      }(l.PureComponent);
    t.MediaSelectDropdownImpl = h;
  }, function (e, t, n) {
    "use strict";

    var _r225,
      o = this && this.__extends || (_r225 = function r(e, t) {
        return (_r225 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r225(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VoiceContent = void 0;
    var l = n(1),
      c = n(0),
      u = n(2),
      p = n(231),
      d = n(232),
      f = n(223),
      h = n(158),
      m = n(280),
      g = n(7),
      y = n(29),
      v = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.refFn = function (e) {
            e && (n.setState({
              playerRef: e
            }), e.once("ready", function () {
              return a(n, void 0, void 0, function () {
                var t;
                return s(this, function (n) {
                  switch (n.label) {
                    case 0:
                      return n.trys.push([0, 2,, 3]), [4, e.play()];
                    case 1:
                      return n.sent(), [3, 3];
                    case 2:
                      return t = n.sent(), g.ErrorManager.createAndProcessError(y.ErrorMessages.INSIGHTS_PLAYER_PLAYBACK_FAILED, {
                        description: "Error upon autoplay attempt in the overlay player",
                        type: g.FlexErrorType.app,
                        context: "Player",
                        wrappedError: t
                      }), [3, 3];
                    case 3:
                      return [2];
                  }
                });
              });
            }));
          }, n.handleSegmentSelect = function (e) {
            n.props.onSegmentSelect(e);
          }, n.state = {
            playerRef: null
          }, n;
        }
        return o(t, e), t.prototype.render = function () {
          return l.createElement(l.Fragment, null, l.createElement(S, null, l.createElement(d.SegmentInfo, {
            key: "segment-info",
            segmentId: this.props.segmentId,
            onSegmentSelect: this.handleSegmentSelect,
            hideCommentAndAssess: !0
          }), l.createElement(h.MediaSelectDropdown, {
            horizontal: !0
          })), l.createElement(p.Player, {
            segmentId: this.props.segmentId,
            ref: this.refFn,
            onSegmentMarkClick: this.handleSegmentSelect
          }), l.createElement(w, null, l.createElement(f.ConversationInfo, {
            segmentId: this.props.segmentId,
            player: this.state.playerRef
          }), l.createElement(k, null, l.createElement(m.OpenInNewWindowBtn, {
            segmentId: this.props.segmentId,
            player: this.state.playerRef
          }))));
        }, t;
      }(l.Component);
    t.VoiceContent = v;
    var b,
      C,
      _,
      k = u.default("div")(b || (b = i(["\n    padding-right: 16px;\n    display: flex;\n"], ["\n    padding-right: 16px;\n    display: flex;\n"]))),
      w = u.default(c.FlexBox)(C || (C = i([""], [""]))),
      S = u.default("div")(_ || (_ = i(["\n    display: flex;\n    padding-right: 38px;\n\n    > div:first-child {\n        flex-grow: 1;\n    }\n"], ["\n    display: flex;\n    padding-right: 38px;\n\n    > div:first-child {\n        flex-grow: 1;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r226,
      o = this && this.__extends || (_r226 = function r(e, t) {
        return (_r226 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r226(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Player = void 0;
    var l = n(113),
      c = n(0),
      u = n(1),
      p = n(21),
      d = n(40),
      f = n(13),
      h = n(9),
      m = n(7),
      g = n(28),
      y = n(3),
      v = n(14),
      b = n(60),
      C = n(70),
      _ = n(18),
      k = n(690),
      w = n(106),
      S = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            flexToken: f.Manager.getInstance().user.token,
            visible: !1
          }, t.playerConfig = i(i({}, l.defaultEnvConfig), h.getFlexInsightsPlayerConfig(f.Manager.getInstance().configuration)), t.onInitialized = function () {
            return a(t, void 0, void 0, function () {
              return s(this, function (e) {
                return [2, !0];
              });
            });
          }, t.show = function () {
            return a(t, void 0, void 0, function () {
              return s(this, function (e) {
                return [2, this.setState({
                  visible: !0
                })];
              });
            });
          }, t.hide = function () {
            return a(t, void 0, void 0, function () {
              return s(this, function (e) {
                return [2, this.setState({
                  visible: !1
                })];
              });
            });
          }, t.play = function (e) {
            return a(t, void 0, void 0, function () {
              var t, n;
              return s(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!e) throw m.ErrorManager.createAndProcessError("payload not provided", {
                      type: m.FlexErrorType.app,
                      context: "Player"
                    });
                    return "segmentId" in e ? (t = e.segmentId, [3, 7]) : [3, 1];
                  case 1:
                    if (!("taskSid" in e)) return [3, 6];
                    r.label = 2;
                  case 2:
                    if (r.trys.push([2, 4,, 5]), !(n = p.InsightsService.getInstance())) throw new Error("unable to play recordings before Insights service is initialized");
                    return [4, w.getSegmentByTaskSid(e.taskSid, n.identityClient)];
                  case 3:
                    return t = r.sent(), [3, 5];
                  case 4:
                    return r.sent(), c.Notifications.showNotification(v.InsightsPlayerLoadingSegmentFailed), [3, 5];
                  case 5:
                    return [3, 7];
                  case 6:
                    throw m.ErrorManager.createAndProcessError("segmentId or taskSid not provided", {
                      type: m.FlexErrorType.app,
                      context: "Player"
                    });
                  case 7:
                    return this.setState({
                      segmentId: t
                    }, function () {
                      c.Actions.invokeAction(C.INSIGHTS_PLAYER_SHOW);
                    }), [2];
                }
              });
            });
          }, t.setFlexToken = function (e) {
            t.setState({
              flexToken: e.token
            });
          }, t.onCloseClick = function () {
            c.Actions.invokeAction(C.INSIGHTS_PLAYER_HIDE), t.props.onPlayerClosed();
          }, t.openInConvScreen = function () {
            var e;
            t.props.mediaLink && ("url" in t.props.mediaLink ? e = encodeURIComponent(t.props.mediaLink.url) : "sid" in t.props.mediaLink && (e = encodeURIComponent(t.props.mediaLink.sid))), window.open(h.getFlexInsightsBaseUrl(f.Manager.getInstance().configuration) + "/player/segment/" + t.state.segmentId + "?mediaLinkId=" + e);
          }, t;
        }
        return o(t, e), t.prototype.componentDidUpdate = function (e, t) {
          (t.segmentId !== this.state.segmentId || t.visible !== this.state.visible) && this.state.segmentId && this.state.visible && this.fetchMediaLinks();
        }, t.prototype.getMediaUrl = function (e) {
          return this.playerConfig.mediaApiUrl + "/data/" + e;
        }, t.prototype.fetchMediaLinks = function () {
          var e;
          return a(this, void 0, void 0, function () {
            var t, n, r, o, i;
            return s(this, function (a) {
              switch (a.label) {
                case 0:
                  if (!(t = this.state.segmentId)) return [2];
                  n = this.getMediaUrl(t), a.label = 1;
                case 1:
                  return a.trys.push([1, 3,, 4]), [4, null === (e = this.identityClient) || void 0 === e ? void 0 : e.axios.get(n)];
                case 2:
                  return r = a.sent(), o = null == r ? void 0 : r.data._links.content, t === this.state.segmentId && (i = o.filter(function (e) {
                    return e.type !== _.InsightsPlayerMediaLinkType.Raw;
                  }), this.props.onMediaLinksFetched(i)), [3, 4];
                case 3:
                  return a.sent(), c.Notifications.dismissNotificationById(v.InsightsPlayerLoadingSegmentFailed), c.Notifications.showNotification(v.InsightsPlayerLoadingSegmentFailed), this.props.onMediaLinksFetched([]), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, t.prototype.registerActions = function () {
          c.Actions.registerAction(C.INSIGHTS_PLAYER_PLAY, this.play), c.Actions.registerAction(C.INSIGHTS_PLAYER_SHOW, this.show), c.Actions.registerAction(C.INSIGHTS_PLAYER_HIDE, this.hide), c.Actions.registerAction(C.INSIGHTS_PLAYER_INITIALIZED, this.onInitialized);
        }, t.prototype.componentDidMount = function () {
          y.FlexModule.events.addListener(g.FlexEvent.tokenUpdated, this.setFlexToken), this.registerActions(), c.Actions.invokeAction(C.INSIGHTS_PLAYER_INITIALIZED, this);
        }, t.prototype.componentWillUnmount = function () {
          y.FlexModule.events.removeListener(g.FlexEvent.tokenUpdated, this.setFlexToken);
        }, t.prototype.render = function () {
          var e = this;
          return u.createElement(b.InsightsController, null, function (t) {
            var n = t.status,
              r = t.client;
            return e.identityClient = e.identityClient || r, n === d.InsightsServiceStatus.Ready && e.state.segmentId && r ? u.createElement(k.PlayerComponent, {
              visible: e.state.visible,
              onClose: e.onCloseClick,
              segmentId: e.state.segmentId,
              identityClient: r,
              flexToken: e.state.flexToken,
              mediaLink: e.props.mediaLink,
              env: e.playerConfig,
              onOpenInConversationScreen: e.openInConvScreen
            }) : null;
          });
        }, t;
      }(u.PureComponent);
    t.Player = y.connect(function (e) {
      return {
        mediaLink: void 0 !== e.insights.selectedMediaLink ? e.insights.playerMediaLinks[e.insights.selectedMediaLink] : void 0
      };
    }, function (e) {
      return {
        onMediaLinksFetched: function onMediaLinksFetched(t) {
          return e({
            type: _.INSIGHTS_PLAYER_SET_MEDIA_LINKS,
            payload: t
          });
        },
        onPlayerClosed: function onPlayerClosed() {
          e({
            type: _.INSIGHTS_PLAYER_SET_MEDIA_LINKS,
            payload: []
          });
        }
      };
    })(S);
  }, function (e, t, n) {
    "use strict";

    var _r227,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (_r227 = function r(e, t) {
        return (_r227 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r227(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PlayerComponent = void 0;
    var a,
      s,
      l = n(1),
      c = n(113),
      u = n(18),
      p = n(106),
      d = n(281),
      f = n(158),
      h = n(146),
      m = n(147),
      g = n(0),
      y = n(2),
      v = n(100),
      b = new g.DynamicContentStore("TranscriptPlayer"),
      C = y.default("div")(a || (a = o(["\n    position: absolute;\n    top: 5px;\n    left: 72px;\n    z-index: 1;\n"], ["\n    position: absolute;\n    top: 5px;\n    left: 72px;\n    z-index: 1;\n"]))),
      _ = y.default("div")(s || (s = o(["\n    display: flex;\n    ", "\n"], ["\n    display: flex;\n    ", "\n"])), function (e) {
        return e.theme.TranscriptPlayer.Sidepanel;
      }),
      k = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.renderContentByMediaType = function () {
          var e = this.props.mediaLink;
          return e ? e.type === u.InsightsPlayerMediaLinkType.VoiceRecording ? l.createElement(d.WrapperPlayer, null, l.createElement(C, null, l.createElement(f.MediaSelectDropdown, {
            onLinkSelected: function onLinkSelected() {}
          })), l.createElement(c.default, {
            id: "Insights-Player_player",
            segmentId: this.props.segmentId,
            identityClient: this.props.identityClient,
            flexToken: this.props.flexToken,
            env: this.props.env
          }), l.createElement(d.CloseButton, {
            id: "Insights-Player_close-button",
            onClick: this.props.onClose
          }, "×")) : l.createElement(_, null, l.createElement(g.SidePanel, {
            displayName: "TranscriptPlayer",
            contentStore: b,
            handleCloseClick: this.props.onClose,
            title: p.getTitleForLink(e),
            rightButton: l.createElement(g.IconButton, {
              onClick: this.props.onOpenInConversationScreen,
              icon: "OpenInNewWindow",
              title: "Open in new window",
              sizeMultiplier: .7
            })
          }, l.createElement(d.WrapperSidebar, {
            key: "wrapper-sidebar"
          }, l.createElement(f.MediaSelectDropdown, {
            onLinkSelected: function onLinkSelected() {},
            key: "select"
          }), function () {
            switch (e.type) {
              case u.InsightsPlayerMediaLinkType.Embedded:
                return l.createElement(h.EmbeddedContent, {
                  mediaLink: e,
                  key: "embedded-content"
                });
              case u.InsightsPlayerMediaLinkType.Referenced:
                return l.createElement(m.ReferencedContent, {
                  mediaLink: e,
                  key: "referenced-content"
                });
              case u.InsightsPlayerMediaLinkType.ChatTranscript:
                return l.createElement(v.TranscriptContent, {
                  mediaLink: e,
                  key: "transcript-content"
                });
              case u.InsightsPlayerMediaLinkType.EmailTranscript:
                return l.createElement(v.TranscriptContent, {
                  mediaLink: e,
                  key: "email-transcript-content"
                });
              default:
                return l.createElement("div", {
                  key: "unknown-media"
                }, "Unknown Media Link type.");
            }
          }()))) : null;
        }, t.prototype.render = function () {
          return this.props.visible && this.props.segmentId && this.props.mediaLink ? this.renderContentByMediaType() : null;
        }, t;
      }(l.PureComponent);
    t.PlayerComponent = k;
  }, function (e, t, n) {
    "use strict";

    var _r228,
      o = this && this.__extends || (_r228 = function r(e, t) {
        return (_r228 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r228(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AgentsView = void 0;
    var s = n(1),
      l = n(19),
      c = n(9),
      u = n(65),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.getUrl = function (e) {
            return i(t, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, e.getServiceSsoUrl("app", c.getFlexInsightsBaseUrl(l.Manager.getInstance().configuration) + "/realtime/", {
                      account_id: e.user && e.user.account_id
                    })];
                  case 1:
                    return [2, "string" == typeof (t = n.sent()) ? t : ""];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.default, {
            getUrl: this.getUrl,
            isActive: this.props.isViewActive,
            name: "realtime"
          });
        }, t.icon = "AgentsView", t.iconActive = "AgentsViewBold", t.viewName = "agents", t.permissions = "coaching.view", t;
      }(s.Component);
    t.AgentsView = p;
  }, function (e, t, n) {
    "use strict";

    var _r229,
      o = this && this.__extends || (_r229 = function r(e, t) {
        return (_r229 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r229(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.YticaApp = void 0;
    var a = n(0),
      s = n(1),
      l = n(19),
      c = n(11),
      u = n(28),
      p = n(10),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            isLoaded: !1
          }, t.iframeRef = s.createRef(), t.onIframeLoad = function () {
            t.setState({
              isLoaded: !0
            }), t.setFlexToken(), t.sendActiveStateToIframe();
          }, t.sendAppEvent = function (e) {
            var n = i({
              app: t.props.name
            }, e);
            t.iframeRef && t.iframeRef.current && t.iframeRef.current.contentWindow && t.iframeRef.current.contentWindow.postMessage(n, "*");
          }, t.setFlexToken = function () {
            t.sendAppEvent({
              type: "setFlexToken",
              value: {
                token: l.Manager.getInstance().user.token,
                expiration: l.Manager.getInstance().user.tokenExpirationDate
              }
            });
          }, t.setYticaToken = function (e) {
            t.sendAppEvent({
              type: "setYticaToken",
              value: {
                token: e.accessToken
              }
            });
          }, t.sendActiveStateToIframe = function () {
            t.sendAppEvent({
              type: "setIsFlexTabActive",
              value: t.props.isActive
            });
          }, t.messageListener = function (e) {
            t.props.onMessage && t.iframeRef.current && e.source === t.iframeRef.current.contentWindow && t.props.onMessage(e);
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          window.addEventListener("message", this.messageListener), l.Manager.getInstance().events.addListener(u.FlexEvent.tokenUpdated, this.setFlexToken), c.FeatureFlags.isEnabled(p.FeatureFlag.InsightsIdentityNext) && l.Manager.getInstance().events.addListener(u.FlexEvent.yticaTokenUpdated, this.setYticaToken);
        }, t.prototype.componentWillUnmount = function () {
          window.removeEventListener("message", this.messageListener), l.Manager.getInstance().events.removeListener(u.FlexEvent.tokenUpdated, this.setFlexToken), c.FeatureFlags.isEnabled(p.FeatureFlag.InsightsIdentityNext) && l.Manager.getInstance().events.removeListener(u.FlexEvent.yticaTokenUpdated, this.setYticaToken);
        }, t.prototype.componentDidUpdate = function (e) {
          e.isActive !== this.props.isActive && this.sendActiveStateToIframe();
        }, Object.defineProperty(t.prototype, "appEmbedUrl", {
          get: function get() {
            var e;
            try {
              return (e = new URL(this.props.src)).searchParams.append("flex", "true"), e.href;
            } catch (e) {
              return this.props.src;
            }
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.render = function () {
          return s.createElement(s.Fragment, null, s.createElement("iframe", {
            frameBorder: "0",
            title: "insights-view-" + this.props.name,
            id: "insights-view-" + this.props.name,
            scrolling: "yes",
            src: this.appEmbedUrl,
            style: {
              width: "100%",
              display: this.state.isLoaded ? "block" : "none"
            },
            onLoad: this.onIframeLoad,
            ref: this.iframeRef
          }), !this.state.isLoaded && s.createElement(a.CircularProgress, {
            borderWidth: 3
          }));
        }, t;
      }(s.Component);
    t.YticaApp = d;
  }, function (e, t, n) {
    "use strict";

    var _r230,
      o = this && this.__extends || (_r230 = function r(e, t) {
        return (_r230 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r230(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AnalyzeView = void 0;
    var s = n(1),
      l = n(19),
      c = n(9),
      u = n(65),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.getUrl = function (e) {
            return i(t, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, e.getServiceSsoUrl("app", c.getFlexInsightsBaseUrl(l.Manager.getInstance().configuration) + "/dashboards/analyze", {
                      account_id: e.user && e.user.account_id
                    })];
                  case 1:
                    return [2, "string" == typeof (t = n.sent()) ? t : ""];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.default, {
            getUrl: this.getUrl,
            isActive: this.props.isViewActive,
            name: "analyze"
          });
        }, t.icon = "Analyze", t.iconActive = "AnalyzeBold", t.viewName = "analyze", t.permissions = "dashboards.analyze", t;
      }(s.Component);
    t.AnalyzeView = p;
  }, function (e, t, n) {
    "use strict";

    var _r231,
      o = this && this.__extends || (_r231 = function r(e, t) {
        return (_r231 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r231(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DashboardsView = void 0;
    var s = n(0),
      l = n(1),
      c = n(19),
      u = n(9),
      p = n(5),
      d = n(65),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.ref = l.createRef(), t.getUrl = function (e) {
            return i(t, void 0, void 0, function () {
              var t, n;
              return a(this, function (r) {
                switch (r.label) {
                  case 0:
                    return [4, e.getServiceSsoUrl("app", u.getFlexInsightsBaseUrl(c.Manager.getInstance().configuration) + "/dashboards/id/908818325360", {
                      account_id: e.user && e.user.account_id
                    })];
                  case 1:
                    return t = r.sent(), n = e.user && e.user.workspace_id, [2, "string" == typeof t ? t + "&workspace_id=" + n + "&link_prevent_default=true" : ""];
                }
              });
            });
          }, t.handleUiLink = function (e, n) {
            return i(t, void 0, void 0, function () {
              var t;
              return a(this, function (r) {
                switch (r.label) {
                  case 0:
                    return r.trys.push([0, 2,, 3]), new URL(e.url), [4, s.Actions.invokeAction("HistoricalReporting:view", e.url)];
                  case 1:
                    return r.sent(), [3, 3];
                  case 2:
                    return t = r.sent(), p.log.info("Cannot parse URL. Falling back to original handler.", t.message), this.delegateEventToOriginal(n), [3, 3];
                  case 3:
                    return [2];
                }
              });
            });
          }, t.handleIncomingMessage = function (e) {
            var n = e.data,
              r = n.name,
              o = n.data,
              i = n.id;
            switch (r) {
              case "com.twilio.wfo.link":
                t.handleUiLink(o, i);
            }
          }, t;
        }
        return o(t, e), t.prototype.delegateEventToOriginal = function (e) {
          this.ref.current && this.ref.current.iframeRef && this.ref.current.iframeRef.contentWindow && this.ref.current.iframeRef.contentWindow.postMessage({
            type: "Insights:handleEvent",
            eventId: e
          }, "*");
        }, t.prototype.render = function () {
          return l.createElement(d.default, {
            getUrl: this.getUrl,
            isActive: this.props.isViewActive,
            name: t.viewName,
            onMessage: this.handleIncomingMessage,
            ref: this.ref
          });
        }, t.icon = "Dashboards", t.iconActive = "DashboardsBold", t.viewName = "dashboards", t.permissions = "dashboards.view", t;
      }(l.Component);
    t.DashboardsView = f;
  }, function (e, t, n) {
    "use strict";

    var _r232,
      o = this && this.__extends || (_r232 = function r(e, t) {
        return (_r232 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r232(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InspectionsView = void 0;
    var s = n(1),
      l = n(19),
      c = n(9),
      u = n(65),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.getUrl = function (e) {
            return i(t, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, e.getServiceSsoUrl("app", c.getFlexInsightsBaseUrl(l.Manager.getInstance().configuration) + "/inspections/", {
                      account_id: e.user && e.user.account_id
                    })];
                  case 1:
                    return [2, "string" == typeof (t = n.sent()) ? t : ""];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.default, {
            getUrl: this.getUrl,
            isActive: this.props.isViewActive,
            name: "inspections"
          });
        }, t.icon = "Inspections", t.iconActive = "InspectionsBold", t.viewName = "inspections", t.permissions = "inspections.view", t;
      }(s.Component);
    t.InspectionsView = p;
  }, function (e, t, n) {
    "use strict";

    var _r233,
      o = this && this.__extends || (_r233 = function r(e, t) {
        return (_r233 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r233(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.QuestionnairesView = void 0;
    var s = n(1),
      l = n(19),
      c = n(11),
      u = n(9),
      p = n(10),
      d = n(65),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.getUrl = function (e) {
            return i(t, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                return t = u.getFlexInsightsQuestionnairesUrl(l.Manager.getInstance().configuration), c.FeatureFlags.isEnabled(p.FeatureFlag.InsightsIdentityNext) ? [2, t + "?flex_ytica_token=" + (e.insightsToken || "")] : [2, "string" == typeof t ? t : ""];
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(d.default, {
            getUrl: this.getUrl,
            isActive: this.props.isViewActive,
            name: "questionnaires"
          });
        }, t.icon = "Questionnaires", t.iconActive = "QuestionnairesBold", t.viewName = "questionnaires", t.permissions = "assessment.manage", t;
      }(s.Component);
    t.QuestionnairesView = f;
  }, function (e, t, n) {
    "use strict";

    var _r234,
      o = this && this.__extends || (_r234 = function r(e, t) {
        return (_r234 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r234(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SpeechSearchesView = void 0;
    var s = n(1),
      l = n(19),
      c = n(9),
      u = n(65),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.getUrl = function (e) {
            return i(t, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, e.getServiceSsoUrl("app", c.getFlexInsightsBaseUrl(l.Manager.getInstance().configuration) + "/phrases/", {
                      account_id: e.user && e.user.account_id
                    })];
                  case 1:
                    return [2, "string" == typeof (t = n.sent()) ? t : ""];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.default, {
            getUrl: this.getUrl,
            isActive: this.props.isViewActive,
            name: "speech-searches"
          });
        }, t.icon = "SpeechSearches", t.iconActive = "SpeechSearchesBold", t.viewName = "speech-searches", t.permissions = "phrases.view", t;
      }(s.Component);
    t.SpeechSearchesView = p;
  }, function (e, t, n) {
    "use strict";

    var _r235,
      o = this && this.__extends || (_r235 = function r(e, t) {
        return (_r235 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r235(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsBar = t.mapTaskStateToProps = void 0;
    var s = n(1),
      l = n(3),
      c = n(0),
      u = n(8),
      p = n(699),
      d = [];
    t.mapTaskStateToProps = function (e) {
      var t = Array.from(e.worker.tasks.values()).find(function (e) {
        return u.TaskHelper.isLiveCall(e);
      });
      return {
        currentCallTask: t,
        currentCallOnHold: t && u.TaskHelper.isCallOnHold(t),
        selectedView: e.view.activeView,
        monitoredTask: e.supervisor.callMonitoring.task,
        monitoredWorkers: e.supervisor.callMonitoring.workers || d,
        monitoringState: e.supervisor.callMonitoring.status
      };
    };
    var f = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return s.createElement(h, i({}, this.props));
      }, t.friendlyName = p.displayName, t.displayName = p.displayName, t.Content = p.contentStore, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);
    t.LiveCommsBar = f;
    var h = l.connect(t.mapTaskStateToProps)(p.LiveCommsBarImpl);
  }, function (e, t, n) {
    "use strict";

    var _r236,
      o = this && this.__extends || (_r236 = function r(e, t) {
        return (_r236 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r236(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsBarImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(98),
      l = n(0),
      c = n(700),
      u = n(283);
    t.displayName = "LiveCommsBar", t.contentStore = new l.DynamicContentStore(t.displayName);
    var p = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        return this.props.monitoringState === s.CallMonitoringStatus.monitoring || this.props.currentCallTask && "agent-desktop" !== this.props.selectedView ? a.createElement(l.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, a.createElement(c.LiveCommsBarContainer, {
          className: "Twilio-LiveCommsBarItem-LiveCommsBarContainer"
        }, a.createElement(u.LiveCommsBarItem, i({
          key: "item"
        }, this.props)))) : null;
      }, n;
    }(a.PureComponent);
    t.LiveCommsBarImpl = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsBarContainer = void 0;
    var o,
      i = n(2);
    t.LiveCommsBarContainer = i.default("div")(o || (o = r(["\n    display: flex;\n    width: 100%;\n    z-index: 3;\n    overflow: hidden;\n    flex-direction: column;\n    flex: 0 0 auto;\n"], ["\n    display: flex;\n    width: 100%;\n    z-index: 3;\n    overflow: hidden;\n    flex-direction: column;\n    flex: 0 0 auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r237,
      o = this && this.__extends || (_r237 = function r(e, t) {
        return (_r237 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r237(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsBarItem = void 0;
    var i = n(1),
      a = n(0),
      s = n(98),
      l = n(702),
      c = n(703),
      u = n(284),
      p = n(4),
      d = n(8),
      f = n(6),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.getMessage = function () {
            if (t.props.monitoringState === s.CallMonitoringStatus.monitoring) {
              var e = t.props.monitoredTask,
                n = t.props.monitoredWorkers;
              return 0 === n.length ? i.createElement(a.Template, {
                source: p.templates.LiveCommsMonitoringMessageNoWorkers,
                task: e
              }) : 1 === n.length ? i.createElement(a.Template, {
                source: p.templates.LiveCommsMonitoringMessage,
                worker: n[0],
                task: e
              }) : i.createElement(a.Template, {
                source: p.templates.LiveCommsMonitoringMessageMoreWorkers,
                workers: n,
                task: e
              });
            }
            if (t.props.currentCallTask) {
              e = t.props.currentCallTask;
              return i.createElement(a.Template, {
                source: p.templates.LiveCommsOngoingCallMessage,
                task: e
              });
            }
            return null;
          }, t.getActions = function () {
            if (t.props.monitoringState === s.CallMonitoringStatus.monitoring) {
              var e = t.props.monitoredTask;
              return [{
                onClick: function onClick() {
                  a.Actions.invokeAction("NavigateToView", {
                    viewName: "teams"
                  }).then(function () {
                    return f.tryInvokeAction("SelectTaskInSupervisor", {
                      task: e
                    });
                  }).catch(function () {});
                },
                caption: p.templates.LiveCommsBarReturnToCall
              }, {
                onClick: function onClick() {
                  return f.tryInvokeAction("StopMonitoringCall", {
                    task: e
                  });
                },
                caption: p.templates.LiveCommsBarStopListening,
                actionsToListen: ["StopMonitoringCall"]
              }];
            }
            if (t.props.currentCallTask) {
              var n = t.props.currentCallTask,
                r = [{
                  onClick: function onClick() {
                    a.Actions.invokeAction("NavigateToView", {
                      viewName: "agent-desktop"
                    }).then(function () {
                      return f.tryInvokeAction("SelectTask", {
                        task: n
                      });
                    }).catch(function () {});
                  },
                  caption: p.templates.LiveCommsBarReturnToCall
                }];
              return d.TaskHelper.canHold(n) && (!d.TaskHelper.isRegularConferenceCall(n) || n.conference.liveParticipantCount <= 2) && r.push({
                actionsToListen: ["UnholdCall", "HoldCall"],
                onClick: function onClick() {
                  var e = t.props.currentCallOnHold ? "UnholdCall" : "HoldCall";
                  f.tryInvokeAction(e, {
                    task: n
                  });
                },
                caption: t.props.currentCallOnHold ? p.templates.LiveCommsBarUnHold : p.templates.LiveCommsBarHold
              }), r;
            }
            return [];
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = "",
            n = !1;
          return this.props.monitoringState === s.CallMonitoringStatus.monitoring ? e = "MonitorSmall" : this.props.currentCallTask && (e = this.props.currentCallOnHold ? "HoldBoldSmall" : "CallSmall", n = this.props.currentCallOnHold), i.createElement(a.DynamicComponent, {
            contentStore: t.Content,
            childProps: this.props,
            name: t.friendlyName,
            customChildren: this.props.children
          }, i.createElement(l.LiveCommsBarItemContainer, {
            showHold: n,
            className: "Twilio-LiveCommsBarItem-LiveCommsBarItemContainer"
          }, i.createElement(c.LiveCommsIcon, {
            key: "icon",
            icon: e
          }), i.createElement(l.MessageContainer, {
            key: "message",
            className: "Twilio-LiveCommsBarItem-MessageContainer"
          }, this.getMessage()), i.createElement(u.LiveCommsBarItemActions, {
            key: "actions",
            actions: this.getActions()
          })));
        }, t.friendlyName = "LiveCommsBarItem", t.displayName = t.friendlyName, t.Content = new a.DynamicContentStore(t.friendlyName), t;
      }(i.PureComponent);
    t.LiveCommsBarItem = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageContainer = t.LiveCommsBarItemContainer = void 0;
    var o,
      i,
      a = n(2);
    t.LiveCommsBarItemContainer = a.default("div")(o || (o = r(["\n    display: flex;\n    min-height: 24px;\n    flex: 1 1 auto;\n    position: relative;\n    align-items: center;\n    padding-right: 4px;\n    padding-left: 4px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    background-color: ", ";\n    color: ", ";\n"], ["\n    display: flex;\n    min-height: 24px;\n    flex: 1 1 auto;\n    position: relative;\n    align-items: center;\n    padding-right: 4px;\n    padding-left: 4px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    background-color: ", ";\n    color: ", ";\n"])), function (e) {
      return e.showHold ? e.theme.colors.holdColor : e.theme.colors.flexBlueColor;
    }, function (e) {
      return e.theme.colors.lightTextColor;
    }), t.MessageContainer = a.default("div")(i || (i = r(["\n    margin-left: 8px;\n    margin-right: 4px;\n    align-self: center;\n    font-size: 12px;\n    flex-grow: 2;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"], ["\n    margin-left: 8px;\n    margin-right: 4px;\n    align-self: center;\n    font-size: 12px;\n    flex-grow: 2;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsIcon = void 0;
    var r = n(704);
    Object.defineProperty(t, "LiveCommsIcon", {
      enumerable: !0,
      get: function get() {
        return r.LiveCommsIcon;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r238,
      o = this && this.__extends || (_r238 = function r(e, t) {
        return (_r238 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r238(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsIcon = void 0;
    var i = n(1),
      a = n(0),
      s = n(705),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.icon;
          return i.createElement(s.IconContainer, {
            className: "Twilio-LiveCommsBarItem-Icon"
          }, i.createElement(a.Icon, {
            icon: e
          }));
        }, t;
      }(i.PureComponent);
    t.LiveCommsIcon = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconContainer = void 0;
    var o,
      i = n(2);
    t.IconContainer = i.default("div")(o || (o = r(["\n    width: 24px;\n    max-height: 24px;\n"], ["\n    width: 24px;\n    max-height: 24px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r239,
      o = this && this.__extends || (_r239 = function r(e, t) {
        return (_r239 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r239(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsBarItemActions = void 0;
    var i = n(1),
      a = n(0),
      s = n(707),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(a.DynamicComponent, {
            contentStore: t.Content,
            childProps: this.props,
            name: t.friendlyName,
            customChildren: this.props.children
          }, i.createElement(s.LiveCommsBarItemActionsContainer, {
            className: "Twilio-LiveCommsBarItemActionsContainer",
            noGrow: !0
          }, this.renderContents()));
        }, t.prototype.renderContents = function () {
          for (var e = [], t = function t(_t3) {
              var r = n.props.actions[_t3];
              e.push(i.createElement(a.ActionStateListener, {
                key: _t3,
                action: r.actionsToListen
              }, function (e) {
                return i.createElement(s.ActionButton, {
                  onClick: r.onClick,
                  disabled: e.disabled
                }, i.createElement(a.Template, {
                  source: r.caption
                }));
              })), _t3 < n.props.actions.length - 1 && e.push("|");
            }, n = this, r = 0; r < this.props.actions.length; r++) t(r);
          return e;
        }, t.friendlyName = "LiveCommsBarItemActions", t.displayName = t.friendlyName, t.Content = new a.DynamicContentStore(t.friendlyName), t;
      }(i.Component);
    t.LiveCommsBarItemActions = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LiveCommsBarItemActionsContainer = t.ActionButton = void 0;
    var o,
      i,
      a = n(2),
      s = n(0);
    t.ActionButton = a.default("button")(o || (o = r(["\n    padding-right: 10px;\n    padding-left: 10px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    border: none;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"], ["\n    padding-right: 10px;\n    padding-left: 10px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    border: none;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"]))), t.LiveCommsBarItemActionsContainer = a.default(s.FlexBox)(i || (i = r(["\n    font-size: 12px;\n    align-items: center;\n"], ["\n    font-size: 12px;\n    align-items: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r240,
      o = this && this.__extends || (_r240 = function r(e, t) {
        return (_r240 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r240(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.OutboundDialerPanelImpl = t.contentStore = t.displayName = void 0;
    var s = n(0),
      l = n(1),
      c = n(13),
      u = n(7),
      p = n(123),
      d = n(6),
      f = n(37),
      h = n(4),
      m = n(286),
      g = n(709);
    t.displayName = "OutboundDialerPanel", t.contentStore = new s.DynamicContentStore(t.displayName);
    var y = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          phoneNumber: "",
          selectedQueueSid: "",
          inProgress: !1,
          errorString: ""
        }, t.renderError = function (e) {
          return e === p.OutboundCallingErrors.missingDestination ? l.createElement(s.Template, {
            source: h.templates.OutboundErrorMissingDestination
          }) : e === p.OutboundCallingErrors.missingQueue ? l.createElement(s.Template, {
            source: h.templates.OutboundErrorMissingQueue
          }) : e === p.OutboundCallingErrors.generic ? l.createElement(s.Template, {
            source: h.templates.OutboundErrorGeneral
          }) : e === p.OutboundCallingErrors.notInTaskQueue ? l.createElement(s.Template, {
            source: h.templates.OutboundErrorNotInQueue,
            queue: f.InsightsEntityCache.getQueue(t.state.selectedQueueSid).name
          }) : l.createElement(l.Fragment, null, l.createElement(s.Template, {
            source: h.templates.OutboundErrorGeneral
          }), l.createElement("br", null), l.createElement(s.Template, {
            code: "[ " + e + " ]"
          }));
        }, t.handleDial = function () {
          return i(t, void 0, void 0, function () {
            var e, t, n, r;
            return a(this, function (o) {
              switch (o.label) {
                case 0:
                  if (e = this.state, t = e.phoneNumber, n = e.selectedQueueSid, !t) return [2];
                  this.setState({
                    inProgress: !0,
                    errorString: ""
                  }), o.label = 1;
                case 1:
                  return o.trys.push([1, 4,, 5]), [4, s.Actions.invokeAction("StartOutboundCall", {
                    destination: t,
                    queueSid: n
                  })];
                case 2:
                  return o.sent(), this.setState({
                    inProgress: !1
                  }), [4, s.Actions.invokeAction("ToggleOutboundDialer")];
                case 3:
                  return o.sent(), [3, 5];
                case 4:
                  return r = o.sent(), this.setState({
                    inProgress: !1,
                    errorString: u.isFlexError(r) ? r.content.description : r.message
                  }), [3, 5];
                case 5:
                  return [2];
              }
            });
          });
        }, t.handleClose = function () {
          d.tryInvokeAction("ToggleOutboundDialer");
        }, t.handlePhoneNumberChange = function (e) {
          return t.setState({
            phoneNumber: e,
            errorString: ""
          });
        }, t.handleQueueChange = function (e) {
          return t.setState({
            selectedQueueSid: e,
            errorString: ""
          });
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e,
          n = this.state,
          r = n.inProgress,
          o = n.phoneNumber,
          i = n.errorString,
          a = n.selectedQueueSid,
          u = this.props.hasIncomingCallReservation,
          p = c.Manager.getInstance().serviceConfiguration.outbound_call_flows,
          d = p && p.default && p.default.location,
          f = c.Manager.getInstance().serviceConfiguration.taskrouter_offline_activity_sid,
          y = (null === (e = this.props.worker.activity) || void 0 === e ? void 0 : e.sid) !== f;
        return l.createElement(m.Container, null, l.createElement(m.StyledSidePanel, {
          displayName: t.displayName,
          themeOverride: this.props.theme && this.props.theme.OutboundDialerPanel,
          handleCloseClick: this.handleClose,
          title: l.createElement(s.Template, {
            source: h.templates.OutboundDialerPanelTitle
          })
        }, y && l.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          name: t.displayName,
          vertical: !0,
          childProps: this.props,
          noContainers: !0
        }, l.createElement(m.DialerContainer, {
          disabled: r
        }, l.createElement(m.Caption, {
          key: "dialer-phone-input",
          htmlFor: "dialer-phone-input",
          className: "Twilio-OutboundDialerPanel-PhoneInput-Caption"
        }, l.createElement(s.Template, {
          source: h.templates.OutboundDialerPanelPhoneInputCaption
        })), l.createElement(s.Dialer, {
          key: "dialer",
          onDial: this.handleDial,
          defaultPhoneNumber: o,
          onPhoneNumberChange: this.handlePhoneNumberChange,
          hideActions: !0,
          disabled: r,
          defaultCountryAlpha2Code: d
        }), l.createElement(m.Caption, {
          key: "queue-select-caption",
          className: "Twilio-OutboundDialerPanel-QueueSelect-Caption"
        }, l.createElement(s.Template, {
          source: h.templates.OutboundDialerPanelQueueSelectCaption
        })), l.createElement(g.OutboundDialerPanelQueueSelect, {
          key: "queue-select",
          selectedQueueSid: a,
          onChange: this.handleQueueChange,
          disabled: r
        }), l.createElement(m.CallControls, {
          key: "call-button"
        }, l.createElement(m.CallButton, {
          "data-test": "outbound-dialer-submit",
          icon: "Call",
          disabled: r || !o || u,
          onClick: this.handleDial,
          themeOverride: this.props.theme && this.props.theme.Dialer.CallButton
        }), r && l.createElement(m.CallAnimation, null, l.createElement(s.ConnectingAnimation, {
          sizeMultiplier: 2
        }))), i && l.createElement(m.ErrorMessage, {
          key: "error"
        }, this.renderError(i)))), !y && l.createElement(m.OfflineContainer, null, l.createElement(m.ErrorIcon, null), l.createElement(s.Template, {
          source: h.templates.NoOutboundCallingWhenOffline,
          offlineName: this.props.worker.activity.name
        }))));
      }, n;
    }(l.PureComponent);
    t.OutboundDialerPanelImpl = y;
  }, function (e, t, n) {
    "use strict";

    var _r241,
      o = this && this.__extends || (_r241 = function r(e, t) {
        return (_r241 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r241(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.OutboundDialerPanelQueueSelect = void 0;
    var s = n(58),
      l = n(1),
      c = n(32),
      u = n(13),
      p = n(3),
      d = n(73),
      f = n(37),
      h = n(4),
      m = n(286),
      g = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            queues: []
          }, t._isMounted = !1, t.searchingForMissingQueues = !1, t.handleQueuesResults = function (e) {
            var n,
              r,
              o = u.Manager.getInstance().serviceConfiguration.outbound_call_flows,
              i = Object.keys(e).map(function (t) {
                var n = e[t],
                  r = new d.InsightsQueue(n);
                return f.InsightsEntityCache.updateCache(r), r;
              }),
              a = null === (n = null == o ? void 0 : o.default) || void 0 === n ? void 0 : n.queue_sid,
              s = i.some(function (e) {
                return e.sid === a;
              });
            t.searchingForMissingQueues ? i = t.state.queues.concat(i) : !s && a && (t.searchingForMissingQueues = !0, null === (r = t.queuesSearch) || void 0 === r || r.search('data.queue_sid == "' + a + '"')), i = i.sort(function (e, t) {
              var n = e.name || "",
                r = t.name || "";
              return n.localeCompare(r);
            }), t.setState({
              queues: i
            }), s && a && t.props.onChange(a);
          }, t.handleChange = function (e) {
            t.props.onChange(e.target.value);
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          return i(this, void 0, void 0, function () {
            var e;
            return a(this, function (t) {
              switch (t.label) {
                case 0:
                  return this._isMounted = !0, !p.FlexModule.insightsClient || c.FlexClientManager.isDegraded(p.FlexModule.insightsClient) ? [2] : (e = this, [4, p.FlexModule.insightsClient.instantQuery("tr-queue")]);
                case 1:
                  return e.queuesSearch = t.sent(), this._isMounted && this.queuesSearch.on("searchResult", this.handleQueuesResults).search(""), [2];
              }
            });
          });
        }, t.prototype.componentWillUnmount = function () {
          this._isMounted = !1, this.queuesSearch && this.queuesSearch.removeAllListeners("searchResult");
        }, t.prototype.render = function () {
          return l.createElement(m.StyledSelect, {
            className: "Twilio-OutboundDialerPanel-QueueSelect",
            value: this.props.selectedQueueSid,
            onChange: this.handleChange,
            displayEmpty: !0,
            disabled: this.props.disabled
          }, l.createElement(s.default, {
            key: "placeholder",
            value: "",
            disabled: !0
          }, h.templates.OutboundDialerPanelQueueSelectCaption()), this.state.queues.map(function (e) {
            return l.createElement(s.default, {
              key: e.name,
              value: e.sid
            }, e.name);
          }));
        }, t.defaultProps = {
          selectedQueueSid: ""
        }, t;
      }(l.PureComponent);
    t.OutboundDialerPanelQueueSelect = g;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Router = void 0;
    var r = n(711);
    Object.defineProperty(t, "Router", {
      enumerable: !0,
      get: function get() {
        return r.Router;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Router = void 0;
    var o = n(1),
      i = n(93),
      a = n(3),
      s = n(44),
      l = n(127);
    t.Router = function (e) {
      var t = {
        dispatch: function dispatch(e) {
          return a.FlexModule.dispatch(r(r({}, e), {
            type: l.FLEX_LOCATION_CHANGE
          }));
        }
      };
      return o.createElement(i.ConnectedRouter, {
        history: s.default(),
        store: t
      }, e.children);
    };
  }, function (e, t, n) {
    "use strict";

    var _r242,
      o = this && this.__extends || (_r242 = function r(e, t) {
        return (_r242 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r242(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideNav = void 0;
    var a = n(1),
      s = n(3),
      l = n(8),
      c = n(713),
      u = n(288),
      p = n(289),
      d = n(290),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(h, i({}, this.props));
        }, t.friendlyName = c.displayName, t.displayName = c.displayName, t.Content = c.contentStore, t.AgentDesktop = u.SideLinkAgentDesktop, t.Teams = p.SideLinkTeams, t.QueuesStats = d.SideLinkQueuesStats, t;
      }(a.PureComponent);
    t.SideNav = f;
    var h = s.connect(function (e) {
      return {
        incomingTasks: !!Array.from(e.worker.tasks.values()).find(function (e) {
          return l.TaskHelper.isPending(e);
        }),
        isOpen: e.view.isSideNavOpen,
        activeView: e.view.activeView
      };
    })(c.SideNavImpl);
  }, function (e, t, n) {
    "use strict";

    var _r243,
      o = this && this.__extends || (_r243 = function r(e, t) {
        return (_r243 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r243(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideNavImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(19),
      c = n(33),
      u = n(714),
      p = n(6),
      d = n(288),
      f = n(289),
      h = n(290),
      m = n(722),
      g = n(724),
      y = n(726),
      v = n(728),
      b = n(730),
      C = n(732),
      _ = n(21),
      k = n(43);
    t.displayName = "SideNav", t.contentStore = new s.DynamicContentStore(t.displayName);
    var w = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.doNavigate = function (e) {
          return function () {
            p.tryInvokeAction("NavigateToView", {
              viewName: e
            });
          };
        }, t.showSupervisor = function (e) {
          var t = e.manager.user.roles;
          return t.indexOf("supervisor") >= 0 || t.indexOf("admin") >= 0;
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this,
          n = this.props,
          r = n.reserveSpace,
          o = n.activeView,
          p = n.isOpen;
        if (!r && !p) return null;
        var w = p;
        return a.createElement(l.FlexContext.Consumer, null, function (n) {
          return a.createElement(u.StyledSideNav, {
            wideLayout: r,
            className: c.cx("Twilio", "Twilio-SideNav-Container")
          }, a.createElement(u.StyledIconBar, {
            isOpen: w,
            wideLayout: r,
            className: c.cx("Twilio", "Twilio-" + t.displayName)
          }, a.createElement(s.DynamicComponent, {
            contentStore: t.contentStore,
            childProps: i(i({}, e.props), {
              showLabel: w
            }),
            name: t.displayName,
            customChildren: e.props.children,
            vertical: !0
          }, a.createElement(a.Fragment, null, a.createElement(s.ContentFragment, {
            align: "start"
          }, a.createElement(d.SideLinkAgentDesktop, {
            key: "agent-desktop",
            showLabel: w,
            activeView: o
          }), e.showSupervisor(n) && a.createElement(f.SideLinkTeams, {
            key: "teams",
            showLabel: w,
            activeView: o
          }), e.showSupervisor(n) && a.createElement(h.SideLinkQueuesStats, {
            key: "queues-stats",
            showLabel: w,
            activeView: o,
            viewName: "queues-stats"
          }), _.InsightsService.hasPermission(k.DashboardsView.permissions) && a.createElement(g.SideLinkInsightsDashboards, {
            key: "dashboards",
            showLabel: w,
            activeView: o
          }), _.InsightsService.hasPermission(k.AnalyzeView.permissions) && a.createElement(m.SideLinkInsightsAnalyze, {
            key: "analyze",
            showLabel: w,
            activeView: o
          }), _.InsightsService.hasPermission(k.QuestionnairesView.permissions) && a.createElement(y.SideLinkInsightsQuestionnaires, {
            key: "questionnaires",
            showLabel: w,
            activeView: o
          }), _.InsightsService.hasPermission(k.InspectionsView.permissions) && a.createElement(v.SideLinkInsightsInspections, {
            key: "inspections",
            showLabel: w,
            activeView: o
          }), _.InsightsService.hasPermission(k.AgentsView.permissions) && a.createElement(b.SideLinkInsightsAgents, {
            key: "agents",
            showLabel: w,
            activeView: o
          }), _.InsightsService.hasPermission(k.SpeechSearchesView.permissions) && a.createElement(C.SideLinkInsightsSpeechSearches, {
            key: "speech-searches",
            showLabel: w,
            activeView: o
          })), a.createElement(s.ContentFragment, {
            align: "end"
          })))));
        });
      }, n.displayName = t.displayName, n;
    }(a.PureComponent);
    t.SideNavImpl = w;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledIconBar = t.StyledSideNav = void 0;
    var o,
      i,
      a = n(2),
      s = n(0);
    t.StyledSideNav = a.default("div")(o || (o = r(["\n    display: flex;\n    position: relative;\n    outline: none;\n    flex: 0 0 ", ";\n"], ["\n    display: flex;\n    position: relative;\n    outline: none;\n    flex: 0 0 ", ";\n"])), function (e) {
      return e.wideLayout ? "44px" : "0px";
    }), t.StyledIconBar = a.default("div")(i || (i = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 100%;\n    z-index: 10;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    position: absolute;\n    border-style: solid;\n    border-width: 0 1px 0 0;\n    width: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 100%;\n    z-index: 10;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    position: absolute;\n    border-style: solid;\n    border-width: 0 1px 0 0;\n    width: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n"])), function (e) {
      return e.isOpen ? "240px" : "44px";
    }, function (e) {
      return s.Animations.SlideInTransition(e.isOpen);
    }, function (e) {
      return e.isOpen && "box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.4);";
    }, function (e) {
      return !e.wideLayout && s.Animations.AppearAnimation(s.Animations.FADE_IN_DURATION);
    }, function (e) {
      return e.theme.SideNav.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var _r244,
      o = this && this.__extends || (_r244 = function r(e, t) {
        return (_r244 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r244(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkAgentDesktop = void 0;
    var a = n(1),
      s = n(0),
      l = n(4),
      c = n(80),
      u = n(6),
      p = n(115),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.gotoAgentDesktop = function () {
            u.tryInvokeAction("NavigateToView", {
              viewName: "agent-desktop"
            });
          }, t;
        }
        var n;
        return o(t, e), n = t, t.prototype.render = function () {
          var e = this.props,
            t = e.activeView,
            n = e.showLabel,
            r = e.Badge;
          return a.createElement(c.SideLink, {
            icon: "Agent",
            iconActive: "AgentBold",
            isActive: "agent-desktop" === t,
            onClick: this.gotoAgentDesktop,
            showLabel: n,
            Badge: r
          }, a.createElement(s.Template, {
            source: l.templates.SideNavTaskView
          }));
        }, t.getBadgeChildren = function (e) {
          var t = new p.AppStateHelper(e);
          return t.isAgentView() ? 0 : t.getPendingTasks() + t.getUnconsumedMessagesCount();
        }, t.defaultProps = {
          Badge: {
            children: n.getBadgeChildren,
            variant: s.Badge.variants.dot
          }
        }, t = n = i([s.withDefaultPropsUpdate], t);
      }(a.PureComponent);
    t.SideLinkAgentDesktop = d;
  }, function (e, t, n) {
    "use strict";

    var _r245,
      o = this && this.__extends || (_r245 = function r(e, t) {
        return (_r245 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r245(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLink = void 0;
    var a = n(1),
      s = n(717),
      l = n(3),
      c = n(15),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(p, i({}, this.props));
        }, t.displayName = s.displayName, t;
      }(a.PureComponent);
    t.SideLink = u;
    var p = c.withTaskContext(l.connect(function (e, t) {
      var n = t.Badge && t.Badge.children;
      return i(i({}, t), {
        Badge: i(i({}, t.Badge), {
          children: "function" == typeof n ? n(e, t) : n
        })
      });
    })(s.SideLinkImpl));
  }, function (e, t, n) {
    "use strict";

    var _r246,
      o = this && this.__extends || (_r246 = function r(e, t) {
        return (_r246 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r246(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkImpl = t.displayName = void 0;
    var a = n(1),
      s = n(0),
      l = n(718),
      c = n(149);
    t.displayName = "SideLink";
    var u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.shouldComponentUpdate = function (e) {
        return !c(this.props, e);
      }, t.prototype.render = function () {
        var e = this.props,
          t = e.isActive,
          n = e.onClick,
          r = e.icon,
          o = e.iconActive,
          c = e.showLabel,
          u = e.children,
          p = e.Badge,
          d = t && o ? o : r;
        return a.createElement(l.StyledSidelinkContainer, {
          className: t ? "Twilio-Side-Link--Active" : "Twilio-Side-Link",
          onClick: n,
          isActive: t
        }, a.createElement(l.StyledSideLinkIcon, {
          isActive: t,
          className: "Twilio-Side-Link-IconContainer"
        }, a.createElement(s.Icon, {
          icon: d
        }), p && a.createElement(s.Badge, i({}, p))), a.createElement(l.StyledSideLinkLabel, {
          show: c
        }, u));
      }, t;
    }(a.Component);
    t.SideLinkImpl = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledSidelinkContainer = t.StyledSideLinkIcon = t.StyledSideLinkLabel = void 0;
    var o,
      i,
      a,
      s = n(2),
      l = n(0);
    t.StyledSideLinkLabel = s.default("div")(o || (o = r(["\n    flex: 1 1 auto;\n    text-align: left;\n    padding: 8px 16px 8px 8px;\n    opacity: 0;\n    white-space: nowrap;\n\n    ", "\n"], ["\n    flex: 1 1 auto;\n    text-align: left;\n    padding: 8px 16px 8px 8px;\n    opacity: 0;\n    white-space: nowrap;\n\n    ", "\n"])), function (e) {
      return l.Animations.FadeInOutTransition(e.show, l.Animations.SLIDE_IN_DURATION / 2, l.Animations.SLIDE_IN_DURATION / 2, l.Animations.SLIDE_IN_DURATION / 2);
    }), t.StyledSideLinkIcon = s.default("div")(i || (i = r(["\n    flex: 0 0 44px;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    background: inherit;\n    padding: 8px 0;\n    ", ";\n"], ["\n    flex: 0 0 44px;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    background: inherit;\n    padding: 8px 0;\n    ", ";\n"])), function (e) {
      return e.theme.SideNav.Icon;
    }), t.StyledSidelinkContainer = s.default("button")(a || (a = r(["\n    display: flex;\n    font-size: 12px;\n    font-weight: bold;\n    height: 44px;\n    outline: none;\n    align-items: center;\n    padding: 0 0 0 0;\n    border-style: none;\n    position: relative;\n    ", ";\n    ", "\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Side-Link-IconContainer,\n        & .Twilio-Badge-OuterCircle {\n            ", "\n        }\n    }\n"], ["\n    display: flex;\n    font-size: 12px;\n    font-weight: bold;\n    height: 44px;\n    outline: none;\n    align-items: center;\n    padding: 0 0 0 0;\n    border-style: none;\n    position: relative;\n    ", ";\n    ", "\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Side-Link-IconContainer,\n        & .Twilio-Badge-OuterCircle {\n            ", "\n        }\n    }\n"])), function (e) {
      return e.theme.SideNav.Icon;
    }, function (e) {
      return l.getBackgroundWithHoverCSS(e.theme.SideNav.Button.background, e.theme.SideNav.Button.lightHover);
    }, function (e) {
      return l.getBackgroundWithHoverCSS(e.theme.SideNav.Button.background, e.theme.SideNav.Button.lightHover, !0);
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r247,
      o = this && this.__extends || (_r247 = function r(e, t) {
        return (_r247 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r247(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkTeams = void 0;
    var a = n(1),
      s = n(0),
      l = n(4),
      c = n(80),
      u = n(6),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.gotoTeams = function () {
            u.tryInvokeAction("NavigateToView", {
              viewName: "teams"
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.activeView,
            n = e.showLabel,
            r = e.Badge;
          return a.createElement(c.SideLink, {
            icon: "Agents",
            iconActive: "AgentsBold",
            isActive: "teams" === t,
            onClick: this.gotoTeams,
            showLabel: n,
            Badge: r
          }, a.createElement(s.Template, {
            source: l.templates.SideNavTeamsView
          }));
        }, t.defaultProps = {}, t = i([s.withDefaultPropsUpdate], t);
      }(a.PureComponent);
    t.SideLinkTeams = p;
  }, function (e, t, n) {
    "use strict";

    var _r248,
      o = this && this.__extends || (_r248 = function r(e, t) {
        return (_r248 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r248(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkQueuesStats = void 0;
    var a = n(1),
      s = n(0),
      l = n(4),
      c = n(80),
      u = n(6),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.gotoView = function () {
            u.tryInvokeAction("NavigateToView", {
              viewName: t.props.viewName
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.activeView,
            n = e.showLabel,
            r = e.Badge,
            o = e.viewName;
          return a.createElement(c.SideLink, {
            icon: "Queues",
            iconActive: "QueuesBold",
            isActive: t === o,
            onClick: this.gotoView,
            showLabel: n,
            Badge: r
          }, a.createElement(s.Template, {
            source: l.templates.SideNavQueuesStatsView
          }));
        }, t.defaultProps = {}, t = i([s.withDefaultPropsUpdate], t);
      }(a.PureComponent);
    t.SideLinkQueuesStats = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsAnalyze = void 0;
    var r = n(723);
    Object.defineProperty(t, "SideLinkInsightsAnalyze", {
      enumerable: !0,
      get: function get() {
        return r.SideLinkInsightsAnalyze;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r249,
      o = this && this.__extends || (_r249 = function r(e, t) {
        return (_r249 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r249(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsAnalyze = void 0;
    var s = n(1),
      l = n(0),
      c = n(4),
      u = n(66),
      p = n(43),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.SideLinkView, i({}, this.props, {
            viewName: p.AnalyzeView.viewName,
            icon: p.AnalyzeView.icon,
            iconActive: p.AnalyzeView.iconActive,
            template: c.templates.SideNavInsightsAnalyzeView
          }));
        }, t.defaultProps = {}, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.SideLinkInsightsAnalyze = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsDashboards = void 0;
    var r = n(725);
    Object.defineProperty(t, "SideLinkInsightsDashboards", {
      enumerable: !0,
      get: function get() {
        return r.SideLinkInsightsDashboards;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r250,
      o = this && this.__extends || (_r250 = function r(e, t) {
        return (_r250 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r250(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsDashboards = void 0;
    var s = n(1),
      l = n(0),
      c = n(4),
      u = n(66),
      p = n(43),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.SideLinkView, i({}, this.props, {
            viewName: p.DashboardsView.viewName,
            icon: p.DashboardsView.icon,
            iconActive: p.DashboardsView.iconActive,
            template: c.templates.SideNavInsightsDashboardsView
          }));
        }, t.defaultProps = {}, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.SideLinkInsightsDashboards = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsQuestionnaires = void 0;
    var r = n(727);
    Object.defineProperty(t, "SideLinkInsightsQuestionnaires", {
      enumerable: !0,
      get: function get() {
        return r.SideLinkInsightsQuestionnaires;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r251,
      o = this && this.__extends || (_r251 = function r(e, t) {
        return (_r251 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r251(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsQuestionnaires = void 0;
    var s = n(1),
      l = n(0),
      c = n(4),
      u = n(66),
      p = n(43),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.SideLinkView, i({}, this.props, {
            viewName: p.QuestionnairesView.viewName,
            icon: p.QuestionnairesView.icon,
            iconActive: p.QuestionnairesView.iconActive,
            template: c.templates.SideNavInsightsQuestionnairesView
          }));
        }, t.defaultProps = {}, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.SideLinkInsightsQuestionnaires = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsInspections = void 0;
    var r = n(729);
    Object.defineProperty(t, "SideLinkInsightsInspections", {
      enumerable: !0,
      get: function get() {
        return r.SideLinkInsightsInspections;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r252,
      o = this && this.__extends || (_r252 = function r(e, t) {
        return (_r252 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r252(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsInspections = void 0;
    var s = n(1),
      l = n(0),
      c = n(4),
      u = n(66),
      p = n(43),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.SideLinkView, i({}, this.props, {
            viewName: p.InspectionsView.viewName,
            icon: p.InspectionsView.icon,
            iconActive: p.InspectionsView.iconActive,
            template: c.templates.SideNavInsightsInspectionsView
          }));
        }, t.defaultProps = {}, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.SideLinkInsightsInspections = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsAgents = void 0;
    var r = n(731);
    Object.defineProperty(t, "SideLinkInsightsAgents", {
      enumerable: !0,
      get: function get() {
        return r.SideLinkInsightsAgents;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r253,
      o = this && this.__extends || (_r253 = function r(e, t) {
        return (_r253 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r253(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsAgents = void 0;
    var s = n(1),
      l = n(0),
      c = n(4),
      u = n(66),
      p = n(43),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.SideLinkView, i({}, this.props, {
            viewName: p.AgentsView.viewName,
            icon: p.AgentsView.icon,
            iconActive: p.AgentsView.iconActive,
            template: c.templates.SideNavInsightsAgentsView
          }));
        }, t.defaultProps = {}, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.SideLinkInsightsAgents = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsSpeechSearches = void 0;
    var r = n(733);
    Object.defineProperty(t, "SideLinkInsightsSpeechSearches", {
      enumerable: !0,
      get: function get() {
        return r.SideLinkInsightsSpeechSearches;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r254,
      o = this && this.__extends || (_r254 = function r(e, t) {
        return (_r254 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r254(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SideLinkInsightsSpeechSearches = void 0;
    var s = n(1),
      l = n(0),
      c = n(4),
      u = n(66),
      p = n(43),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return s.createElement(u.SideLinkView, i({}, this.props, {
            viewName: p.SpeechSearchesView.viewName,
            icon: p.SpeechSearchesView.icon,
            iconActive: p.SpeechSearchesView.iconActive,
            template: c.templates.SideNavInsightsSpeechSearchesView
          }));
        }, t.defaultProps = {}, t = a([l.withDefaultPropsUpdate], t);
      }(s.PureComponent);
    t.SideLinkInsightsSpeechSearches = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LogoutView = void 0;
    var r = n(735);
    Object.defineProperty(t, "LogoutView", {
      enumerable: !0,
      get: function get() {
        return r.LogoutView;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r255,
      o = this && this.__extends || (_r255 = function r(e, t) {
        return (_r255 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r255(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LogoutView = void 0;
    var i = n(1),
      a = n(49),
      s = n(6),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          s.tryInvokeAction("Logout", {
            forceLogout: !1
          });
        }, t.prototype.render = function () {
          return i.createElement(a.Redirect, {
            to: "/"
          });
        }, t;
      }(i.Component);
    t.LogoutView = l;
  }, function (e, t, n) {
    "use strict";

    var _r256,
      o = this && this.__extends || (_r256 = function r(e, t) {
        return (_r256 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r256(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Connected = t.ViewCollection = void 0;
    var s = n(1),
      l = n(0),
      c = n(3),
      u = n(737),
      p = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.updateAll = function () {}, n.prototype.render = function () {
          return s.createElement(t.Connected, i({}, this.props));
        }, n.displayName = u.displayName, n.Content = u.contentStore, n.defaultProps = {
          defaultLocation: "/agent-desktop"
        }, n = a([l.withDefaultPropsUpdate], n);
      }(s.PureComponent);
    t.ViewCollection = p, t.Connected = c.connect(function (e) {
      return {
        router: e.router
      };
    })(u.ViewCollectionImpl);
  }, function (e, t, n) {
    "use strict";

    var _r257,
      o = this && this.__extends || (_r257 = function r(e, t) {
        return (_r257 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r257(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ViewCollectionImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      s = n(49),
      l = n(0),
      c = n(292),
      u = n(83),
      p = n(3);
    t.displayName = "ViewCollection", t.contentStore = new l.DynamicContentStore(t.displayName);
    var d = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.keysOfViewsThatHaveBeenMounted = [], t.getActiveChild = function (e, n) {
          var r,
            o = a.Children.only(e);
          return a.Children.forEach(o.props.children, function (e) {
            a.isValidElement(e) && t.isActiveView(e, n) && !r && (r = e);
          }), r && r.props.name;
        }, t.debouncedWindowResizeListeners = u(function () {
          p.FlexModule.events.emitViewResized(window.innerWidth), p.FlexModule.events.emitSelectedViewChanged(t.getActiveChild(t.props.children, t.props.router), !0);
        }, 100), t.renderRouteChildren = function (e, n) {
          if ("start" !== n) return e;
          var r = t.props,
            o = r.router,
            i = r.defaultLocation;
          e = e.filter(function (e) {
            return a.isValidElement(e);
          });
          var l = o.location && !e.some(function (e) {
              return t.isActiveView(e);
            }),
            c = e.map(function (e) {
              var n = t.getRouteFromView(e);
              return t.shallRenderView(e) ? a.createElement(s.Route, {
                key: "view-" + e.props.name,
                exact: n.exact,
                path: "/" + e.props.name
              }, t.updateChildren(e)) : null;
            });
          return l ? [a.createElement(s.Redirect, {
            key: "redirect",
            to: {
              pathname: i,
              search: o.location.search
            }
          })] : c;
        }, t.updateChildren = function (e) {
          return function (n) {
            var r = t.isActiveView(e);
            return t.registerViewHavingBeenMounted(e.props.name), t.shallRenderView(e) && a.createElement(c.ViewImpl, {
              name: e.props.name,
              isViewActive: r,
              route: n
            }, e.props.children);
          };
        }, t;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.debouncedWindowResizeListeners);
      }, n.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.debouncedWindowResizeListeners);
      }, n.prototype.getPathnameFromRouter = function (e) {
        return e.location && e.location.pathname;
      }, n.prototype.getRouteFromView = function (e) {
        if (e.props.route) {
          if (Array.isArray(e.props.route.path)) {
            var t = e.props.route.path;
            return {
              path: i(t, ["/" + e.props.name])
            };
          }
          return {
            path: [e.props.route.path, "/" + e.props.name]
          };
        }
        return {
          path: "/" + e.props.name
        };
      }, n.prototype.isActiveView = function (e, t) {
        void 0 === t && (t = this.props.router);
        var n = this.getRouteFromView(e),
          r = this.getPathnameFromRouter(t);
        return !!s.matchPath(r, n);
      }, n.prototype.shallRenderView = function (e) {
        if (this.isActiveView(e)) return !0;
        if ("mountRule" in e.props) switch (e.props.mountRule) {
          case c.ViewMountRule.Always:
            return !0;
          case c.ViewMountRule.WhenHasBeenActive:
            return this.keysOfViewsThatHaveBeenMounted.indexOf(e.props.name) > -1;
          default:
            return !1;
        }
        return "keepMounted" in e.props && !1 !== e.props.keepMounted;
      }, n.prototype.registerViewHavingBeenMounted = function (e) {
        this.keysOfViewsThatHaveBeenMounted.indexOf(e) > -1 || this.keysOfViewsThatHaveBeenMounted.push(e);
      }, n.prototype.render = function () {
        return a.createElement(l.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          renderChildren: this.renderRouteChildren,
          noContainers: !0
        }, a.createElement(l.FlexBox, {
          className: "Twilio-ViewCollection",
          overflow: "hidden"
        }));
      }, n;
    }(a.PureComponent);
    t.ViewCollectionImpl = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ViewMountRule = t.View = void 0;
    t.View = function () {
      return null;
    }, function (e) {
      e.Always = "Always", e.WhenActive = "WhenActive", e.WhenHasBeenActive = "WhenHasBeenActive";
    }(t.ViewMountRule || (t.ViewMountRule = {}));
  }, function (e, t, n) {
    "use strict";

    var _r258,
      o = this && this.__extends || (_r258 = function r(e, t) {
        return (_r258 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r258(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ViewImpl = void 0;
    var a = n(1),
      s = n(33),
      l = n(740),
      c = n(35),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this.conditionallySetActiveView();
        }, t.prototype.componentDidUpdate = function (e) {
          var t = this.props.route;
          e.isViewActive && t.location.pathname === e.route.location.pathname || this.conditionallySetActiveView();
        }, t.prototype.conditionallySetActiveView = function () {
          var e = this;
          this.props.isViewActive && setTimeout(function () {
            c.Actions.setActiveView(e.props.name);
          });
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.isViewActive,
            n = e.children,
            r = e.route,
            o = e.name,
            c = e.className;
          return a.createElement(l.StyledViewFlexBox, {
            className: s.cx("Twilio-View", "Twilio-View-" + o, c),
            isViewActive: t
          }, a.Children.map(n, function (e) {
            var n = e;
            return a.isValidElement(e) ? a.cloneElement(n, i(i({}, e.props), {
              isViewActive: t,
              route: r
            })) : e;
          }));
        }, t;
      }(a.PureComponent);
    t.ViewImpl = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledViewFlexBox = void 0;
    var o,
      i = n(2);
    t.StyledViewFlexBox = i.default("div")(o || (o = r(["\n    display: ", ";\n    flex: 1 1 auto;\n    overflow: hidden;\n"], ["\n    display: ", ";\n    flex: 1 1 auto;\n    overflow: hidden;\n"])), function (e) {
      return e.isViewActive ? "flex" : "none";
    });
  }, function (e, t) {
    e.exports = require("@material-ui/core/DialogActions");
  }, function (e, t) {
    e.exports = require("@material-ui/core/DialogContent");
  }, function (e, t) {
    e.exports = require("@material-ui/core/DialogContentText");
  }, function (e, t, n) {
    "use strict";

    var _r259,
      o = this && this.__extends || (_r259 = function r(e, t) {
        return (_r259 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r259(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MultipleCallAlertDialog = void 0;
    var s = n(745),
      l = n(0),
      c = n(1),
      u = n(3),
      p = n(6),
      d = n(8),
      f = n(4),
      h = n(293),
      m = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            open: !1,
            incomingCallTask: void 0,
            outboundCallTask: void 0
          }, t.compute = function (e) {
            var n = e.find(function (e) {
                return d.TaskHelper.isIncomingCall(e) && !d.TaskHelper.isOutboundCallTask(e);
              }),
              r = e.find(function (e) {
                return d.TaskHelper.isOutboundCallTask(e);
              }),
              o = !!n && !!r;
            t.state.open === o && n === t.state.incomingCallTask && r === t.state.outboundCallTask || t.setState({
              open: !!n && !!r,
              incomingCallTask: n,
              outboundCallTask: r
            });
          }, t.rejectIncomingAndContinueWithOutbound = function () {
            return i(t, void 0, void 0, function () {
              var e, t, n;
              return a(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e = this.state, t = e.incomingCallTask, n = e.outboundCallTask, [4, p.tryInvokeAction("RejectTask", {
                      task: t
                    })];
                  case 1:
                    return r.sent(), p.tryInvokeAction("SelectTask", {
                      task: n
                    }), [2];
                }
              });
            });
          }, t.acceptIncomingAndHangupOutbound = function () {
            return i(t, void 0, void 0, function () {
              var e, t, n;
              return a(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e = this.state, t = e.incomingCallTask, n = e.outboundCallTask, [4, p.tryInvokeAction("HangupCall", {
                      task: n
                    })];
                  case 1:
                    return r.sent(), [4, p.tryInvokeAction("CompleteTask", {
                      task: n
                    })];
                  case 2:
                    return r.sent(), [4, p.tryInvokeAction("AcceptTask", {
                      task: t
                    })];
                  case 3:
                    return r.sent(), p.tryInvokeAction("SelectTask", {
                      task: t
                    }), [2];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this.compute(this.props.tasks);
        }, t.prototype.componentDidUpdate = function () {
          this.compute(this.props.tasks);
        }, t.prototype.render = function () {
          return c.createElement(s.default, {
            open: this.state.open,
            "aria-labelledby": "alert-dialog-title",
            "aria-describedby": "alert-dialog-description"
          }, c.createElement(h.StyledDialogTitle, {
            id: "alert-dialog-title"
          }, c.createElement(l.Template, {
            source: f.templates.MultipleCallAlertDialogTitle
          })), c.createElement(h.StyledDialogContent, null, c.createElement(h.StyledDialogContentText, {
            id: "alert-dialog-description"
          }, c.createElement(l.Template, {
            source: f.templates.MultipleCallAlertDialogContent,
            task: this.state.outboundCallTask
          }))), c.createElement(h.StyledDialogActions, null, c.createElement(h.StyledRejectButton, {
            onClick: this.rejectIncomingAndContinueWithOutbound,
            roundCorners: !1
          }, c.createElement(l.Template, {
            source: f.templates.MultipleCallAlertDialogActionReject
          })), c.createElement(h.StyledAcceptButton, {
            onClick: this.acceptIncomingAndHangupOutbound,
            roundCorners: !1
          }, c.createElement(l.Template, {
            source: f.templates.MultipleCallAlertDialogActionAccept
          }))));
        }, t;
      }(c.Component);
    t.MultipleCallAlertDialog = u.connect(function (e) {
      return {
        tasks: Array.from(e.worker.tasks.values())
      };
    })(m);
  }, function (e, t) {
    e.exports = require("@material-ui/core/Dialog");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(2);
    t.Container = i.default("div")(o || (o = r(['\n    display: "flex";\n    flex-wrap: "nowrap";\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-direction: "column";\n    ', "\n"], ['\n    display: "flex";\n    flex-wrap: "nowrap";\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-direction: "column";\n    ', "\n"])), function (e) {
      return e.theme.RootContainer;
    });
  }, function (e, t, n) {
    "use strict";

    var _r260,
      o = this && this.__extends || (_r260 = function r(e, t) {
        return (_r260 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r260(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MultiSessionAlert = void 0;
    var i = n(1),
      a = n(138),
      s = n(39),
      l = n(90),
      c = n(748),
      u = n(751),
      p = n(752),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            secondsLeft: 15
          }, t.runTick = function () {
            var e = t.state.secondsLeft,
              n = t.props.otherSessionDetected;
            n && (e ? t.setState(function (e) {
              return {
                secondsLeft: Math.max(0, e.secondsLeft - 1)
              };
            }) : s.Actions.invalidateCurrentSession(n));
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          a.addTickListener(this.runTick);
        }, t.prototype.componentDidUpdate = function (e) {
          !e.otherSessionDetected && this.props.otherSessionDetected && this.setState({
            secondsLeft: 15
          });
        }, t.prototype.componentWillUnmount = function () {
          a.removeTickListener(this.runTick);
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.otherSessionDetected,
            n = e.sessionInvalidated,
            r = e.otherSessionHasOngoingCall;
          return n ? i.createElement(c.default, null) : t ? r ? i.createElement(p.default, {
            timeout: this.state.secondsLeft,
            onDropCall: l.singleSessionGuard.invalidateOtherSessions,
            onCancel: function onCancel() {
              return s.Actions.invalidateCurrentSession(t);
            }
          }) : i.createElement(u.default, {
            timeout: this.state.secondsLeft,
            onLogIn: l.singleSessionGuard.invalidateOtherSessions,
            onCancel: function onCancel() {
              return s.Actions.invalidateCurrentSession(t);
            }
          }) : null;
        }, t;
      }(i.PureComponent);
    t.MultiSessionAlert = d;
  }, function (e, t, n) {
    "use strict";

    var _r261,
      o = this && this.__extends || (_r261 = function r(e, t) {
        return (_r261 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r261(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
      a = n(0),
      s = n(90),
      l = n(159),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(l.FullScreenAlertView, {
            message: i.createElement(a.Template, {
              source: a.templates.SessionInvalidated
            }),
            showIcon: !1,
            buttons: [{
              type: "primary",
              props: {
                onClick: s.singleSessionGuard.refreshPageWithInitialParams,
                key: "loginAgain"
              },
              content: i.createElement(a.Template, {
                source: a.templates.LogIn
              })
            }]
          });
        }, t;
      }(i.PureComponent);
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var _r262,
      o = this && this.__extends || (_r262 = function r(e, t) {
        return (_r262 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r262(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FullScreenAlertView = void 0;
    var a = n(0),
      s = n(750),
      l = n(1),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.showIcon,
            n = e.message,
            r = e.buttons,
            o = e.primaryDescription,
            i = e.secondaryDescription,
            c = e.showFlexLogo;
          return l.createElement(s.Container, null, t && l.createElement(a.Icon, {
            icon: "Error",
            sizeMultiplier: 2
          }), n && l.createElement(s.Message, null, n), o && l.createElement(s.Description, null, o), r && r.length && l.createElement(s.ButtonContainer, null, this.renderButtons(r)), i && l.createElement(s.Description, null, i), c && l.createElement(s.FlexLogo, {
            className: "Twilio-Flex-Logo",
            icon: "FlexBanner",
            sizeMultiplier: 8
          }));
        }, t.prototype.renderButtons = function (e) {
          return e.map(function (e) {
            var t;
            switch (e.type) {
              case "primary":
                t = s.PrimaryButton;
                break;
              case "danger":
                t = s.DangerButton;
                break;
              default:
                t = s.DefaultButton;
            }
            return l.createElement(t, i({
              roundCorners: !1
            }, e.props), e.content);
          });
        }, t.defaultProps = {
          showIcon: !0,
          showFlexLogo: !0
        }, t;
      }(l.PureComponent);
    t.FullScreenAlertView = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexLogo = t.ButtonContainer = t.Message = t.DangerButton = t.PrimaryButton = t.DefaultButton = t.Description = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p,
      d = n(2),
      f = n(0);
    t.Container = d.default("div")(o || (o = r(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    font-size: 14px;\n    text-align: center;\n    line-height: 24px;\n    z-index: 100;\n\n    @media (max-width: ", ") {\n        box-sizing: border-box;\n        padding-left: 16px;\n        padding-right: 16px;\n    }\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    font-size: 14px;\n    text-align: center;\n    line-height: 24px;\n    z-index: 100;\n\n    @media (max-width: ", ") {\n        box-sizing: border-box;\n        padding-left: 16px;\n        padding-right: 16px;\n    }\n"])), function (e) {
      return e.theme.colors.base2;
    }, function (e) {
      return e.theme.calculated.textColor;
    }, "420px"), t.Description = d.default("div")(i || (i = r(["\n    margin-top: 8px;\n"], ["\n    margin-top: 8px;\n"]))), t.DefaultButton = d.default(f.Button)(a || (a = r(["\n    ", ";\n    color: ", ";\n\n    text-transform: uppercase;\n    padding-left: 20px;\n    padding-right: 20px;\n    height: 36px;\n    min-width: 120px;\n    button + & {\n        margin-left: 12px;\n    }\n\n    @media (max-width: ", ") {\n        width: 100%;\n\n        button + & {\n            margin-left: 0;\n            margin-top: 16px;\n        }\n    }\n"], ["\n    ", ";\n    color: ", ";\n\n    text-transform: uppercase;\n    padding-left: 20px;\n    padding-right: 20px;\n    height: 36px;\n    min-width: 120px;\n    button + & {\n        margin-left: 12px;\n    }\n\n    @media (max-width: ", ") {\n        width: 100%;\n\n        button + & {\n            margin-left: 0;\n            margin-top: 16px;\n        }\n    }\n"])), function (e) {
      return f.getBackgroundWithHoverCSS(e.theme.colors.base4, !1);
    }, function (e) {
      return e.theme.colors.lightTextColor;
    }, "420px"), t.PrimaryButton = d.default(t.DefaultButton)(s || (s = r(["\n    ", ";\n    color: ", ";\n"], ["\n    ", ";\n    color: ", ";\n"])), function (e) {
      return f.getBackgroundWithHoverCSS(e.theme.colors.defaultButtonColor, !1);
    }, function (e) {
      return e.theme.colors.lightTextColor;
    }), t.DangerButton = d.default(t.DefaultButton)(l || (l = r(["\n    ", ";\n    color: ", ";\n"], ["\n    ", ";\n    color: ", ";\n"])), function (e) {
      return f.getBackgroundWithHoverCSS(e.theme.colors.errorColor, !1);
    }, function (e) {
      return e.theme.colors.lightTextColor;
    }), t.Message = d.default("h1")(c || (c = r(["\n    font-size: 18px;\n    line-height: 32px;\n    margin-top: 16px;\n"], ["\n    font-size: 18px;\n    line-height: 32px;\n    margin-top: 16px;\n"]))), t.ButtonContainer = d.default("div")(u || (u = r(["\n    margin: 24px auto 16px;\n    display: flex;\n    justify-content: center;\n\n    @media (max-width: ", ") {\n        display: block;\n        width: 100%;\n    }\n"], ["\n    margin: 24px auto 16px;\n    display: flex;\n    justify-content: center;\n\n    @media (max-width: ", ") {\n        display: block;\n        width: 100%;\n    }\n"])), "420px"), t.FlexLogo = d.default(f.Icon)(p || (p = r(["\n    position: absolute;\n    bottom: 32px;\n    margin: 0 auto;\n\n    & > svg {\n        height: 42px;\n    }\n"], ["\n    position: absolute;\n    bottom: 32px;\n    margin: 0 auto;\n\n    & > svg {\n        height: 42px;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r263,
      o = this && this.__extends || (_r263 = function r(e, t) {
        return (_r263 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r263(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
      a = n(0),
      s = n(159),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(s.FullScreenAlertView, {
            message: i.createElement(a.Template, {
              source: a.templates.SessionAlreadyExists
            }),
            primaryDescription: i.createElement(a.Template, {
              source: a.templates.SessionAlreadyExistsDesc
            }),
            secondaryDescription: i.createElement(a.Template, {
              source: a.templates.SessionTimeoutMessage,
              timeout: this.props.timeout
            }),
            buttons: [{
              type: "primary",
              content: i.createElement(a.Template, {
                source: a.templates.LogInHere
              }),
              props: {
                onClick: this.props.onLogIn,
                key: "loginHere"
              }
            }, {
              type: "default",
              content: i.createElement(a.Template, {
                source: a.templates.Cancel
              }),
              props: {
                onClick: this.props.onCancel,
                key: "cancel"
              }
            }]
          });
        }, t;
      }(i.PureComponent);
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var _r264,
      o = this && this.__extends || (_r264 = function r(e, t) {
        return (_r264 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r264(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
      a = n(0),
      s = n(159),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(s.FullScreenAlertView, {
            message: i.createElement(a.Template, {
              source: a.templates.SessionOngoingCallMessage
            }),
            buttons: [{
              type: "danger",
              content: i.createElement(a.Template, {
                source: a.templates.SessionDropOngoingCall
              }),
              props: {
                onClick: this.props.onDropCall,
                key: "dropCall"
              }
            }, {
              type: "default",
              content: i.createElement(a.Template, {
                source: a.templates.Cancel
              }),
              props: {
                onClick: this.props.onCancel,
                key: "cancel"
              }
            }],
            secondaryDescription: i.createElement(a.Template, {
              source: a.templates.SessionTimeoutMessage,
              timeout: this.props.timeout
            }),
            primaryDescription: i.createElement(a.Template, {
              source: a.templates.SessionOngoingCallDesc
            })
          });
        }, t;
      }(i.PureComponent);
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.OutboundDialerPanel = void 0;
    var r = n(285);
    Object.defineProperty(t, "OutboundDialerPanel", {
      enumerable: !0,
      get: function get() {
        return r.OutboundDialerPanel;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(183), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FilterConditions = t.FLEX_LOCATION_CHANGE = t.ConferenceParticipant = void 0, o(n(121), t), o(n(757), t);
    var i = n(128);
    Object.defineProperty(t, "ConferenceParticipant", {
      enumerable: !0,
      get: function get() {
        return i.ConferenceParticipant;
      }
    });
    var a = n(127);
    Object.defineProperty(t, "FLEX_LOCATION_CHANGE", {
      enumerable: !0,
      get: function get() {
        return a.FLEX_LOCATION_CHANGE;
      }
    });
    var s = n(35);
    Object.defineProperty(t, "FilterConditions", {
      enumerable: !0,
      get: function get() {
        return s.FilterConditions;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ProxiedActions = void 0;
    var r = n(0),
      o = n(12);
    t.ProxiedActions = new Proxy(r.Actions, {
      get: function get(e, t) {
        var n = e[t];
        return "function" == typeof n ? function () {
          for (var r = [], i = 0; i < arguments.length; i++) r[i] = arguments[i];
          switch (t) {
            case "removeListener":
            case "addListener":
            case "removeAllListeners":
              var a = r[0],
                s = "symbol" == typeof a ? a.toString() : a,
                l = s.match(/^(before|after)(.*)$/);
              if (l) {
                var c = "";
                "removeListener" === t ? c = "before" === l[1] ? "removeBeforeListener" : "removeAfterListener" : "addListener" === t ? c = "before" === l[1] ? "addBeforeListener" : "addAfterListener" : "removeAllListeners" === t && (c = "removeAll" + l[1].charAt(0).toUpperCase() + l[1].slice(1) + "Listeners"), o.TelemetryManager.reportProgrammabilityEvent({
                  name: l[2],
                  command: c,
                  callType: o.ProgrammabilityEventCallType.Action
                });
              }
              break;
            case "replaceAction":
            case "registerAction":
              o.TelemetryManager.reportProgrammabilityEvent({
                name: r[0],
                command: t,
                callType: o.ProgrammabilityEventCallType.Action
              });
          }
          return n.apply(e, r);
        } : n;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.registerActions = void 0;
    var r = n(760),
      o = n(761),
      i = n(762),
      a = n(77),
      s = n(76);
    t.registerActions = function () {
      s.WorkerActions.registerActions(), a.VoiceActions.registerActions(), i.SupervisorActions.registerActions(), r.GeneralActions.registerActions(), o.MessageActions.registerActions();
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GeneralActions = void 0;
    var i = n(0),
      a = n(3),
      s = n(35),
      l = function () {
        function e() {}
        return e.registerActions = function () {
          i.Actions.registerAction("NavigateToView", e.navigateToView), i.Actions.registerAction("HistoryPush", s.Actions.push), i.Actions.registerAction("HistoryReplace", s.Actions.replace), i.Actions.registerAction("HistoryGo", s.Actions.go), i.Actions.registerAction("HistoryGoBack", s.Actions.goBack), i.Actions.registerAction("HistoryGoForward", s.Actions.goForward), i.Actions.registerAction("ShowDirectory", e.showDirectory), i.Actions.registerAction("HideDirectory", e.hideDirectory), i.Actions.registerAction("ToggleSidebar", e.toggleSidebar), i.Actions.registerAction("SetComponentState", e.setComponentState), i.Actions.registerAction("ApplyListFilters", e.applyListFilters), i.Actions.registerAction("RemoveListFilters", e.removeListFilters), i.Actions.registerAction("ReloadWindow", e.reloadWindow);
        }, e.navigateToView = function (e) {
          return r(this, void 0, Promise, function () {
            var t, n;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return "agent-desktop" !== e.viewName ? [3, 5] : a.FlexModule.state.view.selectedTaskSid ? [4, i.Actions.invokeAction("HistoryPush", "/agent-desktop/" + a.FlexModule.state.view.selectedTaskSid)] : [3, 2];
                case 1:
                  return r.sent(), [3, 4];
                case 2:
                  return [4, i.Actions.invokeAction("HistoryPush", "/agent-desktop/")];
                case 3:
                  r.sent(), r.label = 4;
                case 4:
                  return [3, 14];
                case 5:
                  return "teams" !== e.viewName ? [3, 12] : a.FlexModule.state.view.selectedTaskInSupervisorSid ? [4, i.Actions.invokeAction("HistoryPush", "/teams/tasks/" + a.FlexModule.state.view.selectedTaskInSupervisorSid)] : [3, 7];
                case 6:
                  return r.sent(), [3, 11];
                case 7:
                  return a.FlexModule.state.view.selectedWorkerInSupervisorSid ? [4, i.Actions.invokeAction("HistoryPush", "/teams/workers/" + a.FlexModule.state.view.selectedWorkerInSupervisorSid)] : [3, 9];
                case 8:
                  return r.sent(), [3, 11];
                case 9:
                  return [4, i.Actions.invokeAction("HistoryPush", "/teams/")];
                case 10:
                  r.sent(), r.label = 11;
                case 11:
                  return [3, 14];
                case 12:
                  return t = /\//g, n = (n = e.viewName).replace(t, ""), [4, i.Actions.invokeAction("HistoryPush", "/" + n + "/")];
                case 13:
                  r.sent(), r.label = 14;
                case 14:
                  return [2];
              }
            });
          });
        }, e.showDirectory = function () {
          return r(this, void 0, Promise, function () {
            return o(this, function (e) {
              return s.Actions.showDirectory(void 0), [2];
            });
          });
        }, e.hideDirectory = function () {
          return r(this, void 0, Promise, function () {
            return o(this, function (e) {
              return s.Actions.hideDirectory(), [2];
            });
          });
        }, e.toggleSidebar = function (e) {
          return r(this, void 0, Promise, function () {
            return o(this, function (t) {
              return e && void 0 !== e.open ? [2, e.open ? s.Actions.showSidebar() : s.Actions.hideSidebar()] : [2, s.Actions.toggleSidebar()];
            });
          });
        }, e.setComponentState = function (e) {
          return r(this, void 0, void 0, function () {
            return o(this, function (t) {
              return [2, s.Actions.setComponentState(e.name, e.state)];
            });
          });
        }, e.applyListFilters = function (e) {
          return r(this, void 0, Promise, function () {
            return o(this, function (t) {
              return e && s.Actions.applyListFilters(e), [2];
            });
          });
        }, e.removeListFilters = function (e) {
          return r(this, void 0, Promise, function () {
            return o(this, function (t) {
              return e && s.Actions.removeListFilters(e), [2];
            });
          });
        }, e.reloadWindow = function () {
          return r(this, void 0, Promise, function () {
            return o(this, function (e) {
              return window.location.reload(!0), [2];
            });
          });
        }, e;
      }();
    t.GeneralActions = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageActions = void 0;
    var r = n(0),
      o = n(8),
      i = n(20),
      a = n(16),
      s = function () {
        function e() {}
        return e.registerActions = function () {
          r.Actions.addListener("beforeSendMessage", this.beforeSendMessage);
        }, e.beforeSendMessage = function (e, t) {
          var n = e.body.trim().length,
            r = o.TaskHelper.getTaskFromChannelSid(e.channelSid),
            s = i.TaskChannels.getForTask(r).charLimit;
          n > s && (a.Notifications.showNotification(a.NotificationIds.MessageSizeExceeded, {
            currentCharCount: n,
            maxCharCount: s
          }), t());
        }, e;
      }();
    t.MessageActions = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SupervisorActions = void 0;
    var i = n(0),
      a = n(3),
      s = n(36),
      l = n(155),
      c = n(35),
      u = function () {
        function e() {}
        return e.registerActions = function () {
          i.Actions.registerAction("MonitorCall", e.monitorCall, this.updateTaskActionPayload), i.Actions.registerAction("StopMonitoringCall", e.stopMonitoringCall, this.updateTaskActionPayload), i.Actions.registerAction("SelectTaskInSupervisor", this.selectTaskInSupervisor, this.updateTaskActionPayload), i.Actions.registerAction("SelectWorkerInSupervisor", this.selectWorkerInSupervisor, this.updateSelectWorkerActionPayload);
        }, e.monitorCall = function (e) {
          return r(this, void 0, Promise, function () {
            var t;
            return o(this, function (n) {
              switch (n.label) {
                case 0:
                  return (t = a.FlexModule.state.worker.source) ? (t.monitor(e.task.taskSid, e.task.sid, e.extraParams), [4, s.Actions.monitorCall(e.task)]) : [3, 2];
                case 1:
                  n.sent(), n.label = 2;
                case 2:
                  return [2];
              }
            });
          });
        }, e.stopMonitoringCall = function (e) {
          return r(this, void 0, Promise, function () {
            return o(this, function (e) {
              return a.FlexModule.state.phone.connection && a.FlexModule.state.phone.connection.source.disconnect(), [2];
            });
          });
        }, e.selectTaskInSupervisor = function (e) {
          return r(this, void 0, Promise, function () {
            var t, n;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return t = e.task, c.Actions.hideOutboundDialer(), c.Actions.selectTaskInSupervisor(t && t.sid), s.Actions.setStickyWorkerSid(t && t.workerSid, t && t.sid), c.Actions.selectWorkerInSupervisor(void 0), n = t ? t.sid : "", [4, i.Actions.invokeAction("HistoryReplace", "/teams/tasks/" + n)];
                case 1:
                  return r.sent(), [2];
              }
            });
          });
        }, e.selectWorkerInSupervisor = function (e) {
          return r(this, void 0, Promise, function () {
            var t, n;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return t = e.worker, c.Actions.hideOutboundDialer(), c.Actions.selectTaskInSupervisor(void 0), s.Actions.setStickyWorkerSid(t && t.sid, void 0), c.Actions.selectWorkerInSupervisor(t && t.sid), n = t ? t.sid : "", [4, i.Actions.invokeAction("HistoryReplace", "/teams/workers/" + n)];
                case 1:
                  return r.sent(), [2];
              }
            });
          });
        }, e.updateSelectWorkerActionPayload = function (e) {
          return e.worker && (e.workerSid = e.worker.sid), e.workerSid && !e.worker && (e.worker = l.SupervisorStateHelper.getWorkerBySid(e.workerSid)), e;
        }, e.updateTaskActionPayload = function (e) {
          return e.task && (e.sid = e.task.sid), e.sid && !e.task && (e.task = l.SupervisorStateHelper.getTaskBySid(e.sid)), e;
        }, e;
      }();
    t.SupervisorActions = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.tryLogin = t.runDefault = t.provideLoginInfo = t.errorPage = t.progress = t.create = void 0;
    var i = n(0),
      a = n(1),
      s = n(120),
      l = n(278),
      c = n(764),
      u = n(767),
      p = n(152),
      d = n(47),
      f = n(141),
      h = n(48),
      m = n(13),
      g = n(263),
      y = n(96),
      v = n(97),
      b = n(62),
      C = n(71),
      _ = n(7),
      k = n(5);
    function w(e) {
      var t;
      return void 0 === e && (e = "body"), t = "string" == typeof e ? P(e) : e, s.unmountComponentAtNode(t), s.render(a.createElement(b.StorelessThemeProvider, {
        themeConf: {
          baseName: "FlexDark"
        }
      }, a.createElement(u.LoadingView, null)), t), this;
    }
    t.create = function (e) {
      return T.create(e);
    }, t.progress = w;
    function S(e, t) {
      return void 0 === e && (e = {}), void 0 === t && (t = "body"), r(this, void 0, Promise, function () {
        var n,
          l,
          c,
          u,
          f,
          m,
          g = this;
        return o(this, function (b) {
          switch (b.label) {
            case 0:
              n = e.sdkOptions, l = (void 0 === n ? {} : n).flex, (c = (void 0 === l ? {} : l).environmentConfig) && (window.__TWILIO_FLEX_SDK__ = {
                environmentConfig: c
              }), u = d.getStoredConfig(), i.Utils.mergeInto(e, u, !1), b.label = 1;
            case 1:
              return b.trys.push([1, 3,, 5]), [4, C.TokenManager.hasActiveToken()];
            case 2:
              return b.sent() ? [2, Promise.resolve()] : [3, 5];
            case 3:
              return f = b.sent(), [4, v.parseCriticalPathError(f)];
            case 4:
              throw b.sent(), f;
            case 5:
              return d.clearStoredConfig(), m = "string" == typeof t ? P(t) : t, e.sso = e.sso || {}, [2, new Promise(function (t, n) {
                var i = function i(e) {
                  t();
                };
                y.SSOLoginHandler.tryValidateConfig(e.sso).then(function () {
                  return void 0 === e.sso.loginPopup ? d.fetchPublicConfiguration({
                    accountSid: e.sso.accountSid
                  }) : Promise.resolve({
                    sso: {}
                  });
                }).then(function () {
                  return y.SSOLoginHandler.tryLogin(e.sso).then(function () {
                    return t();
                  });
                }).catch(function (t) {
                  return r(g, void 0, void 0, function () {
                    var r, l, c, u, d;
                    return o(this, function (o) {
                      switch (o.label) {
                        case 0:
                          return r = t instanceof h.ConfigError && t.key === h.ConfigErrorKeys.accountSid, l = t instanceof h.BrowserError && (t.key === h.BrowserErrorKeys.popupBlocked || t.key === h.BrowserErrorKeys.windowClosed || t.key === h.BrowserErrorKeys.noWindowOpener), c = t instanceof h.ValidationError && (t.key === h.ValidationErrorKeys.sso || t.key === h.ValidationErrorKeys.accountSid), u = t instanceof h.ValidationError && t.key === h.ValidationErrorKeys.untrustedDomain, d = t instanceof h.ValidationError && t.key === h.ValidationErrorKeys.invalidCertificate, r || l || c || u || d ? (s.render(a.createElement(p.LoginFormView, {
                            userConfig: e,
                            onError: n,
                            onSuccess: i
                          }), m), [3, 3]) : [3, 1];
                        case 1:
                          return [4, v.parseCriticalPathError(t)];
                        case 2:
                          o.sent(), n(t), o.label = 3;
                        case 3:
                          if (!_.isFlexError(t)) throw _.ErrorManager.createAndProcessError("Something went wrong on during `provideLoginInfo`", {
                            type: _.FlexErrorType.app,
                            context: "Login",
                            wrappedError: t
                          });
                          return [2];
                      }
                    });
                  });
                });
              })];
          }
        });
      });
    }
    function P(e) {
      var t = document.querySelector(e);
      if (!t) throw _.ErrorManager.createAndProcessError("Unable to find element for selector", {
        type: _.FlexErrorType.app,
        description: "Unable to find element for selector " + t,
        context: "Flex"
      });
      return t;
    }
    t.errorPage = function (e, t) {
      var n;
      if (!(e && e.key === h.BrowserErrorKeys.redirecting || "Logging in in another window" === e)) throw n = "string" == typeof t ? P(t) : t, k.log.error("Unable to launch Flex:", e), s.unmountComponentAtNode(n), s.render(a.createElement(b.StorelessThemeProvider, {
        themeConf: {
          baseName: "FlexDark"
        }
      }, a.createElement(c.ErrorPage, {
        error: e
      })), n), e;
    }, t.provideLoginInfo = S, t.runDefault = function (e, n) {
      return void 0 === e && (e = {}), void 0 === n && (n = "body"), r(this, void 0, Promise, function () {
        return o(this, function (r) {
          return w(n), [2, S(e, n).then(function () {
            return window.history.replaceState({}, document.title, g.getDestinationURLFromLocation()), T.create(e);
          }).then(function (e) {
            return e.init(n);
          }).catch(function (e) {
            e instanceof h.BrowserError && e.key === h.BrowserErrorKeys.redirecting || e instanceof h.ClientError && e.key === h.ClientErrorKeys.metaNoReferrerMissing ? k.log.debug("Flex redirecting") : t.errorPage(e, n);
          })];
        });
      });
    }, t.tryLogin = function (e) {
      return void 0 === e && (e = {}), y.SSOLoginHandler.tryLogin(e).catch(function (e) {
        if (!_.isFlexError(e)) throw _.ErrorManager.createAndProcessError("Something went wrong on login", {
          type: _.FlexErrorType.app,
          context: "login",
          wrappedError: e
        });
        throw e;
      });
    };
    var T = function () {
      function e(e) {
        this._manager = e;
      }
      return e.create = function (t) {
        return m.Manager.create(t).then(function (t) {
          return new e(t);
        });
      }, Object.defineProperty(e.prototype, "manager", {
        get: function get() {
          return this._manager;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.init = function (e) {
        var t;
        void 0 === e && (e = "body"), t = "string" == typeof e ? P(e) : e, s.unmountComponentAtNode(t), s.render(a.createElement(f.ContextProvider, {
          manager: this.manager
        }, a.createElement(l.RootContainer, null)), t);
      }, e;
    }();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorPage = void 0;
    var r = n(765);
    Object.defineProperty(t, "ErrorPage", {
      enumerable: !0,
      get: function get() {
        return r.ErrorPage;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r265,
      o = this && this.__extends || (_r265 = function r(e, t) {
        return (_r265 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r265(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorPage = void 0;
    var a = n(0),
      s = n(1),
      l = n(7),
      c = n(68),
      u = n(6),
      p = n(4),
      d = n(153),
      f = n(2),
      h = n(766),
      m = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t,
            n = this,
            r = p.templates.ErrorPageRetryButton ? s.createElement(a.Template, {
              source: p.templates.ErrorPageRetryButton
            }) : "RETRY",
            o = p.templates.ErrorPageDownloadReportButton ? s.createElement(a.Template, {
              source: p.templates.ErrorPageDownloadReportButton
            }) : "DOWNLOAD REPORT",
            i = this.props.error;
          return s.createElement(h.Container, {
            className: "Twilio-ErrorPage"
          }, s.createElement(h.CenterContainer, {
            className: "Twilio-ErrorPage-Container"
          }, s.createElement(d.LogoWithCircle, {
            disabled: !0
          }), s.createElement(h.ErrorMessage, null, s.createElement(a.Icon, {
            icon: "Error"
          }), s.createElement(h.Label, {
            className: "Twilio-ErrorPage-Label"
          }, i ? i.toString() : "Unknown Error!")), s.createElement(h.ActionButtons, null, s.createElement(h.RetryButton, {
            disabled: (null === (t = null === (e = i) || void 0 === e ? void 0 : e.content) || void 0 === t ? void 0 : t.severity) === l.FlexErrorSeverity.severe,
            roundCorners: !1,
            themeOverride: this.props.theme.ErrorPage.Actions.RetryButton,
            onClick: function onClick() {
              return u.tryInvokeAction("ReloadWindow");
            }
          }, r), s.createElement(h.DownloadReportButton, {
            roundCorners: !1,
            disabled: !i,
            themeOverride: this.props.theme.ErrorPage.Actions.DownloadReportButton,
            onClick: function onClick() {
              return c.downloadReport([n.props.error]);
            }
          }, o))));
        }, t = i([f.withTheme], t);
      }(s.PureComponent);
    t.ErrorPage = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DownloadReportButton = t.RetryButton = t.ActionButtons = t.ErrorMessage = t.CenterContainer = t.Label = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      p = n(2),
      d = n(0);
    t.Container = p.default("div")(o || (o = r(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    height: 100%;\n    ", "\n"], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    height: 100%;\n    ", "\n"])), function (e) {
      return e.theme.ErrorPage.Container;
    }), t.Label = p.default("div")(i || (i = r(["\n    position: relative;\n    font-size: 14px;\n    margin-left: 8px;\n    text-align: center;\n    color: ", ";\n"], ["\n    position: relative;\n    font-size: 14px;\n    margin-left: 8px;\n    text-align: center;\n    color: ", ";\n"])), function (e) {
      return e.theme.colors.errorColor;
    }), t.CenterContainer = p.default("div")(a || (a = r(["\n    position: relative;\n    margin: auto;\n"], ["\n    position: relative;\n    margin: auto;\n"]))), t.ErrorMessage = p.default("div")(s || (s = r(["\n    margin: 44px 0 26px;\n    display: flex;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    color: ", ";\n"], ["\n    margin: 44px 0 26px;\n    display: flex;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    color: ", ";\n"])), function (e) {
      return e.theme.colors.errorColor;
    }), t.ActionButtons = p.default("div")(l || (l = r(["\n    flex: 1;\n    text-align: center;\n"], ["\n    flex: 1;\n    text-align: center;\n"]))), t.RetryButton = p.default(d.Button)(c || (c = r(["\n    width: 160px;\n    height: 32px;\n"], ["\n    width: 160px;\n    height: 32px;\n"]))), t.DownloadReportButton = p.default(d.Button)(u || (u = r(["\n    width: 160px;\n    height: 32px;\n    margin-left: 16px;\n"], ["\n    width: 160px;\n    height: 32px;\n    margin-left: 16px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoadingView = void 0;
    var r = n(768);
    Object.defineProperty(t, "LoadingView", {
      enumerable: !0,
      get: function get() {
        return r.LoadingView;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r266,
      o = this && this.__extends || (_r266 = function r(e, t) {
        return (_r266 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r266(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LoadingView = void 0;
    var a = n(1),
      s = n(2),
      l = n(69),
      c = n(153),
      u = n(769),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(u.Container, {
            className: "Twilio-LoadingView"
          }, a.createElement(u.CenterContainer, {
            className: "Twilio-LoadingView-Container"
          }, a.createElement(c.LogoWithCircle, {
            animating: !0
          }), a.createElement(u.Label, {
            className: "Twilio-LoadingView-Label"
          }, l.languages.default.LoginLoading)));
        }, t = i([s.withTheme], t);
      }(a.PureComponent);
    t.LoadingView = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CenterContainer = t.Label = t.Container = void 0;
    var o,
      i,
      a,
      s = n(2);
    t.Container = s.default("div")(o || (o = r(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    height: 100%;\n    ", "\n"], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    height: 100%;\n    ", "\n"])), function (e) {
      return e.theme.LoadingView.Container;
    }), t.Label = s.default("div")(i || (i = r(["\n    position: relative;\n    font-size: 14px;\n    margin-top: 30px;\n    text-align: center;\n"], ["\n    position: relative;\n    font-size: 14px;\n    margin-top: 30px;\n    text-align: center;\n"]))), t.CenterContainer = s.default("div")(a || (a = r(["\n    position: relative;\n    margin: auto;\n"], ["\n    position: relative;\n    margin: auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Monitor = void 0;
    var r = n(3),
      o = n(5),
      i = n(68),
      a = n(7),
      s = n(169),
      l = n(11),
      c = n(10);
    t.Monitor = {
      getErrors: function getErrors() {
        return {
          errors: (r.FlexModule.state.flexErrors.errors || []).map(function (e) {
            return i.errorToJSON(e);
          })
        };
      },
      getLogs: function getLogs() {
        return {
          logs: o.logManager ? o.logManager.flush() : ""
        };
      },
      sendDebuggerEvent: function sendDebuggerEvent(e, t) {
        if (l.FeatureFlags.isEnabled(c.FeatureFlag.DebuggerIntegration)) {
          var n = {
            twilioErrorCode: s.TwilioErrorCodes.CustomFlexError,
            description: t || null
          };
          a.ErrorManager.createAndProcessError(e, n);
        } else o.log.warn("Debugger Integration must be enabled to send debugger events");
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.initialize = void 0;
    var r = n(86),
      o = n(20),
      i = n(0),
      a = n(123);
    t.initialize = function () {
      o.registerDefaultTaskChannels(r), i.resetCSS(), i.registerStyles(), i.initialize(), a.OutboundCalling.initialize();
    };
  }]);
});